import { EMAIL_SUPPORT } from "../../utils/constants";
import {
  BID_CONTROL_PLACEHOLDER,
  HIGHEST_VOLUME_PLACEHOLDER,
  SAVE_LOCATION_SET_TITLE,
  SAVE_LOCATION_SET_NAME_LABEL,
  SAVE_LOCATION_SET_SAVE_BUTTON,
  SAVE_LOCATION_SET_SAVING_BUTTON,
  SAVE_LOCATION_SET_CANCEL_BUTTON,
  SAVED_LOCATION_SETS_TITLE,
  SAVED_LOCATION_SETS_CLOSE_BUTTON,
  FIELD_OPEN_MAP_RADIUS_SELECT_TITLE,
  FIELD_OPEN_MAP_RADIUS_SELECT_DESCRIPTION,
  LOAD_LOCATION_SET_BUTTON,
  SAVE_LOCATION_SET_BUTTON,
  SAVE_LOCATION_SET_SUCCESS,
  SAVE_LOCATION_SET_ERROR,
  LOAD_LOCATION_SETS_ERROR,
  SAVE_LOCATION_SET_DUPLICATE_ERROR,
  CUSTOMER_ACQUISITION_TITLE,
  CUSTOMER_ACQUISITION_SWITCH_LABEL,
  CUSTOMER_ACQUISITION_ACCOUNT_LEVEL,
  CUSTOMER_ACQUISITION_CAMPAIGN_LEVEL,
  CUSTOMER_ACQUISITION_NEW_CUSTOMER_VALUE,
  CUSTOMER_ACQUISITION_NEW_CUSTOMER_HIGH_VALUE,
  ALERT_PLATFORM_STATUS_BANNER,
  ALERT_REBRAND_BANNER,
  ALERT_REBRAND_BANNER_DISCORD_BODY,
  DISCORD_LINK,
  ALERT_REBRAND_BANNER_APPSUMO_REVIEW_BODY,
  ALERT_REBRAND_BANNER_AFFILIATE_BODY,
  ALERT_REBRAND_BANNER_AFFILIATE_LINK,
  APPSUMO_REVIEW_BANNER_LINK,
  ALERT_REBRAND_BANNER_CAROUSEL_PREVIOUS,
  ALERT_REBRAND_BANNER_CAROUSEL_NEXT,
  MODAL_REBRAND_ADLE_TITLE,
  MODAL_REBRAND_ADLE_DESCRIPTION,
  MODAL_REBRAND_ADLE_GO_TO_ADLE_BUTTON,
  ADS_CONFIGURATION_APPS_TITLE,
  ADS_CONFIGURATION_DESTINATION_TITLE,
  ADS_CAMPAIGN_PREVIEW,
  SEARCH,
  LOADING_INFORMATION,
  AUDIENCE,
  AUDIENCE_TITLE_EXPLANATION,
  AUDIENCE_EXPLANATION,
  ENGAGEMENT,
  ENGAGEMENT_TITLE_EXPLANATION,
  ENGAGEMENT_EXPLANATION,
  RECORDS_IN_TABLE,
  SHOP_DEACTIVATE_ALERT_DESCRIPTION,
  PAGE_IN_TABLE,
  BUTTON_RETRY,
  BUTTON_RETRY_PUBLISHING,
  BUTTON_INVITE,
  BUTTON_EDIT_INVITE,
  BUTTON_VIEW_REQUEST,
  BUTTON_START_NOW,
  BUTTON_REJECT_REQUEST,
  BUTTON_ORDER_IN_PROCESS,
  BUTTON_VIEW_COLLABORATION,
  NEW_CREATORS_CATEGORY,
  CREATORS_TITLE,
  CREATOR_DESCRIPTION,
  SEARCH_BAR_TEXT_CREATORS,
  TAB_CREATORS,
  TAB_REQUESTS,
  TAB_SUGGESTED,
  CREATORS_TABLE_COLUMN_NAME,
  CREATORS_TABLE_COLUMN_CITY,
  CREATORS_TABLE_COLUMN_AUDIENCE,
  CREATORS_TABLE_COLUMN_ENGAGEMENT,
  CREATORS_TABLE_COLUMN_DATE,
  CREATORS_TABLE_COLUMN_CATEGORIES,
  CREATORS_TABLE_COLUMN_SCORE,
  CREATORS_TABLE_COLUMN_ACTIVITY,
  BUTTON_VIEW_INVITE,
  DATE_SHORT,
  CALENDAR_MONTH,
  CALENDAR_WEEK,
  CALENDAR_DAY,
  CALENDAR_TODAY,
  CALENDAR_TOMORROW,
  CALENDAR_NEXT,
  CALENDAR_PREVIOUS,
  CALENDAR_AGENDA,
  CALENDAR_SHOW_MORE,
  VIEW_CALENDAR,
  POST_TITLE,
  CALENDAR_POST_TITLE,
  CALENDAR_INVALID_DATE_ERROR,
  EVENT_DETAILS_DESCRIPTION,
  EVENT_DETAILS_DATE_AND_TIME,
  EVENT_DETAILS_SOCIAL_NETWORK,
  EVENT_DETAILS_STATUS,
  EVENT_DETAILS_STATUS_DRAFT,
  EVENT_DETAILS_STATUS_SCHEDULED,
  EVENT_DETAILS_STATUS_PUBLISHED,
  GALLERY_MAX_SELECTIONS_REACHED,
  GALLERY_PUBLISHED_ON_PLATFORMS,
  GALLERY_PLATFORM_STATUSES_LABEL,
  GALLERY_STATUS_PUBLISHED_DIRECT,
  GALLERY_STATUS_PUBLISHED_DIRECT_UNKNOWN,
  GALLERY_STATUS_SCHEDULED,
  GALLERY_STATUS_SCHEDULED_UNKNOWN,
  GALLERY_STATUS_PUBLISHED_SCHEDULE,
  GALLERY_STATUS_PUBLISHED_SCHEDULE_UNKNOWN,
  GALLERY_STATUS_FAILED,
  GALLERY_STATUS_FAILED_UNKNOWN,
  GALLERY_STATUS_PUBLISHED_LEGACY,
  SHARE_MODAL_PLATFORM_ALREADY_PUBLISHED,
  EVENT_DETAILS_STATUS_FAILED,
  EVENT_DETAILS_NETWORK_INSTAGRAM,
  EVENT_DETAILS_NETWORK_FACEBOOK,
  EVENT_DETAILS_NETWORK_TIKTOK,
  EVENT_DETAILS_NETWORK_LINKEDIN,
  EVENT_DETAILS_NETWORK_YOUTUBE,
  EVENT_DETAILS_CONTENT,
  ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE,
  ORGANIC_PUBLISH_RETRY_CONFIRM_DESCRIPTION,
  ORGANIC_PUBLISH_RETRY_ALERT_ARIA_LABEL,
  ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_PLATFORM,
  ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_MESSAGE,
  ORGANIC_PUBLISH_RETRY_ERROR,
  ORGANIC_PUBLISH_PARTIAL_STATUS,
  BUTTON_VIEW_METRICS,
  QUALITY_AUDIENCE,
  QUALITY_CONTENT,
  CONTENT,
  ANALYTIC,
  EMPTY_COMMENTS,
  COMMENTS,
  SHOW_COMMENTS,
  BUTTON_CANCEL_INVITE,
  ADVANCED_CONFIGURATION,
  MENU_PLATFORM,
  MENU_ACTIONS,
  MENU_CONFIGURATION,
  MENU_ADMINISTRATION,
  SUB_MENU_CREATORS,
  SUB_MENU_PUBLICATIONS,
  SUB_MENU_EVENTS,
  SUB_MENU_CAMPAIGNS,
  SUB_MENU_REPORTS,
  SUB_MENU_REDEEM_CODE,
  SUB_MENU_ORDERS,
  SUB_MENU_ACCOUNT,
  SUB_MENU_STORES,
  SUB_MENU_MENU,
  SUB_MENU_USERS,
  SUB_MENU_BILLING_AND_PAYMENTS,
  SUB_MENU_BILLING_DASHBOARD,
  SUB_MENU_BILLING_DATA,
  SUB_MENU_USERS_OWNER,
  SUB_MENU_BRANDS,
  SUB_MENU_BRAND_SIGNUPS,
  SUB_MENU_CREATORS_OWNER,
  SUB_MENU_CREATORS_EXTERNALS,
  SUB_MENU_PAY_CREATORS,
  SUB_MENU_CREATOR_SIGNUPS,
  SUB_MENU_CONTENTS,
  SUB_MENU_DELIVERIES,
  SUB_MENU_REPORTS_OWNER,
  SUB_MENU_FEEDBACK,
  SUB_MENU_PAYMENTS_FAILED,
  SUB_MENU_DISCOVERY,
  SUB_MENU_GALLERY,
  REQUEST_REJECTED,
  REQUEST_REJECTED_DESCRIPTION,
  REPORTED_CONTENT_STATUS_REJECTED,
  REPORTED_CONTENT_STATUS_PENDING,
  REPORTED_CONTENT_STATUS_APPROVED,
  HELP,
  CREDITS,
  COST_OF_ACTION,
  COST_OF_CAMPAIGN,
  COST_OF_RESIZE,
  CURRENT,
  CURRENT_BALANCE,
  BALANCE_AFTER,
  DEACTIVATE,
  ACTIVATE,
  BRAND,
  NOTIFICATIONS,
  LOGOUT,
  LOADING_SUGGESTED_INFORMATION,
  ALERT_AD_CPA_LOW_LABEL,
  ALERT_AD_CPA_MEDIUM_LABEL,
  ALERT_AD_CPA_HIGH_LABEL,
  ALERT_ASSET_GROUP_CPA_LOW_LABEL,
  ALERT_ASSET_GROUP_CPA_MEDIUM_LABEL,
  ALERT_ASSET_GROUP_CPA_HIGH_LABEL,
  ALERT_AD_GROUP_CPA_LOW_LABEL,
  ALERT_AD_GROUP_CPA_MEDIUM_LABEL,
  ALERT_AD_GROUP_CPA_HIGH_LABEL,
  ALERT_AD_CPA_LOW_TABLE_LABEL,
  ALERT_AD_CPA_MEDIUM_TABLE_LABEL,
  ALERT_AD_CPA_HIGH_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_LOW_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_MEDIUM_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_HIGH_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_LOW_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_MEDIUM_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_HIGH_TABLE_LABEL,
  ALERT_CREATIVE_FATIGUE_MEDIUM_LABEL,
  ALERT_CREATIVE_FATIGUE_HIGH_LABEL,
  ALERT_CREATIVE_FATIGUE_MEDIUM_TABLE_LABEL,
  ALERT_CREATIVE_FATIGUE_HIGH_TABLE_LABEL,
  GO_TO_PROFILE,
  CREATORS_SUGGESTED_EMPTY,
  WARNING,
  WAIT,
  ERROR,
  ERROR_DESCRIPTION_GENERIC,
  LIST_CREATORS_WITH_AUDIENCE_SIMILAR,
  LAST_UPDATE_DATE,
  BUTTON_INIT_CHAT,
  UPDATE,
  INFORMATION_INVALID_ACCESS,
  FOLLOWERS,
  AVG_LIKES,
  AVG_COMMENTS,
  ANALYTICS,
  AVG_VIEWS,
  AUDIENCE_INFORMATION,
  AUDIENCE_CREDIBILITY,
  AUDIENCE_CREDIBILITY_TITLE_EXPLANATION,
  AUDIENCE_CREDIBILITY_DESCRIPTION_EXPLANATION,
  AUDIENCE_BY_COUNTRY,
  AUDIENCE_BY_CITIES,
  AUDIENCE_BY_BRAND_AFFINITY,
  AUDIENCE_BY_INTERESTS,
  FEMALES,
  MALES,
  AUDIENCE_BY_DISTRIBUTION_AGE,
  AUDIENCE_BY_PERCENTAGE_GENDERS,
  BUTTON_USE_AS_REFERENCE_PROFILE,
  AUDIENCE_BY_SIMILAR_AUDIENCE,
  PROFILE,
  PUBLISHED_DATE,
  GALLERY_CONTENT_BUZZLY,
  EMPTY_CONTENT_SHOW,
  LOADING_SIMILAR_PROFILES_INFORMATION,
  EMPTY_SIMILAR_PROFILES_SHOW,
  FIELD_REQUIRED,
  FIELD_MUST_BE_SELECT_AT_LEAST_PRODUCTS,
  EMPTY_RESULTS_SHOW,
  DISCOVER_NEW_CREATORS,
  BUTTON_DOWNLOAD,
  START_DATE_PLACEHOLDER,
  END_DATE_PLACEHOLDER,
  BUTTON_CALCULATE,
  BUTTON_ENTERPRISE_CALCULATE,
  LOADING_REPORT_INFORMATION,
  COLLABORATIONS,
  LIKES,
  SHARES,
  UNKNOWN_FORMAT,
  COLLABORATION,
  CATEGORY,
  REDEEM_CODE_TITLE,
  REDEEM_CODE_DESCRIPTION,
  REDEEM_CODE_SEARCHBAR_PLACEHOLDER,
  BUTTON_REDEEM_CODE,
  BUTTON_ADD_STORE,
  SELECT_STORE,
  STORE,
  EMPTY_STORES,
  REDEEM_CODE_TABLE_COLUMN_VALUE,
  REDEEM_CODE_TABLE_COLUMN_DATE,
  REDEEM_CODE_TABLE_COLUMN_CODE,
  FIELD_NUMERIC,
  FIELD_TEXT,
  FIELD_ALPHANUMERIC,
  CODE_REDEEMED,
  VALUE_CODE_REDEEMED,
  CODE_NO_EXIST,
  CODE_NO_REDEEM_BEFORE_DATE,
  EVENT_NO_EXIST,
  EVENT_DISABLED,
  ORDERS_SEARCHBAR_PLACEHOLDER,
  ORDERS_DESCRIPTION,
  ORDERS_TITLE,
  NEW_ORDER,
  ORDERS_TAB_TO_BE_ACCEPTED,
  ORDERS_TAB_IN_PREPARATION,
  ORDERS_TAB_TO_BE_DELIVERED,
  ORDERS_TAB_TO_BE_ACCEPTED_DESCRIPTION,
  ORDERS_TAB_IN_PREPARATION_DESCRIPTION,
  ORDERS_TAB_TO_BE_DELIVERED_DESCRIPTION,
  NEW,
  MINUTE_LETTER_COUNT_DOWN,
  HOUR_LETTER_COUNT_DOWN,
  DAY_LETTER_COUNT_DOWN,
  WEEK_LETTER_COUNT_DOWN,
  DELIVERY_INTERN,
  DELIVERY_ON_THE_WAY,
  ORDER_ACCEPTED,
  ORDER_ACCEPTED_DESCRIPTION,
  ORDER_READY,
  ORDER_READY_DESCRIPTION,
  ORDER_TO_BE_DELIVERED_CONFIRMATION,
  ORDER_TO_BE_DELIVERED_CONFIRMATION_BUTTON,
  ORDER_DELIVERED,
  ORDER_DELIVERED_DESCRIPTION,
  DELIVERY_SELECTED,
  ORDER_REJECTED,
  ORDER_REJECTED_DESCRIPTION,
  DELIVERY_SELECTED_DESCRIPTION,
  ORDER_TOTAL_VALUE,
  ORDER_LIST_OF_PRODUCTS,
  VALUE_WITH_CURRENCY,
  NUMBER_CURRENCY,
  ORDER_OPTIONS,
  CLIENT,
  ADDRESS,
  IDENTIFICATION_NUMBER,
  PHONE_NUMBER,
  NAME,
  BUTTON_ACCEPT_ORDER,
  BUTTON_REJECT_ORDER,
  DATE_LONG,
  MINUTES,
  HOURS,
  DAYS,
  WEEKS,
  ORDER_TIME_PREPARATION_TITLE,
  MIN_VALUE_PREPARATION_ORDER,
  MAX_VALUE_PREPARATION_ORDER,
  INVALID_TIME_PREPARATION,
  TIME_PREPARATION_VALUES_VALIDATION,
  GO,
  BUTTON_READY_ORDER,
  GUIDE_NUMBER_REQUIRED,
  DELIVERY_TYPE_DUPLICATE,
  SELECT_DELIVERY_TYPE,
  SELECT_DELIVERY_TYPE_OTHER,
  GUIDE_NUMBER,
  DELIVERY_DATA,
  BUTTON_DELIVER_ORDER,
  BUTTON_CANCEL,
  BUTTON_CREATE_CAMPAIGN,
  CAMPAIGNS_TITLE,
  CAMPAIGNS_DESCRIPTION,
  CAMPAIGNS_SEARCHBAR_PLACEHOLDER,
  CAMPAIGNS_TABLE_COLUMN_NAME,
  CAMPAIGNS_TABLE_COLUMN_PLATFORMS,
  CAMPAIGNS_TABLE_COLUMN_STATUS,
  CAMPAIGN_ACTIVATE,
  CAMPAIGN_DEACTIVATE,
  CAMPAIGN_ACTIVATE_TIME_CONFIRMATION,
  CAMPAIGN_DEACTIVATE_TIME,
  CAMPAIGN_DEACTIVATE_APPLICANTS_ACCEPTED,
  CAMPAIGN_ACTIVATE_FIELDS_REQUIRED,
  CAMPAIGN_ACTIVATE_MIN_BUDGET_CREATOR,
  CAMPAIGN_ACTIVATE_TRAFFIC_LINK,
  CAMPAIGN_ACTIVATE_HAS_COLLABORATION_USER_NAME_INSTAGRAM,
  CAMPAIGN_ACTIVATE_ATTACHMENT_LINK,
  CREATE_CAMPAIGN_QUESTION,
  CREATE_CAMPAIGN_ACCEPT_TERMS_DISCLAIMER,
  CREATE_CAMPAIGN_NAME_REQUIRED,
  CREATE_CAMPAIGN_DESCRIPTION_REQUIRED,
  CREATE_CAMPAIGN_BUDGET_REQUIRED,
  CREATE_CAMPAIGN_BUDGET_MIN_VALUE,
  CREATE_CAMPAIGN_PLATFORMS_REQUIRED,
  CREATE_CAMPAIGN_TYPE_CONTENT,
  CREATE_CAMPAIGN_TRAFFIC_LINK_REQUIRED,
  CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_REQUIRED,
  CREATE_CAMPAIGN_MESSAGE_CONTENT_REQUIRED,
  CREATE_CAMPAIGN_DATES_REQUIRED,
  CREATE_CAMPAIGN_REPOST_HAS_COLLABORATION,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_REQUIRED,
  CREATE_CAMPAIGN_ATTACHMENT_LINK,
  CREATE_CAMPAIGN_HAS_BEEN_ACTIVATE,
  CREATE_CAMPAIGN_HAS_BEEN_SAVE,
  CREATE_CAMPAIGN_SAVE_PROGRESS_NAME_REQUIRED,
  CREATE_CAMPAIGN_SAVE_PROGRESS,
  BUTTON_SAVE_PROGRESS,
  QUESTION,
  CREATE_CAMPAIGN_NAME_EXAMPLE,
  BUTTON_NEXT,
  BUTTON_PREVIOUS,
  BUTTON_ADVANCED_CONFIGURATION,
  BUTTON_FINISH,
  CREATE_CAMPAIGN_NAME_QUESTION,
  CREATE_CAMPAIGN_NAME_PLACEHOLDER,
  CREATE_CAMPAIGN_DESCRIPTION_QUESTION,
  CREATE_CAMPAIGN_DESCRIPTION_PLACEHOLDER,
  CREATE_CAMPAIGN_BUDGET_QUESTION,
  CREATE_CAMPAIGN_BUDGET_DESCRIPTION,
  CREATE_CAMPAIGN_PLATFORMS,
  CREATE_CAMPAIGN_TYPE_CONTENT_QUESTION,
  CREATE_CAMPAIGN_COPYWRITING_QUESTION,
  CREATE_CAMPAIGN_COPYWRITING_PLACEHOLDER,
  CREATE_CAMPAIGN_TRAFFIC_LINK_QUESTION,
  CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER,
  CREATE_CAMPAIGN_HAS_COLLABORATION_QUESTION,
  CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_QUESTION,
  CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER,
  CREATE_CAMPAIGN_MESSAGE_CONTENT_QUESTION,
  CREATE_CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER,
  CREATE_CAMPAIGN_DATES_QUESTION,
  CREATE_CAMPAIGN_DATES_DESCRIPTION,
  CREATE_CAMPAIGN_DATES_START_DATE_PLACEHOLDER,
  CREATE_CAMPAIGN_DATES_END_DATE_PLACEHOLDER,
  CREATE_CAMPAIGN_REPOST_QUESTION,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_QUESTION,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_ALL_OPTION,
  CREATE_CAMPAIGN_AGE_RANGE_QUESTION,
  CREATE_CAMPAIGN_BRIEF_QUESTION,
  CREATE_CAMPAIGN_BRIEF_DESCRIPTION,
  CREATE_CAMPAIGN_UPLOAD_BRIEF,
  CREATE_CAMPAIGN_REMOVED_BRIEF,
  CREATE_CAMPAIGN_ATTACHMENT_FILE_QUESTION,
  CREATE_CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION,
  CREATE_CAMPAIGN_ATTACHMENT_LINK_QUESTION,
  CREATE_CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION,
  CREATE_CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER,
  CREATE_CAMPAIGN_QUANTITY_GENDER_QUESTION,
  CREATE_CAMPAIGN_REFERENCE_PROFILES_QUESTION,
  CREATE_CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER,
  CREATE_CAMPAIGN_HASHTAG_QUESTION,
  CREATE_CAMPAIGN_HASHTAG_PLACEHOLDER,
  CREATE_CAMPAIGN_MESSAGE_TONE_QUESTION,
  CREATE_CAMPAIGN_MESSAGE_TONE_PLACEHOLDER,
  CREATE_CAMPAIGN_ENVIRONMENT_QUESTION,
  CREATE_CAMPAIGN_ENVIRONMENT_PLACEHOLDER,
  CREATE_CAMPAIGN_COLORS_CONTENT_QUESTION,
  CREATE_CAMPAIGN_COLORS_CONTENT_PLACEHOLDER,
  CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_QUESTION,
  CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER,
  CREATE_CAMPAIGN_KEY_WORDS_QUESTION,
  CREATE_CAMPAIGN_PROHIBITED_WORDS_QUESTION,
  CREATE_CAMPAIGN_PROHIBITED_WORDS_PLACEHOLDER,
  CREATE_CAMPAIGN_OUTFIT_QUESTION,
  CREATE_CAMPAIGN_OUTFIT_PLACEHOLDER,
  BUTTON_UPLOAD_CONTENT,
  BUTTON_UPLOAD_DOCUMENT,
  BUTTON_REMOVE_CONTENT,
  DELETE_CONTENT_CONFIRMATION_TITLE,
  DELETE_CONTENT_CONFIRMATION_DESCRIPTION,
  DELETE_SCHEDULED_CONTENT_CONFIRMATION_TITLE,
  DELETE_SCHEDULED_CONTENT_CONFIRMATION_DESCRIPTION,
  DELETE_SCHEDULED_CONTENT_ERROR_DESCRIPTION,
  DELETE_SCHEDULED_CONTENT_SUCCESS,
  DELETE_MULTIPLE_CONTENT_CONFIRMATION_TITLE,
  DELETE_MULTIPLE_CONTENT_CONFIRMATION_DESCRIPTION,
  BUTTON_DELETE_CONTENT,
  CREATE_CAMPAIGN_KEY_WORDS_PLACEHOLDER,
  READY,
  FIELD_HAS_NO_VALUE_TO_COPY,
  BUTTON_FINISHED_CAMPAIGN,
  CAMPAIGN_FINISHED_CONFIRMATION,
  BUTTON_SAVE_CAMPAIGN,
  BUTTON_DEACTIVATE_CAMPAIGN,
  BUTTON_ACTIVATE_CAMPAIGN,
  CAMPAIGN_HAS_BEEN_FINISHED,
  CAMPAIGN_DETAIL_TITLE,
  CAMPAIGN_DETAIL_APPLICANTS_ACCEPTED_TITLE,
  CAMPAIGN_DETAIL_CREATORS_INVITED_TITLE,
  CAMPAIGN_DETAIL_CAMPAIGN_INFORMATION_TITLE,
  ACTIONS,
  STATUS,
  CITIES,
  CATEGORIES,
  CAMPAIGN_FINISH_APPLICANTS_ACCEPTED,
  PAYMENT_SUCCESSFUL,
  UPGRADE_SUBSCRIPTION_SUCCESSFUL,
  BUTTON_SEND_INVITE,
  CAMPAIGN_DETAIL_APPLICANT_PAYMENT_DESCRIPTION,
  CAMPAIGN_DETAIL_APPLICANT_PAYMENT_ADDITIONAL_DESCRIPTION,
  CAMPAIGN_DETAIL_REJECT_APPLICANT_CONFIRMATION,
  BUTTON_REJECT,
  LIST_OF_CREATORS,
  CAMPAIGN_FIELDS_REQUIRED,
  CAMPAIGN_NAME_PLACEHOLDER,
  CAMPAIGN_DESCRIPTION_PLACEHOLDER,
  CAMPAIGN_BUDGET_PLACEHOLDER,
  CAMPAIGN_PLATFORMS_PLACEHOLDER,
  CAMPAIGN_TYPE_CONTENT_PLACEHOLDER,
  CAMPAIGN_COPY_POST_PLACEHOLDER,
  CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER,
  CAMPAIGN_HAS_COLLABORATION_PLACEHOLDER,
  CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER,
  CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER,
  CAMPAIGN_DATES_START_DATE_PLACEHOLDER,
  CAMPAIGN_DATES_END_DATE_PLACEHOLDER,
  CAMPAIGN_REPOST_PLACEHOLDER,
  CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER,
  CAMPAIGN_AGE_RANGE_PLACEHOLDER,
  CAMPAIGN_BRIEF_PLACEHOLDER,
  CAMPAIGN_BRIEF_DESCRIPTION,
  CAMPAIGN_ATTACHMENT_FILE_PLACEHOLDER,
  CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION,
  CAMPAIGN_ATTACHMENT_LINK_TITLE,
  CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION,
  CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER,
  CAMPAIGN_GENDERS_PLACEHOLDER,
  CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER,
  CAMPAIGN_HASHTAG_PLACEHOLDER,
  CAMPAIGN_MESSAGE_TONE_PLACEHOLDER,
  CAMPAIGN_ENVIRONMENT_PLACEHOLDER,
  CAMPAIGN_COLORS_CONTENT_PLACEHOLDER,
  CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER,
  CAMPAIGN_KEY_WORDS_PLACEHOLDER,
  CAMPAIGN_PROHIBITED_KEY_WORDS_PLACEHOLDER,
  CAMPAIGN_OUTFIT_PLACEHOLDER,
  BUTTON_ASSIGN_INVITE,
  BUTTON_REVIEW_CONTENT,
  BUTTON_ACCEPT,
  BUTTON_VIEW_PRELIMINARY_CONTENT,
  BUTTON_VIEW_APPLICANT,
  BUTTON_ACCEPT_AND_PAY,
  PAYMENT_METHOD,
  PAYMENT_METHODS,
  CONTENT_CREATOR,
  PRICE_TO_BE_PAID,
  PAYMENT_METHODS_SECURE,
  PAYMENT_METHODS_SECURE_EXPLANATION,
  PAYMENT_METHODS_ENCRYPTED,
  PAY,
  PAYMENT_METHODS_EMPTY,
  MAIN_PAYMENT_METHOD,
  OTHERS_PAYMENT_METHODS_EMPTY,
  OTHERS_PAYMENT_METHODS,
  ADD_CARD,
  VERIFY_SUBSCRIPTION_TITLE,
  VERIFY_SUBSCRIPTION_DESCRIPTION,
  VERIFY_SUBSCRIPTION_CTA,
  SAVE_CONFIGURATION,
  ADD,
  NAME_PLACEHOLDER,
  EMAIL_PLACEHOLDER,
  PASSWORD_PLACEHOLDER,
  PASSWORD_CONFIRMATION_PLACEHOLDER,
  CARD_INFORMATION_EXPLANATION_TITLE,
  CARD_INFORMATION_NUMBER_CARD_EXPLANATION_DESCRIPTION,
  CARD_INFORMATION_NUMBER_CARD_EXPLANATION_TITLE,
  CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_TITLE,
  CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_DESCRIPTION,
  CARD_INFORMATION_CVV_EXPLANATION_TITLE,
  CARD_INFORMATION_CVV_EXPLANATION_DESCRIPTION,
  APPLICANTS_STATUS_PENDING,
  APPLICANTS_STATUS_ACCEPTED,
  APPLICANTS_STATUS_REJECTED,
  APPLICANTS_STATUS_CONTENT_SUBMITTED,
  APPLICANTS_STATUS_CONTENT_REVISIONS,
  APPLICANTS_STATUS_CONTENT_PENDING_SOCIAL,
  APPLICANTS_STATUS_CONTENT_PENDING_ANALYTICS,
  APPLICANTS_STATUS_DELIVERED,
  BUTTON_REVIEW,
  APPLICANT_CONTENT_OF_CREATOR,
  APPLICANT_REVISION_PLACEHOLDER,
  BUTTON_ACCEPT_CONTENT,
  BUTTON_REJECT_CONTENT,
  BUTTON_SEND_REVIEW,
  BUTTON_CONTINUE,
  BUTTON_SIGN_UP,
  BUTTON_MORE_QUESTIONS,
  BUTTON_UNDERSTOOD,
  WARNING_MOBILE_TUTORIAL,
  FAQ_DESCRIPTION,
  EMPTY_QUESTIONS_SHOW,
  BUTTON_INIT_TUTORIAL,
  FAQ_QUESTION_WHAT_IS_BUZZLY,
  FAQ_QUESTION_WHAT_IS_BUZZLY_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_REQUEST,
  FAQ_QUESTION_WHAT_IS_REQUEST_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_PUBLICATION,
  FAQ_QUESTION_WHAT_IS_PUBLICATION_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_CAMPAIGN,
  FAQ_QUESTION_WHAT_IS_CAMPAIGN_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_ORDER,
  FAQ_QUESTION_WHAT_IS_ORDER_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_STORE,
  FAQ_QUESTION_WHAT_IS_STORE_DESCRIPTION,
  FAQ_QUESTION_WHAT_ROLES_EXISTS,
  FAQ_QUESTION_WHAT_ROLES_EXISTS_DESCRIPTION,
  FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS,
  FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS_DESCRIPTION,
  FAQ_QUESTION_MUST_CALL_ADMIN,
  FAQ_QUESTION_MUST_CALL_ADMIN_DESCRIPTION,
  FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE,
  FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE_DESCRIPTION,
  BUTTON_PAYMENTS,
  BUTTON_BROADCAST,
  BUTTON_SAVE,
  RECURRENT_FIELDS_DEFAULT_TITLE,
  RECURRENT_FIELD_REPEAT_COUNT_MIN_VALIDATION,
  RECURRENT_FIELD_REPEAT_COUNT_PLACEHOLDER,
  RECURRENT_FIELD_REPEAT_COUNT_MAX_VALIDATION,
  RECURRENT_FIELD_FREQUENCY_PLACEHOLDER,
  RECURRENT_FIELD_DAY_AN_PLACEHOLDER,
  RECURRENT_FIELD_DAY_ALL_PLACEHOLDER,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
  SUNDAY,
  SELECT_A_OPTION,
  WEEK,
  MONTH,
  MONTHS,
  MODAL_BROADCAST_ARIAL_LABEL,
  MODAL_BROADCAST_TITLE,
  MODAL_BROADCAST_SELECT_USER_PLACEHOLDER,
  MODAL_BROADCAST_SELECT_USER_REQUIRED,
  MODAL_BROADCAST_MESSAGE_PLACEHOLDER,
  BROADCAST_MESSAGE_SENT,
  BUTTON_SEND_MESSAGE,
  BUTTON_UPLOAD_FILE,
  BUTTON_REMOVE_FILE,
  FILE_SELECTED,
  SELECT_PAYMENT_METHOD,
  YOU_WILL_PAY,
  DAY,
  HOUR,
  MINUTE,
  SECOND,
  SECONDS,
  PUBLICATION_TITLE,
  NUMBER_PUBLICATION,
  FEEDBACK_TITLE,
  PUBLICATION_FINISH_ONBOARDING_NEW_BRANDS_DESCRIPTION,
  PUBLICATION_FINISH_DESCRIPTION,
  FEEDBACK_PLACEHOLDER,
  FIELD_MIN_LENGTH,
  PUBLICATIONS_TITLE,
  PUBLICATIONS_DESCRIPTION,
  PUBLICATIONS_TABLE_ARIA_LABEL,
  PUBLICATIONS_TABLE_COLUMN_DATE,
  PUBLICATION_STATUS_PENDING,
  PUBLICATIONS_STATUS_PENDING_ANALYTICS,
  PUBLICATIONS_STATUS_SENT,
  PUBLICATIONS_STATUS_FEEDBACK,
  PUBLICATIONS_STATUS_VERIFIED,
  FEEDBACK_REASON,
  FEEDBACK_COMMENT,
  ANALYTICS_EXPLANATION_TITLE,
  ANALYTICS_EXPLANATION_DESCRIPTION,
  ANALYTICS_EXPLANATION_DESCRIPTION_2,
  ANALYTICS_EXPLANATION_ACCOUNTS_REACHED_DESCRIPTION,
  ANALYTICS_EXPLANATION_ENGAGEMENT_DESCRIPTION,
  ANALYTICS_EXPLANATION_STICKERS_TAPS_DESCRIPTION,
  ANALYTICS_EXPLANATION_NAVIGATION_DESCRIPTION,
  EMPTY_ANALYTICS,
  BUTTON_VERIFY_PUBLICATION,
  FEEDBACK_REASON_ABOUT,
  YES,
  NO,
  RECURRENT_VALUE_NOT_FOUND,
  MODAL_REVIEW_ARIA_LABEL,
  MODAL_REVIEW_DISCLAIMER,
  MODAL_REVIEW_SCORE_CONTENT_PLACEHOLDER,
  MODAL_REVIEW_SCORE_CONTENT_MIN_VALUE,
  MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_TITLE,
  MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_DESCRIPTION,
  MODAL_REVIEW_SCORE_ENGAGEMENT_PLACEHOLDER,
  MODAL_REVIEW_SCORE_ENGAGEMENT_MIN_VALUE,
  MODAL_REVIEW_COMMENT_PLACEHOLDER,
  LOADING_DOWNLOAD_PROFILES,
  BUTTON_SEARCH,
  BUTTON_METRICS_READY,
  IMAGES,
  VIDEOS,
  LOADING_CONTENT,
  MODAL_GALLERY_ARIA_LABEL,
  MODAL_GALLERY_EMPTY_CONTENT,
  SELECT_ACCOUNT_TO_LOAD_GALLERY_CONTENT,
  SELECT_YOUTUBE_ACCOUNT_TO_LOAD_GALLERY_CONTENT,
  MODAL_GALLERY_NO_MORE_CONTENT,
  MODAL_MEDIA_ARIA_LABEL,
  BUTTON_UPLOAD_TIKTOK,
  MODAL_UPLOAD_TIKTOK_ARIA_LABEL,
  MODAL_UPLOAD_TIKTOK_TITLE,
  MODAL_UPLOAD_FAILED_GET_CONFIGURATION,
  LOADING_CONFIGURATION,
  BUTTON_VIEW_PROFILE,
  BUTTON_GENERATE_DESCRIPTION,
  MODAL_UPLOAD_CONTENT_UPLOADED,
  MODAL_UPLOAD_TIKTOK_VIDEO_UPLOADED_DESCRIPTION,
  MODAL_UPLOAD_FAILED_GENERATE_DESCRIPTION,
  MODAL_UPLOAD_TIKTOK_DESCRIPTION_LABEL,
  MODAL_UPLOAD_TIKTOK_DESCRIPTION_PLACEHOLDER,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_LABEL,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_PUBLIC_OPTION,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_FOLLOWERS_OPTION,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_ONLY_I_OPTION,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_PLACEHOLDER,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_COMMENT_OPTION,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_DUOS_OPTION,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_CUT_OPTION,
  ACCOUNT_TITLE,
  ACCOUNT_DESCRIPTION,
  BUTTON_UPLOAD_IMAGE,
  BUTTON_REMOVE_IMAGE,
  FIELD_IMAGE_REQUIRED,
  FIELD_IMAGE_FORMAT_VALID,
  FIELD_IMAGE_SIZE_VALID,
  FIELD_FILE_REQUIRED,
  FIELD_FILE_SIZE_VALID,
  FIELD_URL_VALID,
  FIELD_URL_ADLE_APP_DOMAIN,
  COMPANY_INFORMATION_TITLE,
  COMPANY_INFORMATION_SUBCATEGORY_DUPLICATE,
  COMPANY_INFORMATION_TYPE_ID_PLACEHOLDER,
  COMPANY_INFORMATION_ID_NUMBER_PLACEHOLDER,
  COMPANY_INFORMATION_ID_NUMBER_MIN_LENGTH,
  COMPANY_INFORMATION_ID_NUMBER_TYPE,
  COMPANY_INFORMATION_BRAND_NAME_PLACEHOLDER,
  COMPANY_INFORMATION_BUSINESS_NAME_PLACEHOLDER,
  COMPANY_INFORMATION_ADDRESS_PLACEHOLDER,
  COMPANY_INFORMATION_AVERAGE_TICKET_PLACEHOLDER,
  COMPANY_INFORMATION_AVERAGE_TICKET_MIN_VALUE,
  COMPANY_INFORMATION_SOCIAL_NETWORK_PLACEHOLDER,
  COMPANY_INFORMATION_SECOND_SOCIAL_NETWORK_PLACEHOLDER,
  COMPANY_INFORMATION_TRAFFIC_URL_PLACEHOLDER,
  COMPANY_INFORMATION_CATEGORY_PLACEHOLDER,
  COMPANY_INFORMATION_SUBCATEGORY_PLACEHOLDER,
  COMPANY_INFORMATION_NEW_SUBCATEGORY,
  COMPANY_INFORMATION_SHORT_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_ADMIN_PHONE_PLACEHOLDER,
  COMPANY_INFORMATION_RESERVATION_URL_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_LOGO_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_LOGO_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_COVER_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_COVER_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_VIEW_DOCUMENT,
  COMPANY_INFORMATION_SHOP_ID_COPIED,
  BUTTON_SAVE_CHANGES,
  BUTTON_UPLOAD_VIDEO,
  BUTTON_REMOVE_VIDEO,
  BUTTON_DISCONNECT,
  BUTTON_CONNECT_TIKTOK,
  PLATFORMS_CONNECTED_TITLE,
  SCHEDULE_TITLE,
  SCHEDULE_ECOMMERCE_ALERT_TITLE,
  SCHEDULE_ECOMMERCE_ALERT_DESCRIPTION,
  SCHEDULE_ONE_DAY_WITH_TURN,
  SCHEDULE_EMPTY_TURN,
  SCHEDULE_OPEN_AND_CLOSE_HOUR_VALIDATION,
  SCHEDULE_MAX_CLOSE_HOUR,
  BUTTON_BE_ECOMMERCE,
  BUTTON_NOT_BE_ECOMMERCE,
  BUTTON_ADD_TURN,
  SCHEDULE_TABLE_ARIA_LABEL,
  SCHEDULE_TABLE_COLUMN_OPEN,
  SCHEDULE_TABLE_COLUMN_CLOSE,
  SCHEDULE_SAVED,
  LEGAL_REPRESENTATIVE_TITLE,
  LEGAL_REPRESENTATIVE_NAME_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_LAST_NAME_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_TYPE_ID_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_ID_NUMBER_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_PHONE_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_SAVED,
  PASSWORD_TITLE,
  PASSWORD_CURRENT_PASSWORD_PLACEHOLDER,
  PASSWORD_NEW_PASSWORD_PLACEHOLDER,
  PASSWORD_CONFIRM_PASSWORD_PLACEHOLDER,
  PASSWORD_FORMAT_DESCRIPTION,
  PASSWORD_FORMAT_SUGGESTION1,
  PASSWORD_FORMAT_SUGGESTION2,
  PASSWORD_FORMAT_SUGGESTION3,
  PASSWORD_FORMAT_SUGGESTION4,
  PASSWORD_INSECURE,
  PASSWORDS_NOT_MATCH,
  PASSWORD_CHANGED,
  PASSWORD_CURRENT_INVALID,
  PASSWORD_ACCOUNT_DISABLED_FOR_MORE_INTENTS,
  OK,
  BUTTON_DELETE,
  BUTTON_CREATE,
  MODAL_STORE_ARIA_LABEL,
  MODAL_STORE_TYPE_PLACEHOLDER,
  MODAL_STORE_HOW_TO_INTEGRATE_STORE,
  MODAL_STORE_NAME_PLACEHOLDER,
  MODAL_STORE_DESCRIPTION_PLACEHOLDER,
  MODAL_STORE_ADDRESS_PLACEHOLDER,
  MODAL_STORE_CITY_PLACEHOLDER,
  MODAL_STORE_PHONE_PLACEHOLDER,
  MODAL_STORE_LINK_STORE_SPECIAL_PLACEHOLDER,
  MODAL_STORE_NAME_SHOPIFY_PLACEHOLDER,
  MODAL_STORE_LOOK_NAME_SHOPIFY,
  MODAL_STORE_LOOK_NAME_SHOPIFY_HELPER_TEXT,
  MODAL_STORE_ACCESS_TOKEN_FOR_BUZZLY_PLACEHOLDER,
  MODAL_STORE_DO_CREATE_DISCOUNT_SHIPPING_PLACEHOLDER,
  MODAL_STORE_CITIES_PLACEHOLDER,
  MODAL_STORE_ORDERS_METHODS_PLACEHOLDER,
  MODAL_STORE_ORDERS_METHODS_DELIVERY_OPTION,
  MODAL_STORE_ORDERS_METHODS_IN_STORE_OPTION,
  MODAL_STORE_PRODUCT_AVAILABILITY_PLACEHOLDER,
  MODAL_STORE_PRODUCT_AVAILABILITY_NATIONAL_OPTION,
  MODAL_STORE_PRODUCT_AVAILABILITY_LOCAL_OPTION,
  MODAL_STORE_COVERAGE_RADIUS_PLACEHOLDER,
  FIELD_EMAIL_VALID,
  FIELD_SPACES_VALID,
  MODAL_STORE_TYPE_REGULAR_OPTION,
  FIELD_PHONE_VALID,
  BUTTON_CREATE_USER,
  BUTTON_CREATE_ACCOUNT,
  MODAL_CREATE_ACCOUNT_TITLE,
  MODAL_CREATE_ACCOUNT_DESCRIPTION,
  FILTER,
  OPERATOR,
  ADMIN,
  USERS_TITLE,
  USERS_DESCRIPTION,
  USERS_TABS_ARIA_LABEL,
  USERS_PORTAL_TAB,
  USERS_CONTACTS_TAB,
  USERS_EMAIL_DUPLICATE,
  USERS_USER_CREATED,
  USERS_USER_SAVED,
  USERS_USER_DELETE_CONFIRMATION_TITLE,
  USERS_USER_DELETE_CONFIRMATION_DESCRIPTION,
  USERS_USER_DELETING,
  USERS_USER_DELETED,
  USERS_LIMIT_REACHED,
  ADVERTISERS_LIMIT_REACHED,
  USERS_ONBOARDING_FINISH,
  USERS_USER_SEARCH_BAR_PLACEHOLDER,
  USERS_TABLE_ARIA_LABEL,
  USERS_TABLE_COLUMN_NAME,
  USERS_TABLE_COLUMN_EMAIL,
  USERS_TABLE_COLUMN_STORE,
  USERS_TABLE_COLUMN_ROLE,
  MODAL_USER_ARIA_LABEL,
  MODAL_USER_TITLE,
  MODAL_USER_NAME_PLACEHOLDER,
  MODAL_USER_ROLE_PLACEHOLDER,
  MODAL_USER_ROLE_OPERATOR_EXPLANATION,
  MODAL_USER_STORE_PLACEHOLDER,
  MODAL_USER_PASSWORD_PLACEHOLDER,
  MODAL_USER_REPEAT_PASSWORD_PLACEHOLDER,
  FIELD_ALL_REQUIRED,
  FIELD_PASSWORDS_NO_MATCH,
  FIELD_PASSWORD_MIN_LENGTH,
  BUTTON_CREATE_CONTACT,
  USERS_CONTACT_CREATED,
  USERS_CONTACT_SAVED,
  USERS_CONTACT_DELETE_CONFIRMATION_TITLE,
  USERS_CONTACT_DELETE_CONFIRMATION_DESCRIPTION,
  USERS_CONTACT_DELETED,
  USERS_CONTACT_SEARCH_BAR_PLACEHOLDER,
  USERS_CONTACT_TABLE_ARIA_LABEL,
  USERS_CONTACT_TABLE_COLUMN_PHONE,
  MODAL_CONTACT_ARIA_LABEL,
  MODAL_CONTACT_TITLE,
  MODAL_CONTACT_PHONE_PLACEHOLDER,
  STORAGE_USAGE_TITLE,
  STORAGE_USAGE_LABEL,
  STORAGE_FULL_TITLE,
  STORAGE_FULL_MESSAGE,
  STORAGE_FULL_BUTTON_DELETE,
  STORAGE_FULL_BUTTON_UPGRADE,
  BILLING_DATA_TITLE,
  BILLING_DATA_DESCRIPTION,
  BILLING_DATA_SAVED,
  BILLING_DATA_PERSONAL_INFORMATION_DESCRIPTION,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_NATURE_OPTION,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_LEGAL_OPTION,
  BILLING_DATA_PERSONAL_INFORMATION_BUSINESS_NAME_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_NAME_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_LAST_NAME_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_ID_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_ID_NUMBER_PLACEHOLDER,
  BILLING_DATA_CONTACT_INFORMATION_DESCRIPTION,
  BILLING_DATA_CONTACT_INFORMATION_EMAIL_BILLING_PLACEHOLDER,
  BILLING_DATA_CONTACT_INFORMATION_ADDRESS_PLACEHOLDER,
  BILLING_DATA_CONTACT_INFORMATION_PHONE_PLACEHOLDER,
  BILLING_AND_PAYMENTS_TITLE,
  BILLING_AND_PAYMENTS_DESCRIPTION,
  BUTTON_VIEW_DETAILS,
  BUTTON_DOWNLOAD_INVOICE,
  BUTTON_CLOSE,
  TOTAL,
  BILLING_AND_PAYMENTS_TABLE_ARIA_LABEL,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_PAID_DATE,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_DUE_DATE,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_VALUE,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_REASON,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_STATUS,
  PAYMENT_REASON_COLLABORATION,
  PAYMENT_REASON_APPLICANT,
  PAYMENT_REASON_CLAPP_CREDITS,
  PAYMENT_REASON_PACKAGE,
  PAYMENT_REASON_PLAN,
  PAYMENT_PAID,
  PAYMENT_PENDING,
  MODAL_INVOICE_ARIA_LABEL,
  MODAL_INVOICE_TITLE,
  MODAL_INVOICE_DISCLAIMER,
  MODAL_INVOICE_NUMBER_CREDITS,
  PURCHASE_CREDITS,
  PURCHASE_VIDEOS,
  PURCHASE_X_CREDITS,
  MODAL_INVOICE_ORDER_TO_COLLECT,
  MODAL_INVOICE_APPLICANT_CAMPAIGN_PAID,
  MODAL_PAY_INVOICE_ARIA_LABEL,
  MODAL_PAY_INVOICE_TITLE,
  MODAL_PAY_INVOICE_WILL_PAY,
  MODAL_PAY_SUBSCRIPTION_PENDING_INVOICE_MESSAGE,
  MODAL_PAY_SUBSCRIPTION_PAY_NOW,
  MODAL_PAY_SUBSCRIPTION_PENDING_PAYMENT_TITLE,
  BILLING_PENDING_SUBSCRIPTION_PAYMENT_DESCRIPTION,
  NO_HAVE,
  ADD_PAYMENT_METHOD,
  SUPPORT,
  CONTACT_US,
  BILLING_AND_PAYMENT_CHANGE_YOUR_PLAN,
  BILLING_AND_PAYMENT_ACTIVATE_PLAN,
  BILLING_AND_PAYMENT_SELECT_PLAN,
  BILLING_AND_PAYMENT_NO_HAVE_PLAN,
  BILLING_AND_PAYMENT_PLAN_EXPIRED,
  BILLING_AND_PAYMENT_PLAN_NAME,
  BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_COST,
  BILLING_AND_PAYMENT_MODEL_USAGE_WHAT_BENEFITS,
  BILLING_AND_PAYMENT_MODEL_USAGE_SHOW_BENEFTIS,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT1,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT2,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT3,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT4,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT5,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT6,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_NAME,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_CHANGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_COLLECT_COST_COLLABORATION,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_ADD_PAYMENT_METHOD_TO_ACTIVATE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_EXPIRED,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_NO_HAVE_PACKAGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_ACTIVATE_PACKAGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_SELECT_PACKAGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_PACKAGE,
  MODAL_SELECT_PACKAGE_ARIA_LABEL,
  MODAL_SELECT_PACKAGE_AND_PAYMENT_METHOD_REQUIRED,
  MODAL_SELECT_PACKAGE_UPLOAD_GROWTH,
  MODAL_SELECT_PACKAGE_PRICING_HERO_TITLE,
  MODAL_SELECT_PACKAGE_PRICING_DISCOVER_BUZZLY,
  MODAL_SELECT_PACKAGE_UPLOAD_GROWTH_DESCRIPTION,
  MODAL_SELECT_PACKAGE_PRICING_HERO_DESCRIPTION,
  MODAL_SELECT_PACKAGE_VALUE_EXPRESSED,
  MODAL_SELECT_PACKAGE_PRICE,
  MODAL_SELECT_PACKAGE_PRICE_UPLOAD_GROWTH,
  MODAL_SELECT_PACKAGE_ACCORDING_TO_THE_REQUIREMENT,
  MODAL_SELECT_PACKAGE_BUY_PACKAGE_NAME,
  MODAL_SELECT_PACKAGE_COST_COLLABORATION,
  MODAL_SELECT_PACKAGE_BENEFIT_CATALOG,
  MODAL_SELECT_PACKAGE_BENEFIT_AUTOMATIZATION,
  MODAL_SELECT_PACKAGE_BENEFIT_SUPPORT_TICKETS,
  MODAL_SELECT_PACKAGE_BENEFIT_ALL_BASIC,
  MODAL_SELECT_PACKAGE_BENEFIT_KAM,
  MODAL_SELECT_PACKAGE_BENEFIT_DISCOVERY,
  MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT,
  MODAL_SELECT_PACKAGE_BENEFIT_ASSISTANCE_MARKETING,
  MODAL_SELECT_PACKAGE_BENEFIT_ALL_GROWTH,
  MODAL_SELECT_PACKAGE_BENEFIT_BRANDS_UNLIMITED,
  MODAL_SELECT_PACKAGE_BENEFIT_PERSONALIZED_INTEGRATIONS,
  MODAL_SELECT_PACKAGE_BENEFIT_IMPLEMENTATIONS_TECHNOLOGICAL,
  MODAL_SELECT_PACKAGE_BENEFIT_PRIORITIZED_SUPPORT,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_WHAT_BENEFITS,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_COST_COLLABORATION,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_DISCLAIMER,
  COMPANY_INFORMATION_ONBOARDING_FINISH_DESCRIPTION,
  MODAL_FREE_TRIAL_TITLE,
  MODAL_FREE_TRIAL_DESCRIPTION,
  MODAL_FREE_TRIAL_BUTTON,
  ACCEPT_TERMS_PAY,
  DELETE_PAYMENT_METHOD_CONFIRMATION_TITLE,
  QUANTITY_TO_PAY,
  BLOCK_PAYMENT_FAILED_TITLE,
  BLOCK_TRIAL_END_TITLE,
  BLOCK_PLAN_BUTTON,
  MODAL_BUY_CREDITS_ARIA_LABEL,
  MODAL_BUY_CREDITS_TITLE,
  MODAL_BUY_CREDITS_DESCRIPTION,
  MODAL_BUY_CREDITS_CREDIT_FOR_COLLABORATION,
  MODAL_BUY_CREDITS_HOW_MANY_CREDITS_BUY,
  MODAL_BUY_CREDITS_REDEEMED_ESTIMATED_TIME,
  MODAL_BUY_CREDITS_ADDITIONAL_CREDITS,
  MODAL_BUY_CREDITS_LAST_TEXT_PAY,
  MODAL_BUY_CREDITS_AMOUNT_FOR_PRICE,
  MODAL_BUY_CREDITS_AND_PAYMENT_METHOD_REQUIRED,
  MODAL_BUY_CREDITS_NEGATIVE,
  MODAL_BUY_CREDITS_PURCHASED,
  MODAL_BUY_CREDITS_PURCHASED_DESCRIPTION,
  MODAL_BUY_VIDEOS_PURCHASED,
  MODAL_BUY_VIDEOS_PURCHASED_DESCRIPTION,
  MODAL_BUY_CREDITS_GIFT_CREDITS,
  MODAL_PURCHASE_CREDITS_TITLE,
  MODAL_PURCHASE_CREDITS_ARIA_LABEL,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_TITLE,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_1,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_2,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3_LINK,
  MODAL_PURCHASE_CREDITS_SELECT_AMOUNT,
  MODAL_PURCHASE_CREDITS_CREDITS_LABEL,
  MODAL_PURCHASE_CREDITS_PRICE_PER_CREDIT,
  MODAL_PURCHASE_CREDITS_CREDIT_PACKAGES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_SUBTITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_ON_SCREEN_TEXT_LANGUAGES,
  MODAL_PURCHASE_CREDITS_VIDEOS_LABEL,
  MODAL_PURCHASE_CREDITS_PRICE_PER_VIDEO,
  MODAL_PURCHASE_CREDITS_PURCHASE_VIDEOS_BUTTON,
  MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLE,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_TITLE,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_INTRO,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_INSTRUCTION,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_PURCHASE,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_UPGRADE,
  MODAL_PURCHASE_CREDITS_MINIMUM_AMOUNT,
  MODAL_PURCHASE_CREDITS_CUSTOM_AMOUNT_PLACEHOLDER,
  MODAL_PURCHASE_CREDITS_UPGRADE_PLAN,
  MODAL_PURCHASE_CREDITS_PURCHASE_BUTTON,
  MODAL_PURCHASE_CREDITS_PAYMENT_SUMMARY,
  SECTION_COMPETITORS_TITLE,
  SECTION_COMPETITORS_SUBTITLE_SINGULAR,
  SECTION_COMPETITORS_SUBTITLE_PLURAL,
  SECTION_SOCIAL_TITLE,
  SECTION_SOCIAL_SUBTITLE_SINGULAR,
  SECTION_SOCIAL_SUBTITLE_PLURAL,
  SECTION_VOICE_TITLE,
  SECTION_VOICE_SUBTITLE,
  SECTION_VOICE_TONE_DESCRIPTION,
  SECTION_VOICE_ATTRIBUTES_LABEL,
  SECTION_OFFER_TITLE,
  SECTION_OFFER_SUBTITLE,
  SECTION_OFFER_TYPE_LABEL,
  SECTION_OFFER_VISUAL_STYLE_LABEL,
  SECTION_OFFER_DEFAULT_VALUE,
  SECTION_COUNTRY_TITLE,
  SECTION_COUNTRY_SUBTITLE,
  SECTION_COUNTRY_LABEL,
  SECTION_COUNTRY_DEFAULT_VALUE,
  SECTION_TYPOGRAPHY_TITLE,
  SECTION_TYPOGRAPHY_SUBTITLE,
  SECTION_TYPOGRAPHY_FONT_FAMILY_LABEL,
  SECTION_TYPOGRAPHY_TITLE_FONT_LABEL,
  SECTION_TYPOGRAPHY_SUBTITLE_FONT_LABEL,
  SECTION_TYPOGRAPHY_BODY_FONT_LABEL,
  SECTION_TYPOGRAPHY_ADD_TYPOGRAPHY,
  SECTION_TYPOGRAPHY_FONT_SIZES_LABEL,
  SECTION_TYPOGRAPHY_HEADING_LABEL,
  SECTION_TYPOGRAPHY_SUBHEADING_LABEL,
  SECTION_TYPOGRAPHY_BODY_LABEL,
  SECTION_TYPOGRAPHY_PX_UNIT,
  SECTION_TYPOGRAPHY_GENERATING_PREVIEW,
  SECTION_TYPOGRAPHY_ADD_FONT,
  SECTION_LOGO_TITLE,
  SECTION_LOGO_SUBTITLE,
  SECTION_COLORS_TITLE,
  SECTION_COLORS_SUBTITLE,
  SECTION_COLORS_ADD_COLOR,
  SECTION_TARGET_AUDIENCE_TITLE,
  SECTION_TARGET_AUDIENCE_SUBTITLE,
  SECTION_TARGET_AUDIENCE_ICP_LABEL,
  SECTION_PRODUCT_IMAGES_TITLE,
  SECTION_PRODUCT_IMAGES_SUBTITLE,
  BUTTON_UPLOAD_PRODUCT_IMAGES,
  BUTTON_DELETE_PRODUCT_IMAGE,
  SECTION_ADDITIONAL_ASSETS_TITLE,
  SECTION_ADDITIONAL_ASSETS_SUBTITLE,
  SECTION_ADDITIONAL_ASSETS_PROMPT_LABEL,
  SECTION_ADDITIONAL_ASSETS_PROMPT_PLACEHOLDER,
  SECTION_ADDITIONAL_ASSETS_PROMPT_REQUIRED,
  BUTTON_UPLOAD_ADDITIONAL_ASSET,
  SECTION_ADDITIONAL_ASSETS_MAX_ERROR,
  SECTION_ADDITIONAL_ASSETS_ASSET_LABEL,
  SECTION_ADDITIONAL_ASSETS_MAX_TOOLTIP,
  SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM,
  SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM_TITLE,
  SECTION_ADDITIONAL_ASSETS_INCOMPLETE_PAIR,
  SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_LABEL,
  SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_HELP,
  SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_LABEL,
  SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_HELP,
  SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_LABEL,
  SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_HELP,
  SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_PLACEHOLDER,
  MODAL_ADDITIONAL_ASSET_TITLE,
  BUTTON_CHANGE_ADDITIONAL_ASSET_IMAGE,
  SECTION_BUYER_PERSONA_TITLE,
  SECTION_BUYER_PERSONA_SUBTITLE,
  SECTION_BUYER_PERSONA_LABEL,
  BUTTON_UPLOAD_CATALOG,
  BUTTON_COPY_CATALOG,
  BUTTON_DOWNLOAD_FORMAT,
  BUTTON_EDIT,
  BUTTON_DUPLICATE,
  BUTTON_DUPLICATE_IN_SAME_GROUP,
  BUTTON_DUPLICATE_IN_OTHER_AD_GROUP,
  DUPLICATE_AD_OTHER_GROUP_MODAL_TITLE,
  DUPLICATE_AD_OTHER_GROUP_MODAL_DESCRIPTION,
  DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_CHANGE_WARNING,
  DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_LABEL,
  DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_PLACEHOLDER,
  DUPLICATE_AD_OTHER_GROUP_AD_GROUP_LABEL,
  DUPLICATE_AD_OTHER_GROUP_AD_GROUP_PLACEHOLDER,
  DUPLICATE_AD_OTHER_GROUP_EMPTY_AD_GROUPS,
  BUTTON_DUPLICATE_IN_SAME_CAMPAIGN,
  BUTTON_DUPLICATE_IN_OTHER_CAMPAIGN,
  DUPLICATE_AD_GROUP_MODAL_TITLE,
  DUPLICATE_AD_GROUP_MODAL_DESCRIPTION,
  DUPLICATE_AD_GROUP_CAMPAIGN_CHANGE_WARNING,
  DUPLICATE_AD_GROUP_CAMPAIGN_TYPE_MISMATCH,
  DUPLICATE_CAMPAIGN_AD_FORMAT_MISMATCH,
  DUPLICATE_ASSETS_GROUP_MODAL_TITLE,
  DUPLICATE_ASSETS_GROUP_MODAL_DESCRIPTION,
  DUPLICATE_ASSETS_GROUP_CAMPAIGN_CHANGE_WARNING,
  BUTTON_MOVE_OTHER_CATEGORY,
  MENU_TITLE,
  MENU_DESCRIPTION,
  MENU_EMPTY_STORES,
  MODAL_COPY_MENU_ARIA_LABEL,
  MODAL_COPY_MENU_TITLE,
  MODAL_COPY_MENU_SAME_STORE,
  MODAL_COPY_MENU_CONFIRM_ALERT_TITLE,
  MODAL_COPY_MENU_CONFIRM_ALERT_DESCRIPTION,
  MODAL_COPY_MENU_COPIED,
  SELECT_CATALOG,
  MODAL_UPLOAD_MENU_ARIA_LABEL,
  MODAL_UPLOAD_MENU_TITLE,
  MODAL_UPLOAD_MENU_DESCRIPTION,
  MODAL_UPLOAD_MENU_FILE_PLACEHOLDER,
  MODAL_UPLOAD_MENU_ERROR_FORMAT,
  MODAL_UPLOAD_MENU_MIN_PRICE_PRODUCT,
  MODAL_UPLOAD_MENU_CONFIRM_ALERT_TITLE,
  MODAL_UPLOAD_MENU_CONFIRM_ALERT_DESCRIPTION,
  MODAL_UPLOAD_MENU_UPLOADED,
  MENU_ADD_CATEGORY,
  MENU_CATEGORY_NAME_PLACEHOLDER,
  MENU_CATEGORY_REQUIRED,
  MENU_ADD_PRODUCT,
  MENU_PRODUCT_MIN_VALUE,
  MENU_CREATE_PRODUCT_TITLE,
  MENU_PRODUCT_NAME_PLACEHOLDER,
  MENU_PRODUCT_DESCRIPTION_PLACEHOLDER,
  MENU_PRODUCT_PRICE_PLACEHOLDER,
  MENU_PRODUCT_TYPE_PRODUCT_PLACEHOLDER,
  MENU_PRODUCT_TYPE_PRODUCT_EXPLANATION,
  MENU_PRODUCT_ACCOMPANIMENTS_TYPE_TITLE,
  MENU_PRODUCT_ACCOMPANIMENTS_TYPE_DESCRIPTION,
  MENU_PRODUCT_ADD_ACCOMPANIMENT_TYPE_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_IS_MANDATORY_PLACEHOLDER,
  MENU_PRODUCT_ADD_ACCOMPANIMENT_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_AND_MAX_NUMBER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_NUMBER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_NAME_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_OPTIONS_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MAX_OPTIONS_PLACEHOLDER,
  BUTTON_COPY,
  FIELD_NUMBER_NEGATIVE,
  FIELD_IS_DYNAMIC_CREATIVE_ONLY_ONE_AD,
  FIELD_SCHEDULE_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE,
  FIELD_BID_GOAL_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE,
  MENU_PRODUCT_ACCOMPANIMENT_PRICE_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_NAME_PLACEHOLDER,
  PRODUCT,
  PRODUCTS,
  MODAL_MOVE_PRODUCT_ARIA_LABEL,
  MODAL_MOVE_PRODUCT_CATEGORY_OBJECTIVE,
  MODAL_MOVE_PRODUCT_CATEGORY_REQUIRED,
  MODAL_MOVE_PRODUCT_BUTTON,
  MODAL_COPY_ACCOMPANIMENT_TYPE_ARIA_LABEL,
  MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_OBJECTIVE,
  MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_OBJECTIVE,
  MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE,
  MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE_PLACEHOLDER,
  MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_REQUIRED,
  MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_REQUIRED,
  MODAL_COPY_ACCOMPANIMENT_TYPE_REQUIRED,
  MENU_ONBOARDING_TEST_CATEGORY,
  MENU_ONBOARDING_TEST_PRODUCT,
  MENU_ONBOARDING_TEST_PRODUCT_DESCRIPTION,
  MENU_ONBOARDING_FINISH_DESCRIPTION,
  MENU_ONBOARDING_FINISH_ADDITIONAL_DESCRIPTION,
  MENU_CATEGORY_DUPLICATE,
  MENU_CATEGORY_DUPLICATE_DESCRIPTION,
  MENU_CATEGORY_CREATED,
  MENU_CATEGORY_SAVED,
  MENU_CATEGORY_DELETE_CONFIRMATION_TITLE,
  MENU_CATEGORY_DELETE_CONFIRMATION_DESCRIPTION,
  MENU_CATEGORY_DELETING,
  MENU_CATEGORY_DELETED,
  MENU_PRODUCT_DUPLICATE,
  MENU_PRODUCT_DUPLICATE_DESCRIPTION,
  MENU_PRODUCT_CREATED,
  MENU_PRODUCT_SAVED,
  MENU_PRODUCT_DELETE_CONFIRMATION_TITLE,
  MENU_PRODUCT_DELETE_CONFIRMATION_DESCRIPTION,
  MENU_PRODUCT_DELETING,
  MENU_PRODUCT_DELETED,
  MENU_PRODUCT_MOVE_SAME_CATEGORY,
  MENU_PRODUCT_MOVED,
  MENU_PRODUCT_CHANGE_STATUS,
  MENU_ACCOMPANIMENT_TYPE_DUPLICATE,
  MENU_ACCOMPANIMENT_TYPE_DUPLICATE_DESCRIPTION,
  MENU_ACCOMPANIMENT_TYPE_COPIED,
  MENU_ACCOMPANIMENT_DUPLICATED,
  MENU_ACCOMPANIMENT_DUPLICATED_DESCRIPTION,
  FIELD_EMAIL_REQUIRED,
  FORGOT_PASSWORD,
  NO_HAVE_ACCOUNT,
  REGISTER_HERE,
  LOG_IN,
  AUTH_LAYOUT_HERO_TITLE,
  AUTH_LAYOUT_HERO_DESCRIPTION,
  AUTH_LAYOUT_PREVIEW_PLACEHOLDER,
  AUTH_LAYOUT_PREVIEW_IMAGE_ALT,
  AUTH_LAYOUT_FEATURE_AI_TITLE,
  AUTH_LAYOUT_FEATURE_AI_DESCRIPTION,
  AUTH_LAYOUT_FEATURE_ANALYTICS_TITLE,
  AUTH_LAYOUT_FEATURE_ANALYTICS_DESCRIPTION,
  AUTH_LAYOUT_FEATURE_SCHEDULING_TITLE,
  AUTH_LAYOUT_FEATURE_SCHEDULING_DESCRIPTION,
  LOG_GROUP_AUDIENCE_NETWORK,
  LOG_GROUP_FEEDS,
  LOG_GROUP_REELS_STORIES,
  ACCOUNT_ROLE_INVALID,
  ERROR_INTERNAL,
  AUTH_INVALID_PASSWORD,
  AUTH_WRONG_PASSWORD,
  AUTH_MANY_REQUESTS,
  AUTH_USER_NOT_FOUND,
  AUTH_EMAIL_ALREADY_EXISTS,
  PHONE_ALREADY_REGISTERED,
  STRIPE_CARD_DECLINED,
  STRIPE_EXPIRED_CARD,
  STRIPE_INCORRECT_CVC,
  STRIPE_PROCESSING_ERROR,
  STRIPE_INCORRECT_NUMBER,
  STRIPE_GENERIC_DECLINE,
  STRIPE_INSUFFICIENT_FUNDS,
  STRIPE_LOST_CARD,
  STRIPE_STOLEN_CARD,
  STRIPE_PROFILE_NOT_FOUND,
  STRIPE_INTENT_AUTH_FAILURE,
  NIT_VALID,
  BUSINESS_NAME_VALID,
  BRAND_NAME_VALID,
  ADDRESS_VALID,
  CATEGORY_VALID,
  SUBCATEGORIES_VALID,
  SHORT_DESCRIPTION_VALID,
  ORDERS_METHODS_VALID,
  LOGO_IMG_VALID,
  COVER_IMG_VALID,
  SCHEDULE_VALID,
  STORES_VALID,
  IS_PLAN_ACTIVE_VALID,
  MENUS_VALID,
  DEFAULT_PAYMENT_METHOD_VALID,
  HAS_DEBT_VALID,
  SUBSCRIPTION_PLAN_VALID,
  REGISTER_COUNTRY_ANSWER,
  REGISTER_COUNTRY_PLACEHOLDER,
  REGISTER_NAME_ANSWER,
  REGISTER_PHONE_ANSWER,
  REGISTER_EMAIL_ANSWER,
  REGISTER_BUSINESS_NAME_ANSWER,
  REGISTER_CATEGORY_ANSWER,
  REGISTER_SOCIAL_NETWORK_ANSWER,
  REGISTER_SOCIAL_NETWORK_ANSWER_DESCRIPTION,
  REGISTER_WEBSITE_ANSWER,
  REGISTER_WEBSITE_ANSWER_DESCRIPTION,
  REGISTER_MONTHLY_SALES_ANSWER,
  REGISTER_BUDGET_MARKETING_ANSWER,
  REGISTER_EMPLOYEES_ANSWER,
  REGISTER_PRODUCT_AVAILABILITY_ANSWER,
  REGISTER_RUT_ANSWER,
  REGISTER_INVIMA_ANSWER,
  REGISTER_ICA_ANSWER,
  REGISTER_YOU_MEET_ANSWER,
  REGISTER_WRITE_PLACEHOLDER,
  REGISTER_SELECT_PLACEHOLDER,
  BUTTON_REGISTER,
  BUTTON_NO_HAVE_DOCUMENT,
  BUTTON_UPLOAD_AFTER,
  REGISTER_COUNTRY_REQUIRED,
  REGISTER_NAME_REQUIRED,
  REGISTER_PHONE_REQUIRED,
  REGISTER_PHONE_NUMERIC_REQUIRED,
  REGISTER_BUSINESS_NAME_REQUIRED,
  REGISTER_CATEGORY_REQUIRED,
  REGISTER_SOCIAL_NETWORK_REQUIRED,
  REGISTER_WEB_SITE_REQUIRED,
  REGISTER_MONTHLY_SALES_REQUIRED,
  REGISTER_BUDGET_MARKETING_REQUIRED,
  REGISTER_EMPLOYEES_REQUIRED,
  REGISTER_PRODUCT_AVAILABILITY_REQUIRED,
  REGISTER_RUT_REQUIRED,
  REGISTER_INVIMA_REQUIRED,
  REGISTER_ICA_REQUIRED,
  REGISTER_YOU_MEET_REQUIRED,
  REGISTER_NO_HAVE_DOCUMENTS_ALERT_TITLE,
  REGISTER_NO_HAVE_DOCUMENTS_ALERT_DESCRIPTION,
  REGISTER_REGISTERED_ALERT_DESCRIPTION,
  RESTAURANTS,
  FOODS,
  TRAVEL,
  ENTERTAINMENT,
  TECHNOLOGY,
  FITNESS,
  FASHION,
  BEAUTY,
  PETS,
  HOME,
  EMPLOYEES_2_10,
  EMPLOYEES_10_20,
  EMPLOYEES_20_50,
  EMPLOYEES_50_100,
  EMPLOYEES_100_THAN,
  PRODUCT_AVAILABILITY_LOCAL,
  PRODUCT_AVAILABILITY_NATIONAL,
  PRODUCT_AVAILABILITY_INTERNATIONAL,
  INSTAGRAM,
  TIKTOK,
  LINKEDIN,
  GOOGLE,
  YOUTUBE,
  DARK_KITCHEN,
  OTHERS,
  PLEASE_SELECT_COUNTRY,
  BLOCK_PLAN_BUTTON_ACTIVATE_PLAN,
  BLOCK_PACKAGE_TITLE,
  BLOCK_PACKAGE_DESCRIPTION,
  BILLING_AND_PAYMENT_PLAN_TRIAL,
  BILLING_AND_PAYMENT_PLAN_TRIAL_DESCRIPTION,
  BILLING_AND_PAYMENT_PLAN_DEACTIVATE,
  BUTTON_INVITED,
  MAIN_FUNCTIONALITY_STEP_1,
  MAIN_FUNCTIONALITY_STEP_2,
  MAIN_FUNCTIONALITY_STEP_3,
  PUBLICATIONS_FUNCTIONALITY_STEP_1,
  PUBLICATIONS_FUNCTIONALITY_STEP_2,
  PUBLICATIONS_FUNCTIONALITY_STEP_3,
  PUBLICATIONS_FUNCTIONALITY_STEP_4,
  PUBLICATION_FUNCTIONALITY_STEP_1,
  PUBLICATION_FUNCTIONALITY_STEP_2,
  PUBLICATION_FUNCTIONALITY_STEP_3,
  REVIEW_FUNCTIONALITY_STEP_1,
  REVIEW_FUNCTIONALITY_STEP_2,
  REVIEW_FUNCTIONALITY_STEP_3,
  REVIEW_FUNCTIONALITY_STEP_4,
  REVIEW_FUNCTIONALITY_STEP_5,
  MENU_FUNCTIONALITY_STEP_1,
  MENU_FUNCTIONALITY_STEP_2,
  MENU_FUNCTIONALITY_STEP_3,
  MENU_FUNCTIONALITY_STEP_4,
  MENU_FUNCTIONALITY_STEP_5,
  MENU_FUNCTIONALITY_STEP_6,
  MENU_FUNCTIONALITY_STEP_7,
  MENU_FUNCTIONALITY_STEP_8,
  MENU_FUNCTIONALITY_STEP_9,
  MENU_FUNCTIONALITY_STEP_10,
  MENU_FUNCTIONALITY_STEP_11,
  MENU_FUNCTIONALITY_STEP_12,
  USERS_FUNCTIONALITY_STEP_1,
  USERS_FUNCTIONALITY_STEP_2,
  USERS_FUNCTIONALITY_STEP_3,
  USERS_FUNCTIONALITY_STEP_4,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_1,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_2,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_3,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_4,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_5,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_6,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_7,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_8,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_9,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_10,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_11,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_12,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_13,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_14,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_15,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_16,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_17,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_18,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_19,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_20,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_21,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_22,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_23,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_24,
  CAMPAIGNS_FUNCTIONALITY_STEP_1,
  CAMPAIGNS_FUNCTIONALITY_STEP_2,
  CAMPAIGNS_FUNCTIONALITY_STEP_3,
  CAMPAIGNS_FUNCTIONALITY_STEP_4,
  CAMPAIGNS_FUNCTIONALITY_STEP_5,
  CAMPAIGNS_FUNCTIONALITY_STEP_6,
  CAMPAIGNS_FUNCTIONALITY_STEP_7,
  CAMPAIGNS_FUNCTIONALITY_STEP_8,
  CAMPAIGNS_FUNCTIONALITY_STEP_9,
  CAMPAIGNS_FUNCTIONALITY_STEP_10,
  CAMPAIGNS_FUNCTIONALITY_STEP_11,
  CAMPAIGNS_FUNCTIONALITY_STEP_12,
  CAMPAIGNS_FUNCTIONALITY_STEP_13,
  CAMPAIGNS_FUNCTIONALITY_STEP_14,
  CAMPAIGNS_FUNCTIONALITY_STEP_15,
  CAMPAIGNS_FUNCTIONALITY_STEP_16,
  CAMPAIGNS_FUNCTIONALITY_STEP_17,
  AUTH_SENT_EMAIL_RESET_PASSWORD,
  EMAIL_UNSUBSCRIBE_SUCCESS_TITLE,
  EMAIL_UNSUBSCRIBE_SUCCESS_TEXT,
  EMAIL_UNSUBSCRIBE_ERROR_TITLE,
  EMAIL_UNSUBSCRIBE_ERROR_TEXT,
  AUTH_PAGE_DOCUMENT_TITLE_LOGIN,
  AUTH_PAGE_DOCUMENT_TITLE_LOGIN_OWNER,
  AUTH_LOGIN_OWNER_CHIP_LABEL,
  AUTH_LOGIN_OWNER_SUBMIT,
  AUTH_LOGIN_OWNER_NOT_OWNER,
  AUTH_LOGIN_OWNER_GO_TO_LOGIN,
  AUTH_PAGE_DOCUMENT_TITLE_REGISTER,
  AUTH_PAGE_DOCUMENT_TITLE_RESET_PASSWORD,
  AUTH_PAGE_BRANDING_LOGO_ALT,
  AUTH_LOGIN_DEMO_EXISTING_ACCOUNT_BANNER,
  EVENT_RECURRENT_REQUIRED,
  EVENT_HAS_FIELDS_REQUIRED,
  BILLING_AND_PAYMENT_PLAN_CANCELLED,
  COMPANY_INFORMATION_SAVED,
  ALERT_INACTIVE_SHOP_TITLE,
  ALERT_INACTIVE_SHOP_DESCRIPTION,
  ALERT_OPERATOR_ACTION_UNAUTHORIZED_DESCRIPTION,
  BUTTON_YES_I_SURE,
  ERROR_COMPONENT_TITLE,
  ERROR_COMPONENT_DESCRIPTION,
  ERROR_COMPONENT_BUTTON_RELOAD_PAGE,
  ERROR_COMPONENT_CURRENT_ROUTE,
  LESS_500K,
  BETWEEN_500K_1M,
  BETWEEN_1M_2_5M,
  BETWEEN_2_5M_5M,
  MORE_5M,
  LESS_1M,
  BETWEEN_1M_5M,
  BETWEEN_5M_15M,
  BETWEEN_15M_30M,
  BETWEEN_30M_100M,
  MORE_100M,
  LESS_150,
  BETWEEN_150_250,
  BETWEEN_250_650,
  BETWEEN_650_1250,
  MORE_1250,
  LESS_250,
  BETWEEN_250_1250,
  BETWEEN_1250_3750,
  BETWEEN_3750_7500,
  BETWEEN_7500_25K,
  MORE_25K,
  DOCUMENT_CC,
  DOCUMENT_CE,
  DOCUMENT_NUIP,
  DOCUMENT_NIT,
  DOCUMENT_CI,
  DOCUMENT_PASSPORT,
  DOCUMENT_ID,
  DOCUMENT_RUC,
  MISSING_PARAMETERS,
  PASSWORD_INVALID,
  INVALID_SEARCH,
  USER_ID_REQUIRED,
  SHOP_ID_REQUIRED,
  LAST_USER_NOT_DELETED,
  PLAN_TRIAL_USER_USED,
  ORDERS_NOT_FOUND_IN_INTERVAL,
  TYPE_REPORT_NOT_FOUND,
  SHOP_NOT_FOUND,
  PAYMENT_MODEL_INVALID,
  SHOP_NOT_HAS_SOCIAL_NETWORK,
  NO_VALID_PLATFORM_FOUND,
  GETTING_STATISTICS,
  SHOP_BUSINESS_NAME_NOT_FOUND,
  REFERENCE_PROFILES_REQUIRED,
  DECRYPTING_PASSWORD,
  USER_ID_AND_PAYMENT_ID,
  MESSAGES_REQUIRED,
  PLAN_IS_NO_ACTIVE,
  USER_BANNED,
  GETTING_LOCALES,
  GETTING_PROFILE,
  PRODUCTS_NOT_SENT,
  ACCOUNT_NOT_FOUND,
  COLLECTING_INFORMATION_RETRY_AFTER,
  ERROR_OCCURRED,
  FREE_BOT_MESSAGES_LIMIT_REACHED,
  TEXT_REGENERATION_LIMIT_REACHED,
  ACTION_COULD_NOT_BE_COMPLETED,
  PLATFORM_NOT_SENT,
  PLATFORM_APP_REQUEST_LIMIT_REACHED,
  VERIFICATION_CODE_NOT_FOUND,
  ORDER_NOT_FOUND,
  TYPE_OR_PATH_NOT_SENT,
  ID_OR_PATH_NOT_SENT,
  IDS_NOT_SENT,
  ANALYTIC_URL_NOT_SENT,
  ANALYTIC_URL_INVALID,
  EXTRACTING_ANALYTICS,
  CREDENTIALS_INVALID,
  COLLABORATION_PRICE_NOT_BE_NEGATIVE,
  CREDITS_NOT_BE_NEGATIVE,
  PACKAGES_PRICES_NOT_BE_NEGATIVE,
  ROL_REQUIRED,
  SHOP_ID_AND_STORE_ID_REQUIRED,
  PASSWORD_MUST_BE_6_CHARACTERS,
  ALL_USERS_NOT_DELETE,
  SHOP_APPLICANT_NOT_FOUND,
  USER_PASSWORD_NOT_FOUND,
  PLAN_NOT_FOUND,
  SUBSCRIPTION_NOT_CREATED,
  ID_SUBSCRIPTION_NOT_FOUND,
  SUBSCRIPTION_REACTIVATE,
  CUSTOMER_ID_NOT_FOUND,
  APPLICANT_NOT_FOUND,
  SHOP_COUNTRY_NOT_FOUND,
  FINAL_PRICE_NOT_FOUND,
  PAYMENT_FAILED,
  CREDITS_MUST_BE_GREATER_THAN_ZERO,
  CSRF_INVALID,
  INTEGRATION_INFORMATION_NOT_FOUND,
  GETTING_VIDEO,
  UPLOAD_URL_NOT_FOUND,
  UPLOADING_VIDEO,
  STORE_NOT_FOUND,
  NAME_REQUIRED,
  PRICE_REQUIRED,
  CURRENCY_REQUIRED,
  RECURRING_REQUIRED,
  CREATING_PRODUCT,
  CREATING_PRICE,
  CREATING_PAYMENT_LINK,
  GETTING_PAYMENT_LINK,
  MODAL_REVIEW_SCORE_PLACEHOLDER,
  SCORE,
  CHAT_EMAIL_NO_PERMITTED,
  CHAT_WRITE_MESSAGE_HERE,
  CHAT_WRITE_QUESTION_HERE,
  CHAT_DO_PAYMENT,
  CHAT_ERROR_SENT_MESSAGE,
  RESET_PASSWORD_EMAIL_SENT,
  RESET_PASSWORD,
  RESET_PASSWORD_GET_TOKEN_FAILED,
  RESET_PASSWORD_SAVED,
  TOKEN_INVALID,
  TOKEN_EXPIRED,
  NOTIFICATIONS_CHECK_NOTIFICATION,
  NOTIFICATIONS_NO_MORE,
  NOTIFICATIONS_EMPTY,
  NOTIFICATIONS_MARK_READS,
  NOTIFICATIONS_TITLE,
  ONE_SECOND_AGO,
  DATE_DISTANCE,
  CAMPAIGN_FINISH_ONBOARDING,
  CHAT_FIRST_MESSAGE_BOT,
  OWN_DELIVERY,
  CHAT_NO_MORE,
  PUBLICATION_STATUS_PENDING_CONTENT,
  PUBLICATION_STATUS_PENDING_APPROVAL,
  BUTTON_SEND_REVISION,
  BUTTON_APPROVE_CONTENT,
  REVISION_COUNT,
  ONE,
  TWO,
  THREE,
  DATE_HOUR,
  ORDER_CANCELLED_CONFIRMATION,
  ORDER_CANCELLED_CONFIRMATION_BUTTON,
  COMPANY_INFORMATION_WEBSITE_URL_PLACEHOLDER,
  IG_ACCOUNT_NOT_FOUND,
  IG_DATA_NOT_FOUND,
  BUTTON_UPLOAD_INSTAGRAM,
  BUTTON_CONNECT_INSTAGRAM,
  PLATFORMS_CONNECTED_INSTAGRAM_FAILED,
  PLATFORMS_CONNECTED_FACEBOOK_SDK_UNAVAILABLE,
  PLATFORMS_CONNECTED_META_BLOCKED_TITLE,
  PLATFORMS_CONNECTED_META_POPUP_BLOCKED,
  PLATFORMS_CONNECTED_META_BLOCKED_STEP_DISABLE_BLOCKER,
  PLATFORMS_CONNECTED_META_BLOCKED_STEP_ALLOW_POPUPS,
  PLATFORMS_CONNECTED_META_BLOCKED_STEP_RETRY,
  MODAL_UPLOAD_INSTAGRAM_ARIA_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TITLE,
  MODAL_UPLOAD_INSTAGRAM_CONTENT_UPLOADED_DESCRIPTION,
  MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_LABEL,
  MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_PLACEHOLDER,
  PLATFORMS_TOKEN_EXPIRED,
  INTEGRATIONS_TERMS_TITLE,
  INTEGRATIONS_TERMS_DESCRIPTION,
  INTEGRATIONS_TERMS_CONTENT,
  LESS_1000,
  BETWEEN_1000_5000,
  BETWEEN_5000_15K,
  BETWEEN_15K_30K,
  BETWEEN_30K_60K,
  MORE_60K,
  BETWEEN_1000_2000,
  BETWEEN_2000_5000,
  BETWEEN_5000_10K,
  MORE_10K,
  DOCUMENT_EIN,
  MENU_SERVICES,
  BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_TITLE,
  RESTAURANTS_SUBCATEGORY_FOOD,
  RESTAURANTS_SUBCATEGORY_DRINKS,
  RESTAURANTS_SUBCATEGORY_DESSERTS,
  RESTAURANTS_SUBCATEGORY_COFFEE,
  RESTAURANTS_SUBCATEGORY_HOT_DRINKS,
  RESTAURANTS_SUBCATEGORY_COLD_DRINKS,
  RESTAURANTS_SUBCATEGORY_SOFT_DRINKS,
  RESTAURANTS_SUBCATEGORY_FROZEN_DRINKS,
  RESTAURANTS_SUBCATEGORY_SUSHI,
  RESTAURANTS_SUBCATEGORY_ASIAN,
  RESTAURANTS_SUBCATEGORY_JAPANESE,
  RESTAURANTS_SUBCATEGORY_CHINESE,
  RESTAURANTS_SUBCATEGORY_ITALIAN,
  RESTAURANTS_SUBCATEGORY_MEXICAN,
  RESTAURANTS_SUBCATEGORY_HEALTHY,
  RESTAURANTS_SUBCATEGORY_VEGAN,
  RESTAURANTS_SUBCATEGORY_VEGETARIAN,
  FOODS_SUBCATEGORY_SEASONINGS,
  FOODS_SUBCATEGORY_FOOD,
  FOODS_SUBCATEGORY_GRANOLA,
  FOODS_SUBCATEGORY_DRIED_FRUITS,
  FOODS_SUBCATEGORY_HEALTHY,
  TRAVEL_SUBCATEGORY_BEACH_SUN_TOURISM,
  TRAVEL_SUBCATEGORY_RURAL_TOURISM,
  TRAVEL_SUBCATEGORY_GASTRONOMIC_TOURISM,
  TRAVEL_SUBCATEGORY_NATURE_TOURISM,
  TRAVEL_SUBCATEGORY_CULTURAL_TOURISM,
  TRAVEL_SUBCATEGORY_HEALTH_TOURISM,
  ENTERTAINMENT_SUBCATEGORY_ENTERTAINMENT,
  TECHNOLOGY_SUBCATEGORY_PHONES,
  TECHNOLOGY_SUBCATEGORY_COMPUTERS,
  TECHNOLOGY_SUBCATEGORY_VIDEO_GAME_CONSOLES,
  TECHNOLOGY_SUBCATEGORY_ACCESSORIES,
  TECHNOLOGY_SUBCATEGORY_PERIPHERALS,
  TECHNOLOGY_SUBCATEGORY_ELECTRONICS,
  FITNESS_SUBCATEGORY_SPORTSWEAR,
  FITNESS_SUBCATEGORY_SPORTS_ACCESSORIES,
  FITNESS_SUBCATEGORY_DIETARY_SUPPLEMENTS,
  FITNESS_SUBCATEGORY_TRAINING_EQUIPMENT,
  FASHION_SUBCATEGORY_HAUTE_COUTURE,
  FASHION_SUBCATEGORY_HIPSTER,
  FASHION_SUBCATEGORY_CASUAL,
  FASHION_SUBCATEGORY_CLASSIC,
  FASHION_SUBCATEGORY_ROMANTIC,
  FASHION_SUBCATEGORY_SPORTSWEAR,
  FASHION_SUBCATEGORY_PREPPY,
  FASHION_SUBCATEGORY_GRUNGE,
  FASHION_SUBCATEGORY_VINTAGE,
  BEAUTY_SUBCATEGORY_COSMETICS,
  BEAUTY_SUBCATEGORY_EYE_CARE,
  BEAUTY_SUBCATEGORY_FEMININE_HYGIENE,
  BEAUTY_SUBCATEGORY_FIRST_AID,
  BEAUTY_SUBCATEGORY_HAIR_CARE,
  BEAUTY_SUBCATEGORY_MEDICAL_DEVICES,
  BEAUTY_SUBCATEGORY_MOBILITY_EQUIPMENT,
  BEAUTY_SUBCATEGORY_NUTRITIONAL_SUPPLEMENTS,
  BEAUTY_SUBCATEGORY_MEDICATIONS,
  BEAUTY_SUBCATEGORY_PERSONAL_HYGIENE,
  BEAUTY_SUBCATEGORY_SCALES,
  BEAUTY_SUBCATEGORY_SKIN_CARE,
  BEAUTY_SUBCATEGORY_VITAMINS,
  BEAUTY_SUBCATEGORY_FACIAL_TISSUES,
  PETS_SUBCATEGORY_FOOD,
  PETS_SUBCATEGORY_COSMETICS,
  PETS_SUBCATEGORY_ACCESSORIES,
  PETS_SUBCATEGORY_CLOTHING,
  PETS_SUBCATEGORY_MEDICATIONS,
  HOME_SUBCATEGORY_TEXTILES_CARPETS,
  HOME_SUBCATEGORY_ART_PRINTS,
  HOME_SUBCATEGORY_STORAGE_ORGANIZATION,
  HOME_SUBCATEGORY_PLANT_DECOR,
  HOME_SUBCATEGORY_CURTAINS_BLINDS,
  UPLOAD_NEW_CONTENT,
  MODAL_UPLOAD_INSTAGRAM_TYPE_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_REEL_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_POST_LABEL,
  BUTTON_RELOAD_PAGE,
  NEW_VERSION_TITLE,
  NEW_VERSION_DESCRIPTION,
  DELIVERY_INTERN_ON_THE_WAY,
  FIELD_EMAIL_REGISTERED,
  MODAL_DISSATISFACTION_COLLABORATION_TITLE,
  MODAL_DISSATISFACTION_COLLABORATION_DESCRIPTION,
  MODAL_DISSATISFACTION_COLLABORATION_BUTTON,
  MODAL_DISSATISFACTION_COLLABORATION_EXPLANATION_CREDIT,
  REVIEW_NOT_FOUND,
  REVIEW_IS_NOT_ONE_START,
  DISSATISFACTION_CREDIT_ALREADY_EXISTS,
  MODAL_DISSATISFACTION_COLLABORATION_CREDIT_RECEIVED,
  BUTTON_REPLACE_IMAGE,
  ADD_URL_PUBLICATION,
  VALUE_EXPRESSED_IN,
  ANY,
  GENDER,
  FIELD_SEARCH_CHATS_MORE_3_CHARACTERS,
  MODAL_SUBSCRIPTION_PRO_ARIA_LABEL,
  MODAL_SUBSCRIPTION_PRO_TITLE_HERO,
  MODAL_SUBSCRIPTION_PRO_DESCRIPTION_HERO,
  MODAL_SUBSCRIPTION_PRO_TITLE,
  MODAL_SUBSCRIPTION_PRO_SUB_HEADER,
  MODAL_SUBSCRIPTION_PRO_BENEFIT_1,
  MODAL_SUBSCRIPTION_PRO_BUY_BUTTON,
  PAYMENT_REASON_SUBSCRIPTION_PRO,
  NO_ADDED,
  BUTTON_SEE_PUBLICATION_ON,
  REVISIONS,
  CURRENT_CONTENT,
  CURRENT_CONTENT_EMPTY,
  MALE,
  FEMALE,
  COMMENT,
  NO_SEND_CONTENT_FEEDBACK,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_PERCENTAGE_PLACEHOLDER,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_CODE_PLACEHOLDER,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_TITLE,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_DESCRIPTION,
  FIELD_NUMBER_0_OR_NEGATIVE,
  FIELD_NUMBER_100_GREATER,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_1,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_2,
  VALUE_GENERAL_CODE_REDEEMED,
  VALUE_WITH_PERCENTAGE,
  FIELD_NUMBER_LESS_THAN,
  FIELD_NUMBER_GREATER_THAN,
  BUTTON_ADD_USER,
  SUPER_ADMIN,
  SELECT_BUSINESS_PLACEHOLDER,
  NAME_BUSINESS_PLACEHOLDER,
  SELECT_BRANDS_PLACEHOLDER,
  MAIN_BRAND_PLACEHOLDER,
  SELECT_BRAND_PLACEHOLDER,
  SELECT_STORE_PLACEHOLDER,
  NAME_AND_LAST_NAME_PLACEHOLDER,
  FIELD_PASSWORD_CHANGE_MIN_LENGTH,
  ORDER_TOTAL_VALUE_DISCOUNT,
  GO_TO_ACCOUNT,
  ORDER,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_DESCRIPTION,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_QUESTION,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_REQUIRED,
  CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_UGC_OPTION,
  SELECT_TYPE_PLAN_PLACEHOLDER,
  COST_COLLABORATION_PLACEHOLDER,
  CREDITS_PLACEHOLDER,
  TRIAL_DAYS_PLACEHOLDER,
  TYPE_PACKAGE_PLACEHOLDER,
  PRICE_BASIC_PLACEHOLDER,
  COST_COLLABORATION_BASIC_PLACEHOLDER,
  PRICE_GROWTH_PLACEHOLDER,
  COST_COLLABORATION_GROWTH_PLACEHOLDER,
  PLAN_PAY_PER_USE,
  PLAN_PACKAGE,
  PLAN_REGULAR,
  PLAN_ENTERPRISE,
  COLUMN_NAME_BRAND,
  COLUMN_NAME_AGENCY,
  COLUMN_NAME_ADVERTISER,
  COLUMN_NAME_USER,
  COLUMN_NAME_CATEGORY,
  COLUMN_NAME_IS_LOGGED,
  COLUMN_NAME_IS_ACTIVE,
  COLUMN_NAME_PACKAGE,
  COLUMN_NAME_EMAIL,
  COLUMN_NAME_NAME,
  COLUMN_NAME_PHONE,
  COLUMN_NAME_STAFF,
  COLUMN_NAME_ACCEPTED,
  COLUMN_NAME_MONTHLY_SALES,
  COLUMN_NAME_BUDGET_MARKETING,
  COLUMN_NAME_EMPLOYEES,
  COLUMN_NAME_PRODUCT_AVAILABILITY,
  COLUMN_NAME_SOCIAL_NETWORK,
  COLUMN_NAME_WEB_SITE,
  COLUMN_NAME_YOU_MEET,
  COLUMN_NAME_DATE,
  COMMERCIAL_PLACEHOLDER,
  ADD_NEW_OPTION,
  MODAL_COMMERCIAL_TITLE_CREATE,
  MODAL_COMMERCIAL_TITLE_EDIT,
  MODAL_COMMERCIAL_CREATE_COMMERCIAL,
  MODAL_COMMERCIAL_ALREADY_EXIST,
  BUTTON_ADD_SHOP,
  COLUMN_NAME_PLAN,
  COLUMN_NAME_PAYMENT_METHOD,
  COLUMN_NAME_COST_COLLABORATION,
  COLUMN_NAME_COUNTRY,
  COLUMN_NAME_CREDITS,
  PLAN_PAY_PER_USE_NAME,
  PLAN_PACKAGE_NAME,
  BUSINESS_NAME_PLACEHOLDER,
  USERS,
  FIELD_CREDITS_NOT_BE_NEGATIVE,
  FIELD_COST_COLLABORATION_NOT_BE_NEGATIVE,
  FIELD_TRIAL_MONTHS_NOT_BE_NEGATIVE,
  FIELD_PLAN_PRICES_NOT_BE_NEGATIVE,
  FIELD_STAFF_IS_REQUIRED,
  STORES,
  PLAN,
  AUTOMATIC_RENOVATION,
  DEACTIVATED,
  ACTIVE,
  MODAL_CREATE_PAYMENT_LINK_TITLE,
  MODAL_CREATE_PAYMENT_LINK_ARIA_LABEL,
  MODAL_CREATE_PAYMENT_LINK_LINKS,
  MODAL_CREATE_PAYMENT_LINK_LINKS_EMPTY,
  MODAL_CREATE_PAYMENT_LINK_NAME,
  DESCRIPTION_OPTIONAL_PLACEHOLDER,
  PRICE_PLACEHOLDER,
  CURRENCY_PLACEHOLDER,
  IS_RECURRENCE_PLACEHOLDER,
  RECURRENCE_PLACEHOLDER,
  RECURRENT_OPTION,
  RECURRING_DAYS,
  RECURRING_WEEKS,
  RECURRING_MONTHS,
  RECURRING_YEARS,
  FIELD_BOTH_DATES_REQUIRED,
  FIELD_START_DATE_GREATER_THAN_END_DATE,
  SOMETHING_ERROR_GENERATING_STATISTICS,
  BUTTON_DOWNLOAD_REPORT,
  META_INTEGRATION_UNLINKED_PAGES_ERROR,
  EDIT,
  MENU_MEDIA,
  CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA,
  CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA_QUESTION,
  CAMPAIGN_TYPE_CONTENT_MEDIA_PLACEHOLDER,
  THIS_CREATOR_IS_FAVORITE,
  ADD_TO_FAVORITES,
  REMOVE_FROM_FAVORITES,
  REDEEM_CODE_TABLE_COLUMN_TERMS,
  BUTTON_GENERATE_COMMENT,
  FAVORITES_CATEGORY,
  EMAIL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_LABEL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_TOP_FIVE_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_EDUCATION_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_QUOTES_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_CURIOUS_FACTS_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_RHYMES_OR_POEMS_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_HUMOR_OPTION,
  BUTTON_GENERATE_CONTENT,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_EMPTY_CONTENT,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_GENERATING_CONTENT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TONES_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_TEXT_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_BACKGROUND_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENTS_REQUIRED,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULE_BUTTON,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULED_CONTENT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION,
  BUTTON_UPLOAD_LOGO,
  BUTTON_REPLACE_LOGO,
  BUTTON_UPLOAD_BACKGROUND,
  BUTTON_REPLACE_BACKGROUND,
  BUTTON_REMOVE_BACKGROUND,
  BUTTON_REGENERATE_CONTENT,
  SUB_MENU_SOCIAL_FEED,
  CAMPAIGN_DETAIL_APPLICANTS_PENDING_TITLE,
  ORDERS_REMEMBER_MARK_AS_DELIVERED,
  BUTTON_CONTINUOUS,
  CREATE_CAMPAIGN_GOAL_QUESTION,
  CREATE_CAMPAIGN_GOAL_PLACEHOLDER,
  CREATE_CAMPAIGN_GOAL_BRAND_AWARENESS_OPTION,
  CREATE_CAMPAIGN_GOAL_ENGAGEMENT_OPTION,
  CREATE_CAMPAIGN_GOAL_LEADS_OPTION,
  CREATE_CAMPAIGN_GOAL_SALES_OPTION,
  CREATE_CAMPAIGN_GOAL_REQUIRED,
  CAMPAIGN_GOAL_PLACEHOLDER,
  MODAL_SELECT_PACKAGE_BENEFIT_COLLABORATE_WITH_CREATOR,
  MODAL_SELECT_PACKAGE_BENEFIT_LAUNCH_CAMPAIGNS,
  MODAL_SELECT_PACKAGE_BENEFIT_DOWNLOAD_CONTENT,
  MODAL_SELECT_PACKAGE_BENEFIT_ANALYZE_METRICS,
  CAMPAIGN_REPOST_PLACEHOLDER_ITEM,
  PAYMENT_METHOD_NOT_FOUND,
  HAS_PENDING_PAYMENTS,
  CREATE_CAMPAIGN_TRAFFIC_LINK_VALID,
  ORDER_ID,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_LANGUAGE_LABEL,
  ENGLISH,
  SPANISH,
  CAMPAIGN_FINISHED_TIME,
  DATE_SHORT_LOCALIZED,
  DATE_LONG_LOCALIZED,
  VIEW,
  CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE,
  CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_SCRIPT_LABEL,
  FIELD_MAX_LENGTH,
  CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE_GENERATING,
  BUTTON_GENERATE_OTHER,
  MODAL_INVOICE_SUBSCRIPTION,
  MODAL_INVOICE_APPLICANT,
  MODAL_INVOICE_FEE,
  MODAL_INVOICE_IVA,
  MODAL_INVOICE_COLLABORATION,
  MODAL_INVOICE_CREDITS,
  MODAL_INVOICE_PLAN_ENTERPRISE_WITH_CREDITS,
  BUTTON_SUBSCRIBE_NOW,
  FIELD_TRIAL_DAYS_NOT_BE_NEGATIVE,
  ACCEPTED,
  PENDING,
  ARE_YOU_SURE,
  ARE_YOU_SURE_TO_DISCONNECT_ACCOUNT,
  CHANGE,
  BUTTON_PASS_TO_SUBSCRIPTION_BASIC,
  COLUMN_NAME_CREATOR_NAME,
  COLUMN_NAME_CITY,
  COLUMN_NAME_AUDIENCE,
  COLUMN_NAME_ENGAGEMENT,
  COLUMN_NAME_CATEGORIES,
  COLUMN_NAME_SCORE,
  COLUMN_NAME_ACTIVITY,
  COLUMN_NAME_CREATOR_PLATFORM,
  COLUMN_NAME_ACTIONS,
  COLUMN_NAME_STATUS,
  COLUMN_NAME_REDEEMED_DATE,
  COLUMN_NAME_TERMS,
  COLUMN_NAME_TYPE,
  COLUMN_NAME_ADDRESS,
  COLUMN_NAME_STORE,
  COLUMN_NAME_ROLE,
  COLUMN_NAME_PAID_DATE,
  COLUMN_NAME_DUE_DATE,
  COLUMN_NAME_REASON,
  COLUMN_NAME_VALUE,
  COLUMN_NAME_ID,
  COLUMN_NAME_CREATOR,
  COLUMN_NAME_CREATED_DATE,
  COLUMN_NAME_ACCEPTED_DATE,
  COLUMN_NAME_DETAILS,
  COLUMN_NAME_DELIVERY,
  COLUMN_NAME_CODE_VERIFICATION,
  COLUMN_NAME_ACCOUNT_NAME,
  COLUMN_NAME_IS_HIDDEN,
  COLUMN_NAME_COMMENT,
  BUTTON_EXTEND,
  REPORT_REQUESTS,
  REQUESTS_ACCEPTED,
  REQUESTS_REJECTED,
  REQUESTS_ACTIVE,
  CODE,
  IS_AUTOMATIC,
  REDEEMED,
  EXPIRED,
  REDEEMED_SINGULAR,
  EXPIRED_SINGULAR,
  EMPTY_RESULTS_SHOW_ON_THIS_PAGE,
  CONTENT_TITLE,
  REPORTS_TITLE,
  REPORTS_DESCRIPTION,
  REPORTS_ERROR_GENERATING,
  REPORTS_REQUESTS_ACTIVE,
  REPORTS_REQUESTS_INACTIVE,
  REPORTS_TYPE_USERS,
  REPORTS_NUMBER_USERS,
  REPORTS_TYPE_ORDER,
  REPORTS_NUMBER_ORDER,
  REJECTED,
  ROLE,
  REPORTS_MODAL_DESCRIPTION,
  REPORTS_MODAL_ONLY_BRANDS_ACTIVE,
  REPORTS_MODAL_TYPE_REPORT_LABEL,
  REPORTS_MODAL_TYPE_REPORT_BRANDS,
  REPORTS_MODAL_TYPE_REPORT_CREATORS,
  REPORTS_MODAL_TYPE_REPORT_ORDERS,
  BUTTON_ARCHIVE,
  BUTTON_UNARCHIVE,
  TRANSACTION_CONCEPT_LABEL,
  TRANSACTION_TYPE,
  TRANSACTION_TYPE_CREDIT,
  TRANSACTION_TYPE_DEBIT,
  TRANSACTION_STATUS,
  TRANSACTION_STATUS_PENDING,
  TRANSACTION_STATUS_PENDING_RELEASE,
  TRANSACTION_STATUS_IN_PROCESS_RELEASE,
  TRANSACTION_STATUS_RELEASED,
  TRANSACTION_STATUS_PENDING_SENT,
  TRANSACTION_IN_TRANSIT,
  TRANSACTION_STATUS_PAID,
  UNKNOWN,
  BUTTON_CREATE_TRANSACTION,
  TRANSACTION_WAS_PAID,
  BUTTON_UPDATE_STATISTICS,
  MODAL_CREATE_TRANSACTION,
  MODAL_CREATE_TRANSACTION_AMOUNT_LABEL,
  MODAL_CREATE_TRANSACTION_CONCEPT_LABEL,
  MODAL_CREATE_TRANSACTION_CONCEPT_APPLICANT,
  MODAL_CREATE_TRANSACTION_CONCEPT_ORDER,
  MODAL_CREATE_TRANSACTION_CONCEPT_REFERRAL,
  MODAL_CREATE_TRANSACTION_CONCEPT_ID,
  FIELD_END_DATE_GREATER_NOW,
  BUTTON_SEND_PAYMENT,
  BUTTON_VIEW_REPORT,
  REVIEWS,
  REVIEW,
  SHOW_REVIEWS,
  EMPTY_REVIEWS,
  DESCRIPTION_SEND_MESSAGE,
  DESCRIPTION_SEND_PAYMENT,
  SELECT_CAMPAIGN_PLACEHOLDER,
  CAMPAIGN_DETAIL_APPLICANTS_INVITED_TITLE,
  MODAL_PAY_CREATOR_AMOUNT_LABEL,
  FIELD_MIN_AMOUNT_PAY,
  REGISTER_PASSWORD_ANSWER,
  FIELD_PASSWORD_INSECURE,
  BLOCK_TRIAL_ACTIVE_TITLE,
  BLOCK_TRIAL_ACTIVE_DESCRIPTION,
  BLOCK_TRIAL_ACTIVE_BUTTON,
  MODAL_FREE_TRIAL_START_ALERT_DESCRIPTION,
  TRIAL_CONFIGURING_EXPERIENCE,
  TRIAL_PREPARING_PLATFORM,
  TRIAL_RETRY_ACCESS,
  BLOCK_CONTACT_YOUR_ADMINISTRATOR_TITLE,
  FIELD_BOTH_PASSWORD_REQUIRED,
  MODAL_FREE_TRIAL_CAPTION,
  BUTTON_ADD_AS_REFERENCE,
  BUTTON_ADDED,
  BUTTON_CREATE_CAMPAIGN2,
  BUTTON_LAUNCH_AD,
  BUTTON_CREATOR_CHAT,
  BUTTON_SEND_FILE,
  COLUMN_NAME_ACTION,
  BUTTON_SEE_MORE,
  BUTTON_SEE_LESS,
  BUTTON_SEND,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_LABEL,
  RIGHT,
  LEFT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_HAS_TEXT_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_FONT_FAMILY_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_TEXT_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_LOGO_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_ALL_WITH_TEXT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_SOME_WITH_TEXT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WITHOUT_TEXT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_HAS_TEXTS_LABEL,
  LOGO,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_PLACEHOLDER,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WEBSITE_URL_LABEL,
  FIELD_FILE_VALID_REQUIRED,
  FIELD_FILE_MAX_SIZE,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_TITLE,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TEXT_LABEL,
  BUTTON_YOU_HAVE_DOUBTS,
  BUTTON_WATCH_DEMO,
  CANCEL_ANYTIME,
  NO_IMAGES_FOUND_ON_PAGE,
  FIELD_URL_HTTPS_VALID,
  FIELD_URL_REPEATED,
  ADD_BRAND,
  MODAL_ADD_BRAND_SUPER_ADMIN_TITLE,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_FROM_COLLABORATIONS_OPTION,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_UPLOAD_OPTION,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_EMPTY,
  DATE_LONG_TEXT,
  DATE,
  BUTTON_SAVE_CONTENT,
  BUTTON_REGENERATE_TEXT,
  DATE_LONG_TEXT_WITH_HOUR,
  DATE_LONG_TEXT_2,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALREADY_CONTENT_ON_THIS_DATE,
  NO_CREATE_DISCOUNT_SHOPIFY,
  NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY,
  NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY,
  NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY,
  FIELD_ACCESS_TOKEN_SHOPIFY_VALID,
  BUTTON_SEND_BROADCAST,
  MODAL_BROADCAST_CONFIRM_TITLE,
  MODAL_BROADCAST_CONFIRM_DESCRIPTION,
  NAME_BUSINESS_BOT,
  SERVICE_FEE,
  TOTAL_PAYMENT,
  MODAL_USER_TITLE_EDIT,
  MODAL_USER_DESCRIPTION_EDIT,
  MODAL_USER_DESCRIPTION,
  MODAL_CONTACT_TITLE_EDIT,
  MODAL_CONTACT_DESCRIPTION,
  MODAL_CONTACT_DESCRIPTION_EDIT,
  MODAL_STORE_TITLE,
  MODAL_STORE_TITLE_EDIT,
  MODAL_STORE_DESCRIPTION,
  MODAL_STORE_DESCRIPTION_EDIT,
  MODAL_BROADCAST_DESCRIPTION,
  MODAL_COPY_MENU_DESCRIPTION,
  DESIGNER,
  MODAL_CREATE_PAYMENT_LINK_DESCRIPTION,
  BUTTON_ADD_REFERENCE_PROFILE,
  AUDIENCE_BY_SIMILAR_AUDIENCE_NOT_FOUND,
  OPTION_UGC_FORMAT_GRWM,
  OPTION_UGC_FORMAT_GRWM_EXPLANATION,
  OPTION_UGC_FORMAT_OODT,
  OPTION_UGC_FORMAT_OODT_EXPLANATION,
  OPTION_UGC_FORMAT_HAULS,
  OPTION_UGC_FORMAT_HAULS_EXPLANATION,
  OPTION_UGC_FORMAT_DIYS,
  OPTION_UGC_FORMAT_DIYS_EXPLANATION,
  OPTION_UGC_FORMAT_UNBOXING,
  OPTION_UGC_FORMAT_UNBOXING_EXPLANATION,
  OPTION_UGC_FORMAT_CHALLENGES,
  OPTION_UGC_FORMAT_CHALLENGES_EXPLANATION,
  OPTION_UGC_FORMAT_REVIEWS,
  OPTION_UGC_FORMAT_REVIEWS_EXPLANATION,
  OPTION_UGC_FORMAT_VLOGS,
  OPTION_UGC_FORMAT_VLOGS_EXPLANATION,
  OPTION_UGC_FORMAT_QA,
  OPTION_UGC_FORMAT_QA_EXPLANATION,
  OPTION_UGC_FORMAT_STORYTIME,
  OPTION_UGC_FORMAT_STORYTIME_EXPLANATION,
  OPTION_UGC_FORMAT_ROOM_TOURS,
  OPTION_UGC_FORMAT_ROOM_TOURS_EXPLANATION,
  OPTION_UGC_FORMAT_WHATS_IN_MY_BAG,
  OPTION_UGC_FORMAT_WHATS_IN_MY_BAG_EXPLANATION,
  OPTION_UGC_FORMAT_COOKING,
  OPTION_UGC_FORMAT_COOKING_EXPLANATION,
  OPTION_UGC_FORMAT_FITNESS_ROUTINES,
  OPTION_UGC_FORMAT_FITNESS_ROUTINES_EXPLANATION,
  OPTION_UGC_FORMAT_ASMR,
  OPTION_UGC_FORMAT_ASMR_EXPLANATION,
  OPTION_UGC_FORMAT_PLAN_WITH_ME,
  OPTION_UGC_FORMAT_PLAN_WITH_ME_EXPLANATION,
  OPTION_UGC_FORMAT_MUKBANG,
  OPTION_UGC_FORMAT_MUKBANG_EXPLANATION,
  OPTION_UGC_FORMAT_DAY_IN_THE_LIFE,
  OPTION_UGC_FORMAT_DAY_IN_THE_LIFE_EXPLANATION,
  OPTION_UGC_FORMAT_BEHIND_THE_SCENES,
  OPTION_UGC_FORMAT_BEHIND_THE_SCENES_EXPLANATION,
  OPTION_UGC_FORMAT_TRAVEL_DIARIES,
  OPTION_UGC_FORMAT_TRAVEL_DIARIES_EXPLANATION,
  SELECT_UGC_CONTENT_FORMAT,
  CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_QUESTION,
  CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_PLACEHOLDER,
  SUB_MENU_CONTENT_APPLICATION,
  CONTENT_APPLICATION_TITLE,
  COLUMN_NAME_URLS,
  CONTENT_APPLICATION_ACCEPT_TITLE,
  CONTENT_APPLICATION_ACCEPT_DESCRIPTION,
  CONTENT_APPLICATION_REJECT_TITLE,
  CONTENT_APPLICATION_REJECT_DESCRIPTION,
  BUTTON_CONNECT_WOOCOMMERCE,
  FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS_DESCRIPTION,
  FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS,
  FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS_DESCRIPTION,
  FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS,
  BUTTON_ADD_CONTENT,
  BUTTON_SEE_ALL_APPLICANTS,
  REQUEST_REJECT_CONFIRMATION_DESCRIPTION,
  REQUEST_APPROVE_CONFIRMATION_DESCRIPTION,
  MAIN_FUNCTIONALITY_STEP_4,
  MAIN_FUNCTIONALITY_ONBOARDING_FINISH,
  GETTING_INFORMATION_FROM_SHOPIFY_URL,
  LAST_COLLABORATION,
  REGISTER_PROFILE_CREATOR_PLATFORMS_ANSWER,
  REGISTER_PROFILE_CREATOR_CATEGORIES_ANSWER,
  REGISTER_PROFILE_CREATOR_GENDER_ANSWER,
  REGISTER_PROFILE_CREATOR_AGE_ANSWER,
  REGISTER_PROFILE_CREATOR_AGE_RANGE_REQUIRED,
  REGISTER_PROFILE_CREATOR_GENDER_REQUIRED,
  REGISTER_PROFILE_CREATOR_CATEGORIES_REQUIRED,
  REGISTER_PROFILE_CREATOR_PLATFORMS_REQUIRED,
  SELECT_SOME_OPTIONS,
  REGISTER_PROFILE_CREATOR_CITIES_ANSWER,
  REGISTER_PROFILE_CREATOR_CITIES_REQUIRED,
  RATE_DAILY_LIMIT_AI,
  RATE_DAILY_LIMIT_AI_CHAT,
  BUTTON_GO_BACK,
  TOP_RATED_CATEGORY,
  BUTTON_CLEAR_FILTERS,
  PERSONALIZED_INSTRUCTIONS,
  EMPTY_REQUESTS,
  EMPTY_CAMPAIGNS,
  EMPTY_ORDERS,
  EMPTY_REDEEM_CODES,
  EMPTY_USERS,
  EMPTY_CONTACTS,
  EMPTY_INVOICES,
  EMPTY_APPLICANTS_PENDING,
  EMPTY_APPLICANTS_ACCEPTED,
  PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META,
  ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS,
  AUTH_TIKTOK_VERIFICATION_LOADING,
  AUTH_TIKTOK_VERIFICATION_SUCCESS,
  AUTH_TIKTOK_VERIFICATION_FAILED,
  DOCUMENT_ID_EMIRATES,
  DOCUMENT_TRN,
  ADS_CAMPAIGNS_TITLE,
  ADS_CAMPAIGNS_DESCRIPTION,
  EMPTY_ADS_CAMPAIGNS,
  FIELD_INTERESTS_REQUIRED,
  FIELD_GENDERS_REQUIRED,
  FIELD_LOCATIONS_REQUIRED,
  FIELD_CURRENCY_MIN_VALUE,
  FIELD_BUDGET_REQUIRED,
  FIELD_TYPE_BUDGET_REQUIRED,
  FIELD_OBJECTIVE_REQUIRED,
  FIELD_NAME_REQUIRED,
  CREATE_ADS_CAMPAIGN_NAME_QUESTION,
  CREATE_ADS_CAMPAIGN_NAME_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_OBJECTIVE_QUESTION,
  CREATE_ADS_CAMPAIGN_OBJECTIVE_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_QUESTION,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_DAILY_RADIO_LABEL,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_RADIO_LABEL,
  CREATE_ADS_CAMPAIGN_BUDGET_DAILY_QUESTION,
  CREATE_ADS_CAMPAIGN_BUDGET_TOTAL_QUESTION,
  CREATE_ADS_CAMPAIGN_BUDGET_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_LOCATIONS_QUESTION,
  CREATE_ADS_CAMPAIGN_AGE_RANGE_QUESTION,
  CREATE_ADS_CAMPAIGN_GENDERS_QUESTION,
  CREATE_ADS_CAMPAIGN_INTERESTS_QUESTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_LINKEDIN,
  ADS_CAMPAIGN_OBJECTIVE_SALES,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_DESCRIPTION_EXPLANATION,
  FIELD_PLATFORMS_REQUIRED,
  CREATE_ADS_CAMPAIGN_PLATFORM_QUESTION,
  CREATE_ADS_CAMPAIGN_DESCRIPTION_QUESTION,
  CTR,
  CLICKS,
  IMPRESSIONS,
  REPORTS,
  PLATFORMS,
  AGES,
  GENDERS,
  LOCATIONS,
  TARGET_CAMPAIGN,
  ADS_CAMPAIGN_TITLE,
  ADS_CAMPAIGN_HAS_BEEN_FINISHED,
  DESCRIPTION_PLACEHOLDER,
  INTERESTS_PLACEHOLDER,
  GENDERS_PLACEHOLDER,
  AGE_RANGE_PLACEHOLDER,
  LOCATIONS_PLACEHOLDER,
  EXCLUDED_LOCATIONS_PLACEHOLDER,
  INDUSTRIES_PLACEHOLDER,
  JOB_FUNCTIONS_PLACEHOLDER,
  SENIORITIES_PLACEHOLDER,
  JOB_TITLES_PLACEHOLDER,
  COMPANY_SIZES_PLACEHOLDER,
  COMPANIES_PLACEHOLDER,
  DEGREES_PLACEHOLDER,
  FIELDS_OF_STUDY_PLACEHOLDER,
  SCHOOLS_PLACEHOLDER,
  SKILLS_PLACEHOLDER,
  MEMBER_TRAITS_PLACEHOLDER,
  MEMBER_BEHAVIORS_PLACEHOLDER,
  MEMBER_GROUPS_PLACEHOLDER,
  AUDIENCE_ATTRIBUTES_PLACEHOLDER,
  DEGREES_SEARCH_PLACEHOLDER,
  FIELDS_OF_STUDY_SEARCH_PLACEHOLDER,
  INTERESTS_SEARCH_PLACEHOLDER,
  SCHOOLS_SEARCH_PLACEHOLDER,
  SKILLS_SEARCH_PLACEHOLDER,
  COMPANIES_SEARCH_PLACEHOLDER,
  INDUSTRIES_SEARCH_PLACEHOLDER,
  COMPANY_SIZES_SEARCH_PLACEHOLDER,
  JOB_FUNCTIONS_SEARCH_PLACEHOLDER,
  JOB_TITLES_SEARCH_PLACEHOLDER,
  SENIORITIES_SEARCH_PLACEHOLDER,
  MEMBER_BEHAVIORS_SEARCH_PLACEHOLDER,
  DAILY_BUDGET_PLACEHOLDER,
  PLATFORMS_PLACEHOLDER,
  OBJECTIVE_PLACEHOLDER,
  ADS_CAMPAIGN_HAS_BEEN_ACTIVATE,
  ADS_CAMPAIGN_HAS_BEEN_SAVE,
  CREATE_ADS_CAMPAIGN_INTERESTS_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_DESCRIPTION_PLACEHOLDER,
  FIELD_DESCRIPTION_REQUIRED,
  TYPE_LEAST_CHARACTERS,
  LOADING,
  META,
  META_FACEBOOK_AND_INSTAGRAM,
  PLATFORM,
  FIELD_PLATFORM_REQUIRED,
  ALERT_CREATE_SECOND_ADS_CAMPAIGN,
  ALERT_CREATE_SECOND_ADS_CAMPAIGN_DESCRIPTION,
  BUTTON_META_BILLING,
  BUTTON_TIKTOK_BILLING,
  PLATFORM_PLACEHOLDER,
  SUB_MENU_ADS_CAMPAIGNS,
  OBJECTIVE,
  AWARENESS,
  TRAFFIC,
  SALES,
  DOWNLOADS,
  LEADS,
  INTERACTIONS,
  FIELD_VIDEO_REQUIRED,
  FIELD_CREATIVE_MUST_BE_VIDEO_NOT_IMAGE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_QUESTION,
  BUTTON_REPLACE_CONTENT,
  TIKTOK_CAMPAIGN,
  META_CAMPAIGN,
  ADS_CAMPAIGN_HAS_BEEN_DUPLICATE,
  BUTTON_REPLACE_VIDEO,
  BUTTON_SELECT_VIDEO,
  CONTENT_TO_ADVERTISE,
  FIELD_BEHAVIORS_REQUIRED,
  CREATE_ADS_CAMPAIGN_BEHAVIORS_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_BEHAVIORS_QUESTION,
  CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_QUESTION,
  CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_PLACEHOLDER,
  BEHAVIORS_PLACEHOLDER,
  DEMOGRAPHICS_PLACEHOLDER,
  BUTTON_SELECT_THIS_CONTENT,
  BUTTON_REMOVE_SELECTION,
  FACEBOOK_PAGE_ID_NOT_FOUND,
  META_BUSINESS_ACCOUNT_NOT_FOUND,
  IG_BUSINESS_ACCOUNT_NOT_FOUND,
  CREATE_ADS_CAMPAIGN_TRACKING_QUESTION,
  EMPTY_TRACKING_IDS_META,
  FIELD_META_TRACKING_ID_REQUIRED,
  TRACKING_META_ID_PLACEHOLDER,
  FINISHED,
  ACCOUNT_TIKTOK_AUTH_NOT_MATCH,
  ACCOUNT_TOKEN_META_NOT_FOUND,
  ACCOUNT_ID_BUSINESS_META_NOT_FOUND,
  OBJECTIVE_CAMPAIGN_META_INVALID,
  SPECIAL_CATEGORY_CAMPAIGN_META_INVALID,
  CAMPAIGN_META_NOT_DELETED,
  CAMPAIGN_META_NOT_CREATED,
  ADS_CAMPAIGN_NOT_FOUND,
  NO_PIXELS_FOUND,
  NO_PIXELS_ACTIVE,
  CAMPAIGN_META_NOT_FOUND,
  CAMPAIGN_META_NOT_UPDATED,
  CAMPAIGN_AD_SET_META_NOT_CREATED,
  CAMPAIGN_AD_SET_META_NOT_UPDATED,
  CAMPAIGN_INFORMATION_UPDATE_FAILED_RATE_LIMIT,
  CAMPAIGN_MEDIA_META_NOT_CREATED,
  CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND,
  CAMPAIGN_CREATIVE_AD_META_NOT_CREATED,
  CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED,
  CAMPAIGN_CREATIVE_AD_META_NOT_FOUND,
  CAMPAIGN_MESSAGE_TEMPLATE_META_NOT_FOUND,
  CAMPAIGN_AD_META_NOT_CREATED,
  CAMPAIGN_AD_META_NOT_UPDATED,
  CAMPAIGN_METRICS_META_NOT_FOUND,
  BUTTON_CONNECT_TIKTOK_BUSINESS,
  TIKTOK_BUSINESS,
  EMPTY_TRACKING_IDS_TIKTOK,
  TIKTOK_PRIVACY_LEVEL_PUBLIC_TO_EVERYONE,
  TIKTOK_PRIVACY_LEVEL_MUTUAL_FOLLOW_FRIENDS,
  TIKTOK_PRIVACY_LEVEL_FOLLOWER_OF_CREATOR,
  TIKTOK_PRIVACY_LEVEL_SELF_ONLY,
  TIKTOK_PRIVACY_LEVEL_LABEL,
  TIKTOK_ACCOUNT_LABEL,
  TIKTOK_DISABLE_DUET_LABEL,
  TIKTOK_DISABLE_DUET_DESCRIPTION,
  TIKTOK_DISABLE_STITCH_LABEL,
  TIKTOK_DISABLE_STITCH_DESCRIPTION,
  TIKTOK_DISABLE_COMMENT_LABEL,
  TIKTOK_DISABLE_COMMENT_DESCRIPTION,
  TIKTOK_IS_AIGC_LABEL,
  TIKTOK_IS_AIGC_DESCRIPTION,
  SHORT_TIME_HAS_PASSED_SINCE_ACTIVATION_STATISTICS,
  CREATE_ADS_CAMPAIGN_DESTINATION_URL_QUESTION,
  FIELD_DESTINATION_URL_REQUIRED,
  FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL,
  FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL_REQUIRED,
  CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  BUTTON_RECHARGE_BALANCE,
  ALERT_REMEMBER_IF_RECHARGE_ACCOUNT_PLATFORM,
  INFORMATION,
  DESTINATION_URL_PLACEHOLDER,
  CAMPAIGN_AUDIENCE_IS_TOO_NARROW,
  CAMPAIGN_BUDGET_IS_TOO_LOW,
  PRICE_PRO_PLACEHOLDER,
  COST_COLLABORATION_PRO_PLACEHOLDER,
  MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT_WITH_CREATORS,
  MODAL_SELECT_PACKAGE_BENEFIT_CONTENT_CURATION,
  MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_PUBLICATION_PLATFORM,
  MODAL_SELECT_PACKAGE_LICENSED_PRICE,
  MODAL_SELECT_PACKAGE_LICENSED_FEE,
  MODAL_SELECT_PACKAGE_COST_CONTENT,
  SHOPIFY,
  WOOCOMMERCE,
  BUTTON_CONNECT_SHOPIFY,
  MODAL_STORE_BUTTON_CREATE_INTEGRATE_WOOCOMMERCE,
  MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_WOOCOMMERCE,
  MODAL_STORE_TITLE_CREATE_INTEGRATE_WOOCOMMERCE,
  MODAL_STORE_BUTTON_CREATE_INTEGRATE_SHOPIFY,
  MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_SHOPIFY,
  MODAL_STORE_TITLE_CREATE_INTEGRATE_SHOPIFY,
  MODAL_STORE_DESCRIPTION_DISCONNECT_SHOPIFY,
  MODAL_STORE_DESCRIPTION_DISCONNECT_WOOCOMMERCE,
  ALERT_DESCRIPTION_DISCONNECT_TIKTOK,
  ALERT_DESCRIPTION_DISCONNECT_FACEBOOK,
  MODAL_SELECT_PACKAGE_BENEFIT_VOLUME_CONTENT,
  MODAL_SELECT_PACKAGE_LICENSED_FEE_ENTERPRISE,
  MODAL_SELECT_PACKAGE_CONTENT_ENTERPRISE,
  ALERT_DESCRIPTION_DISCONNECT_TIKTOK_BUSINESS,
  VIDEO_ERROR_ILLEGAL_DURATION,
  VIDEO_ERROR_BLACK_EDGE,
  VIDEO_ERROR_ASPECT_RATIO,
  VIDEO_ERROR_NO_BACKGROUND_AUDIO,
  IDENTITY_NOT_FOUND,
  VIDEO_ERROR_LOW_RESOLUTION,
  TRACKING_TIKTOK_ID_PLACEHOLDER,
  BUTTON_CONNECT_META,
  FIELD_TIKTOK_TRACKING_ID_REQUIRED,
  PUBLICATION_STATUS_PENDING_SOCIAL,
  ADD_NEW_STYLE,
  WANTS_SOCIAL_MEDIA_POST,
  DOES_NOT_WANTS_SOCIAL_MEDIA_POST,
  BUTTON_CONTACT_AN_ADVISOR,
  ENGAGEMENT_ABBREVIATED,
  FOLLOWERS_ABBREVIATED,
  NO_MORE_RESULTS_TO_SHOW,
  BUTTON_GENERATE_SCRIPT,
  EXPLANATION_SEND_ONE_REVISION,
  I_NEED_HELP,
  REVISION_OPTION_GOOD,
  REVISION_OPTION_REGULAR,
  REVISION_OPTION_BAD,
  BUTTON_VIEW_INVOICE,
  MODAL_INVOICE_LICENSE,
  CREATOR_BODY_BUILD_PLACEHOLDER,
  CREATOR_CLOTHING_STYLE_PLACEHOLDER,
  CREATOR_CONTENT_STYLE_PLACEHOLDER,
  CREATOR_DISTINGUISHING_FEATURES_PLACEHOLDER,
  BODY_BUILD_THIN,
  BODY_BUILD_AVERAGE,
  BODY_BUILD_WIDE,
  BODY_BUILD_MUSCULAR,
  BODY_BUILD_CURVY,
  BODY_BUILD_ATHLETIC,
  CLOTHING_STYLE_CASUAL,
  CLOTHING_STYLE_FORMAL,
  CLOTHING_STYLE_SPORTY,
  CLOTHING_STYLE_BUSINESS,
  CLOTHING_STYLE_ELEGANT,
  CLOTHING_STYLE_TRENDY,
  CLOTHING_STYLE_STREETWEAR,
  CLOTHING_STYLE_TRADITIONAL,
  CLOTHING_STYLE_VINTAGE,
  CLOTHING_STYLE_BOHEMIAN,
  CLOTHING_STYLE_HIPSTER,
  CLOTHING_STYLE_PUNK,
  CLOTHING_STYLE_GOTHIC,
  DISTINGUISHING_FEATURES_TATTOOS,
  DISTINGUISHING_FEATURES_SCARS,
  DISTINGUISHING_FEATURES_BIRTHMARKS,
  DISTINGUISHING_FEATURES_FRECKLES,
  DISTINGUISHING_FEATURES_MOLES,
  DISTINGUISHING_FEATURES_PIERCINGS,
  DISTINGUISHING_FEATURES_DIMPLES,
  DISTINGUISHING_FEATURES_WRINKLES,
  DISTINGUISHING_FEATURES_GLASSES,
  DISTINGUISHING_FEATURES_BRACES,
  DISTINGUISHING_FEATURES_MAKEUP,
  DISTINGUISHING_FEATURES_HAIR_ACCESSORIES,
  DISTINGUISHING_FEATURES_BEARD,
  DISTINGUISHING_FEATURES_MUSTACHE,
  CONTENT_STYLE_ELEGANT,
  CONTENT_STYLE_AESTHETIC,
  CONTENT_STYLE_RAW,
  CONTENT_STYLE_MINIMALISTIC,
  CONTENT_STYLE_ARTISTIC,
  CONTENT_STYLE_VINTAGE,
  CONTENT_STYLE_MODERN,
  CONTENT_STYLE_PLAYFUL,
  CONTENT_STYLE_RUSTIC,
  CONTENT_STYLE_MONOCHROMATIC,
  REGISTER_PROFILE_CREATOR_CONTENT_STYLE,
  REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES,
  REGISTER_PROFILE_CREATOR_CLOTHING_STYLE,
  REGISTER_PROFILE_CREATOR_BODY_BUILD,
  REGISTER_PROFILE_CREATOR_BODY_BUILD_REQUIRED,
  REGISTER_PROFILE_CREATOR_CLOTHING_STYLE_REQUIRED,
  REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES_REQUIRED,
  REGISTER_PROFILE_CREATOR_CONTENT_STYLE_REQUIRED,
  BUTTON_ADJUST_PREFERENCES,
  FIELD_MAX_LENGTH_SELECT,
  FIELD_MIN_LENGTH_SELECT,
  CREATE_ADS_CAMPAIGN_LOADING_FINALIZING_DETAILS,
  CREATE_ADS_CAMPAIGN_LOADING_CREATING_INSTANT_FORM,
  CREATE_ADS_CAMPAIGN_LOADING_GENERATING_RECOMMENDATIONS,
  CREATE_ADS_CAMPAIGN_LOADING_ANALYZING_INFORMATION,
  CREATE_ADS_CAMPAIGN_LOADING_GETTING_REQUIRED_INFORMATION,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION,
  CREATE_ADS_CAMPAIGN_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_CONTEXT_PLACEHOLDER,
  BUTTON_GENERATE_AGAIN,
  BUTTON_CREATE_ADS_CAMPAIGN,
  WHY_THESE_RECOMMENDED_SETTINGS,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION,
  BUTTON_EDIT_BUDGET,
  CALL_TO_ACTION_PLACEHOLDER,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU,
  ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP,
  ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE,
  ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_APPLY,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_QUOTE,
  ADS_CAMPAIGN_CALL_TO_ACTION_JOIN,
  ADS_CAMPAIGN_CALL_TO_ACTION_ATTEND,
  ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_DEMO,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_REGISTER,
  ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_CALL_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US,
  ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD,
  ADS_CAMPAIGN_CALL_TO_ACTION_UNLOCK_FULL_DOCUMENT,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_DIRECTIONS,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES,
  ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM,
  ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_TIME,
  ADS_CAMPAIGN_CALL_TO_ACTION_SAVE,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_PROMOTIONS,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_ACCESS,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_UPDATES,
  ADS_CAMPAIGN_CALL_TO_ACTION_INQUIRE_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_BUY_TICKETS,
  ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME,
  ADS_CAMPAIGN_CALL_TO_ACTION_EXPLORE_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_USE_APP,
  ADS_CAMPAIGN_CAMPAIGN_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_BUDGET_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE,
  BUTTON_PUBLISH_CAMPAIGN,
  CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_BUTTON,
  CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ALL_IN_ONE_PLACE,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ANALYZE_PERFORMANCE,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_MANAGE_SIMPLE,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_OPTIMIZE_WITH_AI,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_CREATE_CAMPAIGN,
  CREATE_ADS_CAMPAIGN_INTRO_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_INTRO_TITLE,
  PIXEL_REQUIRED,
  ADS_CAMPAIGN_CONTEXT,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_PRODUCT_ADVERTISE,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_COMMUNICATE,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_SEGMENTATION,
  BUTTON_START_CHAT,
  FIELD_WEBSITE_URL_REQUIRED,
  CREATE_ADS_CAMPAIGN_WEBSITE_URL_QUESTION,
  BUTTON_SELECT_CONTENT,
  BUTTON_SELECT_DOCUMENT,
  BUTTON_SELECT_POST,
  FIELD_CONTENT_REQUIRED,
  TYPE_BUDGET_PLACEHOLDER,
  LIFETIME_BUDGET_PLACEHOLDER,
  DRAFT,
  BUTTON_CREATE_WITH_CANVA,
  BUTTON_CONNECT_CANVA,
  CANVA,
  ALERT_DESCRIPTION_DISCONNECT_CANVA,
  MODAL_CANVA_DESCRIPTION,
  MODAL_CANVA_TITLE,
  MODAL_CANVA_ARIA_LABEL,
  MODAL_CANVA_CREATING_DESIGN,
  MODAL_CANVA_DESIGN_NOT_CREATED,
  MODAL_CANVA_DESIGN_NOT_RETRIEVED,
  MODAL_CANVA_IS_EDITING_IN_CANVA,
  MODAL_CANVA_IS_GETTING_YOUR_DESIGN,
  BUTTON_USE_THIS_CONTENT,
  MODAL_CANVA_INFORMATION_SAVE_DESIGN,
  MODAL_CANVA_IMPORT_IMAGES_ONLY_WARNING_DESCRIPTION,
  MODAL_CANVA_IMAGE_CONFIG_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_DESCRIPTION,
  MODAL_CANVA_IMAGE_CONFIG_TYPE_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_WIDTH_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_HEIGHT_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_CREATE_BUTTON,
  MODAL_CANVA_IMAGE_CONFIG_CANCEL_BUTTON,
  MODAL_CANVA_ACCOUNT_LABEL,
  MODAL_GOOGLE_DRIVE_ACCOUNT_LABEL,
  MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE,
  MODAL_GOOGLE_DRIVE_ACCOUNT_DESCRIPTION,
  MODAL_GOOGLE_DRIVE_ACCOUNT_CONFIRM_BUTTON,
  GOOGLE_DRIVE_CONFIGURING_FILE_SELECTOR,
  GOOGLE_DRIVE_OPENING_SELECTOR,
  GOOGLE_DRIVE_IMPORTING_FILES,
  MODAL_CANVA_FOLDER_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_BUTTON,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_DESCRIPTION,
  MODAL_CANVA_DISCONNECT_TITLE,
  MODAL_CANVA_DISCONNECT_DESCRIPTION,
  MODAL_CANVA_DISCONNECT_BUTTON,
  ERROR_WIDTH_RANGE,
  ERROR_HEIGHT_RANGE,
  CONNECTED_ACCOUNTS,
  CONNECTED_ACCOUNTS_ACCORDION_COLLAPSE,
  CONNECTED_ACCOUNTS_ACCORDION_EXPAND,
  SLIDE_MENU_COLLAPSE,
  SLIDE_MENU_EXPAND,
  CONNECTED_ACCOUNTS_CONNECT_MORE_PLATFORMS,
  CONNECTED_ACCOUNTS_BUTTON_CONNECT,
  CONNECTED_ACCOUNTS_EMPTY_HINT,
  CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT,
  CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT_SINGULAR,
  CONNECTED_ACCOUNTS_PLATFORM_GOOGLE,
  CONNECTED_ACCOUNTS_PLATFORM_LINKEDIN,
  CONNECTED_ACCOUNTS_PLATFORM_META,
  CONNECTED_ACCOUNTS_PLATFORM_TIKTOK_BUSINESS,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TITLE,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_SUCCESS,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_ERROR,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_LOADING,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_AD_FORMAT_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_PROMOTION_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_FOR_APP_INSTALL_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DEEP_LINK_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_TYPE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_URL_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_MERCHANT_ID_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TIKTOK_CAMPAIGN_TYPE_LABEL,
  ADS_CAMPAIGN_USE_GENERAL_BUDGET,
  AD_GROUP,
  AD,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_AD_GROUP_INFORMATION_SUB_TITLE,
  NUMBER_ITEM,
  DESCRIPTIONS,
  HEADLINES,
  TITLES,
  TITLE_PLACEHOLDER,
  HEADLINE_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_START_END_DATE_QUESTION,
  FIELD_START_AND_END_DATES_REQUIRED,
  WEBSITE_URL_PLACEHOLDER,
  COMING_SOON,
  BUTTON_CONNECT_GOOGLE,
  BUTTON_CONNECT_GOOGLE_DRIVE,
  LANGUAGE_CAMPAIGN_PLACEHOLDER,
  FIELD_LANGUAGE_REQUIRED,
  CREATE_ADS_LANGUAGE_QUESTION,
  CREATE_ADS_PLATFORMS_QUESTION,
  BUTTON_SELECT,
  BUTTON_DESELECT,
  BUTTON_SEND_CODE,
  VERIFICATION_CODE_PLACEHOLDER,
  ENTER_CODE,
  AUTH_INVALID_VERIFICATION_CODE,
  BUTTON_VERIFY_CODE,
  WE_SEND_VERIFICATION_CODE_TO_YOUR_PHONE,
  MODIFY_PHONE_NUMBER,
  OTP_VERIFICATION_TITLE,
  OTP_VERIFICATION_EMAIL_SENT,
  OTP_BACK_TO_EMAIL,
  ERROR_GETTING_URL_INFORMATION_BY_PROTECTED,
  META_TOGGLE_DESCRIPTION,
  GOOGLE_TOGGLE_DESCRIPTION,
  TIKTOK_TOGGLE_DESCRIPTION,
  NOT_AVAILABLE,
  BUTTON_CONNECTED,
  EDIT_INSTRUCTIONS,
  PROMPT,
  BUTTON_ADD_RE_TARGETING,
  MODAL_CUSTOM_AUDIENCES_DESCRIPTION,
  MODAL_CUSTOM_AUDIENCES_TITLE,
  MODAL_CUSTOM_AUDIENCES_ARIA_LABEL,
  MODAL_CUSTOM_AUDIENCES_EMPTY_TEXT,
  TYPE,
  RETENTION_DAYS,
  ERRORS,
  OPERATION_STATUS,
  DELIVERY_STATUS,
  MODAL_CREATE_CUSTOM_AUDIENCE_DESCRIPTION,
  MODAL_CREATE_CUSTOM_AUDIENCE_TITLE,
  MODAL_CREATE_CUSTOM_AUDIENCE_ARIA_LABEL,
  RETENTION_DAYS_PLACEHOLDER,
  TYPE_PLACEHOLDER,
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE,
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_TITLE_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_TITLE_EXPLANATION,
  MODAL_CREATE_CUSTOM_AUDIENCE_UPLOAD_CSV_CUSTOMER_LIST,
  ADS_SUBSCRIPTION_BENEFIT_PLATFORMS_CAMPAIGNS,
  ADS_SUBSCRIPTION_BENEFIT_CAMPAIGNS,
  ADS_SUBSCRIPTION_BENEFIT_OPTIMIZATIONS,
  ADS_SUBSCRIPTION_BENEFIT_USERS,
  ADS_SUBSCRIPTION_BENEFIT_STORAGE,
  ADS_SUBSCRIPTION_BENEFIT_STORAGE_CUSTOM,
  ADS_SUBSCRIPTION_BENEFIT_EMAIL_SUPPORT,
  ADS_SUBSCRIPTION_BENEFIT_CHAT_SUPPORT,
  ADS_SUBSCRIPTION_BENEFIT_PRIORITY_SUPPORT,
  ADS_SUBSCRIPTION_BENEFIT_DEDICATED_ACCOUNT_MANAGER,
  VALUE_SUBSCRIPTION_MONTHLY,
  BUTTON_BUY_PLAN,
  MOST_POPULAR,
  PRICING_HERO_TITLE_PACKAGES,
  PRICING_HERO_TITLE_CREDITS,
  PRICING_HERO_DESCRIPTION,
  PRICING_APPSUMO_CREDITS_STACK_TITLE,
  PRICING_APPSUMO_CREDITS_STACK_DESCRIPTION,
  PRICING_CREDIT_USAGE_TITLE,
  PRICING_CREDIT_USAGE_CAMPAIGN,
  PRICING_CREDIT_USAGE_IMAGE,
  PRICING_CREDIT_USAGE_VIDEO,
  PRICING_CREDIT_USAGE_ANIMATE_IMAGE,
  PRICING_CREDIT_USAGE_ANALYZE_IMAGE_LAYERS,
  PRICING_CREDIT_USAGE_CUSTOM_REPORT,
  PRICING_CREDIT_USAGE_CUSTOM_REPORT_DECK,
  PRICING_CREDIT_USAGE_OPTIMIZATION,
  PRICING_CREDIT_USAGE_SCHEDULED_POST,
  PRICING_CREDIT_USAGE_PER,
  PRICING_CREDIT_USAGE_CREDIT,
  PRICING_CREDIT_USAGE_CREDITS,
  CREDIT_COST_ITEM,
  MANUAL_SEGMENTATION,
  RE_TARGETING_SEGMENTATION,
  BUTTON_ADD,
  BUTTON_UPLOAD_CONTENT_FROM_ADS_PLATFORMS,
  ADS_CAMPAIGNS_PIXELS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGNS_PIXELS_TITLE_EXPLANATION,
  BUTTON_UPDATE,
  UPDATING_INFORMATION,
  ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_PROFILE,
  FIELD_CALL_TO_ACTION_VALID_BY_OBJECTIVE,
  TITLE,
  IDENTITIES_TIK_TOK_EMPTY,
  IDENTITY_TIK_TOK_PLACEHOLDER,
  ADD_NEW_IDENTITY,
  PROFILE_IMAGE_PLACEHOLDER,
  PROFILE_NAME_PLACEHOLDER,
  ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_TITLE,
  ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_DESCRIPTION,
  MENU_CONNECTED_ACCOUNTS,
  GENERAL_INFORMATION,
  CONTEXT,
  FIELD_TRACKING_IDS_REQUIRED,
  CREATE_ADS_CAMPAIGN_TRACKINGS_QUESTION,
  AUTH_INVALID_APP_CREDENTIAL,
  LOADING_METRICS_FROM_PLATFORMS,
  CAMPAIGN_HAS_NEVER_BEEN_ACTIVATED,
  HOW_IS_YOUR_CAMPAIGN_GOING,
  AN_ERROR_OCCURRED_GETTING_THE_REPORT,
  META_ERROR_GETTING_USER_INFORMATION,
  META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION,
  META_ERROR_GETTING_ACCOUNTS_INFORMATION,
  META_OAUTH_PERMISSIONS_ERROR,
  META_ACCOUNT_AUTHENTICATION_REQUIRED,
  AD_ACCOUNTS,
  FACEBOOK_PAGES,
  INSTAGRAM_ACCOUNTS,
  AD_ACCOUNT_META_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_AD_ACCOUNTS_QUESTION,
  CREATE_ADS_CAMPAIGN_AD_ACCOUNT_QUESTION,
  AD_ACCOUNT_TIKTOK_PLACEHOLDER,
  FIELD_AD_ACCOUNTS_REQUIRED,
  INSTAGRAM_ACCOUNT_PLACEHOLDER,
  USE_FB_PAGE_AS_IG,
  YOUTUBE_ACCOUNT_PLACEHOLDER,
  YOUTUBE_PRIVACY_LEVEL_PUBLIC,
  YOUTUBE_PRIVACY_LEVEL_UNLISTED,
  YOUTUBE_PRIVACY_LEVEL_PRIVATE,
  YOUTUBE_PRIVACY_LEVEL_LABEL,
  YOUTUBE_TITLE_LABEL,
  YOUTUBE_DESCRIPTION_LABEL,
  YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL,
  YOUTUBE_MADE_FOR_KIDS_LABEL,
  PAGE_FACEBOOK_PLACEHOLDER,
  META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD,
  META_AD_ACCOUNT_IS_NOT_ACTIVE,
  FIELD_CONTENT_IS_BEING_PROCESSED,
  ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_DESCRIPTION,
  ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_TITLE,
  BUTTON_CONNECT_ACCOUNT,
  CREATE_ADS_CAMPAIGN_BUDGET_DESCRIPTION_QUESTION,
  CREATE_ADS_CAMPAIGN_IDENTITIES_ACCOUNTS_QUESTION,
  META_GENERATE_CAMPAIGN_IDENTITIES_PLACEMENTS_HINT,
  MODAL_CLOSE_UNSAVED_WARNING_DESCRIPTION,
  MODAL_CLOSE_UNSAVED_CONFIRM,
  META_ADAPT_PLACEMENTS_CONFIRM_TITLE,
  META_ADAPT_PLACEMENTS_CONFIRM_TEXT,
  META_ADAPT_PLACEMENTS_CONFIRM_YES,
  META_ADAPT_PLACEMENTS_CONFIRM_NO,
  META_ADAPT_PLACEMENTS_CHECKBOX_LABEL,
  META_ADAPT_PLACEMENTS_CHECKBOX_COST,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST,
  ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_DONATE,
  ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT,
  ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE,
  ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH,
  ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE,
  ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT,
  ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_LEAD,
  ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO,
  TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER,
  TRACKING_CUSTOM_EVENT_ID_TIKTOK_PLACEHOLDER,
  ADS_CAMPAIGN_CUSTOM_EVENT_CUSTOMIZE_PRODUCT,
  CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENTS_QUESTION,
  CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENT_QUESTION,
  LAST_UPDATE,
  DATE_RELATIVE,
  LAST_UPDATE_DATE_SHORT,
  BUTTON_RESEND_CODE,
  FIELD_MIN_TOTAL_BUDGET_ONE_DOLLAR,
  LAST_RECORDED_EVENT_ON,
  NEVER,
  PIXEL_HAS_NO_RECORDED_EVENTS,
  DATE_SHORT_2,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD,
  FORMAT_PLACEHOLDER,
  BUTTON_REPLACE,
  BUTTON_SUPPORT,
  ADS_SUBSCRIPTION_TITLE,
  ADS_SUBSCRIPTION_DESCRIPTION,
  SPEND_FEE,
  IN_A_FEW_MINUTES_YOUR_INVOICE_WILL_BE_AVAILABLE,
  BUTTON_REACTIVATE_SUBSCRIPTION,
  BUTTON_CANCEL_SUBSCRIPTION,
  BUTTON_CHANGE_PAYMENT_METHODS,
  ALERT_REACTIVATE_SUBSCRIPTION_TITLE,
  ALERT_PAYMENT_METHOD_CHANGED_TITLE,
  ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION,
  ALERT_CANCEL_SUBSCRIPTION_TITLE,
  ALERT_CANCEL_SUBSCRIPTION_TITLE_CONFIRMATION,
  ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION_CONFIRMATION,
  ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK,
  CURRENCY_MISMATCH,
  ADVERTISER_ID_NOT_FOUND_TIK_TOK,
  ALERT_CONNECT_ACCOUNT_SECURE_DESCRIPTION,
  RETRIEVING_INSTAGRAM_ACCOUNTS,
  RETRIEVING_FACEBOOK_PAGES,
  RETRIEVING_AD_ACCOUNTS,
  RETRIEVING_GENERAL_INFORMATION,
  ENDING_CONNECTION,
  ALERT_POPUP_BLOCKED_DESCRIPTION,
  ALERT_POPUP_BLOCKED_TITLE,
  VERIFYING_YOUR_SESSION,
  ALREADY_HAVE_AN_ACCOUNT,
  GETTING_REQUIRED_INFORMATION,
  VERIFYING_PLATFORMS_INFORMATION,
  CREATING_CAMPAIGN,
  CREATING_AD_GROUPS,
  UPLOADING_CONTENTS,
  CREATING_ADS,
  SAVING_INFORMATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_FORM,
  ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON,
  ADS_CAMPAIGN_CUSTOM_EVENT_PLACE_ORDER,
  INACTIVE,
  CUSTOM_EVENT,
  CREATE_ADS_CAMPAIGN_MODE_QUESTION,
  CREATE_ADS_CAMPAIGN_ADVANCED_MODE_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_ADVANCED_MODE,
  CREATE_ADS_CAMPAIGN_QUICK_MODE_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_QUICK_MODE,
  FAST,
  EASY,
  AUTOMATED,
  FULL_CONTROL,
  CUSTOMIZE,
  TAILORED,
  ERROR_GETTING_URL_META_DATA_AND_IMAGES,
  ALERT_DELETE_PLATFORM_CAMPAIGN_DESCRIPTION,
  BUTTON_DELETE_PLATFORM,
  MODAL_CONNECT_ACCOUNTS_DESCRIPTION,
  MODAL_CONNECT_ACCOUNTS_TITLE,
  TURKISH,
  PORTUGUESE,
  FRENCH,
  RUSSIAN,
  JAPANESE,
  MANDARIN,
  HINDI,
  ARABIC,
  BENGALI,
  PUNJABI,
  GERMAN,
  JAVANESE,
  KOREAN,
  INDONESIAN,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS,
  ADVERTISER_SELECTOR_BRANDS_COUNT,
  ADVERTISER_SELECTOR_NO_RESULTS,
  ADVERTISER_SELECTOR_SEARCH_PLACEHOLDER,
  ADVERTISER_SELECTOR_TRY_ANOTHER_NAME,
  ADVERTISER_SELECTOR_CONFIGURE_LIMITS_BUTTON,
  SELECT_ADVERTISER_ID_PLACEHOLDER,
  ADVERTISER_ID_TO_CHANGE_NO_PERMISSION,
  CANNOT_DELETE_MAIN_ADVERTISER,
  RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION,
  ALERT_DUPLICATE_CAMPAIGN_TITLE,
  ALERT_DUPLICATE_CAMPAIGN_DESCRIPTION,
  MODAL_ERRORS_CAMPAIGNS_DESCRIPTION,
  MODAL_ERRORS_CAMPAIGNS_TITLE,
  CAMPAIGN_CREATED,
  CREATIFY_VIDEO_PREVIEW_CLARIFICATION,
  CREATIFY_VIDEO_ERROR_RENDER_CLARIFICATION,
  CREATIFY_VIDEO_RENDERING_CLARIFICATION,
  COPY,
  CREATIFY_VIDEO_RENDERING_CLARIFICATION_AND_CREATE_CAMPAIGN,
  BUTTON_GENERATE_WITH_AI,
  GENERATING_VIDEO_MESSAGE,
  TASK_ALERT_ESTIMATED_TIME,
  CROATIAN,
  SLOVAK,
  BULGARIAN,
  CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_QUESTION,
  BUTTON_CHANGE_CONTENT,
  BUTTON_EDIT_CONTENT,
  BUTTON_CHANGE_SLIDE,
  PLATFORM_ONLY_ACCEPTS_VIDEOS,
  CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_QUESTION,
  SOCIAL_NETWORK_URL_PLACEHOLDER,
  DISCOUNT_CODE_PLACEHOLDER,
  DO_YOU_HAVE_DISCOUNT_CODE,
  DISCOUNT_CODE_NOT_FOUND,
  DISCOUNT_CODE_NOT_APPLICABLE_TO_THIS_PRODUCT,
  DISCOUNT_VALUE,
  NORMAL_PRICE,
  CONTENT_NUMERATION,
  ALERT_DELETE_CAMPAIGN_DESCRIPTION,
  ALERT_DELETE_CAMPAIGN_TITLE,
  ALERT_DELETE_CAMPAIGN_ERROR_TITLE,
  ALERT_DELETE_CAMPAIGN_ERROR_TEXT,
  FIELD_URL_INSTAGRAM,
  CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_PLACEHOLDER,
  BRAND_INSTAGRAM_PROFILE_URL_PLACEHOLDER,
  LANGUAGE_PLACEHOLDER,
  SCRIPT_PLACEHOLDER,
  BUTTON_CHANGE_AVATAR,
  BUTTON_SELECT_AVATAR,
  WE_CANT_GET_AVATARS,
  CONTENT_GENERATOR,
  SELECT_BACKGROUND_CONTENT_CLARIFICATION,
  SELECT_BACKGROUND_CONTENT,
  CUSTOM,
  BUTTON_CONTACT_US,
  BUTTON_GENERATE,
  BUTTON_GENERATE_RANDOM,
  SCRIPT_IS_TOO_SHORT,
  FIELD_MIN_CONTENT,
  BUTTON_ADD_SELECTED_CONTENT,
  INSTAGRAM_PROFILE_URL_PLACEHOLDER,
  WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED,
  DANISH,
  BUTTON_LOG_IN_WITH_GOOGLE,
  BUTTON_REGISTER_WITH_GOOGLE,
  EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM,
  CREATE_ADS_CAMPAIGN_LOCATIONS_PLACEHOLDER,
  OAUTH_IN_WINDOW_NO_COMPLETED,
  OAUTH_CALLBACK_ACCOUNT_CONNECTED_TITLE,
  OAUTH_CALLBACK_ACCOUNT_CONNECTED_TEXT,
  BUTTON_CHANGE_LOGO,
  ERROR_PROCESSING_REQUEST,
  ERROR_PROCESSING_CAMPAIGNS,
  ERROR_ANALYZING_LINK_CREATIFY,
  GENERATE_AI_FREE_VIDEO_LIMIT,
  NOT_HAVE_ENOUGH_USAGE_VALUE,
  USAGE_VALUE_NOT_FOUND,
  FAL_AI_CREDENTIALS_INVALID,
  HEYGEN_CREDENTIALS_INVALID,
  GETTING_CREATIFY_VIDEO_DATA,
  COINS,
  VALUE_NUMBER,
  PER_MONTH,
  ACTION_CONFIRM_TEXT,
  BUTTON_UPGRADE_PLAN,
  LABEL_CURRENT_SUBSCRIPTION_PLAN,
  COINS_VALUE,
  CREDITS_VALUE,
  ADS_SUBSCRIPTION_CREDITS_BENEFIT,
  ADS_SUBSCRIPTION_COINS_BENEFIT,
  VALUE_SUBSCRIPTION_PRORATED,
  VALUE_SUBSCRIPTION_AFTER_PRORATED,
  RENEWED_ON,
  EXPIRE_ON,
  YOUR_TRIAL_CREDITS_END,
  YOUR_TRIAL_COINS_END,
  BUTTON_UPGRADE_TO_PAID_PLAN,
  CURRENT_USAGE_TYPE,
  LOADING_PLAN_INFORMATION,
  YOUR_TRIAL_END,
  ALERT_PUBLISH_ACTIVE_OR_DEACTIVATE_CAMPAIGN_TITLE,
  CREATE_ACTIVATED,
  CREATE_DEACTIVATED,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_INSTAGRAM,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_FACEBOOK,
  FIELD_AD_FORMAT_REQUIRED_AD_PREVIEW,
  FIELD_CALL_TO_ACTION_REQUIRED_AD_PREVIEW,
  FIELD_PAGE_ID_REQUIRED_AD_PREVIEW,
  FIELD_SPONSOR_PAGE_ID_REQUIRED_AD_PREVIEW,
  FIELD_INSTAGRAM_ID_REQUIRED_AD_PREVIEW,
  FIELD_IDENTITY_TIK_TOK_ID_REQUIRED_AD_PREVIEW,
  BUTTON_UPGRADE_PLAN_2,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_WHATSAPP,
  ALERT_DESCRIPTION_DISCONNECT_GOOGLE,
  EMPTY_TRACKING_IDS_GOOGLE,
  TRACKING_GOOGLE_ID_PLACEHOLDER,
  AD_ACCOUNT_GOOGLE_PLACEHOLDER,
  TRACKING_CUSTOM_EVENT_ID_GOOGLE_PLACEHOLDER,
  COINS_EXPLANATION,
  CREDITS_EXPLANATION,
  KEYWORDS_PLACEHOLDER,
  ADS_CAMPAIGN_TYPE_VIDEO,
  ADS_CAMPAIGN_TYPE_SHOPPING,
  ADS_CAMPAIGN_TYPE_SEARCH,
  ADS_CAMPAIGN_TYPE_VIDEO_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_VIDEO_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SHOPPING_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SHOPPING_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SEARCH_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SEARCH_TITLE_EXPLANATION,
  CAMPAIGN_TYPE_PLACEHOLDER,
  ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE,
  ADS_META_DESTINATION_TYPE_WEBSITE,
  META_DESTINATION_TYPE_PLACEHOLDER,
  META_DESTINATION_TYPE_INSTAGRAM_PROFILE_CLARIFICATION,
  CREATE_ADS_CAMPAIGN_DESTINATION_TYPE_QUESTION,
  ADVERTISER,
  MARKETER,
  VIEWER,
  DELETED,
  ROLE_PLACEHOLDER,
  VIEWER_ROLE_DESCRIPTION_EXPLANATION,
  VIEWER_ROLE_READ_ONLY_CAPABILITY,
  VIEWER_ROLE_TITLE_EXPLANATION,
  VIEWER_CAPABILITY_VIEW_CAMPAIGNS,
  VIEWER_CAPABILITY_VIEW_CONTENT,
  VIEWER_CAPABILITY_VIEW_CALENDAR,
  VIEWER_CAPABILITY_VIEW_REPORTS,
  MARKETER_ROLE_DESCRIPTION_EXPLANATION,
  MARKETER_ROLE_TILE_EXPLANATION,
  ADVERTISER_ROLE_DESCRIPTION_EXPLANATION,
  ADVERTISER_ROLE_TITLE_EXPLANATION,
  DESIGNER_ROLE_TITLE_EXPLANATION,
  ROLE_CAPABILITY_CAN_MANAGE_USERS,
  ROLE_CAPABILITY_CAN_ACCESS_SETTINGS_ACCOUNTS,
  ROLE_CAPABILITY_CAN_CREATE_CAMPAIGN,
  ROLE_CAPABILITY_CAN_EDIT_CAMPAIGN,
  ROLE_CAPABILITY_CAN_USE_CAMPAIGN_AGENT,
  ROLE_CAPABILITY_CAN_EDIT_GALLERY,
  ROLE_CAPABILITY_CAN_POST,
  ROLE_CAPABILITY_CAN_EDIT_BRAND_SETUP,
  ROLE_CAPABILITY_CAN_EDIT_BILLING,
  PASSWORD_CLARIFICATION_IN_EDIT_USER,
  CREATED_AT,
  CREATED_BY,
  ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_TITLE,
  ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_DESCRIPTION,
  BUTTON_BOOK_A_DEMO,
  YEARLY,
  SEMIYEARLY,
  QUARTERLY,
  MONTHLY,
  CPA,
  CPA_CLARIFICATION,
  MAIN_STATISTIC_CPM_CLARIFICATION,
  MAIN_STATISTIC_CLICK_CLARIFICATION,
  MAIN_STATISTIC_POST_ENGAGEMENT_CLARIFICATION,
  MAIN_STATISTIC_LEAD_CLARIFICATION,
  MAIN_STATISTIC_PURCHASE_CLARIFICATION,
  MAIN_STATISTIC_AD_RECALL_CLARIFICATION,
  MAIN_STATISTIC_VIDEO_VIEW_CLARIFICATION,
  MAIN_STATISTICS_INSTAGRAM_PROFILE_CLARIFICATION,
  MAIN_STATISTIC_VALUE_CPM_CLARIFICATION,
  MAIN_STATISTIC_VALUE_CLICK_CLARIFICATION,
  MAIN_STATISTIC_VALUE_POST_ENGAGEMENT_CLARIFICATION,
  MAIN_STATISTIC_VALUE_LEAD_CLARIFICATION,
  MAIN_STATISTIC_VALUE_PURCHASE_CLARIFICATION,
  MAIN_STATISTIC_VALUE_AD_RECALL_CLARIFICATION,
  MAIN_STATISTIC_VALUE_VIDEO_VIEW_CLARIFICATION,
  MAIN_STATISTIC_VALUE_INSTAGRAM_PROFILE_CLARIFICATION,
  GENERATING_OPTIMIZATIONS,
  COMPARING_RESULTS_OBTAINED,
  ANALYZING_CAMPAIGN_STATISTICS,
  CAMPAIGN_OPTIMIZED_NAME,
  CAMPAIGN_OPTIMIZED_GENERATED,
  BUTTON_APPLY_OPTIMIZATIONS,
  BUTTON_DISCARD_OPTIMIZATIONS,
  ERROR_NETWORK_CONNECTION,
  FIELD_START_DATE_LESS_THAN_NOW,
  FIELD_END_DATE_LESS_THAN_NOW,
  CAMPAIGN_UPDATED,
  ERROR_ON_AD_ID_OF_AD_GROUP_ID,
  ERROR_ON_AD_GROUP_ID,
  CAMPAIGN_OPTIMIZED,
  APPLYING_OPTIMIZATIONS,
  ADS_CAMPAIGN_STATISTICS_CURRENT_STATE_TITLE,
  DATE_DAY_AND_MONTH_SHORT,
  SPEND,
  RESULTS,
  CPC,
  CPM,
  CLICK,
  AVERAGE,
  PERIOD,
  MAIN_ACTIONS_BY_PLATFORM,
  CLICKS_BY_PLATFORM,
  IMPRESSIONS_BY_PLATFORM,
  RECOMMENDATIONS,
  CONCLUSION,
  WEEK_COUNT,
  DAY_COUNT,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_DAILY,
  EMPTY_STATISTICS_FOR_DETAILED_REPORT,
  VALUE_WITH_CURRENCY_MANUAL_FORMAT,
  LOCATIONS_TIK_TOK_EMPTY,
  CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_QUESTION,
  CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_QUESTION,
  CHAT_DO_A_QUESTION,
  CHAT_ASK_A_QUESTION_ABOUT_YOUR_CAMPAIGN,
  CHAT_CAMPAIGN_OPEN_AUTO_SUMMARY_QUESTION,
  CHAT_CAMPAIGN_OPEN_ANALYZING_SUGGESTIONS,
  CHAT_BOT_NAME,
  CHAT_BOT_DESCRIPTION,
  CHAT_BOT_WELCOME_MESSAGE,
  CHAT_BOT_WELCOME_MESSAGE_STATISTICS,
  CHAT_BOT_WELCOME_DESCRIPTION_STATISTICS,
  CHAT_BOT_WELCOME_MESSAGE_OWNER,
  CHAT_BOT_WELCOME_DESCRIPTION_OWNER,
  CHAT_ASK_A_QUESTION_OWNER,
  CHAT_REASONING_ANALYZING_USER_MESSAGE,
  CHAT_REASONING_PROCESSING_CAMPAIGN_DATA,
  CHAT_REASONING_GETTING_PERFORMANCE_METRICS,
  CHAT_REASONING_ANALYZING_BEST_PRACTICES,
  CHAT_REASONING_GENERATING_RECOMMENDATIONS,
  PRODUCT_OR_SERVICE_CONTEXT,
  TARGET_AUDIENCE_CONTEXT,
  REQUEST_TIME_OUT,
  TIME_OUT_FOR_PROVIDER,
  ADS_META_DESTINATION_TYPE_ON_POST,
  ADS_META_DESTINATION_TYPE_ON_VIDEO,
  FIELD_POST_ID_REQUIRED_AD_PREVIEW,
  FACEBOOK,
  WHATSAPP_BUSINESS_NUMBER_PLACEHOLDER,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE,
  ADS_CAMPAIGN_ADDITIONAL_CONFIGURATION_AD_GROUP_SUB_TITLE,
  ADS_META_DESTINATION_TYPE_WHATSAPP,
  WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER,
  MESSAGE_TEMPLATE_UNSUPPORTED_TITLE,
  MESSAGE_TEMPLATE_UNSUPPORTED_DESCRIPTION,
  BUTTON_CREATE_TEMPLATE,
  MODAL_MESSAGE_TEMPLATE_DESCRIPTION,
  MODAL_MESSAGE_TEMPLATE_TITLE,
  GREETING_MESSAGE_PLACEHOLDER,
  CUSTOMER_TYPE_MESSAGE_PLACEHOLDER,
  CUSTOMER_TYPE_PREFILL_MESSAGE,
  CUSTOMER_TYPE_QUICK_QUESTIONS_MESSAGE,
  CUSTOMER_TEXT_PLACEHOLDER,
  CUSTOMER_TEXTS_PLACEHOLDER,
  LOG_MESSAGE_TEMPLATE_CUSTOMER_TEXTS,
  FIRST_USER_MESSAGE,
  GREETING,
  BUTTON_EDIT_TEMPLATE,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER,
  ADS_META_DESTINATION_TYPE_INSTANT_FORM,
  BUTTON_VIEW_DETAILED_REPORT,
  IS_CAROUSEL,
  CARD,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD,
  FIELD_MIN_CARDS_AD_CAROUSEL,
  BUTTON_SELECT_INSTANT_FORM,
  FORM,
  MODAL_INSTANT_FORMS_LIST_TITLE,
  MODAL_INSTANT_FORMS_LIST_DESCRIPTION,
  INSTANT_FORM_PLACEHOLDER,
  TIKTOK_LEAD_DESTINATION_WEBSITE,
  TIKTOK_LEAD_DESTINATION_INSTANT_FORM,
  TIKTOK_INSTANT_FORM_EDITOR_HINT,
  TIKTOK_INSTANT_FORM_CREATE,
  TIKTOK_INSTANT_FORM_EDITOR_FAILED,
  INTEGRATION_MISSING_PERMISSION,
  TIKTOK_INSTANT_FORM_LOCKED_DESTINATION,
  TIKTOK_CAROUSEL_REQUIRES_TIKTOK_PLACEMENT,
  TIKTOK_INSTANT_FORM_PREVIEW_NAME,
  CREATE_ADS_CAMPAIGN_TIKTOK_LEAD_DESTINATION_QUESTION,
  CREATE_ADS_CAMPAIGN_TIKTOK_INSTANT_FORM_QUESTION,
  MODAL_INSTANT_FORMS_EMPTY_TEXT,
  FORMS,
  MODAL_CREATE_INSTANT_FORM_TITLE,
  MODAL_CREATE_INSTANT_FORM_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME,
  MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT,
  MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_QUESTIONS_HEADLINE,
  MODAL_CREATE_INSTANT_FORM_CONTACT_FIELDS,
  MODAL_CREATE_INSTANT_FORM_CONTACT_FULL_NAME,
  MODAL_CREATE_INSTANT_FORM_CONTACT_WORK_EMAIL,
  MODAL_CREATE_INSTANT_FORM_MAX_QUESTIONS,
  MODAL_CREATE_INSTANT_FORM_PRIVACY_LINK_TEXT,
  MODAL_CREATE_INSTANT_FORM_ADDITIONAL_ACTION,
  MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE,
  MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME,
  MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_WEBSITE_URL,
  MODAL_CREATE_INSTANT_FORM_SCHEDULING_LINK,
  MODAL_CREATE_INSTANT_FORM_SCHEDULING_PROVIDER,
  MODAL_CREATE_INSTANT_FORM_BOOK_TIME_HINT,
  MODAL_CREATE_INSTANT_FORM_BUTTON_TEXT,
  LEAD_FORM_RECOMMENDATION_GENERATING,
  LEAD_FORM_RECOMMENDATION_CANCEL,
  LEAD_FORM_RECOMMENDATION_FAILED,
  LEAD_FORM_RECOMMENDATION_CAMPAIGN_GENERATING,
  QUESTIONS,
  ENTER_ANSWER_PLACEHOLDER,
  ANSWERS,
  ANSWER,
  FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER,
  YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP,
  MODAL_VERIFY_INTEGRATION_SCOPES_DESCRIPTION,
  MODAL_VERIFY_INTEGRATION_SCOPES_TITLE,
  BUTTON_RECONNECT_ACCOUNT,
  BUTTON_RECONNECT,
  ADS_SUBSCRIPTION_BENEFIT_AI_CAMPAIGNS,
  ADS_SUBSCRIPTION_BENEFIT_AI_AUDIENCE_SEGMENTATION,
  ADS_SUBSCRIPTION_BENEFIT_AI_CONTENT,
  ADS_SUBSCRIPTION_BENEFIT_POSTS,
  ADS_SUBSCRIPTION_BENEFIT_AI_ADVANCED_INSIGHTS_AND_REPORTS,
  ADS_SUBSCRIPTION_CREDITS_YEARLY_BENEFIT,
  ADS_SUBSCRIPTION_CREDITS_SEMIANNUALLY_BENEFIT,
  ADS_SUBSCRIPTION_CREDITS_QUARTERLY_BENEFIT,
  ADS_SUBSCRIPTION_CREDITS_MONTHLY_BENEFIT,
  CONVERSION_ACTIONS_PLACEHOLDER,
  SEARCH_KEYWORDS_PLACEHOLDER,
  GOOGLE_BROAD_KEYWORD_EXPLANATION,
  GOOGLE_BROAD_KEYWORD,
  GOOGLE_EXACT_KEYWORD_EXPLANATION,
  GOOGLE_EXACT_KEYWORD,
  GOOGLE_PHRASE_KEYWORD_EXPLANATION,
  GOOGLE_PHRASE_KEYWORD,
  GOOGLE_KEYWORDS_EXPLANATION,
  GOOGLE_SEARCH_AD_GROUP_TYPE_LABEL,
  GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD,
  GOOGLE_SEARCH_AD_GROUP_TYPE_DSA,
  GOOGLE_WEBPAGE_CRITERIA_TITLE,
  GOOGLE_WEBPAGE_CRITERIA_EXPLANATION,
  GOOGLE_WEBPAGE_CRITERION_OPERATOR_LABEL,
  GOOGLE_WEBPAGE_CRITERION_VALUE_LABEL,
  GOOGLE_WEBPAGE_CRITERION_URL_EQUALS,
  GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS,
  FIELD_WEBPAGE_CRITERIA_REQUIRED,
  FIELD_WEBPAGE_CRITERIA_REPEATED,
  GOOGLE_SEARCH_AD_GROUP_DSA_NO_KEYWORDS_STATS,
  GOOGLE_DSA_SETTINGS_TITLE,
  GOOGLE_DSA_SETTINGS_EXPLANATION,
  GOOGLE_DSA_DOMAIN_LABEL,
  GOOGLE_DSA_LANGUAGE_LABEL,
  GOOGLE_WEBPAGES_NOT_ADDED,
  GOOGLE_WEBPAGE_ADD_TITLE,
  GOOGLE_WEBPAGE_EDIT_TITLE,
  GOOGLE_WEBPAGE_URL_LABEL,
  COLUMN_NAME_URL,
  ALERT_DELETE_WEBPAGE_TITLE,
  ALERT_DELETE_WEBPAGE_DESCRIPTION,
  ALERT_DELETE_WEBPAGES_TITLE,
  ALERT_DELETE_WEBPAGES_DESCRIPTION,
  ADS_CAMPAIGN_AD_FORMAT_GOOGLE_SEARCH,
  BUTTON_ADD_CONVERSION_ACTION,
  FIELD_MAX_CONTENT,
  IMAGES_OF_CAMPAIGN_PLACEHOLDER,
  LOGO_OF_THE_BRAND_PLACEHOLDER,
  FIELD_TEXT_ONLY_HAS_LETTERS_NUMBERS_DOTS_COMMAS,
  NETWORK_DISPLAY_SETTING_PLACEHOLDER,
  GOOGLE_NETWORK_SETTING_PARTNER_SEARCH_NETWORK,
  GOOGLE_NETWORK_SETTING_CONTENT_NETWORK,
  GOOGLE_NETWORK_SETTING_SEARCH_NETWORK,
  GOOGLE_NETWORK_SETTING_GOOGLE_SEARCH,
  GOOGLE_AI_MAX_ENABLE_QUESTION,
  GOOGLE_AI_MAX_ACTIVATED,
  GOOGLE_AI_MAX_DEACTIVATED,
  ADS_CAMPAIGN_PLATFORM_BRAND_CONFIGURATION_SUB_TITLE,
  COLUMN_NAME_CPA,
  COLUMN_NAME_CPM,
  COLUMN_NAME_CPC,
  COLUMN_NAME_CONVERSIONS,
  COLUMN_NAME_CTR,
  COLUMN_NAME_CLICKS,
  COLUMN_NAME_IMPRESSIONS,
  COLUMN_NAME_KEYWORD,
  COLUMN_NAME_SEARCH_TERM,
  GOOGLE_SEARCH_TERMS_TITLE,
  GOOGLE_SEARCH_TERMS_DESCRIPTION,
  GOOGLE_SEARCH_TERMS_EMPTY,
  SEARCH_TERM_MATCH_TYPE_BROAD,
  SEARCH_TERM_MATCH_TYPE_PHRASE,
  SEARCH_TERM_MATCH_TYPE_EXACT,
  SEARCH_TERM_MATCH_TYPE_NEAR_PHRASE,
  SEARCH_TERM_MATCH_TYPE_NEAR_EXACT,
  SEARCH_TERM_MATCH_TYPE_AI_MAX,
  EMPTY_KEYWORDS,
  TOP_KEYWORDS,
  BETA,
  ALERT_CONNECT_GOOGLE_BETA_DESCRIPTION,
  ALERT_CONNECT_GOOGLE_BETA_TITLE,
  SAVING_MEDIA,
  PROCESSING_MEDIA_TO_USE,
  TUTORIAL,
  SELECT_RANGE_DATE,
  TO,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_MONTHLY,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_WEEKLY,
  REPORT_BREAKDOWN_PLACEHOLDER,
  MONTH_COUNT,
  BUTTON_FILTER,
  BUTTON_CONNECT_LINKEDIN,
  LINKEDIN_TOGGLE_DESCRIPTION,
  FIELD_TEXT_REPEATED,
  FIELD_IMAGES_REPEATED,
  FIELD_VIDEOS_REPEATED,
  FIELD_MEDIA_FILE_MIN_DIMENSIONS,
  ERROR_WITH_MOBILE_PROVIDER,
  FIELD_KEYWORDS_REPEATED,
  FIELD_KEYWORDS_MAX_LENGTH,
  ADS_CAMPAIGN_CONTEXT_PLACEHOLDER,
  ADS_CAMPAIGN_CONTEXT_EXAMPLE,
  ADS_CAMPAIGN_LANGUAGE_PLACEHOLDER,
  ADS_CAMPAIGN_LANGUAGE_SELECT_PLACEHOLDER,
  ADS_CAMPAIGN_LOCATION_PLACEHOLDER,
  ADS_CAMPAIGN_LOCATION_EXAMPLE,
  ADS_CAMPAIGN_PLATFORMS_PLACEHOLDER,
  FIELDS_REQUIRED,
  BUDGET_PLACEHOLDER,
  WRITE_INSTRUCTIONS_TO_CREATE_YOUR_CAMPAIGN,
  BUTTON_REMOVE,
  ADD_PLATFORMS,
  BUTTON_TRY_AGAIN,
  ERROR_GENERATING_CAMPAIGN,
  BUTTON_PUBLISH_CHANGES,
  FIELD_MIN_DAILY_BUDGET,
  BUTTON_ANALYZE,
  BRAND_SETUP_TITLE,
  BUSINESS_DESCRIPTION_PLACEHOLDER,
  SOCIAL_NETWORKS_PLACEHOLDER,
  SOCIAL_NETWORK_EXAMPLE,
  BUSINESS_TEXT_STYLE_PLACEHOLDER,
  THIS_ITEM_HAS_ERRORS,
  FIND_A_LOCATION_PLACEHOLDER,
  BUTTON_DROP_PIN,
  CREATIVE_TYPE_PLACEHOLDER,
  CAROUSEL,
  INDIVIDUAL,
  BUTTON_EDIT_PLACEMENTS,
  MODAL_EDIT_PLACEMENTS_META_DESCRIPTION,
  MODAL_EDIT_PLACEMENTS_META_TITLE,
  MODAL_EDIT_GROUP_CREATIVE_META_TITLE,
  MODAL_EDIT_GROUP_CREATIVE_META_DESCRIPTION,
  PLACEMENT_META_USE,
  PLACEMENT_META_RESIZE,
  PLACEMENT_META_SELECT_OTHER_CONTENT,
  FIELD_TWO_CARDS_REQUIRED_FOR_GENERATE_PREVIEW,
  MARKER_NUMBER_LIST,
  MARKER_LIST,
  MARKER_TYPE,
  MARKER_LNG,
  MARKER_LAT,
  MARKER_RADIUS,
  RADIUS,
  AROUND,
  ADVANTAGE_CREATIVE_ENHANCES_PLACEHOLDER,
  BUTTON_EDIT_ADVANTAGE_ENHANCES,
  ADVANTAGE_ENHANCES_ACTIVE_COUNT,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_TITLE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY,
  UKRAINIAN,
  ALERT_FILL_BRAND_SETUP_TITLE,
  ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN,
  BUTTON_COMPLETE_INFORMATION,
  KEYWORDS_NEGATIVE_PLACEHOLDER,
  FIELD_KEYWORDS_AND_KEYWORDS_NEGATIVE_REPEATED,
  ADS_CAMPAIGN_PLATFORM_ADDITIONAL_CONFIGURATION_SUB_TITLE,
  SITE_LINK_FINAL_URL_PLACEHOLDER,
  SITE_LINK_DESCRIPTION_PLACEHOLDER,
  SITE_LINK_TEXT_PLACEHOLDER,
  SITE_LINKS_PLACEHOLDER,
  SITE_LINK_DESCRIPTIONS_PLACEHOLDER,
  SITE_LINK_PLACEHOLDER,
  CALLOUT_TEXT_PLACEHOLDER,
  CALLOUTS_PLACEHOLDER,
  GOOGLE_KEYWORDS_NEGATIVE_EXPLANATION,
  CREATE_ADS_CAMPAIGN_TYPE_QUESTION,
  WE_ARE_SYNCHRONIZING_INFORMATION_WITH_PLATFORMS,
  OPTIONAL,
  CREATE_ADS_CAMPAIGN_DATES_QUESTION,
  CREATE_ADS_CAMPAIGN_AD_FORMAT_QUESTION,
  FIELD_CAMPAIGN_MUST_HAVE_ONE_DAY_ACTIVE,
  COLUMN_NAME_MATCH_TYPE,
  KEYWORD_BROAD_MATCH_TYPE_OPTION,
  KEYWORD_PHRASE_MATCH_TYPE_OPTION,
  KEYWORD_EXACT_MATCH_TYPE_OPTION,
  KEYWORD_PLACEHOLDER,
  KEYWORD_MATCH_TYPE_PLACEHOLDER,
  KEYWORD_TYPE_NORMAL,
  KEYWORD_TYPE_NEGATIVE,
  BUTTON_ADD_KEYWORDS,
  MODAL_EDIT_KEYWORD_TITLE,
  MODAL_ADD_KEYWORDS_TITLE,
  ALERT_DELETE_KEYWORD_DESCRIPTION,
  ALERT_DELETE_KEYWORD_TITLE,
  KEYWORDS_NOT_ADDED,
  KEYWORDS_NEGATIVE_NOT_ADDED,
  FIELD_THIS_KEYWORD_ALREADY_EXIST_IN_YOUR_LIST,
  CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_QUESTION,
  CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_DESCRIPTION,
  ENTER_ONE_KEYWORD_PER_LINE,
  BUTTON_SELECT_POST_FROM_SOCIAL_NETWORKS,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_ON_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_ON_DESCRIPTION,
  ALERT_IS_DYNAMIC_CREATIVE_OFF_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_OFF_DESCRIPTION,
  FIELD_MEDIA_URL_REQUIRED_AD_PREVIEW,
  FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_DRAFT,
  FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_CREATED,
  META_AD_PREVIEW_AD_BLOCKER_NOTICE,
  FROM_PLACEHOLDER,
  KEYWORDS,
  KEYWORDS_NEGATIVE,
  COLUMN_NAME_SPEND,
  ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE,
  ALERT_CHANGE_AD_ACCOUNT_META_DESCRIPTION,
  ALERT_CHANGE_AD_ACCOUNT_TIKTOK_DESCRIPTION,
  ALERT_CHANGE_AD_ACCOUNT_GOOGLE_DESCRIPTION,
  ALERT_CHANGE_AD_ACCOUNT_LINKEDIN_DESCRIPTION,
  ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_OVERVIEW,
  ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_METRICS,
  ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_INSIGHTS,
  ADS_CAMPAIGNS_STATISTICS_PERFORMANCE_TRENDS,
  COLUMN_NAME_PLATFORM,
  COLUMN_NAME_RESULTS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_GROUP,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_KEYWORDS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_VIDEOS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_IMAGES,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_HEADLINES,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_LONG_HEADLINES,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_DESCRIPTIONS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AUDIENCE_BREAKDOWN,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_HIGHEST_PERFORMING,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AGE_RANGE_LABEL,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_PLAY_VIDEO,
  ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPM,
  ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPC,
  ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPA,
  TOTAL_IMPRESSIONS,
  TOTAL_CLICKS,
  TOTAL_CLICK,
  TOTAL_RESULTS,
  TOTAL_SPEND,
  CUSTOM_AUDIENCES,
  CREATIVE,
  BUTTON_CREATE_NEW,
  FIELD_START_DATE_REQUIRED,
  SELECTED,
  ALERT_DELETE_KEYWORDS_TITLE,
  ALERT_DELETE_KEYWORDS_DESCRIPTION,
  ROAS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_TITLE,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_DESCRIPTION,
  ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_PERFORMING_ASSETS,
  FORECAST,
  ACTION,
  MODAL_PREVIEW_OPTIMIZATIONS_TITLE,
  MODAL_PREVIEW_OPTIMIZATIONS_DESCRIPTION,
  WHY_THIS_OPTIMIZATION,
  BUTTON_PREVIEW_OPTIMIZATION,
  COLUMN_NAME_FIELD,
  COLUMN_NAME_CURRENT_VALUE,
  COLUMN_NAME_NEW_VALUE,
  DELETE,
  INSIGHTS,
  CHANGE_CONTENT_FOR_OPTIMIZATION_AD_INSIGHT,
  BUTTON_CHANGE_CREATIVE,
  BUTTON_APPLIED,
  CREATE_ADS_CAMPAIGN_VIDEO_URLS_QUESTION,
  CREATE_ADS_CAMPAIGN_VIDEO_URLS_DESCRIPTION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_APP,
  ADS_CAMPAIGN_TYPE_APP_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_APP_DESCRIPTION_EXPLANATION,
  CREATE_ADS_CAMPAIGN_IMAGE_URLS_QUESTION,
  CREATE_ADS_CAMPAIGN_IMAGE_URLS_DESCRIPTION_QUESTION,
  LONG_HEADLINES,
  VIDEOS_OF_CAMPAIGN_PLACEHOLDER,
  LONG_HEADLINE_PLACEHOLDER,
  LOGO_URLS_PLACEHOLDER,
  ADS_CAMPAIGN_PLATFORM_ASSETS_CONFIGURATION_SUB_TITLE,
  ADS_CAMPAIGNS_PLATFORM_TEXTS_SUB_TITLE,
  SEARCH_THEMES_PLACEHOLDER,
  PRESS_ENTER_TO_ADD_OPTION,
  GOOGLE_P_MAX,
  GOOGLE_SEARCH,
  BUTTON_SKIP,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP,
  ASSETS_GROUP,
  DO_NOT_UPLOAD_VIDEO_ON_YOUTUBE_HELPER_TEXT,
  YOUTUBE_VIDEO_SOURCE_YOUTUBE,
  YOUTUBE_VIDEO_SOURCE_GALLERY,
  YOUTUBE_VIDEO_SOURCE_URL,
  MODAL_GALLERY_YOUTUBE_TITLE,
  MODAL_GALLERY_YOUTUBE_EMPTY,
  BUTTON_SELECT_FROM_YOUTUBE,
  BUTTON_PUBLISH_VIDEO_ON_YOUTUBE,
  MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE,
  MODAL_UPLOAD_YOUTUBE_VIDEO_DURATION_INVALID,
  YOUTUBE_VIDEO_LINK,
  FIELD_VIDEO_YOUTUBE_URL_INVALID,
  FIELD_MAX_VIDEOS_YOUTUBE_VALID,
  FIELD_YOUTUBE_VIDEO_NOT_PUBLIC,
  FIELD_YOUTUBE_VIDEO_DURATION_INVALID,
  FIELD_YOUTUBE_VIDEO_NOT_PUBLIC_AND_DURATION_INVALID,
  FIELD_MAX_IMAGES_VALID,
  FIELD_MIN_TEXTS_VALID,
  FIELD_MAX_TEXTS_VALID,
  REQUIRED_IMAGES_GOOGLE_ASSETS_GROUP_HELPER_TEXT,
  REQUIRED_IMAGES_GOOGLE_SQUARE_IMAGE,
  REQUIRED_IMAGES_GOOGLE_HORIZONTAL_IMAGE,
  BUTTON_ADD_VIDEO,
  ERROR_ON_ASSETS_GROUP_ID,
  BUTTON_CREATE_FROM_SCRATCH,
  BUTTON_CREATE_FROM_TEMPLATES,
  BUTTON_IMPORT_FROM_PLATFORM,
  BUTTON_IMPORT_FROM_GOOGLE_DRIVE,
  MODAL_IMPORT_ADS_CAMPAIGN_TITLE,
  MODAL_IMPORT_ADS_CAMPAIGN_DESCRIPTION,
  MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_TITLE,
  MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_DESCRIPTION,
  ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION,
  BUTTON_IMPORT_CAMPAIGN,
  BUTTON_DUPLICATE_FROM_PLATFORM,
  BUTTON_DUPLICATE_CAMPAIGN,
  MODAL_DUPLICATE_ADS_CAMPAIGN_TITLE,
  MODAL_DUPLICATE_ADS_CAMPAIGN_DESCRIPTION,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_TITLE,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_DESCRIPTION,
  MODAL_IMPORT_ADS_CAMPAIGN_SUPPORTED_TYPES,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUPPORTED_TYPES,
  STATUS_PLACEHOLDER,
  CAMPAIGNS_NOT_FOUND,
  CAMPAIGN_SELECTED,
  ALREADY_IMPORTED,
  CREATE_A_CAMPAIGN,
  CREATE_A_CAMPAIGN_FOR_BRAND_NAME,
  BUTTON_SAVE_AND_PUBLISH,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_ARIA_LABEL,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_DESCRIPTION,
  AD_ACCOUNTS_TITLE,
  SETTINGS_TITLE,
  API_KEYS_TAB_TITLE,
  BYOK_SETTINGS_DESCRIPTION,
  BYOK_DEFAULT_PAYMENT_MODE_LABEL,
  BYOK_DEFAULT_PAYMENT_MODE_HELPER,
  BYOK_PAYMENT_MODE_CREDITS,
  BYOK_PAYMENT_MODE_BYOK,
  BYOK_CONFIGURED_PREVIEW,
  BYOK_NOT_CONFIGURED,
  BYOK_PROVIDER_INPUT_LABEL,
  BYOK_PROVIDER_INPUT_PLACEHOLDER,
  BYOK_SAVE_BUTTON,
  BYOK_SAVING_BUTTON,
  BYOK_SAVE_SUCCESS_TITLE,
  BYOK_SAVE_SUCCESS_DESCRIPTION,
  BYOK_SAVE_ERROR,
  BYOK_PROVIDER_KEYS_TITLE,
  BYOK_PROVIDERS_COUNTER,
  BYOK_KEY_CONFIGURED_STATUS,
  BYOK_NO_KEY_CONFIGURED_STATUS,
  BYOK_REPLACE_KEY,
  BYOK_DELETE_KEY,
  BYOK_DELETE_KEY_TITLE,
  BYOK_DELETE_KEY_DESCRIPTION,
  BYOK_DELETE_KEY_ERROR,
  BYOK_DELETE_KEY_SUCCESS_TITLE,
  BYOK_DELETE_KEY_SUCCESS_DESCRIPTION,
  BYOK_KEY_ENCRYPTED_NOTICE,
  BYOK_DEFAULT_PAYMENT_MODE_DESCRIPTION,
  BYOK_PROVIDERS_WILL_BE_USED,
  BYOK_CONFIGURE_MISSING_PROVIDERS,
  MODAL_API_KEYS_ARIA_LABEL,
  BUSINESS_COMPETITORS_PLACEHOLDER,
  COPY_VALUE_IN_OTHER_ADS,
  COPY_VALUES_IN_OTHER_ADS,
  COPY_VALUE_IN_OTHER_ADGROUPS,
  COPY_VALUES_IN_OTHER_ADGROUPS,
  REST_CAMPAIGNS,
  REST_CREATIVES,
  CREATIVES_REMAINING_SHORT,
  FIELD_TITLES_REQUIRED_AD_PREVIEW,
  FIELD_TITLES_REQUIRED_AD_PREVIEW_TIKTOK,
  FIELD_HEADLINES_REQUIRED_AD_PREVIEW,
  FIELD_DESCRIPTIONS_REQUIRED_AD_PREVIEW,
  USE_CAMPAIGN_BUDGET_PLACEHOLDER,
  GENERATING_REPORT,
  GETTING_METRICS,
  ADS_META_DESTINATION_TYPE_NONE,
  DESTINATION_TYPE_AD_PLACEHOLDER,
  EXPORT_COPIES_TO_GOOGLE_DRIVE,
  COPIES_OF_AD,
  ALL_COPIES_OF_PLATFORM,
  ADVERTISER_ID_NOT_FOUND_GOOGLE,
  CONFIGURED_SITE_LINKS,
  MODAL_SITE_LINKS_TITLE,
  MODAL_SITE_LINKS_DESCRIPTION,
  MODAL_SITE_LINK_TITLE,
  MODAL_SITE_LINK_IMAGE_URL,
  MODAL_SITE_LINK_URL,
  BUTTON_ADD_SITE_LINK,
  BUTTON_EDIT_SITE_LINKS,
  ADS_CAMPAIGN_CALL_TO_ACTION_DYNAMIC,
  ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_TITLE,
  ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_DESCRIPTION,
  ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_TITLE,
  ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_DESCRIPTION,
  MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_DESCRIPTION,
  MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_TITLE,
  DATA_TYPE_PLACEHOLDER,
  BUTTON_SELECT_CSV_FILE,
  DATA_TYPE_CRM_ID_OPTION,
  DATA_TYPE_CONTACT_INFORMATION_OPTION,
  ALL_CUSTOMERS,
  PURCHASERS,
  HIGH_VALUE_CUSTOMERS,
  QUALIFIED_LEADS,
  CONVERTED_LEADS,
  DISENGAGED_CUSTOMERS,
  PAID_SUBSCRIBERS,
  LOYALTY_SIGN_UPS,
  CART_ABANDONERS,
  CUSTOMER_TYPES_PLACEHOLDER,
  FIRST_NAME_PLACEHOLDER,
  LAST_NAME_PLACEHOLDER,
  COUNTRY_CODE_PLACEHOLDER,
  POSTAL_CODE_PLACEHOLDER,
  PHONE_PLACEHOLDER,
  NO_HEADERS_TABLE_VALID_NOT_MODIFY_HEADERS_GOOGLE_CUSTOM_AUDIENCE,
  BUTTON_DOWNLOAD_TEMPLATE,
  FIELD_MIN_BUDGET,
  VALUE_SUBSCRIPTION_YEARLY_UNIQUE_PAYMENT,
  ADS_SUBSCRIPTION_ENTERPRISE_CAMPAIGNS_CUSTOM,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_CUSTOM,
  WITH_OUT_PLAN,
  CONFIRMATION_USAGE_TEXT,
  BUSINESS_LOGO,
  MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_TITLE,
  MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_DESCRIPTION,
  TIKTOK_CREATE_AD_ACCOUNT_OPTION,
  TIKTOK_CREDIT_BANNER_EYEBROW,
  TIKTOK_CREDIT_BANNER_TITLE,
  TIKTOK_CREDIT_BANNER_DESCRIPTION_PREFIX,
  TIKTOK_CREDIT_BANNER_DESCRIPTION_HIGHLIGHT,
  TIKTOK_CREDIT_BANNER_CTA,
  TIKTOK_CREDIT_BADGE_TOOLTIP,
  AD_ACCOUNT_CREATED_FROM_BUSINESS,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_TITLE,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_DESCRIPTION,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_BUSINESS_CENTER,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_NAME,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_COMPANY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_INDUSTRY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_COUNTRY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY_HELPER,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_TIMEZONE,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_REVIEW_NOTE,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_CREDIT_ALERT,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_NO_BUSINESS_CENTERS,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_SUCCESS_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_EYEBROW,
  GUIDE_TIKTOK_AD_ACCOUNT_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_INTRO,
  GUIDE_TIKTOK_AD_ACCOUNT_BACK,
  GUIDE_TIKTOK_AD_ACCOUNT_LINK,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_SETTINGS,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_AD_ACCOUNTS,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_CONNECT,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_CREATE,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_ADS_MANAGER,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_AUTH_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_WEBSITE,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_BILLING,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_PAYMENT,
  CREATE_ADS_CAMPAIGN_PROJECTION_QUESTION,
  BUTTON_UPLOAD_GOOGLE_ASSET_LIBRARY,
  SQUARE_FORMAT,
  VERTICAL_FORMAT,
  SELECT_RANGE_DATE_PLACEHOLDER,
  CAMPAIGN,
  ADS_CAMPAIGNS_LOGS_TITLE,
  CHANGES,
  EMPTY_CHANGES,
  AD_GROUPS,
  ADS,
  ASSETS_GROUPS,
  CUSTOM_AUDIENCES_PLACEHOLDER,
  CUSTOM_PLACEMENTS_PLACEHOLDER,
  EXCLUDED_CUSTOM_AUDIENCES_PLACEHOLDER,
  MEDIA_URLS_PLACEHOLDER,
  ADDED,
  REMOVED,
  IT_WAS_CREATED,
  HISTORICAL_CHANGES,
  STATUS_DEACTIVATED,
  STATUS_ACTIVE,
  STATUS_FINISHED,
  MODAL_STEP_DATA_TITLE,
  BUTTON_MARK_AS_DONE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_WITH_OUT_CAROUSEL,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_DOCUMENTS,
  LINKEDIN_DOCUMENT_PDF_PREVIEW_LOADING,
  LINKEDIN_DOCUMENT_PDF_PREVIEW_ERROR,
  LINKEDIN_DOCUMENT_PDF_PREVIEW_ALT,
  LINKEDIN_DOCUMENT_PREVIEW_PREV,
  LINKEDIN_DOCUMENT_PREVIEW_NEXT,
  LINKEDIN_DOCUMENT_PREVIEW_PAGE_COUNT,
  LINKEDIN_DOCUMENT_PREVIEW_OPEN_NEW_TAB,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_CAROUSEL,
  CREATE_ADS_CAMPAIGN_TEMPLATE_QUESTION,
  CREATE_ADS_CAMPAIGN_TEMPLATE_SINGULAR,
  CREATE_ADS_CAMPAIGN_TEMPLATE_MULTIPLE,
  BUTTON_ADD_PRODUCT,
  N_NUMBER_SELECTED,
  CALL_TO_ACTIONS_PLACEHOLDER,
  FILTER_BY_STATUS,
  CREATE_ADS_CAMPAIGN_CATALOG_QUESTION,
  ADS_META_DESTINATION_TYPE_CATALOG,
  CATALOG_PLACEHOLDER,
  IS_CATALOG_CAMPAIGN_PLACEHOLDER,
  PROMOTED_PRODUCTS_PLACEHOLDER,
  ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE,
  SELECT_CATALOG_IN_CAMPAIGN_LEVEL,
  PRODUCT_SET_AUDIENCE_BUILDER_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_PROSPECTING_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_RETARGETING_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_PROSPECTING_SEGMENT,
  PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_RETARGETING_SEGMENT,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_ADD_BUTTON,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_ADD_BUTTON,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_IN_THE_LAST,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_DAYS,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET,
  PRODUCT_SET_PLACEHOLDER,
  PRODUCT_CONFIGURATION_PLACEHOLDER,
  PRODUCT_LIST,
  PRODUCT_LIST_PLACEHOLDER,
  BUTTON_ADD_PRODUCTS,
  MODAL_PRODUCT_LIST_TIKTOK_TITLE,
  MODAL_PRODUCT_LIST_TIKTOK_DESCRIPTION,
  SEARCH_PRODUCT_PLACEHOLDER,
  BRAND_PLACEHOLDER,
  RETAILER_ID_PLACEHOLDER,
  SHORT_DESCRIPTION_PLACEHOLDER,
  CURRENT_PRICE_PLACEHOLDER,
  UNIT_PRICE_PLACEHOLDER,
  CUSTOM_LABEL_NUMBER_PLACEHOLDER,
  CUSTOM_NUMBER_PLACEHOLDER,
  URL_PLACEHOLDER,
  INTRO_CARD,
  CATALOG_CARD,
  PROFILE_CARD,
  CREATIVE_FROM_PLACEHOLDER,
  SLIDES_SHOW,
  SINGLE_IMAGE,
  EDIT_CREATIVE_TOOLS_PLACEHOLDER,
  MODIFY_CATALOG_LABELS,
  MODIFY_PRODUCT_TAGS,
  OVERLAY_TYPE_PLACEHOLDER,
  OVERLAY_POSITION_PLACEHOLDER,
  OVERLAY_SHAPE_PLACEHOLDER,
  OVERLAY_COLOR_PLACEHOLDER,
  OVERLAY_OPACITY_PLACEHOLDER,
  OVERLAY_FONT_PLACEHOLDER,
  PRICE_LABEL_PLACEHOLDER,
  AUTO_SHOW_LABEL_PLACEHOLDER,
  SOLID,
  TRANSPARENT,
  MODAL_CATALOG_LABELS_TITLE,
  MODAL_CATALOG_LABELS_DESCRIPTION,
  LABEL_TEXT_PLACEHOLDER,
  AUTOMATIC_LABELS,
  MANUAL_LABEL,
  STRIKETHROUGH_PRICE_PLACEHOLDER,
  PERCENTAGE_OFF_PLACEHOLDER,
  FREE_SHIPPING_PLACEHOLDER,
  RECTANGLE,
  PILL,
  CIRCLE,
  TRIANGLE,
  TOP_LEFT,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  OVERLAY_TEXT_COLOR_PLACEHOLDER,
  OVERLAY_TEXT_FONT_PLACEHOLDER,
  MODAL_PRODUCT_TAGS_TITLE_META,
  MODAL_PRODUCT_TAGS_DESCRIPTION_META,
  AUTOMATICALLY_TAG_PRODUCTS,
  ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT,
  APP_PLACEHOLDER,
  ANDROID_DEEP_LINK_PLACEHOLDER,
  IOS_DEEP_LINK_PLACEHOLDER,
  INSTANT_EXPERIENCE,
  BUTTON_SELECT_INSTANT_EXPERIENCE,
  INSTANT_EXPERIENCE_PLACEHOLDER,
  MODAL_INSTANT_EXPERIENCE_LIST_TITLE,
  MODAL_INSTANT_EXPERIENCE_LIST_DESCRIPTION,
  MODAL_INSTANT_EXPERIENCE_EMPTY_TEXT,
  FIELD_INSTANT_EXPERIENCE_REQUIRED_AD_PREVIEW,
  FIELD_PRODUCT_SET_ID_REQUIRED_AD_PREVIEW,
  FIELD_ALMOST_ONE_INCLUSION_OR_EXCLUSION,
  FIELD_CONTENT_INTRO_CARD_IS_REQUIRED_AD_PREVIEW,
  FILTER_BY_NAME,
  CREATE_ADS_CAMPAIGN_APP_ID_QUESTION,
  ADS_META_DESTINATION_TYPE_GOOGLE_PLAY,
  ADS_META_DESTINATION_TYPE_APP_STORE,
  DEEP_DESTINATION_APP_URL_PLACEHOLDER,
  CUSTOM_STORE_LISTING_ID_PLACEHOLDER,
  CUSTOM_PRODUCT_PAGE_ID_PLACEHOLDER,
  IOS_14_CAMPAIGN_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_CATALOG_FOR_APP_INSTALL_QUESTION,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_QUESTION,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_WEBSITE,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_APP,
  UTM_PARAMETERS_PLACEHOLDER,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_RETARGETING,
  BUTTON_DISCONNECTED,
  CREATE_ADS_CAMPAIGN_MERCHANT_ID_QUESTION,
  MERCHANT_CENTER_ID_PLACEHOLDER,
  ALL_PRODUCTS,
  PRODUCTS_TO_PROMOTE_PLACEHOLDER,
  ADS_CAMPAIGN_PRODUCTS_CONFIGURATION_SUB_TITLE,
  MODAL_EDIT_PRODUCTS_CONFIGURATION_TITLE,
  MODAL_EDIT_PRODUCTS_CONFIGURATION_DESCRIPTION,
  PRODUCTS_CONFIGURATION_SYNC_DELAY_CAPTION,
  CATEGORY_ANIMALS_PET_SUPPLIES,
  CATEGORY_ARTS_ENTERTAINMENT,
  CATEGORY_BUSINESS_INDUSTRIAL,
  CATEGORY_CAMERAS_OPTICS,
  CATEGORY_CLOTHING_ACCESSORIES,
  CATEGORY_ELECTRONICS,
  CATEGORY_FOOD_BEVERAGES,
  CATEGORY_FURNITURE,
  CATEGORY_HEALTH_BEAUTY,
  CATEGORY_HOME_GARDEN,
  CATEGORY_BABY_TODDLER,
  CATEGORY_HARDWARE,
  CATEGORY_MATURE,
  CATEGORY_MEDIA,
  CATEGORY_VEHICLES_PARTS,
  CATEGORY_OFFICE_SUPPLIES,
  CATEGORY_SPORTING_GOODS,
  CATEGORY_TOYS_GAMES,
  CATEGORY_SOFTWARE,
  CATEGORY_LUGGAGE_BAGS,
  CATEGORY_RELIGIOUS_CEREMONIAL,
  USE_A_SELECTION_OF_PRODUCTS,
  SELECT_PRODUCTS_BY,
  CONDITION,
  PRODUCT_TYPE,
  CHANNEL,
  CUSTOM_LABEL,
  CONDITION_NEW,
  CONDITION_USED,
  CONDITION_REFURBISHED,
  CHANNEL_ONLINE,
  CHANNEL_LOCAL,
  ITEM_ID,
  SELECT_ALL,
  RECOMMENDED_ACTIONS,
  BUTTON_VIEW_ACTION,
  BUTTON_CREATE_CUSTOM_AUDIENCE,
  COLUMN_NAME_CAMPAIGN,
  COLUMN_NAME_BUDGET,
  COLUMN_NAME_CREATED_BY,
  CAMPAIGNS_TABLE_ARIA_LABEL,
  CAMPAIGNS_TABLE_TITLE,
  CAMPAIGNS_STATUS_DRAFT,
  DAY_SLASH_TIME,
  DRAG_THE_MOUSE_TO_SELECT_THE_TIME_PERIOD,
  SELECTED_TIME_PERIOD,
  NO_SELECTION,
  BUTTON_CLEAR_ALL,
  BUTTON_RESET_TO_BASIC_METRICS,
  ADS_SCHEDULE_PLACEHOLDER,
  ADS_SCHEDULE_ALWAYS_ON,
  TIMEZONE_PLACEHOLDER,
  USER_TIMEZONE,
  AD_ACCOUNT_TIMEZONE,
  AD_SCHEDULE_PLACEHOLDER,
  DEMOGRAPHICS_BASIC_PLACEHOLDER,
  BUDGET_CONFIGURATION_PLACEHOLDER,
  DESTINATION_TYPE_PLACEHOLDER,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL,
  SEARCH_BY_NAME_PLACEHOLDER,
  PLACEMENTS_PLACEHOLDER,
  META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE,
  META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE_DESCRIPTION,
  META_ADGROUP_PLACEMENTS_TYPE_MANUAL,
  META_ADGROUP_PLACEMENTS_TYPE_MANUAL_DESCRIPTION,
  DEVICES_PLACEHOLDER,
  FIELD_META_PLACEMENT_FACEBOOK_PROFILE_FEED_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_MARKETPLACE_REQUIRED,
  FIELD_META_PLACEMENT_MESSENGER_INBOX_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_NOTIFICATIONS_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_STORIES_REQUIRED,
  FIELD_META_PLACEMENT_AUDIENCE_NETWORK_NATIVE_BANNER_INTERSTITIAL_REQUIRED,
  FIELD_META_PLACEMENT_AUDIENCE_NETWORK_REWARDED_VIDEOS_REQUIRED,
  FIELD_META_PLACEMENT_ADS_ON_FACEBOOK_REELS_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_INSTREAM_VIDEOS_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_SEARCH_RESULTS_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_STORIES_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_FEED_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_SEARCH_RESULTS_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_HOME_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_REELS_REQUIRED,
  CAMPAIGNS_STATUS_FINISHED,
  ADS_META_DESTINATION_TYPE_APP,
  ADVANTAGE_CATALOG_PLACEHOLDER,
  MANUAL_UPLOAD_PLACEHOLDER,
  FROM_CATALOG,
  MANUAL_UPLOAD,
  PUBLICATION_DESCRIPTION,
  CREATIVE_SOURCE_PLACEHOLDER,
  ADS_CAMPAIGN_META_FALLBACK_CATALOG,
  ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK,
  ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_LABEL,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_LABEL,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_LABEL,
  DESTINATION_FALLBACK_CONFIGURATION_TITLE,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_QUESTION,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_ABOUT_LINK,
  ADS_CAMPAIGN_META_AD_SETUP,
  ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD,
  ADS_CAMPAIGN_META_AD_SETUP_USE_POST,
  ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD,
  ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT,
  MODAL_META_REUSE_CREATIVES_TITLE,
  MODAL_META_REUSE_CREATIVES_DESCRIPTION,
  MODAL_META_REUSE_CREATIVES_EMPTY,
  MODAL_META_REUSE_CREATIVES_VALID,
  MODAL_META_REUSE_CREATIVES_INVALID,
  MODAL_META_REUSE_CREATIVES_FILTER_ACTIVE,
  MODAL_META_REUSE_CREATIVES_CLEAR_FILTER,
  MODAL_META_REUSE_CREATIVES_OPTIMIZATION_WARN,
  MODAL_META_REUSE_CREATIVES_COLUMN_COMPATIBILITY,
  MODAL_META_REUSE_CREATIVES_COLUMN_TEXTS,
  MODAL_META_REUSE_CREATIVES_COLUMN_ENGAGEMENT,
  ADS_CAMPAIGN_META_PARTNERSHIP_AD_SECTION,
  ADS_CAMPAIGN_META_PARTNERSHIP_AD_TOGGLE,
  ADS_CAMPAIGN_META_PARTNERSHIP_IDENTITY_ORDER,
  ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_FIRST,
  ADS_CAMPAIGN_META_PARTNERSHIP_PARTNER_NAME_FALLBACK,
  ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_CAMPAIGN_FIRST,
  ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_PARTNER_FIRST_LABEL,
  ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_PAGE,
  ADS_CAMPAIGN_META_PARTNERSHIP_APPROVAL_WARNING,
  ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_INSTAGRAM,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_QUESTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_DESCRIPTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_FINANCIAL_PRODUCTS_SERVICES,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_ISSUES_ELECTIONS_POLITICS,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_CREDIT,
  DESTINATION_DEEP_LINK_CONFIGURATION_PLACEHOLDER,
  SUGGESTION_BUDGET_TITLE,
  SUGGESTION_BUDGET_TEXT,
  SUGGESTION_BUDGET_PREVIOUS,
  SUGGESTION_BUDGET_CURRENT,
  SUGGESTION_BUDGET_APPLY,
  SUGGESTION_BUDGET_CANCEL,
  SUGGESTION_BUDGET_MINIMUM,
  TITLE_CAMPAIGN_INSTRUCTIONS,
  DOCUMENTS_ATTACHMENT_LABEL,
  MODAL_INSTANT_EXPERIENCE_CREATE_TITLE,
  MODAL_INSTANT_EXPERIENCE_CREATE_DESCRIPTION,
  COVER_CONTENT_PLACEHOLDER,
  ERROR_CREATING_INSTANT_EXPERIENCE,
  ALERT_ARCHIVE_CAMPAIGN_TITLE,
  ALERT_ARCHIVE_CAMPAIGN_DESCRIPTION,
  BUTTON_ARCHIVE_CAMPAIGN,
  CAMPAIGN_REQUEST_ABORTED,
  GOOGLE_ORIGIN_APP,
  GOOGLE_ORIGIN_CALL_FROM_ADS,
  GOOGLE_ORIGIN_GOOGLE_HOSTED,
  GOOGLE_ORIGIN_STORE,
  GOOGLE_ORIGIN_WEBSITE,
  GOOGLE_ORIGIN_YOUTUBE_HOSTED,
  GOOGLE_CATEGORY_ADD_TO_CART,
  GOOGLE_CATEGORY_BEGIN_CHECKOUT,
  GOOGLE_CATEGORY_BOOK_APPOINTMENT,
  GOOGLE_CATEGORY_CONTACT,
  GOOGLE_CATEGORY_CONVERTED_LEAD,
  GOOGLE_CATEGORY_DEFAULT,
  GOOGLE_CATEGORY_DOWNLOAD,
  GOOGLE_CATEGORY_ENGAGEMENT,
  GOOGLE_CATEGORY_GET_DIRECTIONS,
  GOOGLE_CATEGORY_IMPORTED_LEAD,
  GOOGLE_CATEGORY_OUTBOUND_CLICK,
  GOOGLE_CATEGORY_PAGE_VIEW,
  GOOGLE_CATEGORY_PHONE_CALL_LEAD,
  GOOGLE_CATEGORY_PURCHASE,
  GOOGLE_CATEGORY_QUALIFIED_LEAD,
  GOOGLE_CATEGORY_REQUEST_QUOTE,
  GOOGLE_CATEGORY_SIGNUP,
  GOOGLE_CATEGORY_STORE_SALE,
  GOOGLE_CATEGORY_STORE_VISIT,
  GOOGLE_CATEGORY_SUBMIT_LEAD_FORM,
  GOOGLE_CATEGORY_SUBSCRIBE_PAID,
  SEARCH_PLACEHOLDER,
  ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE,
  TRACKING_WEBSITE_EVENTS,
  ADS_TIKTOK_APP_EVENT_ACTIVE_OPTION,
  ADS_TIKTOK_APP_EVENT_DOWNLOAD_START_OPTION,
  ADS_TIKTOK_APP_EVENT_ACTIVE_REGISTER_OPTION,
  ADS_TIKTOK_APP_EVENT_ACTIVE_PAY_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_ORDER_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_CART_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_DETAIL_UV_OPTION,
  ADS_TIKTOK_APP_EVENT_NEXT_DAY_OPEN_OPTION,
  ADS_TIKTOK_APP_EVENT_LOGIN_OPTION,
  ADS_TIKTOK_APP_EVENT_LAUNCH_APP_OPTION,
  ADS_TIKTOK_APP_EVENT_COMPLETE_TUTORIAL_OPTION,
  ADS_TIKTOK_APP_EVENT_SEARCH_OPTION,
  ADS_TIKTOK_APP_EVENT_START_TRIAL_OPTION,
  ADS_TIKTOK_APP_EVENT_SUBSCRIBE_OPTION,
  CHOOSE_AN_ADDRESS_PLACEHOLDER,
  FIELD_ADDRESS_REQUIRED_AD_PREVIEW,
  FIELD_DATE_IN_PAST,
  FIELD_DATE_AT_LEAST_FIFTEEN_MINUTES_FUTURE,
  FIELD_DATE_AT_LEAST_FIVE_MINUTES_FUTURE,
  FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW,
  FIELD_DESTINATION_URL_IN_YOUR_CAROUSEL_REQUIRED_AD_PREVIEW,
  OFFLINE_EVENTS_PLACEHOLDER,
  DEEP_LINK_PLACEHOLDER,
  TRACKING_EVENTS,
  COLUMN_NAME_CONFIGURE_COLUMNS,
  CAMPAIGNS_TABLE_FILTER_COLUMNS_TITLE,
  FIELD_IMAGES_MIN_REQUIRED,
  APP_URL_NOT_FOUND,
  SIZE_FOR_DISPLAY_PLACEHOLDER,
  SIZE_FOR_SEARCH_PLACEHOLDER,
  VALID,
  INVALID,
  SIZE_PLACEHOLDER,
  INSIGHT,
  NOT_READY,
  INSIGHT_APPLIED,
  MAXIMIZE_CONVERSIONS,
  MAXIMIZE_CONVERSION_VALUE,
  MAXIMUM_COST_PER_CLICK_PLACEHOLDER,
  TARGET_CPA_PLACEHOLDER,
  TARGET_ROAS_PLACEHOLDER,
  BIDDING_STRATEGY_TYPE_PLACEHOLDER,
  ADVERTISERS_AVAILABLE_PLACEHOLDER,
  ALL_CONVERSIONS,
  ALL_CONVERSIONS_FROM_INTERACTIONS_RATE,
  ALL_CONVERSIONS_VALUE,
  APP_EVENT_ADD_TO_CART,
  APP_INSTALL,
  AVERAGE_CART_SIZE,
  AVERAGE_COST,
  AVERAGE_CPC,
  AVERAGE_ORDER_VALUE_MICROS,
  CHECKOUT,
  COMMENTS_METRICS,
  CONVERSION_RATE,
  CONVERSIONS_FROM_INTERACTIONS_RATE,
  CONVERSIONS_VALUE,
  COST_OF_GOODS_SOLD_MICROS,
  COST_PER_ALL_CONVERSIONS,
  COST_PER_APP_EVENT_ADD_TO_CART,
  COST_PER_APP_INSTALL,
  COST_PER_CHECKOUT,
  COST_PER_CONVERSION,
  COST_PER_PURCHASE,
  COST_PER_VIEW_CONTENT,
  CROSS_DEVICE_CONVERSIONS,
  CROSS_DEVICE_CONVERSIONS_VALUE_MICROS,
  CROSS_SELL_COST_OF_GOODS_SOLD_MICROS,
  CROSS_SELL_GROSS_PROFIT_MICROS,
  CROSS_SELL_REVENUE_MICROS,
  CROSS_SELL_UNITS_SOLD,
  ENGAGEMENT_RATE,
  FOLLOWS,
  GROSS_PROFIT_MARGIN,
  GROSS_PROFIT_MICROS,
  INTERACTION_RATE,
  INTERACTIONS_METRICS,
  LEAD_COST_OF_GOODS_SOLD_MICROS,
  LEAD_GROSS_PROFIT_MICROS,
  LEAD_REVENUE_MICROS,
  LEAD_UNITS_SOLD,
  LIKES_METRICS,
  ORDERS_METRICS,
  PROFILE_VISITS,
  PURCHASE,
  REVENUE_MICROS,
  SHARES_METRICS,
  VALUE_PER_ALL_CONVERSIONS,
  VALUE_PER_CONVERSION,
  VIDEO_VIEWS_P100,
  VIEW_CONTENT,
  VIEW_THROUGH_CONVERSIONS,
  ACTION_VALUES,
  ACTIONS_METRICS,
  COST_PER_ADD_TO_CART_META,
  ADD_TO_CART_META,
  COST_PER_WEB_IN_STORE_PURCHASE_META,
  WEB_IN_STORE_PURCHASE_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
  OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
  COST_PER_LINK_CLICK_META,
  LINK_CLICK_META,
  COST_PER_PAGE_ENGAGEMENT_META,
  PAGE_ENGAGEMENT_META,
  COST_PER_PURCHASE_META,
  PURCHASE_META,
  COST_PER_LANDING_PAGE_VIEW_META,
  LANDING_PAGE_VIEW_META,
  COST_PER_POST_ENGAGEMENT_META,
  POST_ENGAGEMENT_META,
  COST_PER_ONSITE_WEB_VIEW_CONTENT_META,
  ONSITE_WEB_VIEW_CONTENT_META,
  COST_PER_ONSITE_WEB_ADD_TO_CART_META,
  ONSITE_WEB_ADD_TO_CART_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
  OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
  COST_PER_COMMENT_META,
  COMMENT_META,
  COST_PER_ONSITE_WEB_APP_PURCHASE_META,
  ONSITE_WEB_APP_PURCHASE_META,
  COST_PER_OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
  OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
  COST_PER_VIEW_CONTENT_META,
  VIEW_CONTENT_META,
  COST_PER_WEB_APP_IN_STORE_PURCHASE_META,
  WEB_APP_IN_STORE_PURCHASE_META,
  COST_PER_ONSITE_WEB_APP_ADD_TO_CART_META,
  ONSITE_WEB_APP_ADD_TO_CART_META,
  COST_PER_OFFSITE_SEARCH_ADD_META_LEADS_META,
  OFFSITE_SEARCH_ADD_META_LEADS_META,
  COST_PER_POST_META,
  POST_META,
  COST_PER_ONSITE_CONVERSION_POST_SAVE_META,
  ONSITE_CONVERSION_POST_SAVE_META,
  COST_PER_ONSITE_WEB_INITIATE_CHECKOUT_META,
  ONSITE_WEB_INITIATE_CHECKOUT_META,
  COST_PER_ONSITE_CONVERSION_POST_NET_SAVE_META,
  ONSITE_CONVERSION_POST_NET_SAVE_META,
  COST_PER_ONSITE_WEB_APP_VIEW_CONTENT_META,
  ONSITE_WEB_APP_VIEW_CONTENT_META,
  COST_PER_POST_INTERACTION_GROSS_META,
  POST_INTERACTION_GROSS_META,
  COST_PER_ONSITE_WEB_PURCHASE_META,
  ONSITE_WEB_PURCHASE_META,
  COST_PER_ADD_PAYMENT_INFO_META,
  ADD_PAYMENT_INFO_META,
  COST_PER_SEARCH_META,
  SEARCH_META,
  COST_PER_VIDEO_VIEW_META,
  VIDEO_VIEW_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
  OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
  OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
  COST_PER_POST_REACTION_META,
  POST_REACTION_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
  OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
  OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
  COST_PER_INITIATE_CHECKOUT_META,
  INITIATE_CHECKOUT_META,
  COST_PER_LIKE_META,
  LIKE_META,
  AD_CLICK_ACTIONS,
  AD_IMPRESSION_ACTIONS,
  AUCTION_BID,
  AUCTION_COMPETITIVENESS,
  AUCTION_MAX_COMPETITOR_BID,
  CANVAS_AVG_VIEW_PERCENT,
  CANVAS_AVG_VIEW_TIME,
  CATALOG_SEGMENT_ACTIONS,
  CATALOG_SEGMENT_VALUE,
  CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS,
  CONVERSION_VALUES,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PRODUCT_QUANTITY,
  CONVERTED_PRODUCT_VALUE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PROMOTED_PRODUCT_QUANTITY,
  CONVERTED_PROMOTED_PRODUCT_VALUE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  COST_PER_15SEC_VIDEO_VIEW,
  COST_PER_15_SEC_VIDEO_VIEW,
  COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW,
  COST_PER_ACTION_TYPE,
  COST_PER_AD_CLICK,
  COST_PER_DDA_COUNT_BY_CONVS,
  COST_PER_ESTIMATED_AD_RECALLERS,
  COST_PER_INLINE_LINK_CLICK,
  COST_PER_INLINE_POST_ENGAGEMENT,
  COST_PER_OBJECTIVE_RESULT,
  COST_PER_ONE_THOUSAND_AD_IMPRESSION,
  COST_PER_OUTBOUND_CLICK,
  COST_PER_RESULT,
  COST_PER_THRUPLAY,
  COST_PER_UNIQUE_ACTION_TYPE,
  COST_PER_UNIQUE_CLICK,
  COST_PER_UNIQUE_CONVERSION,
  COST_PER_UNIQUE_INLINE_LINK_CLICK,
  COST_PER_UNIQUE_OUTBOUND_CLICK,
  CPP,
  DDA_COUNT_BY_CONVS,
  DDA_RESULTS,
  ESTIMATED_AD_RECALLERS,
  INSTAGRAM_PROFILE_FOLLOW,
  FULL_VIEW_IMPRESSIONS,
  FULL_VIEW_REACH,
  INLINE_LINK_CLICK_CTR,
  INLINE_LINK_CLICKS,
  INLINE_POST_ENGAGEMENT,
  INSTANT_EXPERIENCE_CLICKS_TO_OPEN,
  INSTANT_EXPERIENCE_CLICKS_TO_START,
  INSTANT_EXPERIENCE_OUTBOUND_CLICKS,
  INTERACTIVE_COMPONENT_TAP,
  LANDING_PAGE_VIEW_PER_LINK_CLICK,
  MARKETING_MESSAGES_DELIVERY_RATE,
  OBJECTIVE_RESULT_RATE,
  OBJECTIVE_RESULTS,
  OUTBOUND_CLICKS,
  OUTBOUND_CLICKS_CTR,
  PURCHASE_PER_LANDING_PAGE_VIEW,
  QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE,
  RESULT_RATE,
  RESULTS_METRICS,
  ROAS_METRICS,
  SHOPS_ASSISTED_PURCHASES,
  SOCIAL_SPEND,
  TOTAL_CARD_VIEW,
  VIDEO_30SEC_WATCHED_ACTIONS,
  VIDEO_30_SEC_WATCHED_ACTIONS,
  VIDEO_AVG_TIME_WATCHED_ACTIONS,
  VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS,
  VIDEO_P100_WATCHED_ACTIONS,
  VIDEO_P25_WATCHED_ACTIONS,
  VIDEO_P50_WATCHED_ACTIONS,
  VIDEO_P75_WATCHED_ACTIONS,
  VIDEO_P95_WATCHED_ACTIONS,
  VIDEO_PLAY_ACTIONS,
  VIDEO_PLAY_CURVE_ACTIONS,
  VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS,
  VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS,
  VIDEO_PLAY_RETENTION_GRAPH_ACTIONS,
  VIDEO_TIME_WATCHED_ACTIONS,
  WEBSITE_CTR,
  WEBSITE_PURCHASE_ROAS,
  BILLED_COST,
  GROSS_IMPRESSIONS,
  CONVERSION_RATE_TIKTOK,
  RESULT_RATE_TIKTOK,
  VIDEO_VIEWS_P100_TIKTOK,
  AVERAGE_VIDEO_PLAY,
  ENGAGEMENT_RATE_TIKTOK,
  FOLLOWS_TIKTOK,
  LIKES_TIKTOK,
  COMMENTS_TIKTOK,
  SHARES_TIKTOK,
  PROFILE_VISITS_TIKTOK,
  COMMENTS_LINKEDIN,
  COMPANY_PAGE_CLICKS_LINKEDIN,
  EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN,
  FOLLOWS_LINKEDIN,
  FULL_SCREEN_PLAYS_LINKEDIN,
  LANDING_PAGE_CLICKS_LINKEDIN,
  LIKES_LINKEDIN,
  REACTIONS_LINKEDIN,
  RETURN_ON_AD_SPEND_LINKEDIN,
  SHARES_LINKEDIN,
  TOTAL_ENGAGEMENTS_LINKEDIN,
  VIDEO_COMPLETIONS_LINKEDIN,
  VIDEO_STARTS_LINKEDIN,
  VIDEO_VIEWS_LINKEDIN,
  ONE_CLICK_LEADS_LINKEDIN,
  ONE_CLICK_LEAD_FORM_OPENS_LINKEDIN,
  LEAD_FORM_COMPLETION_RATE_LINKEDIN,
  VALID_WORK_EMAIL_LEADS_LINKEDIN,
  DOWNLOAD_CLICKS_LINKEDIN,
  DOCUMENT_FIRST_QUARTILE_COMPLETIONS_LINKEDIN,
  DOCUMENT_MIDPOINT_COMPLETIONS_LINKEDIN,
  DOCUMENT_THIRD_QUARTILE_COMPLETIONS_LINKEDIN,
  DOCUMENT_COMPLETIONS_LINKEDIN,
  LIVE_VIEWS,
  APP_INSTALL_TIKTOK,
  COST_PER_APP_INSTALL_TIKTOK,
  REGISTRATION,
  COST_PER_REGISTRATION,
  PURCHASE_TIKTOK,
  COST_PER_PURCHASE_TIKTOK,
  PURCHASE_RATE,
  TOTAL_PURCHASE_VALUE,
  APP_EVENT_ADD_TO_CART_TIKTOK,
  COST_PER_APP_EVENT_ADD_TO_CART_TIKTOK,
  CHECKOUT_TIKTOK,
  COST_PER_CHECKOUT_TIKTOK,
  VIEW_CONTENT_TIKTOK,
  COST_PER_VIEW_CONTENT_TIKTOK,
  NEXT_DAY_OPEN,
  DAY7_RETENTION,
  CASH_SPEND,
  VOUCHER_SPEND,
  COST_PER_1000_REACHED,
  CONVERSION_RATE_V2,
  REAL_TIME_CONVERSION,
  REAL_TIME_COST_PER_CONVERSION,
  REAL_TIME_CONVERSION_RATE,
  REAL_TIME_CONVERSION_RATE_V2,
  REAL_TIME_RESULT,
  REAL_TIME_COST_PER_RESULT,
  REAL_TIME_RESULT_RATE,
  SECONDARY_GOAL_RESULT,
  COST_PER_SECONDARY_GOAL_RESULT,
  SECONDARY_GOAL_RESULT_RATE,
  VIDEO_PLAY_ACTIONS_TIKTOK,
  VIDEO_WATCHED_2S,
  VIDEO_WATCHED_6S,
  VIDEO_VIEWS_P25,
  VIDEO_VIEWS_P50,
  VIDEO_VIEWS_P75,
  AVERAGE_VIDEO_PLAY_PER_USER,
  PAID_ENGAGED_VIEW,
  PAID_ENGAGEMENT_ENGAGED_VIEW,
  ENGAGED_VIEW_15S,
  PAID_ENGAGED_VIEW_15S,
  PAID_ENGAGEMENT_ENGAGED_VIEW_15S,
  CLICKS_ON_MUSIC_DISC,
  DUET_CLICKS,
  STITCH_CLICKS,
  SOUND_USAGE_CLICKS,
  MUSIC_UPLOAD_TITLE,
  MUSIC_UPLOAD_BUTTON,
  MUSIC_REMOVE_BUTTON,
  MUSIC_UPLOAD_DESCRIPTION,
  ANCHOR_CLICKS,
  ANCHOR_CLICK_RATE,
  CLICKS_ON_HASHTAG_CHALLENGE,
  PROFILE_VISITS_RATE,
  TT_PLAYLIST_VISIT,
  TT_PLAYLIST_VISIT_RATE,
  LIVE_UNIQUE_VIEWS,
  LIVE_EFFECTIVE_VIEWS,
  LIVE_PRODUCT_CLICKS,
  INTERACTIVE_ADD_ON_IMPRESSIONS,
  INTERACTIVE_ADD_ON_DESTINATION_CLICKS,
  INTERACTIVE_ADD_ON_ACTIVITY_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_A_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_B_CLICKS,
  COUNTDOWN_STICKER_RECALL_CLICKS,
  IX_PAGE_DURATION_AVG,
  IX_PAGE_VIEWRATE_AVG,
  IX_VIDEO_VIEWS,
  IX_VIDEO_VIEWS_P25,
  IX_VIDEO_VIEWS_P50,
  IX_VIDEO_VIEWS_P75,
  IX_VIDEO_VIEWS_P100,
  IX_AVERAGE_VIDEO_PLAY,
  REAL_TIME_APP_INSTALL,
  REAL_TIME_APP_INSTALL_COST,
  REGISTRATION_RATE,
  TOTAL_REGISTRATION,
  COST_PER_TOTAL_REGISTRATION,
  TOTAL_PURCHASE,
  COST_PER_TOTAL_PURCHASE,
  VALUE_PER_TOTAL_PURCHASE,
  TOTAL_ACTIVE_PAY_ROAS,
  TOTAL_PURCHASE_ROAS_DAY0,
  TOTAL_PURCHASE_ROAS_DAY2,
  TOTAL_PURCHASE_ROAS_DAY6,
  TOTAL_PURCHASE_VALUE_DAY0,
  TOTAL_PURCHASE_VALUE_DAY2,
  TOTAL_PURCHASE_VALUE_DAY6,
  APP_EVENT_ADD_TO_CART_RATE,
  TOTAL_APP_EVENT_ADD_TO_CART,
  COST_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  TOTAL_APP_EVENT_ADD_TO_CART_VALUE,
  CHECKOUT_RATE,
  TOTAL_CHECKOUT,
  COST_PER_TOTAL_CHECKOUT,
  VALUE_PER_CHECKOUT,
  TOTAL_CHECKOUT_VALUE,
  VIEW_CONTENT_RATE,
  TOTAL_VIEW_CONTENT,
  COST_PER_TOTAL_VIEW_CONTENT,
  VALUE_PER_TOTAL_VIEW_CONTENT,
  TOTAL_VIEW_CONTENT_VALUE,
  COST_PER_NEXT_DAY_OPEN,
  NEXT_DAY_OPEN_RATE,
  TOTAL_NEXT_DAY_OPEN,
  COST_PER_TOTAL_NEXT_DAY_OPEN,
  COST_PER_DAY7_RETENTION,
  DAY7_RETENTION_RATE,
  TOTAL_DAY7_RETENTION,
  COST_PER_TOTAL_DAY7_RETENTION,
  VALUE_PER_TOTAL_DAY7_RETENTION,
  TOTAL_DAY7_RETENTION_VALUE,
  ADD_PAYMENT_INFO,
  COST_PER_ADD_PAYMENT_INFO,
  ADD_PAYMENT_INFO_RATE,
  TOTAL_ADD_PAYMENT_INFO,
  COST_TOTAL_ADD_PAYMENT_INFO,
  ADD_TO_WISHLIST,
  COST_PER_ADD_TO_WISHLIST,
  ADD_TO_WISHLIST_RATE,
  TOTAL_ADD_TO_WISHLIST,
  COST_PER_TOTAL_ADD_TO_WISHLIST,
  VALUE_PER_TOTAL_ADD_TO_WISHLIST,
  TOTAL_ADD_TO_WISHLIST_VALUE,
  LAUNCH_APP,
  COST_PER_LAUNCH_APP,
  LAUNCH_APP_RATE,
  TOTAL_LAUNCH_APP,
  COST_PER_TOTAL_LAUNCH_APP,
  COMPLETE_TUTORIAL,
  COST_PER_COMPLETE_TUTORIAL,
  COMPLETE_TUTORIAL_RATE,
  TOTAL_COMPLETE_TUTORIAL,
  COST_PER_TOTAL_COMPLETE_TUTORIAL,
  VALUE_PER_TOTAL_COMPLETE_TUTORIAL,
  TOTAL_COMPLETE_TUTORIAL_VALUE,
  CREATE_GROUP,
  COST_PER_CREATE_GROUP,
  CREATE_GROUP_RATE,
  TOTAL_CREATE_GROUP,
  COST_PER_TOTAL_CREATE_GROUP,
  VALUE_PER_TOTAL_CREATE_GROUP,
  TOTAL_CREATE_GROUP_VALUE,
  JOIN_GROUP,
  COST_PER_JOIN_GROUP,
  JOIN_GROUP_RATE,
  TOTAL_JOIN_GROUP,
  COST_PER_TOTAL_JOIN_GROUP,
  VALUE_PER_TOTAL_JOIN_GROUP,
  TOTAL_JOIN_GROUP_VALUE,
  CREATE_GAMEROLE,
  COST_PER_CREATE_GAMEROLE,
  CREATE_GAMEROLE_RATE,
  TOTAL_CREATE_GAMEROLE,
  COST_PER_TOTAL_CREATE_GAMEROLE,
  VALUE_PER_TOTAL_CREATE_GAMEROLE,
  TOTAL_CREATE_GAMEROLE_VALUE,
  SPEND_CREDITS,
  COST_PER_SPEND_CREDITS,
  SPEND_CREDITS_RATE,
  TOTAL_SPEND_CREDITS,
  COST_PER_TOTAL_SPEND_CREDITS,
  VALUE_PER_TOTAL_SPEND_CREDITS,
  TOTAL_SPEND_CREDITS_VALUE,
  ACHIEVE_LEVEL,
  COST_PER_ACHIEVE_LEVEL,
  ACHIEVE_LEVEL_RATE,
  TOTAL_ACHIEVE_LEVEL,
  COST_PER_TOTAL_ACHIEVE_LEVEL,
  VALUE_PER_TOTAL_ACHIEVE_LEVEL,
  TOTAL_ACHIEVE_LEVEL_VALUE,
  UNLOCK_ACHIEVEMENT,
  COST_PER_UNLOCK_ACHIEVEMENT,
  UNLOCK_ACHIEVEMENT_RATE,
  TOTAL_UNLOCK_ACHIEVEMENT,
  COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SALES_LEAD,
  COST_PER_SALES_LEAD,
  SALES_LEAD_RATE,
  TOTAL_SALES_LEAD,
  COST_PER_TOTAL_SALES_LEAD,
  VALUE_PER_TOTAL_SALES_LEAD,
  TOTAL_SALES_LEAD_VALUE,
  IN_APP_AD_CLICK,
  COST_PER_IN_APP_AD_CLICK,
  IN_APP_AD_CLICK_RATE,
  TOTAL_IN_APP_AD_CLICK,
  COST_PER_TOTAL_IN_APP_AD_CLICK,
  VALUE_PER_TOTAL_IN_APP_AD_CLICK,
  TOTAL_IN_APP_AD_CLICK_VALUE,
  IN_APP_AD_IMPR,
  COST_PER_IN_APP_AD_IMPR,
  IN_APP_AD_IMPR_RATE,
  TOTAL_IN_APP_AD_IMPR,
  COST_PER_TOTAL_IN_APP_AD_IMPR,
  VALUE_PER_TOTAL_IN_APP_AD_IMPR,
  TOTAL_IN_APP_AD_IMPR_VALUE,
  LOAN_APPLY,
  COST_PER_LOAN_APPLY,
  LOAN_APPLY_RATE,
  TOTAL_LOAN_APPLY,
  COST_PER_TOTAL_LOAN_APPLY,
  LOAN_CREDIT,
  COST_PER_LOAN_CREDIT,
  LOAN_CREDIT_RATE,
  TOTAL_LOAN_CREDIT,
  COST_PER_TOTAL_LOAN_CREDIT,
  LOAN_DISBURSEMENT,
  COST_PER_LOAN_DISBURSEMENT,
  LOAN_DISBURSEMENT_RATE,
  TOTAL_LOAN_DISBURSEMENT,
  COST_PER_TOTAL_LOAN_DISBURSEMENT,
  LOGIN,
  COST_PER_LOGIN,
  LOGIN_RATE,
  TOTAL_LOGIN,
  COST_PER_TOTAL_LOGIN,
  RATINGS,
  GALLERY_VIEW_SCORES,
  GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_TITLE,
  GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_DESCRIPTION,
  GALLERY_SELECTED_COUNT_SINGULAR,
  GALLERY_SELECTED_COUNT_PLURAL,
  GALLERY_FOLDERS_ALL,
  GALLERY_FOLDERS_CREATE_TITLE,
  GALLERY_FOLDERS_NAME,
  GALLERY_FOLDERS_DUPLICATE,
  GALLERY_FOLDERS_CREATE_SUCCESS,
  GALLERY_FOLDERS_MOVE_SUCCESS,
  GALLERY_FOLDERS_CREATE_ERROR,
  GALLERY_FOLDERS_MOVE_ERROR,
  GALLERY_FOLDERS_BAR_ARIA_LABEL,
  GALLERY_FOLDERS_NEW_INLINE,
  GALLERY_UPLOAD_FOLDER_EMPTY,
  GALLERY_FOLDERS_UNASSIGN_SUCCESS,
  GALLERY_FOLDERS_UNASSIGN_ERROR,
  GALLERY_FOLDERS_CREATE_IN,
  GALLERY_FOLDERS_MOVE,
  GALLERY_FOLDERS_MOVE_TITLE,
  GALLERY_FOLDERS_MOVE_DESCRIPTION,
  GALLERY_FOLDERS_DESTINATION,
  GALLERY_FOLDERS_SELECT,
  GALLERY_FOLDERS_DESTINATION_PATH,
  GALLERY_FOLDERS_RENAME_TITLE,
  GALLERY_FOLDERS_RENAME_SUCCESS,
  GALLERY_FOLDERS_RENAME_ERROR,
  GALLERY_FOLDERS_RENAME_ARIA_LABEL,
  GALLERY_FOLDERS_DELETE_ARIA_LABEL,
  GALLERY_FOLDERS_DELETE_TITLE,
  GALLERY_FOLDERS_DELETE_TEXT,
  GALLERY_FOLDERS_DELETE_SUCCESS,
  GALLERY_FOLDERS_DELETE_ERROR,
  GALLERY_FOLDERS_REMOVE_FROM_FOLDER,
  GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TITLE,
  GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TEXT,
  GALLERY_FILTER_APPROVAL_STATUS,
  CAMPAIGNS_FOLDER_EMPTY,
  CAMPAIGNS_MOVE_SELECTED,
  CAMPAIGNS_FOLDERS_MOVE,
  CAMPAIGNS_FOLDERS_MOVE_TITLE,
  CAMPAIGNS_FOLDERS_MOVE_DESCRIPTION,
  CAMPAIGNS_FOLDERS_MOVE_SUCCESS,
  CAMPAIGNS_FOLDERS_MOVE_ERROR,
  CAMPAIGNS_FOLDERS_UNASSIGN_SUCCESS,
  CAMPAIGNS_FOLDERS_UNASSIGN_ERROR,
  CAMPAIGNS_SELECT_ROW,
  COST_PER_RATINGS,
  RATINGS_RATE,
  TOTAL_RATINGS,
  COST_PER_TOTAL_RATINGS,
  VALUE_PER_TOTAL_RATINGS,
  TOTAL_RATINGS_VALUE,
  SEARCH_TIKTOK,
  COST_PER_SEARCH,
  SEARCH_RATE,
  TOTAL_SEARCH,
  COST_PER_TOTAL_SEARCH,
  START_TRIAL,
  COST_PER_START_TRIAL,
  START_TRIAL_RATE,
  TOTAL_START_TRIAL,
  COST_PER_TOTAL_START_TRIAL,
  SUBSCRIBE,
  COST_PER_SUBSCRIBE,
  SUBSCRIBE_RATE,
  TOTAL_SUBSCRIBE,
  COST_PER_TOTAL_SUBSCRIBE,
  VALUE_PER_TOTAL_SUBSCRIBE,
  TOTAL_SUBSCRIBE_VALUE,
  UNIQUE_CUSTOM_APP_EVENTS,
  COST_PER_UNIQUE_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENT_RATE,
  CUSTOM_APP_EVENTS,
  COST_PER_CUSTOM_APP_EVENT,
  VALUE_PER_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENTS_VALUE,
  UNIQUE_AD_IMPRESSION_EVENTS,
  COST_PER_UNIQUE_AD_IMPRESSION_EVENT,
  CUSTOMIZED_AD_IMPRESSION_EVENT_RATE,
  ADS_IMPRESSION_EVENTS,
  COST_PRE_AD_IMPRESSION_EVENT,
  VALUE_PER_AD_IMPRESSION_EVENT,
  TOTAL_AD_IMPRESSION_EVENTS_VALUE,
  TOTAL_AD_IMPRESSION_ROAS,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY0,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY2,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY6,
  AD_IMPRESSION_AD_REVENUE_DAY0,
  AD_IMPRESSION_AD_REVENUE_DAY2,
  AD_IMPRESSION_AD_REVENUE_DAY6,
  COMPLETE_PAYMENT_ROAS,
  COMPLETE_PAYMENT,
  COST_PER_COMPLETE_PAYMENT,
  COMPLETE_PAYMENT_RATE,
  VALUE_PER_COMPLETE_PAYMENT,
  TOTAL_COMPLETE_PAYMENT_RATE,
  TOTAL_LANDING_PAGE_VIEW,
  COST_PER_LANDING_PAGE_VIEW,
  LANDING_PAGE_VIEW_RATE,
  TOTAL_PAGEVIEW,
  COST_PER_PAGEVIEW,
  PAGEVIEW_RATE,
  AVG_VALUE_PER_PAGEVIEW,
  TOTAL_VALUE_PER_PAGEVIEW,
  PAGE_BROWSE_VIEW,
  COST_PER_PAGE_BROWSE_VIEW,
  PAGE_BROWSE_VIEW_RATE,
  TOTAL_PAGE_BROWSE_VIEW_VALUE,
  VALUE_PER_PAGE_BROWSE_VIEW,
  BUTTON_CLICK,
  COST_PER_BUTTON_CLICK,
  BUTTON_CLICK_RATE,
  VALUE_PER_BUTTON_CLICK,
  TOTAL_BUTTON_CLICK_VALUE,
  ONLINE_CONSULT,
  COST_PER_ONLINE_CONSULT,
  ONLINE_CONSULT_RATE,
  VALUE_PER_ONLINE_CONSULT,
  TOTAL_ONLINE_CONSULT_VALUE,
  USER_REGISTRATION,
  COST_PER_USER_REGISTRATION,
  USER_REGISTRATION_RATE,
  VALUE_PER_USER_REGISTRATION,
  TOTAL_USER_REGISTRATION_VALUE,
  PAGE_CONTENT_VIEW_EVENTS,
  COST_PER_PAGE_CONTENT_VIEW_EVENT,
  PAGE_CONTENT_VIEW_EVENT_RATE,
  VALUE_PER_PAGE_CONTENT_VIEW_EVENT,
  TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE,
  PRODUCT_DETAILS_PAGE_BROWSE,
  COST_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  PRODUCT_DETAILS_PAGE_BROWSE_RATE,
  VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE,
  WEB_EVENT_ADD_TO_CART,
  COST_PER_WEB_EVENT_ADD_TO_CART,
  WEB_EVENT_ADD_TO_CART_RATE,
  VALUE_PER_WEB_EVENT_ADD_TO_CART,
  TOTAL_WEB_EVENT_ADD_TO_CART_VALUE,
  ON_WEB_ORDER,
  COST_PER_ON_WEB_ORDER,
  ON_WEB_ORDER_RATE,
  VALUE_PER_ON_WEB_ORDER,
  TOTAL_ON_WEB_ORDER_VALUE,
  INITIATE_CHECKOUT,
  COST_PER_INITIATE_CHECKOUT,
  INITIATE_CHECKOUT_RATE,
  VALUE_PER_INITIATE_CHECKOUT,
  TOTAL_INITIATE_CHECKOUT_VALUE,
  ADD_BILLING,
  COST_PER_ADD_BILLING,
  ADD_BILLING_RATE,
  VALUE_PER_ADD_BILLING,
  TOTAL_ADD_BILLING_VALUE,
  PAGE_EVENT_SEARCH,
  COST_PER_PAGE_EVENT_SEARCH,
  PAGE_EVENT_SEARCH_RATE,
  VALUE_PER_PAGE_EVENT_SEARCH,
  TOTAL_PAGE_EVENT_SEARCH_VALUE,
  FORM_TIKTOK,
  COST_PER_FORM,
  FORM_RATE,
  VALUE_PER_FORM,
  TOTAL_FORM_VALUE,
  DOWNLOAD_START,
  COST_PER_DOWNLOAD_START,
  DOWNLOAD_START_RATE,
  VALUE_PER_DOWNLOAD_START,
  TOTAL_DOWNLOAD_START_VALUE,
  ON_WEB_ADD_TO_WISHLIST,
  COST_PER_ON_WEB_ADD_TO_WISHLIST,
  ON_WEB_ADD_TO_WISHLIST_PER_CLICK,
  VALUE_PER_ON_WEB_ADD_TO_WISHLIST,
  TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE,
  ON_WEB_SUBSCRIBE,
  COST_PER_ON_WEB_SUBSCRIBE,
  ON_WEB_SUBSCRIBE_PER_CLICK,
  VALUE_PER_ON_WEB_SUBSCRIBE,
  TOTAL_ON_WEB_SUBSCRIBE_VALUE,
  WEBSITE_TOTAL_FIND_LOCATION,
  WEBSITE_COST_PER_FIND_LOCATION,
  WEBSITE_FIND_LOCATION_RATE,
  WEBSITE_VALUE_PER_FIND_LOCATION,
  WEBSITE_TOTAL_FIND_LOCATION_VALUE,
  WEBSITE_TOTAL_SCHEDULE,
  WEBSITE_COST_PER_SCHEDULE,
  WEBSITE_SCHEDULE_RATE,
  WEBSITE_VALUE_PER_SCHEDULE,
  WEBSITE_TOTAL_SCHEDULE_VALUE,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT,
  WEBSITE_COST_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_CUSTOMIZE_PRODUCT_RATE,
  WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  CUSTOM_PAGE_EVENTS,
  COST_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENT_RATE,
  VALUE_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENTS_VALUE,
  ONSITE_PURCHASES_ROAS,
  ONSITE_TOTAL_PURCHASE,
  ONSITE_COST_PER_PURCHASE,
  ONSITE_PURCHASE_RATE,
  ONSITE_VALUE_PER_PURCHASE,
  ONSITE_TOTAL_PURCHASE_VALUE,
  ONSITE_TOTAL_CHECKOUT_INITIATION,
  ONSITE_COST_PER_CHECKOUT_INITIATION,
  ONSITE_CHECKOUT_INITIATION_RATE,
  ONSITE_VALUE_PER_CHECKOUT_INITIATION,
  ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE,
  ONSITE_TOTAL_ADD_TO_CART,
  ONSITE_COST_PER_ADD_TO_CART,
  ONSITE_ADD_TO_CART_RATE,
  ONSITE_VALUE_PER_ADD_TO_CART,
  ONSITE_TOTAL_ADD_TO_CART_VALUE,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE,
  ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE,
  ONSITE_ADD_TO_WISHLIST,
  COST_PER_ONSITE_ADD_TO_WISHLIST,
  ONSITE_ADD_TO_WISHLIST_RATE,
  VALUE_PER_ONSITE_ADD_TO_WISHLIST,
  TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE,
  ONSITE_ADD_BILLING,
  COST_PER_ONSITE_ADD_BILLING,
  ONSITE_ADD_BILLING_RATE,
  VALUE_PER_ONSITE_ADD_BILLING,
  TOTAL_ONSITE_ADD_BILLING_VALUE,
  ONSITE_FORM,
  COST_PER_ONSITE_FORM,
  ONSITE_FORM_RATE,
  VALUE_PER_ONSITE_FORM,
  TOTAL_ONSITE_FORM_VALUE,
  ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION,
  ONSITE_DOWNLOAD_START,
  COST_PER_ONSITE_DOWNLOAD_START,
  ONSITE_DOWNLOAD_START_RATE,
  ONSITE_DESTINATION_VISITS,
  COST_PER_ONSITE_DESTINATION_VISIT,
  ONSITE_DESTINATION_VISIT_RATE,
  IX_PAGE_VIEW_COUNT,
  COST_PER_IX_PAGE_VIEW_COUNT,
  IX_PAGE_VIEW_COUNT_RATE,
  IX_BUTTON_CLICK_COUNT,
  COST_PER_IX_BUTTON_CLICK_COUNT,
  IX_BUTTON_CLICK_COUNT_RATE,
  IX_PRODUCT_CLICK_COUNT,
  COST_PER_IX_PRODUCT_CLICK_COUNT,
  IX_PRODUCT_CLICK_COUNT_RATE,
  OFFLINE_TOTAL_CRM_EVENTS,
  OFFLINE_COST_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_RATE,
  OFFLINE_VALUE_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_VALUE,
  OFFLINE_SHOPPING_EVENTS,
  COST_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENT_RATE,
  VALUE_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENTS_VALUE,
  OFFLINE_SHOPPING_EVENTS_ROAS,
  OFFLINE_CONTACT_EVENTS,
  COST_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENT_RATE,
  VALUE_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENTS_VALUE,
  OFFLINE_SUBSCRIBE_EVENTS,
  COST_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENT_RATE,
  VALUE_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENTS_VALUE,
  OFFLINE_FORM_EVENTS,
  COST_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENT_RATE,
  VALUE_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENTS_VALUE,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS,
  COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE,
  OFFLINE_ADD_TO_CART_EVENTS,
  COST_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENTS_VALUE,
  OFFLINE_ADD_TO_WISHLIST_EVENTS,
  COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE,
  OFFLINE_CLICK_BUTTON_EVENTS,
  COST_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENT_RATE,
  VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENTS_VALUE,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS,
  COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE,
  VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE,
  OFFLINE_DOWNLOAD_EVENTS,
  COST_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENT_RATE,
  VALUE_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENTS_VALUE,
  OFFLINE_INITIATE_CHECKOUT_EVENTS,
  COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENT_RATE,
  VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE,
  OFFLINE_PLACE_ORDER_EVENTS,
  COST_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENT_RATE,
  VALUE_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENTS_VALUE,
  OFFLINE_SEARCH_EVENTS,
  COST_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENT_RATE,
  VALUE_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENTS_VALUE,
  OFFLINE_VIEW_CONTENT_EVENTS,
  COST_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENT_RATE,
  VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENTS_VALUE,
  OFFLINE_PREFERRED_LEADS,
  OFFLINE_COST_PER_PREFERRED_LEAD,
  OFFLINE_PREFERRED_LEAD_RATE,
  OFFLINE_TOTAL_FIND_LOCATION,
  OFFLINE_COST_PER_FIND_LOCATION,
  OFFLINE_FIND_LOCATION_RATE,
  OFFLINE_VALUE_PER_FIND_LOCATION,
  OFFLINE_TOTAL_FIND_LOCATION_VALUE,
  OFFLINE_TOTAL_SCHEDULE,
  OFFLINE_COST_PER_SCHEDULE,
  OFFLINE_SCHEDULE_RATE,
  OFFLINE_VALUE_PER_SCHEDULE,
  OFFLINE_TOTAL_SCHEDULE_VALUE,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT,
  OFFLINE_COST_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_CUSTOMIZE_PRODUCT_RATE,
  OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  OFFLINE_TOTAL_CUSTOM_EVENTS,
  OFFLINE_COST_PER_CUSTOM_EVENT,
  OFFLINE_CUSTOM_EVENT_RATE,
  OFFLINE_VALUE_PER_CUSTOM_EVENT,
  OFFLINE_TOTAL_CUSTOM_EVENT_VALUE,
  MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP,
  ONSITE_SHOPPING_ROAS,
  ONSITE_SHOPPING,
  COST_PER_ONSITE_SHOPPING,
  ONSITE_SHOPPING_RATE,
  VALUE_PER_ONSITE_SHOPPING,
  TOTAL_ONSITE_SHOPPING_VALUE,
  SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION,
  SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION,
  SHOP_TOTAL_ITEMS_PURCHASED,
  ONSITE_INITIATE_CHECKOUT_COUNT,
  COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  ONSITE_INITIATE_CHECKOUT_COUNT_RATE,
  VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE,
  ONSITE_ON_WEB_DETAIL,
  COST_PER_ONSITE_ON_WEB_DETAIL,
  ONSITE_ON_WEB_DETAIL_RATE,
  VALUE_PER_ONSITE_ON_WEB_DETAIL,
  TOTAL_ONSITE_ON_WEB_DETAIL_VALUE,
  ONSITE_ON_WEB_CART,
  COST_PER_ONSITE_ON_WEB_CART,
  ONSITE_ON_WEB_CART_RATE,
  VALUE_PER_ONSITE_ON_WEB_CART,
  TOTAL_ONSITE_ON_WEB_CART_VALUE,
  VTA_CONVERSION,
  COST_PER_VTA_CONVERSION,
  CTA_CONVERSION,
  COST_PER_CTA_CONVERSION,
  ENGAGED_VIEW_THROUGH_CONVERSIONS,
  COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION,
  VTA_APP_INSTALL,
  COST_PER_VTA_APP_INSTALL,
  CTA_APP_INSTALL,
  COST_PER_CTA_APP_INSTALL,
  EVTA_APP_INSTALL,
  COST_PER_EVTA_APP_INSTALL,
  VTA_REGISTRATION,
  COST_PER_VTA_REGISTRATION,
  CTA_REGISTRATION,
  COST_PER_CTA_REGISTRATION,
  EVTA_REGISTRATION,
  COST_PER_EVTA_REGISTRATION,
  VTA_PURCHASE,
  COST_PER_VTA_PURCHASE,
  CTA_PURCHASE,
  COST_PER_CTA_PURCHASE,
  EVTA_PURCHASE,
  COST_PER_EVTA_PURCHASE,
  VTA_COMPLETE_PAYMENT,
  COST_PER_VTA_PAYMENTS_COMPLETED,
  EVTA_PAYMENTS_COMPLETED,
  COST_PER_EVTA_PAYMENTS_COMPLETED,
  VTA_COMPLETE_PAYMENT_VALUE,
  VTA_COMPLETE_PAYMENT_ROAS,
  SKAN_RESULT,
  SKAN_COST_PER_RESULT,
  SKAN_RESULT_RATE,
  SKAN_CONVERSION,
  SKAN_COST_PER_CONVERSION,
  SKAN_CONVERSION_RATE,
  SKAN_CONVERSION_RATE_V2,
  SKAN_CLICK_TIME_CONVERSION,
  SKAN_CLICK_TIME_COST_PER_CONVERSION,
  SKAN_CLICK_TIME_CONVERSION_RATE,
  SKAN_CLICK_TIME_CONVERSION_RATE_V2,
  SKAN_APP_INSTALL,
  SKAN_COST_PER_APP_INSTALL,
  SKAN_APP_INSTALL_WITHHELD,
  SKAN_REGISTRATION,
  SKAN_COST_PER_REGISTRATION,
  SKAN_REGISTRATION_RATE,
  SKAN_TOTAL_REGISTRATION,
  SKAN_COST_PER_TOTAL_REGISTRATION,
  SKAN_PURCHASE,
  SKAN_COST_PER_PURCHASE,
  SKAN_PURCHASE_RATE,
  SKAN_TOTAL_PURCHASE,
  SKAN_COST_PER_TOTAL_PURCHASE,
  SKAN_TOTAL_PURCHASE_VALUE,
  SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS,
  SKAN_ADD_TO_CART,
  SKAN_COST_PER_ADD_TO_CART,
  SKAN_ADD_TO_CART_RATE,
  SKAN_TOTAL_ADD_TO_CART,
  SKAN_COST_PER_TOTAL_ADD_TO_CART,
  SKAN_TOTAL_ADD_TO_CART_VALUE,
  SKAN_CHECKOUT,
  SKAN_COST_PER_CHECKOUT,
  SKAN_CHECKOUT_RATE,
  SKAN_TOTAL_CHECKOUT,
  SKAN_COST_PER_TOTAL_CHECKOUT,
  SKAN_TOTAL_CHECKOUT_VALUE,
  SKAN_VIEW_CONTENT,
  SKAN_COST_PER_VIEW_CONTENT,
  SKAN_VIEW_CONTENT_RATE,
  SKAN_TOTAL_VIEW_CONTENT,
  SKAN_COST_PER_TOTAL_VIEW_CONTENT,
  SKAN_TOTAL_VIEW_CONTENT_VALUE,
  SKAN_ADD_PAYMENT_INFO,
  SKAN_COST_PER_ADD_PAYMENT_INFO,
  SKAN_ADD_PAYMENT_INFO_RATE,
  SKAN_TOTAL_ADD_PAYMENT_INFO,
  SKAN_COST_TOTAL_ADD_PAYMENT_INFO,
  SKAN_ADD_TO_WISHLIST,
  SKAN_COST_PER_ADD_TO_WISHLIST,
  SKAN_ADD_TO_WISHLIST_RATE,
  SKAN_TOTAL_ADD_TO_WISHLIST,
  SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST,
  SKAN_TOTAL_ADD_TO_WISHLIST_VALUE,
  SKAN_LAUNCH_APP,
  SKAN_COST_PER_LAUNCH_APP,
  SKAN_LAUNCH_APP_RATE,
  SKAN_TOTAL_LAUNCH_APP,
  SKAN_COST_PER_TOTAL_LAUNCH_APP,
  SKAN_COMPLETE_TUTORIAL,
  SKAN_COST_PER_COMPLETE_TUTORIAL,
  SKAN_COMPLETE_TUTORIAL_RATE,
  SKAN_TOTAL_COMPLETE_TUTORIAL,
  SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL,
  SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE,
  SKAN_CREATE_GROUP,
  SKAN_COST_PER_CREATE_GROUP,
  SKAN_CREATE_GROUP_RATE,
  SKAN_TOTAL_CREATE_GROUP,
  SKAN_COST_PER_TOTAL_CREATE_GROUP,
  SKAN_TOTAL_CREATE_GROUP_VALUE,
  SKAN_JOIN_GROUP,
  SKAN_COST_PER_JOIN_GROUP,
  SKAN_JOIN_GROUP_RATE,
  SKAN_TOTAL_JOIN_GROUP,
  SKAN_COST_PER_TOTAL_JOIN_GROUP,
  SKAN_TOTAL_JOIN_GROUP_VALUE,
  SKAN_CREATE_GAMEROLE,
  SKAN_COST_PER_CREATE_GAMEROLE,
  SKAN_CREATE_GAMEROLE_RATE,
  SKAN_TOTAL_CREATE_GAMEROLE,
  SKAN_COST_PER_TOTAL_CREATE_GAMEROLE,
  SKAN_TOTAL_CREATE_GAMEROLE_VALUE,
  SKAN_SPEND_CREDITS,
  SKAN_COST_PER_SPEND_CREDITS,
  SKAN_SPEND_CREDITS_RATE,
  SKAN_TOTAL_SPEND_CREDITS,
  SKAN_COST_PER_TOTAL_SPEND_CREDITS,
  SKAN_TOTAL_SPEND_CREDITS_VALUE,
  SKAN_ACHIEVE_LEVEL,
  SKAN_COST_PER_ACHIEVE_LEVEL,
  SKAN_ACHIEVE_LEVEL_RATE,
  SKAN_TOTAL_ACHIEVE_LEVEL,
  SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL,
  SKAN_TOTAL_ACHIEVE_LEVEL_VALUE,
  SKAN_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_UNLOCK_ACHIEVEMENT,
  SKAN_UNLOCK_ACHIEVEMENT_RATE,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SKAN_SALES_LEAD,
  SKAN_COST_PER_SALES_LEAD,
  SKAN_SALES_LEAD_RATE,
  SKAN_TOTAL_SALES_LEAD,
  SKAN_COST_PER_TOTAL_SALES_LEAD,
  SKAN_TOTAL_SALES_LEAD_VALUE,
  SKAN_IN_APP_AD_CLICK,
  SKAN_COST_PER_IN_APP_AD_CLICK,
  SKAN_IN_APP_AD_CLICK_RATE,
  SKAN_TOTAL_IN_APP_AD_CLICK,
  SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK,
  SKAN_TOTAL_IN_APP_AD_CLICK_VALUE,
  SKAN_IN_APP_AD_IMPR,
  SKAN_COST_PER_IN_APP_AD_IMPR,
  SKAN_IN_APP_AD_IMPR_RATE,
  SKAN_TOTAL_IN_APP_AD_IMPR,
  SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR,
  SKAN_TOTAL_IN_APP_AD_IMPR_VALUE,
  SKAN_LOAN_APPLY,
  SKAN_COST_PER_LOAN_APPLY,
  SKAN_LOAN_APPLY_RATE,
  SKAN_TOTAL_LOAN_APPLY,
  SKAN_COST_PER_TOTAL_LOAN_APPLY,
  SKAN_LOAN_CREDIT,
  SKAN_COST_PER_LOAN_CREDIT,
  SKAN_LOAN_CREDIT_RATE,
  SKAN_TOTAL_LOAN_CREDIT,
  SKAN_COST_PER_TOTAL_LOAN_CREDIT,
  SKAN_LOAN_DISBURSEMENT,
  SKAN_COST_PER_LOAN_DISBURSEMENT,
  SKAN_LOAN_DISBURSEMENT_RATE,
  SKAN_TOTAL_LOAN_DISBURSEMENT,
  SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT,
  SKAN_LOGIN,
  SKAN_COST_PER_LOGIN,
  SKAN_LOGIN_RATE,
  SKAN_TOTAL_LOGIN,
  SKAN_COST_PER_TOTAL_LOGIN,
  SKAN_RATINGS,
  SKAN_COST_PER_RATINGS,
  SKAN_RATINGS_RATE,
  SKAN_TOTAL_RATINGS,
  SKAN_COST_PER_TOTAL_RATINGS,
  SKAN_TOTAL_RATINGS_VALUE,
  SKAN_SEARCH,
  SKAN_COST_PER_SEARCH,
  SKAN_SEARCH_RATE,
  SKAN_TOTAL_SEARCH,
  SKAN_COST_PER_TOTAL_SEARCH,
  SKAN_START_TRIAL,
  SKAN_COST_PER_START_TRIAL,
  SKAN_START_TRIAL_RATE,
  SKAN_TOTAL_START_TRIAL,
  SKAN_COST_PER_TOTAL_START_TRIAL,
  SKAN_SUBSCRIBE,
  SKAN_COST_PER_SUBSCRIBE,
  SKAN_SUBSCRIBE_RATE,
  SKAN_TOTAL_SUBSCRIBE,
  SKAN_COST_PER_TOTAL_SUBSCRIBE,
  SKAN_TOTAL_SUBSCRIBE_VALUE,
  SKAN_VTA_CONVERSION,
  SKAN_COST_PER_VTA_CONVERSION,
  SKAN_VTA_APP_INSTALL,
  SKAN_COST_PER_VTA_APP_INSTALL,
  SKAN_VTA_REGISTRATION,
  SKAN_COST_PER_VTA_REGISTRATION,
  SKAN_VTA_PURCHASE,
  SKAN_COST_PER_VTA_PURCHASE,
  SKAN_CTA_CONVERSION,
  SKAN_COST_PER_CTA_CONVERSION,
  SKAN_CTA_APP_INSTALL,
  SKAN_COST_PER_CTA_APP_INSTALL,
  SKAN_CTA_REGISTRATION,
  SKAN_COST_PER_CTA_REGISTRATION,
  SKAN_CTA_PURCHASE,
  SKAN_COST_PER_CTA_PURCHASE,
  REACH,
  FREQUENCY,
  CPM_METRICS,
  CPC_METRICS,
  METRICS_NOT_FOUND_MESSAGE,
  SEARCH_METRICS_PLACEHOLDER,
  CONFIGURE_METRICS,
  GENERAL_METRIC,
  PREVIOUS_PERIOD,
  LOADING_CONFIGURATION_METRICS,
  IN_CURRENCY,
  BID_GOAL_EXPLANATION,
  TARGET_CPA_EXPLANATION,
  OPTIMIZATION_GOAL_CONVERSATIONS,
  OPTIMIZATION_GOAL_VISIT_INSTAGRAM_PROFILE,
  OPTIMIZATION_GOAL_LINK_CLICKS,
  OPTIMIZATION_GOAL_THRUPLAY,
  OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS,
  OPTIMIZATION_GOAL_OPTION_REACH,
  OPTIMIZATION_GOAL_OPTION_THRUPLAY,
  OPTIMIZATION_GOAL_OPTION_LINK_CLICKS,
  OPTIMIZATION_GOAL_OPTION_LANDING_PAGE_VIEWS,
  OPTIMIZATION_GOAL_PLACEHOLDER,
  OPTIMIZATION_GOAL_POST_ENGAGEMENT,
  OPTIMIZATION_GOAL_OFFSITE_CONVERSIONS,
  OPTIMIZATION_GOAL_LEAD_GENERATION,
  OPTIMIZATION_GOAL_APP_INSTALLS,
  OPTIMIZATION_GOAL_CPM,
  OPTIMIZATION_GOAL_CLICK_TO_APP,
  OPTIMIZATION_GOAL_CONVERSION_IN_APP,
  PUBLISHING_ALERT_SUCCESS_TITLE,
  PUBLISHING_ALERT_ERROR_TITLE,
  PUBLISHING_ALERT_TITLE,
  PUBLISHING_ALERT_RETRY_BUTTON,
  HIDE_ALERTS,
  SHOW_ALERTS,
  ACTIVITY,
  NO_TASKS,
  NO_TASKS_DESCRIPTION,
  TITLES_META,
  GENERATING_CAMPAIGN,
  CAMPAIGN_GENERATED_SUCCESS,
  CAMPAIGN_GENERATED_ERROR,
  CAMPAIGN_GENERATED_ERROR_DESCRIPTION,
  TOTAL_ROAS_GOOGLE,
  TOTAL_ROAS_TIK_TOK,
  TOTAL_ROAS_META,
  ADS_CAMPAIGN_BUYING_TYPE_RESERVED,
  ADS_CAMPAIGN_BUYING_TYPE_AUCTION,
  BUYING_TYPE_PLACEHOLDER,
  CHANGE_BUYING_TYPE_TO_RESERVED_TITLE,
  CHANGE_BUYING_TYPE_TO_RESERVED_DESCRIPTION,
  ESTIMATED_AUDIENCE_SIZE,
  REACH_AT_TARGET_FREQUENCY,
  AUDIENCE_SIZE,
  POTENTIAL_REACH,
  ESTIMATED_DAILY_RESULTS,
  AUDIENCE_ESTIMATES,
  TIMES_EVERY,
  FREQUENCY_CAP_EXPLANATION,
  FREQUENCY_SPECS_CONTROL_PLACEHOLDER,
  FREQUENCY_SPECS_CAP_EXPLANATION,
  FREQUENCY_SPECS_CAP_DESCRIPTION,
  BUTTON_DISCARD,
  BUTTON_VIEW,
  SEARCH_SPECIFIC_LOCATION_PLACEHOLDER,
  SEARCH_SPECIFIC_LOCATION_EXAMPLE,
  CREATE_ADS_CAMPAIGN_APP_PROMOTION_QUESTION,
  ADS_CAMPAIGN_APP_PROMOTION_ANDROID,
  ADS_CAMPAIGN_APP_PROMOTION_IOS,
  ADS_CAMPAIGN_APP_PROMOTION_BOTH,
  SYNCING_INFORMATION_NO_EDIT_CLARIFICATION,
  WAIT_FOR_CAMPAIGN_SYNC,
  INSIGHT_DISCARDED,
  BUTTON_DISCARD_OPTIMIZATIONS_DESCRIPTION,
  BUTTON_GO_TO_BILLING,
  BRAND_GUIDELINES_ENABLED_CLARIFICATION,
  MODAL_BRAND_SETUP_TITLE,
  MODAL_BRAND_SETUP_DESCRIPTION,
  METRICS,
  BUTTON_WHY_THIS_RECOMMENDATION,
  ADS_CAMPAIGNS_LOGS_CONTEXT_TITLE,
  BUTTON_REVERT_CHANGE,
  REVERT_CHANGE_CONFIRM_TITLE,
  REVERT_CHANGE_CONFIRM_TEXT,
  REVERT_CHANGE_SUCCESS,
  REVERT_CHANGE_ERROR,
  ENGLISH_US,
  ENGLISH_UK,
  SPANISH_SPAIN,
  PORTUGUESE_BRAZIL,
  PORTUGUESE_PORTUGAL,
  FRENCH_FRANCE,
  FRENCH_CANADA,
  TRADITIONAL_CHINESE_HONG_KONG,
  TRADITIONAL_CHINESE_TAIWAN,
  JAPANESE_KANSAI,
  NORWEGIAN_BOKMAL,
  NORWEGIAN_NYNORSK,
  CATALAN,
  CZECH,
  WELSH,
  BASQUE,
  FINNISH,
  GALICIAN,
  HUNGARIAN,
  ITALIAN,
  DUTCH,
  FRISIAN,
  POLISH,
  ROMANIAN,
  SLOVENIAN,
  SWEDISH,
  FLEMISH,
  ESPERANTO,
  ESTONIAN,
  FAROESE,
  GREEK,
  ICELANDIC,
  IRISH,
  LATVIAN,
  LITHUANIAN,
  MACEDONIAN,
  THAI,
  VIETNAMESE,
  KHMER,
  FILIPINO,
  MALAY,
  GUJARATI,
  KANNADA,
  TAMIL,
  TELUGU,
  MALAYALAM,
  URDU,
  HEBREW,
  PERSIAN,
  NORTHERN_KURDISH_KURMANJI,
  ARMENIAN,
  AZERBAIJANI,
  BELARUSIAN,
  BOSNIAN,
  GEORGIAN,
  KAZAKH,
  MONGOLIAN,
  SERBIAN,
  TAJIK,
  UZBEK,
  AFRIKAANS,
  SWAHILI,
  ALBANIAN,
  CEBUANO,
  GUARANI,
  MARATHI,
  NEPALI,
  PASHTO,
  SINHALA,
  CHINESE,
  LANGUAGES_PLACEHOLDER,
  ASSAMESE,
  HARYANAVI,
  BIHARI,
  ORIYA,
  RAJASTHANI,
  NORWEGIAN,
  ALERT_CHANGE_ADVERTISER_TITLE,
  CHAT_QUESTION_1,
  CHAT_QUESTION_2,
  CHAT_QUESTION_3,
  CHAT_QUESTION_4,
  CHAT_QUESTION_5,
  CHAT_QUESTION_6,
  CHAT_QUESTION_7,
  CHAT_QUESTION_8,
  CHAT_QUESTION_9,
  TARGET,
  TARGET_FREQUENCY_EXPLANATION,
  CAP,
  CAP_FREQUENCY_EXPLANATION,
  FREQUENCY_TARGET_EXPLANATION,
  FIELD_ESTIMATION_ID_REQUIRED,
  RESERVATION_ESTIMATES,
  FIELD_ESTIMATION_BUDGET_REQUIRED,
  FIELD_ESTIMATION_START_END_DATE_REQUIRED,
  FIELD_ESTIMATION_FREQUENCY_REQUIRED,
  FIELD_ESTIMATION_LOCATION_REQUIRED,
  RESERVATION_STATUS_1,
  RESERVATION_STATUS_2,
  RESERVATION_STATUS_3,
  RESERVATION_STATUS_4,
  RESERVATION_STATUS_5,
  RESERVATION_STATUS_6,
  RESERVATION_STATUS_7,
  RESERVATION_STATUS_8,
  RESERVATION_STATUS_9,
  RESERVATION_STATUS_10,
  RESERVATION_STATUS_11,
  RESERVATION_STATUS_12,
  RESERVATION_STATUS_13,
  RESERVATION_STATUS_14,
  RESERVATION_STATUS_15,
  RESERVATION_STATUS_16,
  RESERVATION_STATUS_17,
  RESERVATION_STATUS_18,
  RESERVATION_STATUS_19,
  RESERVATION_STATUS_20,
  RESERVATION_STATUS_21,
  RESERVATION_STATUS_23,
  RESERVATION_STATUS_24,
  RESERVATION_STATUS_25,
  RESERVATION_STATUS_26,
  RESERVATION_STATUS_27,
  RESERVATION_STATUS_28,
  RESERVATION_STATUS_29,
  RESERVATION_STATUS_30,
  RESERVATION_STATUS_31,
  RESERVATION_STATUS_32,
  RESERVATION_STATUS_35,
  RESERVATION_STATUS_36,
  RESERVATION_STATUS_37,
  RESERVATION_STATUS_39,
  RESERVATION_STATUS_40,
  RESERVATION_STATUS_41,
  RESERVATION_STATUS_42,
  RESERVATION_STATUS_44,
  RESERVATION_STATUS_45,
  RESERVATION_STATUS_50,
  RESERVATION_STATUS_53,
  RESERVATION_STATUS_60,
  RESERVATION_STATUS_66,
  RESERVATION_STATUS_69,
  RESERVATION_STATUS_100,
  FREQUENCY_CONTROL_PLACEHOLDER,
  LOADING_LOCATIONS_IN_MAP,
  EXPORTING_LOCATIONS_TO_FORM,
  SUGGESTED_LOCATIONS_TITLE,
  LOADING_SUGGESTED_LOCATIONS,
  SUGGESTED_LOCATIONS_COUNT,
  ADD_ALL_LOCATIONS,
  ESTIMATED_DAILY_REACH,
  AVERAGE_AUDIENCE_SIZE,
  NO_ESTIMATION_AVAILABLE,
  CHAT_SUMMARY_OVERVIEW_TEXT,
  ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_STATISTICS,
  REPORT_DATE_GENERATED,
  REPORT_GENERATED_BY_BUZZLY_AI,
  AI_GENERATED_SECTION_CHIP,
  AI_GENERATED_SECTION_CHIP_ARIA,
  DOWNLOADING_PDF,
  PDF_DOWNLOADED_SUCCESSFULLY,
  OPTIMIZATION,
  BUTTON_DOWNLOAD_PDF,
  OVERVIEW_REPORT_GENERATING_SUMMARY,
  OVERVIEW_REPORT_SUMMARY_NOT_GENERATED,
  MONTH_SHORT,
  FILTER_BY_USERS_PLACEHOLDER,
  FILTER_BY_DATES_PLACEHOLDER,
  BUTTON_CLEAR_DATES,
  ALL_USERS,
  ALL_TIME,
  ERROR_CAMPAIGN_NOT_FOUND_TO_DUPLICATE,
  APPLY_OPTIMIZATIONS_WITH_NAME,
  BUTTON_OPTIMIZATION_APPLIED,
  MODAL_WELCOME_TITLE,
  MODAL_WELCOME_SUBTITLE,
  MODAL_WELCOME_PLAN_NAME,
  MODAL_WELCOME_BUTTON,
  VALUE_SUBSCRIPTION_3_DAYS_FREE,
  FIRST_USER_MESSAGE_BRAND_SETUP,
  CONNECTING_TO_PLATFORM,
  MODAL_CANCEL_SUBSCRIPTION_TITLE,
  MODAL_CANCEL_SUBSCRIPTION_SUBTITLE,
  MODAL_CANCEL_SUBSCRIPTION_SUBTITLE_WARNING,
  MODAL_CANCEL_SUBSCRIPTION_CONFIRM_BUTTON,
  MODAL_CANCEL_SUBSCRIPTION_REASON_TITLE,
  MODAL_CANCEL_SUBSCRIPTION_REASON_PLACEHOLDER,
  MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT,
  MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT_MIN_CHARS,
  MODAL_CANCEL_SUBSCRIPTION_WARNING_MESSAGE,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_LIMITED_OFFER,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_TITLE,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_INTRO,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_CAMPAIGNS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_GALLERY,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_DATA,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_API_CONNECTIONS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_INTRO,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DOWNLOAD_GALLERY,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_EXPORT_REPORTS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DUPLICATE_CAMPAIGNS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_NO_RECOVERY,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_CONFIRM_PROMPT,
  MODAL_CANCEL_SUBSCRIPTION_CONFIRM_WORD,
  BUTTON_KEEP_MY_ACCOUNT,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_INTRO,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_FROM_DATE,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_NO_DATE,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_IMMEDIATE_CREDITS,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_TAKE_OFFER_BUTTON,
  MODAL_CANCEL_SUBSCRIPTION_RETENTION_OFFER_REDEEMED_SUCCESS,
  BUTTON_CANCEL_PLAN_AND_DELETE_CAMPAIGNS,
  CANCELLATION_REASON_SELECT_LABEL,
  CANCELLATION_REASON_TOO_EXPENSIVE,
  CANCELLATION_REASON_NOT_FREQUENT_USE,
  CANCELLATION_REASON_BETTER_ALTERNATIVE,
  CANCELLATION_REASON_TECHNICAL_ISSUES,
  CANCELLATION_REASON_NOT_MEET_NEEDS,
  CANCELLATION_REASON_DIFFICULT_TO_USE,
  CANCELLATION_REASON_SITUATION_CHANGED,
  CANCELLATION_REASON_TEMPORARY_NEED,
  CANCELLATION_REASON_SECURITY_CONCERNS,
  CANCELLATION_REASON_OTHER,
  CREATE_ADS_CAMPAIGN_TARGET_CPA_QUESTION,
  BUTTON_NEW_CAMPAIGN,
  FILTERS_GALLERY_IMAGE,
  FILTERS_GALLERY_VIDEO,
  FILTERS_GALLERY_HORIZONTAL,
  FILTERS_GALLERY_VERTICAL,
  FILTERS_GALLERY_SQUARE,
  FILTERS_GALLERY_TODAY,
  FILTERS_GALLERY_WEEK,
  FILTERS_GALLERY_MONTH,
  FILTERS_GALLERY_YEAR,
  FILTERS_GALLERY_RESET_FILTERS,
  FILTERS_GALLERY_RESULTS_COUNTER,
  GALLERY_SOURCE_MY_CONTENT,
  GALLERY_SOURCE_GOOGLE,
  GALLERY_SOURCE_AD_ACCOUNT,
  GALLERY_SOURCE_AD_ACCOUNT_EMPTY,
  GALLERY_SOURCE_GOOGLE_DRIVE,
  GALLERY_SOURCE_SOCIAL_POSTS,
  GALLERY_SOCIAL_POSTS_DESCRIPTION,
  GALLERY_VIDEO_THUMBNAIL_FALLBACK_TOOLTIP,
  GALLERY_SELECT_SOURCE,
  GALLERY_ASSETS_TITLE,
  GALLERY_ASSETS_RENAME_TITLE,
  GALLERY_ASSETS_RENAME_SUCCESS,
  GALLERY_ASSETS_RENAME_ERROR,
  GALLERY_ASSETS_RENAME_ARIA_LABEL,
  GALLERY_ASSETS_NAME_LABEL,
  GALLERY_UPLOADING_ASSETS,
  GALLERY_GOOGLE_NOT_CONNECTED,
  GALLERY_META_NOT_CONNECTED,
  GALLERY_CONTENT_TYPE,
  GALLERY_DIMENSIONS,
  GALLERY_DATE_RANGE,
  GALLERY_TITLE_DIMENSIONS,
  FIELD_SEARCH_THEMES_MAX_WORDS,
  BUDGET_CAMPAIGN_DATES_PLACEHOLDER,
  CAROUSEL_IMAGES_MANAGER_TITLE,
  CAROUSEL_IMAGES_MANAGER_DELETE_ALL,
  CAROUSEL_IMAGES_MANAGER_NO_IMAGES,
  CAROUSEL_IMAGES_MANAGER_ADD_IMAGE,
  CAROUSEL_IMAGES_MANAGER_DIMENSIONS_HELP,
  FIELD_MUSIC_URL_REQUIRED_AD_PREVIEW,
  MAP_TRADUCCIONES_STATUS,
  MAP_TRADUCCIONES_PLATFORM,
  MAP_TRADUCCIONES_TITLES,
  MAP_TRADUCCIONES_CTA,
  MAP_TRADUCCIONES_CTAS,
  MAP_TRADUCCIONES_CTA_ID,
  MAP_TRADUCCIONES_CALL_TO_ACTION,
  MAP_TRADUCCIONES_CALL_TO_ACTIONS,
  MAP_TRADUCCIONES_CALL_TO_ACTION_ID,
  CAMPAIGN_SYNCING_STATUS,
  MAP_TRADUCCIONES_MEDIA_URLS,
  MAP_TRADUCCIONES_MEDIA_DATA,
  MAP_TRADUCCIONES_MUSIC_URL,
  MAP_TRADUCCIONES_IS_CAROUSEL,
  MAP_TRADUCCIONES_OBJECTIVE,
  MAP_TRADUCCIONES_INTEGRATION_ID,
  MAP_TRADUCCIONES_AD_ACCOUNT_ID,
  MAP_TRADUCCIONES_PAGE_ID,
  MAP_TRADUCCIONES_INSTAGRAM_ID,
  MAP_TRADUCCIONES_USE_CAMPAIGN_BUDGET,
  MAP_TRADUCCIONES_TYPE_BUDGET,
  MAP_TRADUCCIONES_BUDGET,
  MAP_TRADUCCIONES_IS_CATALOG_CAMPAIGN,
  MAP_TRADUCCIONES_WHATSAPP_BUSINESS_NUMBER,
  MAP_TRADUCCIONES_MESSAGE_TEMPLATE,
  MAP_TRADUCCIONES_INSTANT_FORM,
  MAP_TRADUCCIONES_TRACKING_ID,
  MAP_TRADUCCIONES_TRACKING_CUSTOM_EVENT_ID,
  MAP_TRADUCCIONES_CATALOG_ID,
  MAP_TRADUCCIONES_IS_IOS14_CAMPAIGN,
  MAP_TRADUCCIONES_APP_ID,
  MAP_TRADUCCIONES_BUYING_TYPE,
  MAP_TRADUCCIONES_DESCRIPTIONS,
  MAP_TRADUCCIONES_ADS,
  MAP_TRADUCCIONES_KEYWORDS,
  MAP_TRADUCCIONES_KEYWORDS_NEGATIVE,
  MAP_TRADUCCIONES_START_DATE,
  MAP_TRADUCCIONES_END_DATE,
  MAP_TRADUCCIONES_AGE_RANGE,
  MAP_TRADUCCIONES_GENDERS,
  MAP_TRADUCCIONES_LOCATIONS,
  MAP_TRADUCCIONES_INTERESTS,
  MAP_TRADUCCIONES_BEHAVIORS,
  MAP_TRADUCCIONES_CUSTOM_AUDIENCES,
  MAP_TRADUCCIONES_EXCLUDED_CUSTOM_AUDIENCES,
  MAP_TRADUCCIONES_BID_GOAL,
  MAP_TRADUCCIONES_OPTIMIZATION_GOAL,
  MAP_TRADUCCIONES_IDENTITY_TIKTOK_ID,
  MAP_TRADUCCIONES_TYPE,
  MAP_TRADUCCIONES_ID,
  MAP_TRADUCCIONES_DESTINATION_URL,
  MAP_TRADUCCIONES_BUSINESS_NAME,
  MAP_TRADUCCIONES_LOGO_URLS,
  MAP_TRADUCCIONES_IMAGE_URLS,
  MAP_TRADUCCIONES_VIDEO_URLS,
  MAP_TRADUCCIONES_LONG_HEADLINES,
  MAP_TRADUCCIONES_SEARCH_THEMES,
  MAP_STATUS_ACTIVE,
  MAP_STATUS_DEACTIVATED,
  BUTTON_OPTIMIZE_CAMPAIGN,
  BUTTON_OPTIMIZE_CAMPAIGN_MESSAGE,
  START_DATE_AND_END_DATE_VALIDATION,
  ADD_CHANGES,
  UPDATE_CHANGES,
  REMOVE_CHANGES,
  BUTTON_DISCONNECT_ACCOUNT,
  DISCONNECTED_ACCOUNT,
  CAMPAIGN_ALREADY_BEING_CREATED,
  CAMPAIGN_ALREADY_BEING_UPDATED,
  GALLERY_SOURCE_CANVA,
  IMAGE_TYPE_PORTRAIT_LABEL,
  IMAGE_TYPE_LANDSCAPE_LABEL,
  IMAGE_TYPE_SQUARE_LABEL,
  ALERT_SHARE_INSTAGRAM_ERROR,
  ALERT_SHARE_SUCCESS,
  ALERT_SHARE_SCHEDULED_SUCCESS,
  BUTTON_SHARE_MEDIA,
  BUTTON_SHARE_LOADING,
  BUTTON_SCHEDULE_MEDIA,
  BUTTON_SCHEDULING_MEDIA,
  BUTTON_PUBLISH_NOW,
  SCHEDULE_DATE_MIN_FUTURE_ERROR,
  SUGGESTED_PUBLISH_SCHEDULE_LOADING,
  DESCRIPTION_INSTAGRAM_LABEL,
  TYPE_CONTENT_INSTAGRAM_LABEL,
  INSTAGRAM_COLLABORATORS_LABEL,
  INSTAGRAM_COLLABORATORS_PLACEHOLDER,
  INSTAGRAM_COLLABORATORS_HELPER,
  IMAGE_NO_CONTENT_TO_SHOW,
  NO_SUPPORTED_FILE,
  MODAL_SHARE_TITLE,
  MODAL_SHARE_SELECT_PLATFORMS_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_CONTENT_TYPE_LABEL,
  VIDEO,
  IMAGE,
  MODAL_CANVA_IS_GETTING_YOUR_FINAL_DESIGN,
  MODAL_CREATE_WITH_IA_TITLE,
  MODAL_CREATE_WITH_IA_SUBTITLE,
  MODAL_CREATE_WITH_IA_GENERATED_CREATIVES,
  BUTTON_CREATE_WITH_IA,
  MODAL_CREATE_WITH_IA_ADD_URL,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_EMPTY,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_SUBTITLE,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_TOGGLE_ARIA,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_PREVIEW_ARIA,
  MODAL_CREATE_WITH_IA_EXTRACT_URL,
  MODAL_CREATE_WITH_IA_IMPORT_PHOTOS_URL_HINT,
  MODAL_CREATE_WITH_IA_DESCRIPTION,
  MODAL_CREATE_WITH_IA_UPLOAD_IMAGE,
  MODAL_CREATE_WITH_IA_EMPTY_STATE_TITLE,
  MODAL_CREATE_WITH_IA_EMPTY_STATE_SUBTITLE,
  MODAL_IMAGE_EDIT_EMPTY_STATE_TITLE,
  MODAL_IMAGE_EDIT_EMPTY_STATE_DESCRIPTION,
  MODAL_IMAGE_EDIT_TITLE,
  MODAL_IMAGE_EDIT_SUBTITLE,
  MODAL_IMAGE_EDIT_PROCESSING_MESSAGE,
  MODAL_IMAGE_EDIT_ERROR_CONVERT_BASE64,
  MODAL_IMAGE_EDIT_ERROR_EDITING,
  MODAL_IMAGE_EDIT_ERROR_PROCESSING,
  MODAL_IMAGE_EDIT_INPUT_PLACEHOLDER,
  MODAL_IMAGE_EDIT_EDITING_LABEL,
  MODAL_IMAGE_EDIT_LOADING_LABEL,
  MODAL_IMAGE_EDIT_IMAGE_NOT_FOUND,
  MODAL_IMAGE_EDIT_START_CREATING,
  MODAL_IMAGE_EDIT_IMAGE_ALT,
  MODAL_IMAGE_EDIT_VERSION_FORMAT,
  MODAL_IMAGE_EDIT_ORIGINAL_IMAGE_LABEL,
  MODAL_IMAGE_EDIT_EDITED_IMAGE_LABEL,
  MODAL_IMAGE_EDIT_SAVE_ALERT_TITLE,
  MODAL_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION,
  MODAL_IMAGE_EDIT_REPLACE_BUTTON,
  MODAL_VIDEO_EDITOR_TITLE,
  MODAL_VIDEO_EDITOR_EDIT_VIDEO,
  MODAL_VIDEO_EDITOR_ADD_VIDEO,
  MODAL_VIDEO_EDITOR_ADD_IMAGE,
  MODAL_VIDEO_EDITOR_ADD_AUDIO,
  MODAL_VIDEO_EDITOR_ADD_SUBTITLES,
  MODAL_VIDEO_EDITOR_EXPORTING,
  MODAL_VIDEO_EDITOR_SAVE_ERROR,
  MODAL_VIDEO_EDITOR_SPLIT_HINT,
  MODAL_VIDEO_EDITOR_ARIA_LABEL,
  MODAL_VIDEO_EDITOR_TRACK_VIDEO,
  MODAL_VIDEO_EDITOR_TRACK_IMAGE,
  MODAL_VIDEO_EDITOR_TRACK_AUDIO,
  MODAL_VIDEO_EDITOR_CLIP_DURATION,
  MODAL_VIDEO_EDITOR_SPLIT_CLIP,
  MODAL_VIDEO_EDITOR_CLIP_ACTIONS,
  MODAL_VIDEO_EDITOR_BRAND,
  MODAL_VIDEO_EDITOR_EMPTY_STAGE_TITLE,
  MODAL_VIDEO_EDITOR_EMPTY_STAGE_HINT,
  MODAL_VIDEO_EDITOR_DROP_HINT,
  MODAL_VIDEO_EDITOR_PLAY,
  MODAL_VIDEO_EDITOR_PAUSE,
  MODAL_VIDEO_EDITOR_DEFAULT_PROJECT_NAME,
  MODAL_VIDEO_EDITOR_TIMELINE_ARIA,
  MODAL_VIDEO_EDITOR_TIMELINE_RESIZE,
  MODAL_VIDEO_EDITOR_INSERT_START,
  MODAL_VIDEO_EDITOR_INSERT_END,
  MODAL_VIDEO_EDITOR_ANALYZING_SUBTITLES,
  MODAL_VIDEO_EDITOR_TRACK_SUBTITLE,
  MODAL_VIDEO_EDITOR_CAPTIONS_ARIA,
  MODAL_VIDEO_EDITOR_CAPTIONS_DISABLE,
  MODAL_VIDEO_EDITOR_CAPTIONS_ENABLE,
  MODAL_VIDEO_EDITOR_SAVE_ALERT_TITLE,
  MODAL_VIDEO_EDITOR_SAVE_ALERT_DESCRIPTION,
  MODAL_VIDEO_EDITOR_ANALYZE_SUBTITLES_ERROR,
  MODAL_VIDEO_EDITOR_PROPERTIES_TITLE,
  MODAL_VIDEO_EDITOR_PROPERTIES_EMPTY,
  MODAL_VIDEO_EDITOR_PROPERTIES_NAME,
  MODAL_VIDEO_EDITOR_PROPERTIES_VOLUME,
  MODAL_VIDEO_EDITOR_PROPERTIES_MIXED,
  MODAL_VIDEO_EDITOR_PROPERTIES_SELECTED_COUNT,
  MODAL_VIDEO_EDITOR_PROPERTIES_POSITION,
  MODAL_VIDEO_EDITOR_PROPERTIES_SIZE,
  MODAL_VIDEO_EDITOR_PROPERTIES_X,
  MODAL_VIDEO_EDITOR_PROPERTIES_Y,
  MODAL_VIDEO_EDITOR_PROPERTIES_WIDTH,
  MODAL_VIDEO_EDITOR_PROPERTIES_HEIGHT,
  MODAL_IMAGE_EDIT_SAVE_AS_NEW_BUTTON,
  MODAL_IMAGE_EDIT_WORK_MODE_LABEL,
  MODAL_IMAGE_EDIT_GENERATIVE_TITLE,
  MODAL_IMAGE_EDIT_GENERATIVE_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_BADGE_NEW,
  MODAL_IMAGE_EDIT_LAYERS_EMPTY_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_EMPTY_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_ERROR_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_ERROR_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_ADD,
  MODAL_IMAGE_EDIT_LAYERS_LIST_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_IMAGE,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_OBJECT,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_TEXT,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_LOGO,
  MODAL_IMAGE_EDIT_LAYERS_BACKGROUND,
  MODAL_IMAGE_EDIT_LAYERS_FALLBACK_NAME,
  MODAL_IMAGE_EDIT_LAYERS_ANALYZING,
  MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_TITLE,
  MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_DESCRIPTION,
  MODAL_IMAGE_EDIT_CLOSE_TITLE,
  MODAL_IMAGE_EDIT_CLOSE_DESCRIPTION,
  ANALYZE_LAYERS_EDIT_TEXT_TITLE,
  ANALYZE_LAYERS_EDIT_TEXT_DESCRIPTION,
  ANALYZE_LAYERS_EXTRACT_TEXT_ENABLE_BUTTON,
  ANALYZE_LAYERS_EXTRACT_TEXT_DISABLE_BUTTON,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_IMAGE,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO_BETA,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_CAROUSEL,
  MODAL_CREATE_WITH_IA_IMAGE_TYPE_REALISTA,
  MODAL_CREATE_WITH_IA_IMAGE_TYPE_PRODUCTO,
  MODAL_CREATE_WITH_IA_LANGUAGE_ES,
  MODAL_CREATE_WITH_IA_LANGUAGE_EN,
  MODAL_CREATE_WITH_IA_LANGUAGE_FR,
  MODAL_CREATE_WITH_IA_LANGUAGE_DE,
  MODAL_CREATE_WITH_IA_LANGUAGE_IT,
  MODAL_CREATE_WITH_IA_DIMENSION_SQUARE,
  MODAL_CREATE_WITH_IA_DIMENSION_HORIZONTAL,
  MODAL_CREATE_WITH_IA_DIMENSION_VERTICAL,
  MODAL_CREATE_WITH_IA_LABEL_MEDIA_TYPE,
  MODAL_CREATE_WITH_IA_LABEL_IMAGE_TYPE,
  MODAL_CREATE_WITH_IA_LABEL_LANGUAGE,
  MODAL_CREATE_WITH_IA_LABEL_ACCENT,
  MODAL_CREATE_WITH_IA_LABEL_LOCATION,
  MODAL_CREATE_WITH_IA_LABEL_DIMENSIONS,
  MODAL_CREATE_WITH_IA_LABEL_PLATFORM,
  MODAL_CREATE_WITH_IA_PLATFORM_DEFAULT,
  MODAL_CREATE_WITH_IA_LABEL_CAROUSEL,
  MODAL_CREATE_WITH_IA_LABEL_NUMBER_OF_IMAGES,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_NUMBER_OF_IMAGES,
  MODAL_CREATE_WITH_IA_PLATFORM_META,
  MODAL_CREATE_WITH_IA_PLATFORM_TIKTOK,
  MODAL_CREATE_WITH_IA_PLATFORM_GOOGLE,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION_VIDEO,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_IMAGE_URL,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_WEBSITE_URL,
  MODAL_CREATE_WITH_IA_WARNING_REFERENCE_IMAGE,
  MODAL_CREATE_WITH_IA_URLS_ADDED,
  MODAL_CREATE_WITH_IA_IMAGES_COUNT,
  MODAL_CREATE_WITH_IA_SERVICE_IMAGES_COUNT,
  MODAL_CREATE_WITH_IA_GENERATING,
  MODAL_CREATE_WITH_IA_GENERATE_WITH_AI,
  MODAL_CREATE_WITH_IA_IMAGES_CREATED,
  MODAL_CREATE_WITH_IA_GENERATING_IMAGES,
  MODAL_CREATE_WITH_IA_YOU_CAN_LEAVE_THE_PAGE,
  MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS,
  MODAL_CREATE_WITH_IA_GENERATION_FAILED,
  MODAL_CREATE_WITH_IA_MAX_CONCURRENT_GENERATIONS,
  MODAL_CREATE_WITH_IA_ERROR_LOADING_IMAGE,
  MODAL_CREATE_WITH_IA_GENERATED_IMAGE_ALT,
  MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY,
  MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY_NO_COUNT,
  MODAL_CREATE_WITH_IA_DOWNLOAD_ALL,
  MODAL_CREATE_WITH_IA_MORE_VARIATIONS,
  MODAL_CREATE_WITH_IA_ARIA_LABEL,
  MODAL_CREATE_WITH_IA_CONFIGURATION_BASIC,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_TITLE,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_STYLE_GUIDE_CHIP,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_LOCAL,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_SEARCH,
  MODAL_CREATE_WITH_IA_REFERENCE_IMAGE_ASSETS_CHIP,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_DESCRIPTION,
  MODAL_CREATE_WITH_IA_PHYSICAL_NO_REFERENCE_IMAGES_DESCRIPTION,
  MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_TITLE,
  MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_DESCRIPTION,
  MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_OPTIONAL_DESCRIPTION,
  MODAL_CREATE_WITH_IA_CONFIGURATION_INSTRUCTIONS,
  MODAL_CREATE_WITH_IA_CONFIGURATION_THEME,
  MODAL_CREATE_WITH_IA_CONFIGURATION_ADVANCED,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL_VIDEO,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_HELPER,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NONE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_WHATSAPP,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_IG_STORY,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_APOLOGY,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_NEWS,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_TEXT_POST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_COMMENT_THREAD,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_REVIEW_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_SEARCH_AUTOCOMPLETE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_CHECKLIST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_EMAIL_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_TEXT_POST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_COMMENT_THREAD,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_REVIEW_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_SEARCH_AUTOCOMPLETE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_CHECKLIST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_EMAIL_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_LOAD_ERROR,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO_ACTION,
  MODAL_CREATE_WITH_IA_GALLERY_BUTTON,
  MODAL_CREATE_WITH_IA_IMPORT_META_AD_LIBRARY,
  COMPETITOR_SCOPE_MENU_ITEM,
  COMPETITOR_SCOPE_MODAL_TITLE,
  ALERT_COMPETITOR_SCOPE_TITLE,
  ALERT_COMPETITOR_SCOPE_DESCRIPTION,
  ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_TITLE,
  ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_DESCRIPTION,
  BUTTON_CONFIGURE_BRAND,
  BUTTON_CONFIGURE_COMPETITORS,
  MODAL_COMPETITORS_CONFIRM_REFERENCE_TITLE,
  MODAL_COMPETITORS_CONFIRM_REFERENCE_DESCRIPTION,
  MODAL_COMPETITORS_PREPARING_REFERENCE,
  MODAL_COMPETITORS_SHOW_FAVORITES_ONLY,
  MODAL_COMPETITORS_SHOW_ALL_ADS,
  MODAL_COMPETITORS_FAVORITES_EMPTY,
  MODAL_COMPETITORS_SAVED_TO_FAVORITES,
  MODAL_COMPETITORS_SAVED_TO_FOLDER,
  MODAL_COMPETITORS_REMOVED_FROM_FOLDER,
  MODAL_COMPETITORS_SELECT_FOLDER_TITLE,
  MODAL_COMPETITORS_CHANGE_LOCATION,
  MODAL_COMPETITORS_REMOVED_FROM_FAVORITES,
  MODAL_COMPETITORS_ADD_OPTION,
  MODAL_COMPETITORS_EDIT_BUTTON,
  MODAL_COMPETITORS_EDIT_TITLE,
  MODAL_COMPETITORS_EDIT_SUBTITLE,
  MODAL_COMPETITORS_EDIT_COUNT_ARIA,
  MODAL_COMPETITORS_STRONG_SIGNAL,
  MODAL_COMPETITORS_AD_LIBRARY_CTA_LABEL,
  MODAL_CREATE_WITH_IA_META_AD_LIBRARY_LOADING,
  MODAL_GALLERY_META_AD_LIBRARY_EMPTY_CONTENT,
  MODAL_META_AD_LIBRARY_COMPETITOR_FILTER_LABEL,
  MODAL_META_AD_LIBRARY_COMPETITOR_ALL,
  MODAL_META_AD_LIBRARY_PLATFORM_ALL,
  MODAL_META_AD_LIBRARY_DURATION_HOURS,
  MODAL_META_AD_LIBRARY_DURATION_DAYS,
  MODAL_META_AD_LIBRARY_VIEW_ONLY_TOOLTIP,
  MODAL_META_AD_LIBRARY_LOADING_RESOLVING_COMPETITORS,
  MODAL_META_AD_LIBRARY_LOADING_FETCHING_ADS,
  MODAL_META_AD_LIBRARY_LOADING_PREPARING_GALLERY,
  MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TITLE,
  MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TEXT,
  MODAL_CREATE_WITH_IA_SAVING_TO_GALLERY,
  MODAL_CREATE_WITH_IA_SAVED_SUCCESSFULLY,
  MODAL_CREATE_WITH_IA_MAX_IMAGES_MESSAGE,
  BUSINESS_LOOK_AND_FEEL_PLACEHOLDER,
  BUSINESS_OFFERING_PLACEHOLDER,
  BUSINESS_OFFERING_PHYSICAL_PRODUCT_PLACEHOLDER,
  BUSINESS_OFFERING_SERVICES_PLACEHOLDER,
  DESCRIPTION_INSTAGRAM_GENERATING,
  MODAL_FILTERS_LABEL,
  FIELD_CONSECUTIVE_UPPERCASE,
  FIELD_EMOJI_NOT_ALLOWED,
  ADS_CAMPAIGNS_TITLE_DASHBOARD,
  OVERVIEW_HOME_STATISTICS,
  KPI_TARGET_CPA_ABOVE_PLATFORM,
  KPI_TARGET_CPA_ALERTS_TITLE,
  OVERVIEW_HOME_STATISTICS_VIEW_MORE,
  STATISTICS_ONLY_BUZZLY_CAMPAIGNS,
  VIEW_SPEND_BREAKDOWN,
  LIST_TABLE_CAMPAIGNS_TITLE,
  DASHBOARD_METRICS_DELAY_WARNING,
  TRIAL_CONTENT_CTA_MESSAGE,
  TRIAL_CONTENT_CTA_BUTTON_SHARE_INSTAGRAM,
  TRIAL_CONTENT_CTA_BUTTON_SHARE_TIKTOK,
  TRIAL_CONTENT_CTA_BUTTON_MORE_OPTIONS,
  CAMPAIGNS,
  GALLERY_TITLE,
  BUTTON_SELECT_ALL,
  BUTTON_DESELECT_ALL,
  AVERAGE_CTR,
  TRACKING_OFFLINE_EVENTS_PLACEHOLDER,
  ALERT_CAMPAIGN_CPA_HIGH_LABEL,
  ALERT_CAMPAIGN_STARTED_LABEL,
  ALERT_PIXEL_NOT_FIRED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_LABEL,
  ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_GENERATE_CREATIVES,
  BUTTON_CREATE_CONTENT,
  MODAL_REDIRECT_BRAND_SETUP_TITLE,
  MODAL_REDIRECT_BRAND_SETUP_SUBTITLE,
  MODAL_REDIRECT_BRAND_SETUP_BUTTON,
  MODAL_SUCCESS_BRAND_SETUP_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_SUBTITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_DESCRIPTION,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_DESCRIPTION,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_POST_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_CALENDAR_DESCRIPTION,
  MODAL_SUCCESS_BRAND_SETUP_BUTTON_START,
  MODAL_SUCCESS_BRAND_SETUP_BUTTON_LATER,
  ONBOARDING_CHECKLIST_HEADER_TITLE,
  ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_TITLE,
  ONBOARDING_CHECKLIST_ITEM_CREATIVES_TITLE,
  ONBOARDING_CHECKLIST_ITEM_PUBLISH_TITLE,
  ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_TITLE,
  ONBOARDING_CHECKLIST_FOOTER_COMPLETED,
  ONBOARDING_CHECKLIST_SUBTITLE,
  ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_CREATIVES_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_PUBLISH_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_DESCRIPTION,
  ONBOARDING_CHECKLIST_PROGRESS_COMPLETED,
  ONBOARDING_CHECKLIST_SKIP_GUIDE,
  ADS_SUBSCRIPTION_BENEFIT_CREATIVES,
  ADS_SUBSCRIPTION_BENEFIT_VIDEOS,
  ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_MONTH,
  ADS_SUBSCRIPTION_BENEFIT_VIDEOS_AI,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_UP_TO,
  ADS_SUBSCRIPTION_BENEFIT_USERS_UP_TO,
  ADS_SUBSCRIPTION_BENEFIT_USER,
  ADS_SUBSCRIPTION_BENEFIT_UNLIMITED_SOCIAL_POSTS,
  ADS_SUBSCRIPTION_BENEFIT_SUPPORT_CHAT_AND_EMAIL,
  ADS_SUBSCRIPTION_BENEFIT_WHITE_LABEL_OPTIONAL,
  ADS_SUBSCRIPTION_BENEFIT_CREATIVES_CUSTOM,
  TEXT_IN_IMAGE,
  LOGO_IN_IMAGE,
  LOGO_IN_VIDEO,
  LOGO_IN_VIDEO_DESCRIPTION_LEAD,
  FIELD_MAX_LENGTH_SHORT,
  COLUMN_NAME_ENTITY,
  UNKNOWN_VALUE,
  ADS_SUBSCRIPTION_BENEFIT_CAMPAIGN,
  I_DONT_HAVE_A_WEBSITE,
  SET_UP_BRAND,
  CHAT_BOT_WELCOME_DESCRIPTION,
  CARD_GENERATE_COPY,
  CARD_GENERATE_COPY_DESCRIPTION,
  CARD_GENERATE_COPY_QUESTION,
  CARD_GET_CAMPAIGN_LEARNINGS,
  CARD_GET_CAMPAIGN_LEARNINGS_DESCRIPTION,
  CARD_GET_CAMPAIGN_LEARNINGS_QUESTION,
  CARD_OPTIMIZE_GENERAL,
  CARD_OPTIMIZE_GENERAL_DESCRIPTION,
  CARD_OPTIMIZE_GENERAL_QUESTION,
  CARD_MANAGE_BUDGET,
  CARD_MANAGE_BUDGET_DESCRIPTION,
  CARD_MANAGE_BUDGET_QUESTION,
  CARD_OWNER_CLIENT_HEALTH,
  CARD_OWNER_CLIENT_HEALTH_DESCRIPTION,
  CARD_OWNER_CLIENT_HEALTH_QUESTION,
  CARD_OWNER_INSIGHTS,
  CARD_OWNER_INSIGHTS_DESCRIPTION,
  CARD_OWNER_INSIGHTS_QUESTION,
  CARD_OWNER_ACCOUNTS,
  CARD_OWNER_ACCOUNTS_DESCRIPTION,
  CARD_OWNER_ACCOUNTS_QUESTION,
  CARD_OWNER_BILLING,
  CARD_OWNER_BILLING_DESCRIPTION,
  CARD_OWNER_BILLING_QUESTION,
  CARD_OWNER_SUPPORT,
  CARD_OWNER_SUPPORT_DESCRIPTION,
  CARD_OWNER_SUPPORT_QUESTION,
  CARD_OWNER_CLIENTS_ACCOUNTS,
  CARD_OWNER_CLIENTS_ACCOUNTS_DESCRIPTION,
  CARD_OWNER_CLIENTS_ACCOUNTS_QUESTION,
  CARD_OWNER_BRANDS,
  CARD_OWNER_BRANDS_DESCRIPTION,
  CARD_OWNER_BRANDS_QUESTION,
  CARD_OWNER_PLANS_MRR,
  CARD_OWNER_PLANS_MRR_DESCRIPTION,
  CARD_OWNER_PLANS_MRR_QUESTION,
  DATE_RANGE_PRESET_TODAY,
  DATE_RANGE_PRESET_YESTERDAY,
  DATE_RANGE_PRESET_LAST_7,
  DATE_RANGE_PRESET_LAST_14,
  DATE_RANGE_PRESET_LAST_30,
  DATE_RANGE_PRESET_THIS_WEEK,
  DATE_RANGE_PRESET_LAST_WEEK,
  DATE_RANGE_PRESET_THIS_MONTH,
  DATE_RANGE_PRESET_LAST_MONTH,
  DATE_RANGE_PRESET_THIS_YEAR,
  DATE_RANGE_PRESET_LAST_YEAR,
  PRESETS_DATE_PLACEHOLDER,
  LOOK_AND_FEEL_PLACEHOLDER,
  MODAL_INTEGRATION_NOT_FOUND_TITLE,
  MODAL_INTEGRATION_NOT_FOUND_DESCRIPTION,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_PLATFORM,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_CAMPAIGN,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_AD_ACCOUNT,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_REASON,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_INTEGRATION,
  MODAL_INTEGRATION_NOT_FOUND_ROW_DISABLED,
  MODAL_INTEGRATION_NOT_FOUND_ROW_LOADING,
  MODAL_INTEGRATION_NOT_FOUND_ROW_ERROR,
  MODAL_INTEGRATION_NOT_FOUND_SELECT_PLACEHOLDER,
  MODAL_INTEGRATION_NOT_FOUND_SAVE,
  DATE_RANGE_PRESET_CUSTOM,
  NPS_FORM_TITLE,
  NPS_LABEL_NOT_LIKELY_AT_ALL,
  NPS_LABEL_EXTREMELY_LIKELY,
  NPS_SAVING_RATING,
  NPS_THANK_YOU_TITLE,
  NPS_THANK_YOU_DESCRIPTION,
  OVERLAPS_WITH,
  MODAL_OVERLAP_CONFLICTS_TITLE,
  MODAL_OVERLAP_CONFLICTS_DESCRIPTION,
  BUTTON_PREVIEW_CHANGES,
  BUTTON_APPLY_CHANGES,
  BUTTON_CHANGES_APPLIED,
  ALERT_ARCHIVE_CAMPAIGN_TITLE_ACTIVE,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISER,
  TOTAL_ADVERTISERS_COUNT,
  TOTAL_ADVERTISER_COUNT,
  CONFIGURATION_PANEL_TITLE_IMAGE_PHYSICAL_PRODUCT,
  CONFIGURATION_PANEL_SUBTITLE_IMAGE_PHYSICAL_PRODUCT,
  CONFIGURATION_PANEL_ADD_MULTIPLE_PERSPECTIVES_TIP,
  CONFIGURATION_PANEL_WEBSITE_URL_TITLE,
  CONFIGURATION_PANEL_WEBSITE_URL_DESCRIPTION,
  FORMAT_OPTIONS_TOOLTIP,
  EDIT_WITH_CANVA,
  EDIT_WITH_IA,
  ANIMATE_IMAGE_WITH_AI,
  ANIMATE_IMAGE_CONFIRMATION_TITLE,
  ANIMATE_IMAGE_CONFIRMATION_DESCRIPTION,
  MODAL_ANIMATE_IMAGE_PREVIEW_TITLE,
  MODAL_ANIMATE_IMAGE_PROMPT_LABEL,
  MODAL_ANIMATE_IMAGE_PROMPT_PLACEHOLDER,
  MODAL_ANIMATE_IMAGE_PROMPT_HELPER,
  MODAL_ANIMATE_IMAGE_PROMPT_MAX_LENGTH,
  ANIMATE_IMAGE_OUTRO_LABEL,
  ANIMATE_IMAGE_OUTRO_HELPER,
  ANIMATE_IMAGE_OUTRO_NONE,
  ANIMATE_IMAGE_SAVE_OUTRO,
  ANIMATE_IMAGE_SAVE_OUTRO_TITLE,
  ANIMATE_IMAGE_SAVE_OUTRO_SUCCESS,
  ANIMATE_IMAGE_SAVE_OUTRO_ERROR,
  ANIMATE_IMAGE_OUTRO_FILE,
  ANIMATE_IMAGE_OUTRO_FILE_HINT,
  ANIMATE_IMAGE_IMPORT_OUTRO,
  ANIMATE_IMAGE_IMPORT_OUTRO_TITLE,
  ANIMATE_IMAGE_IMPORT_OUTRO_EMPTY,
  ANIMATE_IMAGE_IMPORT_OUTRO_ERROR,
  ANIMATE_IMAGE_DELETE_OUTRO,
  ANIMATE_IMAGE_DELETE_OUTRO_ERROR,
  ANIMATE_IMAGE_OUTRO_CLEAR,
  ANIMATE_IMAGE_OUTRO_TOO_LARGE,
  ANIMATE_IMAGE_OUTRO_TOO_LONG,
  ANIMATE_IMAGE_OUTRO_INVALID_TYPE,
  ANIMATE_IMAGE_USE_SELECTED,
  SELECT_CONTENT_CONFIRMATION_TEXT,
  RESIZE_TO_HORIZONTAL,
  RESIZE_TO_VERTICAL,
  RESIZE_TO_SQUARE,
  RESIZE_TO_FEED,
  RESIZE_MENU_LABEL,
  RESIZING_IMAGES_BATCH_MESSAGE,
  MULTI_FORMAT_RESIZE_FORMATS_COUNT,
  MULTI_FORMAT_RESIZE_CREDITS_COUNT,
  MULTI_FORMAT_RESIZE_ONE_FORMAT,
  MULTI_FORMAT_RESIZE_ONE_CREDIT,
  HORIZONTAL_FORMAT,
  ALERT_RESIZE_IMAGE_FAILED_DESCRIPTION,
  CAMPAIGNS_STATUS_DELETED,
  PAGE_NUMBER,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE_UPDATE,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION_UPDATE,
  MAX_TOTAL_BUDGET_PLACEHOLDER,
  MIN_TOTAL_BUDGET_PLACEHOLDER,
  MAX_DAILY_BUDGET_PLACEHOLDER,
  MIN_DAILY_BUDGET_PLACEHOLDER,
  TABLE_ADMIN_DASHBOARD_CLIENT,
  TABLE_ADMIN_DASHBOARD_RENEW_DATE,
  TABLE_ADMIN_DASHBOARD_RENEW_DATE_VALUE,
  TABLE_ADMIN_DASHBOARD_DISCOVERY_SOURCE,
  TABLE_ADMIN_DASHBOARD_HEALTH_SCORE,
  TABLE_ADMIN_DASHBOARD_CAMPAIGNS,
  TABLE_ADMIN_DASHBOARD_KPI,
  TABLE_ADMIN_DASHBOARD_SPEND,
  TABLE_ADMIN_DASHBOARD_CPA,
  TABLE_ADMIN_DASHBOARD_TARGET_CPA,
  TABLE_ADMIN_DASHBOARD_ROAS,
  TABLE_ADMIN_DASHBOARD_LAST_LOGIN,
  TABLE_ADMIN_DASHBOARD_LOGINS,
  TABLE_ADMIN_DASHBOARD_USERS,
  TABLE_ADMIN_DASHBOARD_AUTOMATION,
  TABLE_ADMIN_DASHBOARD_MRR,
  TABLE_ADMIN_DASHBOARD_PLAN,
  TABLE_ADMIN_DASHBOARD_CREATIVES,
  TABLE_ADMIN_DASHBOARD_INVOICE_OVERDUE,
  TABLE_ADMIN_DASHBOARD_SHOWING_CLIENTS,
  TABLE_ADMIN_DASHBOARD_LOADING_MORE,
  TABLE_ADMIN_CREATIVES_UTILIZED,
  TABLE_ADMIN_CREATIVE_UTILIZED,
  TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE,
  TABLE_ADMIN_LAST_LOGIN_DAYS,
  TABLE_ADMIN_DASHBOARD_NPS,
  TABLE_ADMIN_CANCELLATION_REASON_SUBTITLE,
  TABLE_ADMIN_CANCELLATION_REASON_BUTTON,
  TABLE_ADMIN_CANCELLED_BADGE,
  TABLE_ADMIN_ADD_ADVERTISER_BUTTON,
  TABLE_ADMIN_ADD_CREDITS_BUTTON,
  TABLE_ADMIN_ACTIONS_BUTTON,
  TABLE_ADMIN_ACTIVATE_PLAN_BUTTON,
  TABLE_ADMIN_DEACTIVATE_PLAN_BUTTON,
  TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_TITLE,
  TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_MESSAGE,
  TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_TITLE,
  TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_MESSAGE,
  TABLE_ADMIN_MARK_DEMO_BUTTON,
  TABLE_ADMIN_CONFIRM_MARK_DEMO_TITLE,
  TABLE_ADMIN_CONFIRM_MARK_DEMO_MESSAGE,
  TABLE_ADMIN_CREDITS_USAGE,
  TABLE_ADMIN_PENDING_PAYMENT_BADGE,
  TABLE_ADMIN_PRIORITY_BADGE,
  TABLE_ADMIN_SEND_EMAIL_BODY_LABEL,
  TABLE_ADMIN_SEND_EMAIL_BUTTON,
  TABLE_ADMIN_LOGIN_AS_CLIENT_BUTTON,
  OWNER_LOGIN_AS_USER_OPTION,
  OWNER_LOGIN_AS_USER_OPTION_EMAIL,
  OWNER_LOGIN_AS_CONNECTING,
  OWNER_LOGIN_AS_ERROR_TITLE,
  OWNER_LOGIN_AS_ERROR_EXPIRED,
  OWNER_LOGIN_AS_ERROR_INVALID,
  OWNER_LOGIN_AS_ERROR_MISSING_PARAMS,
  OWNER_LOGIN_AS_ERROR_GENERIC,
  OWNER_LOGIN_AS_ERROR_USER_NOT_FOUND,
  OWNER_LOGIN_AS_ERROR_INVALID_EMAIL,
  OWNER_LOGIN_AS_ERROR_FORBIDDEN,
  OWNER_LOGIN_AS_ERROR_UNAUTHORIZED,
  SUPPORT_SESSION_BANNER_TITLE,
  SUPPORT_SESSION_BANNER_DESCRIPTION,
  SUPPORT_SESSION_ENDED_TITLE,
  SUPPORT_SESSION_ENDED_DESCRIPTION,
  TABLE_ADMIN_SEND_EMAIL_MODAL_TITLE,
  TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_LABEL,
  TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_PLACEHOLDER,
  TABLE_ADMIN_SEND_EMAIL_SELECT_ALL,
  TABLE_ADMIN_SEND_EMAIL_SEND_BUTTON,
  TABLE_ADMIN_SEND_EMAIL_SUBJECT_LABEL,
  TABLE_ADMIN_SEND_EMAIL_SUCCESS,
  TABLE_ADMIN_MODIFY_KPI_CPA_BUTTON,
  TABLE_ADMIN_ENABLE_FEATURES_BUTTON,
  TABLE_ADMIN_FEATURE_TYPOGRAPHIC_FIDELITY,
  TABLE_ADMIN_FEATURE_MINIMUM_TERM_CONTRACT,
  TABLE_ADMIN_AI_IMAGE_MODEL_BUTTON,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_GOOGLE,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_OPENAI,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_SEEDREAM,
  MODAL_MODIFY_KPI_CPA_TITLE,
  MODAL_MODIFY_KPI_CPA_PRIMARY_LABEL,
  MODAL_MODIFY_KPI_CPA_TARGET_LABEL,
  MODAL_MODIFY_KPI_CPA_CURRENCY_LABEL,
  MODAL_MODIFY_KPI_CPA_SAVE_SUCCESS,
  MODAL_MODIFY_KPI_CPA_VOLUMEN_LABEL,
  MODAL_CAMPAIGN_KPI_CPA_TITLE,
  MODAL_CAMPAIGN_KPI_CPA_INHERIT_HINT,
  MODAL_CAMPAIGN_KPI_CPA_WEEKLY_VOLUME_LABEL,
  ADMIN_KPI_PRIMARY_LEADS,
  ADMIN_KPI_PRIMARY_SALES,
  ADMIN_KPI_PRIMARY_MESSAGES,
  ADMIN_KPI_PRIMARY_INTERACTIONS,
  ADMIN_KPI_PRIMARY_TRAFFIC,
  ADMIN_KPI_PRIMARY_CONVERSIONS,
  ADMIN_KPI_PRIMARY_DOWNLOADS,
  ADMIN_KPI_PRIMARY_APP_INSTALLS,
  ADMIN_KPI_PRIMARY_VIDEO_VIEWS,
  ADMIN_KPI_PRIMARY_AWARENESS,
  ADMIN_KPI_PRIMARY_REACH,
  ADMIN_KPI_PRIMARY_ENGAGEMENT,
  ADMIN_KPI_PRIMARY_STORE_VISITS,
  ADMIN_KPI_PRIMARY_WEBSITE_CONVERSIONS,
  ADMIN_KPI_PRIMARY_CATALOG_SALES,
  ADMIN_KPI_PRIMARY_SIGNUPS,
  ADMIN_DASHBOARD_TITLE,
  OWNER_DASHBOARD_NAV_FORM,
  OWNER_DASHBOARD_NAV_REPORTED_CONTENT,
  OWNER_DASHBOARD_NAV_PROMOTIONAL_CODES,
  OWNER_DASHBOARD_NAV_GLOBAL_NOTIFICATIONS,
  OWNER_DASHBOARD_NAV_AD_SPEND,
  OWNER_AD_SPEND_TITLE,
  OWNER_AD_SPEND_DESCRIPTION,
  OWNER_AD_SPEND_PRESET_HISTORIC,
  OWNER_AD_SPEND_PRESET_LAST_7,
  OWNER_AD_SPEND_PRESET_LAST_30,
  OWNER_AD_SPEND_PRESET_LAST_90,
  OWNER_AD_SPEND_PRESET_THIS_MONTH,
  OWNER_AD_SPEND_PRESET_LAST_MONTH,
  OWNER_AD_SPEND_PRESET_CUSTOM,
  OWNER_AD_SPEND_CUSTOM_PENDING,
  OWNER_AD_SPEND_ACCURACY_WARNING,
  OWNER_AD_SPEND_ACCURACY_WARNING_ESTIMATED,
  OWNER_AD_SPEND_KPI_TOTAL,
  OWNER_AD_SPEND_KPI_ADVERTISERS,
  OWNER_AD_SPEND_KPI_COUNTRIES,
  OWNER_AD_SPEND_VS_PREVIOUS_PERIOD,
  OWNER_AD_SPEND_CHART_TITLE,
  OWNER_AD_SPEND_CHART_DAILY,
  OWNER_AD_SPEND_CHART_MONTHLY,
  OWNER_AD_SPEND_PLATFORMS_TITLE,
  OWNER_AD_SPEND_TOP_ADVERTISERS_TITLE,
  OWNER_AD_SPEND_TOP_COUNTRIES_TITLE,
  OWNER_AD_SPEND_TOP_ADVERTISERS_ARIA,
  OWNER_AD_SPEND_TOP_COUNTRIES_ARIA,
  OWNER_AD_SPEND_COLUMN_ADVERTISER,
  OWNER_AD_SPEND_COLUMN_COUNTRY,
  OWNER_AD_SPEND_COLUMN_SPEND,
  OWNER_AD_SPEND_COLUMN_SHARE,
  OWNER_AD_SPEND_COLUMN_PLATFORMS,
  OWNER_AD_SPEND_UNASSIGNED_COUNTRY,
  OWNER_AD_SPEND_TREND_NEW,
  OWNER_AD_SPEND_ESTIMATED_BADGE,
  OWNER_AD_SPEND_EMPTY_TITLE,
  OWNER_AD_SPEND_EMPTY_DESCRIPTION,
  OWNER_AD_SPEND_MOCK_BADGE,
  OWNER_DASHBOARD_NAV_CREATE_USER,
  OWNER_DASHBOARD_NAV_OPTIONS,
  OWNER_GLOBAL_NOTIFICATIONS_TITLE,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_TITLE,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_BODY,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_CTA,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK_HELPER,
  OWNER_GLOBAL_NOTIFICATIONS_CTA_LINK_PAIR_ERROR,
  OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_BUTTON,
  OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_SUCCESS,
  MODAL_CREATE_OWNER_USER_ARIA_LABEL,
  MODAL_CREATE_OWNER_USER_TITLE,
  MODAL_CREATE_OWNER_USER_DESCRIPTION,
  MODAL_CREATE_OWNER_USER_SUCCESS,
  REGISTER_PROMOTIONAL_CODE_LABEL,
  REGISTER_PROMOTIONAL_CODE_PLACEHOLDER,
  REGISTER_DISCOVERY_SOURCE_LABEL,
  OWNER_PROMOTIONAL_CODES_CREATE_TITLE,
  OWNER_PROMOTIONAL_CODES_CREATE_BUTTON,
  OWNER_PROMOTIONAL_CODES_MODAL_SUBTITLE,
  OWNER_PROMOTIONAL_CODES_GENERATE_CODE_TOOLTIP,
  OWNER_PROMOTIONAL_CODES_FIELD_CODE,
  OWNER_PROMOTIONAL_CODES_FIELD_MAX_REDEMPTIONS,
  OWNER_PROMOTIONAL_CODES_FIELD_APP_SUMO,
  OWNER_PROMOTIONAL_CODES_FIELD_TIER,
  OWNER_PROMOTIONAL_CODES_TIER_OPTION_1,
  OWNER_PROMOTIONAL_CODES_TIER_OPTION_2,
  OWNER_PROMOTIONAL_CODES_TIER_OPTION_3,
  OWNER_PROMOTIONAL_CODES_COLUMN_CODE,
  OWNER_PROMOTIONAL_CODES_COLUMN_CREATED,
  OWNER_PROMOTIONAL_CODES_COLUMN_REGISTERED,
  OWNER_PROMOTIONAL_CODES_COLUMN_MAX_REDEMPTIONS,
  OWNER_PROMOTIONAL_CODES_COLUMN_TYPE,
  OWNER_PROMOTIONAL_CODES_TYPE_VALUE_APP_SUMO,
  OWNER_PROMOTIONAL_CODES_TYPE_APP_SUMO_TIER_SUFFIX,
  OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STANDARD,
  OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STRIPE_DISCOUNT,
  OWNER_PROMOTIONAL_CODES_FIELD_STRIPE_CODE,
  OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT,
  OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT_TYPE,
  OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_FIXED,
  OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_PERCENTAGE,
  OWNER_PROMOTIONAL_CODES_ERROR_INVALID_STRIPE_DISCOUNT,
  PRICING_PROMO_DISCOUNT_APPLIED,
  OWNER_PROMOTIONAL_CODES_COLUMN_STATUS,
  OWNER_PROMOTIONAL_CODES_STATUS_ACTIVE,
  OWNER_PROMOTIONAL_CODES_STATUS_INACTIVE,
  OWNER_PROMOTIONAL_CODES_CREATE_SUCCESS,
  OWNER_PROMOTIONAL_CODES_ERROR_DUPLICATE,
  OWNER_PROMOTIONAL_CODES_ERROR_INVALID,
  PROMOTIONAL_CODE_NOT_FOUND,
  PROMOTIONAL_CODE_INACTIVE,
  PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED,
  ADMIN_DASHBOARD_SUBTITLE,
  ADMIN_DASHBOARD_SEARCH_PLACEHOLDER,
  ADMIN_DASHBOARD_FILTER_STATUS_PLACEHOLDER,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_TITLE,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_HEALTHY,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_WATCHLIST,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_AT_RISK,
  CREATE_BRAND_BUTTON,
  ADMIN_DASHBOARD_CREATE_BRAND_BUTTON,
  ANNOTATIONS_SIDEBAR_AGENCY_HEADER,
  ANNOTATIONS_SIDEBAR_ADVERTISER_HEADER,
  ANNOTATIONS_SIDEBAR_EMPTY_TITLE,
  ANNOTATIONS_SIDEBAR_EMPTY_SUBTITLE,
  ANNOTATIONS_SIDEBAR_INPUT_PLACEHOLDER,
  ANNOTATIONS_SIDEBAR_YOU_LABEL,
  ANNOTATIONS_SIDEBAR_LOADING,
  ANNOTATIONS_SIDEBAR_CLOSE,
  ANNOTATIONS_UNREAD_BADGE_ARIA,
  ANNOTATIONS_UNREAD_COUNT,
  ANNOTATIONS_MENTION_ALL,
  ANNOTATIONS_MENTION_MENU_ARIA,
  ANNOTATIONS_MESSAGE_EDIT,
  ANNOTATIONS_MESSAGE_DELETE,
  ANNOTATIONS_MESSAGE_DELETE_CONFIRM,
  ANNOTATIONS_MESSAGE_EDITING,
  ANNOTATIONS_MESSAGE_CANCEL_EDIT,
  ANNOTATIONS_MESSAGE_MENU_ARIA,
  ADMIN_DASHBOARD_CREATE_BRAND_MODAL_TITLE,
  ADMIN_DASHBOARD_CREATE_BRAND_MODAL_SUBTITLE,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_ACTIVE_LABEL,
  ADMIN_DASHBOARD_USER_CREATED_SUCCESS,
  ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_YES,
  ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_NO,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_RECURRENT_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_HAS_ADDON_SPEND_FEE_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_FEATURES_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_AD_SPEND_FEE_PERCENTAGE_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_STRIPE_SUBSCRIPTION_ID_LABEL,
  ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_TITLE,
  ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_BRAND_NAME_LABEL,
  ADMIN_DASHBOARD_ADVERTISER_CREATED_SUCCESS,
  DELETE_BRAND_CONFIRMATION_TITLE,
  DELETE_BRAND_CONFIRMATION_DESCRIPTION,
  DELETE_BRAND_SUCCESS,
  DELETE_BRAND_ERROR,
  DELETE_BRAND_MAIN_CANNOT_DELETE,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_TITLE,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_LABEL,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_PLACEHOLDER,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MIN_ERROR,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MAX_ERROR,
  ADMIN_DASHBOARD_CREDITS_ADDED_SUCCESS,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_MODAL_TITLE,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CREDITS_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_VIDEOS_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CONSUMED_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_HINT,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_REMOVE_HINT,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_TOTAL_ASSIGNED_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_SUCCESS,
  NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE,
  NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE_DESCRIPTION,
  BRAND_USAGE_LIMIT_ALERT_EDIT_LIMITS_BUTTON,
  BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN,
  BRAND_USAGE_ALLOCATION_BELOW_CONSUMED,
  HEALTH_SCORE_LABEL,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE,
  VIDEO_LANGUAGE,
  GENERATION_FAILED,
  ASPECT_RATIO_PLACEHOLDER,
  ASPECT_RATIO_9_16,
  ASPECT_RATIO_16_9,
  ASPECT_RATIO_1_1,
  ASPECT_RATIO_4_5,
  GENERATING_CREATIVE_SUCCESS,
  GENERATING_CREATIVE_ERROR,
  ALERT_GENERIC_ERROR_TITLE,
  GENERATING_CREATIVE_TITLE,
  GENERATING_CUSTOM_REPORT_MESSAGE,
  GENERATING_CUSTOM_REPORT_SUCCESS,
  GENERATING_CUSTOM_REPORT_ERROR,
  ANALYZING_IMAGE_LAYERS_MESSAGE,
  ANALYZING_IMAGE_LAYERS_SUCCESS,
  ANALYZING_IMAGE_LAYERS_ERROR,
  ANALYZING_CREATIVE_TEMPLATE_MESSAGE,
  ANALYZING_CREATIVE_TEMPLATE_SUCCESS,
  ANALYZING_CREATIVE_TEMPLATE_ERROR,
  PRODUCING_CREATIVE_TEMPLATE_MESSAGE,
  PRODUCING_CREATIVE_TEMPLATE_PREVIEW_MESSAGE,
  PRODUCING_CREATIVE_TEMPLATE_PREVIEW_SUCCESS,
  PRODUCING_CREATIVE_TEMPLATE_PREVIEW_ERROR,
  PRODUCING_CREATIVE_TEMPLATE_SUCCESS,
  PRODUCING_CREATIVE_TEMPLATE_PARTIAL,
  PRODUCING_CREATIVE_TEMPLATE_PARTIAL_SINGULAR,
  PRODUCING_CREATIVE_TEMPLATE_ERROR,
  EDITING_IMAGE_TITLE,
  EDITING_IMAGE_SUCCESS,
  EDITING_IMAGE_ERROR,
  RESIZING_IMAGE_TITLE,
  RESIZING_IMAGE_SUCCESS,
  RESIZING_IMAGE_ERROR,
  MODAL_CREATE_WITH_IA_LABEL_VIDEO_TYPE,
  VIDEO_TYPE_UNBOXING,
  VIDEO_TYPE_PRODUCT_SHOWCASE,
  VIDEO_TYPE_UGC,
  VIDEO_TYPE_LIFESTYLE,
  VIDEO_TYPE_TESTIMONIALS_REVIEWS,
  VIDEO_TYPE_TESTIMONIAL,
  VIDEO_TYPE_EMOTIONAL_STORYTELLING,
  VIDEO_TYPE_CASE_STUDY,
  VIDEO_TYPE_CORPORATE,
  AGENT_LABEL,
  REST_VIDEOS,
  VIDEOS_REMAINING_SHORT,
  REST_CREATIVE_SINGULAR,
  REST_VIDEO_SINGULAR,
  REST_CREDITS,
  CREATIVES_REMAINING_SHORT_SINGULAR,
  SUGGESTED_CREATIVES_COUNT,
  VIDEOS_REMAINING_SHORT_SINGULAR,
  FIELD_APP_ID_REQUIRED_AD_PREVIEW,
  FIELD_URL_VALID_WITH_PROTOCOL,
  INVALID_APP_DEEP_LINK,
  CONNECTING_TO_PLATFORM_DESCRIPTION,
  MODAL_SAVED_AUDIENCES_DESCRIPTION,
  MODAL_SAVED_AUDIENCES_TITLE,
  BUTTON_USE_SAVED_AUDIENCE,
  ADS_CAMPAIGN_SAVED_AUDIENCE_SUB_TITLE,
  YOUR_CAMPAIGN_HAS_SOME_DISAPPROVALS,
  GENERATION_VIDEO_REJECTED,
  VIDEO_INPUT_REAL_PERSON_REJECTED,
  IMAGE_LAYERS_CONTENT_POLICY_VIOLATION,
  AI_PROVIDER_CREDENTIALS_INVALID,
  AI_PROVIDER_CREDENTIALS_INVALID_GENERIC,
  AI_REQUEST_TIMEOUT,
  DARK_POST_DESCRIPTION_PLACEHOLDER,
  DARK_POST_PLACEHOLDER,
  IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER,
  IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER,
  ALERT_AD_ACCOUNT_STATUS_DISABLED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT_LABEL,
  ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CLOSED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_LIMITED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL_LABEL,
  ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING_LABEL,
  ALERT_AD_ACCOUNT_STATUS_DRAFT_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_RESTRICTED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_STOPPED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_SUSPENDED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CANCELED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED_LABEL,
  ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS_LABEL,
  ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES_LABEL,
  FILE_UPLOADED,
  CHAT_THINKING,
  GO_TO_DASHBOARD,
  IMAGES_MODERATION_BLOCKED,
  MALFORMED_FUNCTION_CALL,
  ALERT_DELETE_CAMPAIGN_ACTIVE_TITLE,
  ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP,
  RESET_CHAT_ALERT_DESCRIPTION,
  RESET_CHAT_ALERT_TITLE,
  DISCARD_OPTIMIZATION_ALERT_DESCRIPTION,
  DISCARD_OPTIMIZATION_ALERT_TITLE,
  DISCARD_GENERATING_CREATIVE_ALERT_DESCRIPTION,
  DISCARD_GENERATING_VIDEO_ALERT_DESCRIPTION,
  DISCARD_IMAGE_ANIMATION_ALERT_DESCRIPTION,
  DISCARD_GENERATING_CUSTOM_REPORT_ALERT_DESCRIPTION,
  DISCARD_ANALYZING_IMAGE_LAYERS_ALERT_DESCRIPTION,
  DISCARD_ANALYZING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION,
  DISCARD_PRODUCING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION,
  BUTTON_DISCARD_ALL,
  DISCARD_ALL_ACTIVITIES_TITLE,
  DISCARD_ALL_ACTIVITIES_DESCRIPTION,
  ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET_LABEL,
  VIDEO_GENERATION_FAILED_BY_PROVIDER,
  AI_RATE_LIMITED,
  AI_PROVIDER_UNAVAILABLE,
  AI_GENERATION_FAILED,
  AGENT_REQUEST_COULD_NOT_BE_PROCESSED,
  CREDITS_RETURNED_SUFFIX,
  CREATIVE_UNEXPECTED_IMAGE_PROVIDER_ERROR,
  CREATIVE_UNEXPECTED_VIDEO_PROVIDER_ERROR,
  CREATIVE_UNEXPECTED_AI_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_IMAGE_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_VIDEO_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_AI_PROVIDER_ERROR,
  CREATE_ADS_CAMPAIGN_DEEP_LINK_QUESTION,
  APP_STORE_ANDROID,
  APP_STORE_IOS,
  APP_STORE_PLACEHOLDER,
  GOOGLE_APP,
  MODAL_CREATE_WITH_IA_LABEL_WITH_SUBTITLES,
  MODAL_CREATE_WITH_IA_LABEL_AI_WATERMARK,
  MODAL_CREATE_WITH_IA_AI_WATERMARK_DESCRIPTION,
  MODAL_SUBTITLE_OPTIONS_TITLE,
  MODAL_SUBTITLE_OPTIONS_PERSONALIZE,
  MODAL_SUBTITLE_OPTIONS_FONT_FAMILY,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_NORMAL,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_ITALIC,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD_ITALIC,
  MODAL_SUBTITLE_OPTIONS_SUBTITLE_COLOR,
  MODAL_SUBTITLE_OPTIONS_DO_HIGHLIGHT,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_COLOR,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_KARAOKE,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_WORD,
  MODAL_SUBTITLE_OPTIONS_PRESET,
  MODAL_SUBTITLE_OPTIONS_PRESET_KARAOKE,
  MODAL_SUBTITLE_OPTIONS_PRESET_HIGHLIGHT,
  MODAL_SUBTITLE_OPTIONS_PRESET_BOXED,
  MODAL_SUBTITLE_OPTIONS_BOX_COLOR,
  MODAL_SUBTITLE_OPTIONS_HAS_BACKGROUND,
  MODAL_SUBTITLE_OPTIONS_BACKGROUND_COLOR,
  MODAL_SUBTITLE_OPTIONS_PREVIEW_LABEL,
  ACCENT_ES_ARGENTINO,
  ACCENT_ES_COLOMBIANO,
  ACCENT_ES_CHILENO,
  ACCENT_ES_MEXICANO,
  ACCENT_ES_ESPANOL_ESPANA,
  ACCENT_ES_PERUANO,
  ACCENT_ES_VENEZOLANO,
  ACCENT_ES_CARIBENO,
  ACCENT_ES_NEUTRAL,
  ACCENT_EN_AMERICAN,
  ACCENT_EN_BRITISH,
  ACCENT_EN_AUSTRALIAN,
  ACCENT_EN_NEUTRAL,
  REQUIRED_VIDEOS_GOOGLE_ASSETS_GROUP_HELPER_TEXT,
  ANALYZING_CONTENT,
  CONTENT_RECOMMENDATIONS,
  NO_CONTENT_RECOMMENDATIONS,
  CONTENT_WARNING_TITLE,
  CONTENT_RECOMMENDATIONS_SUBTITLE,
  CONTENT_RECOMMENDATION_OPEN_CREATE_WITH_IA,
  CONTENT_RECOMMENDATIONS_BANNER_TITLE,
  CONTENT_RECOMMENDATIONS_BANNER_DESCRIPTION,
  CONTENT_RECOMMENDATIONS_VIEW_ALL,
  CONTENT_RECOMMENDATIONS_COMPLETED_PROGRESS,
  CONTENT_RECOMMENDATION_GENERATED,
  CONTENT_RECOMMENDATION_GENERATE_ARIA,
  CONTENT_RECOMMENDATIONS_ALL_COMPLETED,
  CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_QUESTION,
  CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_QUESTION,
  CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_DESCRIPTION,
  BUTTON_ADD_SERVICE,
  PRODUCT_URL_PLACEHOLDER,
  SERVICE_URL_PLACEHOLDER,
  PRODUCT_LABEL,
  SERVICE_LABEL,
  PRODUCT_FIELDS_REQUIRED,
  SERVICE_FIELDS_REQUIRED,
  PRODUCT_URL_INVALID,
  SERVICE_URL_INVALID,
  MEDIA_URLS_TAB_SINGULAR_PRODUCT,
  MEDIA_URLS_TAB_SINGULAR_SERVICE,
  MEDIA_URLS_TAB_MULTIPLE_PRODUCTS,
  MEDIA_URLS_TAB_MULTIPLE_SERVICES,
  MEDIA_URLS_MODE_EXPLANATION_PRODUCTS,
  MEDIA_URLS_MODE_EXPLANATION_SERVICES,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_SERVICES_QUESTION,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DOCUMENTS_QUESTION,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_POSTS_QUESTION,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_PRODUCTS_QUESTION,
  CONFIGURATION_PANEL_CLARIFICATION_INPUT_IMAGES,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_INTRO,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_HIGH_QUALITY,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_PROMINENT,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SIZE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SAME_COLOR_AND_MODEL,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_COMPLETE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_LIGHTING,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_NO_PEOPLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_LIST,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_EXAMPLES_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_PEOPLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_WARNING_DISTORTION,
  PARTNERSHIP,
  VIDEO_TYPE_OTHER,
  BAD,
  REGULAR,
  GOOD,
  VERY_GOOD,
  EXCELLENT,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT_SINGLE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE_SINGLE,
  FIELD,
  EMPTY_TRACKING_IDS_LINKEDIN,
  TRACKING_CUSTOM_EVENT_ID_LINKEDIN_PLACEHOLDER,
  AD_ACCOUNT_LINKEDIN_PLACEHOLDER,
  LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER,
  LINKEDIN_PUBLISH_AS_PERSONAL_LABEL,
  LINKEDIN_PUBLISH_AS_COMPANY_PAGE_LABEL,
  TRACKING_LINKEDIN_ID_PLACEHOLDER,
  ALERT_DESCRIPTION_DISCONNECT_LINKEDIN,
  BUTTON_UPLOAD,
  BUTTON_UPLOAD_FILES,
  BUTTON_UPLOAD_FOLDER,
  BUTTON_URL,
  CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_TITLE,
  CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_DESCRIPTION,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT,
  ADS_CAMPAIGN_LINKEDIN_AD_SETUP,
  ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD,
  ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST,
  ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING,
  AD_FORMAT_PLACEHOLDER,
  SELECT_AD_FORMAT_TO_CONTINUE,
  INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW,
  MODAL_LEAD_FORMS_LIST_TITLE,
  MODAL_LEAD_FORMS_LIST_DESCRIPTION,
  MODAL_LEAD_FORMS_EMPTY_TEXT,
  MODAL_LEAD_FORMS_DUPLICATE_AND_EDIT,
  MODAL_LEAD_FORMS_VIEW,
  MODAL_LEAD_FORMS_COPY_NAME_PREFIX,
  MODAL_CREATE_LEAD_FORM_TITLE,
  MODAL_VIEW_LEAD_FORM_TITLE,
  INSTANT_FORM_PREVIEW_MORE,
  MODAL_CREATE_LEAD_FORM_DESCRIPTION,
  MODAL_VIEW_LEAD_FORM_DESCRIPTION,
  MODAL_VIEW_LEAD_FORM_LOAD_ERROR,
  MODAL_CREATE_LEAD_FORM_LOCALE_WARNING,
  MODAL_CREATE_LEAD_FORM_NAME,
  MODAL_CREATE_LEAD_FORM_HEADLINE,
  MODAL_CREATE_LEAD_FORM_DETAILS,
  MODAL_CREATE_LEAD_FORM_SECTION_FORM,
  MODAL_CREATE_LEAD_FORM_SECTION_CONTACT,
  MODAL_CREATE_LEAD_FORM_SECTION_PRIVACY,
  MODAL_CREATE_LEAD_FORM_SECTION_CONFIRMATION,
  MODAL_CREATE_LEAD_FORM_PROFILE_FIELDS,
  MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL,
  MODAL_CREATE_LEAD_FORM_PROFILE_PHONE,
  MODAL_CREATE_LEAD_FORM_PROFILE_CITY,
  MODAL_CREATE_LEAD_FORM_PROFILE_STATE,
  MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY,
  MODAL_CREATE_LEAD_FORM_PROFILE_ZIP,
  MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE,
  MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY,
  MODAL_CREATE_LEAD_FORM_PROFILE_LINKEDIN,
  MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTIONS,
  MODAL_CREATE_LEAD_FORM_ADD_CUSTOM_QUESTION,
  MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTION_HINT,
  MODAL_CREATE_LEAD_FORM_QUESTION_TITLE,
  MODAL_CREATE_LEAD_FORM_QUESTION_TYPE,
  MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_TEXT,
  MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_MULTIPLE_CHOICE,
  MODAL_CREATE_LEAD_FORM_ADD_OPTION,
  MODAL_CREATE_LEAD_FORM_OPTION,
  MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_URL,
  MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_TEXT,
  MODAL_CREATE_LEAD_FORM_THANK_YOU_MESSAGE,
  MODAL_CREATE_LEAD_FORM_LANDING_PAGE_URL,
  MODAL_CREATE_LEAD_FORM_CTA,
  MODAL_CREATE_LEAD_FORM_CTA_VISIT_COMPANY_WEBSITE,
  MODAL_CREATE_LEAD_FORM_CTA_LEARN_MORE,
  MODAL_CREATE_LEAD_FORM_CTA_VIEW_NOW,
  MODAL_CREATE_LEAD_FORM_CTA_DOWNLOAD_NOW,
  MODAL_CREATE_LEAD_FORM_CTA_TRY_NOW,
  MODAL_CREATE_LEAD_FORM_MIN_OPTIONS,
  MODAL_CREATE_LEAD_FORM_MAX_CUSTOM_QUESTIONS,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENT_WILL_BE_PUBLISHED_IMMEDIATELY,
  CAMPAIGN_LEARNINGS_TITLE,
  CAMPAIGN_LEARNINGS_SUBTITLE,
  CAMPAIGN_LEARNINGS_KEY_LEARNINGS,
  CAMPAIGN_LEARNINGS_WHAT_WORKED,
  CAMPAIGN_LEARNINGS_WHAT_DIDNT_WORK,
  PLATFORM_META,
  PLATFORM_GOOGLE,
  TABLE_ADMIN_DASHBOARD_RESULTS,
  TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE_SINGLE,
  TABLE_ADMIN_DASHBOARD_AI_CREATIVES_LAST_30_DAYS,
  SUGGESTED_CREATIVES_PROGRESS,
  LOGO_DESCRIPTION,
  CALENDAR_MULTIPLE_POST_TITLE,
  BENEFICIARY_OR_PAYER_NOT_FOUND,
  MODAL_BRAND_SETUP_CONFIRM_TITLE,
  MODAL_BRAND_SETUP_CONFIRM_DESCRIPTION,
  MODAL_BRAND_SETUP_CONFIRM_BUTTON,
  MODAL_BRAND_SETUP_REVIEW_BUTTON,
  MODAL_UPLOAD_FACEBOOK_TYPE_LABEL,
  TYPE_CONTENT_FACEBOOK_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_REEL_LABEL,
  CALENDAR_STORIES_TITLE,
  CALENDAR_REELS_TITLE,
  MODAL_SELECT_CREDITS_ARIA_LABEL,
  ADS_SUBSCRIPTION_BENEFIT_CREDITS,
  ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_YEAR,
  APPSUMO_SUBSCRIPTION_TIER_1,
  APPSUMO_SUBSCRIPTION_TIER_2,
  APPSUMO_SUBSCRIPTION_TIER_3,
  VALUE_SUBSCRIPTION_ONE_TIME,
  BUTTON_APPSUMO_VIEW_PLANS,
  VIDEO_HOOK_RATE,
  VIDEO_RETENTION_RATE,
  BUY_CREDITS,
  SECTION_OFFER_BUSINESS_VALUE_PROPOSITION_LABEL,
  BRAND_SETUP_EXTRACTION_WARNING_MESSAGE,
  LINKEDIN_ARTICLE_DEFAULT_TEXT,
  CREDIT_REWARD_MODAL_TITLE,
  CREDIT_REWARD_MODAL_SUBTITLE,
  CREDIT_REWARD_MODAL_ARIA_LABEL,
  CREDIT_REWARD_MODAL_REWARD,
  CREDIT_REWARD_MODAL_REWARD_DESCRIPTION,
  CREDIT_REWARD_MODAL_ARTICLE_CONTENT_LABEL,
  CREDIT_REWARD_MODAL_ARTICLE_CONTENT_PLACEHOLDER,
  CREDIT_REWARD_MODAL_VERIFICATION_NOTICE,
  CREDIT_REWARD_MODAL_BUTTON_CANCEL,
  CREDIT_REWARD_MODAL_BUTTON_PUBLISH,
  CREDIT_REWARD_MODAL_BUTTON_PUBLISHING,
  CREDIT_REWARD_MODAL_BUTTON_RETRY,
  CREDIT_REWARD_MODAL_LOADING_TITLE,
  CREDIT_REWARD_MODAL_LOADING_DESCRIPTION,
  CREDIT_REWARD_MODAL_SUCCESS_TITLE,
  CREDIT_REWARD_MODAL_SUCCESS_TEXT,
  CREDIT_REWARD_MODAL_ERROR_TITLE,
  CREDIT_REWARD_MODAL_ERROR_TEXT,
  CREDIT_REWARD_MODAL_BUTTON_TEXT,
  ALERT_CANCEL_PLAN_TITLE,
  X,
  THREADS,
  INSTAGRAM_FEED_ASPECT_RATIO_WARNING,
  CAROUSEL_MIN_IMAGES_WARNING,
  CAROUSEL_MAX_IMAGES_WARNING,
  CAROUSEL_DRAG_TO_REORDER,
  CAROUSEL_ADD_MORE_IMAGES,
  CAROUSEL_IMAGES_SELECTED,
  CAROUSEL_MAIN_IMAGE,
  TYPE_CONTENT_TIKTOK_LABEL,
  MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL,
  TIKTOK_AUTO_ADD_MUSIC_LABEL,
  CONTENT_TYPE_CAROUSEL,
  CONFIRM_CHANGE_CONTENT_TYPE_TITLE,
  CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_CAROUSEL,
  CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_POST,
  CONFIRM_REGENERATE_TEXTS_AFTER_CREATIVE_CHANGE_TITLE,
  BUTTON_KEEP_TEXTS,
  REGENERATING_AD_TEXTS_OVERLAY_MESSAGE,
  BRAND_SETUP_SECTION_BRAND_NAME,
  BRAND_SETUP_SECTION_BRAND_DESCRIPTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
  BRAND_SETUP_SECTION_BRAND_NAME_PLACEHOLDER,
  BRAND_SETUP_SECTION_BRAND_DESCRIPTION_PLACEHOLDER,
  ANONYMOUS_USER,
  LINKEDIN_STAFF_COUNT_MYSELF_ONLY,
  LINKEDIN_STAFF_COUNT_2_10,
  LINKEDIN_STAFF_COUNT_11_50,
  LINKEDIN_STAFF_COUNT_51_200,
  LINKEDIN_STAFF_COUNT_201_500,
  LINKEDIN_STAFF_COUNT_501_1000,
  LINKEDIN_STAFF_COUNT_1001_5000,
  LINKEDIN_STAFF_COUNT_5001_10000,
  LINKEDIN_STAFF_COUNT_10001_PLUS,
  LINKEDIN_JOB_FUNCTION_ACCOUNTING,
  LINKEDIN_JOB_FUNCTION_ADMINISTRATIVE,
  LINKEDIN_JOB_FUNCTION_ARTS_AND_DESIGN,
  LINKEDIN_JOB_FUNCTION_BUSINESS_DEVELOPMENT,
  LINKEDIN_JOB_FUNCTION_COMMUNITY_AND_SOCIAL_SERVICES,
  LINKEDIN_JOB_FUNCTION_CONSULTING,
  LINKEDIN_JOB_FUNCTION_EDUCATION,
  LINKEDIN_JOB_FUNCTION_ENGINEERING,
  LINKEDIN_JOB_FUNCTION_ENTREPRENEURSHIP,
  LINKEDIN_JOB_FUNCTION_FINANCE,
  LINKEDIN_JOB_FUNCTION_HEALTHCARE_SERVICES,
  LINKEDIN_JOB_FUNCTION_HUMAN_RESOURCES,
  LINKEDIN_JOB_FUNCTION_INFORMATION_TECHNOLOGY,
  LINKEDIN_JOB_FUNCTION_LEGAL,
  LINKEDIN_JOB_FUNCTION_MARKETING,
  LINKEDIN_JOB_FUNCTION_MEDIA_AND_COMMUNICATION,
  LINKEDIN_JOB_FUNCTION_MILITARY_AND_PROTECTIVE_SERVICES,
  LINKEDIN_JOB_FUNCTION_OPERATIONS,
  LINKEDIN_JOB_FUNCTION_PRODUCT_MANAGEMENT,
  LINKEDIN_JOB_FUNCTION_PROGRAM_AND_PROJECT_MANAGEMENT,
  LINKEDIN_JOB_FUNCTION_PURCHASING,
  LINKEDIN_JOB_FUNCTION_QUALITY_ASSURANCE,
  LINKEDIN_JOB_FUNCTION_REAL_ESTATE,
  LINKEDIN_JOB_FUNCTION_RESEARCH,
  LINKEDIN_JOB_FUNCTION_SALES,
  LINKEDIN_JOB_FUNCTION_CUSTOMER_SUCCESS_AND_SUPPORT,
  LINKEDIN_SENIORITY_UNPAID,
  LINKEDIN_SENIORITY_TRAINING,
  LINKEDIN_SENIORITY_ENTRY,
  LINKEDIN_SENIORITY_SENIOR,
  LINKEDIN_SENIORITY_MANAGER,
  LINKEDIN_SENIORITY_DIRECTOR,
  LINKEDIN_SENIORITY_VP,
  LINKEDIN_SENIORITY_CXO,
  LINKEDIN_SENIORITY_PARTNER,
  LINKEDIN_SENIORITY_OWNER,
  LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_JOB_SEEKERS,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_EDUCATION,
  LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_CONTRIBUTORS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_PROMOTED,
  LINKEDIN_MEMBER_BEHAVIOR_CAREER_CHANGERS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_SWITCHED_JOBS,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION,
  LINKEDIN_MEMBER_BEHAVIOR_EXPAT,
  LINKEDIN_MEMBER_BEHAVIOR_MOBILE_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_DESKTOP_LAPTOP_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_DOMESTIC_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_INTERNATIONAL_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_DOMESTIC,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_INTERNATIONAL,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_DOMESTIC,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_INTERNATIONAL,
  LINKEDIN_MEMBER_BEHAVIOR_ANDROID_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_WINDOWS,
  LINKEDIN_MEMBER_BEHAVIOR_MAC,
  LINKEDIN_MEMBER_BEHAVIOR_LINUX,
  RETRIEVING_YOUTUBE_CHANNEL,
  RETRIEVING_TIKTOK_PROFILE,
  ESTABLISHING_CONNECTION_WITH_PLATFORM,
  RETRIEVING_AUTHORIZATION_DATA,
  OPENING_AUTHORIZATION_WINDOW,
  CONNECTING_CANVA_VERIFYING_AUTHORIZATION,
  CONNECTING_CANVA_LINKING_ACCOUNT,
  MODAL_CREATE_WITH_IA_PROMPT_OPTIONAL,
  MODAL_CREATE_WITH_IA_PROMPT_THEME_OPTIONAL,
  FILTERS_GALLERY_CAROUSEL,
  GALLERY_CREATE_CAROUSEL,
  FILTERS_GALLERY_FEED,
  MODAL_UPLOAD_TIKTOK_TYPE_VIDEO_LABEL,
  MODAL_FEEDBACK_TITLE,
  MODAL_FEEDBACK_DESCRIPTION,
  MODAL_FEEDBACK_PLACEHOLDER,
  MODAL_FEEDBACK_LIKE_LABEL,
  MODAL_FEEDBACK_DISLIKE_LABEL,
  MODAL_REPORT_CONTENT_TITLE,
  MODAL_REPORT_CONTENT_DESCRIPTION,
  MODAL_REPORT_CONTENT_PLACEHOLDER,
  MODAL_REPORT_CONTENT_SUCCESS,
  BUTTON_REPORT_CONTENT,
  DASHBOARD_METRICS_DELAY_DISMISS,
  ALERT_DELETE_ELEMENT_TITLE,
  ALERT_DELETE_ELEMENT_DESCRIPTION,
  DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN,
  BUTTON_DELETE_LOGO,
  LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED,
  MODAL_EDIT_URL_PARAMETERS_TITLE,
  MODAL_EDIT_URL_PARAMETERS_DESCRIPTION,
  MODAL_EDIT_URL_PARAMETERS_UTM_SECTION_LABEL,
  MODAL_EDIT_URL_PARAMETERS_CUSTOM_SECTION_LABEL,
  MODAL_EDIT_URL_PARAMETERS_PREVIEW_LABEL,
  MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_NAME,
  MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_VALUE,
  MODAL_EDIT_URL_PARAMETERS_CONFIGURED,
  MODAL_EDIT_URL_PARAMETERS_BUTTON_APPLY,
  MODAL_EDIT_URL_PARAMETERS_BUTTON_CONFIGURE,
  MODAL_EDIT_URL_PARAMETERS_CUSTOM_KEY_RESERVED,
  MODAL_EDIT_URL_PARAMETERS_BUILD_LABEL,
  URL_EXAMPLE_PLACEHOLDER,
  WHY_WOULD_IT_WORK,
  INSTANT_FORM_SECTION_FORM_TYPE,
  INSTANT_FORM_SECTION_INTRO,
  INSTANT_FORM_SECTION_QUESTIONS,
  INSTANT_FORM_SECTION_END,
  INSTANT_FORM_FIELD_HEADLINE,
  INSTANT_FORM_FIELD_DESCRIPTION,
  INSTANT_FORM_FIELD_CTA,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_TYPE_LABEL,
  BUTTON_CONTINUE_WITHOUT_CHANGES,
  BUTTON_RESIZE_AND_CONTINUE,
  ANIMATING_IMAGE_TITLE,
  ANIMATING_IMAGE_SUCCESS,
  ANIMATING_IMAGE_ERROR,
  CAMPAIGN_IS_GENERATING,
  INVALID_JOB_TYPE,
  JOB_CANCELLED_OR_FAILED,
  JOB_TIMEOUT,
  CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD,
  VIDEO_TYPE_SURREAL,
  VIDEO_TYPE_MEGA_CREATIVE,
  SECTION_BUYER_PERSONA_PLACEHOLDER_NAME,
  SECTION_BUYER_PERSONA_PLACEHOLDER_DESCRIPTION,
  ALL,
  SET_PASSWORD,
  COUNTRY_ANDORRA,
  COUNTRY_UNITED_ARAB_EMIRATES,
  COUNTRY_AFGHANISTAN,
  COUNTRY_ANTIGUA_AND_BARBUDA,
  COUNTRY_ANGUILLA,
  COUNTRY_ALBANIA,
  COUNTRY_ARMENIA,
  COUNTRY_ANGOLA,
  COUNTRY_ANTARCTICA,
  COUNTRY_ARGENTINA,
  COUNTRY_AMERICAN_SAMOA,
  COUNTRY_AUSTRIA,
  COUNTRY_AUSTRALIA,
  COUNTRY_ARUBA,
  COUNTRY_ALLAND_ISLANDS,
  COUNTRY_AZERBAIJAN,
  COUNTRY_BOSNIA_AND_HERZEGOVINA,
  COUNTRY_BARBADOS,
  COUNTRY_BANGLADESH,
  COUNTRY_BELGIUM,
  COUNTRY_BURKINA_FASO,
  COUNTRY_BULGARIA,
  COUNTRY_BAHRAIN,
  COUNTRY_BURUNDI,
  COUNTRY_BENIN,
  COUNTRY_SAINT_BARTHELEMY,
  COUNTRY_BERMUDA,
  COUNTRY_BRUNEI_DARUSSALAM,
  COUNTRY_BOLIVIA,
  COUNTRY_BRAZIL,
  COUNTRY_BAHAMAS,
  COUNTRY_BHUTAN,
  COUNTRY_BOUVET_ISLAND,
  COUNTRY_BOTSWANA,
  COUNTRY_BELARUS,
  COUNTRY_BELIZE,
  COUNTRY_CANADA,
  COUNTRY_COCOS_KEELING_ISLANDS,
  COUNTRY_CONGO_DEMOCRATIC_REPUBLIC_OF_THE,
  COUNTRY_CENTRAL_AFRICAN_REPUBLIC,
  COUNTRY_CONGO_REPUBLIC_OF_THE,
  COUNTRY_SWITZERLAND,
  COUNTRY_COTE_D_IVOIRE,
  COUNTRY_COOK_ISLANDS,
  COUNTRY_CHILE,
  COUNTRY_CAMEROON,
  COUNTRY_CHINA,
  COUNTRY_COLOMBIA,
  COUNTRY_COSTA_RICA,
  COUNTRY_CUBA,
  COUNTRY_CAPE_VERDE,
  COUNTRY_CURACAO,
  COUNTRY_CHRISTMAS_ISLAND,
  COUNTRY_CYPRUS,
  COUNTRY_CZECH_REPUBLIC,
  COUNTRY_GERMANY,
  COUNTRY_DJIBOUTI,
  COUNTRY_DENMARK,
  COUNTRY_DOMINICA,
  COUNTRY_DOMINICAN_REPUBLIC,
  COUNTRY_ALGERIA,
  COUNTRY_ECUADOR,
  COUNTRY_ESTONIA,
  COUNTRY_EGYPT,
  COUNTRY_WESTERN_SAHARA,
  COUNTRY_ERITREA,
  COUNTRY_SPAIN,
  COUNTRY_ETHIOPIA,
  COUNTRY_FINLAND,
  COUNTRY_FIJI,
  COUNTRY_FALKLAND_ISLANDS_MALVINAS,
  COUNTRY_MICRONESIA_FEDERATED_STATES_OF,
  COUNTRY_FAROE_ISLANDS,
  COUNTRY_FRANCE,
  COUNTRY_GABON,
  COUNTRY_UNITED_KINGDOM,
  COUNTRY_GRENADA,
  COUNTRY_GEORGIA,
  COUNTRY_FRENCH_GUIANA,
  COUNTRY_GUERNSEY,
  COUNTRY_GHANA,
  COUNTRY_GIBRALTAR,
  COUNTRY_GREENLAND,
  COUNTRY_GAMBIA,
  COUNTRY_GUINEA,
  COUNTRY_GUADELOUPE,
  COUNTRY_EQUATORIAL_GUINEA,
  COUNTRY_GREECE,
  COUNTRY_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  COUNTRY_GUATEMALA,
  COUNTRY_GUAM,
  COUNTRY_GUINEA_BISSAU,
  COUNTRY_GUYANA,
  COUNTRY_HONG_KONG,
  COUNTRY_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  COUNTRY_HONDURAS,
  COUNTRY_CROATIA,
  COUNTRY_HAITI,
  COUNTRY_HUNGARY,
  COUNTRY_INDONESIA,
  COUNTRY_IRELAND,
  COUNTRY_ISRAEL,
  COUNTRY_ISLE_OF_MAN,
  COUNTRY_INDIA,
  COUNTRY_BRITISH_INDIAN_OCEAN_TERRITORY,
  COUNTRY_IRAQ,
  COUNTRY_IRAN_ISLAMIC_REPUBLIC_OF,
  COUNTRY_ICELAND,
  COUNTRY_ITALY,
  COUNTRY_JERSEY,
  COUNTRY_JAMAICA,
  COUNTRY_JORDAN,
  COUNTRY_JAPAN,
  COUNTRY_KENYA,
  COUNTRY_KYRGYZSTAN,
  COUNTRY_CAMBODIA,
  COUNTRY_KIRIBATI,
  COUNTRY_COMOROS,
  COUNTRY_SAINT_KITTS_AND_NEVIS,
  COUNTRY_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  COUNTRY_KOREA_REPUBLIC_OF,
  COUNTRY_KUWAIT,
  COUNTRY_CAYMAN_ISLANDS,
  COUNTRY_KAZAKHSTAN,
  COUNTRY_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  COUNTRY_LEBANON,
  COUNTRY_SAINT_LUCIA,
  COUNTRY_LIECHTENSTEIN,
  COUNTRY_SRI_LANKA,
  COUNTRY_LIBERIA,
  COUNTRY_LESOTHO,
  COUNTRY_LITHUANIA,
  COUNTRY_LUXEMBOURG,
  COUNTRY_LATVIA,
  COUNTRY_LIBYA,
  COUNTRY_MOROCCO,
  COUNTRY_MONACO,
  COUNTRY_MOLDOVA_REPUBLIC_OF,
  COUNTRY_MONTENEGRO,
  COUNTRY_SAINT_MARTIN_FRENCH_PART,
  COUNTRY_MADAGASCAR,
  COUNTRY_MARSHALL_ISLANDS,
  COUNTRY_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  COUNTRY_MALI,
  COUNTRY_MYANMAR,
  COUNTRY_MONGOLIA,
  COUNTRY_MACAO,
  COUNTRY_NORTHERN_MARIANA_ISLANDS,
  COUNTRY_MARTINIQUE,
  COUNTRY_MAURITANIA,
  COUNTRY_MONTSERRAT,
  COUNTRY_MALTA,
  COUNTRY_MAURITIUS,
  COUNTRY_MALDIVES,
  COUNTRY_MALAWI,
  COUNTRY_MEXICO,
  COUNTRY_MALAYSIA,
  COUNTRY_MOZAMBIQUE,
  COUNTRY_NAMIBIA,
  COUNTRY_NEW_CALEDONIA,
  COUNTRY_NIGER,
  COUNTRY_NORFOLK_ISLAND,
  COUNTRY_NIGERIA,
  COUNTRY_NICARAGUA,
  COUNTRY_NETHERLANDS,
  COUNTRY_NORWAY,
  COUNTRY_NEPAL,
  COUNTRY_NAURU,
  COUNTRY_NIUE,
  COUNTRY_NEW_ZEALAND,
  COUNTRY_OMAN,
  COUNTRY_PANAMA,
  COUNTRY_PERU,
  COUNTRY_FRENCH_POLYNESIA,
  COUNTRY_PAPUA_NEW_GUINEA,
  COUNTRY_PHILIPPINES,
  COUNTRY_PAKISTAN,
  COUNTRY_POLAND,
  COUNTRY_SAINT_PIERRE_AND_MIQUELON,
  COUNTRY_PITCAIRN,
  COUNTRY_PUERTO_RICO,
  COUNTRY_PALESTINE_STATE_OF,
  COUNTRY_PORTUGAL,
  COUNTRY_PALAU,
  COUNTRY_PARAGUAY,
  COUNTRY_QATAR,
  COUNTRY_REUNION,
  COUNTRY_ROMANIA,
  COUNTRY_SERBIA,
  COUNTRY_RUSSIAN_FEDERATION,
  COUNTRY_RWANDA,
  COUNTRY_SAUDI_ARABIA,
  COUNTRY_SOLOMON_ISLANDS,
  COUNTRY_SEYCHELLES,
  COUNTRY_SUDAN,
  COUNTRY_SWEDEN,
  COUNTRY_SINGAPORE,
  COUNTRY_SAINT_HELENA,
  COUNTRY_SLOVENIA,
  COUNTRY_SVALBARD_AND_JAN_MAYEN,
  COUNTRY_SLOVAKIA,
  COUNTRY_SIERRA_LEONE,
  COUNTRY_SAN_MARINO,
  COUNTRY_SENEGAL,
  COUNTRY_SOMALIA,
  COUNTRY_SURINAME,
  COUNTRY_SOUTH_SUDAN,
  COUNTRY_SAO_TOME_AND_PRINCIPE,
  COUNTRY_EL_SALVADOR,
  COUNTRY_SINT_MAARTEN_DUTCH_PART,
  COUNTRY_SYRIAN_ARAB_REPUBLIC,
  COUNTRY_SWAZILAND,
  COUNTRY_TURKS_AND_CAICOS_ISLANDS,
  COUNTRY_CHAD,
  COUNTRY_FRENCH_SOUTHERN_TERRITORIES,
  COUNTRY_TOGO,
  COUNTRY_THAILAND,
  COUNTRY_TAJIKISTAN,
  COUNTRY_TOKELAU,
  COUNTRY_TIMOR_LESTE,
  COUNTRY_TURKMENISTAN,
  COUNTRY_TUNISIA,
  COUNTRY_TONGA,
  COUNTRY_TURKEY,
  COUNTRY_TRINIDAD_AND_TOBAGO,
  COUNTRY_TUVALU,
  COUNTRY_TAIWAN,
  COUNTRY_UNITED_REPUBLIC_OF_TANZANIA,
  COUNTRY_UKRAINE,
  COUNTRY_UGANDA,
  COUNTRY_UNITED_STATES,
  COUNTRY_URUGUAY,
  COUNTRY_UZBEKISTAN,
  COUNTRY_HOLY_SEE_VATICAN_CITY_STATE,
  COUNTRY_SAINT_VINCENT_AND_THE_GRENADINES,
  COUNTRY_VENEZUELA,
  COUNTRY_BRITISH_VIRGIN_ISLANDS,
  COUNTRY_US_VIRGIN_ISLANDS,
  COUNTRY_VIETNAM,
  COUNTRY_VANUATU,
  COUNTRY_WALLIS_AND_FUTUNA,
  COUNTRY_SAMOA,
  COUNTRY_KOSOVO,
  COUNTRY_YEMEN,
  COUNTRY_MAYOTTE,
  COUNTRY_SOUTH_AFRICA,
  COUNTRY_ZAMBIA,
  COUNTRY_ZIMBABWE,
  BRAND_SETUP_LOADING_GETTING_WEBSITE_INFORMATION,
  BRAND_SETUP_LOADING_ANALYZING_BRAND,
  BRAND_SETUP_LOADING_GENERATING_BRAND_PROFILE,
  BRAND_SETUP_LOADING_FINALIZING_DETAILS,
  BRAND_SETUP_GENERATION_PROMPT_LABEL,
  BRAND_SETUP_GENERATION_PROMPT_PLACEHOLDER,
  BRAND_SETUP_GENERATION_ATTACH_PDF,
  BRAND_SETUP_GENERATION_PDF_HINT,
  BRAND_SETUP_GENERATION_REMOVE_PDF,
  BRAND_SETUP_GENERATION_PDF_INVALID,
  BRAND_SETUP_GENERATION_PDF_TOO_LARGE,
  BRAND_SETUP_GENERATION_SHOW_ADVANCED,
  BRAND_SETUP_GENERATION_HIDE_ADVANCED,
  BRAND_SETUP_VERSION_CURRENT,
  BRAND_SETUP_VERSION_LABEL,
  BRAND_SETUP_VERSION_PLACEHOLDER,
  BRAND_SETUP_GROUP_VISUAL_IDENTITY_TITLE,
  BRAND_SETUP_GROUP_VISUAL_IDENTITY_DESCRIPTION,
  BRAND_SETUP_GROUP_AUDIENCE_TITLE,
  BRAND_SETUP_GROUP_AUDIENCE_DESCRIPTION,
  BRAND_SETUP_GROUP_COPY_TITLE,
  BRAND_SETUP_GROUP_COPY_DESCRIPTION,
  BRAND_INSIGHTS_TAB_TITLE,
  BRAND_INSIGHTS_PAGE_TITLE,
  BRAND_INSIGHTS_PAGE_DESCRIPTION,
  BRAND_INSIGHTS_POSITIVE_TITLE,
  BRAND_INSIGHTS_NEGATIVE_TITLE,
  BRAND_INSIGHTS_POSITIVE_SUBTITLE,
  BRAND_INSIGHTS_NEGATIVE_SUBTITLE,
  BRAND_INSIGHTS_TOPIC_ANGLE,
  BRAND_INSIGHTS_TOPIC_COPY,
  BRAND_INSIGHTS_TOPIC_CTA,
  BRAND_INSIGHTS_TOPIC_TONE,
  BRAND_INSIGHTS_TOPIC_AESTHETIC,
  BRAND_INSIGHTS_TOPIC_VALUE_PROP,
  BRAND_INSIGHTS_EMPTY,
  BRAND_INSIGHTS_REVIEW_CHANGE,
  BRAND_INSIGHTS_DISMISS,
  BRAND_INSIGHTS_DISMISS_ALERT_TITLE,
  BRAND_INSIGHTS_DISMISS_ALERT_DESCRIPTION,
  BRAND_INSIGHTS_COUNT,
  BRAND_INSIGHTS_UNREAD_ONE,
  BRAND_INSIGHTS_UNREAD_OTHER,
  BRAND_INSIGHTS_APPLY_TITLE,
  BRAND_INSIGHTS_APPLY_LOADING,
  BRAND_INSIGHTS_APPLY_CONFIRM,
  BRAND_INSIGHTS_APPLY_CANCEL,
  BRAND_INSIGHTS_APPLY_REJECTED,
  BRAND_INSIGHTS_APPLY_ALREADY_IN_CONFIG,
  BRAND_INSIGHTS_APPLY_UNMAPPABLE,
  BRAND_INSIGHTS_APPLY_REWRITE,
  BRAND_INSIGHTS_APPLY_RETRY,
  BRAND_INSIGHTS_APPLY_TIMEOUT,
  BRAND_INSIGHTS_APPLY_FIELD,
  BRAND_INSIGHTS_APPLY_RESULT_TITLE,
  BRAND_INSIGHTS_APPLY_SHOW_FULL,
  BRAND_INSIGHTS_APPLY_SHOW_CHANGES,
  BRAND_INSIGHTS_APPLY_NO_CHANGES,
  BRAND_INSIGHTS_APPLY_DIFF_COLLAPSED,
  MODAL_CREDITS_USAGE_DETAILED_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_ARIA_LABEL,
  MODAL_CREDITS_USAGE_DETAILED_LINK,
  MODAL_CREDITS_USAGE_DETAILED_PERIOD,
  MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_ADVERTISER_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_USER_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_ADVERTISER,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_USER,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_VIDEOS_SPENT,
  MODAL_CREDITS_USAGE_DETAILED_LOADING,
  MODAL_CREDITS_USAGE_DETAILED_EMPTY,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_TOTAL_CREDITS,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CREDITS_BY_GROUP_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_CREDITS,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_ACCORDION_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_EMPTY_GROUPS,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CALCULATING,
  PRE_ACTIVATION_BADGE,
  PRE_ACTIVATION_SECTION_01_BUSINESS,
  PRE_ACTIVATION_SECTION_02_CURRENT_ADS,
  PRE_ACTIVATION_SECTION_03_OBJECTIVES,
  PRE_ACTIVATION_SECTION_04_MEETING_ACCESS,
  PRE_ACTIVATION_HERO_TITLE,
  PRE_ACTIVATION_HERO_DESCRIPTION,
  PRE_ACTIVATION_HERO_DESCRIPTION_AGENCY,
  PRE_ACTIVATION_FIELD_BUSINESS_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME,
  PRE_ACTIVATION_FIELD_FULL_NAME,
  PRE_ACTIVATION_FIELD_EMAIL,
  PRE_ACTIVATION_FIELD_WHATSAPP,
  PRE_ACTIVATION_FIELD_WHAT_YOU_SELL,
  PRE_ACTIVATION_HINT_WHAT_YOU_SELL,
  PRE_ACTIVATION_FIELD_AVERAGE_PRICE,
  PRE_ACTIVATION_HINT_AVERAGE_PRICE,
  PRE_ACTIVATION_FIELD_IDEAL_CUSTOMER,
  PRE_ACTIVATION_HINT_IDEAL_CUSTOMER,
  PRE_ACTIVATION_FIELD_WHERE_CUSTOMER_BUYS,
  PRE_ACTIVATION_FIELD_WEBSITE_URL,
  PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME,
  PRE_ACTIVATION_PLACEHOLDER_FULL_NAME,
  PRE_ACTIVATION_PLACEHOLDER_EMAIL,
  PRE_ACTIVATION_PLACEHOLDER_WHATSAPP,
  PRE_ACTIVATION_PLACEHOLDER_WHAT_YOU_SELL,
  PRE_ACTIVATION_PLACEHOLDER_AVERAGE_PRICE,
  PRE_ACTIVATION_PLACEHOLDER_IDEAL_CUSTOMER,
  PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL,
  PRE_ACTIVATION_SALES_CHANNEL_TIENDA_WEB,
  PRE_ACTIVATION_SALES_CHANNEL_TIENDA_FISICA,
  PRE_ACTIVATION_SALES_CHANNEL_WHATSAPP,
  PRE_ACTIVATION_SALES_CHANNEL_MARKETPLACE,
  PRE_ACTIVATION_SALES_CHANNEL_APP,
  PRE_ACTIVATION_FIELD_HAS_ADS,
  PRE_ACTIVATION_HAS_ADS_SI,
  PRE_ACTIVATION_HAS_ADS_ANTES,
  PRE_ACTIVATION_HAS_ADS_NO,
  PRE_ACTIVATION_FIELD_AD_PLATFORMS,
  PRE_ACTIVATION_ADS_PLATFORM_META,
  PRE_ACTIVATION_ADS_PLATFORM_GOOGLE,
  PRE_ACTIVATION_ADS_PLATFORM_TIKTOK,
  PRE_ACTIVATION_ADS_PLATFORM_OTHER,
  PRE_ACTIVATION_PLACEHOLDER_ADS_PLATFORM_OTHER,
  PRE_ACTIVATION_FIELD_MONTHLY_AD_SPEND,
  PRE_ACTIVATION_HINT_MONTHLY_AD_SPEND,
  PRE_ACTIVATION_FIELD_CURRENT_METRICS,
  PRE_ACTIVATION_HINT_CURRENT_METRICS,
  PRE_ACTIVATION_FIELD_TARGET_CPA,
  PRE_ACTIVATION_HINT_TARGET_CPA,
  PRE_ACTIVATION_FIELD_BEST_CAMPAIGN_MESSAGES,
  PRE_ACTIVATION_HINT_BEST_CAMPAIGN_MESSAGES,
  PRE_ACTIVATION_PLACEHOLDER_MONTHLY_AD_SPEND,
  PRE_ACTIVATION_PLACEHOLDER_CURRENT_METRICS,
  PRE_ACTIVATION_PLACEHOLDER_TARGET_CPA,
  PRE_ACTIVATION_PLACEHOLDER_BEST_CAMPAIGN_MESSAGES,
  PRE_ACTIVATION_FIELD_MONTHLY_SALES,
  PRE_ACTIVATION_FIELD_SALES_GOAL_60_90,
  PRE_ACTIVATION_FIELD_BUZZLY_FOCUS,
  PRE_ACTIVATION_BUZZLY_FOCUS_PERFORMANCE,
  PRE_ACTIVATION_BUZZLY_FOCUS_CONTENIDO,
  PRE_ACTIVATION_BUZZLY_FOCUS_AMBOS,
  PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LEVEL,
  PRE_ACTIVATION_HINT_CREATIVE_MATERIAL_LEVEL,
  PRE_ACTIVATION_CREATIVE_MATERIAL_SI_MUCHO,
  PRE_ACTIVATION_CREATIVE_MATERIAL_SI_POCO,
  PRE_ACTIVATION_CREATIVE_MATERIAL_NO_IA,
  PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LOCATION,
  PRE_ACTIVATION_FIELD_ADDITIONAL_MEETING_NOTES,
  PRE_ACTIVATION_PLACEHOLDER_MONTHLY_SALES,
  PRE_ACTIVATION_PLACEHOLDER_SALES_GOAL_60_90,
  PRE_ACTIVATION_PLACEHOLDER_CREATIVE_MATERIAL_LOCATION,
  PRE_ACTIVATION_PLACEHOLDER_ADDITIONAL_MEETING_NOTES,
  PRE_ACTIVATION_MEETING_INTRO,
  PRE_ACTIVATION_FIELD_MEETING_ACCESS,
  PRE_ACTIVATION_MEETING_ACCESS_META_BM,
  PRE_ACTIVATION_MEETING_ACCESS_GOOGLE_ADS,
  PRE_ACTIVATION_MEETING_ACCESS_TIKTOK_ADS,
  PRE_ACTIVATION_MEETING_ACCESS_GA4,
  PRE_ACTIVATION_MEETING_ACCESS_PIXEL,
  PRE_ACTIVATION_MEETING_ACCESS_GTM,
  PRE_ACTIVATION_FIELD_ACCESS_NOT_READY,
  PRE_ACTIVATION_HINT_ACCESS_NOT_READY,
  PRE_ACTIVATION_PLACEHOLDER_ACCESS_NOT_READY,
  PRE_ACTIVATION_ARIA_REQUIRED,
  PRE_ACTIVATION_SUBMIT_BUTTON,
  PRE_ACTIVATION_SUBMIT_SUCCESS_TITLE,
  PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE,
  PRE_ACTIVATION_CONFIDENTIALITY_NOTE,
  PRE_ACTIVATION_FIELD_ORGANIZATION_TYPE,
  PRE_ACTIVATION_HINT_ORGANIZATION_TYPE,
  PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY_LABEL,
  PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND_LABEL,
  PRE_ACTIVATION_SECTION_CONTACT,
  PRE_ACTIVATION_FIELD_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_01_BASICS,
  PRE_ACTIVATION_SECTION_AGENCY_02_LIVE_EXERCISE,
  PRE_ACTIVATION_SECTION_AGENCY_03_OPERATIONS,
  PRE_ACTIVATION_SECTION_AGENCY_04_MEETING_ACCESS,
  PRE_ACTIVATION_FIELD_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_HINT_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS,
  PRE_ACTIVATION_FIELD_AGENCY_MODULES,
  PRE_ACTIVATION_HINT_AGENCY_MODULES,
  PRE_ACTIVATION_AGENCY_MODULE_CREATIVE,
  PRE_ACTIVATION_AGENCY_MODULE_PAID_MEDIA,
  PRE_ACTIVATION_AGENCY_MODULE_ORGANIC_SOCIAL,
  PRE_ACTIVATION_AGENCY_MODULE_COMPETITOR_ADS,
  PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_BRAND_ASSETS_READY,
  PRE_ACTIVATION_HINT_AGENCY_BRAND_ASSETS_READY,
  PRE_ACTIVATION_FIELD_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_HINT_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_FIELD_AGENCY_USES_AD_AUTOMATION,
  PRE_ACTIVATION_HINT_AGENCY_USES_AD_AUTOMATION,
  PRE_ACTIVATION_OPTION_YES,
  PRE_ACTIVATION_OPTION_NO,
  PRE_ACTIVATION_BEFORE_START_LABEL,
  PRE_ACTIVATION_BEFORE_START_TITLE,
  PRE_ACTIVATION_BEFORE_START_INTRO,
  PRE_ACTIVATION_BEFORE_START_TIP_1_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_1_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_2_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_2_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_3_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_3_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_4_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_4_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_5_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_5_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_CALLOUT,
  PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN,
  PRE_ACTIVATION_FIELD_AGENCY_PHONE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_PHONE,
  PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_FIELD_AGENCY_BACKUP_CONTACT,
  PRE_ACTIVATION_HINT_AGENCY_BACKUP_CONTACT,
  PRE_ACTIVATION_FIELD_AGENCY_LEADERSHIP_CONTACT,
  PRE_ACTIVATION_HINT_AGENCY_LEADERSHIP_CONTACT,
  PRE_ACTIVATION_SECTION_CONTACT_DESCRIPTION_AGENCY,
  PRE_ACTIVATION_SECTION_AGENCY_02_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_02_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_03_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_03_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_04_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_04_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_04_DESCRIPTION,
  PRE_ACTIVATION_SECTION_AGENCY_05_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_05_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_05_DESCRIPTION,
  PRE_ACTIVATION_SECTION_AGENCY_06_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_06_HEADING,
  PRE_ACTIVATION_FIELD_AGENCY_USER_FULL_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_USER_EMAIL,
  PRE_ACTIVATION_FIELD_AGENCY_TEAM_FAMILIARITY,
  PRE_ACTIVATION_HINT_AGENCY_TEAM_FAMILIARITY,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_ADVANCED,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INTERMEDIATE,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INITIAL,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_MIXED,
  PRE_ACTIVATION_AGENCY_TEAM_CALLOUT,
  PRE_ACTIVATION_FIELD_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_HINT_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_AGENCY_SCHEDULE_BUTTON,
  PRE_ACTIVATION_AGENCY_SCHEDULE_LOCKED_HINT,
  PRE_ACTIVATION_ONBOARDING_MODAL_ARIA_LABEL,
  PRE_ACTIVATION_ONBOARDING_MODAL_TITLE,
  PRE_ACTIVATION_ONBOARDING_MODAL_DESCRIPTION,
  PRE_ACTIVATION_SCHEDULED_SESSION_TITLE,
  PRE_ACTIVATION_SCHEDULED_SESSION_DATE,
  PRE_ACTIVATION_SCHEDULED_SESSION_TIME,
  PRE_ACTIVATION_SCHEDULED_SESSION_MISSING,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_SINGLE_BRAND,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_ACCOUNT_ADMIN,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_RESCHEDULE,
  PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE_AGENCY,
  OWNER_FORM_SUBMISSION_COLUMN_ORGANIZATION_TYPE,
  TIKTOK_ADGROUP_PLACEMENTS_TITLE,
  TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_LABEL,
  TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_DESCRIPTION,
  TIKTOK_ADGROUP_PLACEMENTS_PANGLE_LABEL,
  TIKTOK_ADGROUP_PLACEMENTS_PANGLE_DESCRIPTION,
  POST,
  ALERT_IMAGE_PROVIDER_STATUS_BANNER,
  ALERT_VIDEO_PROVIDER_STATUS_BANNER,
  ALERT_CAMPAIGN_PROVIDER_STATUS_BANNER,
  WHATSAPP,
  ID_PLATFORM,
  APPSUMO_CALLBACK_CONNECTING,
  APPSUMO_CALLBACK_ERROR_TITLE,
  APPSUMO_CALLBACK_ERROR_DESCRIPTION,
  APPSUMO_CALLBACK_ERROR_CODE_EXPIRED,
  APPSUMO_CALLBACK_ERROR_OAUTH_DENIED,
  APPSUMO_CALLBACK_BUTTON_RETURN_TO_APPSUMO,
  APPSUMO_CALLBACK_ERROR_ANOMALOUS,
  APPSUMO_REGISTER_TITLE,
  APPSUMO_REGISTER_SUBTITLE,
  APPSUMO_REGISTER_BUTTON_SUBMIT,
  APPSUMO_REGISTER_SESSION_EXPIRED,
  APP_SUMO_REACTIVATION_NOT_ELIGIBLE,
  APPSUMO_REACTIVATION_OTP_TITLE,
  APPSUMO_REACTIVATION_OTP_EMAIL_SENT,
  BUTTON_HIRE_PERFORMANCE_SPECIALIST,
  MODAL_PERFORMANCE_SPECIALIST_ARIA_LABEL,
  MODAL_PERFORMANCE_SPECIALIST_TITLE,
  MODAL_PERFORMANCE_SPECIALIST_SUBTITLE,
  MODAL_PERFORMANCE_SPECIALIST_WHAT_YOU_GET_TITLE,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_1,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_2,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_3,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_4,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_TITLE,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_MAIN,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_1,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_2,
  MODAL_PERFORMANCE_SPECIALIST_CTA,
  MODAL_AD_HOC_SUPPORT_ARIA_LABEL,
  MODAL_AD_HOC_SUPPORT_TITLE,
  MODAL_AD_HOC_SUPPORT_DESCRIPTION,
  BILLING_SPECIALIST_PURCHASE_SUCCESS_TITLE,
  BILLING_SPECIALIST_PURCHASE_SUCCESS_DESCRIPTION,
  BILLING_SPECIALIST_SCHEDULE_MEETING_BUTTON,
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY_LABEL,
  ALERT_AD_ACCOUNT_NO_BALANCE_LABEL,
  MODAL_CREATE_WITH_IA_LABEL_VIDEO_DURATION_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_12_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_15_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_20_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_25_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_30_SECONDS,
  ENTERPRISE_INTAKE_BADGE,
  ENTERPRISE_INTAKE_BADGE_AGENCY,
  ENTERPRISE_INTAKE_BADGE_BRAND,
  ENTERPRISE_INTAKE_HERO_TITLE,
  ENTERPRISE_INTAKE_HERO_DESCRIPTION,
  ENTERPRISE_INTAKE_SECTION_01_CONTACT,
  ENTERPRISE_INTAKE_SECTION_03_USERS,
  ENTERPRISE_INTAKE_SECTION_04_SUPPORT_CONTRACT,
  ENTERPRISE_INTAKE_SECTION_05_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_ARIA_REQUIRED,
  ENTERPRISE_INTAKE_SUBMIT_BUTTON,
  ENTERPRISE_INTAKE_SUBMIT_SUCCESS_TITLE,
  ENTERPRISE_INTAKE_SUBMIT_SUCCESS_MESSAGE,
  ENTERPRISE_INTAKE_CONFIDENTIALITY_NOTE,
  ENTERPRISE_INTAKE_OTHER_OPTION,
  ENTERPRISE_INTAKE_OTHER_PLACEHOLDER,
  ENTERPRISE_INTAKE_FIELD_FULL_NAME,
  ENTERPRISE_INTAKE_FIELD_CORPORATE_EMAIL,
  ENTERPRISE_INTAKE_FIELD_COMPANY_NAME,
  ENTERPRISE_INTAKE_FIELD_JOB_TITLE,
  ENTERPRISE_INTAKE_FIELD_COMPANY_WEBSITE,
  ENTERPRISE_INTAKE_PLACEHOLDER_FULL_NAME,
  ENTERPRISE_INTAKE_PLACEHOLDER_CORPORATE_EMAIL,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME,
  ENTERPRISE_INTAKE_PLACEHOLDER_JOB_TITLE,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_WEBSITE,
  ENTERPRISE_INTAKE_FIELD_PURCHASE_DECISION_MAKER,
  ENTERPRISE_INTAKE_PURCHASE_DECISION_SELF,
  ENTERPRISE_INTAKE_PURCHASE_DECISION_COLLECT_INFO,
  ENTERPRISE_INTAKE_PURCHASE_DECISION_SHARED,
  ENTERPRISE_INTAKE_FIELD_CURRENT_TOOL_OR_ADLE_STATUS,
  ENTERPRISE_INTAKE_CURRENT_TOOL_ADLE_CLIENT,
  ENTERPRISE_INTAKE_CURRENT_TOOL_EVALUATING_SWITCH,
  ENTERPRISE_INTAKE_CURRENT_TOOL_NO_SIMILAR,
  ENTERPRISE_INTAKE_FIELD_OPERATING_COUNTRIES_COUNT,
  ENTERPRISE_INTAKE_PLACEHOLDER_OPERATING_COUNTRIES_COUNT,
  ENTERPRISE_INTAKE_FIELD_CREATIVES_VARY_BY_MARKET,
  ENTERPRISE_INTAKE_CREATIVES_VARY_YES_PER_MARKET,
  ENTERPRISE_INTAKE_CREATIVES_VARY_PARTIALLY,
  ENTERPRISE_INTAKE_CREATIVES_VARY_NO_SAME_MATERIAL,
  ENTERPRISE_INTAKE_CREATIVES_VARY_NOT_APPLICABLE,
  ENTERPRISE_INTAKE_SECTION_02_MODULE_SELECTOR,
  ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES,
  ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES,
  ENTERPRISE_INTAKE_MODULE_CREATIVE_ASSETS,
  ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_LAUNCH,
  ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_IMPORT,
  ENTERPRISE_INTAKE_MODULE_ORGANIC_SOCIAL,
  ENTERPRISE_INTAKE_FIELD_PRIMARY_GOAL,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_CREATIVE_SPEED,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_PERFORMANCE,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_SCALE_MULTIPLATFORM,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_REDUCE_COSTS,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_CENTRALIZE_OPERATIONS,
  ENTERPRISE_INTAKE_VOLUME_STABLE_YEAR_ROUND,
  ENTERPRISE_INTAKE_VOLUME_PEAK_DEMAND,
  ENTERPRISE_INTAKE_SECTION_MODULE_1_CREATIVE_ASSETS,
  ENTERPRISE_INTAKE_MODULE1_INTRO,
  ENTERPRISE_INTAKE_MODULE1_FIELD_BRANDS_OR_VISUAL_IDENTITIES_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_INDEPENDENT_BRAND_CONFIGS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_INDEPENDENT_BRAND_CONFIGS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_NEW_IMAGES_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_FORMATS_PER_PIECE_AVG,
  ENTERPRISE_INTAKE_MODULE1_HINT_FORMATS_PER_PIECE,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_ADDITIONAL_EDITS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_ADDITIONAL_EDITS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_VIDEOS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_VIDEOS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_IMAGE_ANIMATIONS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_IMAGE_ANIMATIONS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_VERSIONS_PER_PIECE_BEFORE_APPROVAL,
  ENTERPRISE_INTAKE_MODULE1_HINT_VERSIONS_PER_PIECE,
  ENTERPRISE_INTAKE_MODULE1_FIELD_CREATIVE_VOLUME_VARIATION,
  ENTERPRISE_INTAKE_MODULE1_FIELD_PEAK_MONTH_PIECES_COUNT,
  ENTERPRISE_INTAKE_SECTION_MODULE_2_PAID_MEDIA_LAUNCH,
  ENTERPRISE_INTAKE_MODULE2_INTRO,
  ENTERPRISE_INTAKE_MODULE2_FIELD_AD_ACCOUNTS_OR_ADVERTISERS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_CAMPAIGNS,
  ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_OPTIMIZATIONS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_MODULE2_FIELD_CAMPAIGN_VOLUME_VARIATION,
  ENTERPRISE_INTAKE_MODULE2_FIELD_PEAK_MONTH_CAMPAIGNS_COUNT,
  ENTERPRISE_INTAKE_SECTION_MODULE_3_PAID_MEDIA_IMPORT,
  ENTERPRISE_INTAKE_MODULE3_INTRO,
  ENTERPRISE_INTAKE_MODULE3_FIELD_CAMPAIGNS_TO_IMPORT,
  ENTERPRISE_INTAKE_MODULE3_FIELD_IMPORT_PLATFORMS,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_META,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_GOOGLE,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_TIKTOK,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_LINKEDIN,
  ENTERPRISE_INTAKE_SECTION_MODULE_4_ORGANIC_SOCIAL,
  ENTERPRISE_INTAKE_MODULE4_INTRO,
  ENTERPRISE_INTAKE_MODULE4_FIELD_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_MODULE4_FIELD_SCHEDULING_NETWORKS,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_INSTAGRAM,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_FACEBOOK,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_TIKTOK,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_LINKEDIN,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_X_TWITTER,
  ENTERPRISE_INTAKE_MODULE4_FIELD_POST_CREATION_SOURCE,
  ENTERPRISE_INTAKE_MODULE4_POST_CREATED_IN_ADLE,
  ENTERPRISE_INTAKE_MODULE4_POST_READY_TO_SCHEDULE,
  ENTERPRISE_INTAKE_MODULE4_POST_MIXED,
  ENTERPRISE_INTAKE_FIELD_ACTIVE_ADVERTISERS_MONTH1,
  ENTERPRISE_INTAKE_HINT_ACTIVE_ADVERTISERS_MONTH1,
  ENTERPRISE_INTAKE_FIELD_TOTAL_ADVERTISERS_60_90,
  ENTERPRISE_INTAKE_HINT_TOTAL_ADVERTISERS_60_90,
  ENTERPRISE_INTAKE_FIELD_ADMIN_ACCESS_PHASE1,
  ENTERPRISE_INTAKE_ADMIN_ACCESS_ALL,
  ENTERPRISE_INTAKE_ADMIN_ACCESS_MOST,
  ENTERPRISE_INTAKE_ADMIN_ACCESS_SOME,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_CAPACITY_MANAGEMENT,
  ENTERPRISE_INTAKE_PLATFORM_CAPACITY_CENTRALIZED_POOL,
  ENTERPRISE_INTAKE_PLATFORM_CAPACITY_ASSIGNED_QUOTAS,
  ENTERPRISE_INTAKE_CREDITS_MIXED,
  ENTERPRISE_INTAKE_CREDITS_EQUIVALENCES_TITLE,
  ENTERPRISE_INTAKE_CREDITS_RENEWAL_NOTE,
  ENTERPRISE_INTAKE_CREDITS_UNCERTAIN_NOTE,
  ENTERPRISE_INTAKE_VOLUME_ZERO,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_ESTIMATED_CREDITS,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_IMAGES,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_IMAGES,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_VIDEOS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_VIDEOS,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_CAMPAIGNS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_CAMPAIGNS,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_FIELD_USES_ORGANIC_SCHEDULING,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_ESTIMATED_CREDITS,
  ENTERPRISE_INTAKE_FIELD_PHASE1_PAID_CHANNELS,
  ENTERPRISE_INTAKE_HINT_PHASE1_PAID_CHANNELS,
  ENTERPRISE_INTAKE_CHANNEL_META,
  ENTERPRISE_INTAKE_CHANNEL_GOOGLE,
  ENTERPRISE_INTAKE_CHANNEL_TIKTOK,
  ENTERPRISE_INTAKE_CHANNEL_LINKEDIN,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AD_SPEND_RANGE,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AD_SPEND_RANGE,
  ENTERPRISE_INTAKE_AD_SPEND_LESS_THAN_10K,
  ENTERPRISE_INTAKE_AD_SPEND_MORE_THAN_500K,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_MANAGEMENT,
  ENTERPRISE_INTAKE_HINT_PLATFORM_MANAGEMENT,
  ENTERPRISE_INTAKE_PLATFORM_MGMT_OWN_TEAM,
  ENTERPRISE_INTAKE_PLATFORM_MGMT_THIRD_PARTY,
  ENTERPRISE_INTAKE_PLATFORM_MGMT_ADLE_OPERATES,
  ENTERPRISE_INTAKE_FIELD_WHITE_LABEL,
  ENTERPRISE_INTAKE_HINT_WHITE_LABEL,
  ENTERPRISE_INTAKE_WHITE_LABEL_ESSENTIAL,
  ENTERPRISE_INTAKE_WHITE_LABEL_INTERESTED,
  ENTERPRISE_INTAKE_WHITE_LABEL_NOT_NEEDED,
  ENTERPRISE_INTAKE_WHITE_LABEL_UNSURE,
  ENTERPRISE_INTAKE_FIELD_URGENCY_DEADLINE,
  ENTERPRISE_INTAKE_PLACEHOLDER_URGENCY_DEADLINE,
  ENTERPRISE_INTAKE_FIELD_ESTIMATED_TOOL_BUDGET,
  ENTERPRISE_INTAKE_HINT_ESTIMATED_TOOL_BUDGET,
  ENTERPRISE_INTAKE_BUDGET_LT_1000,
  ENTERPRISE_INTAKE_BUDGET_1000_2500,
  ENTERPRISE_INTAKE_BUDGET_2500_5000,
  ENTERPRISE_INTAKE_BUDGET_5000_10000,
  ENTERPRISE_INTAKE_BUDGET_GT_10000,
  ENTERPRISE_INTAKE_BUDGET_NOT_DEFINED,
  ENTERPRISE_INTAKE_BUDGET_PREFER_NOT_ANSWER,
  ENTERPRISE_INTAKE_FIELD_SUPPORT_LEVEL,
  ENTERPRISE_INTAKE_SUPPORT_TECH_ONLY,
  ENTERPRISE_INTAKE_SUPPORT_PARTIAL,
  ENTERPRISE_INTAKE_SUPPORT_FULL_OPERATION,
  ENTERPRISE_INTAKE_FIELD_CSM_CADENCE,
  ENTERPRISE_INTAKE_CSM_WEEKLY,
  ENTERPRISE_INTAKE_CSM_BIWEEKLY,
  ENTERPRISE_INTAKE_CSM_MONTHLY,
  ENTERPRISE_INTAKE_CSM_AS_NEEDED,
  ENTERPRISE_INTAKE_FIELD_CONTRACT_FORMAT,
  ENTERPRISE_INTAKE_CONTRACT_MONTHLY,
  ENTERPRISE_INTAKE_CONTRACT_QUARTERLY,
  ENTERPRISE_INTAKE_CONTRACT_ANNUAL,
  ENTERPRISE_INTAKE_FIELD_IMPLEMENTATION_TIMELINE,
  ENTERPRISE_INTAKE_HINT_IMPLEMENTATION_TIMELINE,
  ENTERPRISE_INTAKE_TIMELINE_0_3_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_4_7_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_8_15_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_16_30_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_30_PLUS_DAYS,
  ENTERPRISE_INTAKE_FIELD_SECURITY_REQUIREMENTS,
  ENTERPRISE_INTAKE_SECURITY_SSO,
  ENTERPRISE_INTAKE_SECURITY_AUDIT_LOGS,
  ENTERPRISE_INTAKE_SECURITY_NOT_APPLICABLE,
  ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_FOOTNOTE_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_HINT_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_MODULE_REPORTS,
  ENTERPRISE_INTAKE_MODULE_COMPETITORS,
  ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT,
  ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT_AGENCY,
  ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_AGENCY,
  ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_BRAND,
  ENTERPRISE_INTAKE_PLACEHOLDER_SCOPE_BRANDS_COUNT,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME_BRAND,
  ENTERPRISE_INTAKE_HINT_MONTHLY_STATIC_PIECES,
  ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER,
  ENTERPRISE_INTAKE_HINT_CREATIVES_BUFFER,
  ENTERPRISE_INTAKE_BUFFER_STATICS,
  ENTERPRISE_INTAKE_BUFFER_ANIMATIONS,
  ENTERPRISE_INTAKE_BUFFER_VIDEOS,
  ENTERPRISE_INTAKE_BUFFER_NONE,
  ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER_PERCENT,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_10,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_15,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_20,
  ENTERPRISE_INTAKE_PLACEHOLDER_BUFFER_PERCENT_OTHER,
  ENTERPRISE_INTAKE_HINT_CAMPAIGNS_SECTION,
  ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_AGENCY,
  ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_BRAND,
  ENTERPRISE_INTAKE_FIELD_OPTIMIZATION_FREQUENCY,
  ENTERPRISE_INTAKE_HINT_OPTIMIZATION_FREQUENCY,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_LOW,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_MEDIUM,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_HIGH,
  ENTERPRISE_INTAKE_HINT_PLATFORM_USERS_COUNT,
  ENTERPRISE_INTAKE_HINT_CONTRACT_TERM,
  ENTERPRISE_INTAKE_CONTRACT_TERM_6,
  ENTERPRISE_INTAKE_CONTRACT_TERM_12,
  ENTERPRISE_INTAKE_FIELD_MEDIA_MANAGEMENT_ADDON,
  ENTERPRISE_INTAKE_HINT_MEDIA_MANAGEMENT_ADDON,
  ENTERPRISE_INTAKE_MEDIA_ADDON_YES,
  ENTERPRISE_INTAKE_MEDIA_ADDON_NO,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_MEDIA_SPEND,
  ENTERPRISE_INTAKE_PLACEHOLDER_MONTHLY_MEDIA_SPEND,
  ENTERPRISE_INTAKE_WHITE_LABEL_YES,
  ENTERPRISE_INTAKE_WHITE_LABEL_NO,
  ENTERPRISE_INTAKE_SECTION_PLAN,
  OWNER_FORM_SUBMISSION_TYPE_PRE_ACTIVATION,
  OWNER_FORM_SUBMISSION_TYPE_ENTERPRISE,
  OPTION_EMAIL,
  OPTION_META,
  OPTION_LINKEDIN,
  OPTION_GOOGLE,
  OPTION_LLM,
  OPTION_OTHER,
  GLOBAL_REPORT_TITLE,
  GLOBAL_REPORT_DESCRIPTION,
  GLOBAL_REPORT_MENU_GROUP,
  GLOBAL_REPORT_MENU_ITEM,
  GLOBAL_REPORT_PAGE_TITLE,
  GLOBAL_REPORT_PERIOD_LAST_7_DAYS,
  GLOBAL_REPORT_PERIOD_LAST_14_DAYS,
  GLOBAL_REPORT_PERIOD_LAST_30_DAYS,
  GLOBAL_REPORT_AI_ANALYSIS,
  GLOBAL_REPORT_OBJECTIVES_BUTTON,
  GLOBAL_REPORT_TOTAL_INVESTMENT,
  GLOBAL_REPORT_AVERAGE_ROAS,
  GLOBAL_REPORT_ACTIVE_CAMPAIGNS,
  GLOBAL_REPORT_REMAINING_BUDGET,
  GLOBAL_REPORT_BUDGET_EXPIRES_IN,
  GLOBAL_REPORT_PAUSED_CAMPAIGNS,
  GLOBAL_REPORT_VS_PREVIOUS_WEEK,
  GLOBAL_REPORT_AGENT_INSIGHTS,
  GLOBAL_REPORT_NEW_INSIGHTS,
  GLOBAL_REPORT_NO_INSIGHTS,
  GLOBAL_REPORT_INSIGHTS_ERROR,
  GLOBAL_REPORT_SUMMARY_TITLE,
  GLOBAL_REPORT_SUMMARY_OVERVIEW_TEXT,
  GLOBAL_REPORT_INSIGHTS_QUESTION,
  GLOBAL_REPORT_GENERATING_SUMMARY,
  GLOBAL_REPORT_SUMMARY_NOT_GENERATED,
  GLOBAL_REPORT_ASK_QUESTION,
  GLOBAL_REPORT_ASK_QUESTION_OPEN,
  GLOBAL_REPORT_VIEW_HISTORICAL_INSIGHTS,
  GLOBAL_REPORT_AGENT_ACTIONS,
  GLOBAL_REPORT_ACTIONS_PERFORMED,
  GLOBAL_REPORT_ACTION_TYPE_GENERATE_CAMPAIGN,
  GLOBAL_REPORT_ACTION_TYPE_CREATIVES,
  GLOBAL_REPORT_ACTION_TYPE_VIDEOS,
  GLOBAL_REPORT_ACTION_TYPE_MESSAGES,
  GLOBAL_REPORT_ACTION_TYPE_OPTIMIZATIONS_APPLIED,
  GLOBAL_REPORT_ACTION_TYPE_GENERIC,
  GLOBAL_REPORT_ACTION_CREATIVES_SUBTITLE,
  GLOBAL_REPORT_ACTION_VIDEOS_SUBTITLE,
  GLOBAL_REPORT_ACTION_MESSAGES_SUBTITLE,
  GLOBAL_REPORT_ACTION_GENERIC_SUBTITLE,
  GLOBAL_REPORT_NO_ACTIONS_IN_PERIOD,
  GLOBAL_REPORT_NO_CAMPAIGNS_IN_PERIOD,
  GLOBAL_REPORT_NO_ACTIVITY_IN_PERIOD,
  GLOBAL_REPORT_SELECT_DATES_PROMPT,
  GLOBAL_REPORT_MEASURABLE_KPI_LABEL,
  GLOBAL_REPORT_MEASURABLE_KPI_ALL,
  GLOBAL_REPORT_NO_CAMPAIGNS_FOR_KPI,
  GLOBAL_REPORT_DOWNLOAD_NOT_READY,
  GLOBAL_REPORT_PDF_OPTION,
  GLOBAL_REPORT_CUSTOM_OPTION,
  GLOBAL_REPORT_SERVER_PDF_BUTTON,
  GLOBAL_REPORT_SERVER_PDF_FOOTER,
  GLOBAL_REPORT_SERVER_PDF_FILE_NAME,
  MODAL_CUSTOM_REPORT_CTA,
  MODAL_CUSTOM_REPORT_TITLE,
  MODAL_CUSTOM_REPORT_DESCRIPTION,
  MODAL_CUSTOM_REPORT_TEMPLATE,
  MODAL_CUSTOM_REPORT_TEMPLATE_GENERAL,
  MODAL_CUSTOM_REPORT_TEMPLATE_SALES,
  MODAL_CUSTOM_REPORT_TEMPLATE_LEADS,
  MODAL_CUSTOM_REPORT_TEMPLATE_CUSTOM,
  MODAL_CUSTOM_REPORT_PROMPT,
  MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER,
  MODAL_CUSTOM_REPORT_USE_PREVIOUS_PROMPT,
  MODAL_CUSTOM_REPORT_DATES,
  MODAL_CUSTOM_REPORT_FORMAT,
  MODAL_CUSTOM_REPORT_LANGUAGE,
  MODAL_CUSTOM_REPORT_FORMAT_PDF,
  MODAL_CUSTOM_REPORT_FORMAT_PPTX,
  MODAL_CUSTOM_REPORT_FORMAT_CSV,
  MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER_CSV,
  MODAL_CUSTOM_REPORT_PDF_UNAVAILABLE,
  MODAL_CUSTOM_REPORT_COLLECTING,
  MODAL_CUSTOM_REPORT_ANALYZING,
  MODAL_CUSTOM_REPORT_RENDERING,
  MODAL_CUSTOM_REPORT_ERROR,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_TITLE,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DESCRIPTION,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_EMPTY,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_TITLE,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_DESCRIPTION,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE,
  GLOBAL_REPORT_HEAVY_LOAD_FETCHING_CAMPAIGNS,
  GLOBAL_REPORT_HEAVY_LOAD_FETCHING_STATS,
  GLOBAL_REPORT_HEAVY_LOAD_ANALYZING,
  GLOBAL_REPORT_HEAVY_LOAD_GENERATING_INSIGHTS,
  GLOBAL_REPORT_ACTIVE_CAMPAIGNS_TABLE,
  GLOBAL_REPORT_CAMPAIGNS_TABLE,
  GLOBAL_REPORT_COLUMN_CAMPAIGN,
  GLOBAL_REPORT_COLUMN_INVESTMENT,
  GLOBAL_REPORT_COLUMN_ROAS,
  GLOBAL_REPORT_COLUMN_IMPRESSIONS,
  GLOBAL_REPORT_COLUMN_CTR,
  GLOBAL_REPORT_COLUMN_STATUS,
  GLOBAL_REPORT_STATUS_ALERT,
  GLOBAL_REPORT_STATUS_OPTIMAL,
  GLOBAL_REPORT_STATUS_BRAND,
  GLOBAL_REPORT_INSIGHT_ROAS_DROP_TITLE,
  GLOBAL_REPORT_INSIGHT_ROAS_DROP_DESCRIPTION,
  GLOBAL_REPORT_INSIGHT_CPC_PEAK_TITLE,
  GLOBAL_REPORT_INSIGHT_CPC_PEAK_DESCRIPTION,
  GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_TITLE,
  GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_DESCRIPTION,
  GLOBAL_REPORT_ACTION_DATE_TODAY,
  GLOBAL_REPORT_ACTION_DATE_YESTERDAY,
  GLOBAL_REPORT_ACTION_DATE_MAR_26,
  GLOBAL_REPORT_ACTION_DATE_MAR_25,
  GLOBAL_REPORT_ACTION_CAMPAIGNS_CREATED,
  GLOBAL_REPORT_ACTION_IMAGES_GENERATED,
  GLOBAL_REPORT_ACTION_VIDEOS_PRODUCED,
  GLOBAL_REPORT_ACTION_OPTIMIZATION_APPLIED,
  GLOBAL_REPORT_DEFAULT_BRAND_NAME,
  GLOBAL_REPORT_STATS_TIME_TITLE,
  GLOBAL_REPORT_STATS_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_DAILY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_WEEKLY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_MONTHLY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_DAILY_RESULTS_SUBTITLE,
  GLOBAL_REPORT_STATS_WEEKLY_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_MONTHLY_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_TITLE,
  GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_WEEKLY_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_MONTHLY_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_PLATFORM_TITLE,
  GLOBAL_REPORT_STATS_PLATFORM_SUBTITLE,
  GLOBAL_REPORT_STATS_PLATFORM_CPA_TITLE,
  GLOBAL_REPORT_STATS_PLATFORM_SPEND_TITLE,
  GLOBAL_REPORT_STATS_CREATIVES_TITLE,
  GLOBAL_REPORT_STATS_CREATIVES_SUBTITLE,
  GLOBAL_REPORT_STATS_CREATIVES_LOWEST_CPA_TITLE,
  GLOBAL_REPORT_STATS_CREATIVES_HIGHEST_VOLUME_TITLE,
  GLOBAL_REPORT_STATS_RADAR_TITLE,
  GLOBAL_REPORT_STATS_RADAR_SUBTITLE,
  GLOBAL_REPORT_STATS_BELOW_AVERAGE,
  GLOBAL_REPORT_STATS_ABOVE_AVERAGE,
  GLOBAL_REPORT_STATS_NO_DATA,
  GLOBAL_REPORT_STATS_SPEND_AXIS,
  GLOBAL_REPORT_STATS_IMPRESSIONS_AXIS,
  GLOBAL_REPORT_STATS_SPEND_DISTRIBUTION,
  GLOBAL_REPORT_GOALS_TITLE,
  GLOBAL_REPORT_GOALS_SUBTITLE,
  GLOBAL_REPORT_GOALS_STACKED_TITLE,
  GLOBAL_REPORT_GOALS_STACKED_SUBTITLE,
  GLOBAL_REPORT_GOALS_PROJECTION_TITLE,
  GLOBAL_REPORT_GOALS_PROJECTION_SUBTITLE,
  GLOBAL_REPORT_GOALS_ACHIEVED,
  GLOBAL_REPORT_GOALS_REMAINING,
  GLOBAL_REPORT_GOALS_EXCEEDED,
  GLOBAL_REPORT_GOALS_PROJECTION_ACTUAL,
  GLOBAL_REPORT_GOALS_PROJECTION_FORECAST,
  GLOBAL_REPORT_GOALS_TARGET_LINE,
  GLOBAL_REPORT_GOALS_CONFIGURE_PROMPT,
  GLOBAL_REPORT_GOALS_CONFIGURE_BUTTON,
  GLOBAL_REPORT_GOALS_KPI_MISMATCH_PROMPT,
  VERIFICATION_CODE_INCORRECT,
  REGISTRATION_EMAIL_NOT_VERIFIED,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_PRODUCTS,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_SERVICES,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_URL,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_UPLOAD,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_URL,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_UPLOAD,
  ORGANIC,
  ADVERTISER_SELECTOR_BRANDS_COUNT_SINGLE,
  ANIMATE,
  CAMPAIGN_APPROVAL_PAGE_TITLE,
  CAMPAIGN_APPROVAL_PAGE_DESCRIPTION,
  CAMPAIGN_APPROVAL_INVALID_TITLE,
  CAMPAIGN_APPROVAL_INVALID_DESCRIPTION,
  CAMPAIGN_APPROVAL_EXPIRED_TITLE,
  CAMPAIGN_APPROVAL_EXPIRED_DESCRIPTION,
  CAMPAIGN_APPROVAL_CONTENT_EMPTY,
  CAMPAIGN_APPROVAL_LOADING_FETCHING_CAMPAIGN_DATA,
  CAMPAIGN_APPROVAL_LOADING_PREPARING_REVIEW,
  CAMPAIGN_APPROVAL_GENERAL_COMMENT_TITLE,
  CAMPAIGN_APPROVAL_GENERAL_COMMENT_DESCRIPTION,
  CAMPAIGN_APPROVAL_COMMENT_PLACEHOLDER,
  CAMPAIGN_APPROVAL_COMMENT_BUTTON,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_TITLE,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_DESCRIPTION,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_PLACEHOLDER,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_BUTTON,
  CAMPAIGN_APPROVAL_DECISION_TITLE,
  CAMPAIGN_APPROVAL_DECISION_DESCRIPTION,
  CAMPAIGN_APPROVAL_DECISION_PLACEHOLDER,
  CAMPAIGN_APPROVAL_APPROVE_BUTTON,
  CAMPAIGN_APPROVAL_REJECT_BUTTON,
  CAMPAIGN_APPROVAL_TEXTS_TITLE,
  CAMPAIGN_APPROVAL_DESTINATION_TITLE,
  CAMPAIGN_APPROVAL_LEAD_FORM_PREVIEW_UNAVAILABLE,
  CAMPAIGN_APPROVAL_CREATIVES_TITLE,
  CAMPAIGN_APPROVAL_CREATIVE_TITLE,
  CAMPAIGN_APPROVAL_SLIDE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_TITLE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_HEADLINE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_LONG_HEADLINE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_DESCRIPTION_LABEL,
  CAMPAIGN_APPROVAL_FIELD_CREATIVE_LABEL,
  CAMPAIGN_APPROVAL_LOCKED_STATUS_APPROVED,
  CAMPAIGN_APPROVAL_LOCKED_STATUS_REJECTED,
  CAMPAIGN_APPROVAL_LOCKED_STATUS_DECIDED,
  CAMPAIGN_APPROVAL_TARGET_ENTITY_AD,
  CAMPAIGN_APPROVAL_TARGET_ENTITY_ASSETS_GROUP,
  CAMPAIGN_APPROVAL_CONTROLS_TITLE,
  CAMPAIGN_APPROVAL_CONTROLS_DESCRIPTION,
  CAMPAIGN_APPROVAL_INACTIVE_DESCRIPTION,
  CAMPAIGN_APPROVAL_STATE_INACTIVE,
  CAMPAIGN_APPROVAL_STATE_ACTIVE,
  CAMPAIGN_APPROVAL_SHARED_LINK_LABEL,
  CAMPAIGN_APPROVAL_CONFIRM_ENABLE_TITLE,
  CAMPAIGN_APPROVAL_CONFIRM_ENABLE_DESCRIPTION,
  CAMPAIGN_APPROVAL_ENABLE_BUTTON,
  CAMPAIGN_APPROVAL_COPY_LINK_BUTTON,
  CAMPAIGN_APPROVAL_COPY_LINK_COPIED,
  CAMPAIGN_APPROVAL_REJECTED_DESCRIPTION,
  CAMPAIGN_APPROVAL_APPROVED_DESCRIPTION,
  CAMPAIGN_APPROVAL_PENDING_DESCRIPTION,
  CAMPAIGN_APPROVAL_VIEW_COMMENTS_BUTTON,
  CAMPAIGN_APPROVAL_VIEW_REVIEW_BUTTON,
  CAMPAIGN_APPROVAL_STATUS_PENDING,
  CAMPAIGN_APPROVAL_STATUS_APPROVED,
  CAMPAIGN_APPROVAL_STATUS_REJECTED,
  GALLERY_CONTENT_APPROVAL_STATUS_REJECTED,
  CAMPAIGN_APPROVAL_PANEL_TITLE,
  CAMPAIGN_APPROVAL_PANEL_DESCRIPTION,
  CAMPAIGN_APPROVAL_PANEL_EMPTY,
  CAMPAIGN_APPROVAL_PANEL_STALE_TOGGLE,
  CAMPAIGN_APPROVAL_PANEL_CURRENT_DRAFT,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_PENDING,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_APPROVED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_REJECTED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_PENDING,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_APPROVED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_REJECTED,
  CAMPAIGN_APPROVAL_STALE_LABEL,
  CAMPAIGN_APPROVAL_PUBLISH_BLOCKED_BANNER,
  CAMPAIGN_APPROVAL_AD_PREVIEW_TITLE,
  CAMPAIGN_APPROVAL_AD_PREVIEW_ERROR,
  CAMPAIGN_APPROVAL_SEND_FOR_REVIEW,
  CONTENT_APPROVAL_PAGE_TITLE,
  CONTENT_APPROVAL_REPLACE_BUTTON,
  CONTENT_APPROVAL_EDIT_BUTTON,
  CONTENT_APPROVAL_SAVE_REVISION_BUTTON,
  CONTENT_APPROVAL_SAVE_REVISION_SUCCESS_DESCRIPTION,
  CONTENT_APPROVAL_APPROVE_CONTENT_BUTTON,
  CONTENT_APPROVAL_SIDEBAR_TITLE,
  CONTENT_APPROVAL_ALL_GOOD_QUESTION,
  CONTENT_APPROVAL_CONFIRM_ENABLE_TITLE,
  CONTENT_APPROVAL_CONFIRM_ENABLE_DESCRIPTION,
  CONTENT_APPROVAL_ENABLE_SUCCESS_DESCRIPTION,
  CAMPAIGN_APPROVAL_ENABLE_SUCCESS_DESCRIPTION,
  APPROVAL_ENABLE_SUCCESS_OR_SEPARATOR,
  APPROVAL_REVIEW_EMAIL_LABEL,
  APPROVAL_EMAIL_SEND_BUTTON,
  APPROVAL_EMAIL_SEND_SENT,
  APPROVAL_EMAIL_INVALID,
  APPROVAL_REVIEWER_NOT_FOUND,
  APPROVAL_ADD_REVIEWER,
  APPROVAL_REVIEWER_LABEL,
  APPROVAL_REVIEWER_MAX_REACHED,
  APPROVAL_REVIEWER_EMAIL_DUPLICATED,
  APPROVAL_REVIEWER_ADDED_SUCCESS,
  APPROVAL_REVIEWER_STATUS_PENDING,
  APPROVAL_REVIEWER_STATUS_APPROVED,
  APPROVAL_REVIEWER_STATUS_REJECTED,
  APPROVAL_CURRENT_REVIEWER_LABEL,
  APPROVAL_REVIEWING_AS_PREFIX,
  APPROVAL_REVIEWERS_SECTION_LABEL,
  APPROVAL_COMMENT_AUTHOR_LABEL,
  CONTENT_APPROVAL_SENT_DATE,
  CONTENT_APPROVAL_CLIENT_COMMENTS_TITLE,
  CONTENT_APPROVAL_CLIENT_COMMENTS_EMPTY,
  CONTENT_APPROVAL_REVIEWER_COMMENTS_EMPTY,
  CONTENT_APPROVAL_COMMENT_PLACEHOLDER,
  CONTENT_APPROVAL_REVIEW_LINK_LABEL,
  CONTENT_APPROVAL_STATUS_SECTION_LABEL,
  CONTENT_APPROVAL_MAIN_CREATIVE_LABEL,
  CONTENT_APPROVAL_CREATIVE_CARD_TITLE,
  CONTENT_APPROVAL_CREATIVE_TYPE_LABEL,
  CONTENT_APPROVAL_COMMENT_CREATIVE_NUMBER,
  CONTENT_APPROVAL_CONFIRM_APPROVE_TITLE,
  CONTENT_APPROVAL_CONFIRM_APPROVE_DESCRIPTION,
  CONTENT_APPROVAL_APPROVE_BUTTON,
  CONTENT_APPROVAL_DECISION_APPROVED_SUCCESS,
  CONTENT_APPROVAL_CONTENT_APPROVED_TITLE,
  CONTENT_APPROVAL_COMMENT_SENT_SUCCESS,
  CONTENT_APPROVAL_REVIEW_NEXT_CONTENT_BUTTON,
  CONTENT_APPROVAL_ANOTHER_COMMENT_BUTTON,
  CONTENT_APPROVAL_ALL_CONTENTS_REVIEWED,
  CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION,
  CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION_SINGLE,
  CONTENT_APPROVAL_LOCKED_STATUS_APPROVED,
  CONTENT_APPROVAL_INVALID_TITLE,
  CONTENT_APPROVAL_INVALID_DESCRIPTION,
  CONTENT_APPROVAL_EXPIRED_TITLE,
  CONTENT_APPROVAL_EXPIRED_DESCRIPTION,
  CONTENT_APPROVAL_LOADING_VALIDATING_LINK,
  CONTENT_APPROVAL_LOADING_FETCHING_CREATIVES,
  CONTENT_APPROVAL_LOADING_PREPARING_REVIEW,
  CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_TITLE,
  CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_DESCRIPTION,
  CAMPAIGN_APPROVAL_READY_TO_DECIDE,
  CAMPAIGN_APPROVAL_COMMENTS_LEFT,
  CAMPAIGN_APPROVAL_AD_SET_LABEL,
  CAMPAIGN_APPROVAL_ADS_COUNT,
  CAMPAIGN_APPROVAL_ADS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_CAMPAIGNS,
  CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS,
  CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_ADS,
  CAMPAIGN_APPROVAL_SIDEBAR_ADS_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_TEXTS,
  CAMPAIGN_APPROVAL_SIDEBAR_TEXTS_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES,
  CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_REJECT_REQUIRES_COMMENT,
  CAMPAIGN_APPROVAL_COMMENT_SEND_HINT,
  CAMPAIGN_APPROVAL_APPROVE_CAMPAIGN_BUTTON,
  CAMPAIGN_APPROVAL_CONFIRM_APPROVE_TITLE,
  CAMPAIGN_APPROVAL_CONFIRM_APPROVE_DESCRIPTION,
  CAMPAIGN_APPROVAL_CONFIRM_REJECT_TITLE,
  CAMPAIGN_APPROVAL_CONFIRM_REJECT_DESCRIPTION,
  CAMPAIGN_APPROVAL_DECISION_APPROVED_SUCCESS,
  CAMPAIGN_APPROVAL_DECISION_REJECTED_SUCCESS,
  RESIZE_CUSTOM,
  MODAL_RESIZE_CUSTOM_TITLE,
  MODAL_RESIZE_CUSTOM_DESCRIPTION,
  MODAL_RESIZE_CUSTOM_DEFAULT_SIZE_LABEL,
  ERROR_RESIZE_DIMENSION_INVALID,
  ERROR_RESIZE_DIMENSION_MAX_EDGE,
  ERROR_RESIZE_DIMENSION_NOT_MULTIPLE_PREFIX,
  ERROR_RESIZE_DIMENSION_OR,
  ERROR_RESIZE_TOTAL_TOO_SMALL,
  ERROR_RESIZE_TOTAL_TOO_LARGE,
  ERROR_RESIZE_ASPECT_RATIO_EXCEEDED_PREFIX,
  ERROR_RESIZE_ASPECT_RATIO_CHOOSE_OPTION,
  ERROR_RESIZE_ASPECT_RATIO_ADJUST_WIDTH_PREFIX,
  ERROR_RESIZE_ASPECT_RATIO_KEEP_HEIGHT_SUFFIX,
  ERROR_RESIZE_ASPECT_RATIO_ADJUST_HEIGHT_PREFIX,
  ERROR_RESIZE_ASPECT_RATIO_KEEP_WIDTH_SUFFIX,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS,
  BUTTON_RESIZE_IMAGE,
  MODAL_BATCH_IMAGE_EDIT_TITLE,
  MODAL_BATCH_IMAGE_EDIT_VERSION_LABEL,
  MODAL_BATCH_IMAGE_EDIT_PROMPT_PLACEHOLDER,
  MODAL_BATCH_IMAGE_EDIT_GENERATE,
  MODAL_BATCH_IMAGE_EDIT_APPLY,
  MODAL_BATCH_IMAGE_EDIT_STATUS_PENDING,
  MODAL_BATCH_IMAGE_EDIT_STATUS_SUCCESS,
  MODAL_BATCH_IMAGE_EDIT_STATUS_ERROR,
  MODAL_BATCH_IMAGE_EDIT_RETRY,
  MODAL_BATCH_IMAGE_EDIT_FAILED_BADGE,
  MODAL_BATCH_IMAGE_EDIT_EXPAND,
  MODAL_BATCH_IMAGE_EDIT_BACK_TO_GRID,
  MODAL_BATCH_IMAGE_EDIT_FOOTER_ACTION,
  MODAL_BATCH_IMAGE_EDIT_IMAGE_ALT,
  MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_TITLE,
  MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION,
  MODAL_BATCH_IMAGE_EDIT_SAVE_AS_NEW_BUTTON,
  MODAL_BATCH_IMAGE_EDIT_REPLACE_BUTTON,
  TEMPLATES_MENU_ITEM,
  TEMPLATES_TITLE,
  TEMPLATE,
  TEMPLATES_SEARCH_PLACEHOLDER,
  TEMPLATES_SEARCH_NO_RESULTS,
  TEMPLATES_SORT_NEWEST_FIRST,
  TEMPLATES_SORT_OLDEST_FIRST,
  TEMPLATES_SORT_NAME_ASC,
  TEMPLATES_SORT_NAME_DESC,
  TEMPLATES_DESCRIPTION,
  TEMPLATES_BUTTON_UPLOAD,
  TEMPLATES_UPLOAD_FROM_GALLERY,
  TEMPLATES_UPLOAD_FROM_DEVICE,
  TEMPLATES_BUTTON_CREATE,
  TEMPLATES_LAYOUT_KIND_IMAGE,
  TEMPLATES_LAYOUT_KIND_CAROUSEL,
  TEMPLATES_CREATE_KIND_TITLE,
  TEMPLATES_CREATE_KIND_DESCRIPTION,
  TEMPLATES_CREATE_KIND_SINGLE,
  TEMPLATES_CREATE_KIND_CAROUSEL,
  TEMPLATES_CREATE_KIND_SLIDE_COUNT,
  TEMPLATES_SLIDE_LABEL,
  TEMPLATES_ADD_SLIDE,
  TEMPLATES_DUPLICATE_SLIDE,
  TEMPLATES_DELETE_SLIDE,
  TEMPLATES_SLIDES_ROW,
  TEMPLATES_CAROUSEL_TYPE,
  TEMPLATES_CONTINUOUS_SETUP_TITLE,
  TEMPLATES_CONTINUOUS_SETUP_SLIDES,
  TEMPLATES_CONTINUOUS_SETUP_FORMAT,
  TEMPLATES_LAYOUT_KIND_CONTINUOUS,
  TEMPLATES_LAYOUT_KIND_INDIVIDUAL,
  TEMPLATES_LAYOUT_KIND_INDIVIDUAL_TOOLTIP,
  TEMPLATES_LAYOUT_KIND_CONTINUOUS_TOOLTIP,
  TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_HINT,
  TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_HINT,
  TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_BLOCKED,
  TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_BLOCKED,
  TEMPLATES_CONFIRM_DELETE_STRIP_SLIDE_DESCRIPTION,
  TEMPLATES_STRIP_FORMAT_TOO_LARGE,
  TEMPLATES_FORMATS_ROW,
  TEMPLATES_CAROUSEL_CHIP,
  TEMPLATES_CONTINUOUS_CAROUSEL_CHIP,
  TEMPLATES_EMPTY,
  TEMPLATES_FOLDER_EMPTY,
  TEMPLATES_EMPTY_CANVAS_HINT,
  TEMPLATES_EMPTY_ADD_LAYER,
  TEMPLATES_BACKGROUND_LAYER,
  TEMPLATES_OPEN,
  TEMPLATES_DUPLICATE,
  TEMPLATES_DELETE,
  TEMPLATES_SAVE,
  TEMPLATES_USAGE_GUIDE,
  TEMPLATES_GUIDE_PDF_URL,
  TEMPLATES_GUIDE_VIDEO_URL,
  TEMPLATES_BACK,
  TEMPLATES_NAME,
  TEMPLATES_UNTITLED,
  TEMPLATES_ZONES,
  TEMPLATES_LAYERS,
  TEMPLATES_PROPERTIES,
  TEMPLATES_NO_SELECTION,
  TEMPLATES_ADD_LAYER,
  TEMPLATES_ZONE_NAME,
  TEMPLATES_LAYER_NAME,
  TEMPLATES_ZONE_TYPE,
  TEMPLATES_ZONE_SOURCE,
  TEMPLATES_TYPE_TEXT,
  TEMPLATES_TYPE_IMAGE,
  TEMPLATES_TYPE_SHAPE,
  TEMPLATES_TYPE_GROUP,
  TEMPLATES_SOURCE_ASSET,
  TEMPLATES_SOURCE_DATA,
  TEMPLATES_SOURCE_GENERATED,
  TEMPLATES_SOURCE_FIXED,
  TEMPLATES_SOURCE_COMPUTED,
  TEMPLATES_SOURCE_ASSET_HINT,
  TEMPLATES_SOURCE_DATA_HINT,
  TEMPLATES_SOURCE_GENERATED_HINT,
  TEMPLATES_SOURCE_COMPUTED_HINT,
  TEMPLATES_FIXED_VALUE,
  TEMPLATES_FIXED_VALUE_PLACEHOLDER,
  TEMPLATES_LAYER_TEXT,
  TEMPLATES_STYLE,
  TEMPLATES_ORIGIN_TEXT,
  TEMPLATES_EXPRESSION,
  TEMPLATES_VARIABLE,
  TEMPLATES_PROMPT,
  TEMPLATES_GENERATE_PROMPT,
  TEMPLATES_GENERATE_PROMPT_ERROR,
  TEMPLATES_GENERATE_PROMPT_NO_EXAMPLE,
  TEMPLATES_SAVE_PROMPT,
  TEMPLATES_SAVE_PROMPT_TITLE,
  TEMPLATES_SAVE_PROMPT_ERROR,
  TEMPLATES_SAVE_PROMPT_SUCCESS,
  TEMPLATES_IMPORT_PROMPT,
  TEMPLATES_IMPORT_PROMPT_TITLE,
  TEMPLATES_IMPORT_SELECTED,
  TEMPLATES_IMPORT_PROMPT_EMPTY,
  TEMPLATES_IMPORT_PROMPT_ERROR,
  TEMPLATES_DELETE_PROMPT,
  TEMPLATES_DELETE_PROMPT_ERROR,
  TEMPLATES_TRY_LAYER,
  TEMPLATES_TRY_LAYER_ERROR,
  TEMPLATES_IS_BACKGROUND,
  TEMPLATES_NEGATIVE_PROMPT,
  TEMPLATES_ASSET_REF,
  TEMPLATES_SELECT_ASSET,
  TEMPLATES_CHANGE_ASSET,
  TEMPLATES_FIT,
  TEMPLATES_SHAPE_FILL,
  TEMPLATES_SHAPE_RADIUS,
  TEMPLATES_FONT_SIZE,
  TEMPLATES_FONT_COLOR,
  TEMPLATES_STROKE_WIDTH,
  TEMPLATES_STROKE_METRIC,
  TEMPLATES_SHADOW,
  TEMPLATES_SHADOW_ANGLE,
  TEMPLATES_SHADOW_DISTANCE,
  TEMPLATES_SHADOW_BLUR,
  TEMPLATES_PRESETS,
  TEMPLATES_SHADOW_PRESET_SOFT,
  TEMPLATES_SHADOW_PRESET_LIFT,
  TEMPLATES_SHADOW_PRESET_HARD,
  TEMPLATES_SHADOW_PRESET_GLOW,
  TEMPLATES_STROKE_COLOR,
  TEMPLATES_BACKGROUND_PADDING,
  TEMPLATES_BACKGROUND_SEPARATION,
  TEMPLATES_BACKGROUND_RADIUS,
  TEMPLATES_BACKGROUND_COLOR,
  TEMPLATES_PAINT_SETTINGS,
  TEMPLATES_HIGHLIGHTS_TITLE,
  TEMPLATES_HIGHLIGHTS_HINT,
  TEMPLATES_HIGHLIGHTS_ADD,
  TEMPLATES_HIGHLIGHTS_REMOVE,
  TEMPLATES_HIGHLIGHTS_KIND_FILL,
  TEMPLATES_HIGHLIGHTS_KIND_STROKE,
  TEMPLATES_HIGHLIGHTS_KIND_BACKGROUND,
  TEMPLATES_HIGHLIGHTS_PHRASE,
  TEMPLATES_HIGHLIGHTS_PHRASE_INVALID,
  TEMPLATES_HIGHLIGHTS_CAPTURE,
  TEMPLATES_HIGHLIGHTS_CAPTURING,
  TEMPLATES_INLINE_REPLACEMENTS_TITLE,
  TEMPLATES_INLINE_REPLACEMENTS_HINT,
  TEMPLATES_INLINE_REPLACEMENTS_ADD,
  TEMPLATES_INLINE_REPLACEMENTS_REMOVE,
  TEMPLATES_INLINE_REPLACEMENTS_PHRASE,
  TEMPLATES_LINE_SPACING,
  TEMPLATES_LETTER_SPACING,
  TEMPLATES_FONT_FAMILY,
  TEMPLATES_FONT_FACE,
  TEMPLATES_TEXT_STYLE,
  TEMPLATES_TEXT_STYLE_NORMAL,
  TEMPLATES_TEXT_STYLE_ITALIC,
  TEMPLATES_TEXT_STYLE_UNDERLINE,
  TEMPLATES_TEXT_STYLE_ITALIC_UNDERLINE,
  TEMPLATES_ADD_FONT,
  TEMPLATES_ADD_FONT_TITLE,
  TEMPLATES_ADD_FONT_NAME,
  TEMPLATES_ADD_FONT_NAME_HINT,
  TEMPLATES_ADD_FONT_FILE,
  TEMPLATES_ADD_FONT_SELECT_FILE,
  TEMPLATES_ADD_FONT_ERROR,
  TEMPLATES_ADD_FONT_INVALID_FILE,
  TEMPLATES_ADD_FONT_INVALID_NAME,
  TEMPLATES_ADD_FONT_MATCH_HINT,
  TEMPLATES_ADD_FONT_PARSE_FAILED,
  TEMPLATES_ADD_FONT_PARTIAL_ERROR,
  TEMPLATES_ADD_FONT_VARIABLE,
  TEMPLATES_ADD_FONT_SUMMARY,
  TEMPLATES_ADD_FONT_SUMMARY_FAMILY,
  TEMPLATES_ADD_FONT_SUMMARY_STYLE,
  TEMPLATES_ADD_FONT_SUMMARY_KIND,
  TEMPLATES_ADD_FONT_SUMMARY_STATIC,
  TEMPLATES_ADD_FONT_SUMMARY_STYLES,
  TEMPLATES_ADD_FONT_SUMMARY_HINT,
  TEMPLATES_ADD_FONT_CHANGE_FILE,
  TEMPLATES_ALIGN,
  TEMPLATES_ALIGN_LEFT,
  TEMPLATES_ALIGN_CENTER,
  TEMPLATES_ALIGN_RIGHT,
  TEMPLATES_ALIGN_TOP,
  TEMPLATES_ALIGN_MIDDLE,
  TEMPLATES_ALIGN_BOTTOM,
  TEMPLATES_ALIGN_LAYERS,
  TEMPLATES_LOCK_LAYER,
  TEMPLATES_UNLOCK_LAYER,
  TEMPLATES_HIDE_LAYER,
  TEMPLATES_SHOW_LAYER,
  TEMPLATES_ALIGNMENT_GUIDES,
  TEMPLATES_GUIDE_OPACITY,
  TEMPLATES_ORIENTATION,
  TEMPLATES_ORIENTATION_HORIZONTAL,
  TEMPLATES_ORIENTATION_VERTICAL,
  TEMPLATES_ORIENTATION_VERTICAL_UP,
  TEMPLATES_OVERFLOW,
  TEMPLATES_MAX_LINES,
  TEMPLATES_MIN_LINES,
  TEMPLATES_MIN_FONT,
  TEMPLATES_POSITION,
  TEMPLATES_SIZE,
  TEMPLATES_POS_X,
  TEMPLATES_POS_Y,
  TEMPLATES_POS_W,
  TEMPLATES_POS_H,
  TEMPLATES_FRAME_W,
  TEMPLATES_FRAME_H,
  TEMPLATES_CLIP,
  TEMPLATES_HIDE,
  TEMPLATES_SHOW,
  TEMPLATES_MIN_SIZE,
  TEMPLATES_PADDING,
  TEMPLATES_DRAW,
  TEMPLATES_DRAWING,
  TEMPLATES_DRAW_HINT,
  TEMPLATES_OVERFLOW_SHRINK,
  TEMPLATES_OVERFLOW_REJECT,
  TEMPLATES_BACKDROP_NOTE,
  TEMPLATES_NODE_COUNT,
  TEMPLATES_NODE_COUNT_SINGLE,
  TEMPLATES_ARTBOARD,
  TEMPLATES_ADD_FORMAT,
  TEMPLATES_CUSTOM_FORMAT,
  TEMPLATES_CUSTOM_FORMAT_TITLE,
  TEMPLATES_CUSTOM_WIDTH,
  TEMPLATES_CUSTOM_HEIGHT,
  TEMPLATES_CUSTOM_SIZE_INVALID,
  TEMPLATES_EDIT_PREVIOUS,
  TEMPLATES_NEW_FORMAT_HINT,
  TEMPLATES_REMOVE_FORMAT,
  TEMPLATES_THIS_FORMAT,
  TEMPLATES_UPLOAD_REFERENCE,
  TEMPLATES_CHANGE_REFERENCE,
  TEMPLATES_SHOW_GUIDE,
  TEMPLATES_HIDE_GUIDE,
  TEMPLATES_GUIDE_HINT,
  TEMPLATES_EDITOR_PREVIEW_VARIABLES_TITLE,
  TEMPLATES_EDITOR_PREVIEW_VARIABLES_DESCRIPTION,
  TEMPLATES_EDITOR_PREVIEW_ERROR,
  TEMPLATES_EDITOR_PREVIEW_TITLE,
  TEMPLATES_EDITOR_PREVIEW_USED_VALUES,
  TEMPLATES_EDITOR_PREVIEW_SAVED_TO_GALLERY,
  TEMPLATES_ZOOM_IN,
  TEMPLATES_ZOOM_OUT,
  TEMPLATES_ZOOM_FIT,
  TEMPLATES_TEXT_COLLISION_ONE,
  TEMPLATES_TEXT_COLLISION_OTHER,
  TEMPLATES_TEXT_COLLISION_UNNAMED_TEXT,
  TEMPLATES_TEXT_COLLISION_UNNAMED_IMAGE,
  CANVAS_TOOLS_BAR_LABEL,
  CANVAS_TOOL_ERASER,
  CANVAS_TOOL_ERASER_HINT,
  CANVAS_TOOL_ERASER_BRUSH_SIZE,
  CANVAS_TOOL_ERASER_APPLY,
  TEMPLATES_UNAUTHORIZED,
  TEMPLATES_ANALYZING_LOCK,
  TEMPLATES_SAVE_SUCCESS,
  TEMPLATES_DELETE_ERROR,
  TEMPLATES_UPLOAD_ERROR,
  TEMPLATES_ANALYZE_ERROR,
  TEMPLATES_ANALYZE_IMAGE_TOO_SMALL,
  IMAGE_TOO_SMALL_FOR_LAYERIZE,
  TEMPLATES_ANALYZE_RETRY,
  TEMPLATES_CREATE_ERROR,
  TEMPLATES_SAVE_ERROR,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE_CAROUSEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION_CAROUSEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_ARIA_LABEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_FORMAT,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_TYPE,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_VARIABLE,
  TEMPLATES_SAVE_TRANSPARENCY_GAP_TITLE,
  TEMPLATES_SAVE_TRANSPARENCY_GAP_DESCRIPTION,
  TEMPLATES_CONFIRM_DELETE_TITLE,
  TEMPLATES_CONFIRM_DELETE_DESCRIPTION,
  TEMPLATES_CONFIRM_REMOVE_FORMAT_TITLE,
  TEMPLATES_CONFIRM_REMOVE_FORMAT_DESCRIPTION,
  TEMPLATES_CONFIRM_ADD_FORMAT,
  TEMPLATES_CONFIRM_ADD_FORMAT_DESCRIPTION,
  TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND,
  TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND_DESCRIPTION,
  TEMPLATES_AI_RESIZE_BACKGROUND_CONFIRM,
  TEMPLATES_AI_RESIZE_BACKGROUND_LOCK,
  TEMPLATES_KEEP_EDITING,
  TEMPLATES_CLOSE_UNSAVED_DESCRIPTION,
  TEMPLATES_PRODUCE_DRAFT_COMPLETE,
  TEMPLATES_PRODUCE_DRAFT_TITLE,
  TEMPLATES_PRODUCE_DRAFT_DESCRIPTION,
  TEMPLATES_SAVE_PRODUCE_TITLE,
  TEMPLATES_SAVE_BLOCKED_PRODUCING,
  TEMPLATES_SAVE_PRODUCE_DESCRIPTION,
  TEMPLATES_SAVE_PRODUCE_CONFIRM,
  TEMPLATES_SAVE_PRODUCE_CANCEL,
  TEMPLATES_NEW_ZONE,
  TEMPLATES_NEW_LAYER,
  TEMPLATES_PRODUCE_MENU_ITEM,
  TEMPLATES_PRODUCE_TITLE,
  TEMPLATES_PRODUCE_DESCRIPTION,
  TEMPLATES_PRODUCE_CONFIG_KICKER,
  TEMPLATES_PRODUCE_SELECTED_TEMPLATE_LABEL,
  TEMPLATES_PRODUCE_VARIABLES_EYEBROW,
  TEMPLATES_PRODUCE_SUMMARY_IMAGE_UNIT,
  TEMPLATES_PRODUCE_SUMMARY_IMAGES_UNIT,
  TEMPLATES_PRODUCE_SUMMARY_VARIATION_LABEL,
  TEMPLATES_PRODUCE_SUMMARY_VARIATIONS_LABEL,
  TEMPLATES_PRODUCE_SUMMARY_COST,
  TEMPLATES_PRODUCE_SUMMARY_COST_LABEL,
  TEMPLATES_PRODUCE_SUMMARY_RATE,
  TEMPLATES_PRODUCE_SUMMARY_FORMAT,
  TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT_SINGLE,
  TEMPLATES_PRODUCE_SUMMARY_SIZE_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_SIZES_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_SLIDE_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_SLIDES_COUNT,
  TEMPLATES_PRODUCE_ROW_COUNT,
  TEMPLATES_PRODUCE_ROW_COUNT_SINGLE,
  TEMPLATES_PRODUCE_TEMPLATE,
  TEMPLATES_PRODUCE_CHANGE,
  TEMPLATES_PRODUCE_DIMENSIONS,
  TEMPLATES_PRODUCE_LANGUAGE,
  TEMPLATES_PRODUCE_VARIATIONS,
  TEMPLATES_PRODUCE_VARIATIONS_PER_ROW,
  TEMPLATES_PRODUCE_ROWS,
  TEMPLATES_PRODUCE_ROWS_HINT,
  TEMPLATES_PRODUCE_ADD_ROW,
  TEMPLATES_PRODUCE_LOAD_LAST_CONFIG,
  TEMPLATES_PRODUCE_UPLOAD_CSV,
  TEMPLATES_PRODUCE_DOWNLOAD_FORMAT,
  TEMPLATES_PRODUCE_CSV_EXAMPLE_FILENAME,
  TEMPLATES_PRODUCE_CSV_EXAMPLE_TEXT,
  TEMPLATES_PRODUCE_GENERATE,
  TEMPLATES_PRODUCE_GENERATE_SINGLE,
  TEMPLATES_PRODUCE_PREVIEW,
  TEMPLATES_PRODUCE_PREVIEW_TOOLTIP,
  TEMPLATES_PRODUCE_PREVIEW_THIS_SLIDE,
  TEMPLATES_PRODUCE_PREVIEW_WHOLE_CAROUSEL,
  TEMPLATES_PRODUCE_SUMMARY,
  TEMPLATES_PRODUCE_EMPTY_TEMPLATES,
  TEMPLATES_PRODUCE_EMPTY_VARIABLES,
  TEMPLATES_PRODUCE_SELECT_TEMPLATE,
  TEMPLATES_PRODUCE_CSV_TITLE,
  TEMPLATES_PRODUCE_CSV_DESCRIPTION,
  TEMPLATES_PRODUCE_CSV_REPLACE,
  TEMPLATES_PRODUCE_CSV_APPEND,
  TEMPLATES_PRODUCE_CSV_ERROR,
  TEMPLATES_PRODUCE_CSV_EMPTY,
  TEMPLATES_PRODUCE_CHANGE_TEMPLATE_TITLE,
  TEMPLATES_PRODUCE_CHANGE_TEMPLATE_DESCRIPTION,
  TEMPLATES_PRODUCE_VALIDATION_ERROR,
  TEMPLATES_PRODUCE_VALIDATION_HIGHLIGHT,
  TEMPLATES_PRODUCE_VALIDATION_NO_ROWS,
  TEMPLATES_PRODUCE_VALIDATION_VARIATIONS,
  TEMPLATES_PRODUCE_VALIDATION_NO_FORMATS,
  TEMPLATES_PRODUCE_VALIDATION_TOO_MANY_ROWS,
  TEMPLATES_PRODUCE_GENERATE_SUCCESS,
  TEMPLATES_PRODUCE_DELETE_ROW,
  TEMPLATES_PRODUCE_COPY_TO_COLUMN,
  TEMPLATES_PRODUCE_SELECT_IMAGE,
  TEMPLATES_PRODUCE_REPLACE_IMAGE,
  TEMPLATES_PRODUCE_IMAGE_CHECKING,
  TEMPLATES_PRODUCE_IMAGE_UNUSABLE,
  TEMPLATES_PRODUCE_IMAGES_PROCESSING,
  TEMPLATES_PRODUCE_IMAGES_UNUSABLE,
  TEMPLATES_PRODUCE_DELETE_IMAGE,
  TEMPLATES_PRODUCE_RESULTS,
  TEMPLATES_PRODUCE_RUN_TITLE,
  TEMPLATES_PRODUCE_RUN_LEGACY,
  TEMPLATES_PRODUCE_DELETE_SELECTED,
  TEMPLATES_PRODUCE_DELETE_CONFIRM_TITLE,
  TEMPLATES_PRODUCE_DELETE_CONFIRM_TEXT,
  TEMPLATES_PRODUCE_DELETE_ERROR,
  TEMPLATES_PRODUCE_DOWNLOAD_CONFIG,
  TEMPLATES_PRODUCE_CONFIG_FILENAME,
  TEMPLATES_PRODUCE_GENERATING,
  TEMPLATES_PRODUCE_ACTIVE_RUN,
  TEMPLATES_PRODUCE_EDIT_TITLE,
  TEMPLATES_PRODUCE_EDIT_NO_INSTANCE,
  TEMPLATES_PRODUCE_ADD_TEXT,
  TEMPLATES_PRODUCE_ADD_IMAGE,
  TEMPLATES_PRODUCE_ADD_SHAPE,
  TEMPLATES_PRODUCE_ADD_GROUP,
  TEMPLATES_GROUP_LAYERS,
  TEMPLATES_PRODUCE_SAVE_ERROR,
  TEMPLATES_PRODUCE_PARTIAL_SUMMARY,
  TEMPLATES_PRODUCE_PARTIAL_TITLE,
  TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_SINGULAR,
  TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_PLURAL,
  TEMPLATES_PRODUCE_RETRY_FAILED,
  TEMPLATES_PRODUCE_RETRY_FAILED_SINGULAR,
  TEMPLATES_PRODUCE_RETRY_FAILED_PLURAL,
  TEMPLATES_PRODUCE_FAILURE_GENERIC,
  TEMPLATES_PRODUCE_FAILURE_BUSY,
  TEMPLATES_PRODUCE_FAILURE_IMAGE,
  TEMPLATES_PRODUCE_FAILURE_DATA,
  AI_COMPETITORS_PAGE_TITLE,
  AI_COMPETITORS_URL_STEP_NUMBER,
  AI_COMPETITORS_URL_TITLE,
  AI_COMPETITORS_URL_MUTED,
  AI_COMPETITORS_URL_DESCRIPTION,
  AI_COMPETITORS_URL_PLACEHOLDER,
  AI_COMPETITORS_URL_CTA,
  AI_COMPETITORS_URL_INVALID,
  AI_COMPETITORS_URL_BLOCKED,
  AI_COMPETITORS_URL_NO_COMPETITORS,
  AI_COMPETITORS_ANALYZING_STEP_NUMBER,
  AI_COMPETITORS_ANALYZING_TITLE,
  AI_COMPETITORS_ANALYZING_MUTED,
  AI_COMPETITORS_ANALYZING_DESCRIPTION,
  AI_COMPETITORS_PROGRESS_FALLBACK,
  AI_COMPETITORS_PROGRESS_REVIEWING_PAGE,
  AI_COMPETITORS_PROGRESS_FINDING_COMPETITORS,
  AI_COMPETITORS_PROGRESS_CONSOLIDATING_COMPETITORS,
  AI_COMPETITORS_PROGRESS_RESOLVING_ADS,
  AI_COMPETITORS_PROGRESS_SEARCHING_ADS,
  AI_COMPETITORS_PROGRESS_CONSOLIDATING_ADS,
  AI_COMPETITORS_COMPETITORS_STEP_NUMBER,
  AI_COMPETITORS_COMPETITORS_TITLE,
  AI_COMPETITORS_COMPETITORS_MUTED,
  AI_COMPETITORS_COMPETITORS_DESCRIPTION,
  AI_COMPETITORS_COMPETITORS_EMPTY,
  AI_COMPETITORS_COMPETITORS_ADD_PLACEHOLDER,
  AI_COMPETITORS_COMPETITORS_ADD,
  AI_COMPETITORS_COMPETITORS_ADD_INVALID,
  AI_COMPETITORS_COMPETITORS_NAME_LABEL,
  AI_COMPETITORS_COMPETITORS_REMOVE,
  AI_COMPETITORS_COMPETITORS_CTA,
  AI_COMPETITORS_COMPETITORS_NEED_ONE,
  AI_COMPETITORS_COMPETITORS_ADD_MAX,
  AI_COMPETITORS_SEARCHING_STEP_NUMBER,
  AI_COMPETITORS_SEARCHING_TITLE,
  AI_COMPETITORS_SEARCHING_MUTED,
  AI_COMPETITORS_SEARCHING_ERROR,
  AI_COMPETITORS_SEARCHING_RETRY,
  AI_COMPETITORS_RESULTS_STEP_NUMBER,
  AI_COMPETITORS_RESULTS_TITLE,
  AI_COMPETITORS_RESULTS_MUTED,
  AI_COMPETITORS_RESULTS_SUMMARY,
  AI_COMPETITORS_RESULTS_NO_ADS,
  AI_COMPETITORS_RESULTS_NO_ADS_ALERT_TITLE,
  AI_COMPETITORS_RESULTS_NO_ADS_ALERT_BODY,
  AI_COMPETITORS_RESULTS_NO_ADS_CTA,
  AI_COMPETITORS_RESULTS_VIEW_MORE,
  AI_COMPETITORS_RESULTS_GENERATE,
  AI_COMPETITORS_RESULTS_LOCKED_COUNT,
  AI_COMPETITORS_RESULTS_DOWNLOAD,
  AI_COMPETITORS_RESULTS_FORMAT_IMAGE,
  AI_COMPETITORS_RESULTS_FORMAT_VIDEO,
  AI_COMPETITORS_RESULTS_FORMAT_CAROUSEL,
  AI_COMPETITORS_AGENDA_CONFIRM_TITLE,
  AI_COMPETITORS_AGENDA_CONFIRM_TEXT,
  AI_COMPETITORS_AGENDA_CONFIRM_CTA,
  AI_COMPETITORS_AGENDA_BACK,
  AI_COMPETITORS_AGENDA_STEP_NUMBER,
  AI_COMPETITORS_AGENDA_TITLE,
  AI_COMPETITORS_AGENDA_MUTED,
  AI_COMPETITORS_AGENDA_CONTEXT,
  AI_COMPETITORS_AGENDA_CONTEXT_ZERO,
  AI_COMPETITORS_AGENDA_CONTEXT_FALLBACK,
  AI_COMPETITORS_THANKS_STEP_NUMBER,
  AI_COMPETITORS_THANKS_TITLE,
  AI_COMPETITORS_THANKS_MUTED,
  AI_COMPETITORS_THANKS_DESCRIPTION,
  NEW_FEATURE_CALLOUT_BADGE,
  NEW_FEATURE_CALLOUT_CLOSE_ARIA,
  NEW_FEATURE_CALLOUT_DEFAULT_CTA,
  NEW_FEATURE_CALLOUT_INSIGHTS_TITLE,
  NEW_FEATURE_CALLOUT_INSIGHTS_DESCRIPTION,
  NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_TITLE,
  NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_DESCRIPTION,
  NEW_FEATURE_CALLOUT_AUTOMATIONS_TITLE,
  NEW_FEATURE_CALLOUT_AUTOMATIONS_DESCRIPTION,
  AUTOMATIONS_MENU_TITLE,
  AUTOMATIONS_PAGE_TITLE,
  AUTOMATIONS_PAGE_DESCRIPTION,
  BUTTON_NEW_AUTOMATION,
  AUTOMATIONS_HERO_TITLE,
  AUTOMATIONS_HERO_DESCRIPTION,
  AUTOMATIONS_STATUS_ACTIVE,
  AUTOMATIONS_STATUS_PAUSED,
  AUTOMATIONS_LABEL_FOLDER,
  AUTOMATIONS_LABEL_PLATFORMS,
  AUTOMATIONS_LABEL_FREQUENCY,
  AUTOMATIONS_LABEL_NEXT_POST,
  AUTOMATIONS_MOCK_BRAND_CONTENT,
  AUTOMATIONS_MOCK_PRODUCT_LAUNCH,
  AUTOMATIONS_MOCK_THOUGHT_LEADERSHIP,
  AUTOMATIONS_MOCK_FOLDER_SOCIAL_SEPTEMBER,
  AUTOMATIONS_MOCK_FOLDER_ALL_CONTENT,
  AUTOMATIONS_MOCK_FOLDER_LINKEDIN,
  AUTOMATIONS_MOCK_FREQ_ONE_PER_DAY,
  AUTOMATIONS_MOCK_FREQ_FIVE_PER_WEEK,
  AUTOMATIONS_MOCK_FREQ_THREE_PER_WEEK,
  AUTOMATIONS_FREQ_ONE_PER_DAY,
  AUTOMATIONS_FREQ_THREE_PER_WEEK,
  AUTOMATIONS_FREQ_FOUR_PER_WEEK,
  AUTOMATIONS_FREQ_FIVE_PER_WEEK,
  AUTOMATIONS_FREQ_SIX_PER_WEEK,
  AUTOMATIONS_MOCK_NEXT_TODAY,
  AUTOMATIONS_MOCK_NEXT_EMPTY,
  AUTOMATIONS_MOCK_NEXT_TOMORROW,
  MODAL_CREATE_AUTOMATION_TITLE,
  AUTOMATIONS_STEP_SOURCE,
  AUTOMATIONS_STEP_PLATFORMS,
  AUTOMATIONS_STEP_SCHEDULE,
  AUTOMATIONS_STEP_CONTENT_AI,
  AUTOMATIONS_STEP_REVIEW,
  AUTOMATIONS_STEP_SOURCE_TITLE,
  AUTOMATIONS_STEP_SOURCE_HELP,
  AUTOMATIONS_SOURCE_ALL_TITLE,
  AUTOMATIONS_SOURCE_ALL_DESCRIPTION,
  AUTOMATIONS_SOURCE_FOLDER_TITLE,
  AUTOMATIONS_SOURCE_FOLDER_DESCRIPTION,
  AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS,
  AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS_HELP,
  AUTOMATIONS_STEP_LANGUAGE_TITLE,
  AUTOMATIONS_STEP_LANGUAGE_HELP,
  AUTOMATIONS_VALIDATION_LANGUAGE,
  AUTOMATIONS_REVIEW_LANGUAGE,
  AUTOMATIONS_CONNECT_ACCOUNTS,
  AUTOMATIONS_STEP_PLATFORMS_TITLE,
  AUTOMATIONS_STEP_PLATFORMS_HELP,
  AUTOMATIONS_PLATFORM_CONNECTED,
  AUTOMATIONS_STEP_SCHEDULE_TITLE,
  AUTOMATIONS_STEP_SCHEDULE_HELP,
  AUTOMATIONS_SCHEDULE_FREQUENCY,
  AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW,
  AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW_HELP,
  AUTOMATIONS_SCHEDULE_TIMEZONE,
  AUTOMATIONS_SCHEDULE_VALIDITY,
  AUTOMATIONS_SCHEDULE_VALIDITY_HELP,
  AUTOMATIONS_SCHEDULE_START,
  AUTOMATIONS_SCHEDULE_START_NOW,
  AUTOMATIONS_SCHEDULE_START_NOW_HELP,
  AUTOMATIONS_SCHEDULE_START_SCHEDULED,
  AUTOMATIONS_SCHEDULE_END,
  AUTOMATIONS_SCHEDULE_END_ALWAYS_ON,
  AUTOMATIONS_SCHEDULE_END_ALWAYS_ON_HELP,
  AUTOMATIONS_SCHEDULE_END_SCHEDULED,
  AUTOMATIONS_STEP_CONTENT_AI_TITLE,
  AUTOMATIONS_STEP_CONTENT_AI_HELP,
  AUTOMATIONS_CONTENT_ORIGINAL_TITLE,
  AUTOMATIONS_CONTENT_ORIGINAL_DESCRIPTION,
  AUTOMATIONS_CONTENT_AI_TITLE,
  AUTOMATIONS_CONTENT_AI_DESCRIPTION,
  AUTOMATIONS_AI_NOTE_TITLE,
  AUTOMATIONS_AI_NOTE_DESCRIPTION,
  AUTOMATIONS_STEP_REVIEW_TITLE,
  AUTOMATIONS_STEP_REVIEW_HELP,
  AUTOMATIONS_REVIEW_SOURCE,
  AUTOMATIONS_REVIEW_PLATFORMS,
  AUTOMATIONS_REVIEW_SCHEDULE,
  AUTOMATIONS_REVIEW_VALIDITY,
  AUTOMATIONS_REVIEW_VALIDITY_VALUE,
  AUTOMATIONS_REVIEW_VALIDITY_START_NOW,
  AUTOMATIONS_REVIEW_VALIDITY_START_AT,
  AUTOMATIONS_REVIEW_VALIDITY_ALWAYS_ON,
  AUTOMATIONS_REVIEW_VALIDITY_END_AT,
  AUTOMATIONS_REVIEW_NAME,
  AUTOMATIONS_REVIEW_CONTENT_AI,
  AUTOMATIONS_DEFAULT_NAME,
  AUTOMATIONS_BUTTON_BACK,
  AUTOMATIONS_BUTTON_CREATE,
  AUTOMATIONS_BUTTON_SAVE,
  AUTOMATIONS_REVIEW_SCHEDULE_VALUE,
  AUTOMATIONS_STATUS_WAITING,
  AUTOMATIONS_STATUS_SCHEDULING,
  AUTOMATIONS_STATUS_ATTENTION,
  AUTOMATIONS_STATUS_OFF,
  AUTOMATIONS_STATUS_ENDED,
  AUTOMATIONS_MENU_EDIT,
  AUTOMATIONS_MENU_VIEW_CALENDAR,
  AUTOMATIONS_MENU_TURN_OFF,
  AUTOMATIONS_TURN_OFF_TITLE,
  AUTOMATIONS_TURN_OFF_DESCRIPTION,
  AUTOMATIONS_TURN_OFF_CONFIRM,
  AUTOMATIONS_WAITING_BANNER,
  AUTOMATIONS_ATTENTION_BANNER,
  AUTOMATIONS_VALIDATION_FOLDER,
  AUTOMATIONS_VALIDATION_ACCOUNTS,
  AUTOMATIONS_VALIDATION_WINDOW,
  AUTOMATIONS_VALIDATION_START_REQUIRED,
  AUTOMATIONS_VALIDATION_START_FUTURE,
  AUTOMATIONS_VALIDATION_END_REQUIRED,
  AUTOMATIONS_VALIDATION_END_FUTURE,
  AUTOMATIONS_VALIDATION_END_AFTER_START,
  AUTOMATIONS_HERO_QUEUED,
  AUTOMATIONS_HERO_PUBLISHED,
  AUTOMATIONS_HERO_FAILED,
  AUTOMATIONS_HERO_NEXT,
  AUTOMATIONS_NEXT_NONE,
  AUTOMATIONS_REMAINING_CONTENT,
  CALENDAR_SOURCE_AUTOMATED,
  CALENDAR_ACTIVE_AUTOMATIONS,
  CALENDAR_AUTOMATION_ENDS,
  CALENDAR_AUTOMATION_FOLDER,
  CALENDAR_SOURCE_MANUAL,
  EVENT_DETAILS_AUTOMATION,
  EVENT_DETAILS_ACCOUNT,
  MODAL_EDIT_AUTOMATION_TITLE,
  AUTOMATIONS_NO_PERMISSION,
  OPTIMISTIC_SWITCH_FAILURE_BODY,
  OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN,
  OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN,
  OPTIMISTIC_SWITCH_ACTIVATE_ASSETS_GROUP,
  OPTIMISTIC_SWITCH_DEACTIVATE_ASSETS_GROUP,
  OPTIMISTIC_SWITCH_ACTIVATE_AD_GROUP,
  OPTIMISTIC_SWITCH_DEACTIVATE_AD_GROUP,
  OPTIMISTIC_SWITCH_ACTIVATE_AD,
  OPTIMISTIC_SWITCH_DEACTIVATE_AD,
  OPTIMISTIC_SWITCH_ACTIVATE_AUTOMATION,
  OPTIMISTIC_SWITCH_DEACTIVATE_AUTOMATION,
  OPTIMISTIC_SWITCH_ACTIVATE_PROMO_CODE,
  OPTIMISTIC_SWITCH_DEACTIVATE_PROMO_CODE,
  OPTIMISTIC_SWITCH_FAILURE_EMAIL_SUBJECT,
  CREATE_CAMPAIGN_WIZARD_ARIA,
  CREATE_CAMPAIGN_SETUP_TITLE,
  CREATE_CAMPAIGN_SETUP_DESCRIPTION,
  CREATE_CAMPAIGN_WIZARD_STEP_INSTRUCTIONS_HELP,
  CREATE_CAMPAIGN_WIZARD_STEP_LANGUAGE_HELP,
  CREATE_CAMPAIGN_WIZARD_STEP_LOCATIONS_HELP,
  CREATE_CAMPAIGN_WIZARD_STEP_PLATFORM_HELP,
  ACTIVATED,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_TITLE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_DESCRIPTION,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNELS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEOS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CONTENT_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EXCLUDED_APPS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOADING,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY_ROW,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SETTINGS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORDS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_YOUTUBE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APPS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_INVALID_CHARS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_MATCH_SYNTAX,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_TYPE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_BROAD,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_PHRASE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_EXACT,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL_INVALID,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEO,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_ID,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_NAME,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SEARCH_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVED,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVE_ERROR,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOAD_ERROR,
  GOOGLE_ADS_CONTENT_LABEL_BELOW_THE_FOLD,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_CONTENT_FOR_FAMILIES,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_FIGHTING,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_MATURE,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SENSITIVE,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SOURCE_UNDETERMINED,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_RECENT,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SENSITIVE,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SOURCE_NOT_FEATURED,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_POLITICS,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_RELIGION,
  GOOGLE_ADS_CONTENT_LABEL_EMBEDDED_VIDEO,
  GOOGLE_ADS_CONTENT_LABEL_JUVENILE,
  GOOGLE_ADS_CONTENT_LABEL_LIVE_STREAMING_VIDEO,
  GOOGLE_ADS_CONTENT_LABEL_PARKED_DOMAIN,
  GOOGLE_ADS_CONTENT_LABEL_PROFANITY,
  GOOGLE_ADS_CONTENT_LABEL_SEXUALLY_SUGGESTIVE,
  GOOGLE_ADS_CONTENT_LABEL_SOCIAL_ISSUES,
  GOOGLE_ADS_CONTENT_LABEL_TRAGEDY,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_NOT_YET_RATED,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_G,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_MA,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_PG,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_T,
  FEATURE_ADDON_PAYWALL_TITLE,
  FEATURE_ADDON_PAYWALL_DESCRIPTION,
  FEATURE_ADDON_PAYWALL_CURRENT_LIMIT,
  FEATURE_ADDON_PAYWALL_TIER_CTA,
  FEATURE_ADDON_PAYWALL_CLOSE,
  FEATURE_ADDON_PAYWALL_FREE,
  FEATURE_ADDON_PAYWALL_INCLUDED,
  FEATURE_ADDON_INCLUDED_AUTOMATIONS,
  FEATURE_ADDON_INCLUDED_TEMPLATES,
  FEATURE_ADDON_INCLUDED_COMPETITORS,
  FEATURE_ADDON_BENEFIT_COMPETITORS_POOL_ONE,
  FEATURE_ADDON_PAYWALL_CURRENT,
  FEATURE_ADDON_PAYWALL_PER_MONTH,
  FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS,
  FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS_ONE,
  FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES,
  FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES_ONE,
  FEATURE_ADDON_BENEFIT_ACTIONS,
  FEATURE_ADDON_BENEFIT_ACTIONS_ONE,
  FEATURE_ADDON_BENEFIT_VISIBILITY,
  FEATURE_ADDON_BENEFIT_VISIBILITY_ALL,
  FEATURE_ADDON_PAYWALL_TIER_NAME,
  FEATURE_ADDON_HERO_AUTOMATIONS,
  FEATURE_ADDON_HERO_TEMPLATES,
  FEATURE_ADDON_HERO_COMPETITORS,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_PUBLISH,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_SCHEDULE,
  FEATURE_ADDON_BENEFIT_TEMPLATES_LAYERS,
  FEATURE_ADDON_BENEFIT_TEMPLATES_ANALYZE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_SAVE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_INSPIRE,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_PLATFORMS,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_FREQUENCY,
  FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_TERM,
  FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_BODY,
  FEATURE_ADDON_BENEFIT_TEMPLATES_PRODUCE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_PLATFORMS,
  FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES,
  FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES_ONE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE_ONE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_POOL,
  FEATURE_ADDON_NAME_AUTOMATIONS,
  FEATURE_ADDON_NAME_TEMPLATES,
  FEATURE_ADDON_NAME_COMPETITORS,
  FEATURE_ADDON_UNPAID_TITLE,
  FEATURE_ADDON_UNPAID_PERIOD,
  FEATURE_ADDON_UNPAID_AMOUNT,
  FEATURE_ADDON_BILLING_TITLE,
  FEATURE_ADDON_BILLING_RENEWS,
  FEATURE_ADDON_BILLING_CANCELS,
  FEATURE_ADDON_BILLING_UPGRADE,
  FEATURE_ADDON_BILLING_CANCEL_TITLE,
  FEATURE_ADDON_BILLING_CANCEL_MODAL_TITLE,
  FEATURE_ADDON_BILLING_CANCEL_MODAL_CONFIRM,
  FEATURE_ADDON_BILLING_CANCEL_MODAL_KEEP,
  FEATURE_ADDON_BILLING_CANCEL_DESCRIPTION,
  FEATURE_ADDON_BILLING_CANCELLED_TITLE,
  FEATURE_ADDON_BILLING_REACTIVATED_TITLE,
  FEATURE_ADDON_BILLING_MENU,
  EXTRA_SEATS_MANAGE,
  EXTRA_SEATS_MODAL_TITLE,
  EXTRA_SEATS_MODAL_SUBTITLE,
  EXTRA_SEATS_MODAL_SUBTITLE_NO_PRICE,
  EXTRA_SEATS_QUANTITY_LABEL,
  EXTRA_SEATS_DELTA_USERS_ONE,
  EXTRA_SEATS_DELTA_USERS,
  EXTRA_SEATS_AMOUNT_PER_MONTH,
  EXTRA_SEATS_DUE_TODAY_LABEL,
  EXTRA_SEATS_PRORATION_TODAY,
  EXTRA_SEATS_NEXT_TOTAL_FROM,
  EXTRA_SEATS_NEXT_TOTAL_MONTHLY,
  EXTRA_SEATS_MONTHLY_TOTAL,
  EXTRA_SEATS_KEEP_UNTIL_CYCLE_ONE,
  EXTRA_SEATS_KEEP_UNTIL_CYCLE,
  EXTRA_SEATS_PRORATION_NOTE,
  EXTRA_SEATS_NO_CHARGE_NOTE,
  EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK_ONE,
  EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK,
  EXTRA_SEATS_REDUCE_BLOCKED_ONE,
  EXTRA_SEATS_REDUCE_BLOCKED,
  EXTRA_SEATS_CONFIRM,
  EXTRA_SEATS_ADDED,
  EXTRA_SEATS_CHECKOUT_CANCELLED,
  EXTRA_SEATS_CHECKOUT_INCOMPLETE,
  EXTRA_SEATS_BILLING_ROW_TITLE,
  EXTRA_SEATS_QUANTITY_BADGE,
  EXTRA_SEATS_REDUCE_NOTICE,
  EXTRA_SEATS_CANCEL_NOTICE,
  EXTRA_SEATS_CHANGE_SAVED,
  EXTRA_SEATS_FORBIDDEN,
  EXTRA_SEATS_DECREASE,
  EXTRA_SEATS_INCREASE,
  EXTRA_SEATS_RETRY,
  EXTRA_SEATS_REACTIVATE_NOT_ELIGIBLE,
  EXTRA_SEATS_CHECKOUT_FORBIDDEN,
  EXTRA_SEATS_MISSING_AGENCY,
  SEAT_LIMIT_REACHED,
  SEATS_QUANTITY_CHANGED,
  SEATS_OPERATION_IN_PROGRESS,
  SEATS_UNPAID,
  SEATS_QUANTITY_OUT_OF_RANGE,
  SEATS_NOT_ELIGIBLE,
  SEATS_PRICE_NOT_CONFIGURED,
  SEATS_SUBSCRIPTION_NOT_FOUND,
  BUTTON_BULK_CREATE_CAMPAIGNS,
  BULK_CAMPAIGNS_SUMMARY,
  BULK_CAMPAIGNS_LIST_TITLE,
  BULK_CAMPAIGNS_GENERATE,
  BULK_CAMPAIGNS_GENERATING,
  BULK_CAMPAIGNS_ALERT_ANALYZING,
  BULK_CAMPAIGNS_ALERT_ANALYSIS_SUCCESS,
  BULK_CAMPAIGNS_ALERT_ANALYSIS_ERROR,
  BULK_CAMPAIGNS_ALERT_GENERATING,
  BULK_CAMPAIGNS_ALERT_GENERATION_SUCCESS,
  BULK_CAMPAIGNS_ALERT_GENERATION_ERROR,
  BULK_CAMPAIGNS_GENERATE_ERROR,
  BULK_CAMPAIGNS_PLATFORM_NOT_SUPPORTED,
  BULK_CAMPAIGNS_PLATFORM_NOT_DETECTED,
  BULK_CAMPAIGNS_TYPE_NOT_SUPPORTED,
  BULK_CAMPAIGNS_TITLE,
  BULK_CAMPAIGNS_DESCRIPTION,
  BULK_CAMPAIGNS_DROP_TITLE,
  BULK_CAMPAIGNS_DROP_FORMATS,
  BULK_CAMPAIGNS_ANALYZING,
  BULK_CAMPAIGNS_FILE_NOT_SUPPORTED,
  BULK_CAMPAIGNS_FILE_TOO_LARGE,
  BULK_CAMPAIGNS_EXTRACT_ERROR,
  BULK_CAMPAIGNS_CONTENTS_LOAD_ERROR,
  BULK_CAMPAIGNS_NO_CAMPAIGNS_FOUND,
  BULK_CAMPAIGNS_CHOOSE_ANOTHER_FILE,
  CAMPAIGN_AGENT_WELCOME_TITLE,
  CAMPAIGN_AGENT_WELCOME_SUBTITLE,
  CAMPAIGN_AGENT_STEP_ASK,
  CAMPAIGN_AGENT_STEP_REVIEW,
  CAMPAIGN_AGENT_STEP_APPLY,
  CAMPAIGN_AGENT_WELCOME_HINT,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_1,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_2,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_3,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_4,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_5,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_6,
  CAMPAIGN_AGENT_CARD_LEARNINGS_TITLE,
  CAMPAIGN_AGENT_CARD_LEARNINGS_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_LEARNINGS_QUESTION,
  CAMPAIGN_AGENT_CARD_IMPROVE_TITLE,
  CAMPAIGN_AGENT_CARD_IMPROVE_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_IMPROVE_QUESTION,
  CAMPAIGN_AGENT_CARD_BUDGET_TITLE,
  CAMPAIGN_AGENT_CARD_BUDGET_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_BUDGET_QUESTION,
  CAMPAIGN_AGENT_CARD_COPY_TITLE,
  CAMPAIGN_AGENT_CARD_COPY_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_COPY_QUESTION,
  CAMPAIGN_AGENT_IMPROVEMENTS_READY_ONE,
  CAMPAIGN_AGENT_IMPROVEMENTS_READY_MANY,
  CAMPAIGN_AGENT_IMPROVEMENTS_READY_DESCRIPTION,
  CAMPAIGN_AGENT_CHANGES_COUNT_ONE,
  CAMPAIGN_AGENT_CHANGES_COUNT_MANY,
  CAMPAIGN_AGENT_CREATIVE_BADGE,
  CAMPAIGN_AGENT_SUMMARY_TITLE,
  CAMPAIGN_AGENT_SUMMARY_NEW_VALUE,
  CAMPAIGN_AGENT_SUMMARY_NEW_VALUES,
  CAMPAIGN_AGENT_SUMMARY_ADD_ONE,
  CAMPAIGN_AGENT_SUMMARY_ADD_MANY,
  CAMPAIGN_AGENT_SUMMARY_REMOVE_ONE,
  CAMPAIGN_AGENT_SUMMARY_REMOVE_ITEM,
  CAMPAIGN_AGENT_SUMMARY_REMOVE_MANY,
  CAMPAIGN_AGENT_SUMMARY_CREATE,
  CAMPAIGN_AGENT_SUMMARY_CREATE_UNNAMED,
  CAMPAIGN_AGENT_SUMMARY_CREATIVE,
  CAMPAIGN_AGENT_SUMMARY_MORE_ONE,
  CAMPAIGN_AGENT_SUMMARY_MORE_MANY,
  CAMPAIGN_AGENT_SUMMARY_FOOTNOTE,
  CAMPAIGN_AGENT_SUMMARY_CREATIVE_FOOTNOTE,
  CAMPAIGN_AGENT_SUMMARY_MANUAL,
  BUTTON_CAMPAIGN_AGENT_REVIEW_AND_APPLY,
  BUTTON_CAMPAIGN_AGENT_APPLY_AND_OPEN_AD,
  BUTTON_CAMPAIGN_AGENT_VIEW_RECOMMENDATION,
  BUTTON_CAMPAIGN_AGENT_VIEW_CHANGES,
  CAMPAIGN_AGENT_APPLIED_BADGE,
  CAMPAIGN_AGENT_APPLIED_CAPTION,
  CAMPAIGN_AGENT_DONE_CAPTION,
  CAMPAIGN_AGENT_DISCARDED_BADGE,
  CAMPAIGN_AGENT_DISCARDED_CAPTION,
  CAMPAIGN_AGENT_RESULT_APPLIED_TITLE,
  CAMPAIGN_AGENT_RESULT_APPLIED_DESCRIPTION,
  CAMPAIGN_AGENT_RESULT_PARTIAL_TITLE,
  CAMPAIGN_AGENT_RESULT_PARTIAL_DESCRIPTION,
  CAMPAIGN_AGENT_RESULT_FAILED_TITLE,
  CAMPAIGN_AGENT_RESULT_FAILED_DESCRIPTION,
  CAMPAIGN_AGENT_RESULT_CREATIVE_TITLE,
  CAMPAIGN_AGENT_RESULT_CREATIVE_DESCRIPTION,
  BUTTON_CAMPAIGN_AGENT_GO_TO_PUBLISH,
  BUTTON_CAMPAIGN_AGENT_NEXT_IMPROVEMENT,
  BUTTON_CAMPAIGN_AGENT_ASK_ALTERNATIVE,
  CAMPAIGN_AGENT_ASK_ALTERNATIVE_MESSAGE,
  CAMPAIGN_AGENT_FOLLOW_UP_MORE_TITLE,
  CAMPAIGN_AGENT_FOLLOW_UP_MORE_MESSAGE,
  CAMPAIGN_AGENT_FOLLOW_UP_BUDGET_TITLE,
  CAMPAIGN_AGENT_FOLLOW_UP_COPY_TITLE,
  CAMPAIGN_AGENT_BUTTON_TOOLTIP,
  CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_ONE,
  CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_MANY,
  PAYWALL_INSUFFICIENT_CREDITS_TITLE,
  PAYWALL_INSUFFICIENT_CREDITS_SUBTITLE,
  PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_TITLE,
  PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_DESCRIPTION,
  PAYWALL_INSUFFICIENT_CREDITS_BUY_TITLE,
  PAYWALL_INSUFFICIENT_CREDITS_BUY_DESCRIPTION,
  PAYWALL_INSUFFICIENT_CREDITS_ARIA_LABEL,
  BULK_CAMPAIGNS_CONTENTS_COUNTER,
  BULK_PLATFORM_GOOGLE,
  BULK_PLATFORM_META,
  BULK_PLATFORM_TIKTOK,
  BULK_PLATFORM_LINKEDIN,
  BULK_FIELD_INSTAGRAM,
  BULK_CAMPAIGNS_EMPTY_FILE,
  BULK_CAMPAIGNS_TOO_MANY_CONTENTS,
  BULK_CAMPAIGNS_ANALYZE,
  BULK_CAMPAIGNS_CANCEL_ANALYSIS,
  BULK_CAMPAIGNS_STALE,
  BULK_CAMPAIGNS_SELECT_CONTENTS,
  BULK_CAMPAIGNS_CONTENTS_HINT,
  BULK_CAMPAIGNS_REMOVE_CONTENT,
  BULK_CAMPAIGNS_FILE_READY,
  BULK_CAMPAIGNS_REPLACE_FILE,
  BULK_CAMPAIGNS_RESULT_CREATED,
  BULK_CAMPAIGNS_RESULT_FAILED,
  BULK_CAMPAIGNS_RESULT_CLEARED,
  BULK_CAMPAIGNS_RESULT_CLEARED_DETAIL,
  BULK_CAMPAIGNS_RESULT_TITLE,
  BULK_CAMPAIGNS_VIEW_CAMPAIGNS,
  BULK_CAMPAIGNS_SUMMARY_COUNT,
  BULK_CAMPAIGNS_ACCOUNTS_UNAVAILABLE,
  BULK_FIELD_PRIMARY_TEXT,
  BULK_FIELD_HEADLINE,
  BULK_FIELD_LONG_HEADLINE,
  BULK_FIELD_SEARCH_THEME,
  BULK_FIELD_CALL_TO_ACTION,
  BULK_FIELD_TITLES,
  BULK_FIELD_HEADLINES,
  BULK_FIELD_LONG_HEADLINES,
  BULK_FIELD_DESCRIPTIONS,
  BULK_FIELD_KEYWORDS,
  BULK_FIELD_KEYWORDS_NEGATIVE,
  BULK_FIELD_DESTINATION_URL,
  BULK_FIELD_DAILY_BUDGET,
  BULK_FIELD_LANGUAGE,
  BULK_FIELD_OBJECTIVE,
  BULK_FIELD_SEARCH_THEMES,
  BULK_FIELD_CALLOUTS,
  BULK_FIELD_AUDIENCE,
  BULK_FIELD_PAGE,
  BULK_FIELD_IDENTITY,
  BULK_FIELD_APP,
  BULK_FIELD_APP_STORE,
  BULK_FIELD_AD_FORMAT,
  BULK_FIELD_ACCOUNT,
  BULK_FIELD_MERCHANT,
  BULK_FIELD_LOCATIONS,
  TIKTOK_INDUSTRY_22102000000,
  TIKTOK_INDUSTRY_22101000000,
  TIKTOK_INDUSTRY_22107000000,
  TIKTOK_INDUSTRY_22108000000,
  TIKTOK_INDUSTRY_22109000000,
  TIKTOK_INDUSTRY_22106000000,
  TIKTOK_INDUSTRY_22999000000,
  TIKTOK_INDUSTRY_22112000000,
  TIKTOK_INDUSTRY_22105000000,
  TIKTOK_INDUSTRY_22113000000,
  TIKTOK_INDUSTRY_22110000000,
  TIKTOK_INDUSTRY_22111000000,
  TIKTOK_INDUSTRY_16105000000,
  TIKTOK_INDUSTRY_16104000000,
  TIKTOK_INDUSTRY_16101000000,
  TIKTOK_INDUSTRY_16102000000,
  TIKTOK_INDUSTRY_16999000000,
  TIKTOK_INDUSTRY_16100000000,
  TIKTOK_INDUSTRY_20101000000,
  TIKTOK_INDUSTRY_20110000000,
  TIKTOK_INDUSTRY_20104000000,
  TIKTOK_INDUSTRY_20106000000,
  TIKTOK_INDUSTRY_20109000000,
  TIKTOK_INDUSTRY_20107000000,
  TIKTOK_INDUSTRY_20102000000,
  TIKTOK_INDUSTRY_20105000000,
  TIKTOK_INDUSTRY_20999000000,
  TIKTOK_INDUSTRY_20111000000,
  TIKTOK_INDUSTRY_20103000000,
  TIKTOK_INDUSTRY_20100000000,
  TIKTOK_INDUSTRY_20108000000,
  TIKTOK_INDUSTRY_20112000000,
  TIKTOK_INDUSTRY_12104000000,
  TIKTOK_INDUSTRY_12108000000,
  TIKTOK_INDUSTRY_12100000000,
  TIKTOK_INDUSTRY_12102000000,
  TIKTOK_INDUSTRY_12110000000,
  TIKTOK_INDUSTRY_12105000000,
  TIKTOK_INDUSTRY_12107000000,
  TIKTOK_INDUSTRY_12109000000,
  TIKTOK_INDUSTRY_12103000000,
  TIKTOK_INDUSTRY_12999000000,
  TIKTOK_INDUSTRY_12101000000,
  TIKTOK_INDUSTRY_12106000000,
  TIKTOK_INDUSTRY_14105000000,
  TIKTOK_INDUSTRY_14104000000,
  TIKTOK_INDUSTRY_14107000000,
  TIKTOK_INDUSTRY_14106000000,
  TIKTOK_INDUSTRY_14101000000,
  TIKTOK_INDUSTRY_14100000000,
  TIKTOK_INDUSTRY_14999000000,
  TIKTOK_INDUSTRY_14103000000,
  TIKTOK_INDUSTRY_14102000000,
  TIKTOK_INDUSTRY_24108000000,
  TIKTOK_INDUSTRY_24118000000,
  TIKTOK_INDUSTRY_24105000000,
  TIKTOK_INDUSTRY_24103000000,
  TIKTOK_INDUSTRY_24104000000,
  TIKTOK_INDUSTRY_24109000000,
  TIKTOK_INDUSTRY_24114000000,
  TIKTOK_INDUSTRY_24107000000,
  TIKTOK_INDUSTRY_24120000000,
  TIKTOK_INDUSTRY_24119000000,
  TIKTOK_INDUSTRY_24116000000,
  TIKTOK_INDUSTRY_24117000000,
  TIKTOK_INDUSTRY_24111000000,
  TIKTOK_INDUSTRY_24106000000,
  TIKTOK_INDUSTRY_24112000000,
  TIKTOK_INDUSTRY_24101000000,
  TIKTOK_INDUSTRY_24999000000,
  TIKTOK_INDUSTRY_24113000000,
  TIKTOK_INDUSTRY_24100000000,
  TIKTOK_INDUSTRY_24102000000,
  TIKTOK_INDUSTRY_24110000000,
  TIKTOK_INDUSTRY_24115000000,
  TIKTOK_INDUSTRY_30100000000,
  TIKTOK_INDUSTRY_30102000000,
  TIKTOK_INDUSTRY_30101000000,
  TIKTOK_INDUSTRY_10100000000,
  TIKTOK_INDUSTRY_10102000000,
  TIKTOK_INDUSTRY_10105000000,
  TIKTOK_INDUSTRY_10106000000,
  TIKTOK_INDUSTRY_10999000000,
  TIKTOK_INDUSTRY_10103000000,
  TIKTOK_INDUSTRY_10101000000,
  TIKTOK_INDUSTRY_10104000000,
  TIKTOK_INDUSTRY_13100000000,
  TIKTOK_INDUSTRY_13108000000,
  TIKTOK_INDUSTRY_13117000000,
  TIKTOK_INDUSTRY_13115000000,
  TIKTOK_INDUSTRY_13116000000,
  TIKTOK_INDUSTRY_13112000000,
  TIKTOK_INDUSTRY_13107000000,
  TIKTOK_INDUSTRY_13104000000,
  TIKTOK_INDUSTRY_13102000000,
  TIKTOK_INDUSTRY_13110000000,
  TIKTOK_INDUSTRY_13111000000,
  TIKTOK_INDUSTRY_13109000000,
  TIKTOK_INDUSTRY_13999000000,
  TIKTOK_INDUSTRY_13105000000,
  TIKTOK_INDUSTRY_13113000000,
  TIKTOK_INDUSTRY_13101000000,
  TIKTOK_INDUSTRY_13114000000,
  TIKTOK_INDUSTRY_1310300000,
  TIKTOK_INDUSTRY_27103000000,
  TIKTOK_INDUSTRY_27104000000,
  TIKTOK_INDUSTRY_27100000000,
  TIKTOK_INDUSTRY_27101000000,
  TIKTOK_INDUSTRY_27102000000,
  TIKTOK_INDUSTRY_27999000000,
  TIKTOK_INDUSTRY_25301000000,
  TIKTOK_INDUSTRY_25302000000,
  TIKTOK_INDUSTRY_25300000000,
  TIKTOK_INDUSTRY_25313000000,
  TIKTOK_INDUSTRY_25303000000,
  TIKTOK_INDUSTRY_25999000000,
  TIKTOK_INDUSTRY_25311000000,
  TIKTOK_INDUSTRY_25304000000,
  TIKTOK_INDUSTRY_25305000000,
  TIKTOK_INDUSTRY_25306000000,
  TIKTOK_INDUSTRY_25307000000,
  TIKTOK_INDUSTRY_25308000000,
  TIKTOK_INDUSTRY_25309000000,
  TIKTOK_INDUSTRY_25310000000,
  TIKTOK_INDUSTRY_25312000000,
  TIKTOK_INDUSTRY_29102000000,
  TIKTOK_INDUSTRY_29101000000,
  TIKTOK_INDUSTRY_29100000000,
  TIKTOK_INDUSTRY_29103000000,
  TIKTOK_INDUSTRY_29999000000,
  TIKTOK_INDUSTRY_21102000000,
  TIKTOK_INDUSTRY_21101000000,
  TIKTOK_INDUSTRY_21103000000,
  TIKTOK_INDUSTRY_21104000000,
  TIKTOK_INDUSTRY_21100000000,
  TIKTOK_INDUSTRY_21999000000,
  TIKTOK_INDUSTRY_21105000000,
  TIKTOK_INDUSTRY_18106000000,
  TIKTOK_INDUSTRY_18110000000,
  TIKTOK_INDUSTRY_18104000000,
  TIKTOK_INDUSTRY_18101000000,
  TIKTOK_INDUSTRY_18102000000,
  TIKTOK_INDUSTRY_18105000000,
  TIKTOK_INDUSTRY_18108000000,
  TIKTOK_INDUSTRY_18109000000,
  TIKTOK_INDUSTRY_18999000000,
  TIKTOK_INDUSTRY_18112000000,
  TIKTOK_INDUSTRY_18100000000,
  TIKTOK_INDUSTRY_18103000000,
  TIKTOK_INDUSTRY_18107000000,
  TIKTOK_INDUSTRY_18111000000,
  TIKTOK_INDUSTRY_26114000000,
  TIKTOK_INDUSTRY_26112000000,
  TIKTOK_INDUSTRY_26102000000,
  TIKTOK_INDUSTRY_26113000000,
  TIKTOK_INDUSTRY_26108000000,
  TIKTOK_INDUSTRY_26104000000,
  TIKTOK_INDUSTRY_26105000000,
  TIKTOK_INDUSTRY_26111000000,
  TIKTOK_INDUSTRY_26999000000,
  TIKTOK_INDUSTRY_26101000000,
  TIKTOK_INDUSTRY_26106000000,
  TIKTOK_INDUSTRY_26107000000,
  TIKTOK_INDUSTRY_26109000000,
  TIKTOK_INDUSTRY_26103000000,
  TIKTOK_INDUSTRY_26100000000,
  TIKTOK_INDUSTRY_23113000000,
  TIKTOK_INDUSTRY_23114000000,
  TIKTOK_INDUSTRY_23122000000,
  TIKTOK_INDUSTRY_23102000000,
  TIKTOK_INDUSTRY_23126000000,
  TIKTOK_INDUSTRY_23108000000,
  TIKTOK_INDUSTRY_23105000000,
  TIKTOK_INDUSTRY_23111000000,
  TIKTOK_INDUSTRY_23116000000,
  TIKTOK_INDUSTRY_23104000000,
  TIKTOK_INDUSTRY_23128000000,
  TIKTOK_INDUSTRY_23107000000,
  TIKTOK_INDUSTRY_23124000000,
  TIKTOK_INDUSTRY_23125000000,
  TIKTOK_INDUSTRY_23127000000,
  TIKTOK_INDUSTRY_23115000000,
  TIKTOK_INDUSTRY_23106000000,
  TIKTOK_INDUSTRY_23109000000,
  TIKTOK_INDUSTRY_23110000000,
  TIKTOK_INDUSTRY_23100000000,
  TIKTOK_INDUSTRY_23119000000,
  TIKTOK_INDUSTRY_23999000000,
  TIKTOK_INDUSTRY_23129000000,
  TIKTOK_INDUSTRY_23101000000,
  TIKTOK_INDUSTRY_23118000000,
  TIKTOK_INDUSTRY_23130000000,
  TIKTOK_INDUSTRY_23131000000,
  TIKTOK_INDUSTRY_23103000000,
  TIKTOK_INDUSTRY_23134000000,
  TIKTOK_INDUSTRY_23123000000,
  TIKTOK_INDUSTRY_23132000000,
  TIKTOK_INDUSTRY_23133000000,
  TIKTOK_INDUSTRY_23112000000,
  TIKTOK_INDUSTRY_23117000000,
  TIKTOK_INDUSTRY_19999000000,
  TIKTOK_INDUSTRY_19103000000,
  TIKTOK_INDUSTRY_19101000000,
  TIKTOK_INDUSTRY_19102000000,
  TIKTOK_INDUSTRY_19105000000,
  TIKTOK_INDUSTRY_19106000000,
  TIKTOK_INDUSTRY_19104000000,
  TIKTOK_INDUSTRY_19100000000,
  TIKTOK_INDUSTRY_28100000000,
  TIKTOK_INDUSTRY_28101000000,
  TIKTOK_INDUSTRY_15100000000,
  TIKTOK_INDUSTRY_15105000000,
  TIKTOK_INDUSTRY_15103000000,
  TIKTOK_INDUSTRY_15101000000,
  TIKTOK_INDUSTRY_15102000000,
  TIKTOK_INDUSTRY_15104000000,
  TIKTOK_INDUSTRY_15106000000,
  TIKTOK_INDUSTRY_15107000000,
  TIKTOK_INDUSTRY_15999000000,
  TIKTOK_INDUSTRY_17103000000,
  TIKTOK_INDUSTRY_17999000000,
  TIKTOK_INDUSTRY_17105000000,
  TIKTOK_INDUSTRY_17106000000,
  TIKTOK_INDUSTRY_11111000000,
  TIKTOK_INDUSTRY_11110000000,
  TIKTOK_INDUSTRY_11101000000,
  TIKTOK_INDUSTRY_11103000000,
  TIKTOK_INDUSTRY_11102000000,
  TIKTOK_INDUSTRY_11100000000,
  TIKTOK_INDUSTRY_11107000000,
  TIKTOK_INDUSTRY_11112000000,
  TIKTOK_INDUSTRY_11104000000,
  TIKTOK_INDUSTRY_11108000000,
  TIKTOK_INDUSTRY_11106000000,
  TIKTOK_INDUSTRY_11999000000,
  TIKTOK_INDUSTRY_11105000000,
  TIKTOK_INDUSTRY_11109000000,
  META_ATTRIBUTION_WINDOW_TITLE,
  META_ATTRIBUTION_WINDOW_DESCRIPTION,
  META_ATTRIBUTION_WINDOW_7D_CLICK_1D_VIEW,
  META_ATTRIBUTION_WINDOW_7D_CLICK,
  META_ATTRIBUTION_WINDOW_1D_CLICK_1D_VIEW,
  META_ATTRIBUTION_WINDOW_1D_CLICK,
  META_ATTRIBUTION_WINDOW_DEFAULT_OPTION,
  META_ATTRIBUTION_ENGAGED_VIEW_LABEL,
  WHITE_LABEL_TITLE,
  WHITE_LABEL_BUY,
  WHITE_LABEL_PRICE_PER_MONTH,
  WHITE_LABEL_DIALOG_BODY,
  WHITE_LABEL_NO_SETUP_FEE,
  WHITE_LABEL_AFTER_PAYMENT,
  WHITE_LABEL_APP_SUMO_CONFIRM,
  WHITE_LABEL_ONLY_OWNER,
  WHITE_LABEL_STATUS_PENDING_BRANDING,
  WHITE_LABEL_STATUS_CONFIGURING,
  WHITE_LABEL_STATUS_ACTIVE,
  WHITE_LABEL_STATUS_REVERT_PENDING,
  WHITE_LABEL_ALREADY_ACTIVE,
  WHITE_LABEL_COMPLETE_BRAND,
  WHITE_LABEL_EDIT_BRAND,
  WHITE_LABEL_FORM_TITLE,
  WHITE_LABEL_FORM_INTRO,
  WHITE_LABEL_FORM_SECTION_GENERAL,
  WHITE_LABEL_FORM_SECTION_VISUAL,
  WHITE_LABEL_FORM_SECTION_VISUAL_HELP,
  WHITE_LABEL_FORM_SECTION_COLORS,
  WHITE_LABEL_FORM_SECTION_COLORS_HELP,
  WHITE_LABEL_FORM_SECTION_DOMAIN,
  WHITE_LABEL_FORM_BADGE_REQUIRED,
  WHITE_LABEL_FORM_BADGE_OPTIONAL,
  WHITE_LABEL_FORM_DROP_TITLE,
  WHITE_LABEL_FORM_DROP_HINT,
  WHITE_LABEL_FORM_INVALID_FILE,
  WHITE_LABEL_FORM_DOMAIN_BLOCKED,
  WHITE_LABEL_FORM_DOMAIN_INVALID,
  WHITE_LABEL_FORM_COLOR_INVALID,
  WHITE_LABEL_FORM_NAME_INVALID,
  WHITE_LABEL_FORM_NOTES_INVALID,
  WHITE_LABEL_FORM_LOGO_NAV_HELP,
  WHITE_LABEL_FORM_LOGO_LOGIN_HELP,
  WHITE_LABEL_FORM_FAVICON_CAPTION,
  WHITE_LABEL_FORM_FAVICON_HELP,
  WHITE_LABEL_FORM_NAME_PLACEHOLDER,
  WHITE_LABEL_FORM_DOMAIN_PLACEHOLDER,
  WHITE_LABEL_FORM_NOTES_PLACEHOLDER,
  WHITE_LABEL_FORM_COLOR_PRIMARY,
  WHITE_LABEL_FORM_COLOR_SECONDARY,
  WHITE_LABEL_FORM_COLOR_BUTTONS,
  WHITE_LABEL_FORM_NAME_BUSINESS,
  WHITE_LABEL_FORM_LOGO,
  WHITE_LABEL_FORM_LOGO_NAVBAR,
  WHITE_LABEL_FORM_LOGO_LOGIN,
  WHITE_LABEL_FORM_FAVICON,
  WHITE_LABEL_FORM_PRIMARY_COLOR,
  WHITE_LABEL_FORM_SECONDARY_COLOR,
  WHITE_LABEL_FORM_PRIMARY_BUTTON_COLOR,
  WHITE_LABEL_FORM_DESIRED_DOMAIN,
  WHITE_LABEL_FORM_DOMAIN_HELP,
  WHITE_LABEL_FORM_NOTES,
  WHITE_LABEL_FORM_SUBMIT,
  WHITE_LABEL_FORM_SUBMITTED,
  WHITE_LABEL_CONFIRMING_PAYMENT,
  WHITE_LABEL_CHECKOUT_CANCELLED,
  WHITE_LABEL_NOT_ELIGIBLE,
  WHITE_LABEL_ERROR_ALREADY_ACTIVE,
  WHITE_LABEL_NOT_PURCHASED,
  WHITE_LABEL_INVALID_BRANDING,
  WHITE_LABEL_INVALID_TRANSITION,
  AGENCY_ACCOUNT_LINKING_PICKER_TITLE,
  AGENCY_ACCOUNT_LINKING_PICKER_SHEET_TITLE,
  AGENCY_ACCOUNT_LINKING_PICKER_SHEET_DESCRIPTION,
  AGENCY_ACCOUNT_LINKING_CONSENT,
  AGENCY_ACCOUNT_LINKING_CONSENT_TOOLTIP,
  AGENCY_ACCOUNT_LINKING_CONSENT_INFO,
  AGENCY_ACCOUNT_LINKING_CARD_TITLE,
  AGENCY_ACCOUNT_LINKING_CARD_BODY,
  AGENCY_ACCOUNT_LINKING_ENABLE,
  AGENCY_ACCOUNT_LINKING_NOT_NOW,
  AGENCY_ACCOUNT_LINKING_SHEET_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_DESCRIPTION,
  AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_TITLE,
  AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_BODY,
  AGENCY_ACCOUNT_LINKING_CONFIRM,
  AGENCY_ACCOUNT_LINKING_TOAST_DONE_ONE,
  AGENCY_ACCOUNT_LINKING_TOAST_DONE_OTHER,
  AGENCY_ACCOUNT_LINKING_TOAST_PARTIAL,
  AGENCY_ACCOUNT_LINKING_TOAST_LATER,
  AGENCY_ACCOUNT_LINKING_PLATFORM_META,
  AGENCY_ACCOUNT_LINKING_PLATFORM_GOOGLE,
  AGENCY_ACCOUNT_LINKING_PLATFORM_TIKTOK,
  AGENCY_ACCOUNT_LINKING_SHEET_LINKING,
  AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_BODY,
  AGENCY_ACCOUNT_LINKING_SHEET_FAILED_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_FAILED_BODY,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_BODY,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_META,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GOOGLE,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_TIKTOK,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GENERIC,
  AGENCY_ACCOUNT_LINKING_SHEET_NOT_CONFIGURED,
  AGENCY_ACCOUNT_LINKING_SHEET_RECONNECT,
  AGENCY_ACCOUNT_LINKING_SHEET_RETRY_STEP,
  AGENCY_ACCOUNT_LINKING_SHEET_REQUEST_AGAIN,
  AGENCY_ACCOUNT_LINKING_SHEET_SUPPORT,
  AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS,
  AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING,
  AGENCY_ACCOUNT_LINKING_COLUMN_STATUS,
  AGENCY_ACCOUNT_LINKING_COLUMN_DETAILS,
  AGENCY_ACCOUNT_LINKING_STATUS_UNLINKED,
  AGENCY_ACCOUNT_LINKING_STATUS_PENDING,
  AGENCY_ACCOUNT_LINKING_STATUS_FAILED,
  AGENCY_ACCOUNT_LINKING_STATUS_LINKED,
  AGENCY_ACCOUNT_LINKING_DETAIL_NOT_ADMIN,
  AGENCY_ACCOUNT_LINKING_DETAIL_RECONNECT,
  AGENCY_ACCOUNT_LINKING_DETAIL_UNREADABLE,
  AGENCY_ACCOUNT_LINKING_DETAIL_NOT_CONFIGURED,
  AGENCY_ACCOUNT_LINKING_DETAIL_NOT_IN_BUSINESS,
  AGENCY_ACCOUNT_LINKING_DETAIL_LIMIT,
  AGENCY_ACCOUNT_LINKING_DETAIL_MANAGED_ELSEWHERE,
  AGENCY_ACCOUNT_LINKING_DETAIL_INCOMPATIBLE,
  AGENCY_ACCOUNT_LINKING_DETAIL_REJECTED,
  AGENCY_ACCOUNT_LINKING_DETAIL_EXPIRED,
  AGENCY_ACCOUNT_LINKING_DETAIL_REVOKED,
  AGENCY_ACCOUNT_LINKING_DETAIL_UNSUPPORTED,
  AGENCY_ACCOUNT_LINKING_DETAIL_GENERIC,
  ADLE_CARD_WAITLIST_EYEBROW,
  ADLE_CARD_WAITLIST_TITLE,
  ADLE_CARD_WAITLIST_SUBTITLE,
  ADLE_CARD_WAITLIST_FEATURE_VIRTUAL_CARDS,
  ADLE_CARD_WAITLIST_FEATURE_SINGLE_BALANCE,
  ADLE_CARD_WAITLIST_FEATURE_CASHBACK,
  ADLE_CARD_WAITLIST_FEATURE_NO_FEES,
  ADLE_CARD_WAITLIST_FEATURE_NO_DECLINES,
  ADLE_CARD_WAITLIST_FEATURE_TOP_UPS,
  ADLE_CARD_WAITLIST_EMAIL_LABEL,
  ADLE_CARD_WAITLIST_COUNTRY_LABEL,
  ADLE_CARD_WAITLIST_COUNTRY_PLACEHOLDER,
  ADLE_CARD_WAITLIST_CTA,
  ADLE_CARD_WAITLIST_NOT_NOW,
  ADLE_CARD_WAITLIST_DISCLAIMER,
  ADLE_CARD_WAITLIST_SUCCESS_TITLE,
  ADLE_CARD_WAITLIST_SUCCESS_DESCRIPTION,
  ADLE_CARD_WAITLIST_SUBMIT_ERROR,
  ADLE_CARD_WAITLIST_BANNER,
  ADLE_CARD_WAITLIST_BANNER_LINK,
  ADLE_CARD_WAITLIST_CARD_ARIA,
  ADLE_CARD_WAITLIST_CARD_VIRTUAL,
  ADLE_CARD_WAITLIST_CARD_BRAND_FALLBACK,
  OWNER_DASHBOARD_NAV_ADLE_CARD_WAITLIST,
  ADLE_CARD_WAITLIST_ADMIN_TOTAL,
  ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_ALL_TIME,
  ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_3M,
  ADLE_CARD_WAITLIST_ADMIN_SPEND_UNAVAILABLE,
} from "../keysTranslations";

const translation = {
  /*COMMON*/
  [SEARCH]: "Buscar",
  [LOADING_INFORMATION]: "Carregando informação",
  [LOADING_SUGGESTED_INFORMATION]:
    "Buscando criadores sugeridos, isso pode demorar um pouco",
  [LOADING_SIMILAR_PROFILES_INFORMATION]: "Carregando perfis de referência",
  [LOADING_REPORT_INFORMATION]: "Carregando relatório",
  [LOADING_DOWNLOAD_PROFILES]: "Baixando perfis",
  [LOADING_CONTENT]: "Carregando conteúdo",
  [LOADING_CONFIGURATION]: "Carregando configuração",
  [LOADING_PLAN_INFORMATION]: "Carregando informações dos planos",
  [UPDATING_INFORMATION]: "Atualizando informação",
  [INFORMATION_INVALID_ACCESS]: "Você não pode acessar esta informação",
  [EMPTY_CONTENT_SHOW]: "Não há conteúdo para exibir",
  [EMPTY_SIMILAR_PROFILES_SHOW]: "Nenhum perfil de referência encontrado",
  [EMPTY_RESULTS_SHOW]: "Nenhum resultado encontrado",
  [NO_MORE_RESULTS_TO_SHOW]: "Não há mais resultados para exibir",
  [EMPTY_RESULTS_SHOW_ON_THIS_PAGE]: "Nenhum resultado encontrado nesta página",
  [EMPTY_QUESTIONS_SHOW]: "Nenhuma pergunta encontrada",
  [EMPTY_ANALYTICS]:
    "Não foi possível obter as analíticas desta publicação. Entre em contato com o suporte ou seu assessor.",
  [EMPTY_KEYWORDS]: "Nenhuma palavra-chave encontrada",
  [ADVANCED_CONFIGURATION]: "Configuração avançada",
  [WAIT]: "Aguarde",
  [COLLABORATIONS]: "Colaborações",
  [COLLABORATION]: "Colaboração",
  [ALL]: "Todos",
  [DEACTIVATE]: "Desativar",
  [ACTIVATE]: "Ativar",
  [DEACTIVATED]: "Desativada",
  [ACTIVATED]: "Ativado",
  [ACTIVE]: "Ativada",
  [BRAND]: "Marca",
  [WARNING]: "Aviso",
  [INFORMATION]: "Informação",
  [CATEGORY]: "Categoria",
  [CATEGORIES]: "Categorias",
  [PRODUCT]: "Produto",
  [PRODUCTS]: "Produtos",
  [ERROR]: "Erro",
  [ACTIONS]: "Ações",
  [STATUS]: "Situação",
  [CITIES]: "Cidades",
  [UNKNOWN_FORMAT]: "Formato desconhecido",
  [ERROR_DESCRIPTION_GENERIC]: "{{message}}",
  [HELP]: "Ajuda",
  [READY]: "Pronto",
  [FIELD_HAS_NO_VALUE_TO_COPY]: "Este campo não tem um valor para copiar",
  [GO]: "Ir",
  [GO_TO_PROFILE]: "Ir ao perfil",
  [GO_TO_ACCOUNT]: "Ir para a conta",
  [PROFILE]: "Perfil",
  [LOGOUT]: "Sair",
  [CLIENT]: "Cliente",
  [NAME]: "Nome",
  [ADDRESS]: "Endereço",
  [IDENTIFICATION_NUMBER]: "Número de identificação",
  [PHONE_NUMBER]: "Telefone",
  [EMAIL]: "E-mail",
  [NOTIFICATIONS]: "Notificações",
  [CONTENT]: "Conteúdo",
  [ANALYTIC]: "Analítica",
  [ANALYTICS]: "Analíticas",
  [COMMENTS]: "Comentários",
  [COMMENT]: "Comentário",
  [SHOW_COMMENTS]: "Mostrar comentários",
  [EMPTY_COMMENTS]: "Não há comentários",
  [REVIEWS]: "Avaliações",
  [REVIEW]: "Avaliação",
  [SHOW_REVIEWS]: "Mostrar avaliações",
  [EMPTY_REVIEWS]: "Não há avaliações",
  [SCORE]: "Pontuação",
  [QUALITY_AUDIENCE]: "Qualidade da audiência",
  [QUALITY_CONTENT]: "Qualidade do conteúdo",
  [AUDIENCE]: "Audiência",
  [AUDIENCE_TITLE_EXPLANATION]: "O que é a audiência?",
  [AUDIENCE_EXPLANATION]:
    "A audiência é o número de pessoas que seguem ou estão inscritas no perfil do criador de conteúdo. Audiências grandes têm um melhor alcance (reach) em cada publicação, mas geralmente a taxa de interação (engagement) é menor à medida que a audiência aumenta.",
  [ENGAGEMENT]: "Engajamento",
  [ENGAGEMENT_TITLE_EXPLANATION]: "O que é o engajamento?",
  [ENGAGEMENT_EXPLANATION]:
    "O engajamento ou taxa de interação é a quantidade de pessoas que interagem com o conteúdo publicado, seja uma curtida, um comentário, um compartilhamento, um save ou outras ações dependendo da plataforma. Se você quiser estimar quantas pessoas vão interagir com o conteúdo, multiplique a audiência pelo engajamento e divida por 100.",
  [FOLLOWERS]: "Seguidores",
  [AVG_VIEWS]: "Média de visualizações",
  [AVG_LIKES]: "Média de curtidas",
  [POST]: "Publicação",
  [AVG_COMMENTS]: "Média de comentários",
  [RECORDS_IN_TABLE]: "Cadastros",
  [SHOP_DEACTIVATE_ALERT_DESCRIPTION]:
    "Sua loja foi desativada. Entre em contato com o suporte se precisar de ajuda.",
  [PAGE_IN_TABLE]: "Página",
  [UPDATE]: "Atualizar",
  [MALES]: "Homens",
  [MALE]: "Homem",
  [FEMALES]: "Mulheres",
  [FEMALE]: "Mulher",
  [STORE]: "Loja",
  [SELECT_STORE]: "Selecione uma loja",
  [EMPTY_STORES]: "Nenhuma loja criada",
  [ORDER]: "Pedido",
  [NEW_ORDER]: "Novo pedido",
  [NEW]: "Novo",
  [SECOND]: "Segundo",
  [SECONDS]: "Segundos",
  [MINUTE]: "Minuto",
  [MINUTES]: "Minutos",
  [MINUTE_LETTER_COUNT_DOWN]: "min",
  [HOUR]: "Hora",
  [HOURS]: "Horas",
  [HOUR_LETTER_COUNT_DOWN]: "h",
  [DAY]: "Dia",
  [DAYS]: "Dias",
  [DAY_LETTER_COUNT_DOWN]: "d",
  [WEEK]: "Semana",
  [WEEKS]: "Semanas",
  [WEEK_LETTER_COUNT_DOWN]: "sem",
  [MONTH]: "Mês",
  [MONTHS]: "Meses",
  [CALENDAR_MONTH]: "Mês",
  [CALENDAR_WEEK]: "Semana",
  [CALENDAR_DAY]: "Dia",
  [CALENDAR_TODAY]: "Hoje",
  [CALENDAR_TOMORROW]: "Amanhã",
  [CALENDAR_NEXT]: "Próximo",
  [CALENDAR_PREVIOUS]: "Anterior",
  [CALENDAR_AGENDA]: "Agenda",
  [CALENDAR_SHOW_MORE]: "+ {{total}} mais",
  [VIEW_CALENDAR]: "Ver calendário",
  [POST_TITLE]: "Publicações",
  [CALENDAR_POST_TITLE]: "Publicação",
  [CALENDAR_STORIES_TITLE]: "História",
  [CALENDAR_REELS_TITLE]: "Reel",
  [CALENDAR_MULTIPLE_POST_TITLE]: "Publicação - Múltiplas redes",
  [CALENDAR_INVALID_DATE_ERROR]:
    "Por favor, selecione uma data e hora futura para agendar sua publicação.",
  [EVENT_DETAILS_DESCRIPTION]: "Descrição",
  [EVENT_DETAILS_DATE_AND_TIME]: "Data e hora",
  [EVENT_DETAILS_SOCIAL_NETWORK]: "Rede social",
  [EVENT_DETAILS_STATUS]: "Situação",
  [EVENT_DETAILS_STATUS_DRAFT]: "Rascunho",
  [EVENT_DETAILS_STATUS_SCHEDULED]: "Agendado",
  [EVENT_DETAILS_STATUS_PUBLISHED]: "Publicado",
  [GALLERY_MAX_SELECTIONS_REACHED]:
    "Você pode selecionar até {{limit}} conteúdos.",
  [GALLERY_PUBLISHED_ON_PLATFORMS]: "Publicado em {{platforms}}",
  [GALLERY_PLATFORM_STATUSES_LABEL]: "Status de publicação",
  [GALLERY_STATUS_PUBLISHED_DIRECT]: "Publicado diretamente em {{date}}",
  [GALLERY_STATUS_PUBLISHED_DIRECT_UNKNOWN]: "Publicado diretamente",
  [GALLERY_STATUS_SCHEDULED]: "Agendado para {{date}}",
  [GALLERY_STATUS_SCHEDULED_UNKNOWN]: "Agendado",
  [GALLERY_STATUS_PUBLISHED_SCHEDULE]: "Publicado via agendamento em {{date}}",
  [GALLERY_STATUS_PUBLISHED_SCHEDULE_UNKNOWN]: "Publicado via agendamento",
  [GALLERY_STATUS_FAILED]: "Falhou em {{date}}",
  [GALLERY_STATUS_FAILED_UNKNOWN]: "Falhou",
  [GALLERY_STATUS_PUBLISHED_LEGACY]: "Publicado",
  [SHARE_MODAL_PLATFORM_ALREADY_PUBLISHED]:
    "Esta plataforma já foi publicada e não pode ser removida",
  [EVENT_DETAILS_STATUS_FAILED]: "Erro ao publicar",
  [EVENT_DETAILS_NETWORK_INSTAGRAM]: "Instagram",
  [EVENT_DETAILS_NETWORK_FACEBOOK]: "Facebook",
  [EVENT_DETAILS_NETWORK_TIKTOK]: "TikTok",
  [EVENT_DETAILS_NETWORK_LINKEDIN]: "LinkedIn",
  [EVENT_DETAILS_NETWORK_YOUTUBE]: "YouTube",
  [EVENT_DETAILS_CONTENT]: "Conteúdo",
  [ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE]: "Deseja tentar publicar novamente?",
  [ORGANIC_PUBLISH_RETRY_CONFIRM_DESCRIPTION]:
    "Você está prestes a tentar publicar novamente em {{platforms}}.",
  [ORGANIC_PUBLISH_RETRY_ALERT_ARIA_LABEL]:
    "Plataformas e erros da nova tentativa de publicação",
  [ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_PLATFORM]: "Plataforma",
  [ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_MESSAGE]: "Mensagem",
  [ORGANIC_PUBLISH_RETRY_ERROR]:
    "Não foi possível publicar em algumas plataformas. Revise os erros e tente novamente.",
  [ORGANIC_PUBLISH_PARTIAL_STATUS]: "Publicado parcialmente",
  [QUESTION]: "Pergunta",
  [QUESTIONS]: "Perguntas",
  [CONTENT_CREATOR]: "Criador de conteúdo",
  [ADD]: "Adicionar",
  [MONDAY]: "Segunda-feira",
  [TUESDAY]: "Terça-feira",
  [WEDNESDAY]: "Quarta-feira",
  [THURSDAY]: "Quinta-feira",
  [FRIDAY]: "Sexta-feira",
  [SATURDAY]: "Sábado",
  [SUNDAY]: "Domingo",
  [SELECT_A_OPTION]: "Selecione uma opção",
  [FILE_SELECTED]: "Arquivo selecionado: {{fileName}}",
  [YES]: "Sim",
  [NO]: "Não",
  [IMAGES]: "Imagens",
  [VIDEOS]: "Vídeos",
  [OK]: "Ok",
  [FILTER]: "Filtrar",
  [SUPER_ADMIN]: "Super administrador",
  [ADMIN]: "Administrador",
  [OPERATOR]: "Operador",
  [TOTAL]: "Total",
  [NO_HAVE]: "Não há",
  [NO_ADDED]: "Não adicionados",
  [SUPPORT]: "Suporte",
  [CONTACT_US]: "Fale conosco",
  [ONE]: "Um",
  [TWO]: "Dois",
  [THREE]: "Três",
  [ANY]: "Qualquer",
  [GENDER]: "Gênero",
  [REVISIONS]: "Revisões",
  [CURRENT_CONTENT]: "Conteúdo atual",
  [CURRENT_CONTENT_EMPTY]: "Não há conteúdo atual, aguarde o criador enviá-lo",
  [NO_SEND_CONTENT_FEEDBACK]: "O criador não enviou conteúdo de feedback",
  [EDIT]: "Editar",
  [THIS_CREATOR_IS_FAVORITE]: "É favorito",
  [ADD_TO_FAVORITES]: "Adicionar a favoritos",
  [REMOVE_FROM_FAVORITES]: "Remover dos favoritos",
  [SPANISH]: "Espanhol",
  [ENGLISH]: "Inglês",
  [PORTUGUESE]: "Português",
  [FRENCH]: "Francês",
  [RUSSIAN]: "Russo",
  [JAPANESE]: "Japonês",
  [MANDARIN]: "Mandarim",
  [HINDI]: "Hindi",
  [ARABIC]: "Árabe",
  [BENGALI]: "Bengali",
  [PUNJABI]: "Punjabi",
  [GERMAN]: "Alemão",
  [JAVANESE]: "Javanês",
  [KOREAN]: "Coreano",
  [INDONESIAN]: "Indonésio",
  [TURKISH]: "Turco",
  [BULGARIAN]: "Búlgaro",
  [SLOVAK]: "Eslovaco",
  [CROATIAN]: "Croata",
  [DANISH]: "Dinamarquês",
  [UKRAINIAN]: "Ucraniano",
  [ENGLISH_US]: "Inglês (EUA)",
  [ENGLISH_UK]: "Inglês (Reino Unido)",
  [SPANISH_SPAIN]: "Espanhol (Espanha)",
  [PORTUGUESE_BRAZIL]: "Português (Brasil)",
  [PORTUGUESE_PORTUGAL]: "Português (Portugal)",
  [FRENCH_FRANCE]: "Francês (França)",
  [FRENCH_CANADA]: "Francês (Canadá)",
  [TRADITIONAL_CHINESE_HONG_KONG]: "Chinês tradicional (Hong Kong)",
  [TRADITIONAL_CHINESE_TAIWAN]: "Chinês tradicional (Taiwan)",
  [JAPANESE_KANSAI]: "Japonês (Kansai)",
  [NORWEGIAN_BOKMAL]: "Norueguês (Bokmål)",
  [NORWEGIAN_NYNORSK]: "Norueguês (Nynorsk)",
  [CATALAN]: "Catalão",
  [CZECH]: "Tcheco",
  [WELSH]: "Galês",
  [BASQUE]: "Basco",
  [FINNISH]: "Finlandês",
  [GALICIAN]: "Galego",
  [HUNGARIAN]: "Húngaro",
  [ITALIAN]: "Italiano",
  [DUTCH]: "Holandês",
  [FRISIAN]: "Frísio",
  [POLISH]: "Polonês",
  [ROMANIAN]: "Romeno",
  [SLOVENIAN]: "Esloveno",
  [SWEDISH]: "Sueco",
  [FLEMISH]: "Flamengo",
  [ESPERANTO]: "Esperanto",
  [ESTONIAN]: "Estoniano",
  [FAROESE]: "Feroês",
  [GREEK]: "Grego",
  [ICELANDIC]: "Islandês",
  [IRISH]: "Irlandês",
  [LATVIAN]: "Letão",
  [LITHUANIAN]: "Lituano",
  [MACEDONIAN]: "Macedônio",
  [THAI]: "Tailandês",
  [VIETNAMESE]: "Vietnamita",
  [KHMER]: "Khmer",
  [FILIPINO]: "Filipino",
  [MALAY]: "Malaio",
  [GUJARATI]: "Gujarati",
  [KANNADA]: "Canarês",
  [TAMIL]: "Tâmil",
  [TELUGU]: "Telugu",
  [MALAYALAM]: "Malaiala",
  [URDU]: "Urdu",
  [HEBREW]: "Hebraico",
  [PERSIAN]: "Persa",
  [NORTHERN_KURDISH_KURMANJI]: "Kurdo do norte (Kurmanji)",
  [ARMENIAN]: "Armênio",
  [AZERBAIJANI]: "Azeri",
  [BELARUSIAN]: "Bielorrusso",
  [BOSNIAN]: "Bósnio",
  [GEORGIAN]: "Georgiano",
  [KAZAKH]: "Cazaque",
  [MONGOLIAN]: "Mongol",
  [SERBIAN]: "Sérvio",
  [TAJIK]: "Tajique",
  [UZBEK]: "Uzbeque",
  [AFRIKAANS]: "Africâner",
  [SWAHILI]: "Suaíli",
  [ALBANIAN]: "Albanês",
  [CEBUANO]: "Cebuano",
  [GUARANI]: "Guarani",
  [MARATHI]: "Marata",
  [NEPALI]: "Nepalês",
  [PASHTO]: "Pastó",
  [SINHALA]: "Cingalês",
  [CHINESE]: "Chinês",
  [ASSAMESE]: "Assamês",
  [HARYANAVI]: "Haryanvi",
  [BIHARI]: "Biharí",
  [ORIYA]: "Oriya",
  [RAJASTHANI]: "Rajasthani",
  [NORWEGIAN]: "Norueguês",
  [VIEW]: "Ver",
  [STORES]: "Lojas",
  [PLAN]: "Plano",
  [AUTOMATIC_RENOVATION]: "Renovação automática",
  [PREVIOUS_PERIOD]: "Período anterior",
  [START_DATE_AND_END_DATE_VALIDATION]:
    "A data de início não pode ser posterior à data de término",
  [LOADING_CONFIGURATION_METRICS]: "Carregando configuração de métricas",
  [ACCEPTED]: "Aceitas",
  [PENDING]: "Pendentes",
  [ARE_YOU_SURE]: "Tem certeza?",
  [ARE_YOU_SURE_TO_DISCONNECT_ACCOUNT]:
    "Tem certeza de que deseja desconectar esta conta?",
  [CHANGE]: "Alterar",
  [REPORT_REQUESTS]: "Relatório de solicitações",
  [REQUESTS_ACCEPTED]: "Aceitas",
  [REQUESTS_REJECTED]: "Rejeitadas",
  [REQUESTS_ACTIVE]: "Solicitações ativas",
  [CODE]: "Código",
  [IS_AUTOMATIC]: "É automático",
  [REDEEMED]: "Resgatados",
  [EXPIRED]: "Expirados",
  [REDEEMED_SINGULAR]: "Resgatado",
  [EXPIRED_SINGULAR]: "Expirado",
  [REJECTED]: "Rejeitadas",
  [ROLE]: "Função",
  [UNKNOWN]: "Desconhecido",
  [RIGHT]: "Direita",
  [LEFT]: "Esquerda",
  [LOGO]: "Logo",
  [LOGO_DESCRIPTION]:
    "Para obter melhores resultados, use um logo sem transparência, com fundo sólido que contraste com os elementos do logo.",
  [CANCEL_ANYTIME]: "Cancele a qualquer momento",
  [ADD_BRAND]: "Adicionar marca",
  [DATE]: "Data",
  [NAME_BUSINESS_BOT]: "Ana da {{NAME_BUSINESS}}",
  [SERVICE_FEE]: "Taxa de serviço",
  [TOTAL_PAYMENT]: "Pagamento total",
  [LAST_COLLABORATION]: "Última colaboração",
  [PERSONALIZED_INSTRUCTIONS]: "Instruções personalizadas",
  [EMPTY_REQUESTS]: "Você ainda não tem solicitações",
  [EMPTY_CAMPAIGNS]: "Você ainda não tem campanhas",
  [EMPTY_ORDERS]: "Você ainda não tem colaborações",
  [EMPTY_REDEEM_CODES]: "Você ainda não tem códigos resgatados",
  [EMPTY_USERS]: "Você ainda não criou usuários",
  [EMPTY_CONTACTS]: "Você ainda não criou contatos",
  [EMPTY_INVOICES]: "Você ainda não criou faturas",
  [EMPTY_APPLICANTS_PENDING]: "Você ainda não tem candidatos pendentes",
  [EMPTY_APPLICANTS_ACCEPTED]: "Você ainda não aceitou candidatos",
  [EMPTY_ADS_CAMPAIGNS]: "Você ainda não tem campanhas publicitárias",
  [TARGET_CAMPAIGN]: "Segmentação",
  [LOCATIONS]: "Localizações",
  [GENDERS]: "Gêneros",
  [AGES]: "Idades",
  [PLATFORMS]: "Plataformas",
  [PLATFORM]: "Plataforma",
  [PREVIOUS_PERIOD]: "Período anterior",
  [REPORTS]: "Relatórios",
  [IMPRESSIONS]: "Impressões",
  [CLICKS]: "Cliques",
  [CTR]: "CTR",
  [CPA]: "CPA",
  [CLICK]: "Cliques",
  [CPM]: "CPM",
  [CPC]: "CPC",
  [RESULTS]: "Resultados",
  [SPEND]: "Gasto",
  [PERIOD]: "Período",
  [AVERAGE]: "Média",
  [TYPE_LEAST_CHARACTERS]: "Digite pelo menos {{value}} caracteres",
  [LOADING]: "Carregando",
  [OBJECTIVE]: "Objetivo",
  [AWARENESS]: "Reconhecimento",
  [TRAFFIC]: "Tráfego",
  [INTERACTIONS]: "Interações",
  [LEADS]: "Leads",
  [DOWNLOADS]: "Instalações",
  [SALES]: "Vendas",
  [META_CAMPAIGN]: "Campanha de Meta",
  [TIKTOK_CAMPAIGN]: "Campanha de TikTok",
  [CONTENT_TO_ADVERTISE]: "Conteúdo",
  [EMPTY_TRACKING_IDS_META]: "Você não tem pixels da Meta criados",
  [EMPTY_TRACKING_IDS_LINKEDIN]: "Você não tem pixels do LinkedIn criados",
  [FINISHED]: "Finalizada",
  [TIKTOK_BUSINESS]: "TikTok Business",
  [EMPTY_TRACKING_IDS_TIKTOK]: "Você não tem pixels do TikTok criados",
  [TIKTOK_PRIVACY_LEVEL_LABEL]: "Nível de privacidade",
  [TIKTOK_ACCOUNT_LABEL]: "Conta do TikTok",
  [TIKTOK_PRIVACY_LEVEL_PUBLIC_TO_EVERYONE]: "Público para todos",
  [TIKTOK_PRIVACY_LEVEL_MUTUAL_FOLLOW_FRIENDS]:
    "Amigos que se seguem mutuamente",
  [TIKTOK_PRIVACY_LEVEL_FOLLOWER_OF_CREATOR]: "Seguidores do criador",
  [TIKTOK_PRIVACY_LEVEL_SELF_ONLY]: "Somente eu",
  [TIKTOK_DISABLE_DUET_LABEL]: "Desativar Duetos",
  [TIKTOK_DISABLE_DUET_DESCRIPTION]:
    "Se ativado, outros usuários do TikTok não poderão fazer Duetos com esta publicação",
  [TIKTOK_DISABLE_STITCH_LABEL]: "Desativar a função Unir",
  [TIKTOK_DISABLE_STITCH_DESCRIPTION]:
    "Se ativado, outros usuários do TikTok não poderão fazer Stitches com esta publicação",
  [TIKTOK_DISABLE_COMMENT_LABEL]: "Desativar comentários",
  [TIKTOK_AUTO_ADD_MUSIC_LABEL]: "Adicionar música automaticamente",
  [TIKTOK_DISABLE_COMMENT_DESCRIPTION]:
    "Se ativado, outros usuários do TikTok não poderão comentar nesta publicação",
  [TIKTOK_IS_AIGC_LABEL]: "Conteúdo gerado por IA",
  [TIKTOK_IS_AIGC_DESCRIPTION]:
    "Marque esta opção se o vídeo for conteúdo gerado por IA. O vídeo será etiquetado como gerado por IA",
  [SHORT_TIME_HAS_PASSED_SINCE_ACTIVATION_STATISTICS]:
    "Pouco tempo se passou desde que você ativou a campanha; as estatísticas podem demorar para atualizar",
  [SHOPIFY]: "Shopify",
  [WOOCOMMERCE]: "Woocommerce",
  [FOLLOWERS_ABBREVIATED]: "FLL",
  [ENGAGEMENT_ABBREVIATED]: "ER",
  [ADD_NEW_STYLE]: "Adicione novo estilo",
  [WANTS_SOCIAL_MEDIA_POST]: "Quero exposição nas redes sociais",
  [DOES_NOT_WANTS_SOCIAL_MEDIA_POST]: "Não quero exposição nas redes sociais",
  [EXPLANATION_SEND_ONE_REVISION]: "Você só poderá enviar uma revisão",
  [I_NEED_HELP]: "Preciso de ajuda",
  [REVISION_OPTION_GOOD]: "Incrível! Mas tenho uma dúvida",
  [REVISION_OPTION_REGULAR]: "Está ok, mas falta algo",
  [REVISION_OPTION_BAD]: "Isso não funciona para mim",
  [WHY_THESE_RECOMMENDED_SETTINGS]: "Por que estas configurações recomendadas?",
  [PIXEL_REQUIRED]: "Pixel obrigatório",
  [DRAFT]: "Rascunho",
  [CANVA]: "Canva",
  [CONNECTED_ACCOUNTS]: "Contas conectadas",
  [CONNECTED_ACCOUNTS_CONNECT_MORE_PLATFORMS]: "Conectar mais plataformas",
  [CONNECTED_ACCOUNTS_BUTTON_CONNECT]: "Conectar",
  [CONNECTED_ACCOUNTS_EMPTY_HINT]:
    "Você ainda não tem contas conectadas. Use o botão de adicionar para incluir uma.",
  [CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT]: "{{count}} contas",
  [CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT_SINGULAR]: "1 conta",
  [CONNECTED_ACCOUNTS_PLATFORM_META]: "Meta",
  [CONNECTED_ACCOUNTS_PLATFORM_GOOGLE]: "Google Ads",
  [CONNECTED_ACCOUNTS_PLATFORM_TIKTOK_BUSINESS]: "TikTok",
  [CONNECTED_ACCOUNTS_PLATFORM_LINKEDIN]: "LinkedIn",
  [CONNECTED_ACCOUNTS_ACCORDION_EXPAND]: "Mostrar contas conectadas",
  [SLIDE_MENU_COLLAPSE]: "Recolher menu",
  [SLIDE_MENU_EXPAND]: "Expandir menu",
  [CONNECTED_ACCOUNTS_ACCORDION_COLLAPSE]: "Ocultar contas conectadas",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TITLE]:
    "Configuração padrão de campanha",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE]: "Salvar configuração",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_SUCCESS]:
    "A configuração padrão foi salva com sucesso",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_ERROR]:
    "Não foi possível salvar a configuração padrão. Tente novamente.",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_LOADING]:
    "Carregando configuração salva...",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_AD_FORMAT_LABEL]: "Formato de anúncio",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL]: "Aplicativo",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_PROMOTION_LABEL]:
    "Promoção de aplicativo",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL]:
    "Tipo de campanha",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_FOR_APP_INSTALL_LABEL]:
    "Catálogo para instalação",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_LABEL]: "Catálogo",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DEEP_LINK_LABEL]: "Link profundo",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_TYPE_LABEL]:
    "Tipo de destino",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_URL_LABEL]:
    "URL de destino",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL]:
    "Contas e identidades",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_MERCHANT_ID_LABEL]: "Merchant Center",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL]:
    "Objetivo de Campanha",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TIKTOK_CAMPAIGN_TYPE_LABEL]:
    "Tipo de Campanha TikTok",
  [CAMPAIGN]: "Campanha",
  [ASSETS_GROUP]: "Grupo de recursos",
  [AD_GROUP]: "Grupo de anúncios",
  [AD]: "Anúncio",
  [NUMBER_ITEM]: "N° {{value}}",
  [TITLES]: "Títulos",
  [TITLES_META]: "Textos principais",
  [TITLE]: "Título",
  [LONG_HEADLINES]: "Títulos longos",
  [HEADLINES]: "Títulos",
  [DESCRIPTIONS]: "Descrições",
  [COMING_SOON]: "Em breve",
  [ENTER_CODE]: "Digite o código",
  [WE_SEND_VERIFICATION_CODE_TO_YOUR_PHONE]:
    "Enviaremos um código de verificação para seu telefone; pode levar até um minuto para chegar.",
  [MODIFY_PHONE_NUMBER]: "Modificar telefone",
  [OTP_VERIFICATION_TITLE]: "Código de verificação",
  [OTP_VERIFICATION_EMAIL_SENT]:
    "Enviamos um código de 6 dígitos para {{emailMasked}}.",
  [OTP_BACK_TO_EMAIL]: "Voltar ao e-mail",
  [META_TOGGLE_DESCRIPTION]: "Facebook, Instagram e Audience Network",
  [GOOGLE_TOGGLE_DESCRIPTION]:
    "Busca do Google. Em breve: YouTube e Rede de Display",
  [TIKTOK_TOGGLE_DESCRIPTION]: "Feed e busca do TikTok",
  [LINKEDIN_TOGGLE_DESCRIPTION]: "Feed, busca e chat do LinkedIn",
  [NOT_AVAILABLE]: "Não disponível",
  [EDIT_INSTRUCTIONS]: "Editar instruções",
  [PROMPT]: "Instruções",
  [TYPE]: "Tipo",
  [RETENTION_DAYS]: "Dias de retenção",
  [ERRORS]: "Erros",
  [DELIVERY_STATUS]: "Status de entrega",
  [OPERATION_STATUS]: "Status da operação",
  [MOST_POPULAR]: "Mais popular",
  [MANUAL_SEGMENTATION]: "Segmentação manual",
  [RE_TARGETING_SEGMENTATION]: "Audiências personalizadas",
  [IDENTITIES_TIK_TOK_EMPTY]: "Você não tem identidades do TikTok criadas",
  [ADD_NEW_IDENTITY]: "Adicionar nova identidade",
  [GENERAL_INFORMATION]: "Informações gerais",
  [CONTEXT]: "Contexto",
  [CAMPAIGN_HAS_NEVER_BEEN_ACTIVATED]: "A campanha nunca foi ativada",
  [LOADING_METRICS_FROM_PLATFORMS]: "Carregando métricas...",
  [HOW_IS_YOUR_CAMPAIGN_GOING]: "Recomendações desta semana",
  [AN_ERROR_OCCURRED_GETTING_THE_REPORT]:
    "Ocorreu um erro ao gerar o relatório. Tente novamente mais tarde.",
  [AD_ACCOUNTS]: "Contas de anúncios",
  [FACEBOOK_PAGES]: "Páginas do Facebook",
  [INSTAGRAM_ACCOUNTS]: "Contas do Instagram",
  [LAST_RECORDED_EVENT_ON]: "Último evento registrado em",
  [NEVER]: "Nunca",
  [PIXEL_HAS_NO_RECORDED_EVENTS]: "O pixel não tem eventos registrados",
  [LAST_UPDATE]: "Última atualização",
  [IN_A_FEW_MINUTES_YOUR_INVOICE_WILL_BE_AVAILABLE]:
    "Em alguns segundos, seus novos benefícios serão ativados ",
  [RETRIEVING_GENERAL_INFORMATION]:
    "Estamos recuperando as informações gerais da sua conta",
  [RETRIEVING_YOUTUBE_CHANNEL]: "Obtendo o canal do YouTube",
  [RETRIEVING_TIKTOK_PROFILE]: "Recuperando perfil do TikTok",
  [RETRIEVING_AD_ACCOUNTS]:
    "Estamos recuperando a lista de contas de anúncios.",
  [RETRIEVING_FACEBOOK_PAGES]:
    "Estamos recuperando a lista de páginas do Facebook.",
  [RETRIEVING_INSTAGRAM_ACCOUNTS]:
    "Estamos recuperando a lista de contas do Instagram",
  [ENDING_CONNECTION]: "Encerrando a conexão",
  [ESTABLISHING_CONNECTION_WITH_PLATFORM]:
    "Estabelecendo conexão com {{platform}}",
  [RETRIEVING_AUTHORIZATION_DATA]: "Recuperando dados de autorização",
  [OPENING_AUTHORIZATION_WINDOW]: "Abrindo a janela de autorização",
  [CONNECTING_CANVA_VERIFYING_AUTHORIZATION]:
    "Verificando a autorização com o Canva",
  [CONNECTING_CANVA_LINKING_ACCOUNT]: "Vinculando sua conta do Canva",
  [VERIFYING_YOUR_SESSION]: "Verificando sua sessão, aguarde",
  [GETTING_REQUIRED_INFORMATION]: "Obtendo as informações necessárias",
  [VERIFYING_PLATFORMS_INFORMATION]:
    "Verificando as informações das plataformas",
  [CREATING_CAMPAIGN]: "Criando a campanha",
  [CREATING_AD_GROUPS]: "Criando grupos de anúncios",
  [UPLOADING_CONTENTS]: "Enviando conteúdo",
  [CREATING_ADS]: "Criando anúncios",
  [SAVING_INFORMATION]: "Salvando informações",
  [INACTIVE]: "Inativo",
  [CUSTOM_EVENT]: "Evento personalizado",
  [FAST]: "Rápido",
  [EASY]: "Fácil",
  [AUTOMATED]: "Automatizado",
  [FULL_CONTROL]: "Controle total",
  [CUSTOMIZE]: "Personalizado",
  [TAILORED]: "Sob medida",
  [RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION]:
    "Com audiências personalizadas ativadas, a segmentação manual não é necessária",
  [CAMPAIGN_CREATED]: "Campanha criada",
  [CAMPAIGN_UPDATED]: "Campanha atualizada",
  [CREATIFY_VIDEO_PREVIEW_CLARIFICATION]:
    "Esta é uma prévia do vídeo. Ela pode apresentar erros de sincronização que serão corrigidos na versão final",
  [CREATIFY_VIDEO_ERROR_RENDER_CLARIFICATION]:
    "Não foi possível renderizar o vídeo devido a um erro. Entre em contato pelo chat de suporte para resolver este problema e continuar com a campanha",
  [CREATIFY_VIDEO_RENDERING_CLARIFICATION_AND_CREATE_CAMPAIGN]:
    "Estamos renderizando o conteúdo final. Quando estiver pronto, publicaremos sua campanha",
  [CREATIFY_VIDEO_RENDERING_CLARIFICATION]:
    "Estamos renderizando o conteúdo final. Quando estiver pronto, o download será feito automaticamente",
  [COPY]: "Copiar",
  [GENERATING_VIDEO_MESSAGE]: "Gerando vídeo",
  [TASK_ALERT_ESTIMATED_TIME]: "Tempo estimado: {{estimatedTime}}",
  [DO_YOU_HAVE_DISCOUNT_CODE]: "Você tem um código de desconto?",
  [DISCOUNT_VALUE]: "Valor do desconto",
  [NORMAL_PRICE]: "Preço normal",
  [CONTENT_NUMERATION]: "Conteúdo {{value}}",
  [WE_CANT_GET_AVATARS]:
    "Não foi possível obter os avatares. Tente novamente mais tarde",
  [CONTENT_GENERATOR]: "Gerador de conteúdo",
  [SELECT_BACKGROUND_CONTENT]: "Conteúdo de fundo",
  [SELECT_BACKGROUND_CONTENT_CLARIFICATION]:
    "Você deve selecionar ao menos 3 conteúdos",
  [CUSTOM]: "Personalizado",
  [GETTING_CREATIFY_VIDEO_DATA]: "Obtendo dados do vídeo",
  [CREDITS]: "Créditos",
  [COINS]: "Moedas",
  [CREDITS_VALUE]: "{{value,number}} Créditos",
  [COST_OF_ACTION]: "Custo da ação",
  [COST_OF_CAMPAIGN]: "Custo da campanha",
  [COST_OF_RESIZE]: "Custo de redimensionamento",
  [CURRENT]: "Atual",
  [CURRENT_BALANCE]: "Saldo atual",
  [BALANCE_AFTER]: "Saldo após a ação",
  [COINS_VALUE]: "{{value,number}} Moedas",
  [PER_MONTH]: "Por mês",
  [ACTION_CONFIRM_TEXT]:
    "Você vai gastar {{cost,number}} {{type}} ao realizar esta ação",
  [CURRENT_USAGE_TYPE]: "{{type}} atuais",
  [YOUR_TRIAL_CREDITS_END]: "Seus créditos de teste vencem em {{date,short}}",
  [YOUR_TRIAL_COINS_END]: "Suas moedas de teste vencem em {{date,short}}",
  [YOUR_TRIAL_END]: "Seu período de teste terminou",
  [CREATE_DEACTIVATED]: "Criá-la desativada",
  [CREATE_ACTIVATED]: "Criá-la ativada",
  [EMPTY_TRACKING_IDS_GOOGLE]: "Você não tem tags do Google criadas",
  [REST_CAMPAIGNS]: "Você ainda tem {{value,number}} campanhas para criar",
  [REST_CREATIVES]: "Você ainda tem {{value,number}} criativos para gerar",
  [REST_CREATIVE_SINGULAR]: "Você tem {{value,number}} criativo para gerar",
  [REST_VIDEO_SINGULAR]: "Você tem {{value,number}} vídeo para gerar",
  [REST_CREDITS]: "Você ainda tem {{value,number}} créditos",
  [CREATIVES_REMAINING_SHORT]: "Você ainda tem {{value,number}} criativos",
  [REST_VIDEOS]: "Você ainda tem {{value,number}} vídeos para gerar",
  [VIDEOS_REMAINING_SHORT]: "Você ainda tem {{value,number}} vídeos",
  [CREATIVES_REMAINING_SHORT_SINGULAR]: "Você tem {{value,number}} criativo",
  [SUGGESTED_CREATIVES_COUNT]:
    "Número de criativos sugeridos: {{count,number}}",
  [SUGGESTED_CREATIVES_PROGRESS]:
    "{{current,number}}/{{total,number}} sugeridos",
  [VIDEOS_REMAINING_SHORT_SINGULAR]: "Você tem {{value,number}} vídeo",
  [CREDITS_EXPLANATION]: `Com o seu plano você pode gerar campanhas publicitárias, que incluem:<br/>\n  • Gestão multiplataforma.<br/>\n  • Segmentação de audiência por IA.<br/>\n  • Seletor de localizações por IA.<br/>\n  • Textos e copys com IA.<br/>\n  • Relatórios e análises avançadas com IA.`,
  [COINS_EXPLANATION]: `As moedas são usadas principalmente para gerar conteúdo audiovisual, por exemplo:<br/>\n  • Renderizar ou baixar um vídeo gerado por IA`,
  [META_DESTINATION_TYPE_INSTAGRAM_PROFILE_CLARIFICATION]:
    "Os usuários serão levados ao perfil do Instagram selecionado anteriormente",
  [ADVERTISER]: "Administrador",
  [MARKETER]: "Media Buyer",
  [VIEWER]: "Visualizador",
  [DESIGNER]: "Desenhista",
  [DELETED]: "Excluído",
  [PASSWORD_CLARIFICATION_IN_EDIT_USER]:
    "Deixe em branco se não quiser alterá-la",
  [CREATED_AT]: "Criada em",
  [CREATED_BY]: "Criada por",
  [MONTHLY]: "Mensal",
  [QUARTERLY]: "Trimestral",
  [SEMIYEARLY]: "Semestral",
  [YEARLY]: "Anual",
  [CPA_CLARIFICATION]:
    "O CPA (custo por ação) é o custo que você pagou por cada ação que um usuário realiza de acordo com o objetivo da sua campanha. A seguir, são mostradas as ações pelas quais você está pagando nesta campanha.",
  [MAIN_STATISTIC_CPM_CLARIFICATION]:
    "(CPM) Você paga por cada 1.000 impressões do seu anúncio, para aumentar o reconhecimento da sua marca.",
  [MAIN_STATISTIC_CLICK_CLARIFICATION]:
    "(Clique) Você paga por cada clique que o seu anúncio recebe, para aumentar o tráfego do seu site.",
  [MAIN_STATISTIC_POST_ENGAGEMENT_CLARIFICATION]:
    "(Interação na publicação) Você paga por cada interação que a publicação recebe (curtidas, comentários, compartilhamentos, salvamentos etc.), para aumentar a interação do seu conteúdo.",
  [MAIN_STATISTIC_LEAD_CLARIFICATION]:
    "(Lead) Você paga por cada cliente potencial que se cadastra no seu site.",
  [MAIN_STATISTIC_PURCHASE_CLARIFICATION]:
    "(Compra) Você paga por cada compra realizada no seu site.",
  [MAIN_STATISTIC_AD_RECALL_CLARIFICATION]:
    "(Lembrança do anúncio) Você paga por cada pessoa que lembra de ter visto o seu anúncio, para aumentar o reconhecimento da sua marca.",
  [MAIN_STATISTIC_VIDEO_VIEW_CLARIFICATION]:
    "(Visualização de vídeo) Você paga por cada reprodução de pelo menos 6 segundos do seu vídeo publicitário.",
  [MAIN_STATISTICS_INSTAGRAM_PROFILE_CLARIFICATION]:
    "(Visita ao perfil do Instagram) Você paga por cada visita ao perfil do Instagram selecionado anteriormente.",
  [MAIN_STATISTIC_VALUE_CPM_CLARIFICATION]:
    "{{value,number}} impressões. Você paga por cada 1.000 impressões do seu anúncio, para aumentar o reconhecimento da sua marca.",
  [MAIN_STATISTIC_VALUE_CLICK_CLARIFICATION]:
    "{{value,number}} cliques. Você paga por cada clique que o seu anúncio recebe, para aumentar o tráfego do seu site.",
  [MAIN_STATISTIC_VALUE_POST_ENGAGEMENT_CLARIFICATION]:
    "{{value,number}} interações. Você paga por cada interação que a publicação recebe (curtidas, comentários, compartilhamentos, salvamentos etc.), para aumentar a interação do seu conteúdo.",
  [MAIN_STATISTIC_VALUE_LEAD_CLARIFICATION]:
    "{{value,number}} leads. Você paga por cada cliente potencial que se cadastra no seu site.",
  [MAIN_STATISTIC_VALUE_PURCHASE_CLARIFICATION]:
    "{{value,number}} compras. Você paga por cada compra realizada no seu site.",
  [MAIN_STATISTIC_VALUE_AD_RECALL_CLARIFICATION]:
    "{{value,number}} lembranças do anúncio. Você paga por cada pessoa que lembra de ter visto o seu anúncio, para aumentar o reconhecimento da sua marca.",
  [MAIN_STATISTIC_VALUE_VIDEO_VIEW_CLARIFICATION]:
    "{{value,number}} visualizações de vídeo. Você paga por cada reprodução de pelo menos 6 segundos do seu vídeo publicitário.",
  [MAIN_STATISTIC_VALUE_INSTAGRAM_PROFILE_CLARIFICATION]:
    "{{value,number}} visitas ao perfil do Instagram. Você paga por cada visita ao perfil do Instagram selecionado anteriormente.",
  [ANALYZING_CAMPAIGN_STATISTICS]: "Analisando as estatísticas da campanha",
  [COMPARING_RESULTS_OBTAINED]: "Comparando resultados obtidos",
  [GENERATING_OPTIMIZATIONS]: "Gerando otimizações",
  [CAMPAIGN_OPTIMIZED_NAME]: "Otimizada",
  [CAMPAIGN_OPTIMIZED]: "Campanha otimizada",
  [CAMPAIGN_OPTIMIZED_GENERATED]: "Campanha otimizada gerada",
  [APPLYING_OPTIMIZATIONS]: "Aplicando otimizações",
  [IMPRESSIONS_BY_PLATFORM]: "Impressões por plataforma",
  [CLICKS_BY_PLATFORM]: "Cliques por plataforma",
  [MAIN_ACTIONS_BY_PLATFORM]: "Resultados por plataforma",
  [CONCLUSION]: "Conclusão",
  [RECOMMENDATIONS]: "Recomendações",
  [DAY_COUNT]: "Dia {{value,number}}",
  [ADS_CAMPAIGN_REPORT_BREAKDOWN_DAILY]: "Diário",
  [WEEK_COUNT]: "Semana {{value,number}}",
  [EMPTY_STATISTICS_FOR_DETAILED_REPORT]:
    "Não há dados e estatísticas suficientes para gerar um relatório",
  [LOCATIONS_TIK_TOK_EMPTY]:
    "Não foram encontradas localizações relevantes. Elas podem não estar disponíveis no TikTok ou especificamente para o país da sua conta. Mais informações <a href='https://ads.tiktok.com/help/article/placements-available-locations?aadvid=7375164243290914833' target='_blank' style='text-decoration: underline'>aqui</a>",
  [PRODUCT_OR_SERVICE_CONTEXT]: "Produto ou serviço a promover",
  [TARGET_AUDIENCE_CONTEXT]: "Público-alvo que você deseja alcançar",
  [GREETING]: "Saudação",
  [FIRST_USER_MESSAGE]: "Primeira mensagem do usuário",
  [IS_CAROUSEL]: "É carrossel",
  [CARD]: "Cartão",
  [FORM]: "Formulário",
  [FORMS]: "Formulários",
  [ANSWER]: "Resposta",
  [ANSWERS]: "Respostas",
  [GOOGLE_PHRASE_KEYWORD]: "Correspondência de frase",
  [GOOGLE_PHRASE_KEYWORD_EXPLANATION]:
    'Exibirá anúncios quando a busca de um usuário incluir pelo menos o significado da sua palavra-chave. O formato deste tipo é a palavra-chave entre aspas ("palavra-chave")',
  [GOOGLE_EXACT_KEYWORD]: "Correspondência exata",
  [GOOGLE_EXACT_KEYWORD_EXPLANATION]:
    "Exibirá anúncios quando a busca de um usuário incluir a palavra-chave exata ou uma variante próxima que inclua o significado ou a intenção. O formato deste tipo é a palavra-chave entre colchetes ([palavra-chave])",
  [GOOGLE_BROAD_KEYWORD]: "Correspondência ampla",
  [GOOGLE_BROAD_KEYWORD_EXPLANATION]:
    "Exibirá anúncios quando a busca de um usuário incluir sinônimos, variantes e intenções semelhantes à palavra-chave. O formato deste tipo é a palavra-chave sem mais nada (palavra-chave)",
  [GOOGLE_KEYWORDS_EXPLANATION]: `As palavras-chave são termos ou frases usados para exibir anúncios às pessoas que buscam algo online. Existem três tipos de palavras-chave: <br/><br/>\n  <strong>Correspondência exata:</strong> Exibirá anúncios quando a busca de um usuário incluir a palavra-chave exata ou uma variante próxima que inclua o significado ou a intenção. O formato deste tipo é a palavra-chave entre colchetes ([palavra-chave])<br/><br/>\n  <strong>Correspondência de frase:</strong> Exibirá anúncios quando a busca de um usuário incluir pelo menos o significado da sua palavra-chave. O formato deste tipo é a palavra-chave entre aspas ("palavra-chave")<br/><br/>\n  <strong>Correspondência ampla:</strong> Exibirá anúncios quando a busca de um usuário incluir sinônimos, variantes e intenções semelhantes à palavra-chave. O formato deste tipo é a palavra-chave sem mais nada (palavra-chave)`,
  [GOOGLE_KEYWORDS_NEGATIVE_EXPLANATION]: `As palavras-chave negativas são termos ou frases usados na publicidade digital para evitar que os anúncios apareçam em buscas irrelevantes. Ao adicionar palavras-chave negativas, impede-se que os anúncios apareçam quando os usuários buscam esses termos específicos, o que ajuda a melhorar a relevância dos anúncios, reduzir custos e aumentar a taxa de conversão. Existem três tipos de palavras-chave: <br/><br/>\n  <strong>Correspondência exata:</strong> Exibirá anúncios quando a busca de um usuário incluir a palavra-chave exata ou uma variante próxima que inclua o significado ou a intenção. O formato deste tipo é a palavra-chave entre colchetes ([palavra-chave])<br/><br/>\n  <strong>Correspondência de frase:</strong> Exibirá anúncios quando a busca de um usuário incluir pelo menos o significado da sua palavra-chave. O formato deste tipo é a palavra-chave entre aspas ("palavra-chave")<br/><br/>\n  <strong>Correspondência ampla:</strong> Exibirá anúncios quando a busca de um usuário incluir sinônimos, variantes e intenções semelhantes à palavra-chave. O formato deste tipo é a palavra-chave sem mais nada (palavra-chave)`,
  [GOOGLE_SEARCH_AD_GROUP_TYPE_LABEL]: "Tipo de Grupo de Anúncios",
  [GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD]: "Padrão",
  [GOOGLE_SEARCH_AD_GROUP_TYPE_DSA]: "Anúncios dinâmicos de pesquisa",
  [GOOGLE_WEBPAGE_CRITERIA_TITLE]: "Critérios de página da web",
  [GOOGLE_WEBPAGE_CRITERIA_EXPLANATION]:
    "Define quais páginas do seu site indexado podem exibir anúncios neste grupo (por exemplo, URL igual a ou URL contém). Adicione pelo menos um critério.",
  [GOOGLE_WEBPAGE_CRITERION_OPERATOR_LABEL]: "Regra",
  [GOOGLE_WEBPAGE_CRITERION_VALUE_LABEL]: "URL ou texto",
  [GOOGLE_WEBPAGE_CRITERION_URL_EQUALS]: "URL igual a",
  [GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS]: "URL contém",
  [FIELD_WEBPAGE_CRITERIA_REQUIRED]:
    "Adicione pelo menos um critério de página para grupos de anúncios DSA.",
  [FIELD_WEBPAGE_CRITERIA_REPEATED]:
    "Critérios de página duplicados: {{value}}",
  [GOOGLE_SEARCH_AD_GROUP_DSA_NO_KEYWORDS_STATS]:
    "Os grupos de anúncios dinâmicos de pesquisa usam critérios de página em vez de palavras-chave positivas.",
  [GOOGLE_DSA_SETTINGS_TITLE]: "Configuração de anúncios dinâmicos de pesquisa",
  [GOOGLE_DSA_SETTINGS_EXPLANATION]:
    "Obrigatório quando algum grupo de anúncios usa anúncios dinâmicos de pesquisa. O Google usa este domínio para gerar anúncios automaticamente.",
  [GOOGLE_DSA_DOMAIN_LABEL]: "Domínio",
  [GOOGLE_DSA_LANGUAGE_LABEL]: "Idioma",
  [GOOGLE_WEBPAGES_NOT_ADDED]: "Nenhum critério de página adicionado",
  [GOOGLE_WEBPAGE_ADD_TITLE]: "Adicionar URL",
  [GOOGLE_WEBPAGE_EDIT_TITLE]: "Editar URL",
  [GOOGLE_WEBPAGE_URL_LABEL]: "URL",
  [COLUMN_NAME_URL]: "URL",
  [ALERT_DELETE_WEBPAGE_TITLE]: "Excluir página web?",
  [ALERT_DELETE_WEBPAGE_DESCRIPTION]:
    "Tem certeza de que quer excluir este critério de página?",
  [ALERT_DELETE_WEBPAGES_TITLE]: "Excluir páginas web?",
  [ALERT_DELETE_WEBPAGES_DESCRIPTION]:
    "Tem certeza de que quer excluir {{value}} critérios de página?",
  [GOOGLE_NETWORK_SETTING_GOOGLE_SEARCH]: "Pesquisa do Google",
  [GOOGLE_NETWORK_SETTING_SEARCH_NETWORK]: "Rede de pesquisa do Google",
  [GOOGLE_NETWORK_SETTING_CONTENT_NETWORK]: "Rede de Display do Google",
  [GOOGLE_NETWORK_SETTING_PARTNER_SEARCH_NETWORK]:
    "Rede de pesquisa de parceiros do Google",
  [TOP_KEYWORDS]: "Principais palavras-chave",
  [BETA]: "Beta",
  [PROCESSING_MEDIA_TO_USE]: "Processando o conteúdo para usá-lo",
  [SAVING_MEDIA]: "Salvando o conteúdo",
  [TUTORIAL]: "Tutorial",
  [SELECT_RANGE_DATE]: "Selecione um intervalo de datas",
  [TO]: "a",
  [MONTH_COUNT]: "Mês {{value,number}}",
  [WRITE_INSTRUCTIONS_TO_CREATE_YOUR_CAMPAIGN]:
    "Descreva como você deseja direcionar a campanha. Exemplo: Esta campanha busca destacar o produto X como uma solução prática para equipes que precisam economizar tempo e reduzir tarefas manuais.",
  [TITLE_CAMPAIGN_INSTRUCTIONS]: "Tema ou instruções da campanha",
  [DOCUMENTS_ATTACHMENT_LABEL]: "Adicionar arquivos",
  [FILE_UPLOADED]: "ENVIADO",
  [ADD_PLATFORMS]: "Adicionar plataformas",
  [ERROR_GENERATING_CAMPAIGN]: "Ocorreu um erro ao gerar a campanha",
  [THIS_ITEM_HAS_ERRORS]: "Esta seção tem erros",
  [INDIVIDUAL]: "Individual",
  [CAROUSEL]: "Carrossel",
  [RADIUS]: "Raio",
  [AROUND]: "Ao redor",
  [ADVANTAGE_ENHANCES_ACTIVE_COUNT]: "{{active}}/{{total}} melhorias ativas",
  [WE_ARE_SYNCHRONIZING_INFORMATION_WITH_PLATFORMS]: "Sincronizando dados",
  [OPTIONAL]: "Opcional",
  [KEYWORDS_NOT_ADDED]: "Nenhuma palavra-chave adicionada",
  [KEYWORDS_NEGATIVE_NOT_ADDED]: "Nenhuma palavra-chave negativa adicionada",
  [ENTER_ONE_KEYWORD_PER_LINE]: "Digite uma palavra-chave por linha",
  [KEYWORDS]: "Palavras-chave",
  [KEYWORDS_NEGATIVE]: "Palavras-chave negativas",
  [TOTAL_IMPRESSIONS]: "Impressões totais",
  [TOTAL_CLICKS]: "Cliques totais",
  [TOTAL_CLICK]: "Clique total",
  [TOTAL_RESULTS]: "Resultados totais",
  [TOTAL_SPEND]: "Gasto total",
  [AVERAGE_CTR]: "CTR médio",
  [TOTAL_ROAS_GOOGLE]: "Google ROAS",
  [TOTAL_ROAS_TIK_TOK]: "TikTok ROAS",
  [TOTAL_ROAS_META]: "Meta ROAS",
  [CUSTOM_AUDIENCES]: "Audiências personalizadas",
  [CREATIVE]: "Criativo",
  [SELECTED]: "Selecionadas",
  [ROAS]: "ROAS",
  [FORECAST]: "Previsão",
  [ACTION]: "Ação",
  [DELETE]: "Excluir",
  [INSIGHTS]: "Insights",
  [INSIGHT]: "Insight",
  [CHANGE_CONTENT_FOR_OPTIMIZATION_AD_INSIGHT]:
    "Aqui você pode alterar o criativo para aplicar o insight",
  [PRESS_ENTER_TO_ADD_OPTION]: "Pressione Enter para adicionar",
  [GOOGLE_SEARCH]: "Pesquisa do Google",
  [GOOGLE_P_MAX]: "Google PMax",
  [GOOGLE_APP]: "Google App Install",
  [YOUTUBE_VIDEO_LINK]: "URL do vídeo do YouTube",
  [DO_NOT_UPLOAD_VIDEO_ON_YOUTUBE_HELPER_TEXT]:
    "Você não tem o vídeo enviado no YouTube? Envie agora",
  [YOUTUBE_VIDEO_SOURCE_YOUTUBE]: "YouTube",
  [YOUTUBE_VIDEO_SOURCE_GALLERY]: "Galeria",
  [YOUTUBE_VIDEO_SOURCE_URL]: "URL",
  [MODAL_GALLERY_YOUTUBE_TITLE]: "Selecionar vídeos do YouTube",
  [MODAL_GALLERY_YOUTUBE_EMPTY]:
    "Não foram encontrados vídeos públicos neste canal",
  [BUTTON_SELECT_FROM_YOUTUBE]: "Selecionar de YouTube",
  [BUTTON_PUBLISH_VIDEO_ON_YOUTUBE]: "Publicar vídeo no YouTube",
  [MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE]: "Enviar vídeo para o YouTube",
  [MODAL_UPLOAD_YOUTUBE_VIDEO_DURATION_INVALID]:
    "O vídeo deve durar entre {{min}} e {{max}} segundos. Selecione outro vídeo.",
  [REQUIRED_IMAGES_GOOGLE_ASSETS_GROUP_HELPER_TEXT]: `Pelo menos uma imagem quadrada (medidas recomendadas 1200px x 1200px)<br/>\nPelo menos uma imagem horizontal (medidas recomendadas 1200px x 628px)`,
  [REQUIRED_IMAGES_GOOGLE_SQUARE_IMAGE]:
    "<b>Pelo menos uma imagem quadrada</b> (medidas recomendadas 1200px x 1200px)",
  [REQUIRED_IMAGES_GOOGLE_HORIZONTAL_IMAGE]:
    "<b>Pelo menos uma imagem horizontal</b> (medidas recomendadas 1200px x 628px)",
  [REQUIRED_VIDEOS_GOOGLE_ASSETS_GROUP_HELPER_TEXT]: `A duração do vídeo deve ser de no mínimo 10 segundos e no máximo 60 segundos.`,
  [CAMPAIGNS_NOT_FOUND]: "Nenhuma campanha encontrada",
  [CAMPAIGN_SELECTED]: "Campanha selecionada",
  [ALREADY_IMPORTED]: "Já existe",
  [CREATE_A_CAMPAIGN]: "Criar uma Campanha",
  [CREATE_A_CAMPAIGN_FOR_BRAND_NAME]: "Criar uma Campanha para {{value}}",
  [COPY_VALUE_IN_OTHER_ADS]: "Copiar valor para outros anúncios",
  [COPY_VALUES_IN_OTHER_ADS]: "Copiar valores para outros anúncios",
  [COPY_VALUE_IN_OTHER_ADGROUPS]: "Copiar valor em outros grupos",
  [COPY_VALUES_IN_OTHER_ADGROUPS]: "Copiar valores em outros grupos",
  [GETTING_METRICS]: "Obtendo métricas",
  [GENERATING_REPORT]: "Gerando relatório",
  [EXPORT_COPIES_TO_GOOGLE_DRIVE]: "Exportar textos para o Google Drive",
  [COPIES_OF_AD]: "Textos de anúncio",
  [ALL_COPIES_OF_PLATFORM]: "Todos os textos de {{platform}}",
  [CONFIGURED_SITE_LINKS]: "{{value,number}} links de site configurados",
  [FIRST_USER_MESSAGE_BRAND_SETUP]:
    "Você configurou a sua marca corretamente. Agora você pode criar conteúdo para a sua marca e lançar campanhas publicitárias",
  [DATA_TYPE_CONTACT_INFORMATION_OPTION]:
    "E-mails, telefones e/ou endereços de e-mail",
  [DATA_TYPE_CRM_ID_OPTION]: "IDs de usuário",
  [ALL_CUSTOMERS]: "Todos os clientes",
  [PURCHASERS]: "Compradores",
  [HIGH_VALUE_CUSTOMERS]: "Clientes de alto valor",
  [DISENGAGED_CUSTOMERS]: "Clientes inativos",
  [QUALIFIED_LEADS]: "Leads qualificados",
  [CONVERTED_LEADS]: "Leads convertidos",
  [PAID_SUBSCRIBERS]: "Assinantes pagantes",
  [LOYALTY_SIGN_UPS]: "Cadastros de fidelidade",
  [CART_ABANDONERS]: "Carrinhos abandonados",
  [NO_HEADERS_TABLE_VALID_NOT_MODIFY_HEADERS_GOOGLE_CUSTOM_AUDIENCE]:
    "Não foram encontrados cabeçalhos válidos no arquivo enviado. Não modifique os cabeçalhos do modelo",
  [WITH_OUT_PLAN]: "Sem plano",
  [CONFIRMATION_USAGE_TEXT]: "Tem certeza de que quer realizar esta ação?",
  [SQUARE_FORMAT]: "Formato quadrado",
  [VERTICAL_FORMAT]: "Formato vertical",
  [HORIZONTAL_FORMAT]: "Formato horizontal",
  [RESIZE_TO_SQUARE]: "Redimensionar para quadrado",
  [RESIZE_TO_VERTICAL]: "Redimensionar para vertical",
  [RESIZE_TO_HORIZONTAL]: "Redimensionar para horizontal",
  [RESIZE_TO_FEED]: "Redimensionar para 4:5 (Instagram)",
  [RESIZE_CUSTOM]: "Redimensionar personalizado",
  [MODAL_RESIZE_CUSTOM_TITLE]: "Redimensionar Imagem",
  [MODAL_RESIZE_CUSTOM_DESCRIPTION]:
    "Indique a largura e a altura em pixels para redimensionar a imagem.",
  [MODAL_RESIZE_CUSTOM_DEFAULT_SIZE_LABEL]: "Tamanho predefinido",
  [ERROR_RESIZE_DIMENSION_INVALID]: "Digite um valor válido maior que 0",
  [ERROR_RESIZE_DIMENSION_MAX_EDGE]: "Máximo de {{max, number}} px por lado",
  [ERROR_RESIZE_DIMENSION_NOT_MULTIPLE_PREFIX]:
    "Deve ser múltiplo de 16. Sugerido:",
  [ERROR_RESIZE_DIMENSION_OR]: "ou",
  [ERROR_RESIZE_TOTAL_TOO_SMALL]:
    "{{total, number}} px² — muito pequeno. Mínimo de {{min, number}} px² no total.",
  [ERROR_RESIZE_TOTAL_TOO_LARGE]:
    "{{total, number}} px² — muito grande. Máximo de {{max, number}} px² no total.",
  [ERROR_RESIZE_ASPECT_RATIO_EXCEEDED_PREFIX]:
    "A proporção deve ser 3:1 ou menor.",
  [ERROR_RESIZE_ASPECT_RATIO_CHOOSE_OPTION]:
    "Escolha uma das seguintes opções:",
  [ERROR_RESIZE_ASPECT_RATIO_ADJUST_WIDTH_PREFIX]: "Ajustar a largura para",
  [ERROR_RESIZE_ASPECT_RATIO_KEEP_HEIGHT_SUFFIX]: "(manter a altura)",
  [ERROR_RESIZE_ASPECT_RATIO_ADJUST_HEIGHT_PREFIX]: "Ajustar a altura para",
  [ERROR_RESIZE_ASPECT_RATIO_KEEP_WIDTH_SUFFIX]: "(manter a largura)",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID]:
    "A largura e a altura devem ser números positivos.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16]:
    "A largura deve ser múltiplo de 16.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16]:
    "A altura deve ser múltiplo de 16.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED]:
    "O tamanho personalizado ultrapassa o máximo de {{max, number}} px por lado.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED]:
    "A proporção do tamanho personalizado deve ser 3:1 ou menor.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS]:
    "O tamanho personalizado é muito pequeno. Mínimo de {{min, number}} px² no total.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS]:
    "O tamanho personalizado é muito grande. Máximo de {{max, number}} px² no total.",
  [BUTTON_RESIZE_IMAGE]: "Redimensionar",
  [RESIZE_MENU_LABEL]: "Redimensionar",
  [RESIZING_IMAGES_BATCH_MESSAGE]: "Redimensionando imagens",
  [MULTI_FORMAT_RESIZE_FORMATS_COUNT]: "{{count}} formatos",
  [MULTI_FORMAT_RESIZE_CREDITS_COUNT]: "{{count}} créditos",
  [MULTI_FORMAT_RESIZE_ONE_FORMAT]: "1 formato",
  [MULTI_FORMAT_RESIZE_ONE_CREDIT]: "1 crédito",
  [MODAL_BATCH_IMAGE_EDIT_TITLE]: "Edite as suas imagens",
  [MODAL_BATCH_IMAGE_EDIT_VERSION_LABEL]: "Versão {{version, number}}",
  [MODAL_BATCH_IMAGE_EDIT_PROMPT_PLACEHOLDER]:
    "Escreva a instrução para todas...",
  [MODAL_BATCH_IMAGE_EDIT_GENERATE]: "Gerar",
  [MODAL_BATCH_IMAGE_EDIT_APPLY]: "Aplicar",
  [MODAL_BATCH_IMAGE_EDIT_STATUS_PENDING]: "Pendente",
  [MODAL_BATCH_IMAGE_EDIT_STATUS_SUCCESS]: "Pronto",
  [MODAL_BATCH_IMAGE_EDIT_STATUS_ERROR]: "Erro",
  [MODAL_BATCH_IMAGE_EDIT_RETRY]: "Tentar novamente",
  [MODAL_BATCH_IMAGE_EDIT_FAILED_BADGE]: "Falhou",
  [MODAL_BATCH_IMAGE_EDIT_EXPAND]: "Expandir",
  [MODAL_BATCH_IMAGE_EDIT_BACK_TO_GRID]: "Voltar ao grid",
  [MODAL_BATCH_IMAGE_EDIT_FOOTER_ACTION]: "Editar com IA",
  [MODAL_BATCH_IMAGE_EDIT_IMAGE_ALT]: "Criativo em edição em lote",
  [MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_TITLE]: "Como quer guardar estas imagens?",
  [MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION]:
    "Você pode substituir as imagens originais ou criar novas versões com as suas alterações.",
  [MODAL_BATCH_IMAGE_EDIT_SAVE_AS_NEW_BUTTON]: "Salvar como Novas",
  [MODAL_BATCH_IMAGE_EDIT_REPLACE_BUTTON]: "Substituir",
  [EDIT_WITH_CANVA]: "Editar com Canva",
  [EDIT_WITH_IA]: "Editar",
  [ANIMATE_IMAGE_WITH_AI]: "Animar imagem com IA",
  [ANIMATE]: "Animar",
  [ANIMATE_IMAGE_CONFIRMATION_TITLE]: "Informação",
  [ANIMATE_IMAGE_CONFIRMATION_DESCRIPTION]:
    "Serão gastos 15 créditos para realizar esta ação. Deseja continuar?",
  [MODAL_ANIMATE_IMAGE_PREVIEW_TITLE]: "Animar imagem com IA",
  [MODAL_ANIMATE_IMAGE_PROMPT_LABEL]: "Instruções de animação (opcional)",
  [MODAL_ANIMATE_IMAGE_PROMPT_PLACEHOLDER]:
    "ex. mova suavemente os produtos, adicione uma ondulação suave nas cores de fundo...",
  [MODAL_ANIMATE_IMAGE_PROMPT_HELPER]:
    "Deixe vazio para uma animação natural padrão.",
  [MODAL_ANIMATE_IMAGE_PROMPT_MAX_LENGTH]:
    "Máximo de {{max}} caracteres ({{current}}/{{max}})",
  [ANIMATE_IMAGE_OUTRO_LABEL]: "Vídeo de outro (opcional)",
  [ANIMATE_IMAGE_OUTRO_HELPER]:
    "Ele é adicionado ao final de cada vídeo gerado.",
  [ANIMATE_IMAGE_OUTRO_NONE]: "Sem vídeo de outro.",
  [ANIMATE_IMAGE_SAVE_OUTRO]: "Salvar vídeo de outro",
  [ANIMATE_IMAGE_SAVE_OUTRO_TITLE]: "Salvar vídeo de outro",
  [ANIMATE_IMAGE_SAVE_OUTRO_SUCCESS]: "Vídeo de outro salvo",
  [ANIMATE_IMAGE_SAVE_OUTRO_ERROR]: "Não foi possível salvar o vídeo de outro.",
  [ANIMATE_IMAGE_OUTRO_FILE]: "Selecionar vídeo",
  [ANIMATE_IMAGE_OUTRO_FILE_HINT]:
    "MP4, MOV ou WEBM. Máximo de {{seconds}} segundos e {{size}} MB.",
  [ANIMATE_IMAGE_IMPORT_OUTRO]: "Vídeos de outro",
  [ANIMATE_IMAGE_IMPORT_OUTRO_TITLE]: "Vídeos de outro",
  [ANIMATE_IMAGE_IMPORT_OUTRO_EMPTY]: "Não há vídeos de outro salvos.",
  [ANIMATE_IMAGE_IMPORT_OUTRO_ERROR]:
    "Não foi possível carregar os vídeos de outro.",
  [ANIMATE_IMAGE_DELETE_OUTRO]: "Excluir vídeo de outro",
  [ANIMATE_IMAGE_DELETE_OUTRO_ERROR]:
    "Não foi possível excluir o vídeo de outro.",
  [ANIMATE_IMAGE_OUTRO_CLEAR]: "Remover outro",
  [ANIMATE_IMAGE_OUTRO_TOO_LARGE]:
    "O vídeo excede o tamanho máximo de {{size}} MB.",
  [ANIMATE_IMAGE_OUTRO_TOO_LONG]: "O vídeo excede {{seconds}} segundos.",
  [ANIMATE_IMAGE_OUTRO_INVALID_TYPE]:
    "O arquivo deve ser um vídeo MP4, MOV ou WEBM.",
  [ANIMATE_IMAGE_USE_SELECTED]: "Usar",
  [SELECT_CONTENT_CONFIRMATION_TEXT]: "Deseja selecionar este conteúdo?",
  [FORMAT_OPTIONS_TOOLTIP]: "Opções de formato",
  [CHANGES]: "Alterações",
  [EMPTY_CHANGES]: "Não há alterações para exibir",
  [AD_GROUPS]: "Grupos de anúncios",
  [ADS]: "Anúncios",
  [ASSETS_GROUPS]: "Grupos de ativos",
  [ADDED]: "Adicionado",
  [REMOVED]: "Removido",
  [IT_WAS_CREATED]: "Foi criado",
  [HISTORICAL_CHANGES]: "Alterações históricas",
  [LOG_GROUP_AUDIENCE_NETWORK]: "Audiência Network",
  [LOG_GROUP_FEEDS]: "Feeds",
  [LOG_GROUP_REELS_STORIES]: "Reels/Histórias",
  [STATUS_DEACTIVATED]: "Desativado",
  [STATUS_ACTIVE]: "Ativo",
  [STATUS_FINISHED]: "Concluído",
  [N_NUMBER_SELECTED]: "{{value,number}} Selecionedos",
  [FILTER_BY_STATUS]: "Filtrar por situação",
  [SELECT_CATALOG_IN_CAMPAIGN_LEVEL]:
    "Primeiro selecione um catálogo na configuração",
  [INTRO_CARD]: "Cartão de introdução",
  [CATALOG_CARD]: "Cartão de catálogo",
  [PROFILE_CARD]: "Cartão de perfil",
  [SINGLE_IMAGE]: "Imagem única",
  [SLIDES_SHOW]: "Slideshow",
  [MODIFY_CATALOG_LABELS]: "Modificar etiquetas do catálogo",
  [MODIFY_PRODUCT_TAGS]: "Modificar etiquetas de produto",
  [SOLID]: "Sólido",
  [TRANSPARENT]: "Transparente",
  [AUTOMATIC_LABELS]: "Rótulos automáticos",
  [MANUAL_LABEL]: "Etiqueta manual",
  [RECTANGLE]: "Retângulo",
  [PILL]: "Pílula",
  [CIRCLE]: "Círculo",
  [TRIANGLE]: "Triângulo",
  [TOP_LEFT]: "Topo esquerdo",
  [TOP_RIGHT]: "Topo direito",
  [BOTTOM_LEFT]: "Inferior esquerdo",
  [BOTTOM_RIGHT]: "Inferior direito",
  [AUTOMATICALLY_TAG_PRODUCTS]: "Mostrar tags de produtos",
  [INSTANT_EXPERIENCE]: "Experiência instantânea",
  [FILTER_BY_NAME]: "Filtrar por nome",
  [ALL_PRODUCTS]: "Todos os produtos",
  [USE_A_SELECTION_OF_PRODUCTS]: "Use uma seleção de produtos",
  [SELECT_PRODUCTS_BY]: "Selecionar produtos por",
  [CONDITION]: "Condição",
  [PRODUCT_TYPE]: "Produto type",
  [CHANNEL]: "Canal",
  [CUSTOM_LABEL]: "Rótulo personalizado",
  [CONDITION_NEW]: "Novo",
  [CONDITION_USED]: "Usado",
  [CONDITION_REFURBISHED]: "Recondicionado",
  [CHANNEL_ONLINE]: "Online",
  [CHANNEL_LOCAL]: "Local",
  [ITEM_ID]: "Item ID",
  [SELECT_ALL]: "Selecionar todos",
  [RECOMMENDED_ACTIONS]: "Ações recomendadas",
  [DAY_SLASH_TIME]: "Dia/Hora",
  [DRAG_THE_MOUSE_TO_SELECT_THE_TIME_PERIOD]:
    "Arraste o mouse para selecionar o período de tempo",
  [SELECTED_TIME_PERIOD]: "Período de tempo selecionado",
  [NO_SELECTION]: "Nenhuma seleção",
  [USER_TIMEZONE]: "Fuso horário do usuário",
  [AD_ACCOUNT_TIMEZONE]: "Fuso horário da conta de anúncios",
  [GOOGLE_ORIGIN_APP]: "Aplicativo",
  [GOOGLE_ORIGIN_CALL_FROM_ADS]: "Chamada a partir de anúncios",
  [GOOGLE_ORIGIN_GOOGLE_HOSTED]: "Hospedado pelo Google",
  [GOOGLE_ORIGIN_STORE]: "Loja",
  [GOOGLE_ORIGIN_WEBSITE]: "Site",
  [GOOGLE_ORIGIN_YOUTUBE_HOSTED]: "Hospedado pelo YouTube",
  [GOOGLE_CATEGORY_ADD_TO_CART]: "Adicionar ao carrinho",
  [GOOGLE_CATEGORY_BEGIN_CHECKOUT]: "Iniciar compra",
  [GOOGLE_CATEGORY_BOOK_APPOINTMENT]: "Agendar horário",
  [GOOGLE_CATEGORY_CONTACT]: "Contato",
  [GOOGLE_CATEGORY_CONVERTED_LEAD]: "Lead convertido",
  [GOOGLE_CATEGORY_DEFAULT]: "Padrão",
  [GOOGLE_CATEGORY_DOWNLOAD]: "Baixar",
  [GOOGLE_CATEGORY_ENGAGEMENT]: "Engajamento",
  [GOOGLE_CATEGORY_GET_DIRECTIONS]: "Obter direções",
  [GOOGLE_CATEGORY_IMPORTED_LEAD]: "Lead importado",
  [GOOGLE_CATEGORY_OUTBOUND_CLICK]: "Clique de saída",
  [GOOGLE_CATEGORY_PAGE_VIEW]: "Visualização de página",
  [GOOGLE_CATEGORY_PHONE_CALL_LEAD]: "Lead por ligação telefônica",
  [GOOGLE_CATEGORY_PURCHASE]: "Compra",
  [GOOGLE_CATEGORY_QUALIFIED_LEAD]: "Lead qualificado",
  [GOOGLE_CATEGORY_REQUEST_QUOTE]: "Solicitar orçamento",
  [GOOGLE_CATEGORY_SIGNUP]: "Cadastro",
  [GOOGLE_CATEGORY_STORE_SALE]: "Venda na loja",
  [GOOGLE_CATEGORY_STORE_VISIT]: "Visita à loja",
  [GOOGLE_CATEGORY_SUBMIT_LEAD_FORM]: "Enviar Formulário De Lead",
  [GOOGLE_CATEGORY_SUBSCRIBE_PAID]: "Assinatura Pagada",
  [TRACKING_WEBSITE_EVENTS]: "Eventos do site",
  [TRACKING_EVENTS]: "Acompanhamento de eventos",
  [VALID]: "Válido",
  [INVALID]: "Inválido",
  [NOT_READY]: "Não pronto",
  [INSIGHT_APPLIED]: "Insight aplicado",
  [INSIGHT_DISCARDED]: "Insight descartado",
  [MAXIMIZE_CONVERSIONS]: "Maximizar Conversões",
  [MAXIMIZE_CONVERSION_VALUE]: "Maximizar valor de conversão",
  [IN_CURRENCY]: "em {{currency}}",
  [TARGET_CPA_EXPLANATION]:
    "Defina o custo médio que você deseja pagar por cada resultado.",
  [BID_GOAL_EXPLANATION]:
    "Defina o valor máximo que você está disposto a pagar por cada lance.",
  [OPTIMIZATION_GOAL_CONVERSATIONS]: "Você pagará por conversas.",
  [OPTIMIZATION_GOAL_VISIT_INSTAGRAM_PROFILE]:
    "Você pagará por visitas ao perfil.",
  [OPTIMIZATION_GOAL_LINK_CLICKS]: "Você pagará por cliques.",
  [OPTIMIZATION_GOAL_THRUPLAY]: "Você pagará por reproduções completas.",
  [OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS]:
    "Você pagará por visualizações da página de destino.",
  [OPTIMIZATION_GOAL_OPTION_REACH]: "Alcance",
  [OPTIMIZATION_GOAL_OPTION_THRUPLAY]:
    "Maior tempo de visualização de vídeo (ThruPlay)",
  [OPTIMIZATION_GOAL_OPTION_LINK_CLICKS]: "Cliques no link",
  [OPTIMIZATION_GOAL_OPTION_LANDING_PAGE_VIEWS]:
    "Visualizações da página de destino",
  [OPTIMIZATION_GOAL_PLACEHOLDER]: "Otimizar para",
  [OPTIMIZATION_GOAL_POST_ENGAGEMENT]: "Você pagará por engajamento.",
  [OPTIMIZATION_GOAL_OFFSITE_CONVERSIONS]: "Você pagará por conversões.",
  [OPTIMIZATION_GOAL_LEAD_GENERATION]: "Você pagará por geração de leads.",
  [OPTIMIZATION_GOAL_APP_INSTALLS]:
    "Você pagará por instalações do aplicativo.",
  [OPTIMIZATION_GOAL_CPM]: "Você pagará por mil impressões.",
  [OPTIMIZATION_GOAL_CLICK_TO_APP]: "Você pagará por cliques no aplicativo.",
  [OPTIMIZATION_GOAL_CONVERSION_IN_APP]:
    "Você pagará por conversões no aplicativo.",
  [SYNCING_INFORMATION_NO_EDIT_CLARIFICATION]:
    "Sincronizando campanha, aguarde antes de fazer alterações",
  [WAIT_FOR_CAMPAIGN_SYNC]: "Aguarde até que a campanha sincronize",
  [BRAND_GUIDELINES_ENABLED_CLARIFICATION]:
    "As diretrizes da marca estão ativas para esta campanha, então você não pode modificar este campo diretamente.",
  [METRICS]: "Métricas",
  [TIMES_EVERY]: "Vezes a cada",
  [FREQUENCY_CAP_EXPLANATION]:
    "No máximo, tentaremos ficar abaixo de {{value}} impressões a cada {{interval}} dias",
  [FREQUENCY_TARGET_EXPLANATION]:
    "Para ajudar a alcançar seu objetivo, tentaremos entregar aproximadamente {{value}} impressões a cada {{interval}} dias.",
  [TARGET]: "Objetivo",
  [TARGET_FREQUENCY_EXPLANATION]:
    "O número médio de vezes que você quer que as pessoas vejam seus anúncios",
  [CAP]: "Máximo",
  [CAP_FREQUENCY_EXPLANATION]:
    "O número máximo de vezes que você quer que as pessoas vejam seus anúncios",
  [FREQUENCY_SPECS_CONTROL_PLACEHOLDER]: "Controle de frequência",
  [FREQUENCY_SPECS_CAP_EXPLANATION]:
    "O número máximo de vezes que você quer que as pessoas vejam seus anúncios",
  [FREQUENCY_SPECS_CAP_DESCRIPTION]:
    "No máximo, nosso objetivo será ficar abaixo de {{maxFrequency}} impressões a cada {{intervalDays}} dias",
  [RESERVATION_ESTIMATES]: "Estimativas de reserva",
  [AUDIENCE_ESTIMATES]: "Estimativas de audiência",
  [LOADING_LOCATIONS_IN_MAP]: "Carregando localizações no mapa",
  [EXPORTING_LOCATIONS_TO_FORM]: "Configurando localizações...",
  [SUGGESTED_LOCATIONS_TITLE]: "Localizações sugeridas",
  [LOADING_SUGGESTED_LOCATIONS]: "Carregando localizações sugeridas...",
  [SUGGESTED_LOCATIONS_COUNT]: "{{count}} sugeridas",
  [ADD_ALL_LOCATIONS]: "Adicionar todas",
  [ESTIMATED_DAILY_REACH]: "Alcance diário estimado",
  [AVERAGE_AUDIENCE_SIZE]: "Tamanho médio da audiência",
  [NO_ESTIMATION_AVAILABLE]: "Estimativa indisponível",
  [ALL_USERS]: "Todos os usuários",
  [ALL_TIME]: "Todo o período",
  [APPLY_OPTIMIZATIONS_WITH_NAME]: `Aplicar a otimização "{{value}}"`,
  [DISCONNECTED_ACCOUNT]: "Conta desconectada",
  [CAMPAIGN_ALREADY_BEING_CREATED]:
    "A campanha já está sendo criada em outro dispositivo/aba",
  [CAMPAIGN_ALREADY_BEING_UPDATED]:
    "A campanha já está sendo atualizada em outro dispositivo/aba",
  [UNKNOWN_VALUE]: "Valor desconhecido",
  [VIDEO]: "Vídeo",
  [IMAGE]: "Imagem",
  [CAMPAIGNS]: "Campanhas",
  [TEXT_IN_IMAGE]: "Texto na Imagem",
  [VIDEO_LANGUAGE]: "Idioma do vídeo",
  [LOGO_IN_IMAGE]: "Logo na imagem",
  [LOGO_IN_VIDEO]: "Logo no vídeo",
  [LOGO_IN_VIDEO_DESCRIPTION_LEAD]: "O logo aparecerá no final do vídeo.",
  [I_DONT_HAVE_A_WEBSITE]: "Não tenho um site",
  [SET_UP_BRAND]: "Configurar marca",
  [OVERLAPS_WITH]: "Sobrepõe-se a",
  [GENERATION_FAILED]: "Falha na geração",
  [YOUR_CAMPAIGN_HAS_SOME_DISAPPROVALS]: "Sua campanha tem algumas reprovações",
  [ANALYZING_CONTENT]: "Analisando o conteúdo para gerar recomendações...",
  [CONTENT_WARNING_TITLE]: "Aviso de conteúdo",
  [CONTENT_RECOMMENDATIONS_SUBTITLE]:
    "Recomendamos adicionar os seguintes formatos de conteúdo para um melhor desempenho",
  [CONTENT_RECOMMENDATIONS]: "Recomendações de conteúdo",
  [CONTENT_RECOMMENDATION_OPEN_CREATE_WITH_IA]:
    "Usar esta recomendação em Criar com IA",
  [NO_CONTENT_RECOMMENDATIONS]: "Nenhuma recomendação de conteúdo encontrada",
  [CONTENT_RECOMMENDATIONS_BANNER_TITLE]: "Recomendações de Conteúdos",
  [CONTENT_RECOMMENDATIONS_BANNER_DESCRIPTION]:
    "Detectamos ângulos criativos que podem funcionar para a sua campanha. Gere-os em um clique.",
  [CONTENT_RECOMMENDATIONS_VIEW_ALL]: "Ver todas ({{count,number}})",
  [CONTENT_RECOMMENDATIONS_COMPLETED_PROGRESS]:
    "{{completed,number}} de {{total,number}} geradas",
  [CONTENT_RECOMMENDATION_GENERATED]: "Gerada",
  [CONTENT_RECOMMENDATION_GENERATE_ARIA]: "Gerar: {{text}}",
  [CONTENT_RECOMMENDATIONS_ALL_COMPLETED]:
    "Pronto! Você adicionou todas as recomendações",
  [BAD]: "Ruim",
  [REGULAR]: "Regular",
  [GOOD]: "Bom",
  [VERY_GOOD]: "Muito bom",
  [EXCELLENT]: "Excelente",
  [FIELD]: "Campo",
  [ID_PLATFORM]: "{{value}} ID",

  /* PAYMENTS */
  [SELECT_PAYMENT_METHOD]: "Selecionar Método de Pagamento",
  [ADD_PAYMENT_METHOD]: "Adicionar Método de Pagamento",
  [PAYMENT_METHOD]: "Método de pagamento",
  [PAYMENT_METHODS]: "Métodos de pagamento",
  [PAYMENT_METHODS_EMPTY]: "Nenhum método de pagamento disponível, adicione um",
  [MAIN_PAYMENT_METHOD]: "Principal método de pagamento",
  [OTHERS_PAYMENT_METHODS]: "Outros métodos de pagamento",
  [OTHERS_PAYMENT_METHODS_EMPTY]: "Nenhum método de pagamento adicional",
  [PAYMENT_METHODS_SECURE]: "Seus métodos de pagamento estarão seguros",
  [PAYMENT_METHODS_SECURE_EXPLANATION]:
    "Suas informações de pagamento nunca serão expostas e você poderá modificá-las quando quiser",
  [PAYMENT_METHODS_ENCRYPTED]: "Criptografia de ponta a ponta",
  [PAYMENT_SUCCESSFUL]: "Pagamento realizado com sucesso",
  [UPGRADE_SUBSCRIPTION_SUCCESSFUL]: "Assinatura atualizada com sucesso",
  [PRICE_TO_BE_PAID]: "Preço a pagar",
  [PAY]: "Pagar",
  [ADD_CARD]: "Adicionar cartão",
  [VERIFY_SUBSCRIPTION_TITLE]: "Não foi possível verificar sua assinatura",
  [VERIFY_SUBSCRIPTION_DESCRIPTION]:
    "Nosso provedor não conseguiu verificar e sincronizar sua assinatura. Por favor, digite novamente os dados usados na compra. Nenhuma cobrança será realizada e seus dados estarão seguros.",
  [VERIFY_SUBSCRIPTION_CTA]: "Verificar",
  [SAVE_CONFIGURATION]: "Salvar configuração",
  [CARD_INFORMATION_EXPLANATION_TITLE]: "Informações coletadas do seu cartão",
  [CARD_INFORMATION_NUMBER_CARD_EXPLANATION_TITLE]: "Número do cartão",
  [CARD_INFORMATION_NUMBER_CARD_EXPLANATION_DESCRIPTION]:
    "O número do cartão possui 16 dígitos e é separado em grupos de 4, localizados na parte frontal do cartão.",
  [CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_TITLE]: "Data de validade",
  [CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_DESCRIPTION]:
    "Pode ser encontrada na parte frontal ou traseira do cartão. Possui 4 ou, às vezes, 3 números. Seu formato é MM/AA (mês em número/últimos dois números do ano).",
  [CARD_INFORMATION_CVV_EXPLANATION_TITLE]: "Código de segurança (CVV)",
  [CARD_INFORMATION_CVV_EXPLANATION_DESCRIPTION]:
    "Geralmente está localizado na parte traseira do cartão, às vezes na parte frontal. Possui 4 ou 3 números e sua função é validar o cartão.",
  [YOU_WILL_PAY]: "Você pagará",
  [ACCEPT_TERMS_PAY]: `Aceite os termos e condições de {{NAME_BUSINESS}}`,
  [DELETE_PAYMENT_METHOD_CONFIRMATION_TITLE]:
    "Tem certeza de que deseja excluir este método de pagamento?",
  [QUANTITY_TO_PAY]: "Valor a pagar",
  [USERS]: "Usuários",
  [ANONYMOUS_USER]: "Usuário anônimo",

  /* FIELDS PLACEHOLDERS */
  [NAME_PLACEHOLDER]: "Nome",
  [EMAIL_PLACEHOLDER]: "E-mail",
  [PASSWORD_PLACEHOLDER]: "Senha",
  [PASSWORD_CONFIRMATION_PLACEHOLDER]: "Repita a senha",
  [SELECT_BUSINESS_PLACEHOLDER]: "Selecione uma empresa",
  [NAME_BUSINESS_PLACEHOLDER]: "Nome da empresa",
  [SELECT_BRANDS_PLACEHOLDER]: "Selecione as marcas",
  [MAIN_BRAND_PLACEHOLDER]: "Marca principal",
  [SELECT_BRAND_PLACEHOLDER]: "Selecione uma marca",
  [SELECT_STORE_PLACEHOLDER]: "Selecione uma loja",
  [NAME_AND_LAST_NAME_PLACEHOLDER]: "Nome e sobrenome",
  [SELECT_TYPE_PLAN_PLACEHOLDER]: "Tipo de plano",
  [COST_COLLABORATION_PLACEHOLDER]: "Custo por colaboração",
  [CREDITS_PLACEHOLDER]: `Créditos de {{NAME_BUSINESS}}`,
  [TRIAL_DAYS_PLACEHOLDER]: "Dias de teste",
  [TYPE_PACKAGE_PLACEHOLDER]: "Tipo de pacote",
  [PRICE_BASIC_PLACEHOLDER]: "Custo da assinatura básica",
  [COST_COLLABORATION_BASIC_PLACEHOLDER]: "Custo por colaboração básica",
  [PRICE_PRO_PLACEHOLDER]: "Custo da assinatura Pro",
  [COST_COLLABORATION_PRO_PLACEHOLDER]: "Custo por colaboração Pro",
  [PRICE_GROWTH_PLACEHOLDER]: "Custo da assinatura Growth",
  [COST_COLLABORATION_GROWTH_PLACEHOLDER]: "Custo por colaboração Growth",
  [COMMERCIAL_PLACEHOLDER]: "Comercial",
  [BUSINESS_NAME_PLACEHOLDER]: "Nome",
  [BUSINESS_DESCRIPTION_PLACEHOLDER]: "Descrição",
  [BUSINESS_TEXT_STYLE_PLACEHOLDER]: "Tom de comunicação",
  [BUSINESS_LOOK_AND_FEEL_PLACEHOLDER]: "Aparência e estilo",
  [LOOK_AND_FEEL_PLACEHOLDER]: "Aparência e estilo",
  [BUSINESS_OFFERING_PLACEHOLDER]: "Oferta",
  [BUSINESS_OFFERING_PHYSICAL_PRODUCT_PLACEHOLDER]: "Produtos físicos",
  [BUSINESS_OFFERING_SERVICES_PLACEHOLDER]: "Serviços",
  [DESCRIPTION_OPTIONAL_PLACEHOLDER]: "Descrição (opcional)",
  [PRICE_PLACEHOLDER]: "Preço",
  [CURRENCY_PLACEHOLDER]: "Moeda",
  [IS_RECURRENCE_PLACEHOLDER]: "A cobrança é",
  [RECURRENCE_PLACEHOLDER]: "Recorrência",
  [SELECT_CAMPAIGN_PLACEHOLDER]: "Selecione uma campanha",
  [SELECT_UGC_CONTENT_FORMAT]: "Selecione um estilo de conteúdo",
  [SELECT_SOME_OPTIONS]: "Selecione algumas opções",
  [OBJECTIVE_PLACEHOLDER]: "Objetivo",
  [PLATFORMS_PLACEHOLDER]: "Plataformas",
  [PLATFORM_PLACEHOLDER]: "Plataforma",
  [BUDGET_PLACEHOLDER]: "Orçamento",
  [DAILY_BUDGET_PLACEHOLDER]: "Orçamento diário em {{currency}}",
  [LIFETIME_BUDGET_PLACEHOLDER]: "Orçamento total em {{currency}}",
  [LOCATIONS_PLACEHOLDER]: "Localizações",
  [EXCLUDED_LOCATIONS_PLACEHOLDER]: "Localizações excluídas",
  [AGE_RANGE_PLACEHOLDER]: "Faixa etária",
  [GENDERS_PLACEHOLDER]: "Gêneros",
  [INTERESTS_PLACEHOLDER]: "Interesses",
  [INDUSTRIES_PLACEHOLDER]: "Setores",
  [JOB_FUNCTIONS_PLACEHOLDER]: "Funções profissionais",
  [SENIORITIES_PLACEHOLDER]: "Níveis de senioridade",
  [JOB_TITLES_PLACEHOLDER]: "Cargos",
  [COMPANY_SIZES_PLACEHOLDER]: "Tamanhos de empresas",
  [COMPANIES_PLACEHOLDER]: "Empresas",
  [DEGREES_PLACEHOLDER]: "Formações acadêmicas",
  [FIELDS_OF_STUDY_PLACEHOLDER]: "Áreas de estudo",
  [SCHOOLS_PLACEHOLDER]: "Instituições de ensino",
  [SKILLS_PLACEHOLDER]: "Habilidades",
  [MEMBER_TRAITS_PLACEHOLDER]: "Características dos membros",
  [MEMBER_BEHAVIORS_PLACEHOLDER]: "Comportamentos dos membros",
  [MEMBER_GROUPS_PLACEHOLDER]: "Grupos de membros",

  [DEGREES_SEARCH_PLACEHOLDER]:
    "ex. Bacharelado em Engenharia da Computação, Mestrado em Ciência de Dados",
  [FIELDS_OF_STUDY_SEARCH_PLACEHOLDER]:
    "ex. Computer Science, Marketing, Business Administration",
  [INTERESTS_SEARCH_PLACEHOLDER]:
    "ex. Software Development, Digital Marketing, Business Consulting",
  [SCHOOLS_SEARCH_PLACEHOLDER]:
    "ex. Harvard University, Stanford University, MIT",
  [SKILLS_SEARCH_PLACEHOLDER]:
    "ex. Project Management, Python, Microsoft Excel",
  [COMPANIES_SEARCH_PLACEHOLDER]: "ex. Microsoft, Meta, Google, Stripe",
  [INDUSTRIES_SEARCH_PLACEHOLDER]:
    "ex. Software Development, Financial Services, Healthcare",
  [COMPANY_SIZES_SEARCH_PLACEHOLDER]:
    "ex. 11-50 funcionários, 51-200 funcionários",
  [JOB_FUNCTIONS_SEARCH_PLACEHOLDER]: "ex. Marketing, Engineering, Sales",
  [JOB_TITLES_SEARCH_PLACEHOLDER]:
    "ex. Software Engineer, Project Manager, Designer",
  [SENIORITIES_SEARCH_PLACEHOLDER]: "ex. Senior, Manager, Director",
  [MEMBER_BEHAVIORS_SEARCH_PLACEHOLDER]:
    "ex. Job Seekers, Recently Promoted, Frequent Travelers",

  [LINKEDIN_STAFF_COUNT_MYSELF_ONLY]: "Somente eu",
  [LINKEDIN_STAFF_COUNT_2_10]: "2-10 funcionários",
  [LINKEDIN_STAFF_COUNT_11_50]: "11-50 funcionários",
  [LINKEDIN_STAFF_COUNT_51_200]: "51-200 funcionários",
  [LINKEDIN_STAFF_COUNT_201_500]: "201-500 funcionários",
  [LINKEDIN_STAFF_COUNT_501_1000]: "501-1.000 funcionários",
  [LINKEDIN_STAFF_COUNT_1001_5000]: "1.001-5.000 funcionários",
  [LINKEDIN_STAFF_COUNT_5001_10000]: "5.001-10.000 funcionários",
  [LINKEDIN_STAFF_COUNT_10001_PLUS]: "10.001+ funcionários",

  [LINKEDIN_JOB_FUNCTION_ACCOUNTING]: "Containg",
  [LINKEDIN_JOB_FUNCTION_ADMINISTRATIVE]: "Administrativo",
  [LINKEDIN_JOB_FUNCTION_ARTS_AND_DESIGN]: "Arte e Design",
  [LINKEDIN_JOB_FUNCTION_BUSINESS_DEVELOPMENT]: "Desenvolvimento de negócios",
  [LINKEDIN_JOB_FUNCTION_COMMUNITY_AND_SOCIAL_SERVICES]:
    "Serviços Comunitários e Sociais",
  [LINKEDIN_JOB_FUNCTION_CONSULTING]: "Consultoria",
  [LINKEDIN_JOB_FUNCTION_EDUCATION]: "Educação",
  [LINKEDIN_JOB_FUNCTION_ENGINEERING]: "Engenharia",
  [LINKEDIN_JOB_FUNCTION_ENTREPRENEURSHIP]: "Empdesempenho",
  [LINKEDIN_JOB_FUNCTION_FINANCE]: "Finanças",
  [LINKEDIN_JOB_FUNCTION_HEALTHCARE_SERVICES]: "Serviços de saúde",
  [LINKEDIN_JOB_FUNCTION_HUMAN_RESOURCES]: "Recursos humanos",
  [LINKEDIN_JOB_FUNCTION_INFORMATION_TECHNOLOGY]: "Tecnologia da Informação",
  [LINKEDIN_JOB_FUNCTION_LEGAL]: "Legal",
  [LINKEDIN_JOB_FUNCTION_MARKETING]: "Marketing",
  [LINKEDIN_JOB_FUNCTION_MEDIA_AND_COMMUNICATION]: "Mídia e Comunicação",
  [LINKEDIN_JOB_FUNCTION_MILITARY_AND_PROTECTIVE_SERVICES]:
    "Serviços Militares e de Proteção",
  [LINKEDIN_JOB_FUNCTION_OPERATIONS]: "Operações",
  [LINKEDIN_JOB_FUNCTION_PRODUCT_MANAGEMENT]: "Produto Management",
  [LINKEDIN_JOB_FUNCTION_PROGRAM_AND_PROJECT_MANAGEMENT]:
    "Gestão de Programas e Projetos",
  [LINKEDIN_JOB_FUNCTION_PURCHASING]: "Compras",
  [LINKEDIN_JOB_FUNCTION_QUALITY_ASSURANCE]: "Garantia de qualidade",
  [LINKEDIN_JOB_FUNCTION_REAL_ESTATE]: "Imóveis",
  [LINKEDIN_JOB_FUNCTION_RESEARCH]: "Pesquisa",
  [LINKEDIN_JOB_FUNCTION_SALES]: "Vendas",
  [LINKEDIN_JOB_FUNCTION_CUSTOMER_SUCCESS_AND_SUPPORT]:
    "Sucesso e Suporte ao Cliente",

  [LINKEDIN_SENIORITY_UNPAID]: "Não remunerado",
  [LINKEDIN_SENIORITY_TRAINING]: "Treinamento",
  [LINKEDIN_SENIORITY_ENTRY]: "Iniciante",
  [LINKEDIN_SENIORITY_SENIOR]: "Senior",
  [LINKEDIN_SENIORITY_MANAGER]: "Gerente",
  [LINKEDIN_SENIORITY_DIRECTOR]: "Director",
  [LINKEDIN_SENIORITY_VP]: "VP",
  [LINKEDIN_SENIORITY_CXO]: "CXO",
  [LINKEDIN_SENIORITY_PARTNER]: "Sócio",
  [LINKEDIN_SENIORITY_OWNER]: "Proprietário",

  [LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_TRAVELERS]: "Viajantes frequentes",
  [LINKEDIN_MEMBER_BEHAVIOR_JOB_SEEKERS]: "Pessoas em busca de emprego",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_EDUCATION]: "Aberto a educação",
  [LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_CONTRIBUTORS]: "Colaboradores frequentes",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED]: "Mudaram-se recentemente",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_PROMOTED]: "Promovidos recentemente",
  [LINKEDIN_MEMBER_BEHAVIOR_CAREER_CHANGERS]: "Em transição de carreira",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_SWITCHED_JOBS]:
    "Mudaram de emprego recentemente",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION]: "Aberto a realocação",
  [LINKEDIN_MEMBER_BEHAVIOR_EXPAT]: "Expatriado",
  [LINKEDIN_MEMBER_BEHAVIOR_MOBILE_USERS]: "Usuários Móviles",
  [LINKEDIN_MEMBER_BEHAVIOR_DESKTOP_LAPTOP_USERS]:
    "Usuários de Escritorio/Portátil",
  [LINKEDIN_MEMBER_BEHAVIOR_DOMESTIC_FREQUENT_TRAVELERS]:
    "Viajantes frequentes nacionais",
  [LINKEDIN_MEMBER_BEHAVIOR_INTERNATIONAL_FREQUENT_TRAVELERS]:
    "Viajantes frequentes internacionais",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_DOMESTIC]:
    "Mudaram-se recentemente (nacional)",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_INTERNATIONAL]:
    "Mudaram-se recentemente (internacional)",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_DOMESTIC]:
    "Aberto a realocação (Domestic)",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_INTERNATIONAL]:
    "Aberto a realocação (International)",
  [LINKEDIN_MEMBER_BEHAVIOR_ANDROID_USERS]: "Usuários Android",
  [LINKEDIN_MEMBER_BEHAVIOR_WINDOWS]: "Windows",
  [LINKEDIN_MEMBER_BEHAVIOR_MAC]: "Mac",
  [LINKEDIN_MEMBER_BEHAVIOR_LINUX]: "Linux",

  [AUDIENCE_ATTRIBUTES_PLACEHOLDER]: "Atributos da Audiência",
  [BEHAVIORS_PLACEHOLDER]: "Comportamentos",
  [DEMOGRAPHICS_PLACEHOLDER]: "Dados demográficos",
  [DEMOGRAPHICS_BASIC_PLACEHOLDER]: "Demografia básica",
  [BUDGET_CONFIGURATION_PLACEHOLDER]: "Configuração de Orçamento",
  [BUDGET_CAMPAIGN_DATES_PLACEHOLDER]: "Fechas de Campanha",
  [DESTINATION_TYPE_PLACEHOLDER]: "Local da Conversão",
  [CUSTOM_AUDIENCES_PLACEHOLDER]: "Audiências personalizadas",
  [CUSTOM_PLACEMENTS_PLACEHOLDER]: "Posicionamentos personalizados",
  [EXCLUDED_CUSTOM_AUDIENCES_PLACEHOLDER]:
    "Audiências personalizadas excluidas",
  [KEYWORDS_PLACEHOLDER]: "Palavras-chave",
  [KEYWORDS_NEGATIVE_PLACEHOLDER]: "Palavras-chave negativas",
  [DESCRIPTION_PLACEHOLDER]: "Descrição",
  [LONG_HEADLINE_PLACEHOLDER]: "Título longo",
  [TRACKING_META_ID_PLACEHOLDER]: "Meta Pixel ID",
  [TRACKING_TIKTOK_ID_PLACEHOLDER]: "TikTok Pixel ID",
  [TRACKING_GOOGLE_ID_PLACEHOLDER]: "Google Tag ID",
  [TRACKING_LINKEDIN_ID_PLACEHOLDER]: "LinkedIn Pixel ID",
  [TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER]: "Meta Tracking Event",
  [TRACKING_CUSTOM_EVENT_ID_TIKTOK_PLACEHOLDER]: "TikTok Tracking Event",
  [TRACKING_CUSTOM_EVENT_ID_GOOGLE_PLACEHOLDER]: "Google Tracking Event",
  [TRACKING_CUSTOM_EVENT_ID_LINKEDIN_PLACEHOLDER]: "LinkedIn Tracking Event",
  [DESTINATION_URL_PLACEHOLDER]: "URL de Reendereço",
  [DEEP_LINK_PLACEHOLDER]: "Link Profundo",
  [CREATOR_BODY_BUILD_PLACEHOLDER]: "Tipo de corpo",
  [CREATOR_CLOTHING_STYLE_PLACEHOLDER]: "Estilo de roupa",
  [CREATOR_CONTENT_STYLE_PLACEHOLDER]: "Estilo de conteúdo",
  [CREATOR_DISTINGUISHING_FEATURES_PLACEHOLDER]: "Características distintivas",
  [CALL_TO_ACTION_PLACEHOLDER]: "Chamada para ação",
  [CHOOSE_AN_ADDRESS_PLACEHOLDER]: "Escolha um endereço",
  [CALL_TO_ACTIONS_PLACEHOLDER]: "Chamadas para ação",
  [ADS_CAMPAIGN_CONTEXT]: "Do que se trata sua campanha?",
  [TYPE_BUDGET_PLACEHOLDER]: "Tipo de Orçamento",
  [TITLE_PLACEHOLDER]: "Título",
  [HEADLINE_PLACEHOLDER]: "Título",
  [WEBSITE_URL_PLACEHOLDER]: "URL do seu site",
  [LANGUAGE_CAMPAIGN_PLACEHOLDER]: "Idioma da campanha",
  [LANGUAGE_PLACEHOLDER]: "Idioma",
  [VERIFICATION_CODE_PLACEHOLDER]: "Código de verificação",
  [TYPE_PLACEHOLDER]: "Tipo",
  [RETENTION_DAYS_PLACEHOLDER]: "Retenção do público (Em dias)",
  [IDENTITY_TIK_TOK_PLACEHOLDER]: "Identidade do TikTok",
  [PROFILE_IMAGE_PLACEHOLDER]: "Imagem de perfil",
  [PROFILE_NAME_PLACEHOLDER]: "Nome do perfil",
  [AD_ACCOUNT_META_PLACEHOLDER]: "Meta Ad Conta",
  [AD_ACCOUNT_TIKTOK_PLACEHOLDER]: "TikTok Ad Conta",
  [AD_ACCOUNT_GOOGLE_PLACEHOLDER]: "Google Ad Conta",
  [AD_ACCOUNT_LINKEDIN_PLACEHOLDER]: "LinkedIn Ad Conta",
  [LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER]: "Conta do LinkedIn",
  [LINKEDIN_PUBLISH_AS_PERSONAL_LABEL]: "Personal",
  [LINKEDIN_PUBLISH_AS_COMPANY_PAGE_LABEL]: "Empresa Page",
  [PAGE_FACEBOOK_PLACEHOLDER]: "Página do Facebook",
  [INSTAGRAM_ACCOUNT_PLACEHOLDER]: "Conta do Instagram",
  [USE_FB_PAGE_AS_IG]: "Usar a Página do Facebook como Instagram",
  [YOUTUBE_ACCOUNT_PLACEHOLDER]: "Conta do YouTube",
  [YOUTUBE_PRIVACY_LEVEL_PUBLIC]: "Público",
  [YOUTUBE_PRIVACY_LEVEL_UNLISTED]: "Não listado",
  [YOUTUBE_PRIVACY_LEVEL_PRIVATE]: "Privado",
  [YOUTUBE_PRIVACY_LEVEL_LABEL]: "Nivel de privacidade",
  [YOUTUBE_TITLE_LABEL]: "Título",
  [YOUTUBE_DESCRIPTION_LABEL]: "Descrição",
  [YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL]: "Notificar inscritos",
  [YOUTUBE_MADE_FOR_KIDS_LABEL]: "Feito para crianças",
  [FORMAT_PLACEHOLDER]: "Formato",
  [ADVERTISER_SELECTOR_BRANDS_COUNT]: "{{count}} marcas",
  [ADVERTISER_SELECTOR_BRANDS_COUNT_SINGLE]: "{{count}} marca",
  [ADVERTISER_SELECTOR_NO_RESULTS]: "Não results",
  [ADVERTISER_SELECTOR_SEARCH_PLACEHOLDER]: "Buscar brands…",
  [ADVERTISER_SELECTOR_TRY_ANOTHER_NAME]: "Tente com outro nome",
  [ADVERTISER_SELECTOR_CONFIGURE_LIMITS_BUTTON]: "Configurar limites",
  [SELECT_ADVERTISER_ID_PLACEHOLDER]: "Marca",
  [SOCIAL_NETWORK_URL_PLACEHOLDER]: "URL de seu Red Social",
  [DISCOUNT_CODE_PLACEHOLDER]: "Discount Código",
  [BRAND_INSTAGRAM_PROFILE_URL_PLACEHOLDER]:
    "URL do Perfil de Instagram de seu Marca",
  [INSTAGRAM_PROFILE_URL_PLACEHOLDER]: "URL do Perfil de Instagram",
  [SCRIPT_PLACEHOLDER]: "Roteiro",
  [META_DESTINATION_TYPE_PLACEHOLDER]: "Local da Conversão",
  [ROLE_PLACEHOLDER]: "Função",
  [CAMPAIGN_TYPE_PLACEHOLDER]: "Tipo de Campanha",
  [CONVERSION_ACTIONS_PLACEHOLDER]: "Ações de Conversão",
  [SEARCH_KEYWORDS_PLACEHOLDER]: "Buscar palavras-chave",
  [WHATSAPP_BUSINESS_NUMBER_PLACEHOLDER]: "Número do WhatsApp Business",
  [WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER]: "Modelo de mensagem de boas-vindas",
  [MESSAGE_TEMPLATE_UNSUPPORTED_TITLE]:
    "Modelo não compatível com a plataforma",
  [MESSAGE_TEMPLATE_UNSUPPORTED_DESCRIPTION]:
    "Este modelo inclui um formulário criado diretamente na Meta. Não é possível editá-lo aqui, mas ele será mantido como está ao salvar as alterações do anúncio.",
  [GREETING_MESSAGE_PLACEHOLDER]: "Mensagem de saudação",
  [CUSTOMER_TYPE_MESSAGE_PLACEHOLDER]: "Tipo de mensagem do usuário",
  [CUSTOMER_TYPE_PREFILL_MESSAGE]: "Mensagem pré-preenchida",
  [CUSTOMER_TYPE_QUICK_QUESTIONS_MESSAGE]: "Perguntas rápidas",
  [CUSTOMER_TEXT_PLACEHOLDER]: "Mensagem pré-preenchida do usuário",
  [CUSTOMER_TEXTS_PLACEHOLDER]: "Pergunta rápida {{value}} do usuário",
  [LOG_MESSAGE_TEMPLATE_CUSTOMER_TEXTS]: "Textos do cliente",
  [INSTANT_FORM_PLACEHOLDER]: "Formulário Instantâneo",
  [TIKTOK_LEAD_DESTINATION_WEBSITE]: "Site",
  [TIKTOK_LEAD_DESTINATION_INSTANT_FORM]: "Formulário Instantâneo",
  [TIKTOK_INSTANT_FORM_EDITOR_HINT]:
    "O formulário é criado no editor do TikTok. Para mudar as perguntas, crie outro formulário e substitua-o no anúncio.",
  [TIKTOK_INSTANT_FORM_CREATE]: "Criar formulário",
  [INTEGRATION_MISSING_PERMISSION]:
    "Sua integração não tem permissões suficientes para esta funcionalidade. Reconecte sua conta de {{platform}}.",
  [TIKTOK_INSTANT_FORM_EDITOR_FAILED]:
    "Não foi possível abrir o editor. Permita as janelas pop-up deste site e tente criar o formulário novamente. Se o problema continuar, fale com o suporte pelo chat de ajuda à direita.",
  [TIKTOK_INSTANT_FORM_LOCKED_DESTINATION]:
    "O destino de um conjunto já publicado não pode ser alterado. Crie outro conjunto.",
  [TIKTOK_CAROUSEL_REQUIRES_TIKTOK_PLACEMENT]:
    "O carrossel exige que o conjunto inclua o posicionamento TikTok.",
  [TIKTOK_INSTANT_FORM_PREVIEW_NAME]: "Formulário: {{name}}",
  [CREATE_ADS_CAMPAIGN_TIKTOK_LEAD_DESTINATION_QUESTION]:
    "Para onde os leads devem ir?",
  [CREATE_ADS_CAMPAIGN_TIKTOK_INSTANT_FORM_QUESTION]:
    "Escolha um formulário instantâneo. Você pode deixar em branco e selecionar depois.",
  [WHY_WOULD_IT_WORK]: "Por que funcionaria?",
  [INSTANT_FORM_SECTION_FORM_TYPE]: "Tipo de formulário",
  [INSTANT_FORM_SECTION_INTRO]: "Introdução",
  [INSTANT_FORM_SECTION_QUESTIONS]: "Perguntas",
  [INSTANT_FORM_SECTION_END]: "Encerramento",
  [INSTANT_FORM_FIELD_HEADLINE]: "Título",
  [INSTANT_FORM_FIELD_DESCRIPTION]: "Descrição",
  [INSTANT_FORM_FIELD_CTA]: "CTA",
  [ENTER_ANSWER_PLACEHOLDER]: "Digite sua resposta",
  [IMAGES_OF_CAMPAIGN_PLACEHOLDER]: "Imagens",
  [VIDEOS_OF_CAMPAIGN_PLACEHOLDER]: "Vídeos",
  [LOGO_OF_THE_BRAND_PLACEHOLDER]: "Logo da marca",
  [LOGO_URLS_PLACEHOLDER]: "Logos da Marca",
  [NETWORK_DISPLAY_SETTING_PLACEHOLDER]:
    "Onde quer que Google muestre seu anúncio?",
  [GOOGLE_AI_MAX_ENABLE_QUESTION]: "Quer habilitar Google AI Max?",
  [GOOGLE_AI_MAX_ACTIVATED]: "Ativado",
  [GOOGLE_AI_MAX_DEACTIVATED]: "Desativado",
  [REPORT_BREAKDOWN_PLACEHOLDER]: "Desglose do relatório",
  [ADS_CAMPAIGN_CONTEXT_PLACEHOLDER]: "Em que consistirá sua campanha?",
  [ADS_CAMPAIGN_LANGUAGE_PLACEHOLDER]: "Idioma da Campanha",
  [ADS_CAMPAIGN_LANGUAGE_SELECT_PLACEHOLDER]: "Selecione um idioma",
  [ADS_CAMPAIGN_LOCATION_PLACEHOLDER]:
    "Para quais localizações você quer se direcionar?",
  [ADS_CAMPAIGN_PLATFORMS_PLACEHOLDER]:
    "Em quais plataformas sua campanha será veiculada?",
  [SOCIAL_NETWORKS_PLACEHOLDER]: "Redes sociais",
  [BUSINESS_COMPETITORS_PLACEHOLDER]: "Concorrentes",
  [FIND_A_LOCATION_PLACEHOLDER]: "Buscar um local",
  [CREATIVE_TYPE_PLACEHOLDER]: "Tipo de criativo",
  [ADVANTAGE_CREATIVE_ENHANCES_PLACEHOLDER]: "Mejoras Advantage do Creativo",
  [SITE_LINKS_PLACEHOLDER]: "Links de Sitio",
  [SITE_LINK_PLACEHOLDER]: "Link de Sitio",
  [SITE_LINK_TEXT_PLACEHOLDER]: "Nome",
  [SITE_LINK_DESCRIPTION_PLACEHOLDER]: "Descrição",
  [SITE_LINK_FINAL_URL_PLACEHOLDER]: "URL final",
  [SITE_LINK_DESCRIPTIONS_PLACEHOLDER]: "Descriçãos",
  [CALLOUTS_PLACEHOLDER]: "Chamadas para a ação",
  [CALLOUT_TEXT_PLACEHOLDER]: "Texto de destaque",
  [KEYWORD_PLACEHOLDER]: "Palavra-chave",
  [KEYWORD_MATCH_TYPE_PLACEHOLDER]: "Tipo de correspondência",
  [FROM_PLACEHOLDER]: "De",
  [SEARCH_THEMES_PLACEHOLDER]: "Buscar themes",
  [STATUS_PLACEHOLDER]: "Situação",
  [USE_CAMPAIGN_BUDGET_PLACEHOLDER]: "Orçamento a Nivel de Campanha (CBO)",
  [DESTINATION_TYPE_AD_PLACEHOLDER]: "Destino",
  [DATA_TYPE_PLACEHOLDER]: "Tipo de dados",
  [CUSTOMER_TYPES_PLACEHOLDER]: "Tipos de cliente",
  [FIRST_NAME_PLACEHOLDER]: "Nome",
  [LAST_NAME_PLACEHOLDER]: "Sobrenome",
  [COUNTRY_CODE_PLACEHOLDER]: "País code",
  [POSTAL_CODE_PLACEHOLDER]: "Código postal",
  [PHONE_PLACEHOLDER]: "Telefone",
  [BUSINESS_LOGO]: "Logo da marca",
  [SELECT_RANGE_DATE_PLACEHOLDER]: "Selecione um intervalo de datas",
  [MEDIA_URLS_PLACEHOLDER]: "Criativo",
  [CATALOG_PLACEHOLDER]: "Catálogo",
  [PROMOTED_PRODUCTS_PLACEHOLDER]: "Promoted Produtos",
  [PRODUCT_SET]: "Produto Set",
  [PRODUCT_SET_PLACEHOLDER]: "Produto Set",
  [PRODUCT_CONFIGURATION_PLACEHOLDER]: "Configuração de produtos",
  [PRODUCT_LIST]: "Produto List",
  [PRODUCT_LIST_PLACEHOLDER]: "Customized Produtos",
  [BUTTON_ADD_PRODUCTS]: "Adicionar produtos",
  [MODAL_PRODUCT_LIST_TIKTOK_TITLE]: "Selecionar produtos",
  [MODAL_PRODUCT_LIST_TIKTOK_DESCRIPTION]:
    "Escolha os produtos que você quer promover neste anúncio.",
  [SEARCH_PRODUCT_PLACEHOLDER]: "Buscar products",
  [IS_CATALOG_CAMPAIGN_PLACEHOLDER]: "Campanha de Catálogo",
  [BRAND_PLACEHOLDER]: "Marca",
  [RETAILER_ID_PLACEHOLDER]: "ID da loja",
  [SHORT_DESCRIPTION_PLACEHOLDER]: "Descrição curta",
  [CURRENT_PRICE_PLACEHOLDER]: "Atual price",
  [UNIT_PRICE_PLACEHOLDER]: "Preço unitário",
  [CUSTOM_LABEL_NUMBER_PLACEHOLDER]: "Rótulo personalizado {{value}}",
  [CUSTOM_NUMBER_PLACEHOLDER]: "Número personalizado {{value}}",
  [URL_PLACEHOLDER]: "URL",
  [CREATIVE_FROM_PLACEHOLDER]: "Criativo de",
  [EDIT_CREATIVE_TOOLS_PLACEHOLDER]: "Editar Creative Tools",
  [OVERLAY_TYPE_PLACEHOLDER]: "Tipo de sobreposição",
  [OVERLAY_POSITION_PLACEHOLDER]: "Posição da sobreposição",
  [OVERLAY_SHAPE_PLACEHOLDER]: "Forma da sobreposição",
  [OVERLAY_COLOR_PLACEHOLDER]: "Cor da sobreposição",
  [OVERLAY_OPACITY_PLACEHOLDER]: "Opacidade da sobreposição",
  [OVERLAY_FONT_PLACEHOLDER]: "Fonte da sobreposição",
  [PRICE_LABEL_PLACEHOLDER]: "Preço",
  [AUTO_SHOW_LABEL_PLACEHOLDER]: "Mostrar etiqueta automaticamente",
  [LABEL_TEXT_PLACEHOLDER]: "Texto da etiqueta",
  [STRIKETHROUGH_PRICE_PLACEHOLDER]: "Preço riscado",
  [PERCENTAGE_OFF_PLACEHOLDER]: "Percentual de desconto",
  [FREE_SHIPPING_PLACEHOLDER]: "Envío grátis",
  [OVERLAY_TEXT_COLOR_PLACEHOLDER]: "Color do texto",
  [OVERLAY_TEXT_FONT_PLACEHOLDER]: "Fuente do texto",
  [ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT]:
    "Mostrar a etiqueta apenas quando for provável aumentar o engajamento.",
  [APP_PLACEHOLDER]: "App",
  [ANDROID_DEEP_LINK_PLACEHOLDER]: "Link Profundo de Android",
  [IOS_DEEP_LINK_PLACEHOLDER]: "Link Profundo de iOS",
  [INSTANT_EXPERIENCE_PLACEHOLDER]: "Experiência instantânea",
  [DEEP_DESTINATION_APP_URL_PLACEHOLDER]: "Link Profundo da App",
  [CUSTOM_STORE_LISTING_ID_PLACEHOLDER]: "ID da listagem personalizada da loja",
  [CUSTOM_PRODUCT_PAGE_ID_PLACEHOLDER]:
    "ID da Página de Producto Personalizada",
  [IOS_14_CAMPAIGN_PLACEHOLDER]:
    "Dirigirse a dispositivos iOS 14 e superiores (Recomendado)",
  [UTM_PARAMETERS_PLACEHOLDER]: "Parâmetros UTM",
  [MERCHANT_CENTER_ID_PLACEHOLDER]: "ID do Merchant Center",
  [PRODUCTS_TO_PROMOTE_PLACEHOLDER]: "Produtos a promover",
  [ADS_SCHEDULE_PLACEHOLDER]: "Exibir anúncios em um horário",
  [ADS_SCHEDULE_ALWAYS_ON]: "Sempre ativo",
  [TIMEZONE_PLACEHOLDER]: "Fuso horário",
  [AD_SCHEDULE_PLACEHOLDER]: "Programação de anúncios",
  [SEARCH_BY_NAME_PLACEHOLDER]: "Buscar por nome",
  [PLACEMENTS_PLACEHOLDER]: "Posicionamentos",
  [DEVICES_PLACEHOLDER]: "Dispositivos",
  [CREATIVE_SOURCE_PLACEHOLDER]: "Fuente do Creativo",
  [MANUAL_UPLOAD_PLACEHOLDER]: "Manual Enviar",
  [FROM_CATALOG]: "Do catálogo",
  [MANUAL_UPLOAD]: "Envio manual",
  [PUBLICATION_DESCRIPTION]: "Descrição da publicação",
  [ADVANTAGE_CATALOG_PLACEHOLDER]: "Catálogo Advantage",
  [DESTINATION_DEEP_LINK_CONFIGURATION_PLACEHOLDER]:
    "Configuração de destino de link profundo",
  [COVER_CONTENT_PLACEHOLDER]: "Conteúdo da portada",
  [SEARCH_PLACEHOLDER]: "Buscar",
  [OFFLINE_EVENTS_PLACEHOLDER]: "Eventos offline",
  [SIZE_FOR_DISPLAY_PLACEHOLDER]: "Tamanho para Display",
  [SIZE_FOR_SEARCH_PLACEHOLDER]: "Tamanho para pesquisa",
  [SIZE_PLACEHOLDER]: "Tamanho",
  [MAXIMUM_COST_PER_CLICK_PLACEHOLDER]: "Custo máximo por clique",
  [TARGET_CPA_PLACEHOLDER]: "CPA desejado",
  [BID_CONTROL_PLACEHOLDER]: "Controle de lance",
  [HIGHEST_VOLUME_PLACEHOLDER]: "Maior volume",
  [TARGET_ROAS_PLACEHOLDER]: "ROAS desejado",
  [BIDDING_STRATEGY_TYPE_PLACEHOLDER]: "Tipo de estratégia de lances",
  [ADVERTISERS_AVAILABLE_PLACEHOLDER]: "Marcas às quais você tem acesso",
  [BUYING_TYPE_PLACEHOLDER]: "Tipo de compra",
  [SEARCH_SPECIFIC_LOCATION_PLACEHOLDER]: "Buscar a specific location",
  [LANGUAGES_PLACEHOLDER]: "Idiomas",
  [FREQUENCY_CONTROL_PLACEHOLDER]: "Controle de frequência",
  [FILTER_BY_USERS_PLACEHOLDER]: "Filtrar por Usuário",
  [FILTER_BY_DATES_PLACEHOLDER]: "Filtrar por datas",
  [TRACKING_OFFLINE_EVENTS_PLACEHOLDER]: "Eventos offline",
  [PRESETS_DATE_PLACEHOLDER]: "Intervalos predefinidos",
  [ASPECT_RATIO_PLACEHOLDER]: "Dimensões",
  [DATE_RANGE_PRESET_CUSTOM]: "Personalizado",
  [MIN_DAILY_BUDGET_PLACEHOLDER]: "Minimum Diário Spend",
  [MAX_DAILY_BUDGET_PLACEHOLDER]: "Maximum Diário Spend",
  [MIN_TOTAL_BUDGET_PLACEHOLDER]: "Gasto total mínimo",
  [MAX_TOTAL_BUDGET_PLACEHOLDER]: "Gasto total máximo",
  [DARK_POST_PLACEHOLDER]: "Modo Solo Anúncios",
  [DARK_POST_DESCRIPTION_PLACEHOLDER]:
    "Se você ativar esta opção, seus anúncios aparecerão apenas como anúncios e não no seu perfil do TikTok. Se desativar, também serão publicados como um post no seu perfil.",

  [IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER]: "Ativar Audiência Advantage+",
  [IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER]:
    "Permite que a Meta amplie sua segmentação automaticamente para públicos que potencialmente convertam.",

  //EXAMPLES
  [ADS_CAMPAIGN_CONTEXT_EXAMPLE]:
    "Escreva um parágrafo detalhando o produto ou serviço que quer promover, a qual público-alvo deseja chegar e qual objetivo deseja alcançar com sua campanha",
  [ADS_CAMPAIGN_LOCATION_EXAMPLE]:
    "Escreva um prompt e pressione enter (ex.: “principais cidades dos Estados Unidos”) ou busque um lugar",
  [SEARCH_SPECIFIC_LOCATION_EXAMPLE]:
    "Buscar por nome ou coordenadas (no formato: latitude, longitude)",
  [SOCIAL_NETWORK_EXAMPLE]: "https://www.instagram.com/suamarca",

  /*OPTIONS SELECT*/
  [PLAN_PAY_PER_USE]: "Assinatura paga por uso",
  [PLAN_PACKAGE]: "Licença de pacote",
  [PLAN_REGULAR]: "Planos regulares (Basic e Pro)",
  [PLAN_ENTERPRISE]: "Enterprise",
  [ADD_NEW_OPTION]: `Adicionar "{{value}}"`,
  [RECURRENT_OPTION]: "Recorrente",
  [RECURRING_DAYS]: "Cada dia",
  [RECURRING_WEEKS]: "Toda semana",
  [RECURRING_MONTHS]: "Todo mês",
  [RECURRING_YEARS]: "Todo ano",
  [ASPECT_RATIO_9_16]: "Vertical (9:16)",
  [ASPECT_RATIO_16_9]: "Horizontal (16:9)",
  [ASPECT_RATIO_1_1]: "Quadrado (1:1)",
  [ASPECT_RATIO_4_5]: "Instagram Feed (4:5)",

  /*PLANS*/
  [PLAN_PAY_PER_USE_NAME]: "Plano pago por uso",
  [PLAN_PACKAGE_NAME]: "Plano {{value}}",

  /* FIELDS VALIDATIONS */
  [FIELD_REQUIRED]: "Este campo é obrigatório",
  [FIELD_MUST_BE_SELECT_AT_LEAST_PRODUCTS]:
    "Você deve selecionar pelo menos {{value}} produtos",
  [FIELDS_REQUIRED]: "Todos os campos são obrigatórios",
  [FIELD_NUMERIC]: "Este campo deve ser numérico",
  [FIELD_TEXT]: "Este campo deve conter apenas letras",
  [FIELD_ALPHANUMERIC]: "O campo deve ter apenas letras e números",
  [FIELD_MIN_LENGTH]: "Mínimo de {{value}} caracteres",
  [FIELD_MAX_LENGTH]: "Máximo de {{value}} caracteres",
  [FIELD_MAX_LENGTH_SHORT]: "Máximo de {{value}} caracteres",
  [FIELD_FILE_VALID_REQUIRED]:
    "Você deve selecionar um arquivo em algum destes formatos: {{value}}",
  [FIELD_FILE_MAX_SIZE]:
    "O arquivo é muito grande. Selecione um com tamanho menor que {{value}}{{type}}",
  [FIELD_MEDIA_FILE_MIN_DIMENSIONS]:
    "O conteúdo selecionado tem baixa resolução. Selecione um conteúdo com pelo menos {{width}}px de largura e {{height}}px de altura",
  [FIELD_IMAGE_REQUIRED]:
    "Você deve selecionar uma imagem em um formato válido",
  [FIELD_IMAGE_FORMAT_VALID]:
    "A imagem é muito grande. Selecione uma com tamanho menor que {{value}}{{type}}",
  [FIELD_IMAGE_SIZE_VALID]: "Nenhuma imagem foi selecionada",
  [FIELD_FILE_REQUIRED]:
    "O arquivo é muito grande. Selecione um com tamanho menor que {{value}}{{type}}",
  [FIELD_FILE_SIZE_VALID]: "Nenhum arquivo foi selecionado",
  [FIELD_URL_VALID]: "A URL deve ser válida",
  [FIELD_URL_ADLE_APP_DOMAIN]: "O link deve ser do domínio app.adle.ai",
  [FIELD_URL_VALID_WITH_PROTOCOL]:
    "A URL deve ser válida e conter um protocolo (https:// ou http://)",
  [FIELD_URL_HTTPS_VALID]: "A URL deve incluir https://",
  [FIELD_URL_REPEATED]: "Esta URL já foi adicionada",
  [FIELD_EMAIL_VALID]: "O e-mail deve ser válido",
  [FIELD_EMAIL_REGISTERED]: "O e-mail já está registrado",
  [FIELD_SPACES_VALID]: "O campo não pode conter espaços",
  [FIELD_PHONE_VALID]: "O telefone deve ser válido",
  [FIELD_ALL_REQUIRED]: "Todos os campos são obrigatórios",
  [FIELD_BOTH_PASSWORD_REQUIRED]: "Ambas as senhas são obrigatórias",
  [FIELD_PASSWORDS_NO_MATCH]: "As senhas não coincidem",
  [FIELD_PASSWORD_MIN_LENGTH]: "A senha deve ter pelo menos 6 caracteres",
  [FIELD_PASSWORD_CHANGE_MIN_LENGTH]:
    "Se você for alterar a senha, ela deve ter pelo menos 6 caracteres",
  [FIELD_PASSWORD_INSECURE]:
    "A senha deve ter pelo menos 6 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial",
  [FIELD_NUMBER_NEGATIVE]: "O número não pode ser negativo",
  [FIELD_IS_DYNAMIC_CREATIVE_ONLY_ONE_AD]:
    "Com criativos dinâmicos, só é permitido 1 anúncio no conjunto de anúncios.",
  [FIELD_SCHEDULE_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE]:
    "Com orçamento de campanha, se algum grupo de anúncios tiver a programação de anúncios configurada, todos devem tê-la configurada. Configure-a também neste grupo.",
  [FIELD_BID_GOAL_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE]:
    "Com orçamento de campanha, se algum grupo de anúncios tiver um objetivo de lance definido, todos devem tê-lo. Configure-o também neste grupo.",
  [FIELD_EMAIL_REQUIRED]: "O e-mail é obrigatório",
  [FIELD_SEARCH_CHATS_MORE_3_CHARACTERS]:
    "Digite mais de 3 caracteres para buscar novos chats",
  [FIELD_NUMBER_0_OR_NEGATIVE]: "O número não pode ser 0 ou negativo",
  [FIELD_NUMBER_100_GREATER]: "O número não pode ser maior que 100",
  [FIELD_NUMBER_LESS_THAN]: "O número não pode ser menor que {{value}}",
  [FIELD_NUMBER_GREATER_THAN]: "O número não pode ser maior que {{value}}",
  [FIELD_CREDITS_NOT_BE_NEGATIVE]: `Os {{NAME_BUSINESS}} Credits não podem ser negativos`,
  [FIELD_COST_COLLABORATION_NOT_BE_NEGATIVE]:
    "O custo da colaboração não pode ser negativo",
  [FIELD_TRIAL_MONTHS_NOT_BE_NEGATIVE]:
    "Os meses de teste não podem ser negativos",
  [FIELD_TRIAL_DAYS_NOT_BE_NEGATIVE]:
    "Os dias de teste não podem ser negativos",
  [FIELD_PLAN_PRICES_NOT_BE_NEGATIVE]:
    "Os preços dos planos não podem ser negativos",
  [FIELD_STAFF_IS_REQUIRED]: "Você deve selecionar um membro da equipe",
  [FIELD_BOTH_DATES_REQUIRED]: "Ambas as datas são obrigatórias",
  [FIELD_START_DATE_GREATER_THAN_END_DATE]:
    "A data inicial não pode ser posterior à data final",
  [FIELD_END_DATE_GREATER_NOW]:
    "A data de término não pode ser anterior à data atual",
  [FIELD_START_DATE_LESS_THAN_NOW]:
    "A data de início não pode ser anterior à data atual",
  [FIELD_END_DATE_LESS_THAN_NOW]:
    "A data de término não pode ser anterior à data atual",
  [FIELD_DATE_IN_PAST]: "A data não pode ser no passado",
  [FIELD_DATE_AT_LEAST_FIFTEEN_MINUTES_FUTURE]:
    "A data deve ser pelo menos 15 minutos no futuro",
  [FIELD_DATE_AT_LEAST_FIVE_MINUTES_FUTURE]:
    "A data deve ser pelo menos 5 minutos no futuro",
  [FIELD_MIN_AMOUNT_PAY]:
    "O valor a pagar não pode ser menor que {{value,currency}}",
  [FIELD_ACCESS_TOKEN_SHOPIFY_VALID]:
    "O token de acesso da Shopify não está no formato correto. Geralmente começa com shpat_ seguido de caracteres aleatórios",
  [FIELD_NAME_REQUIRED]: "O nome é obrigatório",
  [FIELD_OBJECTIVE_REQUIRED]: "O objetivo é obrigatório",
  [FIELD_PLATFORMS_REQUIRED]: "As plataformas são obrigatórias",
  [FIELD_PLATFORM_REQUIRED]: "A plataforma é obrigatória",
  [FIELD_TYPE_BUDGET_REQUIRED]: "O tipo de orçamento é obrigatório",
  [FIELD_BUDGET_REQUIRED]: "O orçamento é obrigatório",
  [FIELD_CURRENCY_MIN_VALUE]:
    "O valor não pode ser menor que {{value,currency}}",
  [FIELD_LOCATIONS_REQUIRED]: "Locais são obrigatórios",
  [FIELD_GENDERS_REQUIRED]: "Os gêneros são obrigatórios",
  [FIELD_INTERESTS_REQUIRED]: "Os interesses são obrigatórios",
  [FIELD_BEHAVIORS_REQUIRED]: "Os comportamentos são obrigatórios",
  [FIELD_DESCRIPTION_REQUIRED]: "A descrição é obrigatória",
  [FIELD_VIDEO_REQUIRED]: "O vídeo é obrigatório",
  [FIELD_CREATIVE_MUST_BE_VIDEO_NOT_IMAGE]:
    "O criativo deve ser um vídeo, não uma imagem",
  [FIELD_META_TRACKING_ID_REQUIRED]: "O pixel da Meta é obrigatório",
  [FIELD_DESTINATION_URL_REQUIRED]: "A URL de destino é obrigatória",
  [FIELD_WEBSITE_URL_REQUIRED]: "A URL do site é obrigatória",
  [FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL_REQUIRED]:
    "A URL de destino não está configurada nos pixels selecionados",
  [FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL]:
    "A URL de destino não está configurada com o pixel selecionado. Se você continuar, algumas estatísticas podem não ser registradas",
  [FIELD_TIKTOK_TRACKING_ID_REQUIRED]: "O pixel do TikTok é obrigatório",
  [FIELD_MIN_LENGTH_SELECT]: "Você deve selecionar pelo menos {{value}} opções",
  [FIELD_MAX_LENGTH_SELECT]: "Você deve selecionar no máximo {{value}} opções",
  [FIELD_CONTENT_REQUIRED]: "O conteúdo é obrigatório",
  [FIELD_START_AND_END_DATES_REQUIRED]:
    "As datas de início e fim são obrigatórias",
  [FIELD_LANGUAGE_REQUIRED]: "O idioma é obrigatório",
  [FIELD_CALL_TO_ACTION_VALID_BY_OBJECTIVE]:
    "Selecione um call to action válido para este objetivo",
  [FIELD_TRACKING_IDS_REQUIRED]: "Os pixels são obrigatórios",
  [FIELD_AD_ACCOUNTS_REQUIRED]: "Contas de anúncios são obrigatórias",
  [FIELD_CONTENT_IS_BEING_PROCESSED]: "O conteúdo está sendo processado",
  [FIELD_MIN_TOTAL_BUDGET_ONE_DOLLAR]:
    "O orçamento não pode ser menor que {{value,number}} {{currency}}",
  [FIELD_MIN_DAILY_BUDGET]:
    "O orçamento diário não pode ser menor que {{value,number}} {{currency}}",
  [FIELD_MIN_BUDGET]:
    "O orçamento não pode ser menor que {{value,number}} {{currency}}",
  [FIELD_URL_INSTAGRAM]: "A URL deve ser do Instagram",
  [FIELD_MIN_CONTENT]: "Você deve selecionar ao menos {{value}} conteúdos",
  [FIELD_MAX_CONTENT]: "Você deve selecionar máximo {{value}} conteúdos",
  [FIELD_TRAFFIC_URL_NOT_BE_LINK_FACEBOOK]:
    "A URL para onde você quer levar o tráfego não pode ser do Facebook",
  [FIELD_TRAFFIC_URL_NOT_BE_LINK_INSTAGRAM]: `Para levar o tráfego ao Instagram, escolha "Tráfego" como objetivo da campanha e "Perfil do Instagram" como local de conversão`,
  [FIELD_TRAFFIC_URL_NOT_BE_LINK_WHATSAPP]:
    "A URL para onde você quer levar o tráfego não pode ser do WhatsApp",
  [FIELD_AD_FORMAT_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar um formato para gerar a pré-visualização do anúncio",
  [FIELD_CALL_TO_ACTION_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar um call to action para gerar a pré-visualização do anúncio",
  [FIELD_PAGE_ID_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar uma página do Facebook na configuração para gerar a pré-visualização do anúncio",
  [FIELD_SPONSOR_PAGE_ID_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar a página do Facebook do patrocinador do anúncio em colaboração para gerar a pré-visualização do anúncio",
  [FIELD_INSTAGRAM_ID_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar uma conta do Instagram na configuração para gerar a pré-visualização do anúncio",
  [FIELD_APP_ID_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar um aplicativo no grupo de anúncios para gerar a pré-visualização do anúncio",
  [FIELD_IDENTITY_TIK_TOK_ID_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar uma identidade do TikTok na configuração para gerar a pré-visualização do anúncio",
  [FIELD_POST_ID_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar um post do Facebook ou do Instagram para gerar a pré-visualização do anúncio",
  [FIELD_ADDRESS_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar um endereço para gerar a pré-visualização do anúncio",
  [FIELD_MIN_CARDS_AD_CAROUSEL]:
    "Você deve criar pelo menos {{value}} cartões para usar um anúncio de carrossel",
  [FIELD_TEXT_ONLY_HAS_LETTERS_NUMBERS_DOTS_COMMAS]:
    "O texto deve ter apenas letras, números, pontos e vírgulas",
  [FIELD_TEXT_REPEATED]: "O texto não pode ser repetido",
  [FIELD_IMAGES_REPEATED]: "Não é permitido usar imagens duplicadas",
  [FIELD_VIDEOS_REPEATED]: "Não é permitido usar vídeos duplicados",
  [FIELD_KEYWORDS_REPEATED]: "Há palavras-chave repetidas: {{value}}",
  [FIELD_KEYWORDS_MAX_LENGTH]:
    "Estas palavras-chave excedem o máximo de {{value}} caracteres: {{keywords}}",
  [FIELD_TWO_CARDS_REQUIRED_FOR_GENERATE_PREVIEW]:
    "Você deve criar pelo menos dois cartões para gerar a pré-visualização",
  [FIELD_KEYWORDS_AND_KEYWORDS_NEGATIVE_REPEATED]:
    "Há palavras-chave repetidas entre as palavras-chave e as palavras-chave negativas: {{value}}",
  [FIELD_CAMPAIGN_MUST_HAVE_ONE_DAY_ACTIVE]:
    "A campanha deve ficar ativa por pelo menos um dia",
  [FIELD_THIS_KEYWORD_ALREADY_EXIST_IN_YOUR_LIST]:
    "Esta palavra-chave já existe na sua lista",
  [FIELD_MEDIA_URL_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar um conteúdo para o seu anúncio",
  [FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_DRAFT]:
    "Depois que o anúncio for criado, você não poderá alterar o conteúdo",
  [FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_CREATED]:
    "Para alterar o conteúdo, você deve criar um novo anúncio",
  [META_AD_PREVIEW_AD_BLOCKER_NOTICE]:
    "Se a pré-visualização não aparecer ou não renderizar bem, verifique se você tem um bloqueador de anúncios ativo e desative-o para esta página.",
  [FIELD_START_DATE_REQUIRED]: "A data de início é obrigatória",
  [FIELD_VIDEO_YOUTUBE_URL_INVALID]:
    "A URL de um vídeo do YouTube deve estar no formato https://www.youtube.com/watch?v=XXXXXXXX ou https://www.youtube.com/shorts/XXXXXXXX",
  [FIELD_MAX_IMAGES_VALID]: "Você deve selecionar no máximo {{value}} imagens",
  [FIELD_MAX_VIDEOS_YOUTUBE_VALID]:
    "Você deve inserir no máximo {{value}} vídeos",
  [FIELD_YOUTUBE_VIDEO_NOT_PUBLIC]: "Este vídeo do YouTube não é público",
  [FIELD_YOUTUBE_VIDEO_DURATION_INVALID]:
    "Este vídeo do YouTube não cumpre a duração exigida",
  [FIELD_YOUTUBE_VIDEO_NOT_PUBLIC_AND_DURATION_INVALID]:
    "Este vídeo do YouTube não é público e não cumpre a duração exigida",
  [FIELD_MIN_TEXTS_VALID]: "Você deve inserir pelo menos {{value}} textos",
  [FIELD_MAX_TEXTS_VALID]: "Você deve inserir no máximo {{value}} textos",
  [FIELD_TITLES_REQUIRED_AD_PREVIEW]: "Títulos vazios não são permitidos",
  [FIELD_TITLES_REQUIRED_AD_PREVIEW_TIKTOK]:
    "O título é obrigatório e deve ter entre 1 e 100 caracteres.",
  [FIELD_HEADLINES_REQUIRED_AD_PREVIEW]: "Manchetes vazias não são permitidas",
  [FIELD_DESCRIPTIONS_REQUIRED_AD_PREVIEW]:
    "Descrições vazias não são permitidas",
  [FIELD_INSTANT_EXPERIENCE_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar uma experiência instantânea para gerar a pré-visualização do anúncio",
  [FIELD_PRODUCT_SET_ID_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar um conjunto de produtos para gerar a pré-visualização do anúncio",
  [FIELD_ALMOST_ONE_INCLUSION_OR_EXCLUSION]:
    "Você deve selecionar pelo menos uma inclusão ou uma exclusão",
  [FIELD_CONTENT_INTRO_CARD_IS_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar um conteúdo no cartão de introdução para gerar a pré-visualização do anúncio",
  [FIELD_META_PLACEMENT_FACEBOOK_PROFILE_FEED_REQUIRED]:
    "Facebook profile feed exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_MARKETPLACE_REQUIRED]:
    "Facebook Marketplace exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_MESSENGER_INBOX_REQUIRED]:
    "Messenger inbox exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_NOTIFICATIONS_REQUIRED]:
    "Facebook Notifications exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_STORIES_REQUIRED]:
    "Facebook Stories exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_AUDIENCE_NETWORK_NATIVE_BANNER_INTERSTITIAL_REQUIRED]:
    "Audience Network native, banner e interstitial exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_AUDIENCE_NETWORK_REWARDED_VIDEOS_REQUIRED]:
    "Audience Network rewarded videos exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_ADS_ON_FACEBOOK_REELS_REQUIRED]:
    "Ads on Facebook Reels exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_INSTREAM_VIDEOS_REQUIRED]:
    "Facebook in-stream videos exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_FACEBOOK_SEARCH_RESULTS_REQUIRED]:
    "Facebook search results exige que Facebook Feed esteja selecionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_STORIES_REQUIRED]:
    "Facebook Stories exige que Instagram Stories esteja selecionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_FEED_REQUIRED]:
    "Instagram profile feed exige que Instagram feed esteja selecionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_SEARCH_RESULTS_REQUIRED]:
    "Instagram search results exige que Instagram feed esteja selecionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_REQUIRED]:
    "Instagram Explore exige que Instagram feed esteja selecionado.",
  [FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_HOME_REQUIRED]:
    "Instagram Explore home exige que tanto Instagram feed quanto Instagram Explore estejam selecionados.",
  [FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_REELS_REQUIRED]:
    "Instagram profile reels exige que Instagram Reels esteja selecionado.",
  [FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar uma URL de destino para gerar a pré-visualização do anúncio",
  [FIELD_DESTINATION_URL_IN_YOUR_CAROUSEL_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar uma URL de destino em cada cartão do seu carrossel para gerar a pré-visualização do anúncio",
  [FIELD_IMAGES_MIN_REQUIRED]:
    "Você deve selecionar pelo menos {{value}} imagens",
  [FIELD_ESTIMATION_ID_REQUIRED]:
    "Você deve aguardar a geração da estimativa antes de reservá-la",
  [FIELD_ESTIMATION_BUDGET_REQUIRED]:
    "Você deve inserir um orçamento para gerar a estimativa",
  [FIELD_ESTIMATION_START_END_DATE_REQUIRED]:
    "Você deve selecionar as datas de início e fim para gerar a estimativa",
  [FIELD_ESTIMATION_FREQUENCY_REQUIRED]:
    "Você deve configurar a frequência para gerar a estimativa",
  [FIELD_ESTIMATION_LOCATION_REQUIRED]:
    "Você deve selecionar pelo menos uma localização para gerar a estimativa",
  [FIELD_SEARCH_THEMES_MAX_WORDS]:
    "Os seguintes temas de pesquisa têm mais de {{value}} palavras: {{items}}",
  [FIELD_MUSIC_URL_REQUIRED_AD_PREVIEW]:
    "Você deve selecionar uma música para o seu anúncio",
  [FIELD_CONSECUTIVE_UPPERCASE]:
    "Não são permitidas {{value}} letras maiúsculas consecutivas",
  [FIELD_EMOJI_NOT_ALLOWED]: "Emojis não são permitidos",

  [REQUEST_REJECT_CONFIRMATION_DESCRIPTION]:
    "Deseja marcar este conteúdo como rejeitado e fechar o relatório?",
  [REQUEST_APPROVE_CONFIRMATION_DESCRIPTION]:
    "Deseja aprovar este relatório e reembolsar os créditos ao anunciante?",
  [REQUEST_REJECTED]: "Solicitação rejeitada",
  [REQUEST_REJECTED_DESCRIPTION]:
    "A solicitação do criador de conteúdo {{influencerName}} foi rejeitada corretamente",
  [REPORTED_CONTENT_STATUS_REJECTED]: "Rejeitado",
  [REPORTED_CONTENT_STATUS_PENDING]: "Pendente",
  [REPORTED_CONTENT_STATUS_APPROVED]: "Aprovado",
  [LIST_OF_CREATORS]: "Lista de criadores",

  /*MODAL COMMERCIAL*/
  [MODAL_COMMERCIAL_TITLE_CREATE]: "Criar comercial",
  [MODAL_COMMERCIAL_TITLE_EDIT]: "Editar commercial {{value}}",
  [MODAL_COMMERCIAL_CREATE_COMMERCIAL]: "Criar comercial",
  [MODAL_COMMERCIAL_ALREADY_EXIST]: "Já existe um comercial com este nome",

  /*MODAL CREATE PAYMENT LINK*/
  [MODAL_CREATE_PAYMENT_LINK_TITLE]: "Criar link de pagamento",
  [MODAL_CREATE_PAYMENT_LINK_DESCRIPTION]:
    "Crie um link de pagamento para esta marca. Isso criará uma assinatura empresarial.",
  [MODAL_CREATE_PAYMENT_LINK_ARIA_LABEL]: "Modal para criar link de pagamento",
  [MODAL_CREATE_PAYMENT_LINK_LINKS]: "Links de pagamento",
  [MODAL_CREATE_PAYMENT_LINK_LINKS_EMPTY]:
    "Não há links de pagamento disponíveis",
  [MODAL_CREATE_PAYMENT_LINK_NAME]: "Pagamento {{value}}",

  /*MODAL HELP VIDEO AND FAQ*/
  [WARNING_MOBILE_TUTORIAL]:
    "Para uma melhor experiência, faça o tutorial no seu computador ou notebook.",
  [FAQ_DESCRIPTION]:
    "Aqui você encontra as perguntas mais frequentes dos nossos usuários. Você pode buscá-las por palavras-chave ou frases.",
  [FAQ_QUESTION_WHAT_IS_BUZZLY]: `O que é {{NAME_BUSINESS}}?`,
  [FAQ_QUESTION_WHAT_IS_BUZZLY_DESCRIPTION]: `{{NAME_BUSINESS}} é a primeira plataforma que permite que pequenos negócios ofereçam produtos gratuitos ou com desconto a criadores de conteúdo em troca de exposição nas redes sociais. Ao mesmo tempo, os criadores podem acessar uma grande variedade de produtos e serviços diretamente das suas marcas favoritas pelo nosso app.`,
  [FAQ_QUESTION_WHAT_IS_REQUEST]: "O que é uma solicitação?",
  [FAQ_QUESTION_WHAT_IS_REQUEST_DESCRIPTION]:
    "Uma solicitação é um pedido feito por um criador de conteúdo para que você envie um convite de colaboração com a sua marca.",
  [FAQ_QUESTION_WHAT_IS_PUBLICATION]: "O que é uma publicação?",
  [FAQ_QUESTION_WHAT_IS_PUBLICATION_DESCRIPTION]: `Uma publicação é a colaboração gerada quando o criador de conteúdo resgata um convite na sua loja. Uma publicação pode ter os seguintes status: <br><br>\n  <strong>Publicação pendente:</strong> O criador resgatou o convite, mas ainda não publicou nada nas redes sociais.<br>\n  <strong>Análise pendente:</strong> O criador já publicou o conteúdo da marca nas redes sociais e fez o upload, mas as análises ainda não estão disponíveis.<br>\n  <strong>Verificar:</strong> O criador enviou as análises e você já pode revisar os resultados da colaboração para avaliá-lo.<br>\n  <strong>Verificada:</strong> Você já avaliou a colaboração com base no conteúdo e nas análises geradas.<br>\n  <strong>Feedback:</strong> O criador teve algum problema com seus produtos ou serviços; nenhuma colaboração é gerada e você pode convidá-lo novamente.<br>\n  `,
  [FAQ_QUESTION_WHAT_IS_CAMPAIGN]: "O que é uma campanha?",
  [FAQ_QUESTION_WHAT_IS_CAMPAIGN_DESCRIPTION]: `Uma campanha é uma forma de colaboração com criadores muito mais estruturada, na qual você pode definir orçamento, objetivo, tipos de conteúdo e características específicas para que os criadores possam se candidatar. Depois que se candidatarem, você pode aceitar ou recusar criadores para a sua campanha.`,
  [FAQ_QUESTION_WHAT_IS_ORDER]: "O que é um pedido?",
  [FAQ_QUESTION_WHAT_IS_ORDER_DESCRIPTION]: `Um pedido é uma solicitação de produtos ou serviços feita por um criador de conteúdo à sua marca via delivery. Um pedido pode ter os seguintes status: <br><br>\n  <strong>A aceitar:</strong> O criador já solicitou os produtos ou serviços, mas você precisa aceitar o pedido e definir um prazo de processamento.<br>\n  <strong>Em processamento:</strong> Você já aceitou o pedido e está preparando os produtos ou serviços para enviar ao criador quando estiver pronto, informando os dados de envio.<br>\n  <strong>Para entregar:</strong> Você já enviou os produtos ou serviços ao criador e falta apenas a entrega final.<br>\n  `,
  [FAQ_QUESTION_WHAT_IS_STORE]: "O que é uma loja?",
  [FAQ_QUESTION_WHAT_IS_STORE_DESCRIPTION]:
    "Uma loja é uma unidade física onde os criadores de conteúdo podem resgatar os convites que você envia para obter produtos ou serviços da sua marca e gerar conteúdo nas suas instalações.",
  [FAQ_QUESTION_WHAT_ROLES_EXISTS]: "Quais funções existem?",
  [FAQ_QUESTION_WHAT_ROLES_EXISTS_DESCRIPTION]: `Você pode criar diferentes usuários para acessar o painel da sua marca. Existem duas funções: <br><br>\n  <strong>Administrador:</strong> Pode gerenciar convites para criadores, solicitações, embaixadores, pedidos, campanhas etc. Também pode editar as informações da marca e criar mais usuários.<br>\n  <strong>Operador:</strong> Recebe o criador quando ele visita uma das suas lojas, pode resgatar o código, gerenciar pedidos nos três status e visualizar o menu.<br>\n  `,
  [FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS]:
    "Entreguei os produtos. Preciso fazer algo adicional na plataforma?",
  [FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS_DESCRIPTION]: `Não, você não precisa fazer nada adicional. Basta inserir o código na seção "Resgatar código", verificar o valor do convite e entregar os produtos.<br><br>\n    \n  <strong>1.</strong> Selecione a loja no canto superior direito.<br>\n  <strong>2.</strong> Digite o código fornecido pelo criador de conteúdo quando ele chegar à loja.<br>\n  <strong>3.</strong> Valide o código e o respectivo valor.`,
  [FAQ_QUESTION_MUST_CALL_ADMIN]:
    "Preciso ligar para o proprietário do negócio para verificar os convites?",
  [FAQ_QUESTION_MUST_CALL_ADMIN_DESCRIPTION]:
    "Não é necessário entrar em contato. Se, ao digitar o código, a plataforma o aceitar, isso significa que o proprietário do negócio, seu gestor direto ou o administrador já enviou um convite a esse criador de conteúdo e ele foi aprovado.",
  [FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE]:
    "O que acontece se o criador resgatar o código e não usar todo o valor do convite?",
  [FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE_DESCRIPTION]:
    "Depois que o código é resgatado, ele expira automaticamente. Isso significa que o código não funcionará em ocasiões posteriores.",
  [FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS]:
    "Quais são as diferenças entre a modalidade de permuta e as campanhas pagas?",
  [FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS_DESCRIPTION]: `A principal diferença é que, na <strong>modalidade de permuta</strong>, os criadores de conteúdo têm mais liberdade para escolher como produzir o conteúdo, gerando uma colaboração mais orgânica e natural. Já nas <strong>campanhas pagas</strong>, as marcas podem definir regras mais rígidas sobre como o conteúdo deve ser feito, e o criador precisa seguir essas diretrizes para que o conteúdo seja aprovado.`,
  [FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS]:
    "Como posso garantir que os criadores entendam e aceitem os termos da permuta?",
  [FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS_DESCRIPTION]: `Para garantir que os criadores compreendam e aceitem os termos da permuta, você pode:<br><br>\n    <strong>1.</strong> Revisar o perfil e as métricas do criador para ver se o conteúdo que ele costuma produzir está alinhado com o que você busca.<br>\n    <strong>2.</strong> Deixar o comentário do convite claro e fácil de entender.<br>\n    <strong>3.</strong> Depois de enviar o convite, enviar uma mensagem ao criador para estabelecer uma comunicação mais direta e esclarecer dúvidas sobre a produção do conteúdo.<br>\n    `,

  /*MODAL BRAND SETUP*/
  [MODAL_BRAND_SETUP_TITLE]:
    "Deseja reconfigurar e atualizar as informações da sua marca?",
  [MODAL_BRAND_SETUP_DESCRIPTION]:
    "Os seguintes usuários serão afetados por esta alteração:",
  [BRAND_SETUP_EXTRACTION_WARNING_MESSAGE]:
    "Não foi possível extrair alguns dados. Isso acontece porque alguns sites usam mecanismos que bloqueiam o acesso automatizado às informações, então você precisará inserir os dados manualmente.",
  [BRAND_SETUP_LOADING_GETTING_WEBSITE_INFORMATION]:
    "Analisando seu site para entender sua marca...",
  [BRAND_SETUP_LOADING_ANALYZING_BRAND]:
    "Analisando tom, proposta de valor e elementos-chave da sua marca...",
  [BRAND_SETUP_LOADING_GENERATING_BRAND_PROFILE]:
    "Construindo o perfil da sua marca...",
  [BRAND_SETUP_LOADING_FINALIZING_DETAILS]:
    "Organizando tudo para concluir a configuração da marca...",
  [BRAND_SETUP_GENERATION_PROMPT_LABEL]: "Foco ou contexto extra (opcional)",
  [BRAND_SETUP_GENERATION_PROMPT_PLACEHOLDER]:
    "Exemplo: foque no teste de 14 dias, fale com donos de lojas e evite claims de desconto",
  [BRAND_SETUP_GENERATION_ATTACH_PDF]: "Anexar um PDF",
  [BRAND_SETUP_GENERATION_PDF_HINT]:
    "Opcional. Um PDF, até 20 MB. É analisado junto com seu site e suas notas.",
  [BRAND_SETUP_GENERATION_REMOVE_PDF]: "Remover {{name}}",
  [BRAND_SETUP_GENERATION_PDF_INVALID]: "Use um arquivo PDF.",
  [BRAND_SETUP_GENERATION_PDF_TOO_LARGE]:
    "O PDF deve ter {{maxMb}} MB ou menos.",
  [BRAND_SETUP_GENERATION_SHOW_ADVANCED]: "Adicionar um PDF ou contexto extra",
  [BRAND_SETUP_GENERATION_HIDE_ADVANCED]: "Ocultar PDF e contexto extra",
  [BRAND_SETUP_VERSION_CURRENT]: "Atual",
  [BRAND_SETUP_VERSION_LABEL]:
    "V{{versionNumber}} - {{date, MM/dd/yyyy HH:mm}}",
  [BRAND_SETUP_VERSION_PLACEHOLDER]: "Versão",
  [BRAND_SETUP_GROUP_VISUAL_IDENTITY_TITLE]: "Identidade visual",
  [BRAND_SETUP_GROUP_VISUAL_IDENTITY_DESCRIPTION]:
    "Tudo o que define a aparência da sua marca",
  [BRAND_SETUP_GROUP_AUDIENCE_TITLE]: "Audiência e concorrentes",
  [BRAND_SETUP_GROUP_AUDIENCE_DESCRIPTION]:
    "Com quem você fala e em qual contexto",
  [BRAND_SETUP_GROUP_COPY_TITLE]: "Mensagem da marca",
  [BRAND_SETUP_GROUP_COPY_DESCRIPTION]:
    "Como sua marca se comunica e o valor que oferece",
  [BRAND_INSIGHTS_TAB_TITLE]: "Insights",
  [BRAND_INSIGHTS_PAGE_TITLE]: "Insights",
  [BRAND_INSIGHTS_PAGE_DESCRIPTION]:
    "Descubra os aprendizados que a IA identificou a partir dos resultados das suas campanhas. Aplique-os à configuração da sua marca.",
  [BRAND_INSIGHTS_POSITIVE_TITLE]: "Repetir",
  [BRAND_INSIGHTS_NEGATIVE_TITLE]: "Evitar",
  [BRAND_INSIGHTS_POSITIVE_SUBTITLE]:
    "Estratégias que já estão funcionando. Faça mais disso.",
  [BRAND_INSIGHTS_NEGATIVE_SUBTITLE]:
    "Estratégias que não estão funcionando. Evite repeti-las.",
  [BRAND_INSIGHTS_TOPIC_ANGLE]: "Ângulo",
  [BRAND_INSIGHTS_TOPIC_COPY]: "Texto",
  [BRAND_INSIGHTS_TOPIC_CTA]: "CTA",
  [BRAND_INSIGHTS_TOPIC_TONE]: "Tom",
  [BRAND_INSIGHTS_TOPIC_AESTHETIC]: "Estética",
  [BRAND_INSIGHTS_TOPIC_VALUE_PROP]: "Proposta de valor",
  [BRAND_INSIGHTS_EMPTY]: "Ainda não há aprendizados para a sua marca",
  [BRAND_INSIGHTS_REVIEW_CHANGE]: "Revisão",
  [BRAND_INSIGHTS_DISMISS]: "Descartar",
  [BRAND_INSIGHTS_DISMISS_ALERT_TITLE]: "Tem certeza?",
  [BRAND_INSIGHTS_DISMISS_ALERT_DESCRIPTION]:
    "Este aprendizado será descartado e não poderá ser recuperado.",
  [BRAND_INSIGHTS_COUNT]: "{{count}} aprendizados",
  [BRAND_INSIGHTS_UNREAD_ONE]: "1 novo",
  [BRAND_INSIGHTS_UNREAD_OTHER]: "{{count}} novos",
  [BRAND_INSIGHTS_APPLY_TITLE]: "Aplicar alteração",
  [BRAND_INSIGHTS_APPLY_LOADING]:
    "A IA está propondo uma alteração na configuração da sua marca.",
  [BRAND_INSIGHTS_APPLY_CONFIRM]: "Aplicar",
  [BRAND_INSIGHTS_APPLY_CANCEL]: "Cancelar",
  [BRAND_INSIGHTS_APPLY_REJECTED]:
    "Não foi possível propor uma alteração segura na configuração da marca.",
  [BRAND_INSIGHTS_APPLY_ALREADY_IN_CONFIG]:
    "Este insight já está refletido na configuração da sua marca.",
  [BRAND_INSIGHTS_APPLY_UNMAPPABLE]:
    "Este insight não se encaixa em nenhum campo da configuração da sua marca, pois é algo operacional ou de como administrar suas campanhas.",
  [BRAND_INSIGHTS_APPLY_REWRITE]:
    "Não foi possível gerar uma proposta. Tente novamente.",
  [BRAND_INSIGHTS_APPLY_RETRY]:
    "Não foi possível gerar uma proposta. Tente novamente.",
  [BRAND_INSIGHTS_APPLY_TIMEOUT]:
    "A proposta está demorando mais do que o normal. Tente novamente em alguns minutos.",
  [BRAND_INSIGHTS_APPLY_FIELD]: "Campo",
  [BRAND_INSIGHTS_APPLY_RESULT_TITLE]: "Como o campo fica",
  [BRAND_INSIGHTS_APPLY_SHOW_FULL]: "Mostrar texto completo",
  [BRAND_INSIGHTS_APPLY_SHOW_CHANGES]: "Mostrar apenas alterações",
  [BRAND_INSIGHTS_APPLY_NO_CHANGES]:
    "A proposta não altera nada no campo atual.",
  [BRAND_INSIGHTS_APPLY_DIFF_COLLAPSED]: "[…{{count}} palavras sem alteração…]",

  [LIST_CREATORS_WITH_AUDIENCE_SIMILAR]:
    "Lista de criadores com audiências similares",
  [AUDIENCE_INFORMATION]: "Informação da audiência",
  [AUDIENCE_CREDIBILITY]: "Credibilidade da audiência",
  [AUDIENCE_CREDIBILITY_TITLE_EXPLANATION]:
    "O que é a credibilidade da audiência?",
  [AUDIENCE_CREDIBILITY_DESCRIPTION_EXPLANATION]:
    "A credibilidade da audiência é um indicador que determina a porcentagem de seguidores que são perfis reais ou válidos, ou seja, exclui bots ou perfis fraudulentos. Quanto maior a porcentagem, mais confiável será a audiência do criador de conteúdo.",
  [AUDIENCE_BY_COUNTRY]: "Audiência por país",
  [AUDIENCE_BY_CITIES]: "Audiência por cidades",
  [AUDIENCE_BY_BRAND_AFFINITY]: "Marca affinity",
  [AUDIENCE_BY_INTERESTS]: "Interesses",
  [AUDIENCE_BY_DISTRIBUTION_AGE]: "Distribuição de idades e gêneros",
  [AUDIENCE_BY_PERCENTAGE_GENDERS]: "Percentual de gêneros",
  [AUDIENCE_BY_SIMILAR_AUDIENCE]: "Perfis semelhantes",
  [AUDIENCE_BY_SIMILAR_AUDIENCE_NOT_FOUND]: "Não similar profiles found",
  [GALLERY_CONTENT_BUZZLY]: "Portfólio",

  /* LIST MENU */
  [MENU_CONNECTED_ACCOUNTS]: "Conectared accounts",
  [MENU_PLATFORM]: "Permuta",
  [MENU_MEDIA]: "Conteúdo",
  [MENU_SERVICES]: "Ferramentas",
  [MENU_ACTIONS]: "Operações",
  [MENU_CONFIGURATION]: "Configuração",
  [MENU_ADMINISTRATION]: "Administração",
  [SUB_MENU_CREATORS]: "Criadores",
  [SUB_MENU_PUBLICATIONS]: "Colaborações",
  [SUB_MENU_EVENTS]: "Eventos",
  [SUB_MENU_CAMPAIGNS]: "Campanhas",
  [SUB_MENU_ADS_CAMPAIGNS]: "{{NAME_BUSINESS}} Ads",
  [SUB_MENU_REPORTS]: "Relatórios",
  [SUB_MENU_DISCOVERY]: "Explorar",
  [SUB_MENU_SOCIAL_FEED]: "Feed social",
  [SUB_MENU_GALLERY]: "Galeria",
  [SUB_MENU_REDEEM_CODE]: "Resgatar código",
  [SUB_MENU_ORDERS]: "Pedidos",
  [SUB_MENU_ACCOUNT]: "Conta",
  [SUB_MENU_STORES]: "Minhas lojas",
  [SUB_MENU_MENU]: "Catálogo",
  [SUB_MENU_USERS]: "Usuários",
  [SUB_MENU_BILLING_AND_PAYMENTS]: "Faturamento",
  [SUB_MENU_BILLING_DASHBOARD]: "Pagamentos",
  [SUB_MENU_BILLING_DATA]: "Informação",
  [SUB_MENU_USERS_OWNER]: "Usuários",
  [SUB_MENU_BRANDS]: "Marcas",
  [SUB_MENU_BRAND_SIGNUPS]: "Cadastros de marcas",
  [SUB_MENU_CREATORS_OWNER]: "Criadores",
  [SUB_MENU_CREATORS_EXTERNALS]: "Criadores externos",
  [SUB_MENU_PAY_CREATORS]: "Pagamentos a criadores",
  [SUB_MENU_CREATOR_SIGNUPS]: "Cadastro de criadores",
  [SUB_MENU_CONTENTS]: "Conteúdos",
  [SUB_MENU_DELIVERIES]: "Entregas",
  [SUB_MENU_CONTENT_APPLICATION]: "Aplicação de conteúdo",
  [SUB_MENU_REPORTS_OWNER]: "Relatórios",
  [SUB_MENU_FEEDBACK]: "Feedback",
  [SUB_MENU_PAYMENTS_FAILED]: "Pagamentos com falha",

  /* DATE */
  [MONTH_SHORT]: "{{date,monthTextShort}}",
  [DATE_DAY_AND_MONTH_SHORT]: "{{date, day}} {{date,monthTextShort}}",
  [DATE_HOUR]: "{{date, hour}}",
  [DATE_SHORT]: "{{date, day}} de {{date, monthText}} de {{date, year}}",
  [DATE_SHORT_2]: "{{date,monthTextShort}} {{date,dayShort}}, {{date,year}}",
  [DATE_RELATIVE]: "{{date, relative}}",
  [DATE_SHORT_LOCALIZED]: "{{date, short}}",
  [DATE_LONG]: "{{date, day}}/{{date,month}}/{{date,year}} {{date,hour}}",
  [DATE_LONG_TEXT]:
    "{{date,dayText}}, {{date, day}} de {{date,monthText}} de {{date,year}}",
  [DATE_LONG_TEXT_2]:
    "{{date,dayTextLong}}, {{date, day}} de {{date,monthText}} de {{date,year}}",
  [DATE_LONG_TEXT_WITH_HOUR]:
    "{{date,dayText}}, {{date, day}} de {{date,monthText}} de {{date,year}} {{date,hour}}",
  [DATE_LONG_LOCALIZED]: "{{date, long}}",
  [DATE_DISTANCE]: "{{date, ago}}",
  [RENEWED_ON]: "Renovam em: {{date,short}}",
  [EXPIRE_ON]: "Expiram em: {{date,short}}",
  [LAST_UPDATE_DATE]: "Última atualização: {{date, relative}}",
  [LAST_UPDATE_DATE_SHORT]:
    "Atualizado em {{date,monthTextShort}} {{date,dayShort}}, {{date,year}}",
  [PUBLISHED_DATE]: "Publicado: {{date, short}}",

  /* CURRENCY */
  [VALUE_WITH_CURRENCY]: "{{value,number}} {{currency}}",
  [VALUE_WITH_PERCENTAGE]: "{{value, number}}%",
  [NUMBER_CURRENCY]: "{{value, currency}}",
  [VALUE_SUBSCRIPTION_3_DAYS_FREE]: "3 dias grátis",
  [VALUE_SUBSCRIPTION_MONTHLY]: "{{value,number}} {{currency}}/mês",
  [VALUE_SUBSCRIPTION_YEARLY_UNIQUE_PAYMENT]:
    "Pagamento único anual de {{value,number}} {{currency}}",
  [VALUE_SUBSCRIPTION_PRORATED]: "{{value,currency}} agora",
  [VALUE_SUBSCRIPTION_AFTER_PRORATED]:
    "{{value,currency}}/mês a partir de {{date,short}}",
  [VALUE_EXPRESSED_IN]: "Valor expresso em {{currency}}",
  [VALUE_NUMBER]: "{{value,number}}",
  [VALUE_WITH_CURRENCY_MANUAL_FORMAT]: "${{value,number}} {{currency}}",

  /* Buttons */
  [BUTTON_RETRY]: "Tentar novamente",
  [BUTTON_RETRY_PUBLISHING]: "Tentar publicar novamente",
  [BUTTON_INVITE]: "Convidar",
  [BUTTON_VIEW_INVITE]: "Ver convite",
  [BUTTON_EDIT_INVITE]: "Editar convite",
  [BUTTON_CANCEL_INVITE]: "Cancelar convite",
  [BUTTON_VIEW_REQUEST]: "Ver solicitação",
  [BUTTON_START_NOW]: "Começar agora",
  [BUTTON_REJECT_REQUEST]: "Rejeitar solicitação",
  [BUTTON_ORDER_IN_PROCESS]: "Pedido em processo",
  [BUTTON_VIEW_COLLABORATION]: "Ver colaboração",
  [BUTTON_VIEW_METRICS]: "Ver métricas",
  [BUTTON_VIEW_REPORT]: "Ver relatório",
  [BUTTON_INIT_CHAT]: "Enviar mensagem",
  [BUTTON_ADD_REFERENCE_PROFILE]: "Adicionar perfil de referência",
  [BUTTON_USE_AS_REFERENCE_PROFILE]: "Usar como perfil de referência",
  [BUTTON_ADD_AS_REFERENCE]: "Adicionar como referência",
  [BUTTON_ADDED]: "Adicionado",
  [BUTTON_DOWNLOAD]: "Baixar",
  [BUTTON_DOWNLOAD_PDF]: "Baixar PDF",
  [BUTTON_CALCULATE]: "Calcular",
  [BUTTON_ENTERPRISE_CALCULATE]: "Calcular para empresarial",
  [BUTTON_REDEEM_CODE]: "Resgatar",
  [BUTTON_ADD_STORE]: "Adicionar loja",
  [BUTTON_SEARCH]: "Buscar",
  [BUTTON_ACCEPT_ORDER]: "Aceitar pedido",
  [BUTTON_REJECT_ORDER]: "Rejeitar pedido",
  [BUTTON_READY_ORDER]: "Pedido pronto",
  [BUTTON_DELIVER_ORDER]: "Pedido entregue",
  [BUTTON_CANCEL]: "Cancelar",
  [BUTTON_DISCARD]: "Descartar",
  [BUTTON_VIEW]: "Ver",
  [BUTTON_CREATE_CAMPAIGN]: "Criar",
  [BUTTON_CREATE_CAMPAIGN2]: "Criar Campanha",
  [BUTTON_LAUNCH_AD]: "Publicar anúncio",
  [BUTTON_CREATE_CONTENT]: "Criar Conteúdo",
  [BUTTON_SAVE_PROGRESS]: "Salvar progresso",
  [BUTTON_NEXT]: "Próximo",
  [BUTTON_PREVIOUS]: "Anterior",
  [BUTTON_ADVANCED_CONFIGURATION]: "Configuração avançada",
  [BUTTON_FINISH]: "Finalizar",
  [BUTTON_URL]: "URL",
  [BUTTON_UPLOAD]: "Enviar",
  [BUTTON_UPLOAD_FILES]: "Enviar Arquivos",
  [BUTTON_UPLOAD_FOLDER]: "Enviar Pasta",
  [BUTTON_UPLOAD_CONTENT]: "Enviar conteúdo",
  [BUTTON_UPLOAD_DOCUMENT]: "Enviar documento",
  [BUTTON_REMOVE_CONTENT]: "Excluir conteúdo",
  [DELETE_CONTENT_CONFIRMATION_TITLE]: "Excluir Conteúdo",
  [DELETE_CONTENT_CONFIRMATION_DESCRIPTION]:
    "Tem certeza de que deseja excluir este conteúdo? Esta ação é definitiva e você não poderá desfazê-la.",
  [DELETE_SCHEDULED_CONTENT_CONFIRMATION_TITLE]: "Excluir Conteúdo Agendado",
  [DELETE_SCHEDULED_CONTENT_CONFIRMATION_DESCRIPTION]:
    "Tem certeza de que deseja excluir este conteúdo agendado? Se continuar, ele será removido do calendário e a publicação programada não será realizada.",
  [DELETE_SCHEDULED_CONTENT_ERROR_DESCRIPTION]:
    "Não foi possível eliminar este conteúdo agendado.",
  [DELETE_SCHEDULED_CONTENT_SUCCESS]:
    "Publicação programada excluída corretamente",
  [DELETE_MULTIPLE_CONTENT_CONFIRMATION_TITLE]:
    "Excluir conteúdos selecionados",
  [DELETE_MULTIPLE_CONTENT_CONFIRMATION_DESCRIPTION]:
    "Tem certeza de que deseja excluir {{count}} conteúdos selecionados? Esta ação é definitiva e você não poderá desfazê-la.",
  [BUTTON_DELETE_CONTENT]: "Excluir",
  [BUTTON_FINISHED_CAMPAIGN]: "Finalizar campanha",
  [BUTTON_SAVE_CAMPAIGN]: "Salvar campanha",
  [BUTTON_DEACTIVATE_CAMPAIGN]: "Desativar campanha",
  [BUTTON_ACTIVATE_CAMPAIGN]: "Ativar campanha",
  [BUTTON_SEND_INVITE]: "Enviar convite",
  [BUTTON_REJECT]: "Rejeitar",
  [BUTTON_ACCEPT]: "Aceitar",
  [BUTTON_ACCEPT_AND_PAY]: "Pagar agora",
  [BUTTON_ASSIGN_INVITE]: "Atribuir convite",
  [BUTTON_REVIEW_CONTENT]: "Revisar conteúdo",
  [BUTTON_VIEW_PRELIMINARY_CONTENT]: "Revisão",
  [BUTTON_VIEW_APPLICANT]: "Ver candidato",
  [BUTTON_REVIEW]: "Avaliar",
  [BUTTON_ACCEPT_CONTENT]: "Aceitar conteúdo",
  [BUTTON_REJECT_CONTENT]: "Rejeitar e não reembolsar",
  [BUTTON_SEND_REVIEW]: "Enviar revisões",
  [BUTTON_CONTINUE]: "Continuar",
  [BUTTON_SIGN_UP]: "Cadastrar-se",
  [BUTTON_CONTINUOUS]: "Contínuo",
  [BUTTON_CONTINUE_WITHOUT_CHANGES]: "Continuar sem alterações",
  [BUTTON_RESIZE_AND_CONTINUE]: "Redimensionar e Publicar",
  [BUTTON_UNDERSTOOD]: "Entendi",
  [BUTTON_MORE_QUESTIONS]: "Tenho mais perguntas",
  [BUTTON_INIT_TUTORIAL]: "Iniciar tutorial",
  [BUTTON_PAYMENTS]: "Pagamentos",
  [BUTTON_BROADCAST]: "Broadcast",
  [BUTTON_SAVE]: "Salvar",
  [BUTTON_SEND_MESSAGE]: "Conversar agora",
  [BUTTON_UPLOAD_FILE]: "Enviar arquivo",
  [BUTTON_REMOVE_FILE]: "Excluir arquivo",
  [BUTTON_VERIFY_PUBLICATION]: "Verificar publicação",
  [BUTTON_SEE_PUBLICATION_ON]: "Ver em {{value}}",
  [BUTTON_METRICS_READY]: "Métricas prontas",
  [BUTTON_UPLOAD_TIKTOK]: "Enviar no TikTok",
  [BUTTON_VIEW_PROFILE]: "Ver perfil",
  [BUTTON_GENERATE_DESCRIPTION]: "Gerar descrição",
  [BUTTON_GENERATE_COMMENT]: "Gerar comentário",
  [BUTTON_UPLOAD_IMAGE]: "Enviar imagem",
  [BUTTON_REMOVE_IMAGE]: "Excluir imagem",
  [BUTTON_SAVE_CHANGES]: "Salvar alterações",
  [BUTTON_UPLOAD_VIDEO]: "Enviar vídeo",
  [BUTTON_REMOVE_VIDEO]: "Excluir vídeo",
  [BUTTON_DISCONNECT]: "Desconectar",
  [BUTTON_CONNECT_TIKTOK]: "Conectar TikTok",
  [BUTTON_CONNECT_TIKTOK_BUSINESS]: "Conectar TikTok Business",
  [BUTTON_BE_ECOMMERCE]: "Sempre aberto",
  [BUTTON_NOT_BE_ECOMMERCE]: "Editar horários",
  [BUTTON_ADD_TURN]: "Adicionar turno",
  [BUTTON_DELETE]: "Excluir",
  [BUTTON_ARCHIVE_CAMPAIGN]: "Arquivar",
  [BUTTON_CREATE]: "Criar",
  [BUTTON_CONNECT_WOOCOMMERCE]: "Conectar WooCommerce",
  [BUTTON_CREATE_USER]: "Criar usuário",
  [BUTTON_CREATE_ACCOUNT]: "Criar conta",
  [MODAL_CREATE_ACCOUNT_TITLE]: "Qual é o seu e-mail?",
  [MODAL_CREATE_ACCOUNT_DESCRIPTION]:
    "Vincule sua conta a um e-mail e uma senha para manter o seu acesso.",
  [BUTTON_CREATE_CONTACT]: "Criar contato",
  [BUTTON_VIEW_DETAILS]: "Ver detalhes",
  [BUTTON_DOWNLOAD_INVOICE]: "Baixar fatura",
  [BUTTON_CLOSE]: "Fechar",
  [BUTTON_UPLOAD_CATALOG]: "Enviar catálogo",
  [BUTTON_COPY_CATALOG]: "Copiar catálogo",
  [BUTTON_DOWNLOAD_FORMAT]: "Baixar formato",
  [BUTTON_DUPLICATE]: "Duplicar",
  [BUTTON_DUPLICATE_IN_SAME_GROUP]: "No mesmo grupo",
  [BUTTON_DUPLICATE_IN_OTHER_AD_GROUP]:
    "Outra campanha ou grupo desta ou de outra campanha",
  [DUPLICATE_AD_OTHER_GROUP_MODAL_TITLE]: "Duplicar seu Anúncio",
  [DUPLICATE_AD_OTHER_GROUP_MODAL_DESCRIPTION]:
    "Selecione a campanha e o grupo de anúncios de destino onde o anúncio será duplicado.",
  [DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_CHANGE_WARNING]:
    "Duplicar este anúncio em outra campanha fará você sair da campanha atual. As alterações não publicadas ou não salvas da campanha atual serão perdidas.",
  [DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_LABEL]: "Campanha",
  [DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_PLACEHOLDER]: "Selecione uma campanha",
  [DUPLICATE_AD_OTHER_GROUP_AD_GROUP_LABEL]: "Grupo de anúncios",
  [DUPLICATE_AD_OTHER_GROUP_AD_GROUP_PLACEHOLDER]:
    "Selecione um grupo de anúncios",
  [DUPLICATE_AD_OTHER_GROUP_EMPTY_AD_GROUPS]:
    "Não há grupos de anúncios disponíveis para esta campanha",
  [BUTTON_DUPLICATE_IN_SAME_CAMPAIGN]: "Na mesma campanha",
  [BUTTON_DUPLICATE_IN_OTHER_CAMPAIGN]: "Em outra campanha",
  [DUPLICATE_AD_GROUP_MODAL_TITLE]: "Duplicar seu Grupo de Anúncios",
  [DUPLICATE_AD_GROUP_MODAL_DESCRIPTION]:
    "Selecione a campanha de destino onde o grupo de anúncios será duplicado.",
  [DUPLICATE_AD_GROUP_CAMPAIGN_CHANGE_WARNING]:
    "Duplicar este grupo de anúncios em outra campanha fará você sair da campanha atual. As alterações não publicadas ou não salvas da campanha atual serão perdidas.",
  [DUPLICATE_AD_GROUP_CAMPAIGN_TYPE_MISMATCH]:
    "A campanha selecionada não compartilha o mesmo objetivo ou tipo de campanha. Selecione uma campanha com o mesmo objetivo ou tipo.",
  [DUPLICATE_CAMPAIGN_AD_FORMAT_MISMATCH]:
    "A campanha selecionada não compartilha o mesmo formato de anúncio. Selecione uma campanha com o mesmo formato.",
  [DUPLICATE_ASSETS_GROUP_MODAL_TITLE]: "Duplicar seu Grupo de Recursos",
  [DUPLICATE_ASSETS_GROUP_MODAL_DESCRIPTION]:
    "Selecione a campanha de destino onde o grupo de recursos será duplicado.",
  [DUPLICATE_ASSETS_GROUP_CAMPAIGN_CHANGE_WARNING]:
    "Duplicar este grupo de recursos em outra campanha fará você sair da campanha atual. As alterações não publicadas ou não salvas da campanha atual serão perdidas.",
  [BUTTON_EDIT]: "Editar",
  [BUTTON_MOVE_OTHER_CATEGORY]: "Mover para outra categoria",
  [BUTTON_COPY]: "Copiar",
  [BUTTON_REGISTER]: "Cadastrar-se",
  [BUTTON_NO_HAVE_DOCUMENT]: "Não tenho este documento",
  [BUTTON_UPLOAD_AFTER]: "Enviar depois",
  [BUTTON_INVITED]: "Convidado",
  [BUTTON_YES_I_SURE]: "Sim, tenho certeza",
  [BUTTON_SEND_REVISION]: "Enviar revisão",
  [BUTTON_APPROVE_CONTENT]: "Reembolsar créditos",
  [BUTTON_UPLOAD_INSTAGRAM]: "Enviar no Instagram",
  [BUTTON_CONNECT_INSTAGRAM]: "Conectar Instagram",
  [BUTTON_RELOAD_PAGE]: "Recarregar página",
  [BUTTON_REPLACE_IMAGE]: "Substituir imagem",
  [BUTTON_GENERATE_CONTENT]: "Gerar conteúdo",
  [BUTTON_REGENERATE_CONTENT]: "Regenerar conteúdo",
  [BUTTON_REGENERATE_TEXT]: "Regenerar textos",
  [BUTTON_UPLOAD_LOGO]: "Enviar Logo",
  [BUTTON_REPLACE_LOGO]: "Substituir logo",
  [BUTTON_UPLOAD_BACKGROUND]: "Enviar fundo",
  [BUTTON_REPLACE_BACKGROUND]: "Substituir fundo",
  [BUTTON_REMOVE_BACKGROUND]: "Excluir fundo",
  [BUTTON_GENERATE_OTHER]: "Regenerar",
  [BUTTON_SUBSCRIBE_NOW]: "Assinar",
  [BUTTON_ADD_USER]: "Adicionar usuário",
  [BUTTON_ADD_SHOP]: "Adicionar loja",
  [BUTTON_DOWNLOAD_REPORT]: "Baixar relatório",
  [BUTTON_PASS_TO_SUBSCRIPTION_BASIC]: "Mudar para a assinatura básica",
  [BUTTON_EXTEND]: "Estender",
  [BUTTON_ARCHIVE]: "Arquivar",
  [BUTTON_UNARCHIVE]: "Desarquivar",
  [BUTTON_CREATE_TRANSACTION]: "Criar transação",
  [BUTTON_UPDATE_STATISTICS]: "Atualizar estatísticas",
  [BUTTON_SEND_PAYMENT]: "Enviar pagamento",
  [BUTTON_CREATOR_CHAT]: "Chat de Criadores",
  [BUTTON_SEND_FILE]: "Enviar arquivo",
  [BUTTON_SEE_MORE]: "Ver mais",
  [BUTTON_SEE_LESS]: "Ver menos",
  [BUTTON_SEND]: "Enviar",
  [BUTTON_YOU_HAVE_DOUBTS]: "Você tem perguntas? Fale conosco",
  [BUTTON_WATCH_DEMO]: "Ver demonstração",
  [BUTTON_SAVE_CONTENT]: "Salvar conteúdo",
  [BUTTON_SEND_BROADCAST]: "Enviar broadcast",
  [BUTTON_ADD_CONTENT]: "Adicionar Conteúdo",
  [BUTTON_ADD_SELECTED_CONTENT]: "Adicionar Conteúdo",
  [BUTTON_SEE_ALL_APPLICANTS]: "Ver todos os candidatos",
  [BUTTON_GO_BACK]: "Voltar",
  [BUTTON_CLEAR_FILTERS]: "Limpar filtros",
  [BUTTON_TIKTOK_BILLING]: "Faturamento de TikTok",
  [BUTTON_META_BILLING]: "Faturamento de Meta",
  [BUTTON_REPLACE_CONTENT]: "Substituir",
  [BUTTON_CHANGE_CONTENT]: "Alterar conteúdo",
  [BUTTON_EDIT_CONTENT]: "Editar",
  [BUTTON_CHANGE_SLIDE]: "Alterar slide",
  [PLATFORM_ONLY_ACCEPTS_VIDEOS]: "{{platform}} só aceita vídeos",
  [BUTTON_SELECT_VIDEO]: "Selecionar um vídeo",
  [BUTTON_REPLACE_VIDEO]: "Substituir vídeo",
  [BUTTON_SELECT_THIS_CONTENT]: "Selecionar este Conteúdo",
  [BUTTON_REMOVE_SELECTION]: "Excluir seleção",
  [BUTTON_RECHARGE_BALANCE]: "Recarregar saldo",
  [BUTTON_CONNECT_SHOPIFY]: "Conectar Shopify",
  [BUTTON_CONNECT_META]: "Conectar Meta",
  [BUTTON_CONTACT_AN_ADVISOR]: "Necesito Ajuda",
  [BUTTON_GENERATE_SCRIPT]: "Gerar roteiro",
  [BUTTON_VIEW_INVOICE]: "Ver fatura",
  [BUTTON_ADJUST_PREFERENCES]: "Ajustar Preferências",
  [BUTTON_GENERATE_AGAIN]: "Gerar de novo",
  [BUTTON_CREATE_ADS_CAMPAIGN]: "Criar Campanha",
  [BUTTON_EDIT_BUDGET]: "Editar Orçamento",
  [BUTTON_PUBLISH_CAMPAIGN]: "Publicar Campanha",
  [BUTTON_START_CHAT]: "Conversar agora",
  [BUTTON_SELECT_CONTENT]: "Selecionar conteúdo",
  [BUTTON_SELECT_DOCUMENT]: "Selecionar documentos",
  [BUTTON_SELECT_POST]: "Selecionar Publicação",
  [BUTTON_CREATE_WITH_CANVA]: "Criar com Canva",
  [BUTTON_CREATE_WITH_IA]: "Criar",
  [BUTTON_CONNECT_CANVA]: "Conectar Canva",
  [BUTTON_USE_THIS_CONTENT]: "Usar este Conteúdo",
  [BUTTON_CONNECT_GOOGLE]: "Conectar Google",
  [BUTTON_CONNECT_GOOGLE_DRIVE]: "Conectar Google Drive",
  [BUTTON_SELECT]: "Selecionar",
  [BUTTON_DESELECT]: "Deselecionar",
  [BUTTON_SEND_CODE]: "Enviar Código",
  [BUTTON_VERIFY_CODE]: "Verificar",
  [BUTTON_RESEND_CODE]: "Reenviar",
  [BUTTON_CONNECTED]: "Conectared",
  [BUTTON_DISCONNECTED]: "Desconectared",
  [BUTTON_ADD_RE_TARGETING]: "Adicionar audiência",
  [BUTTON_BUY_PLAN]: "Comprar {{value}}",
  [BUTTON_ADD]: "Adicionar",
  [BUTTON_UPLOAD_CONTENT_FROM_ADS_PLATFORMS]: "Enviar pelas redes sociais",
  [BUTTON_UPDATE]: "Atualizar",
  [BUTTON_CONNECT_ACCOUNT]: "Conectar Conta",
  [BUTTON_REPLACE]: "Substituir",
  [BUTTON_SUPPORT]: "Suporte",
  [BUTTON_CANCEL_SUBSCRIPTION]: "Cancelar Assinatura",
  [BUTTON_REACTIVATE_SUBSCRIPTION]: "Reativar Assinatura",
  [BUTTON_CHANGE_PAYMENT_METHODS]: "Change Método de pagamento",
  [BUTTON_DELETE_PLATFORM]: "Excluir Plataforma",
  [BUTTON_GENERATE_WITH_AI]: "Gerar com IA",
  [BUTTON_CONTACT_US]: "Fale conosco",
  [BUTTON_GENERATE_RANDOM]: "Gerar aleatório",
  [BUTTON_GENERATE]: "Gerar",
  [BUTTON_REGISTER_WITH_GOOGLE]: "Cadastrar-se com Google",
  [BUTTON_LOG_IN_WITH_GOOGLE]: "Entrar com Google",
  [BUTTON_CHANGE_LOGO]: "Alterar logo",
  [BUTTON_DELETE_LOGO]: "Excluir Logo",
  [BUTTON_UPGRADE_PLAN]: "Atualizar a {{value}}",
  [BUTTON_UPGRADE_PLAN_2]: "Atualizar Plano",
  [LABEL_CURRENT_SUBSCRIPTION_PLAN]: "Plano atual",
  [BUTTON_UPGRADE_TO_PAID_PLAN]: "Mudar para um plano pago",
  [BUTTON_BOOK_A_DEMO]: "Agendar uma demonstração",
  [BUTTON_APPLY_OPTIMIZATIONS]: "Aplicar Otimizaçãos",
  [BUTTON_OPTIMIZATION_APPLIED]: "Otimização Aplicada",
  [BUTTON_CHANGES_APPLIED]: "Alterações aplicadas",
  [BUTTON_APPLY_CHANGES]: "Aplicar alterações",
  [BUTTON_PREVIEW_CHANGES]: "Revisar alterações",
  [BUTTON_DISCARD_OPTIMIZATIONS]: "Descartar otimizações",
  [BUTTON_DISCARD_OPTIMIZATIONS_DESCRIPTION]:
    "Tem certeza de que deseja descartar as otimizações?",
  [BUTTON_CREATE_TEMPLATE]: "Criar modelo",
  [BUTTON_EDIT_TEMPLATE]: "Editar modelo",
  [BUTTON_VIEW_DETAILED_REPORT]: "Ver relatório detalhado",
  [BUTTON_SELECT_INSTANT_FORM]: "Selecionar Formulário",
  [BUTTON_RECONNECT_ACCOUNT]: "Reconectar conta",
  [BUTTON_RECONNECT]: "Reconectar",
  [BUTTON_ADD_CONVERSION_ACTION]: "Adicionar ação de conversão",
  [BUTTON_SELECT_AVATAR]: "Selecionar Avatar",
  [BUTTON_CHANGE_AVATAR]: "Alterar avatar",
  [BUTTON_FILTER]: "Filtrar",
  [BUTTON_CONNECT_LINKEDIN]: "Conectar LinkedIn",
  [BUTTON_REMOVE]: "Excluir",
  [BUTTON_TRY_AGAIN]: "Tenter de Novo",
  [BUTTON_PUBLISH_CHANGES]: "Publicar changes",
  [BUTTON_ANALYZE]: "Analisar",
  [BUTTON_DROP_PIN]: "Marcar pin",
  [BUTTON_EDIT_PLACEMENTS]: "Editar posicionamentos",
  [BUTTON_EDIT_ADVANTAGE_ENHANCES]: "Editar advantage enhances",
  [BUTTON_COMPLETE_INFORMATION]: "Completar Informação",
  [BUTTON_ADD_KEYWORDS]: "Adicionar",
  [BUTTON_SELECT_POST_FROM_SOCIAL_NETWORKS]:
    "Selecionar publicação de redes sociais",
  [BUTTON_CREATE_NEW]: "Criar novo",
  [BUTTON_PREVIEW_OPTIMIZATION]: "Revisar Otimização",
  [BUTTON_CHANGE_CREATIVE]: "Alterar criativo",
  [BUTTON_APPLIED]: "Aplicado",
  [BUTTON_SKIP]: "Pular",
  [BUTTON_ADD_VIDEO]: "Adicionar vídeo",
  [BUTTON_CREATE_FROM_SCRATCH]: "Criar com IA",
  [BUTTON_CREATE_FROM_TEMPLATES]: "A partir de modelos",
  [BUTTON_IMPORT_FROM_PLATFORM]: "Importar",
  [BUTTON_IMPORT_FROM_GOOGLE_DRIVE]: "Importar do Google Drive",
  [BUTTON_IMPORT_CAMPAIGN]: "Importar Campanha",
  [BUTTON_DUPLICATE_FROM_PLATFORM]: "Duplicar",
  [BUTTON_DUPLICATE_CAMPAIGN]: "Duplicar Campanha",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_TITLE]: "Duplicar Campanha",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_DESCRIPTION]:
    "Selecione uma campanha da sua plataforma para duplicar sua estrutura como rascunho",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_TITLE]: "Campanha Duplicada",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_DESCRIPTION]:
    "A estrutura da campanha foi duplicada como rascunho. Revise e publique quando estiver pronto.",
  [MODAL_IMPORT_ADS_CAMPAIGN_SUPPORTED_TYPES]:
    "Você só pode importar campanhas de {{types}}.",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_SUPPORTED_TYPES]:
    "Você só pode duplicar campanhas de {{types}}.",
  [BUTTON_SAVE_AND_PUBLISH]: "Publicar alterações",
  [BUTTON_ADD_SITE_LINK]: "Adicionar link do site",
  [BUTTON_EDIT_SITE_LINKS]: "Editar links do site",
  [BUTTON_SELECT_CSV_FILE]: "Enviar arquivo CSV",
  [BUTTON_DOWNLOAD_TEMPLATE]: "Baixar modelo",
  [BUTTON_UPLOAD_GOOGLE_ASSET_LIBRARY]: "Enviar da Biblioteca do Google",
  [BUTTON_MARK_AS_DONE]: "Marcar como feito",
  [BUTTON_SELECT_INSTANT_EXPERIENCE]: "Selecionar experiencia",
  [BUTTON_VIEW_ACTION]: "Ver action",
  [BUTTON_CREATE_CUSTOM_AUDIENCE]: "Criar Audiência",
  [BUTTON_CLEAR_ALL]: "Limpar tudo",
  [BUTTON_RESET_TO_BASIC_METRICS]: "Mostrar métricas básicas",
  [BUTTON_GO_TO_BILLING]: "Ir a Faturamento",
  [BUTTON_WHY_THIS_RECOMMENDATION]: "Por que esta recomendação?",
  [BUTTON_CLEAR_DATES]: "Limpar datas",
  [BUTTON_NEW_CAMPAIGN]: "Nova Campanha",
  [BUTTON_DISCONNECT_ACCOUNT]: "Desconectar Conta",
  [BUTTON_SELECT_ALL]: "Selecionar Todas",
  [BUTTON_DESELECT_ALL]: "Deselecionar Todas",
  [BUTTON_USE_SAVED_AUDIENCE]: "Usar Audiência Guardada",
  [BUTTON_ADD_PRODUCT]: "Adicionar Producto",
  [BUTTON_ADD_SERVICE]: "Adicionar Servicio",

  /* Categories */
  [NEW_CREATORS_CATEGORY]: "Novos criadores",
  [FAVORITES_CATEGORY]: "Favoritos",
  [TOP_RATED_CATEGORY]: "Mais bem avaliados",

  //VERSION
  [NEW_VERSION_TITLE]: "Nova versão disponível!",
  [NEW_VERSION_DESCRIPTION]:
    "Lançamos uma atualização do nosso site que pode gerar conflitos com a sua versão atual. Recomendamos recarregar a página para obter a versão mais recente e evitar possíveis erros.",

  [DESCRIPTION_SEND_MESSAGE]: "Converse com este criador",
  [DESCRIPTION_SEND_PAYMENT]: "Enviar um pagamento com segurança",

  [MODAL_PAY_CREATOR_AMOUNT_LABEL]: "Valor do pagamento",

  /* PAGES */

  // Creators
  [CREATORS_TITLE]: "Criadores de Conteúdo",
  [CREATOR_DESCRIPTION]:
    "Encontre e filtre criadores para colaborar em permuta, enviar mensagens e pagamentos",
  [SEARCH_BAR_TEXT_CREATORS]: "Buscar por nome de usuário",
  [TAB_CREATORS]: "Criadores",
  [TAB_REQUESTS]: "Solicitações",
  [TAB_SUGGESTED]: "Para você",
  [CREATORS_SUGGESTED_EMPTY]:
    "Não foram encontrados criadores sugeridos; ajuste suas preferências para encontrar criadores",
  [CREATORS_TABLE_COLUMN_NAME]: "Nome",
  [CREATORS_TABLE_COLUMN_CITY]: "Cidade",
  [CREATORS_TABLE_COLUMN_AUDIENCE]: "Audiência",
  [CREATORS_TABLE_COLUMN_ENGAGEMENT]: "Engajamento",
  [CREATORS_TABLE_COLUMN_CATEGORIES]: "Categorias",
  [CREATORS_TABLE_COLUMN_DATE]: "Data",
  [CREATORS_TABLE_COLUMN_SCORE]: "Pontuação",
  [CREATORS_TABLE_COLUMN_ACTIVITY]: "Atividade",
  [DISCOVER_NEW_CREATORS]: "Descubra novos criadores",

  [RECURRENT_FIELDS_DEFAULT_TITLE]: "Cada cuánto quer invitar a este criador?",
  [RECURRENT_FIELD_REPEAT_COUNT_PLACEHOLDER]: "A cada",
  [RECURRENT_FIELD_REPEAT_COUNT_MIN_VALIDATION]: "O valor mínimo é {{value}}",
  [RECURRENT_FIELD_REPEAT_COUNT_MAX_VALIDATION]:
    "A recorrência máxima é de {{months}} meses ou {{weeks}} semanas",
  [RECURRENT_FIELD_FREQUENCY_PLACEHOLDER]: "Escolha uma opção",
  [RECURRENT_FIELD_DAY_AN_PLACEHOLDER]: "A",
  [RECURRENT_FIELD_DAY_ALL_PLACEHOLDER]: "Todos os",
  [MODAL_BROADCAST_ARIAL_LABEL]: "Modal de transmissão",
  [MODAL_BROADCAST_TITLE]: "Enviar a broadcast",
  [MODAL_BROADCAST_DESCRIPTION]:
    "Envie uma mensagem a todos os seus embaixadores",
  [MODAL_BROADCAST_SELECT_USER_PLACEHOLDER]: "Selecione os usuários",
  [MODAL_BROADCAST_SELECT_USER_REQUIRED]:
    "Você deve selecionar pelo menos um usuário",
  [MODAL_BROADCAST_MESSAGE_PLACEHOLDER]: "Mensagem",
  [BROADCAST_MESSAGE_SENT]: "Mensagem global enviada",
  [MODAL_BROADCAST_CONFIRM_TITLE]: "Enviar transmissão",
  [MODAL_BROADCAST_CONFIRM_DESCRIPTION]:
    "Tem certeza de que deseja enviar uma mensagem a todos os seus embaixadores?",

  //PUBLICATIONS
  [PUBLICATIONS_TITLE]: "Colaborações",
  [PUBLICATIONS_DESCRIPTION]:
    "Revise as colaborações que os criadores de conteúdo realizaram sobre seus produtos",
  [PUBLICATIONS_TABLE_ARIA_LABEL]: "Colaborações table",
  [PUBLICATIONS_TABLE_COLUMN_DATE]: "Data",
  [PUBLICATION_STATUS_PENDING_CONTENT]: "Conteúdo Pendente",
  [PUBLICATION_STATUS_PENDING_APPROVAL]: "Revisão",
  [PUBLICATION_STATUS_PENDING]: "Publicação pendente",
  [PUBLICATION_STATUS_PENDING_SOCIAL]: "Publicação pendente",
  [PUBLICATIONS_STATUS_PENDING_ANALYTICS]: "Analítica pendente",
  [PUBLICATIONS_STATUS_SENT]: "Revisão",
  [PUBLICATIONS_STATUS_FEEDBACK]: "Feedback",
  [PUBLICATIONS_STATUS_VERIFIED]: "Verificada",

  //PUBLICATION
  [PUBLICATION_TITLE]: "Publicação",
  [NUMBER_PUBLICATION]: "N° Publicação",
  [FEEDBACK_TITLE]: "Feedback",
  [PUBLICATION_FINISH_ONBOARDING_NEW_BRANDS_DESCRIPTION]:
    "Agora você pode continuar com o tutorial de lojas.",
  [PUBLICATION_FINISH_DESCRIPTION]:
    "Você concluiu o tutorial da plataforma; agora já sabe como gerar convites.",
  [FEEDBACK_PLACEHOLDER]: "Como foi sua experiência usando a plataforma?",
  [FEEDBACK_REASON_ABOUT]: "Avaliação negativa sobre {{reason}}",
  [FEEDBACK_REASON]: "Motivo da review negativa",
  [FEEDBACK_COMMENT]: "Comentário",
  [ANALYTICS_EXPLANATION_TITLE]: "Como interpretar as análises?",
  [ANALYTICS_EXPLANATION_DESCRIPTION]:
    " Nas análises você poderá determinar se o conteúdo que o criador publicou sobre sua marca gerou os resultados de acordo com seus critérios.",
  [ANALYTICS_EXPLANATION_DESCRIPTION_2]:
    "As análises geralmente se dividem em diferentes seções de informação, mas as mais importantes são as de resumo e interações. A seguir, uma explicação dos diferentes dados que essas seções têm.",
  [ANALYTICS_EXPLANATION_ACCOUNTS_REACHED_DESCRIPTION]:
    "• <b>Contas alcançadas</b>: são as diferentes contas da rede social que a publicação em questão alcançou; podem ser divididas em seguidores e não seguidores, referindo-se a quem segue ou não o criador de conteúdo.",
  [ANALYTICS_EXPLANATION_ENGAGEMENT_DESCRIPTION]:
    "• <b>Contas que interagiram</b>: são as contas que tiveram algum tipo de interação com a publicação, por exemplo respostas às stories ou vezes em que foi compartilhada por outros usuários.",
  [ANALYTICS_EXPLANATION_STICKERS_TAPS_DESCRIPTION]:
    "• <b>Toques em etiquetas ou stickers</b>: é o número de vezes que se interagiu com a etiqueta ou sticker de alguma publicação, permitindo que os usuários vissem o perfil da sua marca.",
  [ANALYTICS_EXPLANATION_NAVIGATION_DESCRIPTION]:
    "• <b>Navegação</b>: descreve o comportamento que os usuários tiveram com o conteúdo que o criador publicou — se abandonou o story, se passou para o seguinte sem aguardar o tempo de finalização, se esperou todo o tempo determinado do story ou se voltou para vê-lo outra vez.",
  [RECURRENT_VALUE_NOT_FOUND]:
    "Não foi possível obter a recorrência do convite por alguma razão; altere os valores.",
  [MODAL_REVIEW_ARIA_LABEL]: "Modal para avaliar um influenciador",
  [MODAL_REVIEW_DISCLAIMER]:
    "Sua avaliação não será compartilhada com o criador de conteúdo.",
  [MODAL_REVIEW_SCORE_PLACEHOLDER]:
    "Avalie de 1 a 5 os resultados deste criador de acordo com suas expectativas.",
  [MODAL_REVIEW_SCORE_CONTENT_PLACEHOLDER]:
    "Avalie a qualidade e a produção do conteúdo publicado.",
  [MODAL_REVIEW_SCORE_CONTENT_MIN_VALUE]:
    "A avaliação mínima do conteúdo é de 1 estrela",
  [MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_TITLE]:
    "Como interpretar o conteúdo?",
  [MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_DESCRIPTION]:
    "Dê uma avaliação ao criador de conteúdo com base na qualidade da publicação — imagens, texto ou vídeos sobre sua marca. Uma estrela significa que você não está satisfeito com o conteúdo e não vai usá-lo ou baixá-lo; cinco significa que você está totalmente satisfeito(a) com o conteúdo e vai usá-lo e republicá-lo em seus canais ou redes.",
  [MODAL_REVIEW_SCORE_ENGAGEMENT_PLACEHOLDER]:
    "Avalie o alcance e o engajamento do conteúdo publicado.",
  [MODAL_REVIEW_SCORE_ENGAGEMENT_MIN_VALUE]:
    "A avaliação mínima das estatísticas é de 1 estrela",
  [MODAL_REVIEW_COMMENT_PLACEHOLDER]:
    "Descreva o que achou do conteúdo e do alcance deste criador",
  [REVISION_COUNT]: "Revisão {{value}}",
  [UPLOAD_NEW_CONTENT]: "Enviar novo conteúdo",
  [ADD_URL_PUBLICATION]: "Adicione URL",

  //ADS CAMPAIGNS
  [ADS_CAMPAIGNS_TITLE]: "Campanhas",
  [ADS_CAMPAIGNS_TITLE_DASHBOARD]: "Campanhas",
  [ADS_CAMPAIGNS_DESCRIPTION]:
    "Gerencie e analise suas campanhas publicitárias",

  //ADS CAMPAIGN
  [ADS_CONFIGURATION_APPS_TITLE]: "Configuração de Apps",
  [ADS_CONFIGURATION_DESTINATION_TITLE]: "Configuração de Destino",
  [ADS_CAMPAIGN_PREVIEW]: "Pré-visualização",
  [ADS_CAMPAIGN_TITLE]: "Informação da campanha",
  [ADS_CAMPAIGN_CAMPAIGN_INFORMATION_SUB_TITLE]: "Anúncio de {{platform}}",
  [ADS_CAMPAIGN_BUDGET_INFORMATION_SUB_TITLE]: "Informação do orçamento geral",
  [ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE]: "Informação de segmentação",
  [ADS_CAMPAIGN_SAVED_AUDIENCE_SUB_TITLE]: "Audiência Guardada",
  [ADS_CAMPAIGN_ADDITIONAL_CONFIGURATION_AD_GROUP_SUB_TITLE]:
    "Configuração adicional",
  [ADS_CAMPAIGN_HAS_BEEN_FINISHED]: "Esta campanha foi finalizada",
  [ADS_CAMPAIGN_HAS_BEEN_ACTIVATE]: "Campanha ativada",
  [ADS_CAMPAIGN_HAS_BEEN_SAVE]: "Campanha salva",
  [ADS_CAMPAIGN_HAS_BEEN_DUPLICATE]: "Campanha duplicada",
  [ADS_CAMPAIGN_USE_GENERAL_BUDGET]: "Usar um orçamento geral de campanha",
  [ADS_CAMPAIGN_PLATFORM_BRAND_CONFIGURATION_SUB_TITLE]:
    "Configuração de Marca",
  [ADS_CAMPAIGN_PLATFORM_ASSETS_CONFIGURATION_SUB_TITLE]:
    "Configuração de Assets",
  [ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE]:
    "Informação do Orçamento",
  [ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL]: "Configuração geral",
  [ADS_CAMPAIGN_AD_GROUP_INFORMATION_SUB_TITLE]:
    "Informação do grupo de anúncios",
  [ADS_CAMPAIGN_PLATFORM_ADDITIONAL_CONFIGURATION_SUB_TITLE]:
    "Configuração Adicional",
  [ADS_CAMPAIGNS_PLATFORM_TEXTS_SUB_TITLE]: "Configuração de textos",
  [ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE]: "Configuração de produtos",
  [ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE]: "Configuração do aplicativo",
  [ADS_CAMPAIGN_PRODUCTS_CONFIGURATION_SUB_TITLE]: "Configuração de produtos",

  //PRODUCT SET AUDIENCE BUILDER
  [PRODUCT_SET_AUDIENCE_BUILDER_TITLE]: "Regras de audiência",
  [PRODUCT_SET_AUDIENCE_BUILDER_PROSPECTING_TITLE]:
    "Encontre clientes potenciais mesmo que não tenham interagido com o seu negócio.",
  [PRODUCT_SET_AUDIENCE_BUILDER_RETARGETING_TITLE]:
    "Redirecione anúncios para pessoas que interagiram com os seus produtos dentro e fora das plataformas da Meta.",
  [PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_PROSPECTING_SEGMENT]:
    "Encontrar novos clientes",
  [PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_RETARGETING_SEGMENT]:
    "Voltar a se direcionar a uma audiência",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_TITLE]: "Combinação personalizada",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_TITLE]:
    "Interações de audiência",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_ADD_BUTTON]:
    "Adicionar inclusão",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_TITLE]: "Mas não",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_ADD_BUTTON]:
    "Adicionar exclusão",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_IN_THE_LAST]: "Nos últimos",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_DAYS]: "dias",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL]:
    "Vistos ou adicionados ao carrinho, mas não comprados",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION]:
    "Promova produtos de {{value}} para pessoas que viram ou adicionaram esses produtos ao carrinho nos últimos ",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL]:
    "Adicionados ao carrinho, mas não comprados",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION]:
    "Promova produtos de {{value}} para pessoas que adicionaram esses produtos ao carrinho nos últimos ",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_LABEL]:
    "Produtos de venda adicional",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_DESCRIPTION]:
    "Promova {{value}} para pessoas que viram ou adicionaram produtos ao carrinho do conjunto de produtos inferior nos últimos ",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_SELECT_PRODUCT_SET_LABEL]:
    "Produtos vistos ou adicionados ao carrinho em:",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_LABEL]:
    "Produtos de venda cruzada",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_DESCRIPTION]:
    "Promova {{value}} para pessoas que compraram do conjunto de produtos inferior nos últimos",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_SELECT_PRODUCT_SET_LABEL]:
    "Produtos comprados em:",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_SELECT_PRODUCT_SET_LABEL]:
    "Interagiu com produtos de:",

  [MODAL_ERRORS_CAMPAIGNS_TITLE]: "Ups! Algo deu errado",
  [MODAL_ERRORS_CAMPAIGNS_DESCRIPTION]: "Ocorreu um erro ao criar a campanha",

  //CREATE ADS CAMPAIGN
  [CREATE_ADS_CAMPAIGN_MODE_QUESTION]: "Escolha o tipo de campanha",
  [CREATE_ADS_CAMPAIGN_NAME_QUESTION]: "Qual será o nome da sua campanha?",
  [CREATE_ADS_CAMPAIGN_NAME_PLACEHOLDER]: "Nova coleção de verão",
  [CREATE_ADS_CAMPAIGN_OBJECTIVE_QUESTION]:
    "Qual é o objetivo da sua campanha?",
  [CREATE_ADS_CAMPAIGN_APP_PROMOTION_QUESTION]:
    "O que tipo de aplicação quer promover?",
  [CREATE_ADS_CAMPAIGN_TYPE_QUESTION]: "Que tipo de campanha quer criar?",
  [CREATE_ADS_CAMPAIGN_OBJECTIVE_DESCRIPTION]:
    "O objetivo da sua campanha é importante para que seus anúncios sejam exibidos da melhor maneira possível.",
  [CREATE_ADS_CAMPAIGN_DESTINATION_TYPE_QUESTION]:
    "Onde quer gerar a conversão?",
  [CREATE_ADS_CAMPAIGN_TARGET_CPA_QUESTION]:
    "Qual é o CPA objetivo da sua campanha?",
  [CREATE_ADS_CAMPAIGN_DESTINATION_URL_QUESTION]:
    "Para qual site quer redirecionar o tráfego da sua campanha?",
  [CREATE_ADS_CAMPAIGN_DEEP_LINK_QUESTION]:
    "Qual é o link profundo do seu app?",
  [CREATE_ADS_CAMPAIGN_DATES_QUESTION]:
    "Quando sua campanha começará e terminará?",
  [CREATE_ADS_CAMPAIGN_AD_FORMAT_QUESTION]:
    "O que formato de anúncio quer usar?",
  [CREATE_ADS_CAMPAIGN_WEBSITE_URL_QUESTION]: "Qual é a URL do seu site?",
  [CREATE_ADS_CAMPAIGN_AD_ACCOUNT_QUESTION]:
    "Em qual conta publicitária deseja criar a campanha?",
  [CREATE_ADS_CAMPAIGN_AD_ACCOUNTS_QUESTION]:
    "Em quais contas de anúncios deseja criar a campanha?",
  [CREATE_ADS_CAMPAIGN_IDENTITIES_ACCOUNTS_QUESTION]:
    "Em quais contas seus anúncios serão exibidos?",
  [META_GENERATE_CAMPAIGN_IDENTITIES_PLACEMENTS_HINT]:
    "Depois você poderá afinar as localizações onde quiser exibir seus anúncios (por exemplo, só Instagram ou só Facebook).",
  [MODAL_CLOSE_UNSAVED_WARNING_DESCRIPTION]:
    "Tem certeza de que quer sair? Sua configuração não será salva.",
  [MODAL_CLOSE_UNSAVED_CONFIRM]: "Sair",
  [META_ADAPT_PLACEMENTS_CONFIRM_TITLE]:
    "Adaptamos suas imagens a mais formatos?",
  [META_ADAPT_PLACEMENTS_CONFIRM_TEXT]:
    "Podemos gerar versões quadradas e verticais das suas imagens para exibi-las melhor em feeds, stories e reels. Isso consome créditos de criativos adicionais.",
  [META_ADAPT_PLACEMENTS_CONFIRM_YES]: "Sim, adapt",
  [META_ADAPT_PLACEMENTS_CONFIRM_NO]: "Não, continue",
  [META_ADAPT_PLACEMENTS_CHECKBOX_LABEL]:
    "Redimensionar imagens para se adaptar a todas as localizações verticais e quadradas.",
  [META_ADAPT_PLACEMENTS_CHECKBOX_COST]: "(Vai custar {{count}} créditos)",
  [CREATE_ADS_CAMPAIGN_CATALOG_QUESTION]:
    "Qual catálogo você quer usar para criar a campanha?",
  [CREATE_ADS_CAMPAIGN_CATALOG_FOR_APP_INSTALL_QUESTION]:
    "Deseja usar um catálogo para esta campanha?",
  [CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_QUESTION]:
    "Que tipo de campanha deseja criar?",
  [CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_WEBSITE]: "Website",
  [CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_APP]: "App",
  [CREATE_ADS_CAMPAIGN_APP_ID_QUESTION]: "O que aplicação quer promover?",
  [CREATE_ADS_CAMPAIGN_TRACKING_QUESTION]:
    "Com qual pixel deseja rastrear sua campanha?",
  [CREATE_ADS_CAMPAIGN_TRACKINGS_QUESTION]:
    "Com quais pixels deseja rastrear sua campanha?",
  [CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENT_QUESTION]:
    "Qual evento da Meta quer rastrear no seu site?",
  [CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENTS_QUESTION]:
    "Quais eventos da Meta quer rastrear no seu site?",
  [CREATE_ADS_CAMPAIGN_PLATFORM_QUESTION]:
    "Em qual plataforma você quer criar os anúncios?",
  [CREATE_ADS_CAMPAIGN_TYPE_BUDGET_QUESTION]:
    "Que tipo de campanha quer criar?",
  [CREATE_ADS_CAMPAIGN_TYPE_BUDGET_DAILY_RADIO_LABEL]:
    "Campanha diária (orçamento diário)",
  [CREATE_ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_RADIO_LABEL]:
    "Campanha com datas definidas (orçamento total)",
  [CREATE_ADS_CAMPAIGN_BUDGET_DAILY_QUESTION]:
    "Qual será o orçamento máximo DIÁRIO da sua campanha?",
  [CREATE_ADS_CAMPAIGN_BUDGET_TOTAL_QUESTION]:
    "Qual será o orçamento máximo da sua campanha?",
  [CREATE_ADS_CAMPAIGN_BUDGET_DESCRIPTION_QUESTION]:
    "Você não pagará nada até publicar sua campanha.",
  [CREATE_ADS_CAMPAIGN_BUDGET_PLACEHOLDER]: "Digite um valor",
  [CREATE_ADS_CAMPAIGN_START_END_DATE_QUESTION]:
    "Quando sua campanha começará e terminará?",
  [CREATE_ADS_CAMPAIGN_LOCATIONS_QUESTION]:
    "Para quais localizações deseja se direcionar?",
  [CREATE_ADS_CAMPAIGN_LOCATIONS_PLACEHOLDER]:
    "Descreva um lugar ou um conjunto de locais",
  [CREATE_ADS_CAMPAIGN_AGE_RANGE_QUESTION]:
    "Qual é a faixa etária da audiência que verá seus anúncios?",
  [CREATE_ADS_CAMPAIGN_GENDERS_QUESTION]:
    "Para quais gêneros deseja que seus anúncios sejam exibidos?",
  [CREATE_ADS_CAMPAIGN_INTERESTS_QUESTION]:
    "Que interesses deseja que a audiência que verá seus anúncios tenha?",
  [CREATE_ADS_CAMPAIGN_INTERESTS_PLACEHOLDER]: "Moda praia, férias, verão",
  [CREATE_ADS_CAMPAIGN_BEHAVIORS_QUESTION]:
    "Que comportamentos deseja que a audiência que verá seus anúncios tenha?",
  [CREATE_ADS_CAMPAIGN_BEHAVIORS_PLACEHOLDER]:
    "Compradores de moda praia, viajantes frequentes",
  [CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_QUESTION]:
    "Que dados demográficos deseja que a audiência que verá seus anúncios tenha?",
  [CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_PLACEHOLDER]:
    "Noivos recentes, aniversário próximo, data comemorativa próxima",
  [CREATE_ADS_CAMPAIGN_DESCRIPTION_QUESTION]:
    "Qual texto acompanhará o seu anúncio?",
  [CREATE_ADS_CAMPAIGN_DESCRIPTION_PLACEHOLDER]:
    "A nova coleção de verão já chegou: eleva seu estilo na praia com nossas peças. Descubra-as agora!",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION]: "Fale sobre sua campanha",
  [CREATE_ADS_CAMPAIGN_CONTEXT_DESCRIPTION]: `Escreva um parágrafo detalhando qual é o produto ou serviço que deseja promover, qual é a mensagem principal e a qual público-alvo deseja chegar.`,
  [CREATE_ADS_CAMPAIGN_CONTEXT_PLACEHOLDER]:
    "Minha campanha é para promover minha nova coleção de verão que acabei de lançar. Esta coleção é perfeita para as férias na praia, com roupas de banho, shortes e acessórios de praia. É ideal para homens e mulheres que buscam um visual fresco e moderno.",
  [CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_QUESTION]:
    "Qual é o produto ou serviço que quer promover e quais são seus principais atributos?",
  [CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_DESCRIPTION]:
    "Escreva um parágrafo detalhando o produto ou serviço que deseja promover, quais são seus principais atributos e o que o faz destacar.",
  [CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_PLACEHOLDER]:
    "Meu produto são roupas de banho com um design moderno e fresco. É feito de material de alta qualidade e é perfeito para se destacar na praia.",
  [CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_QUESTION]:
    "Para qual público quer mostrar o anúncio?",
  [CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_DESCRIPTION]:
    "Escreva um parágrafo detalhando o público-alvo a que deseja chegar e quais características ele deve ter.",
  [CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_PLACEHOLDER]:
    "Meu público-alvo são homens e mulheres de 18 a 35 anos que gostam de praia e moda, e que gostam de um visual moderno e fresco.",
  [CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_QUESTION]: "Háblanos sobre sua marca",
  [CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_DESCRIPTION]:
    "Escreva um parágrafo detalhando como se chama sua marca, do que se trata, quais produtos ou serviços você oferece e o que a faz destacar.",
  [CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_PLACEHOLDER]:
    "Minha marca se chama 'Beachwear', é uma loja de roupas e acessórios de praia. Oferecemos uma ampla variedade de produtos com um design moderno e fresco que se adapta às tendências atuais. Nossos produtos são de alta qualidade e buscam se destacar na praia.",
  [CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_QUESTION]:
    "Qual é o perfil do Instagram da sua marca?",
  [CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_PLACEHOLDER]:
    "https://www.instagram.com/suamarca",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_QUESTION]: "O que conteúdos quer promover?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_SERVICES_QUESTION]:
    "O que conteúdos quer promover?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DOCUMENTS_QUESTION]:
    "O que documentos quer promover?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_POSTS_QUESTION]:
    "Quais publicações quer promover?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_PRODUCTS_QUESTION]:
    "Quais produtos quer promover?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_WITH_OUT_CAROUSEL]:
    "Envie um conteúdo por anúncio. Depois você poderá escolher outros formatos.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_DOCUMENTS]:
    "Envie um documento por anúncio (PDF, PPT ou DOC). Cada documento será um anúncio independente.",
  [LINKEDIN_DOCUMENT_PDF_PREVIEW_LOADING]: "Carregando prévia do documento",
  [LINKEDIN_DOCUMENT_PDF_PREVIEW_ERROR]:
    "Não foi possível mostrar a prévia do documento",
  [LINKEDIN_DOCUMENT_PDF_PREVIEW_ALT]: "Prévia de {{fileName}}",
  [LINKEDIN_DOCUMENT_PREVIEW_PREV]: "Página anterior",
  [LINKEDIN_DOCUMENT_PREVIEW_NEXT]: "Próxima página",
  [LINKEDIN_DOCUMENT_PREVIEW_PAGE_COUNT]: "{{current}} / {{total}}",
  [LINKEDIN_DOCUMENT_PREVIEW_OPEN_NEW_TAB]: "Abrir em uma nova aba",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_CAROUSEL]:
    "Por enquanto, selecione apenas as primeiras imagens dos carrosséis que quiser enviar. Depois você poderá adicionar o restante.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT]:
    "Adicione conteúdo dos produtos que quiser promover. <b>Cada conteúdo que você adicionar será um anúncio independente dentro da campanha</b> e você poderá editar os formatos mais adiante.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT_SINGLE]:
    "Adicione conteúdo dos produtos que quiser promover. Você poderá editar os formatos mais adiante.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE_SINGLE]:
    "Adicione conteúdo dos serviços que quiser promover. Você poderá editar os formatos mais adiante.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE]:
    "Adicione conteúdo dos serviços que quiser promover. <b>Cada conteúdo que você adicionar será um anúncio independente dentro da campanha</b> e você poderá editar os formatos mais adiante.",
  [CREATE_ADS_CAMPAIGN_TEMPLATE_QUESTION]: "Que tipo de campanha deseja criar?",
  [CREATE_ADS_CAMPAIGN_TEMPLATE_SINGULAR]: "Singular",
  [CREATE_ADS_CAMPAIGN_TEMPLATE_MULTIPLE]: "Múltiplo",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_QUESTION]:
    "Adicione os produtos que quer promover",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_DESCRIPTION]:
    "Para cada produto, adicione o link de destino e os conteúdos criativos.",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_QUESTION]:
    "Adicione os serviços que quer promover",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_DESCRIPTION]:
    "Para cada serviço, adicione o link de destino e os conteúdos criativos.",
  [PRODUCT_URL_PLACEHOLDER]: "URL do produto",
  [SERVICE_URL_PLACEHOLDER]: "URL ou página de destino",
  [PRODUCT_LABEL]: "Produto {{number}}",
  [SERVICE_LABEL]: "Serviço {{number}}",
  [PRODUCT_FIELDS_REQUIRED]:
    "Todos os campos são obrigatórios no produto {{number}}",
  [SERVICE_FIELDS_REQUIRED]:
    "Todos os campos são obrigatórios no serviço {{number}}",
  [PRODUCT_URL_INVALID]: "A URL do produto {{number}} é inválida",
  [SERVICE_URL_INVALID]: "A URL do serviço {{number}} é inválida",
  [MEDIA_URLS_TAB_SINGULAR_PRODUCT]: "Um único produto",
  [MEDIA_URLS_TAB_SINGULAR_SERVICE]: "Um único serviço",
  [MEDIA_URLS_TAB_MULTIPLE_PRODUCTS]: "Vários produtos",
  [MEDIA_URLS_TAB_MULTIPLE_SERVICES]: "Vários serviços",
  [MEDIA_URLS_MODE_EXPLANATION_PRODUCTS]:
    "Decida se esta campanha se concentrará em um único produto ou em vários. Cada produto pode ter seu próprio link e criativos.",
  [MEDIA_URLS_MODE_EXPLANATION_SERVICES]:
    "Decida se esta campanha se concentrará em um único serviço ou em vários. Cada serviço pode ter seu próprio link e criativos.",
  [CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_QUESTION]:
    "Qual ação de conversão quer rastrear?",
  [CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_DESCRIPTION]:
    "Selecione a ação de conversão que quer rastrear na sua campanha.",
  [CREATE_ADS_CAMPAIGN_LOADING_GETTING_REQUIRED_INFORMATION]:
    "Definindo a estratégia da sua campanha...",
  [CREATE_ADS_CAMPAIGN_LOADING_ANALYZING_INFORMATION]:
    "Analisando dados para encontrar oportunidades de alto impacto...",
  [CREATE_ADS_CAMPAIGN_LOADING_GENERATING_RECOMMENDATIONS]:
    "Montando a sua estratégia de anúncios otimizada...",
  [CREATE_ADS_CAMPAIGN_LOADING_FINALIZING_DETAILS]:
    "Preparando sua campanha para revisão...",
  [CREATE_ADS_CAMPAIGN_LOADING_CREATING_INSTANT_FORM]:
    "Criando formulário instantâneo",
  [CREATE_ADS_CAMPAIGN_INTRO_TITLE]: "{{NAME_BUSINESS}} AI",
  [CREATE_ADS_CAMPAIGN_INTRO_DESCRIPTION]:
    "Uma solução poderosa para a criação, otimização e gestão das suas campanhas em múltiplas plataformas",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_CREATE_CAMPAIGN]:
    "Crie campanhas publicitárias em minutos",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_CREATE_CAMPAIGN]:
    "Crie campanhas publicitárias em minutos",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_OPTIMIZE_WITH_AI]:
    "Otimize suas campanhas com IA",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_MANAGE_SIMPLE]:
    "Gerencie suas campanhas de forma simples",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ANALYZE_PERFORMANCE]:
    "Analise o desempenho das suas campanhas",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ALL_IN_ONE_PLACE]:
    "E muito mais! Tudo em um só lugar.",
  [CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_DESCRIPTION]:
    "O que você está esperando para começar? Crie sua campanha agora!",
  [CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_BUTTON]: "Criar campanha",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_PRODUCT_ADVERTISE]:
    "- Qual é o produto ou serviço que deseja promover?",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_COMMUNICATE]:
    "- Qual é a mensagem principal que quer comunicar?",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_SEGMENTATION]:
    "- A qual público-alvo deseja chegar?",
  [CREATE_ADS_LANGUAGE_QUESTION]: "Em que idioma estará sua campanha?",
  [CREATE_ADS_PLATFORMS_QUESTION]:
    "Em quais plataformas deseja publicar sua campanha?",
  [CREATE_ADS_CAMPAIGN_QUICK_MODE]: "Campanha Rápida",
  [CREATE_ADS_CAMPAIGN_QUICK_MODE_DESCRIPTION]:
    "Inteligência artificial para iniciantes. Configuração rápida e simples com as melhores práticas automatizadas",
  [CREATE_ADS_CAMPAIGN_ADVANCED_MODE]: "Avançado",
  [CREATE_ADS_CAMPAIGN_ADVANCED_MODE_DESCRIPTION]:
    "Configure sua campanha, selecione objetivos, eventos de conversão e contas publicitárias",
  [CREATE_ADS_CAMPAIGN_VIDEO_URLS_QUESTION]: "O que videos quer promover?",
  [CREATE_ADS_CAMPAIGN_VIDEO_URLS_DESCRIPTION]:
    "Selecione os vídeos que quer promover na sua campanha",
  [CREATE_ADS_CAMPAIGN_IMAGE_URLS_QUESTION]: "O que imagens quer promover?",
  [CREATE_ADS_CAMPAIGN_IMAGE_URLS_DESCRIPTION_QUESTION]:
    "Selecione as imagens que quer promover na sua campanha",
  [CREATE_ADS_CAMPAIGN_PROJECTION_QUESTION]: "Projeção da campanha",
  [CREATE_ADS_CAMPAIGN_MERCHANT_ID_QUESTION]:
    "Quer promover produtos nesta campanha?",

  // ADS CAMPAIGN REPORTS
  [ADS_CAMPAIGN_STATISTICS_CURRENT_STATE_TITLE]: "Atual metrics",
  [ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_OVERVIEW]: "Resumo",
  [ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_STATISTICS]: "Estatísticas",
  [ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_METRICS]: "Métricas",
  [ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_PERFORMING_ASSETS]:
    "Ativos de Mayor Desempenho",
  [ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_INSIGHTS]: "Insights",
  [ADS_CAMPAIGNS_STATISTICS_PERFORMANCE_TRENDS]: "Tendencias do desempenho",
  [ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPM]: "Custo por mil impressões",
  [ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPC]: "Custo por clique",
  [ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPA]: "Custo por ação",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP]:
    "Melhor grupo de ativos",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_GROUP]:
    "Melhor grupo de anúncios",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD]: "Melhor criativo",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_TITLE]:
    "Título mais visto",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_DESCRIPTION]:
    "Descrição mais vista",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_KEYWORDS]: "Principais palavras-chave",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_VIDEOS]: "Principais vídeos",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_IMAGES]: "Imagens principales",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_HEADLINES]: "Principais títulos",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_LONG_HEADLINES]:
    "Principais títulos longos",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_DESCRIPTIONS]: "Principais descrições",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AUDIENCE_BREAKDOWN]:
    "Desglose de Audiência",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_HIGHEST_PERFORMING]: "Maior desempenho",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AGE_RANGE_LABEL]: "Faixa",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_PLAY_VIDEO]: "Reproduzir vídeo",

  //ADS CAMPAIGNS LOGS
  [ADS_CAMPAIGNS_LOGS_TITLE]: "Histórico de alterações",
  [ADS_CAMPAIGNS_LOGS_CONTEXT_TITLE]: "Contexto da Campanha",
  [BUTTON_REVERT_CHANGE]: "Reverter",
  [REVERT_CHANGE_CONFIRM_TITLE]: "Revertir Cambio?",
  [REVERT_CHANGE_CONFIRM_TEXT]:
    "Esta alteração será aplicada ao rascunho. Você deverá salvar ou publicar para aplicá-la na plataforma.",
  [REVERT_CHANGE_SUCCESS]: "Alteração revertida com sucesso",
  [REVERT_CHANGE_ERROR]: "Não foi possível reverter a alteração",

  // SETTINGS
  [SETTINGS_TITLE]: "Configuração",
  [API_KEYS_TAB_TITLE]: "API keys",
  [BYOK_SETTINGS_DESCRIPTION]:
    "Configure suas próprias chaves de provedor e escolha se, por padrão, o uso de IA deve ser cobrado com suas chaves ou com créditos.",
  [BYOK_DEFAULT_PAYMENT_MODE_LABEL]: "Modo de uso padrão",
  [BYOK_DEFAULT_PAYMENT_MODE_HELPER]:
    "Quando o BYOK está selecionado, {{NAME_BUSINESS}} usará sua chave compatível do provedor. Se faltar uma chave obrigatória, a ação fará fallback automático para créditos.",
  [BYOK_PAYMENT_MODE_CREDITS]: "Créditos",
  [BYOK_PAYMENT_MODE_BYOK]: "Traga a sua própria chave",
  [BYOK_CONFIGURED_PREVIEW]: "Chave configurada: {{preview}}",
  [BYOK_NOT_CONFIGURED]: "Não key configured yet.",
  [BYOK_PROVIDER_INPUT_LABEL]: "Chave de API da {{provider}}",
  [BYOK_PROVIDER_INPUT_PLACEHOLDER]: "Cole uma nova chave de API",
  [BYOK_SAVE_BUTTON]: "Salvar configuração",
  [BYOK_SAVING_BUTTON]: "Salvando...",
  [BYOK_SAVE_SUCCESS_TITLE]: "Chaves de API atualizadas",
  [BYOK_SAVE_SUCCESS_DESCRIPTION]:
    "A configuração BYOK foi salva corretamente.",
  [BYOK_SAVE_ERROR]:
    "Não foi possível salvar a configuração BYOK. Tente novamente.",
  [BYOK_PROVIDER_KEYS_TITLE]: "Chaves de provedor",
  [BYOK_PROVIDERS_COUNTER]: "{{configured}} de {{total}} configuradas",
  [BYOK_KEY_CONFIGURED_STATUS]: "Chave configurada",
  [BYOK_NO_KEY_CONFIGURED_STATUS]: "Não key configured",
  [BYOK_REPLACE_KEY]: "Substituir chave",
  [BYOK_DELETE_KEY]: "Excluir llave",
  [BYOK_DELETE_KEY_TITLE]: "Excluir API key",
  [BYOK_DELETE_KEY_DESCRIPTION]:
    "Excluir a API key de {{provider}}? {{NAME_BUSINESS}} usará créditos como reserva para esse provedor.",
  [BYOK_DELETE_KEY_ERROR]:
    "Não foi possível excluir esta chave de API. Tente novamente.",
  [BYOK_DELETE_KEY_SUCCESS_TITLE]: "Chave de API removida",
  [BYOK_DELETE_KEY_SUCCESS_DESCRIPTION]:
    "A API key de {{provider}} foi removida da sua configuração BYOK.",
  [BYOK_KEY_ENCRYPTED_NOTICE]:
    "Sua chave é armazenada de forma criptografada e segura. Nunca será exibida em texto simples.",
  [BYOK_DEFAULT_PAYMENT_MODE_DESCRIPTION]:
    "Escolha como o uso de IA é cobrado por padrão em todos os provedores.",
  [BYOK_PROVIDERS_WILL_BE_USED]: "Provedores que serão usados:",
  [BYOK_CONFIGURE_MISSING_PROVIDERS]: "Configurar provedores faltantes",
  [MODAL_API_KEYS_ARIA_LABEL]: "Configuração de API keys",

  // CAMPAIGNS
  [CAMPAIGNS_TITLE]: "Campanhas",
  [CAMPAIGNS_DESCRIPTION]:
    "Crie sua campanha, selecione e pague os candidatos e aprove o conteúdo",
  [CAMPAIGNS_SEARCHBAR_PLACEHOLDER]: "Buscar campanhas",
  [CAMPAIGNS_TABLE_COLUMN_NAME]: "Nome",
  [CAMPAIGNS_TABLE_COLUMN_PLATFORMS]: "Plataformas",
  [CAMPAIGNS_TABLE_COLUMN_STATUS]: "Situação",
  [CAMPAIGN_ACTIVATE]: "Ativar campanha",
  [CAMPAIGN_DEACTIVATE]: "Desativar campanha",
  [CAMPAIGN_ACTIVATE_TIME_CONFIRMATION]:
    "Tem certeza de que deseja ativar esta campanha? Sua campanha ficará ativa por no mínimo 24 horas",
  [CAMPAIGN_DEACTIVATE_TIME]:
    "Você deve aguardar 24 horas para desativar a campanha desde a sua última ativação",
  [CAMPAIGN_FINISHED_TIME]:
    "Você deve aguardar 24 horas para finalizar a campanha desde a sua última ativação",
  [CAMPAIGN_DEACTIVATE_APPLICANTS_ACCEPTED]:
    "Você não pode desativar a campanha até que todos os candidatos aceitos tenham entregue seu conteúdo",
  [CAMPAIGN_FINISH_APPLICANTS_ACCEPTED]:
    "Você não pode finalizar a campanha até que todos os candidatos aceitos tenham entregue seu conteúdo",
  [CAMPAIGN_ACTIVATE_FIELDS_REQUIRED]:
    "Esta campanha tem campos obrigatórios vazios; para ativá-la, preencha-os",
  [CAMPAIGN_ACTIVATE_MIN_BUDGET_CREATOR]:
    "O orçamento por cada criador de conteúdo não deve ser menor que {{value,currency}}",
  [CAMPAIGN_ACTIVATE_TRAFFIC_LINK]:
    "O link de tráfego deve ser uma URL válida.",
  [CAMPAIGN_ACTIVATE_HAS_COLLABORATION_USER_NAME_INSTAGRAM]:
    "O usuário do Instagram é obrigatório se você for fazer uma colaboração",
  [CAMPAIGN_ACTIVATE_ATTACHMENT_LINK]:
    "O link de referência da campanha deve ser uma URL válida",
  [CAMPAIGN_FINISHED_CONFIRMATION]:
    "Tem certeza de que deseja finalizar esta campanha?",
  [CAMPAIGN_HAS_BEEN_FINISHED]: "Esta campanha foi finalizada",
  [CAMPAIGN_FINISH_ONBOARDING]:
    "Você terminou o tutorial e agora sabe como gerar colaborações mais personalizadas com criadores de conteúdo.",

  // CAMPAIGN DETAIL
  [CAMPAIGN_DETAIL_TITLE]: "Campanha {{name}}",
  [CAMPAIGN_DETAIL_APPLICANTS_ACCEPTED_TITLE]: "Participantes",
  [CAMPAIGN_DETAIL_APPLICANTS_PENDING_TITLE]: "Solicitações",
  [CAMPAIGN_DETAIL_APPLICANTS_INVITED_TITLE]: "Convidados",
  [CAMPAIGN_DETAIL_CREATORS_INVITED_TITLE]: "Criadores invitados",
  [CAMPAIGN_DETAIL_CAMPAIGN_INFORMATION_TITLE]: "Informação da campanha",
  [CAMPAIGN_DETAIL_APPLICANT_PAYMENT_DESCRIPTION]:
    "Seu pagamento foi realizado com sucesso; agora você deve aguardar que {{influencerName}} gere o conteúdo para sua aprovação",
  [CAMPAIGN_DETAIL_APPLICANT_PAYMENT_ADDITIONAL_DESCRIPTION]:
    "Além disso, você pode enviar um convite em permuta de produtos ao criador de conteúdo para que ele possa acessar seus produtos gratuitamente",
  [CAMPAIGN_DETAIL_REJECT_APPLICANT_CONFIRMATION]:
    "Tem certeza de que deseja rejeitar este candidato?",
  [CAMPAIGN_FIELDS_REQUIRED]:
    "Os campos que não são de configuração avançada são obrigatórios",
  [CAMPAIGN_NAME_PLACEHOLDER]: "Nome da campanha",
  [CAMPAIGN_DESCRIPTION_PLACEHOLDER]: "Descrição da campanha",
  [CAMPAIGN_GOAL_PLACEHOLDER]: "Objetivo da campanha",
  [CAMPAIGN_BUDGET_PLACEHOLDER]: "Orçamento individual por cada conteúdo",
  [CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER]:
    "Com conteúdo publicado nas redes sociais",
  [CAMPAIGN_PLATFORMS_PLACEHOLDER]: "Plataformas para sua campanha",
  [CAMPAIGN_TYPE_CONTENT_MEDIA_PLACEHOLDER]:
    "Tipo de conteúdo para sua campanha",
  [CAMPAIGN_TYPE_CONTENT_PLACEHOLDER]: "Formatos para sua campanha",
  [CAMPAIGN_COPY_POST_PLACEHOLDER]:
    "Copy que acompanhará o conteúdo (Opcional)",
  [CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER]: "Link para onde quer levar o tráfego",
  [CAMPAIGN_HAS_COLLABORATION_PLACEHOLDER]:
    "Quero que o conteúdo seja publicado com uma colaboração do Instagram",
  [CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER]:
    "Principais atributos do produto a comunicar",
  [CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER]: "Mensagem a comunicar com o conteúdo",
  [CAMPAIGN_DATES_START_DATE_PLACEHOLDER]: "Data de início da campanha",
  [CAMPAIGN_DATES_END_DATE_PLACEHOLDER]: "Data de término da campanha",
  [CAMPAIGN_REPOST_PLACEHOLDER]:
    "Deseja que o criador de conteúdo marque seu perfil?",
  [CAMPAIGN_REPOST_PLACEHOLDER_ITEM]: "Usuário de {{platform}}",
  [CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER]:
    "Cidades de interesse para impactar com sua campanha",
  [CAMPAIGN_AGE_RANGE_PLACEHOLDER]:
    "Faixa etária que os criadores de conteúdo devem ter para sua campanha",
  [CAMPAIGN_BRIEF_PLACEHOLDER]: "Brief da Marca",
  [CAMPAIGN_BRIEF_DESCRIPTION]:
    "É um pequeno documento criativo com toda a informação detalhada e guia de ação para a campanha; deve estar em formato PDF.",
  [CAMPAIGN_ATTACHMENT_FILE_PLACEHOLDER]: "Referência de conteúdo da campanha",
  [CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION]:
    "Uma imagem ou vídeo que sirva de referência para os criadores de conteúdo de como será a campanha",
  [CAMPAIGN_ATTACHMENT_LINK_TITLE]: "Referência no link da campanha",
  [CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION]:
    "Um link para outra página com conteúdo que sirva de referência para os criadores de conteúdo de como será a campanha",
  [CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER]: "Link de referência",
  [CAMPAIGN_GENDERS_PLACEHOLDER]: "Generos para a campanha",
  [CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER]:
    "Perfil(is) que podem servir de referência",
  [CAMPAIGN_HASHTAG_PLACEHOLDER]: "#Hashtag da sua campanha",
  [CAMPAIGN_MESSAGE_TONE_PLACEHOLDER]: "Tom da mensagem da sua campanha",
  [CAMPAIGN_ENVIRONMENT_PLACEHOLDER]: "Ambiente onde o conteúdo será feito",
  [CAMPAIGN_COLORS_CONTENT_PLACEHOLDER]: "Cores que devem aparecer no conteúdo",
  [CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER]:
    "Cores que NÃO devem aparecer no conteúdo",
  [CAMPAIGN_KEY_WORDS_PLACEHOLDER]: "Palavras-chave da sua campanha",
  [CAMPAIGN_PROHIBITED_KEY_WORDS_PLACEHOLDER]:
    "O que NÃO se deve dizer durante a campanha",
  [CAMPAIGN_OUTFIT_PLACEHOLDER]: "Vestimenta recomendada",

  // CREATE CAMPAIGN
  [CREATE_CAMPAIGN_QUESTION]: "Pergunta {{question}}",
  [CREATE_CAMPAIGN_ACCEPT_TERMS_DISCLAIMER]: `Ao criar uma campanha, você está aceitando os Termos e Condições de {{NAME_BUSINESS}}`,
  [CREATE_CAMPAIGN_NAME_EXAMPLE]: "Campanha de ejemplo",
  [CREATE_CAMPAIGN_NAME_REQUIRED]: "O nome é obrigatório",
  [CREATE_CAMPAIGN_DESCRIPTION_REQUIRED]: "A descrição é obrigatória",
  [CREATE_CAMPAIGN_BUDGET_REQUIRED]: "O orçamento é obrigatório",
  [CREATE_CAMPAIGN_BUDGET_MIN_VALUE]:
    "O orçamento por cada criador de conteúdo não deve ser menor que {{value,currency}}",
  [CREATE_CAMPAIGN_PLATFORMS_REQUIRED]:
    "Você deve selecionar ao menos uma plataforma",
  [CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA]:
    "Você deve selecionar ao menos um tipo de conteúdo",
  [CREATE_CAMPAIGN_TYPE_CONTENT]: "Você deve selecionar ao menos um formato",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_REQUIRED]:
    "O link para onde se quer levar o tráfego é obrigatório",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_VALID]:
    "O link para onde você quer levar o tráfego deve ser uma URL válida.",
  [CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_REQUIRED]:
    "Os atributos dos produtos são obrigatórios",
  [CREATE_CAMPAIGN_MESSAGE_CONTENT_REQUIRED]:
    "A mensagem a comunicar com o conteúdo é obrigatória",
  [CREATE_CAMPAIGN_DATES_REQUIRED]: "As duas datas são obrigatórias",
  [CREATE_CAMPAIGN_REPOST_HAS_COLLABORATION]:
    "Como você fará uma colaboração no Instagram, o username do Instagram é obrigatório",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_REQUIRED]: "As cidades são obrigatórias",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK]: "A URL deve ser válida",
  [CREATE_CAMPAIGN_HAS_BEEN_ACTIVATE]: "Campanha ativada",
  [CREATE_CAMPAIGN_HAS_BEEN_SAVE]: "Campanha salva",
  [CREATE_CAMPAIGN_SAVE_PROGRESS_NAME_REQUIRED]:
    "Para salvar o progresso você deve pelo menos digitar o nome da campanha",
  [CREATE_CAMPAIGN_SAVE_PROGRESS]: "Seu progresso foi salvo",
  [CREATE_CAMPAIGN_NAME_QUESTION]: "Qual será o nome da sua campanha?",
  [CREATE_CAMPAIGN_NAME_PLACEHOLDER]: "Nova coleção X de sapatos",
  [CREATE_CAMPAIGN_DESCRIPTION_QUESTION]:
    "Crie uma descrição chamativa e clara da sua campanha para que os criadores se animem a participar!",
  [CREATE_CAMPAIGN_DESCRIPTION_PLACEHOLDER]:
    "A coleção de sapatos X que revolucionará o mercado de calçados",
  [CREATE_CAMPAIGN_GOAL_QUESTION]: "Qual é o objetivo da sua campanha?",
  [CREATE_CAMPAIGN_GOAL_PLACEHOLDER]: "Selecione uma opção",
  [CREATE_CAMPAIGN_GOAL_BRAND_AWARENESS_OPTION]: "Marca awareness",
  [CREATE_CAMPAIGN_GOAL_ENGAGEMENT_OPTION]: "Engajamento",
  [CREATE_CAMPAIGN_GOAL_LEADS_OPTION]: "Leads",
  [CREATE_CAMPAIGN_GOAL_SALES_OPTION]: "Conversão de venda",
  [CREATE_CAMPAIGN_GOAL_REQUIRED]: "Você deve selecionar um objetivo",
  [CREATE_CAMPAIGN_BUDGET_QUESTION]:
    "Quanto você está disposto a pagar a cada criador de conteúdo?",
  [CREATE_CAMPAIGN_BUDGET_DESCRIPTION]:
    "Com base na quantidade de criadores de que você precisa ({{quantity}}), sugerimos um orçamento de {{budget,currency}}",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_QUESTION]: "Tipo de campanha",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_DESCRIPTION]:
    "A menção nas redes significa que os criadores publicarão o conteúdo mencionando sua conta; se você selecionar que não, o conteúdo simplesmente será entregue a você.",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER]:
    "Selecione uma opção",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_UGC_OPTION]:
    "UGC - Obtenha apenas o conteúdo para que você o publique",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_REQUIRED]:
    "Você deve selecionar uma opção",
  [CREATE_CAMPAIGN_PLATFORMS]:
    "Quais serão as plataformas que você quer para a sua campanha?",
  [CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA_QUESTION]:
    "Qual será o tipo de conteúdo para sua campanha?",
  [CREATE_CAMPAIGN_TYPE_CONTENT_QUESTION]:
    "Qual será o formato para sua campanha?",
  [CREATE_CAMPAIGN_COPYWRITING_QUESTION]: `Qual seria o texto "copy" que acompanharia o conteúdo? (Opcional)`,
  [CREATE_CAMPAIGN_COPYWRITING_PLACEHOLDER]:
    "Foi lançada a nova coleção de Sapatos X, atreva-se a experimentá-los!",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_QUESTION]:
    "Qual é o link para onde quer levar o tráfego?",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER]: "https://www.seusite.com",
  [CREATE_CAMPAIGN_HAS_COLLABORATION_QUESTION]:
    "Quer que o conteúdo seja publicado com uma colaboração do Instagram?",
  [CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_QUESTION]:
    "Quais são os principais atributos do produto ou serviço a comunicar com o conteúdo?",
  [CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER]:
    "Novo, revolucionário, original, singular etc.",
  [CREATE_CAMPAIGN_MESSAGE_CONTENT_QUESTION]:
    "Qual é a mensagem a comunicar com o conteúdo?",
  [CREATE_CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER]:
    "Deve-se comunicar que não há nenhum produto igual no mercado, porque é uma nova tendência",
  [CREATE_CAMPAIGN_DATES_QUESTION]:
    "Qual será a data de início e de término da sua campanha?",
  [CREATE_CAMPAIGN_DATES_DESCRIPTION]:
    "A duração da campanha deve ser de no mínimo uma semana; por isso há um intervalo obrigatório entre a data de início e a de término, além de que deve ser criada com uma semana de antecedência.",
  [CREATE_CAMPAIGN_DATES_START_DATE_PLACEHOLDER]: "Data de início da campanha",
  [CREATE_CAMPAIGN_DATES_END_DATE_PLACEHOLDER]: "Data de término da campanha",
  [CREATE_CAMPAIGN_REPOST_QUESTION]:
    "Se quiser que o criador de conteúdo marque seu perfil, digite o @. Caso contrário, clique em próximo",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_QUESTION]:
    "Quais são as cidades de interesse onde quer impactar com sua campanha?",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER]: "Selecione as cidades",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_ALL_OPTION]: "Todas",
  [CREATE_CAMPAIGN_AGE_RANGE_QUESTION]:
    "Qual é a faixa etária que os criadores de conteúdo devem ter para sua campanha?",
  [CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_QUESTION]:
    "Que estilo de conteúdo quer para sua campanha?",
  [CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_PLACEHOLDER]: "Selecione um estilo",
  [CREATE_CAMPAIGN_BRIEF_QUESTION]: "Envie o brief da marca",
  [CREATE_CAMPAIGN_BRIEF_DESCRIPTION]:
    "É um pequeno documento criativo com toda a informação detalhada e guia de ação para a campanha; deve estar em formato PDF.",
  [CREATE_CAMPAIGN_UPLOAD_BRIEF]: "Enviar brief",
  [CREATE_CAMPAIGN_REMOVED_BRIEF]: "Excluir brief",
  [CREATE_CAMPAIGN_ATTACHMENT_FILE_QUESTION]:
    "Envie uma referência de conteúdo da campanha",
  [CREATE_CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION]:
    "Uma imagem ou vídeo que sirva de referência para os criadores de conteúdo de como será a campanha.",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK_QUESTION]:
    "Envie uma referência em link de conteúdo da campanha",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION]:
    "Um link para outra página com conteúdo que sirva de referência para os criadores de conteúdo de como será a campanha.",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER]: "https://www.suamarca.com/",
  [CREATE_CAMPAIGN_QUANTITY_GENDER_QUESTION]:
    "Quais gêneros você precisa para sua campanha?",
  [CREATE_CAMPAIGN_REFERENCE_PROFILES_QUESTION]:
    "Você tem perfis que possam servir de referência?",
  [CREATE_CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER]:
    "@xavi, @laura, @daniel, @maria, etc.",
  [CREATE_CAMPAIGN_HASHTAG_QUESTION]: "Qual será o hashtag da sua campanha?",
  [CREATE_CAMPAIGN_HASHTAG_PLACEHOLDER]: "#SapatosXTrend",
  [CREATE_CAMPAIGN_MESSAGE_TONE_QUESTION]:
    "Como deve ser o tom da mensagem da sua campanha?",
  [CREATE_CAMPAIGN_MESSAGE_TONE_PLACEHOLDER]:
    "Sério, bem-humorado, calmo, livre etc.",
  [CREATE_CAMPAIGN_ENVIRONMENT_QUESTION]:
    "Como deve ser o ambiente onde o conteúdo será feito?",
  [CREATE_CAMPAIGN_ENVIRONMENT_PLACEHOLDER]:
    "Caseiro, natural, comercial, livre etc.",
  [CREATE_CAMPAIGN_COLORS_CONTENT_QUESTION]:
    "Quais cores devem aparecer no conteúdo?",
  [CREATE_CAMPAIGN_COLORS_CONTENT_PLACEHOLDER]: "Azul e branco",
  [CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_QUESTION]:
    "Quais cores NÃO podem aparecer no conteúdo?",
  [CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER]: "Rojo e negro",
  [CREATE_CAMPAIGN_KEY_WORDS_QUESTION]:
    "Quais são as palavras-chave da sua campanha?",
  [CREATE_CAMPAIGN_KEY_WORDS_PLACEHOLDER]:
    "Revolucionário, tendência, novo etc.",
  [CREATE_CAMPAIGN_PROHIBITED_WORDS_QUESTION]:
    "O que NÃO se deve dizer durante a campanha?",
  [CREATE_CAMPAIGN_PROHIBITED_WORDS_PLACEHOLDER]:
    "Palavras, detalhes, referência a outras marcas etc.",
  [CREATE_CAMPAIGN_OUTFIT_QUESTION]: "Hay alguna vestimenta recomendada?",
  [CREATE_CAMPAIGN_OUTFIT_PLACEHOLDER]:
    "O que se deve ou não mostrar no físico",
  [CREATE_CAMPAIGN_OUTFIT_PLACEHOLDER]:
    "O que se deve ou não mostrar no físico",
  [CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE]:
    "Pronto! Aqui está o roteiro do seu conteúdo",
  [CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE_GENERATING]:
    "Estamos gerando um roteiro de conteúdo para sua campanha...",
  [CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_SCRIPT_LABEL]:
    "Guión de campanha",

  //APPLICANTS
  [APPLICANTS_STATUS_PENDING]: "Pendente",
  [APPLICANTS_STATUS_ACCEPTED]: "Conteúdo Pendente",
  [APPLICANTS_STATUS_REJECTED]: "Rejeitado",
  [APPLICANTS_STATUS_CONTENT_SUBMITTED]: "Conteúdo por Revisar",
  [APPLICANTS_STATUS_CONTENT_REVISIONS]: "Comentário Enviado",
  [APPLICANTS_STATUS_CONTENT_PENDING_SOCIAL]: "Pendente de Publicação a Redes",
  [APPLICANTS_STATUS_CONTENT_PENDING_ANALYTICS]: "Pendente de Analítica",
  [APPLICANTS_STATUS_DELIVERED]: "Conteúdo Pronto",
  [APPLICANT_CONTENT_OF_CREATOR]: "Conteúdo de {{influencerName}}",
  [APPLICANT_REVISION_PLACEHOLDER]: "Envie uma revisão ao criador de conteúdo",

  //REPORTS SHOP
  [START_DATE_PLACEHOLDER]: "Data de início",
  [END_DATE_PLACEHOLDER]: "Data de término",
  [LIKES]: "Likes",
  [SHARES]: "Compartilhars",

  //GALLERY
  [GALLERY_TITLE]: "Conteúdo",
  [MODAL_GALLERY_ARIA_LABEL]: "Modal de galería de conteúdo da marca",
  [MODAL_GALLERY_EMPTY_CONTENT]: "Ainda não há conteúdo na galeria",
  [SELECT_ACCOUNT_TO_LOAD_GALLERY_CONTENT]:
    "Selecione uma plataforma e uma conta para carregar o conteúdo",
  [SELECT_YOUTUBE_ACCOUNT_TO_LOAD_GALLERY_CONTENT]:
    "Selecione uma conta do YouTube para carregar o conteúdo",
  [MODAL_GALLERY_NO_MORE_CONTENT]: "Não há mais conteúdo para exibir",
  [MODAL_FILTERS_LABEL]: "Filtros",

  // ADGROUP PLACEMENTS
  [META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE]:
    "Posicionamentos Advantage+ (recomendado)",
  [META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE_DESCRIPTION]:
    "Use as localizações Advantage+ para maximizar seu orçamento e ajudar a mostrar seus anúncios a mais pessoas.",
  [META_ADGROUP_PLACEMENTS_TYPE_MANUAL]: "Posicionamentos manuais",
  [META_ADGROUP_PLACEMENTS_TYPE_MANUAL_DESCRIPTION]:
    "Escolha manualmente as localizações onde quer mostrar seu anúncio. Quanto mais localizações você selecionar, mais oportunidades terá de alcançar seu público-alvo.",

  //MODAL_MEDIA
  [MODAL_MEDIA_ARIA_LABEL]: "Modal de mídia",

  //MODAL UPLOAD TIKTOK
  [MODAL_UPLOAD_TIKTOK_ARIA_LABEL]: "Enviar vídeo para o TikTok",
  [MODAL_UPLOAD_TIKTOK_TITLE]: "Enviar vídeo para o TikTok",
  [MODAL_UPLOAD_FAILED_GET_CONFIGURATION]:
    "Ocorreu um erro ao obter a configuração; tente mais tarde ou entre em contato com o suporte.",
  [MODAL_UPLOAD_CONTENT_UPLOADED]: "Conteúdo subido!",
  [MODAL_UPLOAD_TIKTOK_VIDEO_UPLOADED_DESCRIPTION]:
    "O vídeo foi enviado corretamente ao TikTok; aparecerá no seu perfil em alguns instantes",
  [MODAL_UPLOAD_FAILED_GENERATE_DESCRIPTION]:
    "Não foi possível recuperar a informação da colaboração; entre em contato com o suporte",
  [MODAL_UPLOAD_TIKTOK_DESCRIPTION_LABEL]: "Descrição",
  [MODAL_UPLOAD_TIKTOK_DESCRIPTION_PLACEHOLDER]:
    "Lembre-se de adicionar uma descrição chamativa ao seu vídeo, marcar os usuários que aparecem nele e adicionar hashtags relevantes.",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_LABEL]: "Quem pode ver este vídeo?",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_PUBLIC_OPTION]: "Público",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_FOLLOWERS_OPTION]: "Seguidores",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_ONLY_I_OPTION]: "Somente eu",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_PLACEHOLDER]: "Permitir que os usuários",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_COMMENT_OPTION]: "Comentário",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_DUOS_OPTION]: "Dueto",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_CUT_OPTION]: "Recortar",

  //MODAL MAP RADIUS
  [MARKER_LIST]: "Lista de marcadores",
  [MARKER_NUMBER_LIST]: "Marcador #{{value}}",
  [MARKER_TYPE]: "Tipo",
  [MARKER_LNG]: "Lng",
  [MARKER_LAT]: "Lat",
  [MARKER_RADIUS]: "Raio",

  //MODAL PREVIEW OPTIMIZATION
  [MODAL_PREVIEW_OPTIMIZATIONS_TITLE]: "Aplicar alteraçãos",
  [MODAL_PREVIEW_OPTIMIZATIONS_DESCRIPTION]:
    "Revise e aprove as alterações que serão aplicadas à sua campanha",
  [WHY_THIS_OPTIMIZATION]: "Por que esta otimização?",

  //MODAL STEP DATA
  [MODAL_STEP_DATA_TITLE]: "Informação a modificar",

  //MODAL MESSAGE TEMPLATE
  [MODAL_MESSAGE_TEMPLATE_TITLE]: "Criar um modelo de mensagem",
  [MODAL_MESSAGE_TEMPLATE_DESCRIPTION]:
    "Defina uma configuração de mensagens para quando os usuários clicarem no seu anúncio.",

  //MODAL PRODUCT TAGS META
  [MODAL_PRODUCT_TAGS_TITLE_META]: "Produto tags",
  [MODAL_PRODUCT_TAGS_DESCRIPTION_META]:
    "Ative esta opção para exibir uma etiqueta de informação dos seus produtos no seu anúncio",

  //MODAL CATALOG LABELS
  [MODAL_CATALOG_LABELS_TITLE]: "Etiquetas de catálogo",
  [MODAL_CATALOG_LABELS_DESCRIPTION]:
    "Configure etiquetas de catálogo para o seu anúncio",

  //MODAL SITE LINKS
  [MODAL_SITE_LINKS_TITLE]: "Links de Sitio",
  [MODAL_SITE_LINKS_DESCRIPTION]:
    "Configure os links de site para o seu anúncio",
  [MODAL_SITE_LINK_TITLE]: "Etiqueta",
  [MODAL_SITE_LINK_IMAGE_URL]: "Miniatura",
  [MODAL_SITE_LINK_URL]: "URL",

  //MODAL INSTANT FORMS LIST
  [MODAL_INSTANT_FORMS_LIST_TITLE]: "Formulários Instantâneos",
  [MODAL_INSTANT_FORMS_LIST_DESCRIPTION]:
    "Selecione o formulário que quer usar para capturar potenciais clientes.",
  [MODAL_INSTANT_FORMS_EMPTY_TEXT]: "Não há formulários instantâneos criados",

  //MODAL LEAD FORMS LIST
  [MODAL_LEAD_FORMS_LIST_TITLE]: "Formulários",
  [MODAL_LEAD_FORMS_LIST_DESCRIPTION]:
    "Selecione um formulário de potenciais clientes para seu anúncio. Um formulário que não esteja em inglês só serve em campanhas do mesmo idioma.",
  [MODAL_LEAD_FORMS_EMPTY_TEXT]:
    "Não há formulários de clientes potenciais criados",
  [MODAL_LEAD_FORMS_DUPLICATE_AND_EDIT]: "Duplicar e editar",
  [MODAL_LEAD_FORMS_VIEW]: "Ver",
  [MODAL_LEAD_FORMS_COPY_NAME_PREFIX]: "Cópia de",

  //MODAL CREATE LEAD FORM
  [MODAL_CREATE_LEAD_FORM_TITLE]: "Criar Formulário",
  [MODAL_VIEW_LEAD_FORM_TITLE]: "Ver Formulário",
  [INSTANT_FORM_PREVIEW_MORE]: "+{{count}} mais",
  [MODAL_CREATE_LEAD_FORM_DESCRIPTION]:
    "Crie um formulário do LinkedIn para capturar clientes potenciais na sua campanha",
  [MODAL_VIEW_LEAD_FORM_DESCRIPTION]:
    "Consulte os dados do formulário. Nesta visualização não é possível editar nem criar.",
  [MODAL_VIEW_LEAD_FORM_LOAD_ERROR]:
    "Não foi possível carregar os detalhes do formulário. Tente novamente em alguns minutos.",
  [MODAL_CREATE_LEAD_FORM_LOCALE_WARNING]:
    "Um formulário que não esteja em inglês só serve para campanhas do mesmo idioma",
  [MODAL_CREATE_LEAD_FORM_NAME]: "Nome do formulário",
  [MODAL_CREATE_LEAD_FORM_HEADLINE]: "Título",
  [MODAL_CREATE_LEAD_FORM_DETAILS]: "Detalhes",
  [MODAL_CREATE_LEAD_FORM_SECTION_FORM]: "Detalhes do formulário",
  [MODAL_CREATE_LEAD_FORM_SECTION_CONTACT]: "Detalhes do contato",
  [MODAL_CREATE_LEAD_FORM_SECTION_PRIVACY]: "Privacidade de dados",
  [MODAL_CREATE_LEAD_FORM_SECTION_CONFIRMATION]: "Confirmaration",
  [MODAL_CREATE_LEAD_FORM_PROFILE_FIELDS]: "Perfil fields",
  [MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME]: "Nome",
  [MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME]: "Sobrenome",
  [MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL]: "E-mail",
  [MODAL_CREATE_LEAD_FORM_PROFILE_PHONE]: "Telefone",
  [MODAL_CREATE_LEAD_FORM_PROFILE_CITY]: "Cidade",
  [MODAL_CREATE_LEAD_FORM_PROFILE_STATE]: "Status",
  [MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY]: "País",
  [MODAL_CREATE_LEAD_FORM_PROFILE_ZIP]: "Código postal",
  [MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE]: "Cargo",
  [MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY]: "Nome da empresa",
  [MODAL_CREATE_LEAD_FORM_PROFILE_LINKEDIN]: "URL do perfil de LinkedIn",
  [MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTIONS]: "Perguntas personalizadas",
  [MODAL_CREATE_LEAD_FORM_ADD_CUSTOM_QUESTION]:
    "Adicionar pergunta personalizada",
  [MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTION_HINT]:
    "Prefira opção múltipla em vez de texto de uma linha quando for possível. Os campos de perfil e as perguntas personalizadas não podem somar mais de 12.",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TITLE]: "Pergunta",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TYPE]: "Tipo de pergunta",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_TEXT]: "Texto de uma linha",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_MULTIPLE_CHOICE]: "Múltipla escolha",
  [MODAL_CREATE_LEAD_FORM_ADD_OPTION]: "Adicionar opção",
  [MODAL_CREATE_LEAD_FORM_OPTION]: "Opção",
  [MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_URL]: "URL de política de privacidade",
  [MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_TEXT]:
    "Texto de política de privacidade",
  [MODAL_CREATE_LEAD_FORM_THANK_YOU_MESSAGE]: "Mensagem de agradecimento",
  [MODAL_CREATE_LEAD_FORM_LANDING_PAGE_URL]: "URL de destino",
  [MODAL_CREATE_LEAD_FORM_CTA]: "Chamada para ação de agradecimento",
  [MODAL_CREATE_LEAD_FORM_CTA_VISIT_COMPANY_WEBSITE]: "Visitar site da empresa",
  [MODAL_CREATE_LEAD_FORM_CTA_LEARN_MORE]: "Más informação",
  [MODAL_CREATE_LEAD_FORM_CTA_VIEW_NOW]: "Ver agora",
  [MODAL_CREATE_LEAD_FORM_CTA_DOWNLOAD_NOW]: "Baixar agora",
  [MODAL_CREATE_LEAD_FORM_CTA_TRY_NOW]: "Experimentar agora",
  [MODAL_CREATE_LEAD_FORM_MIN_OPTIONS]: "Adicione entre 2 e 15 opções",
  [MODAL_CREATE_LEAD_FORM_MAX_CUSTOM_QUESTIONS]:
    "Os campos de perfil e as perguntas personalizadas não podem somar mais de 12",

  //MODAL CREATE INSTANT FORM
  [MODAL_CREATE_INSTANT_FORM_TITLE]: "Criar um formulário instantâneo",
  [MODAL_CREATE_INSTANT_FORM_DESCRIPTION]:
    "Crie um formulário para capturar clientes potenciais",
  [MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME]: "Mais volume",
  [MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME_DESCRIPTION]:
    "Crie um formulário rápido de preencher e enviar pelo celular.",
  [MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT]: "Maior intenção",
  [MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT_DESCRIPTION]:
    "Adicione uma etapa para que as pessoas revisem e confirmem seus dados antes de enviar.",
  [MODAL_CREATE_INSTANT_FORM_QUESTIONS_HEADLINE]:
    "Título da página de perguntas",
  [MODAL_CREATE_INSTANT_FORM_CONTACT_FIELDS]: "Informações de contato",
  [MODAL_CREATE_INSTANT_FORM_CONTACT_FULL_NAME]: "Nome completo",
  [MODAL_CREATE_INSTANT_FORM_CONTACT_WORK_EMAIL]: "E-mail corporativo",
  [MODAL_CREATE_INSTANT_FORM_MAX_QUESTIONS]:
    "As informações de contato e as perguntas personalizadas não podem somar mais de {{value}}",
  [MODAL_CREATE_INSTANT_FORM_PRIVACY_LINK_TEXT]: "Texto do link",
  [MODAL_CREATE_INSTANT_FORM_ADDITIONAL_ACTION]: "Ação adicional",
  [MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE]: "Ir para o site",
  [MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE_DESCRIPTION]:
    "Compartilhe uma URL para que as pessoas visitem seu site.",
  [MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME]: "Agendar horário",
  [MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME_DESCRIPTION]:
    "Permita que as pessoas abram seu Calendly ou outro link de agendamento para reservar um horário.",
  [MODAL_CREATE_INSTANT_FORM_WEBSITE_URL]: "URL do site",
  [MODAL_CREATE_INSTANT_FORM_SCHEDULING_LINK]: "Link de agendamento",
  [MODAL_CREATE_INSTANT_FORM_SCHEDULING_PROVIDER]:
    "Provedor detectado: {{provider}}",
  [MODAL_CREATE_INSTANT_FORM_BOOK_TIME_HINT]:
    "No Facebook o calendário aparece dentro do formulário. No Instagram ele abre no navegador do app.",
  [MODAL_CREATE_INSTANT_FORM_BUTTON_TEXT]: "Texto do botão",
  [LEAD_FORM_RECOMMENDATION_GENERATING]: "Gerando formulário recomendado...",
  [LEAD_FORM_RECOMMENDATION_CANCEL]: "Cancelar recomendação",
  [LEAD_FORM_RECOMMENDATION_FAILED]:
    "Não foi possível gerar o formulário recomendado. Você pode preenchê-lo manualmente.",
  [LEAD_FORM_RECOMMENDATION_CAMPAIGN_GENERATING]:
    "A campanha ainda está sendo gerada. Você pode preencher o formulário manualmente.",

  //MODAL INSTANT EXPERIENCE LIST
  [MODAL_INSTANT_EXPERIENCE_LIST_TITLE]: "Experiências instantâneas",
  [MODAL_INSTANT_EXPERIENCE_LIST_DESCRIPTION]:
    "Selecione a experiência instantânea que quer usar no seu anúncio.",
  [MODAL_INSTANT_EXPERIENCE_EMPTY_TEXT]:
    "Não há experiências instantâneas criadas",

  //MODAL EDIT PRODUCTS CONFIGURATION
  [MODAL_EDIT_PRODUCTS_CONFIGURATION_TITLE]: "Configuração de produtos",
  [MODAL_EDIT_PRODUCTS_CONFIGURATION_DESCRIPTION]:
    "Edite a configuração dos produtos que você quer promover no seu anúncio",
  [PRODUCTS_CONFIGURATION_SYNC_DELAY_CAPTION]:
    "As alterações ou produtos novos podem demorar até 24 horas para sincronizar e aparecer aqui.",
  [CATEGORY_ANIMALS_PET_SUPPLIES]: "Produtos para animais de estimação",
  [CATEGORY_ARTS_ENTERTAINMENT]: "Arte e entretenimento",
  [CATEGORY_BUSINESS_INDUSTRIAL]: "Indústria e negócios",
  [CATEGORY_CAMERAS_OPTICS]: "Câmeras e dispositivos ópticos",
  [CATEGORY_CLOTHING_ACCESSORIES]: "Roupas e acessórios",
  [CATEGORY_ELECTRONICS]: "Eletrônicos",
  [CATEGORY_FOOD_BEVERAGES]: "Comida, bebidas e tabaco",
  [CATEGORY_FURNITURE]: "Móveis",
  [CATEGORY_HEALTH_BEAUTY]: "Saúde e beleza",
  [CATEGORY_HOME_GARDEN]: "Casa e jardim",
  [CATEGORY_BABY_TODDLER]: "Bebês e crianças pequenas",
  [CATEGORY_HARDWARE]: "Ferragens",
  [CATEGORY_MATURE]: "Conteúdo adulto",
  [CATEGORY_MEDIA]: "Mídia",
  [CATEGORY_VEHICLES_PARTS]: "Veículos e peças",
  [CATEGORY_OFFICE_SUPPLIES]: "Material de escritório",
  [CATEGORY_SPORTING_GOODS]: "Artigos esportivos",
  [CATEGORY_TOYS_GAMES]: "Brinquedos e jogos",
  [CATEGORY_SOFTWARE]: "Software",
  [CATEGORY_LUGGAGE_BAGS]: "Malas e bolsas",
  [CATEGORY_RELIGIOUS_CEREMONIAL]: "Religião e cerimônias",

  //MODAL EDIT PLACEMENTS META
  [MODAL_EDIT_PLACEMENTS_META_TITLE]: "Editar posicionamentos",
  [MODAL_EDIT_PLACEMENTS_META_DESCRIPTION]:
    "Edite o criativo de cada posicionamento",
  [MODAL_EDIT_GROUP_CREATIVE_META_TITLE]: "Editar o criativo do posicionamento",
  [MODAL_EDIT_GROUP_CREATIVE_META_DESCRIPTION]:
    "Ajuste o criativo para este grupo de posicionamentos",
  [PLACEMENT_META_USE]: "Usar",
  [PLACEMENT_META_RESIZE]: "Redimensionar",
  [PLACEMENT_META_SELECT_OTHER_CONTENT]: "Selecionar outro conteúdo",

  //MODAL EDIT ADVANTAGE ENHANCES META
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_TITLE]: "Melhorias Advantage do criativo",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_DESCRIPTION]:
    "Permite que a Meta aplique essas melhorias nos seus anúncios quando suas previsões determinarem que isso ajudará a melhorar o desempenho ao máximo. As melhorias ativadas serão exibidas em menos de 5% das impressões dos seus anúncios.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_TITLE]: "Melhorias padrão",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_DESCRIPTION]: `Conjunto de melhorias que podem incluir: <br/>\n    <ol>\n    <li>- Ajuste automático da proporção do anúncio</li>    \n    <li>- Aplicação de modelos em determinadas localizações para melhor visibilidade</li>    \n    <li>- Mostrar comentários relevantes abaixo do anúncio</li>    \n    </ol>`,
  [MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_TITLE]: "Recorte automático",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_DESCRIPTION]:
    "A proporção do anúncio será ajustada quando for provável melhorar o desempenho.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_TITLE]:
    "Otimização de texto",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_DESCRIPTION]:
    "A proporção do anúncio será ajustada automaticamente quando for provável melhorar o desempenho.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_TITLE]:
    "Comentário relevante",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_DESCRIPTION]:
    "O comentário mais relevante será mostrado abaixo do anúncio no Facebook e no Instagram.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_TITLE]: "Melhorar CTA",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_DESCRIPTION]:
    "Frases-chave das fontes do anúncio serão vinculadas à CTA. Você poderá revisá-las antes de publicar.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_TITLE]:
    "Imagem Templates",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_DESCRIPTION]:
    "Serão adicionadas sobreposições de texto junto ao seu conteúdo quando for provável melhorar o desempenho.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_TITLE]:
    "Animação de imagem",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_DESCRIPTION]:
    "Serão adicionados movimentos (panorâmica, zoom, rotação etc.) e serão convertidos em vídeos curtos.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_TITLE]: "Transformação 3D",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_DESCRIPTION]:
    "Será adicionado movimento 3D e profundidade à imagem quando for provável melhorar o desempenho.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_TITLE]:
    "Ajuste de brillo e contraste",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_DESCRIPTION]:
    "O brilho e o contraste da imagem serão ajustados quando for provável melhorar o desempenho. A imagem mostrada não representa seu anúncio.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_TITLE]: "Vídeo Filtering",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_DESCRIPTION]:
    "Serão adicionadas melhorias de cor e nitidez para que o vídeo fique mais atrativo.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_TITLE]:
    "Automação de descrição",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_DESCRIPTION]:
    "Escolheremos dinamicamente quando mostrar a descrição do seu carrossel.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_TITLE]: "Perfil Card",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_DESCRIPTION]:
    "Adicionaremos um cartão no final com a foto de perfil da sua página.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_TITLE]:
    "Carrossel para vídeo",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_DESCRIPTION]:
    "Mostramos anúncios com múltiplas imagens como uma apresentação em vídeo quando for provável que aumente o desempenho.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_TITLE]: "Pedido de mídia",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_DESCRIPTION]:
    "Mostraremos automaticamente primeiro o cartão com melhor desempenho.",

  //MODAL KEYWORDS
  [MODAL_EDIT_KEYWORD_TITLE]: "Editar Keyword",
  [MODAL_ADD_KEYWORDS_TITLE]: "Adicionar palavras-chave",

  //MODAL IMPORT ADS CAMPAIGN
  [MODAL_IMPORT_ADS_CAMPAIGN_TITLE]: "Importar Campanha",
  [MODAL_IMPORT_ADS_CAMPAIGN_DESCRIPTION]:
    "Selecione uma campanha para importar",
  [MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_TITLE]: "Importação concluída com sucesso",
  [MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_DESCRIPTION]:
    "A campanha foi importada corretamente. As campanhas importadas são somente leitura, mas você pode consultar métricas e gerar relatórios.",
  [ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION]:
    "As campanhas importadas são somente leitura, mas você pode consultar métricas e gerar relatórios.",

  //MODAL UPLOAD INSTAGRAM
  [MODAL_UPLOAD_INSTAGRAM_ARIA_LABEL]: "Enviar conteúdo a Instagram",
  [MODAL_UPLOAD_INSTAGRAM_TITLE]: "Enviar conteúdo a Instagram",
  [MODAL_UPLOAD_INSTAGRAM_CONTENT_UPLOADED_DESCRIPTION]:
    "O conteúdo foi enviado corretamente ao Instagram; aparecerá no seu perfil em alguns instantes",
  [MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_LABEL]: "Descrição",
  [MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_PLACEHOLDER]:
    "Lembre-se de adicionar uma descrição chamativa ao seu conteúdo, marcar os usuários que aparecem nele e adicionar hashtags relevantes.",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_LABEL]: "Tipo",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_POST_LABEL]: "Publicação",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL]: "História",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_REEL_LABEL]: "Reel",

  //MODAL CANVA
  [MODAL_CANVA_ARIA_LABEL]: "Modal para criar no Canva",
  [MODAL_CANVA_TITLE]: "Criar no Canva",
  [MODAL_CANVA_DESCRIPTION]:
    "Gere designs criativos para usar em {{NAME_BUSINESS}}",
  [MODAL_CANVA_CREATING_DESIGN]:
    "Estamos gerando uma área de design; aguarde um momento",
  [MODAL_CANVA_DESIGN_NOT_CREATED]:
    "Ocorreu um erro e não foi possível criar uma área de design",
  [MODAL_CANVA_DESIGN_NOT_RETRIEVED]:
    "Ocorreu um erro e não foi possível recuperar o design",
  [MODAL_CANVA_IS_EDITING_IN_CANVA]:
    "Volte para {{NAME_BUSINESS}} quando terminar de editar seu conteúdo no Canva",
  [MODAL_CANVA_IS_GETTING_YOUR_DESIGN]:
    "Estamos recuperando o seu design mais recente",
  [MODAL_CANVA_IS_GETTING_YOUR_FINAL_DESIGN]:
    "Estamos exportando o seu design final",
  [MODAL_CANVA_INFORMATION_SAVE_DESIGN]:
    "Quando terminar de editar seu conteúdo no Canva, feche a aba e ele será carregado automaticamente aqui.",
  [MODAL_CANVA_IMPORT_IMAGES_ONLY_WARNING_DESCRIPTION]:
    "Você só pode importar imagens do Canva. Não é possível importar vídeos.",
  [MODAL_CANVA_IMAGE_CONFIG_TITLE]: "Criar conteúdo com Canva",
  [MODAL_CANVA_IMAGE_CONFIG_DESCRIPTION]:
    "Selecione o tipo de conteúdo e suas dimensões",
  [MODAL_CANVA_IMAGE_CONFIG_TYPE_LABEL]: "Formato de Conteúdo",
  [MODAL_CANVA_IMAGE_CONFIG_WIDTH_LABEL]: "Largura (px)",
  [MODAL_CANVA_IMAGE_CONFIG_HEIGHT_LABEL]: "Altura (px)",
  [MODAL_CANVA_IMAGE_CONFIG_CREATE_BUTTON]: "Criar design",
  [MODAL_CANVA_IMAGE_CONFIG_CANCEL_BUTTON]: "Cancelar",
  [MODAL_CANVA_ACCOUNT_LABEL]: "Conta do Canva",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_LABEL]: "Conta do Google Drive",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE]: "Importar do Google Drive",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_DESCRIPTION]:
    "Selecione a conta do Google Drive da qual deseja importar",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_CONFIRM_BUTTON]: "Continuar",
  [GOOGLE_DRIVE_CONFIGURING_FILE_SELECTOR]:
    "Configurando selector de arquivos...",
  [GOOGLE_DRIVE_OPENING_SELECTOR]: "Abrindo o seletor do Google Drive...",
  [GOOGLE_DRIVE_IMPORTING_FILES]: "Importando arquivos do Google Drive...",
  [MODAL_CANVA_FOLDER_LABEL]: "Pastas do Canva",
  [MODAL_CANVA_IMAGE_CONFIG_EDIT_BUTTON]: "Editar",
  [MODAL_CANVA_IMAGE_CONFIG_EDIT_TITLE]: "Editar com Canva",
  [MODAL_CANVA_IMAGE_CONFIG_EDIT_DESCRIPTION]:
    "Selecione a conta com a qual deseja editar",
  [MODAL_CANVA_DISCONNECT_TITLE]: "Desconectar Conta do Canva",
  [MODAL_CANVA_DISCONNECT_DESCRIPTION]:
    "Selecione a conta que deseja desconectar",
  [MODAL_CANVA_DISCONNECT_BUTTON]: "Desconectar",
  [IMAGE_TYPE_PORTRAIT_LABEL]: "Vertical",
  [IMAGE_TYPE_LANDSCAPE_LABEL]: "Horizontal",
  [IMAGE_TYPE_SQUARE_LABEL]: "Quadrada",
  [ERROR_WIDTH_RANGE]: "A largura deve estar entre 100 e 5000 pixels",
  [ERROR_HEIGHT_RANGE]: "A altura deve estar entre 100 e 5000 pixels",

  //MODAL VERIFY INTEGRATION SCOPES
  [MODAL_VERIFY_INTEGRATION_SCOPES_TITLE]: "Faltam Algumas Permissões",
  [MODAL_VERIFY_INTEGRATION_SCOPES_DESCRIPTION]:
    "Detectamos que uma ou mais conexões não têm as permissões necessárias para acessar novas funcionalidades da plataforma. Reconecte-as abaixo.",

  //MODAL CUSTOM AUDIENCES
  [MODAL_CUSTOM_AUDIENCES_ARIA_LABEL]:
    "Configuração de audiências personalizadas",
  [MODAL_CUSTOM_AUDIENCES_TITLE]: "Configuração de Audiências Personalizadas",
  [MODAL_CUSTOM_AUDIENCES_DESCRIPTION]:
    "Configure um público personalizado para alcançar um grupo específico de pessoas",
  [MODAL_CUSTOM_AUDIENCES_EMPTY_TEXT]: "Não há públicos criados",

  //MODAL CUSTOM AUDIENCES EXCLUDE
  [MODAL_EXCLUDED_CUSTOM_AUDIENCES_ARIA_LABEL]:
    "Configuração de públicos excluídos",
  [MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE]: "Configuração de públicos excluídos",
  [MODAL_EXCLUDED_CUSTOM_AUDIENCES_DESCRIPTION]:
    "Configure um público personalizado para excluir um grupo específico de pessoas",

  //MODAL SAVED AUDIENCES
  [MODAL_SAVED_AUDIENCES_TITLE]: "Públicos salvos",
  [MODAL_SAVED_AUDIENCES_DESCRIPTION]:
    "Carregue um público salvo para usar na sua campanha",

  //MODAL CREATE CUSTOM AUDIENCE
  [MODAL_CREATE_CUSTOM_AUDIENCE_ARIA_LABEL]:
    "Configuração de audiência personalizada",
  [MODAL_CREATE_CUSTOM_AUDIENCE_TITLE]:
    "Configuração de audiência personalizada",
  [MODAL_CREATE_CUSTOM_AUDIENCE_DESCRIPTION]:
    "Configure um novo público personalizado",
  [MODAL_CREATE_CUSTOM_AUDIENCE_UPLOAD_CSV_CUSTOMER_LIST]:
    "Envie um arquivo CSV com a lista dos seus clientes",

  //MODAL CREATE IDENTITY TIKTOK BUSINESS
  [MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_TITLE]:
    "Criar uma identidade do TikTok",
  [MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_DESCRIPTION]:
    "Crie uma identidade para seus anúncios no TikTok. Esta identidade (nome e logo) será exibida como perfil nos seus anúncios para que os usuários possam identificar sua marca",
  [TIKTOK_CREATE_AD_ACCOUNT_OPTION]: "Criar Conta de Anúncios",
  [TIKTOK_CREDIT_BANNER_EYEBROW]: "Crédito no TikTok",
  [TIKTOK_CREDIT_BANNER_TITLE]:
    "do seu gasto publicitário como crédito no TikTok durante 12 meses",
  [TIKTOK_CREDIT_BANNER_DESCRIPTION_PREFIX]: "Basta",
  [TIKTOK_CREDIT_BANNER_DESCRIPTION_HIGHLIGHT]:
    "criar sua conta de anúncios do TikTok na {{NAME_BUSINESS}}",
  [TIKTOK_CREDIT_BANNER_CTA]:
    "Criar minha conta do TikTok na {{NAME_BUSINESS}}",
  [TIKTOK_CREDIT_BADGE_TOOLTIP]:
    "Esta conta foi criada na {{NAME_BUSINESS}}: você recebe 4% do seu gasto publicitário como crédito no TikTok durante 12 meses.",
  [AD_ACCOUNT_CREATED_FROM_BUSINESS]: "Criada pela {{NAME_BUSINESS}}",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_TITLE]: "Criar Conta de Anúncios do TikTok",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_DESCRIPTION]:
    "Escolha o Business Center onde a conta será criada e informe os dados do anunciante.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_BUSINESS_CENTER]: "Business Center",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_NAME]: "Nome da conta de anúncios",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_COMPANY]: "Nome da empresa",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_INDUSTRY]: "Setor",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_COUNTRY]: "País de registro da empresa",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY]: "Moeda",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY_HELPER]:
    "Deve ser igual à moeda do Business Center",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_TIMEZONE]: "Fuso horário",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_REVIEW_NOTE]:
    "Recomendamos que você entre no TikTok Ads Manager, pois o TikTok pode pedir alguns dados que só podem ser preenchidos lá, como uma verificação ou a adição de um método de pagamento. Quando o TikTok aprovar sua conta, você poderá usá-la na {{NAME_BUSINESS}}.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_CREDIT_ALERT]:
    "Receba 4% do seu gasto publicitário como crédito no TikTok durante 12 meses com a conta que você criar pela {{NAME_BUSINESS}}.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_NO_BUSINESS_CENTERS]:
    "Não encontramos nenhum Business Center. Conecte sua conta do TikTok para continuar.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_SUCCESS_TITLE]: "Conta de Anúncios Criada",

  [GUIDE_TIKTOK_AD_ACCOUNT_EYEBROW]: "Guia",
  [GUIDE_TIKTOK_AD_ACCOUNT_TITLE]: "Criar uma Conta de Anúncios do TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_INTRO]:
    "Crie a conta de anúncios no {{NAME_BUSINESS}}. O TikTok ainda precisa aprovar a conta e os dados de pagamento antes de os anúncios começarem a veicular.",
  [GUIDE_TIKTOK_AD_ACCOUNT_BACK]: "Voltar para contas de anúncios",
  [GUIDE_TIKTOK_AD_ACCOUNT_LINK]: "Ver o guia",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP]: "Passo {{step}}",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_SETTINGS]: "Configuração",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_AD_ACCOUNTS]: "Contas de anúncios",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_CONNECT]: "Conectar TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_CREATE]: "Criar Conta de Anúncios",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_ADS_MANAGER]: "TikTok Ads Manager",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_TITLE]:
    "Abra contas de anúncios e conecte o TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_BODY]:
    "Abra Configuração no menu lateral e entre em Contas de anúncios. Em Conectar mais plataformas, clique em Conectar TikTok e conclua a autorização do TikTok for Business.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_ALT]:
    "Configuração em contas de anúncios, com o botão Conectar TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_AUTH_ALT]:
    "Janela de autorização do TikTok for Business para confirmar permissões",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_TITLE]: "Escolha Criar Conta de Anúncios",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_BODY]:
    "Abra a conta do TikTok conectada. Na lista de contas de anúncios do TikTok, selecione Criar Conta de Anúncios.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_ALT]:
    "Seletor de conta de anúncios do TikTok com Criar Conta de Anúncios",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_TITLE]: "Informe os dados do anunciante",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_BODY]:
    "Escolha o Business Center. Depois informe o nome da conta de anúncios, o nome da empresa, o setor, o país de registro, a moeda e o fuso horário. A moeda precisa ser a mesma do Business Center. Clique em Criar.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_ALT]:
    "Formulário para criar uma conta de anúncios do TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_TITLE]: "Complete a conta no TikTok Business",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_BODY]:
    "Criar a conta não encerra a configuração. Abra o ___TIKTOK_BUSINESS___, entre na conta nova e informe o que o TikTok pede. Se você já preencheu isso antes, o TikTok provavelmente não vai pedir de novo.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_TITLE]: "Você Já Pode Lançar Uma Campanha",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_BODY]:
    "Depois de concluir todos os passos e confirmar no ___TIKTOK_BUSINESS___ que não há etapas adicionais, você já pode lançar campanhas a partir do {{NAME_BUSINESS}}.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_ALT]:
    "Modal para criar uma campanha no {{NAME_BUSINESS}}",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_TITLE]: "Obrigatório no TikTok Business",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_WEBSITE]: "Site",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_BILLING]: "Endereço de cobrança",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_PAYMENT]: "Forma de pagamento",

  //MODAL MAIN GENERATE SOCIAL MEDIA CONTENT
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL]:
    "Modal para gerar o conteúdo da semana",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE]: "Gerador de feed",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION]:
    "Gere seu conteúdo semanal para redes sociais com um clique",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_LABEL]:
    "O que quer comunicar com este conteúdo?",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_PLACEHOLDER]:
    "Quero comunicar que os meus produtos/marca são tudo o que o usuário precisa",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WEBSITE_URL_LABEL]: "URL do seu site",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_HAS_TEXTS_LABEL]:
    "Quer que os conteúdos tenham texto?",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_ALL_WITH_TEXT]: "Todos com texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_SOME_WITH_TEXT]: "Alguns com texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WITHOUT_TEXT]: "Nenhum com texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_LANGUAGE_LABEL]: "Idioma",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TONES_LABEL]: "Conteúdo tones",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_TEXT_LABEL]: "Texto color",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_BACKGROUND_LABEL]:
    "Cor de fundo",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_HAS_TEXT_LABEL]: "Com texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_FONT_FAMILY_LABEL]: "Fonte",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_TEXT_LABEL]:
    "Alinhamento do texto",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_LOGO_LABEL]:
    "Alinhamento do logo",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_TITLE]: "Galería de conteúdo",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_EMPTY]:
    "Ainda não há conteúdo; adicione-o",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_UPLOAD_OPTION]:
    "Enviar do dispositivo",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_FROM_COLLABORATIONS_OPTION]:
    "Enviar de {{NAME_BUSINESS}}",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENTS_REQUIRED]:
    "Você deve selecionar ao menos um dia",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULE_BUTTON]:
    "Agendar Conteúdo",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULED_CONTENT]:
    "Conteúdo agendado",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALREADY_CONTENT_ON_THIS_DATE]:
    "Já há um conteúdo para esta data, por favor selecione outra",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENT_WILL_BE_PUBLISHED_IMMEDIATELY]:
    "Este conteúdo será publicado imediatamente",

  //MODAL CONNECT ACCOUNTS
  [MODAL_CONNECT_ACCOUNTS_TITLE]: "Conecte suas contas",
  [MODAL_CONNECT_ACCOUNTS_DESCRIPTION]:
    "Para publicar esta campanha você deve conectar as suas contas de anúncios",

  //MODAL GENERATE SOCIAL MEDIA CONTENT
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL]: "Modal para gerar conteúdo",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE]: "Genera conteúdo",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_LABEL]: "Escolha o tom",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_TOP_FIVE_OPTION]:
    "Top cinco",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_EDUCATION_OPTION]:
    "Educacional",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_QUOTES_OPTION]:
    "Frases famosas",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_CURIOUS_FACTS_OPTION]:
    "Fatos curiosos",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_RHYMES_OR_POEMS_OPTION]:
    "Rimas ou poemas",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_HUMOR_OPTION]: "Humor",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_EMPTY_CONTENT]: "Não há conteúdo gerado",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TEXT_LABEL]: "Texto da imagem",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION]: "Descrição do conteúdo",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_GENERATING_CONTENT]:
    "Generando conteúdo",

  //REDEEM CODE
  [REDEEM_CODE_TITLE]: "Resgatar código",
  [REDEEM_CODE_DESCRIPTION]:
    "Digite o código que o criador de conteúdo fornece para validar o valor e realizar a permuta de produto",
  [REDEEM_CODE_SEARCHBAR_PLACEHOLDER]: "Escreva um código",
  [REDEEM_CODE_TABLE_COLUMN_CODE]: "Código",
  [REDEEM_CODE_TABLE_COLUMN_DATE]: "Data de resgate",
  [REDEEM_CODE_TABLE_COLUMN_VALUE]: "Valor",
  [REDEEM_CODE_TABLE_COLUMN_TERMS]: "Termos e condições",
  [CODE_REDEEMED]: "Código redeemed",
  [VALUE_CODE_REDEEMED]: "Valor: {{value,currency}}",
  [VALUE_GENERAL_CODE_REDEEMED]: "Valor: {{value}}%",
  [CODE_NO_EXIST]: "Este código não existe",
  [CODE_NO_REDEEM_BEFORE_DATE]:
    "Ainda não é possível resgatar este código; isso poderá ser feito a partir de {{date,short}}",

  //ORDERS
  [ORDERS_TITLE]: "Pedidos",
  [ORDERS_DESCRIPTION]:
    "Gerencie os pedidos que os criadores de conteúdo realizam",
  [ORDERS_REMEMBER_MARK_AS_DELIVERED]:
    "Lembre-se de marcar seu pedido como 'Entregue' para que o criador possa enviar seu conteúdo.",
  [ORDERS_SEARCHBAR_PLACEHOLDER]: "Buscar por número do pedido",
  [ORDERS_TAB_TO_BE_ACCEPTED]: "Por aceitar",
  [ORDERS_TAB_TO_BE_ACCEPTED_DESCRIPTION]:
    "Aqui você verá novos pedidos dos criadores de conteúdo convidados. Aceite-os para confirmar que você vai processá-los.",
  [ORDERS_TAB_IN_PREPARATION]: "Processando",
  [ORDERS_TAB_IN_PREPARATION_DESCRIPTION]:
    "Aqui você verá os pedidos a processar do seu lado. Ao expirar o tempo, um entregador estará pronto para recolhê-lo.",
  [ORDERS_TAB_TO_BE_DELIVERED]: "Para entregar",
  [ORDERS_TAB_TO_BE_DELIVERED_DESCRIPTION]:
    "Aqui você verá os pedidos prontos do seu lado para que um entregador possa recolhê-los.",
  [DELIVERY_INTERN]: "Próprio",
  [DELIVERY_INTERN_ON_THE_WAY]: "Entrega própria a caminho",
  [DELIVERY_ON_THE_WAY]: "Entrega {{delivery}} a caminho",
  [ORDER_ID]: "Pedido #{{id}}",
  [ORDER_ACCEPTED]: "Pedido aceita",
  [ORDER_ACCEPTED_DESCRIPTION]:
    "O pedido foi aceito e movido para processamento",
  [ORDER_READY]: "Pedido lista",
  [ORDER_READY_DESCRIPTION]: "O pedido está pronto e foi movido para entrega",
  [ORDER_TO_BE_DELIVERED_CONFIRMATION]:
    "Tem certeza de que o pedido já foi entregue?",
  [ORDER_TO_BE_DELIVERED_CONFIRMATION_BUTTON]: "Entregar pedido",
  [ORDER_CANCELLED_CONFIRMATION]:
    "Tem certeza de que deseja cancelar o pedido?",
  [ORDER_CANCELLED_CONFIRMATION_BUTTON]: "Cancelar order",
  [ORDER_DELIVERED]: "Pedido entregue",
  [ORDER_DELIVERED_DESCRIPTION]: "O pedido já foi entregue ao usuário",
  [DELIVERY_SELECTED]: "Delivery selecionado!",
  [DELIVERY_SELECTED_DESCRIPTION]:
    "Foi selecionado o delivery {{delivery}} para este pedido",
  [ORDER_REJECTED]: "Pedido rejeitada",
  [ORDER_REJECTED_DESCRIPTION]: "O pedido foi rejeitado",
  [ORDER_TOTAL_VALUE]: "Valor total",
  [ORDER_TOTAL_VALUE_DISCOUNT]: "Com {{value}}% de desconto",
  [ORDER_LIST_OF_PRODUCTS]: "Lista de produtos",
  [ORDER_OPTIONS]: "Opções",
  [ORDER_TIME_PREPARATION_TITLE]: "Indique o tempo de entrega do pedido",
  [MIN_VALUE_PREPARATION_ORDER]:
    "Este é o tempo mínimo para processar este pedido",
  [MAX_VALUE_PREPARATION_ORDER]:
    "Este é o tempo máximo para processar este pedido",
  [INVALID_TIME_PREPARATION]: "Você deve escolher um tipo de tempo válido",
  [TIME_PREPARATION_VALUES_VALIDATION]:
    "Você deve escolher um tempo maior que {{min}} ou menor que {{max}}",
  [GUIDE_NUMBER]: "Número da guia",
  [GUIDE_NUMBER_REQUIRED]: "O número de rastreio é obrigatório",
  [DELIVERY_TYPE_DUPLICATE]: "Já existe uma entrega com este nome",
  [SELECT_DELIVERY_TYPE]: "Selecione um delivery",
  [SELECT_DELIVERY_TYPE_OTHER]: "Outra entrega",
  [DELIVERY_DATA]: "Datos do delivery",
  [OWN_DELIVERY]: "Entrega própria",

  //EVENTS
  [EVENT_NO_EXIST]: "O evento não existe",
  [EVENT_DISABLED]: "O evento {{event}} não está ativo",
  [EVENT_HAS_FIELDS_REQUIRED]:
    "Esta evento tiene campos obrigatórios vacíos, para ativarlos completalos",
  [EVENT_RECURRENT_REQUIRED]: "O tipo de recorrência é obrigatório",

  //ACCOUNT
  [ACCOUNT_TITLE]: "My Conta",
  [ACCOUNT_DESCRIPTION]: "Preencha as informações da sua empresa",

  //COMPANY INFORMATION
  [COMPANY_INFORMATION_TITLE]: "Configure a sua marca",
  [COMPANY_INFORMATION_SUBCATEGORY_DUPLICATE]:
    "Já existe uma subcategoria com este nome",
  [COMPANY_INFORMATION_TYPE_ID_PLACEHOLDER]: "Tipo de identificação",
  [COMPANY_INFORMATION_ID_NUMBER_PLACEHOLDER]: "Número de identificação",
  [COMPANY_INFORMATION_ID_NUMBER_MIN_LENGTH]:
    "O número de identificação deve ter ao menos {{value}} dígitos",
  [COMPANY_INFORMATION_ID_NUMBER_TYPE]:
    "O número de identificação deve ter apenas dígitos; no caso de ser NIT, deve conter um hífen e o dígito verificador",
  [COMPANY_INFORMATION_BRAND_NAME_PLACEHOLDER]: "Motivo social",
  [COMPANY_INFORMATION_BUSINESS_NAME_PLACEHOLDER]: "Nome da marca",
  [COMPANY_INFORMATION_ADDRESS_PLACEHOLDER]: "Endereço registrada",
  [COMPANY_INFORMATION_AVERAGE_TICKET_PLACEHOLDER]: "Valor do ticket médio",
  [COMPANY_INFORMATION_AVERAGE_TICKET_MIN_VALUE]:
    "O valor do ticket médio deve ser de ao menos {{value,currency}}",
  [COMPANY_INFORMATION_SOCIAL_NETWORK_PLACEHOLDER]: "Rede social principal",
  [COMPANY_INFORMATION_SECOND_SOCIAL_NETWORK_PLACEHOLDER]:
    "Rede social secundaria",
  [COMPANY_INFORMATION_WEBSITE_URL_PLACEHOLDER]: "Página web de sua marca",
  [COMPANY_INFORMATION_TRAFFIC_URL_PLACEHOLDER]:
    "URL para onde quer levar o tráfego",
  [COMPANY_INFORMATION_CATEGORY_PLACEHOLDER]: "Categorias",
  [COMPANY_INFORMATION_SUBCATEGORY_PLACEHOLDER]: "Subcategorias",
  [COMPANY_INFORMATION_NEW_SUBCATEGORY]: "Nova subcategoria",
  [COMPANY_INFORMATION_SHORT_DESCRIPTION_PLACEHOLDER]:
    "Escreva uma descrição marcante da sua marca para incentivar criadores a colaborar com você",
  [COMPANY_INFORMATION_ADMIN_PHONE_PLACEHOLDER]: "Celular do administrador",
  [COMPANY_INFORMATION_RESERVATION_URL_PLACEHOLDER]: "URL para reservas",
  [COMPANY_INFORMATION_UPLOAD_LOGO_PLACEHOLDER]: "Enviar logo da marca",
  [COMPANY_INFORMATION_UPLOAD_LOGO_DESCRIPTION_PLACEHOLDER]:
    "Isso ajudará os clientes ou entregadores a identificarem sua marca.",
  [COMPANY_INFORMATION_UPLOAD_COVER_PLACEHOLDER]: "Enviar imagem de portada",
  [COMPANY_INFORMATION_UPLOAD_COVER_DESCRIPTION_PLACEHOLDER]:
    "Isso aumentará a visibilidade. Use imagens horizontais ou com proporção 16:9 para uma melhor visualização.",
  [COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_PLACEHOLDER]:
    "Enviar documento regulatorio",
  [COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_DESCRIPTION_PLACEHOLDER]:
    "Documento regulatório para a venda de alimentos (por exemplo, Invima, FDA)",
  [COMPANY_INFORMATION_VIEW_DOCUMENT]: "Ver document",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_TITLE]: "Código de desconto geral",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_DESCRIPTION]: `O código de desconto geral é um código que os criadores de {{NAME_BUSINESS}} podem usar para comprar seus produtos como qualquer outro cliente, por isso não será gerada uma colaboração.`,
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_1]:
    "Se você salvar uma porcentagem de desconto e tiver uma integração de e-commerce, será criado um código de desconto com essa porcentagem.",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_2]:
    "Se você remover a porcentagem de desconto, tiver uma integração de e-commerce e já tiver um código geral criado anteriormente, ele será desativado.",

  [COMPANY_INFORMATION_GENERAL_DISCOUNT_PERCENTAGE_PLACEHOLDER]:
    "Percentual de desconto",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_CODE_PLACEHOLDER]: "Código de desconto",
  [COMPANY_INFORMATION_SHOP_ID_COPIED]: "ID da loja copiado",
  [COMPANY_INFORMATION_ONBOARDING_FINISH_DESCRIPTION]:
    "Agora você deverá preencher toda a informação da sua marca nesta seção da conta.",
  [COMPANY_INFORMATION_SAVED]: "Informações da empresa salvas",

  //PLATFORMS CONNECT
  [PLATFORMS_CONNECTED_TITLE]: "Conecte suas contas",
  [PLATFORMS_CONNECTED_INSTAGRAM_FAILED]:
    "Não foi possível conectar com o Instagram",
  [PLATFORMS_CONNECTED_FACEBOOK_SDK_UNAVAILABLE]:
    "Seu navegador bloqueou a conexão com a Meta. Isso costuma ser causado por um bloqueador de anúncios, uma extensão de privacidade ou uma rede/firewall corporativo.",
  [PLATFORMS_CONNECTED_META_BLOCKED_TITLE]:
    "Não conseguimos abrir o login da Meta",
  [PLATFORMS_CONNECTED_META_POPUP_BLOCKED]:
    "A janela da Meta não abriu ou fechou antes de terminar. Isso costuma acontecer quando o navegador bloqueia pop-ups ou uma extensão de privacidade interfere.",
  [PLATFORMS_CONNECTED_META_BLOCKED_STEP_DISABLE_BLOCKER]:
    "Desative o bloqueador de anúncios e as extensões de privacidade para esta página.",
  [PLATFORMS_CONNECTED_META_BLOCKED_STEP_ALLOW_POPUPS]:
    "Permita pop-ups para esta página.",
  [PLATFORMS_CONNECTED_META_BLOCKED_STEP_RETRY]:
    "Recarregue a página e tente novamente.",
  [PLATFORMS_TOKEN_EXPIRED]: "Seu token expirou, por favor reconecte sua conta",
  [AD_ACCOUNTS_TITLE]: "Contas de anúncios",

  //BRAND SETUP
  [BRAND_SETUP_TITLE]: "Configure a sua marca",

  //SCHEDULE
  [SCHEDULE_TITLE]: "Agendars",
  [SCHEDULE_ECOMMERCE_ALERT_TITLE]: "Tem certeza?",
  [SCHEDULE_ECOMMERCE_ALERT_DESCRIPTION]:
    "Isso fará com que o horário da sua marca seja 24/7",
  [SCHEDULE_ONE_DAY_WITH_TURN]: "Pelo menos um dia deve ter um turno",
  [SCHEDULE_EMPTY_TURN]: "Não pode haver turnos vazios",
  [SCHEDULE_OPEN_AND_CLOSE_HOUR_VALIDATION]:
    "O horário de abertura não pode ser maior que o de fechamento",
  [SCHEDULE_MAX_CLOSE_HOUR]:
    "O horário não pode ser maior que 23:59. Use 00:00 em vez de 24:00",
  [SCHEDULE_TABLE_ARIA_LABEL]: "Agendar table",
  [SCHEDULE_TABLE_COLUMN_OPEN]: "Abre",
  [SCHEDULE_TABLE_COLUMN_CLOSE]: "Fecha",
  [SCHEDULE_SAVED]: "Horário salvo",

  //LEGAL REPRESENTATIVE
  [LEGAL_REPRESENTATIVE_TITLE]: "Informação do representante legal",
  [LEGAL_REPRESENTATIVE_NAME_PLACEHOLDER]: "Nomes",
  [LEGAL_REPRESENTATIVE_LAST_NAME_PLACEHOLDER]: "Sobrenome",
  [LEGAL_REPRESENTATIVE_TYPE_ID_PLACEHOLDER]: "Tipo de identificação",
  [LEGAL_REPRESENTATIVE_ID_NUMBER_PLACEHOLDER]: "Número de identificação",
  [LEGAL_REPRESENTATIVE_PHONE_PLACEHOLDER]: "Telefone",
  [LEGAL_REPRESENTATIVE_SAVED]: "Informação do representante legal guardada",

  //PASSWORD
  [PASSWORD_TITLE]: "Alterar senha",
  [PASSWORD_CURRENT_PASSWORD_PLACEHOLDER]: "Senha actual",
  [PASSWORD_NEW_PASSWORD_PLACEHOLDER]: "Nova senha",
  [PASSWORD_CONFIRM_PASSWORD_PLACEHOLDER]: "Repita a nova senha",
  [PASSWORD_FORMAT_DESCRIPTION]: "Formato da senha:",
  [PASSWORD_FORMAT_SUGGESTION1]: "Pelo menos 6 caracteres",
  [PASSWORD_FORMAT_SUGGESTION2]: "Pelo menos uma letra maiúscula",
  [PASSWORD_FORMAT_SUGGESTION3]: "Pelo menos uma letra minúscula",
  [PASSWORD_FORMAT_SUGGESTION4]: "Pelo menos um número",
  [PASSWORD_INSECURE]: "A senha não é segura; tenha em conta as recomendações",
  [PASSWORDS_NOT_MATCH]: "As senhas novas não coincidem",
  [PASSWORD_CHANGED]: "Senha cambiada",
  [PASSWORD_CURRENT_INVALID]: "A senha atual não está correta",
  [PASSWORD_ACCOUNT_DISABLED_FOR_MORE_INTENTS]:
    "A conta foi desabilitada temporariamente por muitas tentativas falhas; tente novamente mais tarde.",

  //STORES
  [MODAL_STORE_ARIA_LABEL]: "Modal de loja",
  [MODAL_STORE_TITLE]: "Criar a store",
  [MODAL_STORE_TITLE_EDIT]: "Editar a store",
  [MODAL_STORE_DESCRIPTION]:
    "Crie uma loja que seja um ponto de venda físico ou virtual da marca.",
  [MODAL_STORE_DESCRIPTION_EDIT]: "Edite uma loja que você criou.",
  [MODAL_STORE_TYPE_PLACEHOLDER]: "Tipo de loja",
  [MODAL_STORE_TYPE_REGULAR_OPTION]: "Regular",
  [MODAL_STORE_HOW_TO_INTEGRATE_STORE]:
    "Como integrar a minha loja de {{value}} com {{NAME_BUSINESS}}?",
  [MODAL_STORE_NAME_PLACEHOLDER]: "Nome da loja",
  [MODAL_STORE_DESCRIPTION_PLACEHOLDER]: "Descrição",
  [MODAL_STORE_ADDRESS_PLACEHOLDER]: "Endereço",
  [MODAL_STORE_CITY_PLACEHOLDER]: "Cidade",
  [MODAL_STORE_PHONE_PLACEHOLDER]: "Telefone",
  [MODAL_STORE_LINK_STORE_SPECIAL_PLACEHOLDER]: "Link da sua loja {{value}}",
  [MODAL_STORE_NAME_SHOPIFY_PLACEHOLDER]: "Nome da loja no Shopify",
  [MODAL_STORE_LOOK_NAME_SHOPIFY]: "Veja o nome da sua loja",
  [MODAL_STORE_LOOK_NAME_SHOPIFY_HELPER_TEXT]:
    "O nome da sua loja é o que aparecerá na URL para a qual você é redirecionado; você deverá copiar o trecho que está antes de <strong>.myshopify.com</strong>. Por exemplo, se você for redirecionado para a URL https://<strong>testclapps</strong>.myshopify.com, o nome da loja é <strong>testclapps</strong>.",
  [MODAL_STORE_ACCESS_TOKEN_FOR_BUZZLY_PLACEHOLDER]:
    "Token de acesso para {{NAME_BUSINESS}}",
  [MODAL_STORE_DO_CREATE_DISCOUNT_SHIPPING_PLACEHOLDER]: "Dar envío grátis",
  [MODAL_STORE_CITIES_PLACEHOLDER]: "Selecione as cidades",
  [MODAL_STORE_ORDERS_METHODS_PLACEHOLDER]:
    "Selecione métodos para a entrega de seus produtos",
  [MODAL_STORE_ORDERS_METHODS_DELIVERY_OPTION]: "Delivery",
  [MODAL_STORE_ORDERS_METHODS_IN_STORE_OPTION]: "Na loja",
  [MODAL_STORE_PRODUCT_AVAILABILITY_PLACEHOLDER]:
    "Disponibilidade dos seus produtos",
  [MODAL_STORE_PRODUCT_AVAILABILITY_NATIONAL_OPTION]:
    "Nacional (Todas as cidades)",
  [MODAL_STORE_PRODUCT_AVAILABILITY_LOCAL_OPTION]:
    "Local (Solo na cidade selecioneda)",
  [MODAL_STORE_COVERAGE_RADIUS_PLACEHOLDER]: "Raio de cobertura em quilômetros",
  [MODAL_STORE_TITLE_CREATE_INTEGRATE_SHOPIFY]: "Integrar Shopify",
  [MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_SHOPIFY]:
    "Conecte sua loja Shopify com {{NAME_BUSINESS}} para facilitar a gestão dos seus convites e permutas.",
  [MODAL_STORE_DESCRIPTION_DISCONNECT_SHOPIFY]:
    "Serão desabilitadas todas as funcionalidades de gestão de convites e permutas do Shopify",
  [MODAL_STORE_BUTTON_CREATE_INTEGRATE_SHOPIFY]: "Integrar Shopify",
  [MODAL_STORE_TITLE_CREATE_INTEGRATE_WOOCOMMERCE]: "Integrar WooCommerce",
  [MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_WOOCOMMERCE]:
    "Conecte sua loja WooCommerce com {{NAME_BUSINESS}} para facilitar a gestão dos seus convites e permutas.",
  [MODAL_STORE_BUTTON_CREATE_INTEGRATE_WOOCOMMERCE]: "Integrar WooCommerce",
  [MODAL_STORE_DESCRIPTION_DISCONNECT_WOOCOMMERCE]:
    "Serão desabilitadas todas as funcionalidades de gestão de convites e permutas do WooCommerce",

  //MENU
  [MENU_TITLE]: "Catálogo",
  [MENU_DESCRIPTION]: "Crie o catálogo dos produtos da sua marca",
  [MENU_EMPTY_STORES]:
    "Você não tem uma loja criada para adicionar um catálogo",
  [MODAL_COPY_MENU_ARIA_LABEL]: "Modal para copiar catálogo",
  [MODAL_COPY_MENU_TITLE]: "Copiar catalog",
  [MODAL_COPY_MENU_DESCRIPTION]: "Copiar o catálogo de uma loja para outra",
  [MODAL_COPY_MENU_SAME_STORE]:
    "Não é possível copiar um catálogo para a mesma loja",
  [MODAL_COPY_MENU_CONFIRM_ALERT_TITLE]:
    "Tem certeza de que deseja copiar este catálogo?",
  [MODAL_COPY_MENU_CONFIRM_ALERT_DESCRIPTION]:
    "Esta ação substituirá o catálogo que estiver na loja de destino.",
  [MODAL_COPY_MENU_COPIED]: "Catálogo copiado",
  [SELECT_CATALOG]: "Selecione um catálogo",
  [MODAL_UPLOAD_MENU_ARIA_LABEL]: "Modal para enviar catálogo",
  [MODAL_UPLOAD_MENU_TITLE]: "Enviar catálogo",
  [MODAL_UPLOAD_MENU_DESCRIPTION]:
    "Selecione a loja para a qual quer enviar o catálogo",
  [MODAL_UPLOAD_MENU_FILE_PLACEHOLDER]:
    "Para enviar um catálogo, faça isso a partir de um arquivo Excel com a extensão xlsx, respeitando o modelo das colunas.",
  [MODAL_UPLOAD_MENU_ERROR_FORMAT]:
    "Foi encontrado um erro no formato; por favor, não modifique a estrutura do modelo nem deixe campos obrigatórios vazios",
  [MODAL_UPLOAD_MENU_MIN_PRICE_PRODUCT]:
    "O preço de um produto deve ser {{value,number}} ou maior",
  [MODAL_UPLOAD_MENU_CONFIRM_ALERT_TITLE]:
    "Tem certeza de que deseja enviar este catálogo?",
  [MODAL_UPLOAD_MENU_CONFIRM_ALERT_DESCRIPTION]:
    "Esta ação apagará o catálogo existente e o substituirá.",
  [MODAL_UPLOAD_MENU_UPLOADED]: "Catálogo enviado",
  [MENU_ADD_CATEGORY]: "Adicionar categoria",
  [MENU_CATEGORY_NAME_PLACEHOLDER]: "Nome da categoria",
  [MENU_CATEGORY_REQUIRED]: "Você deve digitar um nome de categoria",
  [MENU_ADD_PRODUCT]: "Adicionar produto",
  [MENU_PRODUCT_MIN_VALUE]: "O preço deve ser {{value,number}} ou maior",
  [MENU_CREATE_PRODUCT_TITLE]: "Criar o produto base",
  [MENU_PRODUCT_NAME_PLACEHOLDER]: "Nome",
  [MENU_PRODUCT_DESCRIPTION_PLACEHOLDER]: "Descrição",
  [MENU_PRODUCT_PRICE_PLACEHOLDER]: "Preço",
  [MENU_PRODUCT_TYPE_PRODUCT_PLACEHOLDER]: "Produto type",
  [MENU_PRODUCT_TYPE_PRODUCT_EXPLANATION]:
    "Este produto não é adequado para o público em geral (é nocivo ou para maiores de 18 anos)",
  [MENU_PRODUCT_ACCOMPANIMENTS_TYPE_TITLE]: "Produto Options",
  [MENU_PRODUCT_ACCOMPANIMENTS_TYPE_DESCRIPTION]:
    "Adicione opções e personalização deste produto",
  [MENU_PRODUCT_ADD_ACCOMPANIMENT_TYPE_PLACEHOLDER]:
    "Adicione categoria de opção de produto",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_IS_MANDATORY_PLACEHOLDER]: "Es obrigatório?",
  [MENU_PRODUCT_ADD_ACCOMPANIMENT_PLACEHOLDER]: "Adicione opção de produto",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_AND_MAX_NUMBER]:
    "O mínimo de opções não pode ser maior que o máximo",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_NUMBER]:
    "O mínimo ou o máximo de opções não pode ser menor que 0",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_NAME_PLACEHOLDER]: "Nome",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_OPTIONS_PLACEHOLDER]: "Opções mínimas",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MAX_OPTIONS_PLACEHOLDER]: "Opções máximas",
  [MENU_PRODUCT_ACCOMPANIMENT_NAME_PLACEHOLDER]: "Nome",
  [MENU_PRODUCT_ACCOMPANIMENT_PRICE_PLACEHOLDER]: "Preço",
  [MODAL_MOVE_PRODUCT_ARIA_LABEL]:
    "Modal para mover um produto para outra categoria",
  [MODAL_MOVE_PRODUCT_CATEGORY_OBJECTIVE]:
    "Selecione a categoria para a qual quer mover o produto",
  [MODAL_MOVE_PRODUCT_CATEGORY_REQUIRED]: "Você deve selecionar uma categoria",
  [MODAL_MOVE_PRODUCT_BUTTON]: "Mover produto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_ARIA_LABEL]:
    "Modal para copiar uma categoria de opção de produto para outro produto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_OBJECTIVE]:
    "Selecione a categoria de produto que contém a categoria de opção de produto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_OBJECTIVE]:
    " Selecione o produto que contém a categoria de opção de produto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE]:
    "Selecione a categoria de opção de produto que quer copiar",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE_PLACEHOLDER]:
    "Categoria de opção de produto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_REQUIRED]:
    "Você deve selecionar uma categoria",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_REQUIRED]:
    "Você deve selecionar um produto",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_REQUIRED]:
    "Você deve selecionar uma categoria de opção de produto",
  [MENU_ONBOARDING_TEST_CATEGORY]: "Categoria de teste",
  [MENU_ONBOARDING_TEST_PRODUCT]: "Produto de teste",
  [MENU_ONBOARDING_TEST_PRODUCT_DESCRIPTION]: "Descrição de teste",
  [MENU_ONBOARDING_FINISH_DESCRIPTION]:
    "Você concluiu o tutorial de criação de menu; agora já sabe como gerenciar seu catálogo.",
  [MENU_ONBOARDING_FINISH_ADDITIONAL_DESCRIPTION]:
    "Agora você deverá preencher toda a informação da sua marca nesta seção da conta.",
  [MENU_CATEGORY_DUPLICATE]: "Categoria duplicada",
  [MENU_CATEGORY_DUPLICATE_DESCRIPTION]:
    "Já existe uma categoria com este nome",
  [MENU_CATEGORY_CREATED]: "Categoria criada",
  [MENU_CATEGORY_SAVED]: "Categoria guardada",
  [MENU_CATEGORY_DELETE_CONFIRMATION_TITLE]: "Excluir categoria",
  [MENU_CATEGORY_DELETE_CONFIRMATION_DESCRIPTION]:
    "Tem certeza de que deseja excluir esta categoria?",
  [MENU_CATEGORY_DELETING]: "Excluindo categoria",
  [MENU_CATEGORY_DELETED]: "Categoria eliminada",
  [MENU_PRODUCT_DUPLICATE]: "Produto duplicado",
  [MENU_PRODUCT_DUPLICATE_DESCRIPTION]: "Já existe um produto com este nome",
  [MENU_PRODUCT_CREATED]: "Produto criado",
  [MENU_PRODUCT_SAVED]: "Produto salvo",
  [MENU_PRODUCT_DELETE_CONFIRMATION_TITLE]: "Excluir produto",
  [MENU_PRODUCT_DELETE_CONFIRMATION_DESCRIPTION]:
    "Tem certeza de que deseja excluir este produto?",
  [MENU_PRODUCT_DELETING]: "Excluindo produto",
  [MENU_PRODUCT_DELETED]: "Produto excluído",
  [MENU_PRODUCT_MOVE_SAME_CATEGORY]:
    "Não é possível mover o produto para a mesma categoria",
  [MENU_PRODUCT_MOVED]: "Produto moved",
  [MENU_PRODUCT_CHANGE_STATUS]: "Produto {{status}}",
  [MENU_ACCOMPANIMENT_TYPE_DUPLICATE]:
    "Categoria de opção de produto duplicada",
  [MENU_ACCOMPANIMENT_TYPE_DUPLICATE_DESCRIPTION]:
    "Já existe uma categoria de opção de produto com este nome",
  [MENU_ACCOMPANIMENT_TYPE_COPIED]: "Categoria de opção de produto copiada",
  [MENU_ACCOMPANIMENT_DUPLICATED]: "Produto option duplicated",
  [MENU_ACCOMPANIMENT_DUPLICATED_DESCRIPTION]:
    "Já existe uma opção de produto com este nome",

  //USERS
  [USERS_TITLE]: "Usuários",
  [USERS_DESCRIPTION]:
    "Crie os usuários que vão ajudar você a gerenciar o seu negócio",
  [USERS_TABS_ARIA_LABEL]: "abas de usuários e contatos",
  [USERS_PORTAL_TAB]: "Usuários",
  [USERS_CONTACTS_TAB]: "Contatos",
  [USERS_EMAIL_DUPLICATE]: "O e-mail já está em uso por outro usuário",
  [USERS_USER_CREATED]: "Usuário criado",
  [USERS_USER_SAVED]: "Usuário guardado",
  [USERS_USER_DELETE_CONFIRMATION_TITLE]:
    "Tem certeza de que deseja excluir este usuário?",
  [USERS_USER_DELETE_CONFIRMATION_DESCRIPTION]:
    "Depois de excluído, não será possível recuperá-lo",
  [USERS_USER_DELETING]: "Excluindo usuário",
  [USERS_USER_DELETED]: "Usuário eliminado",
  [USERS_LIMIT_REACHED]: "Limite de usuários atingido",
  [ADVERTISERS_LIMIT_REACHED]:
    "Você atingiu o limite de marcas. Atualize o seu plano para adicionar mais.",
  [USERS_ONBOARDING_FINISH]:
    "Agora você já sabe quais são os papéis que existem e para que serve cada um",
  [USERS_USER_SEARCH_BAR_PLACEHOLDER]: "Buscar usuário",
  [USERS_TABLE_ARIA_LABEL]: "Tabla de Usuários",
  [USERS_TABLE_COLUMN_NAME]: "Nome",
  [USERS_TABLE_COLUMN_EMAIL]: "E-mail",
  [USERS_TABLE_COLUMN_STORE]: "Loja",
  [USERS_TABLE_COLUMN_ROLE]: "Função",
  [MODAL_USER_ARIA_LABEL]: "Criar user modal",
  [MODAL_USER_TITLE]: "Criar Usuário",
  [MODAL_USER_TITLE_EDIT]: "Editar Usuário",
  [MODAL_USER_DESCRIPTION]:
    "Adicione um usuário para que possa acessar {{NAME_BUSINESS}}.",
  [MODAL_USER_DESCRIPTION_EDIT]:
    "Edite um usuário que tem acesso a {{NAME_BUSINESS}}.",
  [MODAL_USER_NAME_PLACEHOLDER]: "Nomes e Apellidos",
  [MODAL_USER_ROLE_PLACEHOLDER]: "Rol do Usuário",
  [MODAL_USER_ROLE_OPERATOR_EXPLANATION]:
    "Pessoas que gerenciam as ações de Resgatar código e Pedidos, e que ativam ou desativam os produtos conforme o estoque.",
  [MODAL_USER_STORE_PLACEHOLDER]: "Escolha uma loja",
  [MODAL_USER_PASSWORD_PLACEHOLDER]: "Senha",
  [MODAL_USER_REPEAT_PASSWORD_PLACEHOLDER]: "Repetir senha",
  [USERS_CONTACT_CREATED]: "Contact Criard",
  [USERS_CONTACT_SAVED]: "Contato salvo",
  [USERS_CONTACT_DELETE_CONFIRMATION_TITLE]:
    "Tem certeza de que deseja excluir este contato?",
  [USERS_CONTACT_DELETE_CONFIRMATION_DESCRIPTION]:
    "Depois de excluído, não será possível recuperá-lo",
  [USERS_CONTACT_DELETED]: "Contato excluído",
  [USERS_CONTACT_SEARCH_BAR_PLACEHOLDER]: "Buscar contato",
  [USERS_CONTACT_TABLE_ARIA_LABEL]: "Tabela de contatos",
  [USERS_CONTACT_TABLE_COLUMN_PHONE]: "Telefone",
  [MODAL_CONTACT_ARIA_LABEL]: "Modal para criar contato",
  [MODAL_CONTACT_TITLE]: "Criar um contato",
  [MODAL_CONTACT_TITLE_EDIT]: "Editar um contato",
  [MODAL_CONTACT_DESCRIPTION]:
    "Crie um contato para que {{NAME_BUSINESS}} se comunique com você.",
  [MODAL_CONTACT_DESCRIPTION_EDIT]: "Edite um contato que você criou.",
  [MODAL_CONTACT_PHONE_PLACEHOLDER]: "Celular do contato",

  //BILLING AND PAYMENTS
  [STORAGE_USAGE_TITLE]: "Armazenamento",
  [STORAGE_USAGE_LABEL]: "{{value}} {{unit}} de {{maxValue}} GB",
  [STORAGE_FULL_TITLE]: "Armazenamento insuficiente",
  [STORAGE_FULL_MESSAGE]:
    "Você atingiu o limite de armazenamento. Para guardar mais conteúdo, atualize o plano ou apague conteúdo existente.",
  [STORAGE_FULL_BUTTON_DELETE]: "Apagar conteúdo",
  [STORAGE_FULL_BUTTON_UPGRADE]: "Atualizar plano",
  [BILLING_AND_PAYMENTS_TITLE]: "Faturamento",
  [BILLING_AND_PAYMENTS_DESCRIPTION]:
    "Conheça o seu plano comercial e gerencie os pagamentos das faturas",
  [BILLING_AND_PAYMENTS_TABLE_ARIA_LABEL]: "Tabela de faturas",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_PAID_DATE]: "Data de pagamento",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_DUE_DATE]: "Data de vencimento",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_VALUE]: "Valor",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_REASON]: "Motivo",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_STATUS]: "Situação",
  [PAYMENT_REASON_COLLABORATION]: "Pagamento por colaboração",
  [PAYMENT_REASON_APPLICANT]: "Pagamento por candidato",
  [PAYMENT_REASON_CLAPP_CREDITS]: "Pagamento por créditos",
  [PAYMENT_REASON_SUBSCRIPTION_PRO]: `Assinatura {{NAME_BUSINESS}} Pro`,
  [PAYMENT_REASON_PACKAGE]: "Plano {{name}}",
  [PAYMENT_REASON_PLAN]: "Plano {{name}}",
  [PAYMENT_PAID]: "Pago",
  [PAYMENT_PENDING]: "Pendente",
  [MODAL_INVOICE_ARIA_LABEL]: "Modal de detalhes da fatura",
  [MODAL_INVOICE_TITLE]: "Fatura nº {{value}}",
  [MODAL_INVOICE_DISCLAIMER]:
    "Se achar que há um erro no faturamento, você pode entrar em contato com o suporte para receber um atendimento detalhado.",
  [MODAL_INVOICE_CREDITS]: "Pagamento de créditos",
  [MODAL_INVOICE_NUMBER_CREDITS]: "Número de créditos",
  [PURCHASE_CREDITS]: "Compra de créditos",
  [PURCHASE_VIDEOS]: "Compra de vídeos",
  [PURCHASE_X_CREDITS]: "Compra de {{value}} créditos",
  [MODAL_INVOICE_PLAN_ENTERPRISE_WITH_CREDITS]:
    "{{credits}} colaborações com mídia e publicidade",
  [MODAL_INVOICE_SUBSCRIPTION]:
    "Pago de assinatura {{name}}, periodo do {{startDate, short}} ao {{endDate, short}}",
  [MODAL_INVOICE_LICENSE]:
    "Pago de licencia {{name}}, periodo do {{startDate, short}} ao {{endDate, short}}",
  [MODAL_INVOICE_COLLABORATION]: "Pagamento por permuta de conteúdo",
  [MODAL_INVOICE_APPLICANT]: "Pago a aplicante de campanha",
  [MODAL_INVOICE_FEE]: "Fee {{value}}%",
  [MODAL_INVOICE_IVA]: "IVA {{value}}%",
  [MODAL_INVOICE_ORDER_TO_COLLECT]: "Pedido a Cobrar",
  [MODAL_INVOICE_APPLICANT_CAMPAIGN_PAID]: "Campanha",
  [MODAL_PAY_INVOICE_ARIA_LABEL]: "Modal de pagamento da fatura",
  [MODAL_PAY_INVOICE_TITLE]: "Pagar fatura nº {{value}}",
  [MODAL_PAY_INVOICE_WILL_PAY]: "Você pagará {{value,currency}}",
  [MODAL_PAY_SUBSCRIPTION_PENDING_INVOICE_MESSAGE]:
    "Você tem uma fatura pendente, de {{value}} {{currency}}, referente a: {{concept}}",
  [MODAL_PAY_SUBSCRIPTION_PAY_NOW]: "Pagar agora",
  [MODAL_PAY_SUBSCRIPTION_PENDING_PAYMENT_TITLE]:
    "Pago Pendente de {{value}} {{currency}}",
  [BILLING_PENDING_SUBSCRIPTION_PAYMENT_DESCRIPTION]:
    "Realize o pagamento antes de {{limitDate}}, para evitar que o conteúdo da galeria e suas campanhas de {{NAME_BUSINESS}} (e das plataformas publicitárias conectadas) sejam removidos.",
  [BILLING_AND_PAYMENT_PLAN_DEACTIVATE]: "Seu plano está inativo",
  [BILLING_AND_PAYMENT_PLAN_CANCELLED]: "Seu plano foi cancelado",
  [BILLING_AND_PAYMENT_PLAN_TRIAL]: "Teste",
  [BILLING_AND_PAYMENT_PLAN_TRIAL_DESCRIPTION]:
    "Você tem um plano de teste ativo para conhecer os benefícios de usar {{NAME_BUSINESS}}",
  [BILLING_AND_PAYMENT_CHANGE_YOUR_PLAN]: "Altere seu plano agora",
  [BILLING_AND_PAYMENT_ACTIVATE_PLAN]: "Ativar plano",
  [BILLING_AND_PAYMENT_SELECT_PLAN]: "Selecione um plano",
  [BILLING_AND_PAYMENT_NO_HAVE_PLAN]: "-",
  [BILLING_AND_PAYMENT_PLAN_EXPIRED]:
    "O seu plano de teste expirou. Adicione um método de pagamento e ative o seu plano agora para continuar usando {{NAME_BUSINESS}}.",
  [BILLING_AND_PAYMENT_PLAN_NAME]: "Plano {{name}}",
  [BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_TITLE]: "Pagamento por uso",
  [BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_COST]:
    "{{value,currency}} por permuta",
  [BILLING_AND_PAYMENT_MODEL_USAGE_WHAT_BENEFITS]:
    "Quais benefícios você tem com este plano?",
  [BILLING_AND_PAYMENT_MODEL_USAGE_SHOW_BENEFTIS]: "Mostrar benefícios",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT1]:
    "Acesse o nosso catálogo de criadores de conteúdo.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT2]:
    "Mostre os seus produtos e/ou serviços a públicos entre 5 mil e 2 milhões de pessoas no Instagram, TikTok e YouTube.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT3]:
    "Analise os perfis, verifique a qualidade e a autenticidade dos conteúdos e obtenha informações sobre a audiência.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT4]:
    "Automatize a permuta de produtos e/ou serviços (convites e solicitações).",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT5]: "Automatize campanhas pagas.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT6]:
    "Baixe o conteúdo na plataforma e use-o em suas redes sociais, página web e outros canais de marketing.",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_NAME]: "Plano {{name}}",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_CHANGE]: "Altere seu plano agora",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_COLLECT_COST_COLLABORATION]:
    "Você ainda não selecionou um plano; por enquanto será cobrado {{value,currency}} por cada colaboração realizada.",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_ADD_PAYMENT_METHOD_TO_ACTIVATE]:
    "Adicione um método de pagamento para ativar seu plano",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_EXPIRED]: `O seu plano de teste expirou. Selecione um plano para continuar usando {{NAME_BUSINESS}}.`,
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_NO_HAVE_PACKAGE]: "-",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_ACTIVATE_PACKAGE]: "Ativar plano",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_SELECT_PACKAGE]: "Selecionar plano",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_PACKAGE]: "Cancelar plano",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_WHAT_BENEFITS]:
    "Quais benefícios você tem com este plano?",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_COST_COLLABORATION]:
    "{{value,currency}} por colaboração",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_DISCLAIMER]:
    " * As assinaturas são renovadas automaticamente a cada mês; se desejar cancelar ou alterar seu plano, você deve contactar o suporte com 5 dias de antecedência.",
  [MODAL_SELECT_PACKAGE_ARIA_LABEL]: "Modal de seleção de plano",
  [MODAL_SELECT_CREDITS_ARIA_LABEL]: "Modal de seleção de créditos",
  [MODAL_SELECT_PACKAGE_AND_PAYMENT_METHOD_REQUIRED]:
    "O plano e o método de pagamento são necessários",
  [MODAL_SELECT_PACKAGE_UPLOAD_GROWTH]: "Suba para o Growth!",
  [MODAL_SELECT_PACKAGE_PRICING_HERO_TITLE]:
    "Você está pronto para que a sua marca seja vista por milhares de pessoas?",
  [MODAL_SELECT_PACKAGE_PRICING_DISCOVER_BUZZLY]: "Conheça {{NAME_BUSINESS}}",
  [MODAL_SELECT_PACKAGE_UPLOAD_GROWTH_DESCRIPTION]:
    "Com o plano Growth você pode acessar mais benefícios",
  [MODAL_SELECT_PACKAGE_PRICING_HERO_DESCRIPTION]:
    "Descubra a plataforma que levará sua marca ao próximo nível de reconhecimento nas redes sociais.",
  [MODAL_SELECT_PACKAGE_VALUE_EXPRESSED]:
    "Os valores estão expressos em {{currency}}",
  [MODAL_SELECT_PACKAGE_PRICE]: "{{value,currency}}/mês",
  [MODAL_SELECT_PACKAGE_LICENSED_FEE_ENTERPRISE]: "Fee Licencia e Conteúdo",
  [MODAL_SELECT_PACKAGE_LICENSED_FEE]: "Taxa de licença ({{period}} meses)",
  [MODAL_SELECT_PACKAGE_LICENSED_PRICE]: "{{value,currency}}",
  [MODAL_SELECT_PACKAGE_CONTENT_ENTERPRISE]: "Conteúdo",
  [MODAL_SELECT_PACKAGE_PRICE_UPLOAD_GROWTH]:
    "Se te cobrará {{value,currency}} por enviar a growth",
  [MODAL_SELECT_PACKAGE_ACCORDING_TO_THE_REQUIREMENT]: "Conforme a necessidade",
  [MODAL_SELECT_PACKAGE_BUY_PACKAGE_NAME]: "Comprar {{value}}",
  [MODAL_SELECT_PACKAGE_COST_COLLABORATION]:
    "{{value,currency}} por colaboração",
  [MODAL_SELECT_PACKAGE_COST_CONTENT]: "{{value,currency}} por conteúdo",
  [MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT_WITH_CREATORS]:
    "Chat direto com criadores",
  [MODAL_SELECT_PACKAGE_BENEFIT_CONTENT_CURATION]: "Curadoria de conteúdo",
  [MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_PUBLICATION_PLATFORM]:
    "• Publicação directa a IG o TikTok",
  [MODAL_SELECT_PACKAGE_BENEFIT_COLLABORATE_WITH_CREATOR]:
    "• Colabore com criadores",
  [MODAL_SELECT_PACKAGE_BENEFIT_LAUNCH_CAMPAIGNS]: "• Lanza campanhas",
  [MODAL_SELECT_PACKAGE_BENEFIT_DOWNLOAD_CONTENT]:
    "• Baixe conteúdo para o feed das suas redes sociais",
  [MODAL_SELECT_PACKAGE_BENEFIT_ANALYZE_METRICS]:
    "• Analiza métricas de audiência, alcance e engagement",
  [MODAL_SELECT_PACKAGE_BENEFIT_CATALOG]:
    "• Acesso ao catálogo de criadores de conteúdo",
  [MODAL_SELECT_PACKAGE_BENEFIT_AUTOMATIZATION]:
    "• Automação de permuta de produtos por conteúdo",
  [MODAL_SELECT_PACKAGE_BENEFIT_SUPPORT_TICKETS]:
    "• Suporte de ajuda por tickets",
  [MODAL_SELECT_PACKAGE_BENEFIT_ALL_BASIC]: `• Todos los beneficios do Plan Basic`,
  [MODAL_SELECT_PACKAGE_BENEFIT_KAM]:
    "• KAM - gerente de contas (consultoria estratégica)",
  [MODAL_SELECT_PACKAGE_BENEFIT_VOLUME_CONTENT]: "• Volumen de conteúdos",
  [MODAL_SELECT_PACKAGE_BENEFIT_DISCOVERY]:
    "• Descubra e analise as métricas de qualquer perfil do Instagram ou TikTok",
  [MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT]: "• Chat direto com criadores",
  [MODAL_SELECT_PACKAGE_BENEFIT_ASSISTANCE_MARKETING]:
    "• Assistente de marketing com inteligência artificial 24/7",
  [MODAL_SELECT_PACKAGE_BENEFIT_ALL_GROWTH]:
    "• Todos os benefícios do Plano Growth",
  [MODAL_SELECT_PACKAGE_BENEFIT_BRANDS_UNLIMITED]: "• Marcas ilimitadas",
  [MODAL_SELECT_PACKAGE_BENEFIT_PERSONALIZED_INTEGRATIONS]:
    "• Integrações personalizadas (WhatsApp, páginas web)",
  [MODAL_SELECT_PACKAGE_BENEFIT_IMPLEMENTATIONS_TECHNOLOGICAL]:
    "• Implementações tecnológicas",
  [MODAL_SELECT_PACKAGE_BENEFIT_PRIORITIZED_SUPPORT]: "• Suporte prioritario",
  [MODAL_SUBSCRIPTION_PRO_ARIA_LABEL]: "Modal para pagar assinatura pro",
  [MODAL_SUBSCRIPTION_PRO_TITLE_HERO]:
    "Você está pronto para desbloquear ferramentas para melhorar suas colaborações?",
  [MODAL_SUBSCRIPTION_PRO_DESCRIPTION_HERO]: `{{NAME_BUSINESS}} Pro dará acesso a funcionalidades que ajudarão você a melhorar suas colaborações com criadores.`,
  [MODAL_SUBSCRIPTION_PRO_TITLE]: `{{NAME_BUSINESS}} Pro`,
  [MODAL_SUBSCRIPTION_PRO_SUB_HEADER]: "Mais recursos",
  [MODAL_SUBSCRIPTION_PRO_BENEFIT_1]:
    "• Iniciar chats diretos com criadores que não são embaixadores",
  [MODAL_SUBSCRIPTION_PRO_BUY_BUTTON]: "Comprar {{NAME_BUSINESS}} Pro",

  //PACKAGES
  [ADS_SUBSCRIPTION_TITLE]: "Assinatura {{value}}",
  [SPEND_FEE]: "Taxa de gasto publicitário",
  [ADS_SUBSCRIPTION_DESCRIPTION]:
    "Com a sua assinatura você poderá acessar as nossas ferramentas de geração de campanhas e conteúdo com IA",

  //PRICING
  [PRICING_HERO_TITLE_PACKAGES]: "Crie, lance e otimize anúncios em segundos",
  [PRICING_HERO_TITLE_CREDITS]: "Crie, lance e otimize anúncios em segundos",
  [PRICING_HERO_DESCRIPTION]: ``,
  [PRICING_APPSUMO_CREDITS_STACK_TITLE]: "Os seus créditos acumulam-se",
  [PRICING_APPSUMO_CREDITS_STACK_DESCRIPTION]:
    "Os créditos mensais do seu plano serão adicionados aos seus créditos atuais do AppSumo.",
  [PRICING_CREDIT_USAGE_TITLE]: "Como os créditos são usados?",
  [PRICING_CREDIT_USAGE_CAMPAIGN]: "campanha de anúncios",
  [PRICING_CREDIT_USAGE_IMAGE]: "imagem gerada por IA",
  [PRICING_CREDIT_USAGE_VIDEO]: "Vídeo gerado por IA",
  [PRICING_CREDIT_USAGE_ANIMATE_IMAGE]: "imagem animada com IA",
  [PRICING_CREDIT_USAGE_ANALYZE_IMAGE_LAYERS]: "análisis de capas de imagem",
  [PRICING_CREDIT_USAGE_CUSTOM_REPORT]: "relatório personalizado (CSV)",
  [PRICING_CREDIT_USAGE_CUSTOM_REPORT_DECK]:
    "relatório personalizado (PPTX/PDF)",
  [PRICING_CREDIT_USAGE_OPTIMIZATION]: "mensagem ao agente de IA",
  [PRICING_CREDIT_USAGE_SCHEDULED_POST]: "publicação agendada",
  [PRICING_CREDIT_USAGE_PER]: "por",
  [PRICING_CREDIT_USAGE_CREDIT]: "crédito",
  [PRICING_CREDIT_USAGE_CREDITS]: "créditos",
  [CREDIT_COST_ITEM]: "{{credits}} {{creditWord}} por {{action}}",
  [ADS_SUBSCRIPTION_CREDITS_BENEFIT]: "{{value,number}} Créditos",
  [ADS_SUBSCRIPTION_CREDITS_MONTHLY_BENEFIT]: "{{value,number}}/mês Créditos",
  [ADS_SUBSCRIPTION_CREDITS_QUARTERLY_BENEFIT]: "{{value,number}}/q Créditos",
  [ADS_SUBSCRIPTION_CREDITS_SEMIANNUALLY_BENEFIT]:
    "{{value,number}}/s Créditos",
  [ADS_SUBSCRIPTION_CREDITS_YEARLY_BENEFIT]: "{{value,number}}/ano Créditos",
  [ADS_SUBSCRIPTION_COINS_BENEFIT]: "{{value,number}} moedas",
  [ADS_SUBSCRIPTION_BENEFIT_PLATFORMS_CAMPAIGNS]: "Campanhas de Meta e TikTok",
  [ADS_SUBSCRIPTION_BENEFIT_CAMPAIGNS]: "{{value}} campanhas multiplataforma",
  [ADS_SUBSCRIPTION_BENEFIT_CAMPAIGN]: "{{value}} campanha multiplataforma",
  [ADS_SUBSCRIPTION_ENTERPRISE_CAMPAIGNS_CUSTOM]:
    "Número de campanhas personalizado",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS]: "{{value}} marcas",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISER]: "{{value}} marca",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_CUSTOM]:
    "Número personalizado de marcas",
  [TOTAL_ADVERTISERS_COUNT]: "{{value}} Marcas",
  [TOTAL_ADVERTISER_COUNT]: "{{value}} Marca",
  [ADS_SUBSCRIPTION_BENEFIT_CREATIVES]: "{{value}} conteúdos",
  [ADS_SUBSCRIPTION_BENEFIT_VIDEOS]:
    "{{value}} Vídeos IA (Prontos para Publicar)",
  [ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_MONTH]:
    "{{value,number}} créditos / mês",
  [ADS_SUBSCRIPTION_BENEFIT_VIDEOS_AI]: "{{value}} vídeos com IA",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_UP_TO]: "Até {{value}} marcas",
  [ADS_SUBSCRIPTION_BENEFIT_USERS_UP_TO]: "Até {{value}} usuários",
  [ADS_SUBSCRIPTION_BENEFIT_USER]: "{{value}} usuário",
  [ADS_SUBSCRIPTION_BENEFIT_UNLIMITED_SOCIAL_POSTS]:
    "Publicações ilimitadas nas redes",
  [ADS_SUBSCRIPTION_BENEFIT_SUPPORT_CHAT_AND_EMAIL]:
    "Suporte por chat + email prioritario",
  [ADS_SUBSCRIPTION_BENEFIT_WHITE_LABEL_OPTIONAL]: "Opcional white-label",
  [ADS_SUBSCRIPTION_BENEFIT_CREATIVES_CUSTOM]:
    "Número de conteúdos personalizado",
  [ADS_SUBSCRIPTION_BENEFIT_OPTIMIZATIONS]: "Até {{value}} otimizações",
  [ADS_SUBSCRIPTION_BENEFIT_AI_CAMPAIGNS]: "Criação de campanhas com IA",
  [ADS_SUBSCRIPTION_BENEFIT_AI_AUDIENCE_SEGMENTATION]:
    "Segmentação de audiência por IA",
  [ADS_SUBSCRIPTION_BENEFIT_AI_CONTENT]: "Conteúdo gerado por IA",
  [ADS_SUBSCRIPTION_BENEFIT_POSTS]: "Publicação e programação em redes sociais",
  [ADS_SUBSCRIPTION_BENEFIT_AI_ADVANCED_INSIGHTS_AND_REPORTS]:
    "Informes e análisis avanzados por IA",
  [ADS_SUBSCRIPTION_BENEFIT_USERS]: "Até {{value}} usuário(s)",
  [ADS_SUBSCRIPTION_BENEFIT_STORAGE]: "{{value}} GB de armazenamento",
  [ADS_SUBSCRIPTION_BENEFIT_STORAGE_CUSTOM]: "Armazenamento personalizado",
  [ADS_SUBSCRIPTION_BENEFIT_EMAIL_SUPPORT]: "Suporte por E-mail Electrónico",
  [ADS_SUBSCRIPTION_BENEFIT_CHAT_SUPPORT]: "Suporte por Chat",
  [ADS_SUBSCRIPTION_BENEFIT_PRIORITY_SUPPORT]: "Suporte Prioritario",
  [ADS_SUBSCRIPTION_BENEFIT_DEDICATED_ACCOUNT_MANAGER]:
    "Dedicated Conta Marketer",

  //BILLING DATA
  [BILLING_DATA_TITLE]: "Datos de Faturamento",
  [BILLING_DATA_DESCRIPTION]: "Preencha os dados usados para emitir as faturas",
  [BILLING_DATA_SAVED]: "Datos de faturamento guardados",
  [BILLING_DATA_PERSONAL_INFORMATION_DESCRIPTION]: "Informação personal",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_PLACEHOLDER]: "Tipo",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_NATURE_OPTION]:
    "Pessoa física",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_LEGAL_OPTION]:
    "Pessoa jurídica",
  [BILLING_DATA_PERSONAL_INFORMATION_BUSINESS_NAME_PLACEHOLDER]:
    "Motivo social",
  [BILLING_DATA_PERSONAL_INFORMATION_NAME_PLACEHOLDER]: "Nomes",
  [BILLING_DATA_PERSONAL_INFORMATION_LAST_NAME_PLACEHOLDER]: "Sobrenome",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_ID_PLACEHOLDER]:
    "Tipo de identificação",
  [BILLING_DATA_PERSONAL_INFORMATION_ID_NUMBER_PLACEHOLDER]:
    "Número de identificação",
  [BILLING_DATA_CONTACT_INFORMATION_DESCRIPTION]: "Informações de contato",
  [BILLING_DATA_CONTACT_INFORMATION_EMAIL_BILLING_PLACEHOLDER]:
    "E-mail (Faturamento)",
  [BILLING_DATA_CONTACT_INFORMATION_ADDRESS_PLACEHOLDER]: "Endereço",
  [BILLING_DATA_CONTACT_INFORMATION_PHONE_PLACEHOLDER]: "Celular",

  [MODAL_FREE_TRIAL_TITLE]: "Comece o seu teste grátis de 3 dias!",
  [MODAL_FREE_TRIAL_DESCRIPTION]:
    "Colabore em permuta, campanhas, envie pagamentos e converse com criadores de conteúdo.",
  [MODAL_FREE_TRIAL_CAPTION]: "Comece agora grátis",
  [MODAL_FREE_TRIAL_BUTTON]: "Experimentar GRÁTIS",
  [MODAL_FREE_TRIAL_START_ALERT_DESCRIPTION]:
    "Você desbloqueou o seu teste grátis. Assine o {{NAME_BUSINESS}} Pro para começar a trabalhar com criadores de conteúdo.",

  [TRIAL_CONFIGURING_EXPERIENCE]: "Configurando sua experiência...",
  [TRIAL_PREPARING_PLATFORM]:
    "Estamos preparando todo para que puedas probar la plataforma ao instante.",
  [TRIAL_RETRY_ACCESS]: "Tentar novamente Acceso",

  [BLOCK_PAYMENT_FAILED_TITLE]: "Seu pagamento falhou",
  [BLOCK_TRIAL_END_TITLE]: "Seu período de teste foi finalizado",
  [BLOCK_PACKAGE_DESCRIPTION]:
    "Ative o seu plano para colaborar com criadores, publicar campanhas, analisar métricas e baixar conteúdo para o feed das suas redes sociais",
  [BLOCK_PACKAGE_TITLE]: "Plano desativado",
  [BLOCK_PLAN_BUTTON]: "Ir a painel de faturamento",
  [BLOCK_PLAN_BUTTON_ACTIVATE_PLAN]: "Ativar plano",
  [BLOCK_TRIAL_ACTIVE_TITLE]: "O teste grátis está ativo",
  [BLOCK_TRIAL_ACTIVE_DESCRIPTION]:
    "Ativa seu plan para desbloquear todo o potencial de {{NAME_BUSINESS}}",
  [BLOCK_TRIAL_ACTIVE_BUTTON]: "Ativar plano",
  [BLOCK_CONTACT_YOUR_ADMINISTRATOR_TITLE]:
    "Sua conta está inativa, por favor entre em contato com seu administrador.",

  [MODAL_DISSATISFACTION_COLLABORATION_TITLE]:
    "Sabemos que você não está satisfeito",
  [MODAL_DISSATISFACTION_COLLABORATION_DESCRIPTION]:
    " Lamentamos que a colaboração não tenha sido satisfatória. Por isso, oferecemos a próxima colaboração grátis.",
  [MODAL_DISSATISFACTION_COLLABORATION_BUTTON]: "Receber 1 crédito",
  [MODAL_DISSATISFACTION_COLLABORATION_EXPLANATION_CREDIT]:
    " *Um crédito equivale a uma colaboração gratuita e será aplicado na próxima colaboração que você realizar.",
  [MODAL_DISSATISFACTION_COLLABORATION_CREDIT_RECEIVED]:
    "Você recebeu um crédito",

  [MODAL_BUY_CREDITS_ARIA_LABEL]:
    "Modal para comprar créditos de {{NAME_BUSINESS}}",
  [MODAL_BUY_CREDITS_TITLE]: "Comprar créditos",
  [MODAL_BUY_CREDITS_DESCRIPTION]:
    "Um crédito equivale a uma publicação em permuta de um criador",
  [MODAL_BUY_CREDITS_CREDIT_FOR_COLLABORATION]:
    "Cada permuta concluída custa {{value,currency}}",
  [MODAL_BUY_CREDITS_HOW_MANY_CREDITS_BUY]: "Quantos créditos quer comprar?",
  [MODAL_BUY_CREDITS_REDEEMED_ESTIMATED_TIME]:
    "Seus créditos serão resgatados em cerca de {{value}} meses",
  [MODAL_BUY_CREDITS_ADDITIONAL_CREDITS]:
    "Vamos presentear você com {{value}} crédito(s)!",
  [MODAL_BUY_CREDITS_LAST_TEXT_PAY]:
    "O pagamento total será de {{value,currency}}",
  [MODAL_BUY_CREDITS_AMOUNT_FOR_PRICE]:
    "{{credits}} créditos por {{value,currency}}",
  [MODAL_BUY_CREDITS_GIFT_CREDITS]:
    "(Presenteamos você com {{creditsGift}} por comprar mais de {{creditsBuy}})",
  [MODAL_BUY_CREDITS_AND_PAYMENT_METHOD_REQUIRED]:
    "O número de créditos e o método de pagamento são necessários",
  [MODAL_BUY_CREDITS_NEGATIVE]: "O número de créditos não pode ser menor que 1",
  [MODAL_BUY_CREDITS_PURCHASED]: "Compra de créditos concluída com sucesso",
  [MODAL_BUY_CREDITS_PURCHASED_DESCRIPTION]:
    "Concluímos a transação com sucesso. Seus créditos já estão disponíveis na sua conta.",
  [MODAL_BUY_VIDEOS_PURCHASED]: "Compra de vídeos concluída com sucesso",
  [MODAL_BUY_VIDEOS_PURCHASED_DESCRIPTION]:
    "Concluímos a transação com sucesso. Os vídeos que você comprou já estão disponíveis na sua conta.",
  [BUY_CREDITS]: "Comprar Créditos",
  [MODAL_PURCHASE_CREDITS_TITLE]: "Comprar Créditos",
  [MODAL_PURCHASE_CREDITS_ARIA_LABEL]: "Modal para comprar créditos",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_TITLE]:
    "Como funciona a compra de créditos",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_1]:
    "Créditos avulsos custam 50% a mais do que créditos recorrentes.",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_2]:
    "Os créditos não utilizados serão reiniciados ao finalizar seu período de faturamento atual.",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3]:
    "Quer uma tarifa melhor ou um limite mais alto?",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3_LINK]: "Atualize seu plano",
  [MODAL_PURCHASE_CREDITS_SELECT_AMOUNT]: "Selecione um pacote",
  [MODAL_PURCHASE_CREDITS_MINIMUM_AMOUNT]:
    "A quantidade mínima de créditos que você pode comprar é {{minCredits}}.",
  [MODAL_PURCHASE_CREDITS_CUSTOM_AMOUNT_PLACEHOLDER]:
    "Digite a quantidade personalizada",
  [MODAL_PURCHASE_CREDITS_UPGRADE_PLAN]: "Atualizar Plano",
  [MODAL_PURCHASE_CREDITS_PURCHASE_BUTTON]: "Comprar Créditos",
  [MODAL_PURCHASE_CREDITS_PAYMENT_SUMMARY]:
    "Você pagará ${{amount}} USD por {{credits}} créditos",
  [MODAL_PURCHASE_CREDITS_CREDITS_LABEL]: "{{credits}} créditos",
  [MODAL_PURCHASE_CREDITS_PRICE_PER_CREDIT]: "${{price}} por crédito",
  [MODAL_PURCHASE_CREDITS_CREDIT_PACKAGES_TITLE]: "Pacotes de Créditos",
  [MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_TITLE]: "Pacotes de Vídeos",
  [MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_SUBTITLE]:
    "Vídeos prontos para publicar, com roteiro estruturado, áudio e legendas incluídos.",
  [MODAL_PURCHASE_CREDITS_VIDEO_ON_SCREEN_TEXT_LANGUAGES]:
    "Idiomas suportados:",
  [MODAL_PURCHASE_CREDITS_VIDEOS_LABEL]: "{{videos}} Vídeos com IA",
  [MODAL_PURCHASE_CREDITS_PRICE_PER_VIDEO]: "${{price}} USD cada",
  [MODAL_PURCHASE_CREDITS_PURCHASE_VIDEOS_BUTTON]: "Comprar vídeos",
  [MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE]: "Exemplos de vídeo",
  [MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLE]: "Exemplo {{number}}",

  [VIDEO_INSUFFICIENT_CREDITS_ALERT_TITLE]: "Créditos de vídeo insuficientes",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_INTRO]:
    "Você não tem créditos de vídeo suficientes para a operação. Para adquirir créditos, selecione uma das seguintes opções:",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_INSTRUCTION]:
    "Para adquirir créditos, selecione uma das seguintes opções:",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_PURCHASE]: "Comprar Créditos",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_UPGRADE]: "Atualizar plano",

  //MODAL ADD BRAND SUPER ADMIN
  [MODAL_ADD_BRAND_SUPER_ADMIN_TITLE]: "Adicionar Marca",

  //MODAL UPLOAD CUSTOM AUDIENCES GOOGLE
  [MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_TITLE]: "Carregue sua audiência",
  [MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_DESCRIPTION]:
    "Envie um arquivo CSV para criar uma audiência personalizada",

  //MODAL INSTANT EXPERIENCE CREATE
  [MODAL_INSTANT_EXPERIENCE_CREATE_TITLE]: "Criar experiência instantânea",
  [MODAL_INSTANT_EXPERIENCE_CREATE_DESCRIPTION]:
    "Configure a sua experiência instantânea personalizada.",

  //LOGIN
  [FORGOT_PASSWORD]: "Esqueceu sua senha?",
  [NO_HAVE_ACCOUNT]: "Não tem uma conta?",
  [REGISTER_HERE]: "Cadastre-se",
  [ALREADY_HAVE_AN_ACCOUNT]: "Já tem uma conta?",
  [LOG_IN]: "Entrar",
  [RESET_PASSWORD_EMAIL_SENT]:
    "Enviamos um e-mail com um link para você redefinir sua senha.",

  //AUTH LAYOUT (MARKETING PANEL)
  [AUTH_LAYOUT_HERO_TITLE]: "Potencialize seu Marketing",
  [AUTH_LAYOUT_HERO_DESCRIPTION]:
    "A plataforma de marketing com IA para criar, agendar e analisar seu conteúdo com facilidade.",
  [AUTH_LAYOUT_PREVIEW_PLACEHOLDER]: "Aqui você verá uma prévia do seu painel.",
  [AUTH_LAYOUT_PREVIEW_IMAGE_ALT]:
    "Prévia do painel de {{NAME_BUSINESS}} com campanhas, métricas e lista de campanhas",
  [AUTH_LAYOUT_FEATURE_AI_TITLE]: "Campanhas com IA",
  [AUTH_LAYOUT_FEATURE_AI_DESCRIPTION]: "Automatize seu marketing com IA.",
  [AUTH_LAYOUT_FEATURE_ANALYTICS_TITLE]: "Análises que importam",
  [AUTH_LAYOUT_FEATURE_ANALYTICS_DESCRIPTION]:
    "Meça resultados e converta dados em decisões claras.",
  [AUTH_LAYOUT_FEATURE_SCHEDULING_TITLE]: "Programação inteligente",
  [AUTH_LAYOUT_FEATURE_SCHEDULING_DESCRIPTION]:
    "Planeje e publique em seus canais a partir de um só lugar.",

  //RESET PASSWORD
  [RESET_PASSWORD]: "Redefinir senha",
  [RESET_PASSWORD_GET_TOKEN_FAILED]:
    "Não foi possível obter o token para redefinir a senha; tente abrir novamente o link enviado ao seu e-mail ou clique de novo em Esqueceu sua senha.",
  [RESET_PASSWORD_SAVED]: "Senha cambiada",

  //COMPLETE REGISTRATION
  [SET_PASSWORD]: "Establece seu Senha",

  //REGISTER
  [REGISTER_COUNTRY_ANSWER]: "Em qual país está sua marca?",
  [REGISTER_COUNTRY_PLACEHOLDER]: "País",
  [REGISTER_NAME_ANSWER]: "Qual é o seu nome?",
  [REGISTER_PHONE_ANSWER]: "Qual é o seu número de celular?",
  [REGISTER_EMAIL_ANSWER]: "Qual é o seu e-mail?",
  [REGISTER_PASSWORD_ANSWER]: "Crie uma senha",
  [REGISTER_BUSINESS_NAME_ANSWER]: "Qual é o nome da sua marca?",
  [REGISTER_CATEGORY_ANSWER]: "Qual é a categoria da sua marca?",
  [REGISTER_SOCIAL_NETWORK_ANSWER]:
    "Qual é a rede social principal da sua marca?",
  [REGISTER_SOCIAL_NETWORK_ANSWER_DESCRIPTION]:
    "Digite o @usuário da sua rede social.",
  [REGISTER_WEBSITE_ANSWER]: "Qual é o site da sua marca?",
  [REGISTER_WEBSITE_ANSWER_DESCRIPTION]:
    "Digite o link do seu Instagram ou de outra rede social se você não tiver site.",
  [REGISTER_MONTHLY_SALES_ANSWER]: "Qual é o faturamento mensal da sua marca?",
  [REGISTER_BUDGET_MARKETING_ANSWER]:
    "De quanto é o orçamento mensal de marketing da sua marca?",
  [REGISTER_EMPLOYEES_ANSWER]: "Quantos empleados tiene sua marca?",
  [REGISTER_PRODUCT_AVAILABILITY_ANSWER]:
    "Qual é a disponibilidade dos seus produtos?",
  [REGISTER_RUT_ANSWER]: "Envie o documento de constituição da sua empresa",
  [REGISTER_INVIMA_ANSWER]:
    "Envie o registro de autoridade sanitária da sua marca",
  [REGISTER_ICA_ANSWER]:
    "Envie o registro de autoridade de produtos para animais da sua marca",
  [REGISTER_YOU_MEET_ANSWER]: "Onde nos conociste?",
  [REGISTER_WRITE_PLACEHOLDER]: "Escreva sua resposta aqui",
  [REGISTER_SELECT_PLACEHOLDER]: "Selecione uma opção",
  [REGISTER_COUNTRY_REQUIRED]: "Você deve selecionar seu país",
  [REGISTER_NAME_REQUIRED]: "Você deve escrever seu nome",
  [REGISTER_PHONE_REQUIRED]: "Você deve escrever seu número de celular",
  [REGISTER_PHONE_NUMERIC_REQUIRED]: "O número de celular não é válido",
  [REGISTER_BUSINESS_NAME_REQUIRED]: "Você deve escrever o nome da sua marca",
  [REGISTER_CATEGORY_REQUIRED]: "Você deve selecionar uma categoria",
  [REGISTER_SOCIAL_NETWORK_REQUIRED]:
    "O @ da sua rede social deve ter ao menos 3 caracteres",
  [REGISTER_WEB_SITE_REQUIRED]:
    "Você deve escrever o link da página web da sua marca",
  [REGISTER_MONTHLY_SALES_REQUIRED]:
    "Você deve selecionar o faturamento mensal da sua marca",
  [REGISTER_BUDGET_MARKETING_REQUIRED]:
    "Você deve selecionar o orçamento mensal de marketing da sua marca",
  [REGISTER_EMPLOYEES_REQUIRED]:
    "Você deve selecionar o número de funcionários da sua marca",
  [REGISTER_PRODUCT_AVAILABILITY_REQUIRED]:
    "Você deve selecionar a disponibilidade dos seus produtos",
  [REGISTER_RUT_REQUIRED]:
    "Você deve selecionar o RUT ou documento de constituição da empresa",
  [REGISTER_INVIMA_REQUIRED]:
    "Você deve selecionar o registro INVIMA da sua marca",
  [REGISTER_ICA_REQUIRED]: "Você deve selecionar o registro ICA da sua marca",
  [REGISTER_YOU_MEET_REQUIRED]:
    "Você deve selecionar uma opção de onde nos conheceu",
  [REGISTER_NO_HAVE_DOCUMENTS_ALERT_TITLE]: "Desculpe",
  [REGISTER_NO_HAVE_DOCUMENTS_ALERT_DESCRIPTION]:
    "Não podemos continuar o processo se você não tiver os documentos obrigatórios. Retome o processo quando os tiver.",
  [REGISTER_REGISTERED_ALERT_DESCRIPTION]:
    "Estamos analisando suas informações. Enviaremos um e-mail quando sua marca for aprovada",
  [PLEASE_SELECT_COUNTRY]: "Por favor selecione um país",
  [REGISTER_PROFILE_CREATOR_CITIES_ANSWER]:
    "De quais cidades você quer encontrar criadores para trabalhar?",
  [REGISTER_PROFILE_CREATOR_PLATFORMS_ANSWER]:
    "Em quais plataformas de redes sociais ou conteúdo você quer encontrar criadores para trabalhar?",
  [REGISTER_PROFILE_CREATOR_CATEGORIES_ANSWER]:
    "Que tipo de conteúdo você quer que o seu criador ideal faça?",
  [REGISTER_PROFILE_CREATOR_GENDER_ANSWER]:
    "Com criadores de qual gênero você tem interesse em colaborar?",
  [REGISTER_PROFILE_CREATOR_AGE_ANSWER]:
    "Com criadores de quais idades você tem interesse em colaborar?",
  [REGISTER_PROFILE_CREATOR_BODY_BUILD]:
    "Que tipo de corpo você quer que o seu criador ideal tenha?",
  [REGISTER_PROFILE_CREATOR_CLOTHING_STYLE]:
    "Que estilo de roupa você quer que o seu criador ideal tenha?",
  [REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES]:
    "Que características distintivas você quer que o seu criador ideal tenha?",
  [REGISTER_PROFILE_CREATOR_CONTENT_STYLE]:
    "Que estilo de conteúdo você quer que o seu criador ideal tenha?",
  [REGISTER_PROFILE_CREATOR_CITIES_REQUIRED]:
    "Você deve selecionar ao menos uma cidade",
  [REGISTER_PROFILE_CREATOR_PLATFORMS_REQUIRED]:
    "Você deve selecionar ao menos uma plataforma",
  [REGISTER_PROFILE_CREATOR_CATEGORIES_REQUIRED]:
    "Você deve selecionar no mínimo três categorias",
  [REGISTER_PROFILE_CREATOR_GENDER_REQUIRED]:
    "Você deve selecionar ao menos um gênero",
  [REGISTER_PROFILE_CREATOR_AGE_RANGE_REQUIRED]:
    "Você deve selecionar no mínimo duas faixas de idade",
  [REGISTER_PROFILE_CREATOR_BODY_BUILD_REQUIRED]:
    "Você deve selecionar ao menos dois tipos de corpo",
  [REGISTER_PROFILE_CREATOR_CLOTHING_STYLE_REQUIRED]:
    "Você deve selecionar ao menos três estilos de roupa",
  [REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES_REQUIRED]:
    "Você deve selecionar ao menos três características distintivas",
  [REGISTER_PROFILE_CREATOR_CONTENT_STYLE_REQUIRED]:
    "Você deve selecionar ao menos três estilos de conteúdo",

  //CHATS
  [CHAT_ERROR_SENT_MESSAGE]:
    "Desculpe, houve uma falha interna. Tente mais tarde.",
  [CHAT_DO_PAYMENT]: "Fazer pagamento",
  [CHAT_WRITE_QUESTION_HERE]: "Escreva uma pergunta",
  [CHAT_WRITE_MESSAGE_HERE]: "Escreva uma mensagem",
  [CHAT_EMAIL_NO_PERMITTED]: "Não é permitido enviar e-mails",
  [ONE_SECOND_AGO]: "há 1 segundo",
  [CHAT_FIRST_MESSAGE_BOT]:
    "Olá, sou a Ana, assessora especialista na plataforma.\\nEm que posso ajudar hoje?",
  [CHAT_NO_MORE]: "Não há mais chats",
  [CHAT_DO_A_QUESTION]: "Fazer uma pergunta",
  [CHAT_ASK_A_QUESTION_ABOUT_YOUR_CAMPAIGN]: "Enviar uma mensagem",
  [CHAT_CAMPAIGN_OPEN_AUTO_SUMMARY_QUESTION]:
    "Me dê um resumo conciso da minha campanha e se devo fazer alguma alteração neste momento.",
  [CHAT_CAMPAIGN_OPEN_ANALYZING_SUGGESTIONS]:
    "Analisando sua campanha para trazer sugestões...",
  [CHAT_BOT_NAME]: "Agente de marketing",
  [CHAT_BOT_DESCRIPTION]: "Pergunte sobre sua campanha",
  [CHAT_BOT_WELCOME_MESSAGE]: "O que você gostaria de otimizar hoje?",
  [CHAT_BOT_WELCOME_DESCRIPTION]:
    "Você também pode pedir mudanças de texto, segmentação e mais.",
  [CHAT_BOT_WELCOME_MESSAGE_STATISTICS]:
    "O que você gostaria de saber sobre sua campanha?",
  [CHAT_BOT_WELCOME_DESCRIPTION_STATISTICS]:
    "Você pode me perguntar sobre métricas, segmentação, orçamentos, custos e mais.",
  [CHAT_BOT_WELCOME_MESSAGE_OWNER]: "Em que você precisa de ajuda?",
  [CHAT_BOT_WELCOME_DESCRIPTION_OWNER]:
    "Pergunte sobre seus clientes, marcas, planos e faturamento.",
  [CHAT_ASK_A_QUESTION_OWNER]: "Pergunte sobre seu painel...",
  [CHAT_REASONING_ANALYZING_USER_MESSAGE]: "Analisando a mensagem do usuário",
  [CHAT_REASONING_PROCESSING_CAMPAIGN_DATA]: "Processando dados da campanha",
  [CHAT_REASONING_GETTING_PERFORMANCE_METRICS]:
    "Obtendo métricas de desempenho",
  [CHAT_REASONING_ANALYZING_BEST_PRACTICES]: "Analisando boas práticas",
  [CHAT_REASONING_GENERATING_RECOMMENDATIONS]: "Gerando recomendações",
  [CHAT_THINKING]: "Pensando",

  //SUMMARY TEXT (CHAT)
  [CHAT_SUMMARY_OVERVIEW_TEXT]:
    "Como foi o desempenho geral em {{platforms}} entre as datas {{startDateTime}} e {{endDateTime}}? Me dê um parágrafo conciso detalhando o desempenho.",

  //NOTIFICATIONS
  [NOTIFICATIONS_TITLE]: "Notificações",
  [NOTIFICATIONS_MARK_READS]: "Marcar como lidas",
  [NOTIFICATIONS_EMPTY]: "Você não tem notificações",
  [NOTIFICATIONS_NO_MORE]: "Você não tem mais notificações",
  [NOTIFICATIONS_CHECK_NOTIFICATION]: "Ver",

  //TRANSACTIONS
  [TRANSACTION_CONCEPT_LABEL]: "Conceito",
  [TRANSACTION_TYPE]: "Tipo",
  [TRANSACTION_TYPE_CREDIT]: "Crédito",
  [TRANSACTION_TYPE_DEBIT]: "Débito",
  [TRANSACTION_STATUS]: "Situação",
  [TRANSACTION_STATUS_PENDING]: "Pendente",
  [TRANSACTION_STATUS_PENDING_RELEASE]: "Pendente de liberar",
  [TRANSACTION_STATUS_IN_PROCESS_RELEASE]: "Em processo de liberação",
  [TRANSACTION_STATUS_RELEASED]: "Liberado",
  [TRANSACTION_STATUS_PENDING_SENT]: "Pendente de enviar",
  [TRANSACTION_IN_TRANSIT]: "Em trânsito",
  [TRANSACTION_STATUS_PAID]: "Pago",
  [TRANSACTION_WAS_PAID]: "Foi pago",
  [MODAL_CREATE_TRANSACTION]: "Crie uma transação para um criador",
  [MODAL_CREATE_TRANSACTION_AMOUNT_LABEL]: "Valor (USD)",
  [MODAL_CREATE_TRANSACTION_CONCEPT_LABEL]: "Conceito",
  [MODAL_CREATE_TRANSACTION_CONCEPT_APPLICANT]: "Candidato",
  [MODAL_CREATE_TRANSACTION_CONCEPT_ORDER]: "Pedido",
  [MODAL_CREATE_TRANSACTION_CONCEPT_REFERRAL]: "Indicação",
  [MODAL_CREATE_TRANSACTION_CONCEPT_ID]: "ID do concepto (Opcional)",

  //CONTENT
  [CONTENT_TITLE]: "Conteúdo de marcas",

  //CONTENT APPLICATION
  [CONTENT_APPLICATION_TITLE]: "Aplicação de conteúdo",
  [CONTENT_APPLICATION_ACCEPT_TITLE]: "Aceitar aplicação",
  [CONTENT_APPLICATION_ACCEPT_DESCRIPTION]:
    "Ao aceitar esta aplicação, o usuário poderá se cadastrar como criador de conteúdo",
  [CONTENT_APPLICATION_REJECT_TITLE]: "Rejeitar aplicação",
  [CONTENT_APPLICATION_REJECT_DESCRIPTION]:
    "Ao rejeitar estar aplicação, o usuário não poderá se cadastrar como criador de conteúdo",

  //REPORTS
  [REPORTS_TITLE]: "Relatórios",
  [REPORTS_DESCRIPTION]:
    "Aqui você encontrará as estatísticas gerais do ecossistema de {{NAME_BUSINESS}}",
  [REPORTS_ERROR_GENERATING]:
    "Algo deu errado com a geração de estatísticas, por favor tente novamente.",
  [REPORTS_REQUESTS_ACTIVE]: "Solicitações ativas",
  [REPORTS_REQUESTS_INACTIVE]: "Solicitações inativas",
  [REPORTS_TYPE_USERS]: "Usuário type",
  [REPORTS_NUMBER_USERS]: "Número de usuários",
  [REPORTS_TYPE_ORDER]: "Tipo de pedido",
  [REPORTS_NUMBER_ORDER]: "Número de pedidos",
  [REPORTS_MODAL_DESCRIPTION]:
    "Aqui você encontrará os relatórios de distintas categorias",
  [REPORTS_MODAL_ONLY_BRANDS_ACTIVE]: "Somente lojas ativas",
  [REPORTS_MODAL_TYPE_REPORT_LABEL]: "Tipo de relatório",
  [REPORTS_MODAL_TYPE_REPORT_BRANDS]: "Marcas",
  [REPORTS_MODAL_TYPE_REPORT_CREATORS]: "Criadores",
  [REPORTS_MODAL_TYPE_REPORT_ORDERS]: "Pedidos",

  //SHOPIFY TERMS
  [INTEGRATIONS_TERMS_TITLE]: `Política de Privacidade de {{NAME_BUSINESS}} com Integrações`,
  [INTEGRATIONS_TERMS_DESCRIPTION]: "Última atualização: {{date,short}}",
  [INTEGRATIONS_TERMS_CONTENT]: `\n  <strong>1. Informação coletada</strong>\n\n  Em {{NAME_BUSINESS}}, respeitamos a privacidade dos nossos usuários e clientes. Por meio da nossa integração com plataformas, coletamos informação limitada e específica apenas para o funcionamento técnico da nossa aplicação. Os dados que coletamos incluem:\n\n  Nome da loja da plataforma: Utilizamos esta informação para identificar a loja e facilitar a execução de ações específicas dentro da plataforma.\n\n  Token de autorização: Utilizamos um token de autorização fornecido pelos comerciantes da plataforma para realizar as solicitações técnicas necessárias para o monitoramento de mudanças de estado de entregas e a execução de ações conforme necessário.\n\n  <strong>2. Uso da informação</strong>\n\n  É importante destacar que não armazenamos nenhum dado pessoal nem informação identificável dos comerciantes ou dos seus clientes. A informação coletada é utilizada apenas para a execução técnica da aplicação {{NAME_BUSINESS}} na plataforma. Não é utilizada para nenhum outro fim e não é armazenada nas nossas bases de dados.\n\n  <strong>3. Retenção de dados</strong>\n\n  Em linha com a nossa política de não armazenamento de dados, não retemos nenhuma informação dos comerciantes ou dos seus clientes. Qualquer informação recebida é utilizada em tempo real e descartada imediatamente após o uso.\n\n  <strong>4. Contato</strong>\n\n  Se você tiver alguma pergunta ou dúvida sobre a nossa política de privacidade, não hesite em entrar em contato conosco em ${EMAIL_SUPPORT}.\n  `,

  [AUTH_TIKTOK_VERIFICATION_LOADING]: "Verificando sua conta de TikTok",
  [AUTH_TIKTOK_VERIFICATION_SUCCESS]: "Sua conta do TikTok foi verificada",
  [AUTH_TIKTOK_VERIFICATION_FAILED]:
    "Ocorreu um erro. Não foi possível verificar sua conta do TikTok",

  // COLUMN NAMES
  [COLUMN_NAME_BRAND]: "Marca",
  [COLUMN_NAME_AGENCY]: "Agência",
  [COLUMN_NAME_ADVERTISER]: "Marca",
  [COLUMN_NAME_USER]: "Usuário",
  [COLUMN_NAME_CATEGORY]: "Categoria",
  [COLUMN_NAME_IS_LOGGED]: "Fez login",
  [COLUMN_NAME_IS_ACTIVE]: "Está Ativa",
  [COLUMN_NAME_PACKAGE]: "Pacote",
  [COLUMN_NAME_EMAIL]: "E-mail",
  [COLUMN_NAME_NAME]: "Nome",
  [COLUMN_NAME_PHONE]: "Telefone",
  [COLUMN_NAME_STAFF]: "Staff",
  [COLUMN_NAME_ACCEPTED]: "Aceito",
  [COLUMN_NAME_MONTHLY_SALES]: "Vendas por mês",
  [COLUMN_NAME_BUDGET_MARKETING]: "Orçamento de marketing",
  [COLUMN_NAME_EMPLOYEES]: "Funcionários",
  [COLUMN_NAME_PRODUCT_AVAILABILITY]: "Disponibilidade de produtos",
  [COLUMN_NAME_SOCIAL_NETWORK]: "Rede social",
  [COLUMN_NAME_WEB_SITE]: "Website",
  [COLUMN_NAME_YOU_MEET]: "Onde nos conheceu",
  [COLUMN_NAME_DATE]: "Data",
  [COLUMN_NAME_PLAN]: "Plano",
  [COLUMN_NAME_PAYMENT_METHOD]: "Método de pagamento",
  [COLUMN_NAME_COST_COLLABORATION]: "Custo por colaboração",
  [COLUMN_NAME_CREDITS]: "Créditos",
  [COLUMN_NAME_COUNTRY]: "País",
  [COLUMN_NAME_CREATOR_NAME]: "Nome",
  [COLUMN_NAME_CREATOR_PLATFORM]: "Plataforma",
  [COLUMN_NAME_CITY]: "Cidade",
  [COLUMN_NAME_AUDIENCE]: "Audiência",
  [COLUMN_NAME_ENGAGEMENT]: "Engajamento",
  [COLUMN_NAME_CATEGORIES]: "Categorias",
  [COLUMN_NAME_SCORE]: "Pontuação",
  [COLUMN_NAME_ACTIVITY]: "Atividade",
  [COLUMN_NAME_ACTIONS]: "Ações",
  [COLUMN_NAME_ACTION]: "Ação",
  [COLUMN_NAME_STATUS]: "Situação",
  [COLUMN_NAME_REDEEMED_DATE]: "Resgatada em",
  [COLUMN_NAME_TERMS]: "Termos",
  [COLUMN_NAME_TYPE]: "Tipo",
  [COLUMN_NAME_ADDRESS]: "Endereço",
  [COLUMN_NAME_STORE]: "Loja",
  [COLUMN_NAME_ROLE]: "Função",
  [COLUMN_NAME_PAID_DATE]: "Paga em",
  [COLUMN_NAME_DUE_DATE]: "Vence em",
  [COLUMN_NAME_REASON]: "Motivo",
  [COLUMN_NAME_VALUE]: "Valor",
  [COLUMN_NAME_ID]: "ID",
  [COLUMN_NAME_CREATOR]: "Criador",
  [COLUMN_NAME_CREATED_DATE]: "Criado em",
  [COLUMN_NAME_ACCEPTED_DATE]: "Aceito em",
  [COLUMN_NAME_DETAILS]: "Detalhes",
  [COLUMN_NAME_DELIVERY]: "Delivery",
  [COLUMN_NAME_CODE_VERIFICATION]: "Código de verificação",
  [COLUMN_NAME_ACCOUNT_NAME]: "Nome da conta",
  [COLUMN_NAME_IS_HIDDEN]: "Oculto",
  [COLUMN_NAME_COMMENT]: "Comentário",
  [COLUMN_NAME_URLS]: "Urls",
  [COLUMN_NAME_KEYWORD]: "Keyword",
  [COLUMN_NAME_SEARCH_TERM]: "Termo de busca",
  [GOOGLE_SEARCH_TERMS_TITLE]: "Termos de Búsqueda",
  [GOOGLE_SEARCH_TERMS_DESCRIPTION]:
    "São as consultas exatas que os usuários escreveram no Google e que ativaram os seus anúncios. Cada linha mostra qual palavra-chave as acionou.",
  [GOOGLE_SEARCH_TERMS_EMPTY]: "Ainda não há termos de busca",
  [SEARCH_TERM_MATCH_TYPE_BROAD]: "Correspondência ampla",
  [SEARCH_TERM_MATCH_TYPE_PHRASE]: "Correspondência de frase",
  [SEARCH_TERM_MATCH_TYPE_EXACT]: "Correspondência exata",
  [SEARCH_TERM_MATCH_TYPE_NEAR_PHRASE]:
    "Correspondência de frase (variante próxima)",
  [SEARCH_TERM_MATCH_TYPE_NEAR_EXACT]:
    "Correspondência exata (variante próxima)",
  [SEARCH_TERM_MATCH_TYPE_AI_MAX]: "AI Max",
  [COLUMN_NAME_IMPRESSIONS]: "Impressões",
  [COLUMN_NAME_CLICKS]: "Cliques",
  [COLUMN_NAME_CONFIGURE_COLUMNS]: "Mostrar colunas",
  [COLUMN_NAME_CTR]: "CTR",
  [COLUMN_NAME_CONVERSIONS]: "Conversões",
  [COLUMN_NAME_CPA]: "CPA",
  [COLUMN_NAME_CPM]: "CPM",
  [COLUMN_NAME_CPC]: "CPC",
  [COLUMN_NAME_MATCH_TYPE]: "Tipo de correspondência",
  [COLUMN_NAME_PLATFORM]: "Plataformas",
  [COLUMN_NAME_SPEND]: "Gasto",
  [COLUMN_NAME_RESULTS]: "Resultados",
  [COLUMN_NAME_FIELD]: "Campo",
  [COLUMN_NAME_CURRENT_VALUE]: "Valor atual",
  [COLUMN_NAME_NEW_VALUE]: "Valor novo",
  [COLUMN_NAME_CAMPAIGN]: "Campanha",
  [COLUMN_NAME_BUDGET]: "Orçamento",
  [COLUMN_NAME_CREATED_BY]: "Criado por",
  [CAMPAIGNS_TABLE_ARIA_LABEL]: "Tabla de campanhas publicitarias",
  [CAMPAIGNS_TABLE_TITLE]: "Listado de campanhas",
  [CAMPAIGNS_STATUS_DRAFT]: "Rascunho",
  [CAMPAIGNS_STATUS_FINISHED]: "Finalizado",
  [CAMPAIGNS_STATUS_DELETED]: "Excluída",
  [CAMPAIGNS_TABLE_FILTER_COLUMNS_TITLE]: "Filtrar colunas",
  [COLUMN_NAME_ENTITY]: "Entidade",

  //ALERTS
  [ALERT_PLATFORM_STATUS_BANNER]:
    "{{platform}} está com problemas técnicos. Algumas funções podem ser afetadas temporariamente",
  [ALERT_IMAGE_PROVIDER_STATUS_BANNER]:
    "O provedor de geração/edição de imagens está enfrentando problemas técnicos. Esta funcionalidade pode ser afetada temporariamente",
  [ALERT_VIDEO_PROVIDER_STATUS_BANNER]:
    "O provedor de geração de vídeos está enfrentando problemas técnicos. Esta funcionalidade pode ser afetada temporariamente",
  [ALERT_CAMPAIGN_PROVIDER_STATUS_BANNER]:
    "O provedor de geração de campanhas está enfrentando problemas técnicos. Esta funcionalidade pode ser afetada temporariamente",
  [ALERT_REBRAND_BANNER]:
    "Buzzly agora é Adle. A mesma plataforma de marketing com IA, nova identidade.",
  [ALERT_REBRAND_BANNER_DISCORD_BODY]:
    "Entre na comunidade oficial da Adle no Discord.",
  [DISCORD_LINK]: "Entrar no Discord",
  [ALERT_REBRAND_BANNER_APPSUMO_REVIEW_BODY]:
    "<margin>🌮</margin> Early Sumolings: você já tem seus créditos bônus. <underline>Compartilhe sua experiência na AppSumo 💛</underline>",
  [ALERT_REBRAND_BANNER_AFFILIATE_BODY]:
    "<margin>💸</margin> Ganhe com o nosso programa de afiliados.",
  [ALERT_REBRAND_BANNER_AFFILIATE_LINK]: "Aplicar Now 💸",
  [APPSUMO_REVIEW_BANNER_LINK]: "Deixar uma avaliação",
  [ALERT_REBRAND_BANNER_CAROUSEL_PREVIOUS]: "Mensagem anterior do banner",
  [ALERT_REBRAND_BANNER_CAROUSEL_NEXT]: "Próxima mensagem do banner",
  [MODAL_REBRAND_ADLE_TITLE]: "Buzzly agora é Adle",
  [MODAL_REBRAND_ADLE_DESCRIPTION]:
    "Buzzly está migrando sua marca para Adle. Será a mesma plataforma de marketing com IA, com uma nova identidade.",
  [MODAL_REBRAND_ADLE_GO_TO_ADLE_BUTTON]: "Ir para o Adle",
  [ALERT_INACTIVE_SHOP_TITLE]: "Marca Desativard",
  [ALERT_INACTIVE_SHOP_DESCRIPTION]:
    "Ativa la marca para seguir usando la plataforma",

  [ALERT_OPERATOR_ACTION_UNAUTHORIZED_DESCRIPTION]:
    "Você não pode executar esta ação porque não tem as permissões suficientes",
  [ALERT_CREATE_SECOND_ADS_CAMPAIGN]: "Criar campanha em {{platform}}",
  [ALERT_CREATE_SECOND_ADS_CAMPAIGN_DESCRIPTION]:
    "Deseja criar uma campanha em {{platform}} com a mesma configuração desta campanha?",
  [ALERT_REMEMBER_IF_RECHARGE_ACCOUNT_PLATFORM]:
    "Se recarregar sua conta, tenha em conta que o saldo pode demorar alguns minutos para aparecer e para esta opção ser habilitada novamente.",
  [ALERT_DESCRIPTION_DISCONNECT_FACEBOOK]:
    "Serão desabilitadas todas as funcionalidades de criar e gerenciar campanhas no Meta e publicar diretamente no Instagram.",
  [ALERT_DESCRIPTION_DISCONNECT_TIKTOK]:
    "Todas as funcionalidades para publicar diretamente no TikTok serão desativadas.",
  [ALERT_DESCRIPTION_DISCONNECT_TIKTOK_BUSINESS]:
    "Serão desabilitadas todas as funcionalidades de criar e gerenciar campanhas do TikTok",
  [ALERT_DESCRIPTION_DISCONNECT_LINKEDIN]:
    "Serão desabilitadas todas as funcionalidades de criar e gerenciar campanhas do LinkedIn",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE]: "Tem certeza?",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION]:
    "Você criará uma campanha com os seguintes orçamentos para cada plataforma:",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE_UPDATE]: "Tem certeza?",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION_UPDATE]:
    "Serão criados grupos de anúncios com os seguintes novos orçamentos para cada plataforma",
  [ALERT_DESCRIPTION_DISCONNECT_CANVA]:
    "Serão desabilitadas todas as funcionalidades de criar conteúdo ou editar com o Canva",
  [ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_TITLE]:
    "Conexão realizada com sucesso",
  [ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_DESCRIPTION]:
    "Sua conta do TikTok foi conectada com sucesso; agora você precisa criar uma identidade para exibir seus anúncios",
  [ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_TITLE]: "Conecta sua conta",
  [ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_DESCRIPTION]:
    "Para poder criar uma campanha você precisa conectar sua conta",
  [ALERT_CANCEL_SUBSCRIPTION_TITLE_CONFIRMATION]: "Tem certeza?",
  [ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION_CONFIRMATION]:
    "Ao cancelar a sua assinatura, você perderá o acesso a todas as funcionalidades da plataforma",
  [ALERT_CANCEL_SUBSCRIPTION_TITLE]: "Assinatura Cancelada",
  [ALERT_CANCEL_PLAN_TITLE]: "Plano cancelado",
  [ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION]:
    "A renovação automática da sua assinatura foi cancelada; seu serviço continuará ativo até {{date, monthText}} de {{date, day}}, {{date, year}}",
  [ALERT_REACTIVATE_SUBSCRIPTION_TITLE]: "Assinatura Reactivada",
  [ALERT_PAYMENT_METHOD_CHANGED_TITLE]:
    "O seu método de pagamento foi alterado corretamente",
  [ALERT_CONNECT_ACCOUNT_SECURE_DESCRIPTION]:
    "Com {{NAME_BUSINESS}} suas contas estarão seguras. Somos uma plataforma verificada e auditada pela {{platform}}, o que permite gerenciar e desconectar suas contas a qualquer momento.",
  [ALERT_POPUP_BLOCKED_TITLE]: "Permitir pop-ups",
  [ALERT_POPUP_BLOCKED_DESCRIPTION]:
    "Detectamos que as janelas pop-up estão bloqueadas para este site. Por favor, habilite as janelas pop-up e tente novamente.",
  [ALERT_DELETE_PLATFORM_CAMPAIGN_DESCRIPTION]:
    "Você não vai mais publicar uma campanha em {{platform}}",
  [ALERT_DUPLICATE_CAMPAIGN_TITLE]: "Duplicar Campanha",
  [ALERT_DUPLICATE_CAMPAIGN_DESCRIPTION]:
    "Será criada uma campanha com esta mesma configuração, mas você poderá editá-la antes de publicá-la.",
  [ALERT_DELETE_CAMPAIGN_ACTIVE_TITLE]:
    "Quer desativar e excluir esta campanha?",
  [ALERT_DELETE_CAMPAIGN_TITLE]:
    "Tem certeza de que deseja excluir esta campanha?",
  [ALERT_ARCHIVE_CAMPAIGN_TITLE]:
    "Tem certeza de que deseja arquivar esta campanha?",
  [ALERT_ARCHIVE_CAMPAIGN_TITLE_ACTIVE]:
    "Quer desativar e arquivar esta campanha?",
  [ALERT_ARCHIVE_CAMPAIGN_DESCRIPTION]:
    "Esta campanha já foi gerada e foi descontada do seu plano. Ao arquivá-la, você não poderá recuperá-la e o gasto não será eliminado",
  [ALERT_DELETE_CAMPAIGN_DESCRIPTION]:
    "A campanha de {{platform}} será excluída. Você não poderá recuperar as informações nem voltar a criar uma campanha de {{platform}} neste grupo de campanhas.",
  [ALERT_DELETE_ELEMENT_TITLE]: "Tem certeza?",
  [ALERT_DELETE_ELEMENT_DESCRIPTION]:
    "Se excluir este elemento, você não poderá recuperar a informação.",
  [ALERT_DELETE_CAMPAIGN_ERROR_TITLE]: "Erro ao excluir a campanha",
  [ALERT_DELETE_CAMPAIGN_ERROR_TEXT]:
    "Não foi possível excluir a campanha. Tente novamente",
  [ALERT_PUBLISH_ACTIVE_OR_DEACTIVATE_CAMPAIGN_TITLE]:
    "Escolha se quer que sua campanha seja criada com status ativo ou inativo",
  [ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_TITLE]:
    "Você não tem uma conta registrada",
  [ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_DESCRIPTION]:
    "Para se cadastrar, você precisa agendar uma demonstração conosco.",
  [ALERT_DESCRIPTION_DISCONNECT_GOOGLE]:
    "Serão desabilitadas todas as funcionalidades de criar e gerenciar campanhas do Google Ads",
  [ALERT_CONNECT_GOOGLE_BETA_TITLE]: "Conecta sua conta de Google Ads",
  [ALERT_CONNECT_GOOGLE_BETA_DESCRIPTION]:
    "Esta funcionalidade está em <strong>BETA</strong>. A seguir, você verá como conectar sua conta do Google Ads.",
  [ALERT_FILL_BRAND_SETUP_TITLE]: "Completa la informação de sua marca",
  [ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN]:
    "Preencha a informação da sua marca para gerar uma campanha com IA",
  [ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_GENERATE_CREATIVES]:
    "Preencha a informação da sua marca para gerar criativos com IA",
  [ALERT_DELETE_KEYWORD_TITLE]: "Excluir palabra clave",
  [ALERT_DELETE_KEYWORD_DESCRIPTION]:
    "Tem certeza de que deseja excluir esta palavra-chave?",
  [ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE]:
    "Aguarde",
  [ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION]:
    "Se realizar esta alteração, os conteúdos que você tiver selecionado para seus anúncios serão desmarcados",
  [ALERT_IS_DYNAMIC_CREATIVE_ON_TITLE]: "Tem certeza?",
  [ALERT_IS_DYNAMIC_CREATIVE_ON_DESCRIPTION]:
    "Ao utilizar criativos dinâmicos, serão aplicadas as seguintes limitações:<br><br><ul><li>Só será possível ter 1 anúncio. (Os restantes serão removidos se você tiver mais de um)</li><br/><li>Você só poderá utilizar Website ou Formulários Instantâneos como local de conversão do grupo de anúncios</li><br/></ul>Estas correções serão aplicadas automaticamente se você continuar.",
  [ALERT_IS_DYNAMIC_CREATIVE_OFF_TITLE]: "Tem certeza?",
  [ALERT_IS_DYNAMIC_CREATIVE_OFF_DESCRIPTION]:
    "Ao deixar de utilizar criativos dinâmicos, serão aplicadas as seguintes alterações:<br><br><ul><li>Seu único anúncio será reiniciado, mantendo apenas o primeiro criativo e o primeiro call to action</li></ul>",
  [ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE]: "Aguarde",
  [ALERT_CHANGE_AD_ACCOUNT_META_DESCRIPTION]: `Ao alterar a conta publicitária, algumas configurações selecionadas da sua campanha serão redefinidas:<br/><br/>\n\nPixel<br/>\nFormulário instantâneo<br/>\nNúmero de WhatsApp<br/>\nAudiências personalizadas<br/>\nOrçamentos`,
  [ALERT_CHANGE_AD_ACCOUNT_TIKTOK_DESCRIPTION]: `Ao alterar a conta publicitária, algumas configurações selecionadas da sua campanha serão redefinidas:<br/><br/>\n\nIdentidade do TikTok<br/>\nPixel<br/>\nOrçamentos`,
  [ALERT_CHANGE_AD_ACCOUNT_GOOGLE_DESCRIPTION]: `Ao alterar a conta publicitária, algumas configurações selecionadas da sua campanha serão redefinidas:<br/><br/>\n\nAções de conversão<br/>\nOrçamento`,
  [ALERT_CHANGE_AD_ACCOUNT_LINKEDIN_DESCRIPTION]: `Ao alterar a conta publicitária, algumas configurações selecionadas da sua campanha serão redefinidas:<br/><br/>\n\nAudiências personalizadas<br/>\nFormulário instantâneo<br/>\nOrçamento`,
  [ALERT_DELETE_KEYWORDS_TITLE]: "Excluir palavras-chave",
  [ALERT_DELETE_KEYWORDS_DESCRIPTION]:
    "Tem certeza de que deseja excluir {{value}} palavras-chave?",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_TITLE]: "Aguarde",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_DESCRIPTION]:
    "Um ou mais grupos de anúncios têm audiências personalizadas configuradas; se você selecionar audiências personalizadas no nível da campanha, as configurações de audiências personalizadas dos grupos de anúncios serão desmarcadas.",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_TITLE]: "Aguarde",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_DESCRIPTION]:
    "Há uma ou mais audiências personalizadas configuradas no nível da campanha; se você selecionar audiências personalizadas no nível do grupo, as configurações de audiências personalizadas da campanha serão desmarcadas.",
  [SUGGESTION_BUDGET_TITLE]: "Sugestão de orçamento",
  [SUGGESTION_BUDGET_TEXT]:
    "Você estendeu a data de término deste grupo de anúncios; recomendamos aumentar o orçamento total para manter uma relação igual",
  [SUGGESTION_BUDGET_PREVIOUS]: "Orçamento Anterior",
  [SUGGESTION_BUDGET_CURRENT]: "Orçamento Sugerido",
  [SUGGESTION_BUDGET_APPLY]: "Aplicar Suggestion",
  [SUGGESTION_BUDGET_CANCEL]: "Cancelar",
  [SUGGESTION_BUDGET_MINIMUM]: "Orçamento Mínimo",
  [ALERT_CHANGE_ADVERTISER_TITLE]: "Cambiaste ao anunciante {{businessName}}",
  [ALERT_RESIZE_IMAGE_FAILED_DESCRIPTION]:
    "Não foi possível redimensionar esta imagem, por favor tente novamente.",

  //OPTIONS UGC FORMATS
  [OPTION_UGC_FORMAT_GRWM]: "GRWM (Get Ready With Me)",
  [OPTION_UGC_FORMAT_GRWM_EXPLANATION]:
    "Este tipo de conteúdo envolve criadores compartilhando sua rotina de preparação, seja para o dia a dia ou para eventos especiais. Os espectadores podem ver como o criador se maquia, penteia e escolhe o vestuário, enquanto fala de diversos temas de maneira informal.",
  [OPTION_UGC_FORMAT_OODT]: "OOTD (Look do dia)",
  [OPTION_UGC_FORMAT_OODT_EXPLANATION]:
    "Nesses vídeos ou publicações, os criadores mostram o look que escolheram para o dia. É popular entre entusiastas da moda e pode incluir detalhes sobre onde compraram a roupa, como a combinam com outros elementos e conselhos de estilo.",
  [OPTION_UGC_FORMAT_HAULS]: "Hauls",
  [OPTION_UGC_FORMAT_HAULS_EXPLANATION]:
    "Os 'hauls' são vídeos ou séries de fotos em que os criadores mostram uma coleção de produtos que compraram recentemente, que podem incluir moda, beleza, tecnologia etc. Com frequência, compartilham suas primeiras impressões sobre esses produtos e podem incluir demonstrações de uso.",
  [OPTION_UGC_FORMAT_DIYS]: "Tutorials/DIYs",
  [OPTION_UGC_FORMAT_DIYS_EXPLANATION]:
    "Tutoriais ou 'Faça você mesmo' (Do It Yourself) são guias passo a passo criados por usuários que mostram como fazer algo, de receitas de cozinha a projetos de artesanato e dicas de beleza. Esses conteúdos são educativos e buscam ensinar habilidades de forma fácil e acessível.",
  [OPTION_UGC_FORMAT_UNBOXING]: "Unboxing",
  [OPTION_UGC_FORMAT_UNBOXING_EXPLANATION]:
    "Nesses vídeos, os criadores abrem produtos novos diante da câmera para exibir seu conteúdo e dar uma primeira impressão. São comuns em tecnologia, brinquedos, cosméticos e mais, ajudando os espectadores a decidir se desejam comprar esses produtos.",
  [OPTION_UGC_FORMAT_CHALLENGES]: "Challenges",
  [OPTION_UGC_FORMAT_CHALLENGES_EXPLANATION]:
    "Os desafios ou 'challenges' são atividades em que os criadores participam para entreter seus seguidores. Podem variar de desafios de comida, jogos e atividades físicas a desafios de moda, como criar um look com elementos específicos.",
  [OPTION_UGC_FORMAT_REVIEWS]: "Revisãos/Testimonials",
  [OPTION_UGC_FORMAT_REVIEWS_EXPLANATION]:
    "Os criadores compartilham suas opiniões e experiências detalhadas sobre um produto ou serviço específico. Essas avaliações ajudam outros usuários a formar uma opinião antes de fazer uma compra.",
  [OPTION_UGC_FORMAT_VLOGS]: "Vlogs",
  [OPTION_UGC_FORMAT_VLOGS_EXPLANATION]:
    "Os vlogs são diários em vídeo em que os criadores compartilham aspectos da sua vida diária, viagens, eventos especiais etc. São pessoais e permitem que os espectadores sintam uma conexão mais próxima com o criador.",
  [OPTION_UGC_FORMAT_QA]: "P&R (Perguntas e Respostas)",
  [OPTION_UGC_FORMAT_QA_EXPLANATION]:
    "Em um formato de perguntas e respostas, os criadores interagem diretamente com sua audiência respondendo a perguntas enviadas previamente. Isso ajuda a construir uma relação mais pessoal e direta com os seguidores.",
  [OPTION_UGC_FORMAT_STORYTIME]: "Storytime",
  [OPTION_UGC_FORMAT_STORYTIME_EXPLANATION]:
    "Estes são vídeos ou posts em que os criadores narram histórias pessoais ou experiências significativas. São atrativos pelo aspecto narrativo e frequentemente incluem lições ou moral da história.",
  [OPTION_UGC_FORMAT_ROOM_TOURS]: "Room Tours",
  [OPTION_UGC_FORMAT_ROOM_TOURS_EXPLANATION]:
    "Os criadores mostram seu espaço pessoal, como quarto, estúdio ou casa inteira. Esses vídeos são populares porque permitem aos seguidores obter ideias de decoração e sentir proximidade com o estilo de vida do criador.",
  [OPTION_UGC_FORMAT_WHATS_IN_MY_BAG]: "O que tem na minha bolsa?",
  [OPTION_UGC_FORMAT_WHATS_IN_MY_BAG_EXPLANATION]:
    "Neste tipo de conteúdo, os criadores revelam o que levam nas bolsas ou mochilas diariamente. É popular especialmente entre celebridades e influenciadores de moda e beleza, pois oferece um vislumbre dos seus itens essenciais pessoais.",
  [OPTION_UGC_FORMAT_COOKING]: "Cooking/Baking Recipes",
  [OPTION_UGC_FORMAT_COOKING_EXPLANATION]:
    "Os criadores compartilham receitas e processos de cozinha ou confeitaria em forma de vídeos ou posts. Esses conteúdos são úteis para quem busca novas ideias de refeições e aprecia o aspecto visual e explicativo da cozinha.",
  [OPTION_UGC_FORMAT_FITNESS_ROUTINES]: "Fitness Routines",
  [OPTION_UGC_FORMAT_FITNESS_ROUTINES_EXPLANATION]:
    "Os influenciadores de fitness compartilham suas rotinas de exercícios, conselhos de saúde e jornadas de bem-estar. Esses vídeos são motivacionais e educativos, ajudando os seguidores a se manterem ativos e saudáveis.",
  [OPTION_UGC_FORMAT_ASMR]: "ASMR (Autonomous Sensory Meridian Response)",
  [OPTION_UGC_FORMAT_ASMR_EXPLANATION]:
    "Os vídeos de ASMR são feitos para provocar uma sensação relaxante nos espectadores por meio de sons suaves e movimentos meticulosos. São muito populares para relaxamento e manejo do estresse.",
  [OPTION_UGC_FORMAT_PLAN_WITH_ME]: "Planeje comigo",
  [OPTION_UGC_FORMAT_PLAN_WITH_ME_EXPLANATION]:
    "Nesses vídeos, os criadores mostram como organizam sua agenda ou planner semanal, compartilhando técnicas de gestão do tempo e decoração dos planners. É ideal para amantes de papelaria e organização pessoal.",
  [OPTION_UGC_FORMAT_MUKBANG]: "Mukbang",
  [OPTION_UGC_FORMAT_MUKBANG_EXPLANATION]:
    "Originado na Coreia do Sul, nesses vídeos os criadores comem grandes quantidades de comida enquanto interagem com sua audiência. Popularizou-se globalmente como uma forma de companhia virtual durante as refeições.",
  [OPTION_UGC_FORMAT_DAY_IN_THE_LIFE]: "Um dia na vida",
  [OPTION_UGC_FORMAT_DAY_IN_THE_LIFE_EXPLANATION]:
    "Os criadores compartilham um vídeo que documenta um dia típico na sua vida, mostrando desde a manhã até a noite. Isso dá aos seguidores uma visão completa das suas atividades cotidianas e do seu estilo de vida.",
  [OPTION_UGC_FORMAT_BEHIND_THE_SCENES]: "Bastidores",
  [OPTION_UGC_FORMAT_BEHIND_THE_SCENES_EXPLANATION]:
    "Esses vídeos oferecem um olhar dos bastidores na vida dos criadores, incluindo como preparam seus conteúdos, gerenciam negócios ou até eventos especiais a que assistem.",
  [OPTION_UGC_FORMAT_TRAVEL_DIARIES]: "Travel Diaries",
  [OPTION_UGC_FORMAT_TRAVEL_DIARIES_EXPLANATION]:
    "Em diários de viagem, os criadores compartilham experiências, conselhos e aventuras das suas viagens. Esses vídeos ou posts são atrativos para quem busca inspiração para viajar ou aprender sobre novas culturas.",

  //ERRORS
  [SOMETHING_ERROR_GENERATING_STATISTICS]:
    "Algo deu errado com a geração de estatísticas, por favor tente novamente.",
  [AUTH_SENT_EMAIL_RESET_PASSWORD]:
    "Foi enviado um e-mail para redefinir a senha",
  [EMAIL_UNSUBSCRIBE_SUCCESS_TITLE]: "Unsubscribed Sucessofully",
  [EMAIL_UNSUBSCRIBE_SUCCESS_TEXT]:
    "Você não receberá mais e-mails neste endereço.",
  [EMAIL_UNSUBSCRIBE_ERROR_TITLE]: "Unsubscribe Falhou",
  [EMAIL_UNSUBSCRIBE_ERROR_TEXT]:
    "Não foi possível processar sua solicitação. O link pode ser inválido ou ter expirado.",
  [AUTH_PAGE_DOCUMENT_TITLE_LOGIN]: "{{nameBusiness}} - Entrar",
  [AUTH_PAGE_DOCUMENT_TITLE_LOGIN_OWNER]: "{{nameBusiness}} - Acesso admin",
  [AUTH_LOGIN_OWNER_CHIP_LABEL]: "Acesso do proprietário",
  [AUTH_LOGIN_OWNER_SUBMIT]: "Entrar como proprietário",
  [AUTH_LOGIN_OWNER_NOT_OWNER]: "No eres owner?",
  [AUTH_LOGIN_OWNER_GO_TO_LOGIN]: "Entrar",
  [AUTH_PAGE_DOCUMENT_TITLE_REGISTER]: "{{nameBusiness}} - Cadastro",
  [AUTH_PAGE_DOCUMENT_TITLE_RESET_PASSWORD]:
    "{{nameBusiness}} - Redefinir senha",
  [AUTH_PAGE_BRANDING_LOGO_ALT]: "Logotipo",
  [AUTH_LOGIN_DEMO_EXISTING_ACCOUNT_BANNER]:
    "Este e-mail já está cadastrado. Entre abaixo com sua senha ou recupere-a se você esqueceu.",
  [ACCOUNT_ROLE_INVALID]: "Esta conta não tem um papel válido para entrar",
  [ERROR_INTERNAL]: "Erro interno, tente novamente mais tarde",
  [AUTH_INVALID_PASSWORD]: "A senha não é válida",
  [AUTH_WRONG_PASSWORD]: "O e-mail ou a senha está incorreto",
  [AUTH_MANY_REQUESTS]: "Muitas tentativas falhas, tente novamente mais tarde",
  [AUTH_USER_NOT_FOUND]: "O e-mail ou a senha está incorreto",
  [AUTH_EMAIL_ALREADY_EXISTS]: "O e-mail já está em uso",
  [PHONE_ALREADY_REGISTERED]: "Este número de telefone já está registrado",
  [AUTH_INVALID_VERIFICATION_CODE]: "O código de verificação não é válido",
  [AUTH_INVALID_APP_CREDENTIAL]: "Número de telefone inválido",
  [STRIPE_CARD_DECLINED]:
    "O cartão foi recusado. Verifique as informações ou a validade do cartão, ou use um cartão diferente",
  [STRIPE_EXPIRED_CARD]:
    "O cartão expirou. Verifique a data de validade ou use um cartão diferente",
  [STRIPE_INCORRECT_CVC]:
    "O código de segurança do cartão está incorreto. Verifique o código de segurança do cartão ou use um cartão diferente",
  [STRIPE_PROCESSING_ERROR]:
    "Ocorreu um erro ao processar o cartão. Tente novamente mais tarde ou use outro método de pagamento",
  [STRIPE_INCORRECT_NUMBER]:
    "O número do cartão está incorreto. Verifique o número do cartão ou use um cartão diferente",
  [STRIPE_GENERIC_DECLINE]: "O cartão foi recusado por um motivo desconhecido",
  [STRIPE_INSUFFICIENT_FUNDS]:
    "O cartão não tem saldo suficiente para concluir a compra ou para a cobrança de verificação",
  [STRIPE_LOST_CARD]:
    "O pagamento foi recusado porque o cartão foi informado como perdido",
  [STRIPE_STOLEN_CARD]:
    "O pagamento foi recusado porque o cartão foi informado como roubado",
  [STRIPE_PROFILE_NOT_FOUND]: "Este perfil não existe",
  [STRIPE_INTENT_AUTH_FAILURE]: "A autenticação do cartão falhou",
  [NIT_VALID]: "Número de identificação",
  [BUSINESS_NAME_VALID]: "Motivo social da empresa",
  [BRAND_NAME_VALID]: "Nome da marca",
  [ADDRESS_VALID]: "Endereço da empresa",
  [CATEGORY_VALID]: "Categoria",
  [SUBCATEGORIES_VALID]: "Subcategorias",
  [SHORT_DESCRIPTION_VALID]: "Descrição curta da empresa",
  [ORDERS_METHODS_VALID]: "Métodos de entrega de pedidos",
  [LOGO_IMG_VALID]: "Logo da empresa",
  [COVER_IMG_VALID]: "Imagem de capa",
  [SCHEDULE_VALID]: "Horários de atendimento da empresa",
  [STORES_VALID]: "Pelo menos uma loja criada e ativa",
  [IS_PLAN_ACTIVE_VALID]: "Você deve ter um plano ativo",
  [MENUS_VALID]:
    "Você deve ter pelo menos uma categoria com pelo menos um produto criado no menu",
  [DEFAULT_PAYMENT_METHOD_VALID]:
    "Você deve ter um cartão padrão adicionado ou créditos comprados",
  [HAS_DEBT_VALID]: "Você não deve ter pagamentos pendentes",
  [SUBSCRIPTION_PLAN_VALID]: "Você deve ter um plano ativo",
  [MISSING_PARAMETERS]: "Os parâmetros obrigatórios não foram enviados.",
  [PASSWORD_INVALID]: "Senha inválida.",
  [INVALID_SEARCH]: "Pesquisa inválida.",
  [USER_ID_REQUIRED]: "UserID é obrigatório.",
  [SHOP_ID_REQUIRED]: "ShopID é obrigatório.",
  [LAST_USER_NOT_DELETED]:
    "Você não pode excluir todos os usuários; deve deixar pelo menos um.",
  [PLAN_TRIAL_USER_USED]: "O período de teste já foi usado para este usuário.",
  [ORDERS_NOT_FOUND_IN_INTERVAL]:
    "Não foram encontrados pedidos no intervalo de datas selecionado.",
  [TYPE_REPORT_NOT_FOUND]: "O tipo de relatório não foi encontrado.",
  [SHOP_NOT_FOUND]: "Marca não encontrada.",
  [PAYMENT_MODEL_INVALID]: "Modelo de pagamento inválido.",
  [SHOP_NOT_HAS_SOCIAL_NETWORK]: "A marca não tem uma rede social associada.",
  [NO_VALID_PLATFORM_FOUND]: "Nenhuma plataforma válida foi encontrada.",
  [GETTING_STATISTICS]:
    "Erro ao obter estatísticas. Tente novamente mais tarde ou fale com o suporte.",
  [SHOP_BUSINESS_NAME_NOT_FOUND]: "O nome da marca não foi encontrado.",
  [REFERENCE_PROFILES_REQUIRED]: "Perfis de referência não encontrados.",
  [DECRYPTING_PASSWORD]: "Erro ao obter a senha.",
  [USER_ID_AND_PAYMENT_ID]: "UserID e paymentID são obrigatórios.",
  [MESSAGES_REQUIRED]: "As mensagens são obrigatórias.",
  [PLAN_IS_NO_ACTIVE]: "O plano não está ativo.",
  [USER_BANNED]: "Este usuário está banido.",
  [GETTING_LOCALES]:
    "Erro ao obter os arquivos locais. Tente novamente mais tarde ou fale com o suporte.",
  [GETTING_PROFILE]:
    "Erro ao obter os dados do perfil. Tente novamente mais tarde ou fale com o suporte.",
  [PRODUCTS_NOT_SENT]: "Os produtos não foram enviados.",
  [ACCOUNT_NOT_FOUND]: "Conta não encontrada.",
  [COLLECTING_INFORMATION_RETRY_AFTER]:
    "Erro ao coletar as informações. Tente novamente mais tarde ou fale com o suporte.",
  [ERROR_OCCURRED]: "Ocorreu um erro inesperado. Tente novamente mais tarde",
  [FREE_BOT_MESSAGES_LIMIT_REACHED]:
    "Você atingiu o limite de {{limit}} mensagens grátis de hoje com o agente. Ele é redefinido amanhã.",
  [TEXT_REGENERATION_LIMIT_REACHED]:
    "Esta campanha já usou as {{limit}} regenerações de texto grátis.",
  [ACTION_COULD_NOT_BE_COMPLETED]:
    "Não foi possível concluir esta ação por um erro do nosso provedor. Tente novamente mais tarde.",
  [PLATFORM_NOT_SENT]: "A plataforma não foi enviada.",
  [PLATFORM_APP_REQUEST_LIMIT_REACHED]:
    "Esta plataforma está com uma demanda muito alta e está limitando as solicitações temporariamente. Algumas funções podem ser afetadas.",
  [VERIFICATION_CODE_NOT_FOUND]: "O código de verificação não foi encontrado.",
  [VERIFICATION_CODE_INCORRECT]: "O código de verificação está incorreto.",
  [REGISTRATION_EMAIL_NOT_VERIFIED]: "O e-mail não está verificado.",
  [ORDER_NOT_FOUND]: "O pedido não foi encontrado.",
  [TYPE_OR_PATH_NOT_SENT]: "O arquivo ou o caminho não foram enviados.",
  [ID_OR_PATH_NOT_SENT]: "O ID do arquivo ou o caminho não foram enviados.",
  [IDS_NOT_SENT]: "Os IDs não foram enviados",
  [ANALYTIC_URL_NOT_SENT]: "A URL da análise não foi enviada.",
  [ANALYTIC_URL_INVALID]: "A URL da análise é inválida.",
  [EXTRACTING_ANALYTICS]:
    "Erro ao extrair a análise. Tente novamente mais tarde ou fale com o suporte.",
  [CREDENTIALS_INVALID]: "Credenciais inválidas.",
  [COLLABORATION_PRICE_NOT_BE_NEGATIVE]:
    "O preço da colaboração não pode ser negativo.",
  [CREDITS_NOT_BE_NEGATIVE]: "Os créditos não podem ser negativos.",
  [PACKAGES_PRICES_NOT_BE_NEGATIVE]:
    "O preço dos planos não pode ser negativo.",
  [ROL_REQUIRED]: "O papel é obrigatório.",
  [SHOP_ID_AND_STORE_ID_REQUIRED]: "ShopID e storeID são obrigatórios.",
  [PASSWORD_MUST_BE_6_CHARACTERS]: "A senha deve ter pelo menos 6 caracteres.",
  [ALL_USERS_NOT_DELETE]:
    "Você não pode excluir todos os usuários; deve deixar pelo menos um.",
  [SHOP_APPLICANT_NOT_FOUND]: "O aplicativo da marca não foi encontrado.",
  [USER_PASSWORD_NOT_FOUND]: "A senha do usuário não foi encontrada.",
  [PLAN_NOT_FOUND]: "O plano não foi encontrado.",
  [SUBSCRIPTION_NOT_CREATED]: "A assinatura não foi criada.",
  [ID_SUBSCRIPTION_NOT_FOUND]: "O ID da assinatura não foi encontrado.",
  [SUBSCRIPTION_REACTIVATE]: "Assinatura reativada.",
  [CUSTOMER_ID_NOT_FOUND]: "CustomerID não encontrado.",
  [APPLICANT_NOT_FOUND]: "Candidato não encontrado.",
  [SHOP_COUNTRY_NOT_FOUND]: "O país da marca não foi encontrado.",
  [FINAL_PRICE_NOT_FOUND]: "Não foi possível obter o preço final.",
  [PAYMENT_FAILED]: "Pagamento falhou",
  [CREDITS_MUST_BE_GREATER_THAN_ZERO]: "Os créditos devem ser maiores que 0.",
  [CSRF_INVALID]: "CSRF inválido",
  [INTEGRATION_INFORMATION_NOT_FOUND]:
    "As informações da integração não foram encontradas.",
  [MODAL_INTEGRATION_NOT_FOUND_TITLE]: "Reconectar as suas contas",
  [MODAL_INTEGRATION_NOT_FOUND_DESCRIPTION]:
    "Há um erro com a conta conectada atualmente. Reconecte a conta atual ou conecte uma nova no seletor que aparece no final da tabela e depois escolha a conta que cada campanha deve usar. A integração que você conectar deve ter acesso à conta de anúncios da campanha.",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_PLATFORM]: "Plataforma",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_CAMPAIGN]: "Campanha",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_AD_ACCOUNT]: "Conta de anúncios",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_REASON]: "Motivo",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_INTEGRATION]: "Integração",
  [MODAL_INTEGRATION_NOT_FOUND_ROW_DISABLED]:
    "Não é possível resolver a campanha associada.",
  [MODAL_INTEGRATION_NOT_FOUND_ROW_LOADING]: "Carregando...",
  [MODAL_INTEGRATION_NOT_FOUND_ROW_ERROR]:
    "Erro ao carregar os dados da campanha.",
  [MODAL_INTEGRATION_NOT_FOUND_SELECT_PLACEHOLDER]: "Selecione uma integração",
  [MODAL_INTEGRATION_NOT_FOUND_SAVE]: "Salvar",
  [GETTING_VIDEO]: "Erro ao obter o vídeo.",
  [UPLOAD_URL_NOT_FOUND]: "A URL de envio não foi encontrada.",
  [UPLOADING_VIDEO]: "Erro ao enviar o vídeo.",
  [STORE_NOT_FOUND]: "A loja não foi encontrada.",
  [NAME_REQUIRED]: "O nome é obrigatório.",
  [PRICE_REQUIRED]: "O preço é obrigatório.",
  [CURRENCY_REQUIRED]: "A moeda é obrigatória.",
  [RECURRING_REQUIRED]: "A recorrência é obrigatória.",
  [CREATING_PRODUCT]: "Erro ao criar o produto.",
  [CREATING_PRICE]: "Erro ao criar o preço.",
  [CREATING_PAYMENT_LINK]: "Erro ao criar o link de pagamento.",
  [GETTING_PAYMENT_LINK]: "Erro ao obter o link de pagamento.",
  [TOKEN_INVALID]: "Token inválido",
  [TOKEN_EXPIRED]: "O token expirou",
  [IG_ACCOUNT_NOT_FOUND]:
    "Não foi encontrada uma conta do Instagram vinculada a uma página do Facebook. Confirme que você selecionou uma conta do Instagram durante a integração ou vincule uma e tente novamente.",
  [IG_DATA_NOT_FOUND]: "Informações do Instagram não encontradas",
  [REVIEW_NOT_FOUND]: "Não foi encontrada a avaliação desta colaboração",
  [REVIEW_IS_NOT_ONE_START]:
    "A avaliação desta colaboração não é de 1 estrela, então não é possível emitir um crédito",
  [DISSATISFACTION_CREDIT_ALREADY_EXISTS]:
    "Já foi atribuído um crédito grátis para esta colaboração",
  [META_INTEGRATION_UNLINKED_PAGES_ERROR]:
    "É possível que a sua conta do Instagram não esteja vinculada à sua página do Facebook ou ao Meta Business. Vincule as suas contas para continuar.",
  [PAYMENT_METHOD_NOT_FOUND]:
    "Você não tem um método de pagamento adicionado. Adicione um para continuar.",
  [HAS_PENDING_PAYMENTS]:
    "Você tem faturas pendentes. Faça o pagamento para continuar.",
  [NO_IMAGES_FOUND_ON_PAGE]: "Não foram encontradas imagens na página",
  [NO_CREATE_DISCOUNT_SHOPIFY]:
    "Recebemos um erro do Shopify durante a integração. Confirme que você selecionou os escopos 'read_price_rules', 'write_price_rules', 'write_discounts' e 'read_discounts' durante os passos da integração.",
  [NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY]:
    "Recebemos um erro do Shopify durante a integração. Confirme que você selecionou o escopo 'read_orders' durante os passos da integração.",
  [NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY]:
    "Recebemos um erro do Shopify durante a integração. Confirme que você selecionou o escopo 'read_fulfillments' durante os passos da integração.",
  [NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY]:
    "Recebemos um erro do Shopify durante a integração. Confirme que você selecionou o escopo 'read_fulfillments' durante os passos da integração.",
  [GETTING_INFORMATION_FROM_SHOPIFY_URL]:
    "Erro ao obter a configuração do Shopify. Confirme que a URL está correta e que o acesso à loja é público.",
  [RATE_DAILY_LIMIT_AI]:
    "Você atingiu o limite diário de uso das funcionalidades de inteligência artificial. Tente novamente amanhã.",
  [RATE_DAILY_LIMIT_AI_CHAT]:
    "Você atingiu o limite de {{NAME_BUSINESS}} Help de hoje. Tente novamente amanhã.",
  [PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META]:
    "As permissões ou a configuração da sua conta mudaram. Tente novamente. Se o erro continuar, desconecte e conecte a conta de novo.",
  [ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS]:
    "A sua conta do Instagram não é do tipo Business ou você não selecionou todas as permissões. Mude a sua conta para Business e tente novamente. Se o erro continuar, desconecte e conecte a conta de novo.",
  [FACEBOOK_PAGE_ID_NOT_FOUND]:
    "Não foi encontrada uma página do Facebook vinculada. Confirme que você selecionou uma página durante a integração ou vincule uma e tente novamente.",
  [META_BUSINESS_ACCOUNT_NOT_FOUND]:
    "Não foi encontrada uma conta de negócio vinculada. Confirme que você selecionou uma conta de negócio durante a integração ou vincule uma e tente novamente.",
  [IG_BUSINESS_ACCOUNT_NOT_FOUND]: `Não foi encontrada uma conta do Instagram de Criador ou de Negócio vinculada à página do Facebook que você selecionou. Siga este passo a passo para vincular uma conta do Instagram.\n    <ol>\n     <li style="text-align: left">\n      Entre no <a style="color:inherit" href="https://business.facebook.com/latest/settings/pages/" target="_blank">Central de Negócios da Meta</a>\n     </li>\n     <li style="text-align: left">\n      Busque e selecione a página do Facebook que quer conectar\n     </li>\n     <li style="text-align: left">\n      Na nova interface, clique em "Conectar ativos"\n     </li>\n     <li style="text-align: left">\n      Na nova janela, clique em "Conectar conta do Instagram"\n     </li>\n     <li style="text-align: left">\n      Na nova janela, entre na sua conta do Instagram e finalize a conexão\n     </li>\n     <li style="text-align: left">\n      Quando a conexão terminar, tente conectar a sua conta de novo na nossa plataforma\n     </li>\n    </ol>\n    `,
  [ACCOUNT_TIKTOK_AUTH_NOT_MATCH]:
    "Não conseguimos verificar a sua conta. Tente novamente.",
  [ACCOUNT_TOKEN_META_NOT_FOUND]:
    "Não encontramos as informações da sua integração com a Meta. Tente novamente ou reconecte a sua conta.",
  [ACCOUNT_ID_BUSINESS_META_NOT_FOUND]:
    "Não encontramos uma conta Business da Meta vinculada à sua conta. Tente novamente ou vincule uma conta Business.",
  [OBJECTIVE_CAMPAIGN_META_INVALID]:
    "O objetivo da campanha selecionado não é válido.",
  [SPECIAL_CATEGORY_CAMPAIGN_META_INVALID]:
    "O tipo de categoria especial selecionado não é válido.",
  [CAMPAIGN_META_NOT_DELETED]:
    "Não foi possível excluir a campanha. Tente novamente.",
  [CAMPAIGN_META_NOT_CREATED]:
    "Não foi possível criar a campanha. Tente novamente.",
  [ADS_CAMPAIGN_NOT_FOUND]: "A campanha de anúncios não foi encontrada.",
  [NO_PIXELS_FOUND]:
    "Não foram encontrados pixels associados à sua conta da Meta. Crie um e tente novamente.",
  [NO_PIXELS_ACTIVE]:
    "Você não tem um pixel ativo associado à sua conta da Meta. Ative um e tente novamente.",
  [CAMPAIGN_META_NOT_FOUND]: "A campanha não foi encontrada na Meta.",
  [CAMPAIGN_META_NOT_UPDATED]:
    "Não foi possível atualizar a campanha. Tente novamente.",
  [CAMPAIGN_AD_SET_META_NOT_CREATED]:
    "Não foi possível criar o conjunto de anúncios. Tente novamente.",
  [CAMPAIGN_AD_SET_META_NOT_UPDATED]:
    "Não foi possível atualizar o conjunto de anúncios. Tente novamente.",
  [CAMPAIGN_INFORMATION_UPDATE_FAILED_RATE_LIMIT]:
    "Ocorreu um erro ao atualizar as informações. Tente novamente em alguns segundos.",
  [CAMPAIGN_MEDIA_META_NOT_CREATED]:
    "Não foi possível enviar o vídeo da campanha. Tente novamente.",
  [CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND]:
    "A miniatura do vídeo da campanha não foi encontrada.",
  [CAMPAIGN_CREATIVE_AD_META_NOT_CREATED]:
    "Não foi possível criar o modelo criativo do anúncio. Tente novamente.",
  [CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED]:
    "Não foi possível atualizar o modelo criativo do anúncio. Tente novamente.",
  [CAMPAIGN_CREATIVE_AD_META_NOT_FOUND]:
    "O modelo criativo do anúncio não foi encontrado.",
  [CAMPAIGN_MESSAGE_TEMPLATE_META_NOT_FOUND]:
    "Não foi possível recuperar o formulário do WhatsApp deste anúncio. Tente novamente mais tarde.",
  [CAMPAIGN_AD_META_NOT_CREATED]:
    "Não foi possível criar o anúncio. Tente novamente.",
  [CAMPAIGN_AD_META_NOT_UPDATED]:
    "Não foi possível atualizar o anúncio. Tente novamente.",
  [CAMPAIGN_METRICS_META_NOT_FOUND]:
    "As métricas da campanha não foram encontradas.",
  [CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE]:
    "Você não tem saldo suficiente para criar uma campanha. Recarregue a sua conta e tente novamente.",
  [ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE]:
    "Você não tem saldo suficiente para ativar a campanha. Recarregue a sua conta e tente novamente.",
  [CAMPAIGN_AUDIENCE_IS_TOO_NARROW]:
    "A sua audiência-alvo é muito pequena. Altere os critérios de segmentação para alcançar uma audiência maior.",
  [CAMPAIGN_BUDGET_IS_TOO_LOW]: "O seu orçamento diário é muito baixo.",
  [IDENTITY_NOT_FOUND]:
    "Não encontramos um perfil do TikTok vinculado à sua conta do TikTok Business. Vincule um perfil e tente novamente.",
  [VIDEO_ERROR_LOW_RESOLUTION]:
    "O vídeo tem uma resolução muito baixa. Envie um vídeo com uma resolução maior.",
  [VIDEO_ERROR_NO_BACKGROUND_AUDIO]:
    "O vídeo não tem áudio ou o áudio está muito baixo. Envie um vídeo com um áudio claro e audível.",
  [VIDEO_ERROR_ASPECT_RATIO]:
    "O vídeo não tem uma proporção permitida. Envie um vídeo com proporção 1:1 (quadrado), 9:16 (vertical) ou 16:9 (horizontal).",
  [VIDEO_ERROR_BLACK_EDGE]:
    "O vídeo tem faixas pretas ou bordas. Envie um vídeo sem bordas.",
  [VIDEO_ERROR_ILLEGAL_DURATION]:
    "O vídeo tem uma duração não permitida. Envie um vídeo com duração entre 5 e 60 segundos.",
  [ERROR_GETTING_URL_INFORMATION_BY_PROTECTED]:
    "Não conseguimos obter as informações do seu site. Algumas páginas usam mecanismos que bloqueiam o acesso automatizado (anti-crawlers), então você terá que digitar as informações manualmente.",
  [META_ERROR_GETTING_USER_INFORMATION]:
    "Erro ao obter as informações do usuário",
  [META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION]:
    "Erro ao obter as informações das contas de anúncios",
  [META_ERROR_GETTING_ACCOUNTS_INFORMATION]:
    "Erro ao obter as informações das contas",
  [META_AD_ACCOUNT_IS_NOT_ACTIVE]:
    "A conta de anúncios da Meta está desativada",
  [META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD]:
    "A conta de anúncios da Meta não tem um método de pagamento válido associado",
  [META_OAUTH_PERMISSIONS_ERROR]: `Você não tem acesso a algum dos recursos que tentou usar. Verifique o seguinte:<br/>\n    <ul style="text-align: left">\n      <li>Se você selecionou a conta de anúncios correta</li>\n      <li>Se a sua conta de anúncios está ativa, tem um método de pagamento válido e não tem pagamentos pendentes</li>\n      <li>Se você tem acesso correto a pixels, catálogos ou posts (se selecionou)</li>\n    </ul>`,
  [META_ACCOUNT_AUTHENTICATION_REQUIRED]: `A Meta exige que você verifique a sua conta antes de criar ou modificar anúncios. Conclua a verificação no Gerenciador de anúncios da Meta e tente publicar de novo em {{NAME_BUSINESS}}.<br/>\n    <ol style="text-align: left; padding-left: 1.25em; margin: 0.5em 0 0;">\n      <li style="text-align: left; margin-bottom: 0.35em;">Abra o <a style="color:inherit" href="https://adsmanager.facebook.com/adsmanager/manage/campaigns" target="_blank">Gerenciador de anúncios da Meta</a></li>\n      <li style="text-align: left; margin-bottom: 0.35em;">No seletor de contas (acima à esquerda), busque e selecione a conta de anúncios que você usa para esta campanha em {{NAME_BUSINESS}}</li>\n      <li style="text-align: left; margin-bottom: 0.35em;">Clique em <strong>Criar</strong> para iniciar uma campanha, escolha qualquer objetivo e preencha dados fictícios</li>\n      <li style="text-align: left; margin-bottom: 0.35em;">Quando a estrutura estiver criada, abra o anúncio no painel esquerdo</li>\n      <li style="text-align: left; margin-bottom: 0.35em;">Pode ser que você já veja um alerta em vermelho para se autenticar; se aparecer, siga-o. Se não, continue com o próximo passo</li>\n      <li style="text-align: left; margin-bottom: 0.35em;">Complete os dados da campanha e do anúncio até poder clicar em <strong>Publicar</strong> (abaixo à direita). Ao tentar publicar, a Meta deve pedir que você se autentique</li>\n      <li style="text-align: left; margin-bottom: 0;">Depois de se autenticar, tente publicar de novo em {{NAME_BUSINESS}}. Se ainda não conseguir ou não viu o alerta, fale com o suporte</li>\n    </ol>`,
  [ADVERTISER_ID_NOT_FOUND_TIK_TOK]: `Não foi encontrada uma conta de anúncios associada à conta que você quer conectar. Siga este passo a passo para criar uma e tente novamente.<br/>\n     <ol>\n      <li style="text-align: left">\n      Entre no <a style="color:inherit" href="https://business.tiktok.com/select" target="_blank">centro de negócios</a>\n      </li>\n      <li style="text-align: left">\n      Selecione uma conta de negócios\n      </li>\n      <li style="text-align: left">\n      No menu esquerdo, busque a opção "Contas de anunciantes" e clique\n      </li>\n      <li style="text-align: left">\n      Na parte superior você encontrará um botão "Adicionar conta de anunciante". Clique e siga os passos\n      </li>\n      <li style="text-align: left">\n      Quando terminar de criá-la, tente conectar a sua conta de novo na nossa plataforma\n      </li>\n    </ol>`,
  [ADVERTISER_ID_NOT_FOUND_GOOGLE]: `Não foi encontrada uma conta de anúncios associada à conta que você quer conectar. Siga este passo a passo para criar uma e tente novamente.<br/>\n     <ol>\n      <li style="text-align: left">\n      Entre no  <a style="color:inherit" href="https://ads.google.com/aw" target="_blank">Google Ads Manager</a>\n      </li>\n      <li style="text-align: left">\n      Confirme que a conta correta do Google está selecionada no canto superior direito. Se não estiver, clique em alterar conta no centro da tela.\n      </li>\n      <li style="text-align: left">\n      Com a conta correta selecionada, confirme que a sua conta tem acesso a uma conta de anúncios válida. Se não tiver, clique em "Nova conta do Google Ads" no centro da tela e siga os passos para criar uma.\n      </li>\n      <li style="text-align: left">\n      Quando terminar de criá-la, tente conectar a sua conta de novo na nossa plataforma\n      </li>\n    </ol>`,
  [CURRENCY_MISMATCH]:
    "Detectamos um erro na moeda da sua conta de anúncios, tente novamente mais tarde.",
  [ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK]: `A sua conta de negócio não tem uma moeda atribuída. Siga este passo a passo para atribuí-la e tente novamente. <br/>\n    <ol>\n      <li style="text-align: left">\n      Entre no <a style="color:inherit" href="https://business.tiktok.com/select" target="_blank">centro de negócios</a>\n      </li>\n      <li style="text-align: left">\n      Selecione uma conta de negócios\n      </li>\n      <li style="text-align: left">\n      No menu esquerdo, busque a opção "Configuração do negócio" e clique\n      </li>\n      <li style="text-align: left">\n      Na parte superior você encontrará a opção de configurar o seu negócio. Clique e siga os passos para configurar todo o negócio, inclusive a moeda\n      </li>\n      <li style="text-align: left">\n      Quando terminar de configurar o negócio, tente conectar a sua conta de novo na nossa plataforma\n      </li>\n    </ol>\n    `,
  [ERROR_GETTING_URL_META_DATA_AND_IMAGES]:
    "Não conseguimos obter informações do seu site. Confirme que a URL é válida, está acessível e contém imagens.",
  [ADVERTISER_ID_TO_CHANGE_NO_PERMISSION]:
    "Você não tem permissão para mudar para este anunciante.",
  [CANNOT_DELETE_MAIN_ADVERTISER]:
    "Não é possível excluir esta marca porque ela é a marca principal da agência. Selecione uma marca diferente.",
  [DISCOUNT_CODE_NOT_FOUND]: "Código de desconto não encontrado",
  [DISCOUNT_CODE_NOT_APPLICABLE_TO_THIS_PRODUCT]:
    "O código não se aplica a este produto",
  [SCRIPT_IS_TOO_SHORT]:
    "O roteiro é muito curto. Tente adicionar mais informações",
  [WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED]:
    "Não conseguimos analisar o seu site e a rede social. Verifique as URLs ou envie o conteúdo manualmente e tente novamente",
  [EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM]:
    "Encontramos uma inconsistência com o e-mail informado. Tente novamente",
  [OAUTH_IN_WINDOW_NO_COMPLETED]:
    "O processo de autenticação não foi concluído. Tente novamente",
  [OAUTH_CALLBACK_ACCOUNT_CONNECTED_TITLE]: "Conta conectada",
  [OAUTH_CALLBACK_ACCOUNT_CONNECTED_TEXT]:
    "A sua conta foi conectada corretamente.",
  [ERROR_PROCESSING_REQUEST]:
    "Ocorreu um erro ao processar esta solicitação. Tente novamente",
  [ERROR_PROCESSING_CAMPAIGNS]:
    "Ocorreu um erro ao processar as campanhas. Tente novamente.",
  [ERROR_ANALYZING_LINK_CREATIFY]:
    "Não foi possível analisar este link. Verifique a URL e tente novamente.",
  [GENERATE_AI_FREE_VIDEO_LIMIT]:
    "Você atingiu o limite gratuito de geração de vídeos com IA.",
  [NOT_HAVE_ENOUGH_USAGE_VALUE]:
    "Você não tem créditos suficientes para esta ação.",
  [USAGE_VALUE_NOT_FOUND]: "As informações de uso não foram encontradas.",
  [FAL_AI_CREDENTIALS_INVALID]:
    "Sua chave de API do Fal AI é inválida ou a conta não tem saldo.",
  [HEYGEN_CREDENTIALS_INVALID]:
    "Sua chave de API do HeyGen é inválida ou a conta não tem saldo.",
  [ERROR_NETWORK_CONNECTION]:
    "Ocorreu um erro de conexão com a internet. Tente novamente",
  [ERROR_ON_AD_ID_OF_AD_GROUP_ID]:
    "No anúncio nº {{adID}} do grupo de anúncios nº {{adGroupID}}",
  [ERROR_ON_AD_GROUP_ID]: "No grupo de anúncios nº {{adGroupID}}",
  [ERROR_ON_ASSETS_GROUP_ID]: "No grupo de recursos nº {{assetsGroupID}}",
  [REQUEST_TIME_OUT]:
    "Ocorreu um erro inesperado. Tente novamente em alguns segundos",
  [TIME_OUT_FOR_PROVIDER]:
    "Ocorreu um erro com o nosso provedor de vídeo. Tente novamente mais tarde.",
  [FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER]: `A sua página do Facebook precisa ter um número de WhatsApp conectado para continuar. Siga este passo a passo para conectá-lo e tente novamente.<br/>\n    <ol>\n      <li style="text-align: left">\n        Entre na <a style="color:inherit" href="https://www.facebook.com/settings/?tab=linked_whatsapp" target="_blank">configuração da sua página do Facebook</a>\n      </li>\n      <li style="text-align: left">\n        Digite o número de WhatsApp que deseja conectar\n      </li>\n      <li style="text-align: left">\n        Clique em Enviar código de WhatsApp\n      </li>\n      <li style="text-align: left">\n        Digite o código que você recebeu no WhatsApp\n      </li>\n      <li style="text-align: left">\n        Clique em Confirmar\n      </li>\n      <li style="text-align: left">\n        Quando terminar de conectar o número de WhatsApp, tente novamente. Se o erro continuar, pode ser necessário reconectar a sua conta da Meta na nossa plataforma\n      </li>\n    </ol>`,
  [YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP]: `A sua página do Facebook não está no portfólio de negócios ao qual pertence o número de WhatsApp Business que você tenta usar. Siga este passo a passo para conectá-la e tente novamente.<br/>\n  <ol>\n    <li style="text-align: left">\n      Entre no <a style="color:inherit" href="https://business.facebook.com/latest/settings/pages/?business_id={{businessID}}" target="_blank">Portfólio de negócios, na seção de páginas</a>\n    </li>\n    <li style="text-align: left">\n      Clique no botão Adicionar, no canto superior direito\n    </li>\n    <li style="text-align: left">\n      Selecione a opção Adicionar uma página do Facebook existente\n    </li>\n    <li style="text-align: left">\n      Digite o nome ou o link da sua página do Facebook. Usar o link torna a busca mais precisa. Selecione a sua página do Facebook quando ela aparecer na lista\n    </li>\n    <li style="text-align: left">\n      Clique no botão Próximo até chegar ao último passo. Marque a caixa para aceitar os termos da Meta e depois clique em Reivindicar página e Instagram\n    </li>\n    <li style="text-align: left">\n      Quando terminar de conectar a página do Facebook ao portfólio de negócios, tente novamente. Se o erro continuar, pode ser necessário reconectar a sua conta da Meta na nossa plataforma\n    </li>\n  </ol>\n  `,
  [ERROR_WITH_MOBILE_PROVIDER]:
    "Ocorreu um erro com o seu provedor de telefonia. Tente novamente mais tarde",
  [ERROR_CREATING_INSTANT_EXPERIENCE]:
    "Ocorreu um erro ao criar a experiência instantânea. Tente novamente",
  [CAMPAIGN_REQUEST_ABORTED]:
    "A solicitação da campanha foi interrompida por atingir o limite de tempo de espera. Fale com o suporte.",
  [APP_URL_NOT_FOUND]:
    "O app selecionado não tem um link válido na loja de aplicativos selecionada",
  [ERROR_CAMPAIGN_NOT_FOUND_TO_DUPLICATE]:
    "Não foi possível recuperar as informações para duplicar a campanha. Tente novamente",
  [INVALID_APP_DEEP_LINK]:
    "O link digitado não é um deep link válido associado a um aplicativo.",
  [GENERATION_VIDEO_REJECTED]:
    "As suas instruções de conteúdo violam as políticas de segurança de conteúdo. Tente novamente modificando as instruções.",
  [VIDEO_INPUT_REAL_PERSON_REJECTED]:
    "A imagem de entrada inclui uma pessoa real e o provedor de vídeo não pode processá-la. Use uma imagem do produto ou da marca sem pessoas reais e tente novamente.",
  [IMAGE_LAYERS_CONTENT_POLICY_VIOLATION]:
    "Não foi possível separar o seu conteúdo em camadas porque ele pode estar violando as políticas de conteúdo.",
  [AI_PROVIDER_CREDENTIALS_INVALID]:
    "A API key de {{provider}} não é válida ou a conta não tem saldo. Revise a API key em Configuração e tente novamente.",
  [AI_PROVIDER_CREDENTIALS_INVALID_GENERIC]:
    "Uma API key dos seus provedores não é válida ou a conta não tem saldo. Revise a API key em Configuração e tente novamente.",
  [AI_REQUEST_TIMEOUT]:
    "Ocorreu um erro com o nosso provedor de IA. Tente novamente mais tarde.",
  [IMAGES_MODERATION_BLOCKED]: "Imagens bloqueadas pela moderação",
  [MALFORMED_FUNCTION_CALL]:
    "Não foi possível realizar esta ação. Tente com uma instrução diferente.",
  [VIDEO_GENERATION_FAILED_BY_PROVIDER]:
    "O vídeo não foi gerado por um erro interno. Tente novamente mais tarde.",
  [AI_RATE_LIMITED]:
    "O nosso provedor de IA está recebendo solicitações demais. Tente novamente mais tarde.",
  [AI_PROVIDER_UNAVAILABLE]:
    "O nosso provedor de IA não está disponível neste momento. Tente novamente mais tarde.",
  [AI_GENERATION_FAILED]:
    "Não foi possível concluir a geração com o nosso provedor de IA. Tente novamente mais tarde.",
  [AGENT_REQUEST_COULD_NOT_BE_PROCESSED]:
    'Não consegui processar sua solicitação. Por favor, tente novamente. Se o erro persistir, fale com a equipe de suporte pelo botão "Obtenha Ajuda".',
  [CREDITS_RETURNED_SUFFIX]:
    "Por causa deste erro, os seus créditos foram devolvidos.",
  [CREATIVE_UNEXPECTED_IMAGE_PROVIDER_ERROR]:
    "Ocorreu um erro inesperado com o nosso provedor de imagem. Tente novamente mais tarde.",
  [CREATIVE_UNEXPECTED_VIDEO_PROVIDER_ERROR]:
    "Ocorreu um erro inesperado com o nosso provedor de vídeo. Tente novamente mais tarde.",
  [CREATIVE_UNEXPECTED_AI_PROVIDER_ERROR]:
    "Ocorreu um erro inesperado com o nosso provedor de IA. Tente novamente mais tarde.",
  [CREATIVE_TIMEOUT_IMAGE_PROVIDER_ERROR]:
    "Ocorreu um erro com o nosso provedor de imagem. Tente novamente mais tarde.",
  [CREATIVE_TIMEOUT_VIDEO_PROVIDER_ERROR]:
    "Ocorreu um erro com o nosso provedor de vídeo. Tente novamente mais tarde.",
  [CREATIVE_TIMEOUT_AI_PROVIDER_ERROR]:
    "Ocorreu um erro com o nosso provedor de IA. Tente novamente mais tarde.",
  [INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW]:
    "Não é possível atualizar o estado do criativo enquanto ele estiver em revisão. Tente novamente mais tarde",
  [BENEFICIARY_OR_PAYER_NOT_FOUND]:
    "O beneficiário ou o pagador não foi encontrado. Confirme que você tem permissão para ler as informações do negócio.",
  [DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN]:
    "Esta operação não é permitida para esta campanha",
  [LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED]:
    "Esta conta já resgatou os créditos grátis.",
  [CAMPAIGN_IS_GENERATING]:
    "Esta campanha já está sendo gerada em outra janela ou dispositivo.",
  [INVALID_JOB_TYPE]:
    "O tipo de tarefa não é válido ou não é compatível. Tente novamente ou fale com o suporte.",
  [JOB_CANCELLED_OR_FAILED]:
    "Não foi possível concluir a operação porque a tarefa foi cancelada ou falhou. Tente novamente.",
  [JOB_TIMEOUT]:
    "A operação demorou demais para ser concluída. Tente novamente.",
  [CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD]:
    "Não foram encontradas campanhas ativas nesse período para gerar um relatório.",

  //ERROR COMPONENT
  [ERROR_COMPONENT_TITLE]: "Ops! Parece que ocorreu um erro",
  [ERROR_COMPONENT_DESCRIPTION]:
    "Isso pode ter sido causado por um erro técnico. Tente novamente recarregando a página. Se o erro continuar, fale com o suporte.",
  [ERROR_COMPONENT_BUTTON_RELOAD_PAGE]: "Recarregar página",
  [ERROR_COMPONENT_CURRENT_ROUTE]: "Rota atual {{value}}",

  //CATEGORIES
  [RESTAURANTS]: "Restaurantes",
  [FOODS]: "Alimentos",
  [TRAVEL]: "Viagens e turismo",
  [ENTERTAINMENT]: "Entretenimento",
  [TECHNOLOGY]: "Tecnologia",
  [FITNESS]: "Fitness",
  [FASHION]: "Moda",
  [BEAUTY]: "Saúde e beleza",
  [PETS]: "Pets",
  [HOME]: "Decoração",

  //SUBCATEGORIES
  [RESTAURANTS_SUBCATEGORY_FOOD]: "Comida",
  [RESTAURANTS_SUBCATEGORY_DRINKS]: "Bebidas",
  [RESTAURANTS_SUBCATEGORY_DESSERTS]: "Sobremesas",
  [RESTAURANTS_SUBCATEGORY_COFFEE]: "Café",
  [RESTAURANTS_SUBCATEGORY_HOT_DRINKS]: "Bebidas quentes",
  [RESTAURANTS_SUBCATEGORY_COLD_DRINKS]: "Bebidas frias",
  [RESTAURANTS_SUBCATEGORY_SOFT_DRINKS]: "Refrigerantes",
  [RESTAURANTS_SUBCATEGORY_FROZEN_DRINKS]: "Bebidas congeladas",
  [RESTAURANTS_SUBCATEGORY_SUSHI]: "Sushi",
  [RESTAURANTS_SUBCATEGORY_ASIAN]: "Asiática",
  [RESTAURANTS_SUBCATEGORY_JAPANESE]: "Japonesa",
  [RESTAURANTS_SUBCATEGORY_CHINESE]: "Chinesa",
  [RESTAURANTS_SUBCATEGORY_ITALIAN]: "Italiana",
  [RESTAURANTS_SUBCATEGORY_MEXICAN]: "Mexicana",
  [RESTAURANTS_SUBCATEGORY_HEALTHY]: "Saudável",
  [RESTAURANTS_SUBCATEGORY_VEGAN]: "Vegana",
  [RESTAURANTS_SUBCATEGORY_VEGETARIAN]: "Vegetariana",
  [FOODS_SUBCATEGORY_SEASONINGS]: "Temperos",
  [FOODS_SUBCATEGORY_FOOD]: "Alimentos",
  [FOODS_SUBCATEGORY_GRANOLA]: "Granolas",
  [FOODS_SUBCATEGORY_DRIED_FRUITS]: "Frutas secas",
  [FOODS_SUBCATEGORY_HEALTHY]: "Saudável",
  [TRAVEL_SUBCATEGORY_BEACH_SUN_TOURISM]: "Turismo de sol e praia",
  [TRAVEL_SUBCATEGORY_RURAL_TOURISM]: "Turismo rural",
  [TRAVEL_SUBCATEGORY_GASTRONOMIC_TOURISM]: "Turismo gastronômico",
  [TRAVEL_SUBCATEGORY_NATURE_TOURISM]: "Turismo de natureza",
  [TRAVEL_SUBCATEGORY_CULTURAL_TOURISM]: "Turismo cultural",
  [TRAVEL_SUBCATEGORY_HEALTH_TOURISM]: "Turismo de saúde",
  [ENTERTAINMENT_SUBCATEGORY_ENTERTAINMENT]: "Entretenimento",
  [TECHNOLOGY_SUBCATEGORY_PHONES]: "Telefones",
  [TECHNOLOGY_SUBCATEGORY_COMPUTERS]: "Computadores",
  [TECHNOLOGY_SUBCATEGORY_VIDEO_GAME_CONSOLES]: "Consoles de videogame",
  [TECHNOLOGY_SUBCATEGORY_ACCESSORIES]: "Acessórios",
  [TECHNOLOGY_SUBCATEGORY_PERIPHERALS]: "Periféricos",
  [TECHNOLOGY_SUBCATEGORY_ELECTRONICS]: "Eletrônicos",
  [FITNESS_SUBCATEGORY_SPORTSWEAR]: "Roupa esportiva",
  [FITNESS_SUBCATEGORY_SPORTS_ACCESSORIES]: "Acessórios esportivos",
  [FITNESS_SUBCATEGORY_DIETARY_SUPPLEMENTS]: "Suplementos alimentares",
  [FITNESS_SUBCATEGORY_TRAINING_EQUIPMENT]: "Equipamentos de treino",
  [FASHION_SUBCATEGORY_HAUTE_COUTURE]: "Moda de alta-costura",
  [FASHION_SUBCATEGORY_HIPSTER]: "Moda hipster",
  [FASHION_SUBCATEGORY_CASUAL]: "Moda casual",
  [FASHION_SUBCATEGORY_CLASSIC]: "Moda clássica",
  [FASHION_SUBCATEGORY_ROMANTIC]: "Moda romântica",
  [FASHION_SUBCATEGORY_SPORTSWEAR]: "Moda esportiva",
  [FASHION_SUBCATEGORY_PREPPY]: "Moda preppy",
  [FASHION_SUBCATEGORY_GRUNGE]: "Moda grunge",
  [FASHION_SUBCATEGORY_VINTAGE]: "Moda vintage",
  [BEAUTY_SUBCATEGORY_COSMETICS]: "Cosméticos",
  [BEAUTY_SUBCATEGORY_EYE_CARE]: "Cuidado dos olhos",
  [BEAUTY_SUBCATEGORY_FEMININE_HYGIENE]: "Higiene feminina",
  [BEAUTY_SUBCATEGORY_FIRST_AID]: "Primeiros socorros",
  [BEAUTY_SUBCATEGORY_HAIR_CARE]: "Cuidado do cabelo",
  [BEAUTY_SUBCATEGORY_MEDICAL_DEVICES]: "Dispositivos e aparelhos médicos",
  [BEAUTY_SUBCATEGORY_MOBILITY_EQUIPMENT]: "Equipamento de mobilidade",
  [BEAUTY_SUBCATEGORY_NUTRITIONAL_SUPPLEMENTS]: "Suplementos nutricionais",
  [BEAUTY_SUBCATEGORY_MEDICATIONS]: "Medicamentos",
  [BEAUTY_SUBCATEGORY_PERSONAL_HYGIENE]: "Higiene pessoal",
  [BEAUTY_SUBCATEGORY_SCALES]: "Balanças",
  [BEAUTY_SUBCATEGORY_SKIN_CARE]: "Cuidado da pele",
  [BEAUTY_SUBCATEGORY_VITAMINS]: "Vitaminas",
  [BEAUTY_SUBCATEGORY_FACIAL_TISSUES]: "Lenços faciais",
  [PETS_SUBCATEGORY_FOOD]: "Comida",
  [PETS_SUBCATEGORY_COSMETICS]: "Cosméticos",
  [PETS_SUBCATEGORY_ACCESSORIES]: "Acessórios",
  [PETS_SUBCATEGORY_CLOTHING]: "Roupas",
  [PETS_SUBCATEGORY_MEDICATIONS]: "Medicamentos",
  [HOME_SUBCATEGORY_TEXTILES_CARPETS]: "Têxteis e tapetes",
  [HOME_SUBCATEGORY_ART_PRINTS]: "Arte e gravuras",
  [HOME_SUBCATEGORY_STORAGE_ORGANIZATION]: "Armazenamento e organização",
  [HOME_SUBCATEGORY_PLANT_DECOR]: "Decorações com plantas",
  [HOME_SUBCATEGORY_CURTAINS_BLINDS]: "Cortinas e persianas",

  //OPTIONS
  [BODY_BUILD_THIN]: "Magro",
  [BODY_BUILD_AVERAGE]: "Médio",
  [BODY_BUILD_WIDE]: "Largo",
  [BODY_BUILD_MUSCULAR]: "Musculoso",
  [BODY_BUILD_CURVY]: "Curvilíneo",
  [BODY_BUILD_ATHLETIC]: "Atlético",

  [CLOTHING_STYLE_CASUAL]: "Casual",
  [CLOTHING_STYLE_FORMAL]: "Formal",
  [CLOTHING_STYLE_SPORTY]: "Esportivo",
  [CLOTHING_STYLE_BUSINESS]: "Negócios",
  [CLOTHING_STYLE_ELEGANT]: "Elegante",
  [CLOTHING_STYLE_TRENDY]: "Da moda",
  [CLOTHING_STYLE_STREETWEAR]: "Urbano",
  [CLOTHING_STYLE_TRADITIONAL]: "Tradicional",
  [CLOTHING_STYLE_VINTAGE]: "Vintage",
  [CLOTHING_STYLE_BOHEMIAN]: "Boêmio",
  [CLOTHING_STYLE_HIPSTER]: "Hipster",
  [CLOTHING_STYLE_PUNK]: "Punk",
  [CLOTHING_STYLE_GOTHIC]: "Gótico",

  [DISTINGUISHING_FEATURES_TATTOOS]: "Tatuagens",
  [DISTINGUISHING_FEATURES_SCARS]: "Cicatrizes",
  [DISTINGUISHING_FEATURES_BIRTHMARKS]: "Marcas de nascença",
  [DISTINGUISHING_FEATURES_FRECKLES]: "Sardas",
  [DISTINGUISHING_FEATURES_MOLES]: "Sinais",
  [DISTINGUISHING_FEATURES_PIERCINGS]: "Piercings",
  [DISTINGUISHING_FEATURES_DIMPLES]: "Covinhas",
  [DISTINGUISHING_FEATURES_WRINKLES]: "Rugas",
  [DISTINGUISHING_FEATURES_GLASSES]: "Óculos",
  [DISTINGUISHING_FEATURES_BRACES]: "Aparelho",
  [DISTINGUISHING_FEATURES_MAKEUP]: "Maquiagem",
  [DISTINGUISHING_FEATURES_HAIR_ACCESSORIES]: "Acessórios para o cabelo",
  [DISTINGUISHING_FEATURES_BEARD]: "Barba",
  [DISTINGUISHING_FEATURES_MUSTACHE]: "Bigode",

  [CONTENT_STYLE_ELEGANT]: "Elegante",
  [CONTENT_STYLE_AESTHETIC]: "Estético",
  [CONTENT_STYLE_RAW]: "Cru",
  [CONTENT_STYLE_MINIMALISTIC]: "Minimalista",
  [CONTENT_STYLE_ARTISTIC]: "Artístico",
  [CONTENT_STYLE_VINTAGE]: "Vintage",
  [CONTENT_STYLE_MODERN]: "Moderno",
  [CONTENT_STYLE_PLAYFUL]: "Divertido",
  [CONTENT_STYLE_RUSTIC]: "Rústico",
  [CONTENT_STYLE_MONOCHROMATIC]: "Monocromático",

  [EMPLOYEES_2_10]: "2-10 funcionários",
  [EMPLOYEES_10_20]: "10-20 funcionários",
  [EMPLOYEES_20_50]: "20-50 funcionários",
  [EMPLOYEES_50_100]: "50-100 funcionários",
  [EMPLOYEES_100_THAN]: "Mais de 100 funcionários",

  [PRODUCT_AVAILABILITY_LOCAL]: "Local (Cidade)",
  [PRODUCT_AVAILABILITY_NATIONAL]: "Nacional",
  [PRODUCT_AVAILABILITY_INTERNATIONAL]: "Internacional",

  [META]: "Meta",
  [META_FACEBOOK_AND_INSTAGRAM]: "Meta (Facebook e Instagram)",
  [INSTAGRAM]: "Instagram",
  [FACEBOOK]: "Facebook",
  [TIKTOK]: "TikTok",
  [LINKEDIN]: "LinkedIn",
  [GOOGLE]: "Google",
  [YOUTUBE]: "YouTube",
  [X]: "X",
  [THREADS]: "Threads",
  [WHATSAPP]: "WhatsApp",
  [ORGANIC]: "Orgânico",

  [DARK_KITCHEN]: "Cozinhas ocultas",
  [OTHERS]: "Outros",

  [ADS_CAMPAIGN_APP_PROMOTION_ANDROID]: "Android",
  [ADS_CAMPAIGN_APP_PROMOTION_IOS]: "Apple iOS 14+",
  [APP_STORE_ANDROID]: "Android",
  [APP_STORE_IOS]: "iOS",
  [APP_STORE_PLACEHOLDER]: "Selecione a loja de aplicativos",
  [ADS_CAMPAIGN_APP_PROMOTION_BOTH]: "Android e Apple iOS 14-",

  [ADS_CAMPAIGN_OBJECTIVE_AWARENESS]: "Reconhecimento",
  [ADS_CAMPAIGN_OBJECTIVE_TRAFFIC]: "Tráfego",
  [ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT]: "Engajamento",
  [ADS_CAMPAIGN_OBJECTIVE_LEADS]: "Clientes potenciais",
  [ADS_CAMPAIGN_OBJECTIVE_LEADS_LINKEDIN]: "Formulário Instantâneo",
  [ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION]: "Promoção de aplicativo",
  [ADS_CAMPAIGN_OBJECTIVE_SALES]: "Vendas",
  [ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS]: "Visualizações de vídeo",
  [ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS]: "Conversões do site",
  [ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL]: "Instalação de aplicativo",
  [ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_RETARGETING]: "Retargeting de usuários",
  [ADS_CAMPAIGN_TYPE_SEARCH]: "Pesquisa",
  [ADS_CAMPAIGN_TYPE_APP]: "Instalação de aplicativo",
  [ADS_CAMPAIGN_TYPE_SHOPPING]: "Compras",
  [ADS_CAMPAIGN_TYPE_VIDEO]: "Vídeo",
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY]: "Orçamento diário",
  [ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME]: "Orçamento total",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU]: "Ver cardápio",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW]: "Comprar agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP]: "Cadastrar-se",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE]: "Inscrever-se",
  [ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE]: "Ver mais",
  [ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW]: "Aplicar agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_APPLY]: "Aplicar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_QUOTE]: "Ver cotação",
  [ADS_CAMPAIGN_CALL_TO_ACTION_JOIN]: "Participar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_ATTEND]: "Comparecer",
  [ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_DEMO]: "Solicitar demonstração",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MORE]: "Ver mais",
  [ADS_CAMPAIGN_CALL_TO_ACTION_REGISTER]: "Cadastrar-se",
  [ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW]: "Reservar agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_CALL_NOW]: "Ligar agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US]: "Fale conosco",
  [ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD]: "Baixar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_UNLOCK_FULL_DOCUMENT]:
    "Desbloquear documento completo",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_DIRECTIONS]: "Como chegar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE]: "Pedir cotação",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES]: "Ver horários",
  [ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE]: "Mais informações",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE]:
    "Enviar mensagem de WhatsApp",
  [ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW]: "Ouvir agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE]: "Enviar mensagem",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM]:
    "Enviar mensagem no Instagram",
  [ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW]: "Pedir agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_TIME]: "Solicitar horário",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SAVE]: "Salvar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER]: "Ver oferta",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_PROMOTIONS]: "Ver promoções",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_ACCESS]: "Obter acesso",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_UPDATES]: "Receber atualizações",
  [ADS_CAMPAIGN_CALL_TO_ACTION_INQUIRE_NOW]: "Consultar agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_BUY_TICKETS]: "Comprar ingressos",
  [ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME]: "Jogar",
  [ADS_CAMPAIGN_CALL_TO_ACTION_EXPLORE_MORE]: "Explore mais",
  [ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW]: "Instalar agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_USE_APP]: "Usar aplicativo",
  [ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW]: "Assistir agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE]: "Ler mais",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW]: "Ver agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED]: "Tenho interesse",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW]: "Comprar ingressos agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW]: "Tenho interesse",
  [ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW]: "Pré-encomendar agora",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE]: "Visitar loja",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_PROFILE]: "Ver perfil",
  [ADS_CAMPAIGN_CALL_TO_ACTION_DYNAMIC]: "Dinâmico",
  [ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE]: "Site",
  [ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST]: "Lista de clientes",
  [ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO]:
    "Adicionar informações de pagamento",
  [ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART]: "Adicionar ao carrinho",
  [ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST]: "Adicionar à lista de desejos",
  [ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION]: "Concluir cadastro",
  [ADS_CAMPAIGN_CUSTOM_EVENT_DONATE]: "Doar",
  [ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT]: "Iniciar checkout",
  [ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE]: "Comprar",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH]: "Pesquisar",
  [ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL]: "Iniciar teste",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE]: "Inscrever-se",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT]: "Entrar em contato",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CUSTOMIZE_PRODUCT]: "Personalizar produto",
  [ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION]: "Encontrar localização",
  [ADS_CAMPAIGN_CUSTOM_EVENT_LEAD]: "Gerar cliente potencial",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE]: "Agendar",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION]: "Enviar candidatura",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW]: "Ver conteúdo",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_FORM]: "Enviar formulário",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON]: "Clicar no botão",
  [ADS_CAMPAIGN_CUSTOM_EVENT_PLACE_ORDER]: "Fazer pedido",
  [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD]: "Facebook Feed",
  [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY]: "Facebook Story",
  [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE]: "Facebook Reels",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY]: "Instagram Story",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL]: "Instagram Reel",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED]: "Instagram Feed",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD]: "Instagram Post",
  [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO]: "TikTok Post",
  [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS]: "TikTok Post",
  [ADS_CAMPAIGN_AD_FORMAT_GOOGLE_SEARCH]: "Pesquisa do Google",
  [ADS_META_DESTINATION_TYPE_NONE]: "Nenhum",
  [ADS_META_DESTINATION_TYPE_WEBSITE]: "Site",
  [ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP]: "Site e aplicativo",
  [ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE]: "Site e loja física",
  [ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE]:
    "Site, aplicativo e loja física",
  [ADS_META_DESTINATION_TYPE_CATALOG]: "Catálogo",
  [ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE]: "Perfil do Instagram",
  [ADS_META_DESTINATION_TYPE_ON_VIDEO]: "No vídeo",
  [ADS_META_DESTINATION_TYPE_ON_POST]: "Na publicação",
  [ADS_META_DESTINATION_TYPE_WHATSAPP]: "WhatsApp",
  [ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM]: "Mensagens no Instagram",
  [ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER]: "Mensagens no Messenger",
  [ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER]:
    "Mensagens no Instagram e no Messenger",
  [ADS_META_DESTINATION_TYPE_INSTANT_FORM]: "Formulário Instantâneo",
  [ADS_META_DESTINATION_TYPE_GOOGLE_PLAY]: "Google Play",
  [ADS_META_DESTINATION_TYPE_APP_STORE]: "App Store",
  [ADS_META_DESTINATION_TYPE_APP]: "Aplicativo",
  [ADS_CAMPAIGN_BUYING_TYPE_RESERVED]: "Reserva",
  [ADS_CAMPAIGN_BUYING_TYPE_AUCTION]: "Leilão",

  [ADS_TIKTOK_APP_EVENT_ACTIVE_OPTION]: "Ativação",
  [ADS_TIKTOK_APP_EVENT_DOWNLOAD_START_OPTION]: "Início do download",
  [ADS_TIKTOK_APP_EVENT_ACTIVE_REGISTER_OPTION]: "Cadastro",
  [ADS_TIKTOK_APP_EVENT_ACTIVE_PAY_OPTION]: "Compra",
  [ADS_TIKTOK_APP_EVENT_IN_APP_ORDER_OPTION]: "Pedido no aplicativo",
  [ADS_TIKTOK_APP_EVENT_IN_APP_CART_OPTION]: "Carrinho no aplicativo",
  [ADS_TIKTOK_APP_EVENT_IN_APP_DETAIL_UV_OPTION]: "Detalhe no aplicativo",
  [ADS_TIKTOK_APP_EVENT_NEXT_DAY_OPEN_OPTION]: "Abertura no dia seguinte",
  [ADS_TIKTOK_APP_EVENT_LOGIN_OPTION]: "Entrar",
  [ADS_TIKTOK_APP_EVENT_LAUNCH_APP_OPTION]: "Abrir aplicativo",
  [ADS_TIKTOK_APP_EVENT_COMPLETE_TUTORIAL_OPTION]: "Concluir tutorial",
  [ADS_TIKTOK_APP_EVENT_SEARCH_OPTION]: "Pesquisa",
  [ADS_TIKTOK_APP_EVENT_START_TRIAL_OPTION]: "Iniciar teste",
  [ADS_TIKTOK_APP_EVENT_SUBSCRIBE_OPTION]: "Inscrever-se",

  [ADS_CAMPAIGN_REPORT_BREAKDOWN_WEEKLY]: "Semanal",
  [ADS_CAMPAIGN_REPORT_BREAKDOWN_MONTHLY]: "Mensalmente",

  [KEYWORD_BROAD_MATCH_TYPE_OPTION]: "Correspondência ampla",
  [KEYWORD_PHRASE_MATCH_TYPE_OPTION]: "Correspondência de frase",
  [KEYWORD_EXACT_MATCH_TYPE_OPTION]: "Correspondência exata",
  [KEYWORD_TYPE_NORMAL]: "Palavra-chave",
  [KEYWORD_TYPE_NEGATIVE]: "Palavra-chave negativa",

  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK]:
    "Abrir o link profundo no aplicativo ou direcionar ao navegador",
  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK]:
    "Abrir o link profundo no aplicativo ou direcionar à loja de aplicativos",
  [ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY]:
    "Abrir o link profundo no navegador do celular",
  [ADS_CAMPAIGN_META_FALLBACK_CATALOG]:
    "Usar a configuração de destino do link a partir do catálogo",
  [ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_LABEL]: "Destino na web",
  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_LABEL]:
    "Destino no app com alternativa no site",
  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_LABEL]:
    "Destino no app com alternativa na App Store",
  [DESTINATION_FALLBACK_CONFIGURATION_TITLE]:
    "Configuração de destino alternativo",

  [ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_QUESTION]: "Criativo dinâmico",
  [ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION]:
    "A Meta criará automaticamente combinações dos seus conteúdos e textos às quais a sua audiência provavelmente vai responder.",
  [ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_ABOUT_LINK]:
    "Sobre o criativo dinâmico",

  [ADS_CAMPAIGN_META_AD_SETUP]: "Configuração de Anúncio",
  [ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD]: "Criar Anúncio",
  [ADS_CAMPAIGN_META_AD_SETUP_USE_POST]: "Usar Publicação",
  [ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD]: "Usar Anúncio Existente",
  [ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT]:
    "Você só poderá escolher anúncios com configurações compatíveis e não poderá modificar nenhum campo do anúncio original.",
  [MODAL_META_REUSE_CREATIVES_TITLE]: "Anúncios existentes",
  [MODAL_META_REUSE_CREATIVES_DESCRIPTION]:
    "Selecione um anúncio criado antes para conservar o engajamento gerado",
  [MODAL_META_REUSE_CREATIVES_EMPTY]: "Ainda não há criativos reutilizáveis.",
  [MODAL_META_REUSE_CREATIVES_VALID]: "Compatível",
  [MODAL_META_REUSE_CREATIVES_INVALID]: "Não compatível",
  [MODAL_META_REUSE_CREATIVES_FILTER_ACTIVE]: "Filtrar pelo conteúdo atual",
  [MODAL_META_REUSE_CREATIVES_CLEAR_FILTER]: "Mostrar todos os criativos",
  [MODAL_META_REUSE_CREATIVES_OPTIMIZATION_WARN]:
    "Objetivo de otimização diferente",
  [MODAL_META_REUSE_CREATIVES_COLUMN_COMPATIBILITY]: "Compatibilidade",
  [MODAL_META_REUSE_CREATIVES_COLUMN_TEXTS]: "Textos",
  [MODAL_META_REUSE_CREATIVES_COLUMN_ENGAGEMENT]: "Engajamento",

  [ADS_CAMPAIGN_META_PARTNERSHIP_AD_SECTION]: "Parceria",
  [ADS_CAMPAIGN_META_PARTNERSHIP_AD_TOGGLE]: "Ativar anúncio de colaboração",
  [ADS_CAMPAIGN_META_PARTNERSHIP_IDENTITY_ORDER]: "Pedido de identidades",
  [ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_FIRST]: "Primeiro {{name}}",
  [ADS_CAMPAIGN_META_PARTNERSHIP_PARTNER_NAME_FALLBACK]: "parceiro",
  [ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_CAMPAIGN_FIRST]:
    "Primeiro a minha marca (página/Instagram da campanha)",
  [ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_PARTNER_FIRST_LABEL]:
    "Primeiro o parceiro (criador)",
  [ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_PAGE]:
    "Página do Facebook do parceiro",
  [ADS_CAMPAIGN_META_PARTNERSHIP_APPROVAL_WARNING]:
    "Confirme que {{name}} aprovou a sua solicitação para publicar anúncios em colaboração. Caso contrário, os seus anúncios não serão entregues.",
  [ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_INSTAGRAM]:
    "Conta do Instagram do parceiro",

  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_QUESTION]:
    "A sua campanha pertence a alguma categoria especial de anúncios?",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_DESCRIPTION]:
    "Selecione as categorias correspondentes (opcional; isso pode limitar certos tipos de segmentação)",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER]: "Categorias especiais",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_HOUSING]: "Moradia",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT]: "Emprego",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_FINANCIAL_PRODUCTS_SERVICES]:
    "Produtos e serviços financeiros",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_ISSUES_ELECTIONS_POLITICS]:
    "Temas, eleições e política",

  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_PLACEHOLDER]:
    "Categorias especiais de anúncios",
  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_HOUSING]: "Moradia",
  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT]: "Emprego",
  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_CREDIT]: "Crédito",

  [LESS_500K]: "Menos de $500,000.00",
  [BETWEEN_500K_1M]: "$500,000.00 - $1,000,000.00",
  [BETWEEN_1M_2_5M]: "$1,000,000.00 - $2,500,000.00",
  [BETWEEN_2_5M_5M]: "$2,500,000.00 - $5,000,000.00",
  [MORE_5M]: "Mais de $5,000,000.00",
  [LESS_1M]: "Menos de $1,000,000.00",
  [BETWEEN_1M_5M]: "$1,000,000.00 - $5,000,000.00",
  [BETWEEN_5M_15M]: "$5,000,000.00 - $15,000,000.00",
  [BETWEEN_15M_30M]: "$15,000,000.00 - $30,000,000.00",
  [BETWEEN_30M_100M]: "$30,000,000.00 - $100,000,000.00",
  [MORE_100M]: "Mais de $100,000,000.00",
  [LESS_150]: "Menos de $150",
  [BETWEEN_150_250]: "$150.00 - $250.00",
  [BETWEEN_250_650]: "$250.00 - $650.00",
  [BETWEEN_650_1250]: "$650.00 - $1,250.00",
  [MORE_1250]: "Mais de $1,250.00",
  [LESS_250]: "Menos de $250.00",
  [BETWEEN_250_1250]: "$250.00 - $1,250.00",
  [BETWEEN_1250_3750]: "$1,250.00 - $3,750.00",
  [BETWEEN_3750_7500]: "$3,750.00 - $7,500.00",
  [BETWEEN_7500_25K]: "$7,500.00 - $25,000.00",
  [MORE_25K]: "Mais de $25,000.00",
  [LESS_1000]: "Menos de $1,000.00",
  [BETWEEN_1000_5000]: "$1,000.00 - $5,000.00",
  [BETWEEN_5000_15K]: "$5,000.00 - $15,000.00",
  [BETWEEN_15K_30K]: "$15,000.00 - $30,000.00",
  [BETWEEN_30K_60K]: "$30,000.00 - $60,000.00",
  [MORE_60K]: "Mais de $60,000.00",
  [BETWEEN_1000_2000]: "$1,000.00 - $2,000.00",
  [BETWEEN_2000_5000]: "$2,000.00 - $5,000.00",
  [BETWEEN_5000_10K]: "$5,000.00 - $10,000.00",
  [MORE_10K]: "Mais de $10,000.00",

  [DOCUMENT_CC]: "Cédula de cidadania",
  [DOCUMENT_CE]: "Cédula de estrangeiro",
  [DOCUMENT_NUIP]: "NUIP",
  [DOCUMENT_NIT]: "NIT",
  [DOCUMENT_CI]: "Cédula de identidade",
  [DOCUMENT_PASSPORT]: "Passaporte",
  [DOCUMENT_EIN]: "EIN",
  [DOCUMENT_RUC]: "RUC",
  [DOCUMENT_ID]: "ID",
  [DOCUMENT_ID_EMIRATES]: "ID dos Emirados",
  [DOCUMENT_TRN]: "TRN",

  //EXPLANATIONS TOOLTIP
  [ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION]:
    "O que é o objetivo de reconhecimento?",
  [ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION]: `Os anúncios serão exibidos para pessoas com mais chances de se lembrar deles. Este objetivo é ideal para aumentar o reconhecimento da sua marca ou produto.<br><br>\n    Bom para:<br>\n    <li><strong>Alcance:</strong> Alcança pessoas com mais chances de se interessar pela sua marca.</li>\n    <li><strong>Reconhecimento de marca:</strong> Alcança pessoas com mais chances de se lembrar da sua marca.</li>\n    <li><strong>Visualizações de vídeo:</strong> Alcança pessoas com mais chances de ver o seu vídeo.</li>\n    <li><strong>Conhecimento da localização da sua loja:</strong> Alcança pessoas usando a localização física do seu negócio, organização ou conjunto de lojas.</li>\n    `,
  [ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION]:
    "O que é o objetivo de tráfego?",
  [ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION]: `Os anúncios serão exibidos para pessoas com mais chances de clicar neles. Este objetivo é ideal para aumentar o tráfego do seu site ou aplicativo.<br><br>\n    Bom para:<br>\n    <li><strong>Cliques no link:</strong> Faz com que as pessoas cliquem em um link para o seu site, aplicativo ou evento do Facebook.</li>\n    <li><strong>Visitas à página:</strong> Faz com que as pessoas vejam o conteúdo da sua página.</li>\n    <li><strong>Visitas ao perfil do Instagram:</strong> Faz com que as pessoas visitem o seu perfil do Instagram.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION]:
    "O que é o objetivo de interações?",
  [ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION]: `Os anúncios serão exibidos para pessoas com mais chances de interagir com eles. Este objetivo é ideal para aumentar comentários, curtidas, compartilhamentos e cliques no seu anúncio.<br><br>\n    Bom para:<br>\n    <li><strong>Visualizações de vídeo:</strong> Alcança pessoas com mais chances de ver o seu vídeo.</li>\n    <li><strong>Engajamento na publicação:</strong> Faz com que as pessoas interajam com as suas publicações.</li>\n    <li><strong>Conversões:</strong> Faz com que as pessoas vejam conteúdo, entrem em contato com o seu negócio, adicionem a uma lista de desejos ou realizem outra ação no seu site ou aplicativo.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION]:
    "O que é o objetivo de leads?",
  [ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION]: `Os anúncios serão exibidos para pessoas com mais chances de fornecer informações de contato. Este objetivo é ideal para aumentar os cadastros de leads.<br><br>\n    Bom para:<br>\n    <li><strong>Formulários instantâneos:</strong> Encontra pessoas dispostas a compartilhar as informações de contato e outros detalhes ao preencher um formulário.</li>\n    <li><strong>Conversões:</strong> Faz com que as pessoas compartilhem as informações de contato, concluam um formulário de cadastro, enviem uma solicitação ou realizem outra ação no seu site ou aplicativo.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION]:
    "O que é o objetivo de promoção de aplicativos?",
  [ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION]: `Os anúncios serão exibidos para pessoas com mais chances de baixar o seu aplicativo. Este objetivo é ideal para aumentar os downloads do seu aplicativo.<br><br>\n    Bom para:<br>\n    <li><strong>Instalação de aplicativos:</strong> Faz com que as pessoas baixem e instalem o seu aplicativo.</li>\n    <li><strong>Eventos de aplicativos:</strong> Faz com que os usuários comprem dentro do aplicativo ou realizem outras ações dentro do seu aplicativo.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION]:
    "O que é o objetivo de vendas?",
  [ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION]: `Os anúncios serão exibidos para pessoas com mais chances de comprar. Este objetivo é ideal para aumentar as vendas do seu produto ou serviço.<br><br>\n    Bom para:<br>\n    <li><strong>Conversões:</strong> Faz com que as pessoas adicionem um item ao carrinho, façam uma compra, iniciem uma assinatura ou realizem outra ação no seu site ou aplicativo.</li>\n    <li><strong>Vendas por catálogo:</strong> Faz com que as pessoas comprem produtos ou serviços do seu catálogo.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_TITLE_EXPLANATION]:
    "Visualizações de vídeo",
  [ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_DESCRIPTION_EXPLANATION]: `Exibe os seus anúncios de vídeo para pessoas com mais chances de vê-los. Este objetivo é ideal para aumentar as visualizações de vídeo e a interação.<br><br>\n    Bom para:<br>\n    <li><strong>Conteúdo de vídeo:</strong> Promove conteúdo de vídeo para aumentar as visualizações e a interação.</li>\n    <li><strong>Reconhecimento de marca:</strong> Usa o vídeo para gerar reconhecimento de marca e alcançar uma audiência mais ampla.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_TITLE_EXPLANATION]:
    "Conversões do site",
  [ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_DESCRIPTION_EXPLANATION]: `Exibe anúncios para pessoas com mais chances de realizar ações valiosas no seu site. Este objetivo é ideal para impulsionar conversões e vendas.<br><br>\n    Bom para:<br>\n    <li><strong>Conversões:</strong> Faz com que as pessoas concluam ações valiosas no seu site, como compras, cadastros ou envios de formulários.</li>\n    <li><strong>Vendas:</strong> Impulsiona as vendas e a receita ao direcionar pessoas que provavelmente vão converter.</li>`,
  [ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX]: "Performance Max",
  [ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_TITLE_EXPLANATION]:
    "O que é um tipo de campanha Performance Max?",
  [ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_DESCRIPTION_EXPLANATION]:
    "As campanhas Performance Max usam o aprendizado de máquina do Google para exibir os anúncios em todos os canais do Google Ads, maximizando as conversões ou o valor de conversão dentro do seu orçamento-alvo.",
  [ADS_CAMPAIGN_TYPE_APP_TITLE_EXPLANATION]:
    "O que é um tipo de campanha de instalação de app?",
  [ADS_CAMPAIGN_TYPE_APP_DESCRIPTION_EXPLANATION]:
    "As campanhas de instalação de app são feitas para promover o download e a instalação de aplicativos no Google Play ou na App Store.",
  [ADS_CAMPAIGN_TYPE_SEARCH_TITLE_EXPLANATION]:
    "O que é um tipo de campanha de pesquisa?",
  [ADS_CAMPAIGN_TYPE_SEARCH_DESCRIPTION_EXPLANATION]:
    "Os anúncios de pesquisa são exibidos para pessoas interessadas no momento certo na Pesquisa do Google.",
  [ADS_CAMPAIGN_TYPE_SHOPPING_TITLE_EXPLANATION]:
    "O que é um tipo de campanha de compras?",
  [ADS_CAMPAIGN_TYPE_SHOPPING_DESCRIPTION_EXPLANATION]:
    "Os anúncios de compras são exibidos para compradores enquanto exploram o que comprar online.",
  [ADS_CAMPAIGN_TYPE_VIDEO_TITLE_EXPLANATION]:
    "O que é um tipo de campanha de vídeo?",
  [ADS_CAMPAIGN_TYPE_VIDEO_DESCRIPTION_EXPLANATION]:
    "Os anúncios de vídeo são exibidos antes, durante ou depois de um vídeo no YouTube.",
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY_TITLE_EXPLANATION]:
    "O que significa um tipo de orçamento diário?",
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY_DESCRIPTION_EXPLANATION]:
    "O orçamento diário é o valor máximo que você está disposto a gastar por dia na sua campanha. A rede social tentará não ultrapassar esse limite, mas pode gastar um pouco mais nos dias em que houver mais oportunidades de exibir os seus anúncios.",
  [ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_TITLE_EXPLANATION]:
    "O que significa um tipo de orçamento total?",
  [ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_DESCRIPTION_EXPLANATION]:
    "O orçamento total é o valor máximo que você está disposto a gastar em toda a sua campanha. A rede social tentará não ultrapassar esse limite, mas pode gastar um pouco mais nos dias em que houver mais oportunidades de exibir os seus anúncios.",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_TITLE_EXPLANATION]:
    "O que é uma audiência personalizada de site?",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_DESCRIPTION_EXPLANATION]:
    "Uma audiência personalizada de site é criada a partir das pessoas que visitam o seu site ou realizam ações específicas nele.",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_TITLE_EXPLANATION]:
    "O que é uma audiência personalizada de lista de clientes?",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_DESCRIPTION_EXPLANATION]:
    "Uma audiência personalizada de lista de clientes é criada a partir das informações de contato que você já tem dos seus clientes, como endereços de e-mail ou números de telefone.",
  [ADS_CAMPAIGNS_PIXELS_TITLE_EXPLANATION]: "O que é um pixel?",
  [ADS_CAMPAIGNS_PIXELS_DESCRIPTION_EXPLANATION]: `Os pixels são ferramentas integradas a sites e aplicativos para medir a eficácia dos seus anúncios e entender as ações que os usuários realizam no seu site.<br/><br/>\n\n    Configurar um pixel aumenta a chance de os seus anúncios serem direcionados à audiência certa, o que maximiza os resultados obtidos.\n    \n    <ul>\n      <li><a href="https://www.facebook.com/business/help/952192354843755?id=1205376682832142" target="_blank">Como criar e configurar um pixel na Meta?</a></li>\n      <li><a href="https://ads.tiktok.com/help/article/get-started-pixel" target="_blank">Como criar e configurar um pixel no TikTok?</a></li>\n    </ul>`,
  [ADVERTISER_ROLE_TITLE_EXPLANATION]: "O que faz um administrador?",
  [ADVERTISER_ROLE_DESCRIPTION_EXPLANATION]: `Os administradores têm acesso total a todas as funcionalidades da plataforma. <br/><br/>\n    • Conectar e desconectar contas de plataformas.<br/>\n    • Gerar, publicar e editar campanhas.<br/>\n    • Gerar relatórios.<br/>\n    • Criar e editar usuários.<br/>\n    • Ver informações de faturamento e o plano atual.`,
  [MARKETER_ROLE_TILE_EXPLANATION]: "O que faz um Media Buyer?",
  [MARKETER_ROLE_DESCRIPTION_EXPLANATION]: `Os media buyers cuidam principalmente da criação e da publicação de campanhas na plataforma.<br/><br/>\n    • Conectar e desconectar contas de plataformas.<br/>\n    • Gerar relatórios.<br/>\n    • Gerar, publicar e editar campanhas.<br/>`,
  [VIEWER_ROLE_TITLE_EXPLANATION]: "O que faz um visualizador?",
  [VIEWER_ROLE_DESCRIPTION_EXPLANATION]: `Os visualizadores têm acesso às informações das campanhas e aos resultados obtidos. <br/><br/>\n    • Ver informações de campanhas.<br/>\n    • Gerar relatórios.<br/>`,
  [VIEWER_ROLE_READ_ONLY_CAPABILITY]:
    "Visualizadores só podem ver informações; não podem fazer alterações.",
  [VIEWER_CAPABILITY_VIEW_CAMPAIGNS]: "Ver campanhas",
  [VIEWER_CAPABILITY_VIEW_CONTENT]: "Ver conteúdos",
  [VIEWER_CAPABILITY_VIEW_CALENDAR]: "Ver calendário",
  [VIEWER_CAPABILITY_VIEW_REPORTS]: "Ver relatórios de campanha",
  [DESIGNER_ROLE_TITLE_EXPLANATION]: "O que faz um desenhista?",
  [ROLE_CAPABILITY_CAN_MANAGE_USERS]: "Gerenciar usuários",
  [ROLE_CAPABILITY_CAN_ACCESS_SETTINGS_ACCOUNTS]: "Conectar contas",
  [ROLE_CAPABILITY_CAN_CREATE_CAMPAIGN]: "Gerar campanhas",
  [ROLE_CAPABILITY_CAN_EDIT_CAMPAIGN]: "Publicar, editar e gerenciar campanhas",
  [ROLE_CAPABILITY_CAN_USE_CAMPAIGN_AGENT]: "Usar agente de IA",
  [ROLE_CAPABILITY_CAN_EDIT_GALLERY]: "Gerar e editar conteúdo",
  [ROLE_CAPABILITY_CAN_POST]: "Publicar conteúdo",
  [ROLE_CAPABILITY_CAN_EDIT_BRAND_SETUP]: "Configurar marca",
  [ROLE_CAPABILITY_CAN_EDIT_BILLING]: "Editar faturamento",

  //ONBOARDING

  //MAIN FUNCTIONALITY
  [MAIN_FUNCTIONALITY_STEP_1]: `Esta é a seção de Criadores de conteúdo. Aqui você encontrará a lista de criadores registrados em {{NAME_BUSINESS}} e disponíveis para colaborar com a sua marca.`,
  [MAIN_FUNCTIONALITY_STEP_2]:
    "Com os filtros você poderá buscar criadores de conteúdo pelo nome da conta, categorias, cidade, número de seguidores, porcentagem de engajamento da audiência, etc.",
  [MAIN_FUNCTIONALITY_STEP_3]: `Você tem três seções para buscar criadores de conteúdo: <br/><br/>\n    <strong>Criadores:</strong> Esta é a lista geral de todos os criadores registrados em {{NAME_BUSINESS}}.<br/>\n    <strong>Para você:</strong> Esta é a lista dos criadores que coincidem com o perfil de criador que interessa a você.<br/>\n    <strong>Solicitações:</strong> Esta é a lista dos criadores interessados na sua marca e que enviam uma solicitação de colaboração.\n    `,
  [MAIN_FUNCTIONALITY_STEP_4]:
    "Estas são as informações gerais do criador. Você pode clicar em cada cartão para acessar informações mais completas. Clique no cartão.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_1]:
    "Quando os criadores resgatarem os convites, serão geradas publicações. Para ir à seção de publicações, clique no menu lateral no botão Publicações.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_2]:
    "As publicações podem ter vários estados. O primeiro é Publicação pendente, quando o criador resgatou o convite, mas ainda não publicou o conteúdo que gerou.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_3]:
    "O segundo é Análise pendente, quando o criador já publicou o conteúdo que gerou, mas ainda não publicou a análise para ver os resultados da colaboração.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_4]:
    "O terceiro é Avaliar, quando o criador já publicou o conteúdo que gerou e a análise. Agora você deve revisá-los, dar uma nota ao criador e pensar se quer torná-lo embaixador. Clique no botão Avaliar",
  [PUBLICATION_FUNCTIONALITY_STEP_1]:
    "Aqui você verá as análises e os resultados gerados pelo conteúdo do criador de conteúdo.",
  [PUBLICATION_FUNCTIONALITY_STEP_2]:
    "Aqui você verá todo o conteúdo que o criador de conteúdo gerou para a sua marca.",
  [PUBLICATION_FUNCTIONALITY_STEP_3]:
    "Este é o botão para avaliar o criador de conteúdo. Clique no botão Avaliar.",
  [REVIEW_FUNCTIONALITY_STEP_1]:
    "Este é o formulário para avaliar o criador de conteúdo. As informações da sua avaliação não serão compartilhadas com o criador.",
  [REVIEW_FUNCTIONALITY_STEP_2]:
    "Você pode avaliar o conteúdo do criador de conteúdo, de 1 a 5, conforme a qualidade do conteúdo gerado.",
  [REVIEW_FUNCTIONALITY_STEP_3]:
    "Você pode avaliar a análise do criador de conteúdo, de 1 a 5, conforme a qualidade do resultado gerado.",
  [REVIEW_FUNCTIONALITY_STEP_4]:
    "Descreva em texto como foi a experiência geral com a colaboração. Este texto deve ter no mínimo 10 caracteres.",
  [REVIEW_FUNCTIONALITY_STEP_5]:
    "Depois de preencher o formulário, para enviar a avaliação você deve clicar no botão Finalizar.",
  [MAIN_FUNCTIONALITY_ONBOARDING_FINISH]:
    "Você concluiu o tutorial da plataforma. Agora você sabe onde encontrar os criadores de conteúdo, ver as informações deles e realizar diferentes ações com eles.",

  //MENU FUNCTIONALITY
  [MENU_FUNCTIONALITY_STEP_1]:
    "Aqui você poderá selecionar a loja cujo catálogo quer gerenciar.",
  [MENU_FUNCTIONALITY_STEP_2]:
    "Aqui você poderá adicionar uma categoria para organizar os seus produtos ou serviços. Clique no botão e escreva o nome da categoria.",
  [MENU_FUNCTIONALITY_STEP_3]:
    "Esta é a nova categoria que você acabou de criar.",
  [MENU_FUNCTIONALITY_STEP_4]:
    "Aqui você poderá adicionar um produto ou serviço.",
  [MENU_FUNCTIONALITY_STEP_5]:
    "Clique no botão para enviar uma imagem do produto.",
  [MENU_FUNCTIONALITY_STEP_6]: "Escreva o nome do produto e clique em próximo.",
  [MENU_FUNCTIONALITY_STEP_7]:
    "Escreva a descrição do produto e clique em próximo.",
  [MENU_FUNCTIONALITY_STEP_8]:
    "Escreva o preço do produto e clique em próximo.",
  [MENU_FUNCTIONALITY_STEP_9]:
    "Indique se o produto é prejudicial à saúde ou para maiores de idade clicando na caixa.",
  [MENU_FUNCTIONALITY_STEP_10]:
    "Depois de preencher o formulário, para criar o produto você deve clicar no botão Criar.",
  [MENU_FUNCTIONALITY_STEP_11]: "Este é o produto que você acabou de criar.",
  [MENU_FUNCTIONALITY_STEP_12]:
    "Clique para ativar ou desativar um produto conforme o seu estoque.",

  //USERS FUNCTIONALITY
  [USERS_FUNCTIONALITY_STEP_1]: "Este é um usuário administrador.",
  [USERS_FUNCTIONALITY_STEP_2]:
    "O papel de administrador tem acesso a todas as funcionalidades, ou seja, pode gerenciar convites a criadores, gerenciar as publicações, modificar informações da marca, gerenciar informações de pagamento, etc.",
  [USERS_FUNCTIONALITY_STEP_3]: "Este é um usuário operador.",
  [USERS_FUNCTIONALITY_STEP_4]:
    "O papel de operador tem acesso apenas às funcionalidades de resgatar os códigos dos criadores que cheguem à sua loja física, de gerenciar os pedidos/deliveries que os criadores façam pelo app e ativar/desativar produtos conforme o estoque.",

  //MAIN FUNCTIONALITY OPERATOR
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_1]:
    "Com a barra de resgate você poderá escrever um código e tentar resgatá-lo. Escreva qualquer código e clique em Resgatar.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_2]:
    "Aqui está o código que você acabou de resgatar e o valor do convite. Este é o valor que será concedido ao criador de conteúdo. Se o que o criador pedir for maior que o valor do convite, o excedente será cobrado.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_3]: `Esta é a seção de Pedidos. Aqui você poderá ver a lista dos pedidos que os criadores de conteúdo fizeram via delivery pelo aplicativo de {{NAME_BUSINESS}}. Os pedidos/deliveries têm 3 estados`,
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_4]:
    "O primeiro é A aceitar, quando o criador de conteúdo fez um pedido e está aguardando que você o aceite e atribua um tempo de processamento.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_5]:
    "O segundo é Processando, quando o criador de conteúdo fez um pedido, você o aceitou e atribuiu um tempo de processamento. Agora você deve comunicar a preparação do pedido.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_6]:
    "O terceiro é A entregar, quando o pedido que estava em processamento já está pronto e você o despachou com algum método de entrega. Quando você for notificado da entrega ou o criador marcá-lo como entregue, o pedido desaparecerá daqui.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_7]:
    "Acabou de entrar um novo pedido. A plataforma começará a emitir um som até que você veja o pedido novo. Clique para vê-lo.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_8]:
    "Aqui estão os produtos que o criador de conteúdo pediu. Você pode ver a quantidade e o preço de cada produto.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_9]:
    "Aqui está a mensagem que o criador de conteúdo deixou. Pode ser uma indicação ou recomendação para realizar a entrega.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_10]: "Aqui está o valor total do pedido.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_11]:
    "Aqui está o criador de conteúdo que fez o pedido e as informações dele.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_12]:
    "Aqui você poderá indicar o tempo de processamento e entrega do pedido. Podem ser minutos, horas, dias ou semanas.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_13]:
    "Aqui você poderá indicar a quantidade de tempo de processamento e entrega do pedido. Você pode adicionar ou subtrair tempo.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_14]:
    "Depois de revisar as informações e atribuir o tempo de processamento do pedido, você pode clicar no botão Aceitar pedido para passá-lo a processando",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_15]:
    "Este é o pedido que você acabou de aceitar. Ele mudou de estado.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_16]:
    "Aqui você verá quanto tempo de processamento resta. Clique para voltar a ver os detalhes do pedido.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_17]:
    "Quando o pedido estiver pronto, você deverá atribuir as informações de entrega.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_18]:
    "Depois de preencher o formulário, para marcar o pedido como pronto você deve clicar no botão Pedido pronto.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_19]:
    "Este é o pedido que você acabou de enviar. Ele mudou de estado. Aqui você encontrará as informações de entrega que atribuiu ao pedido. Quando for informado de que o pedido foi entregue, você deve marcá-lo como entregue. Clique em ver detalhes do pedido",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_20]:
    "Depois de revisar as informações e ser informado de que foi entregue ao criador, você deve marcar o pedido como entregue. Para isso, clique no botão Pedido entregue.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_21]:
    "Esta é a seção de Menu. Aqui você poderá ver a lista dos produtos que a sua marca tem no catálogo.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_22]:
    "Aqui estão a lista de categorias e a categoria de teste.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_23]:
    "Aqui estão a lista de produtos e o produto de teste.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_24]:
    "Como operador, você só pode ativar ou desativar produtos conforme a disponibilidade do estoque. Para desativar/ativar um produto, clique no botão.",

  //CAMPAIGNS FUNCTIONALITY
  [CAMPAIGNS_FUNCTIONALITY_STEP_1]:
    "Esta é a página de Campanhas. Você poderá criar campanhas para gerar colaborações mais personalizadas com os criadores.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_2]:
    "Vamos começar criando uma campanha. Clique em Criar campanha.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_3]:
    "No centro da tela irão aparecendo as perguntas da sua campanha.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_4]:
    "Na primeira pergunta você deverá escrever o nome da sua campanha.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_5]:
    "Depois de completar a pergunta, clique no botão Próximo.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_6]:
    "Depois de clicar no botão Próximo, aparecerá a próxima pergunta.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_7]:
    "Aqui você poderá selecionar a pergunta que quiser ver. Aparecerão apenas as que você já viu.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_8]:
    "O formulário pode ser um pouco longo, então você pode salvar o progresso até agora. Clique em Salvar progresso.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_9]:
    "Depois de salvar o progresso, você será redirecionado para a página da campanha.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_10]:
    "Esta é a seção de candidatos. Aqui você poderá ver os criadores que se candidataram à sua campanha. Você poderá ver as informações, estatísticas, aceitá-los ou recusá-los.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_11]:
    "Aqui você também poderá usar os filtros para ver os candidatos que interessam a você.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_12]:
    "Este é um criador que se candidatou à sua campanha.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_13]:
    "Esta é a seção de criadores convidados. Aqui aparecerão os criadores que interessaram para a sua campanha e que você convidou.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_14]:
    "Nesta seção você encontrará as informações da sua campanha. Aqui você poderá completar as informações que faltam e ativar a campanha para que os criadores possam se candidatar.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_15]:
    "Com este botão você poderá salvar as alterações da sua campanha e ela continuará desativada, então os criadores ainda não poderão se candidatar.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_16]:
    "Com este botão você poderá ativar a campanha. Você deverá ter todas as informações exigidas para poder fazê-lo. Nesse estado, os criadores poderão se candidatar à sua campanha.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_17]:
    "Com este botão você poderá encerrar a campanha. Nenhum criador poderá se candidatar e você não poderá ativá-la nunca mais.",

  //ALERTS
  [SAVE_LOCATION_SET_TITLE]: "Salvar conjunto de localizações",
  [SAVE_LOCATION_SET_NAME_LABEL]: "Nome do conjunto",
  [SAVE_LOCATION_SET_SAVE_BUTTON]: "Salvar",
  [SAVE_LOCATION_SET_SAVING_BUTTON]: "Salvando...",
  [SAVE_LOCATION_SET_CANCEL_BUTTON]: "Cancelar",
  [PUBLISHING_ALERT_TITLE]: "Publicando campanha",
  [PUBLISHING_ALERT_ERROR_TITLE]: "Erro ao publicar a campanha",
  [PUBLISHING_ALERT_SUCCESS_TITLE]: "Campanha publicada com sucesso",
  [PUBLISHING_ALERT_RETRY_BUTTON]: "Tentar novamente",
  [GENERATING_CAMPAIGN]: "Gerando campanha",
  [CAMPAIGN_GENERATED_SUCCESS]: "Campanha gerada com sucesso",
  [CAMPAIGN_GENERATED_ERROR]: "Erro ao gerar a campanha",
  [CAMPAIGN_GENERATED_ERROR_DESCRIPTION]:
    "Ocorreu um erro ao gerar a campanha. Por favor, tente novamente.",
  [CHANGE_BUYING_TYPE_TO_RESERVED_TITLE]: "Aguarde",
  [CHANGE_BUYING_TYPE_TO_RESERVED_DESCRIPTION]:
    "Ao mudar para o tipo de compra por reserva, as configurações atuais serão perdidas e só estará disponível o objetivo de Awareness. Deseja continuar?",
  [HIDE_ALERTS]: "Ocultar alertas",
  [SHOW_ALERTS]: "Mostrar alertas",
  [ACTIVITY]: "Atividade",
  [NO_TASKS]: "Ainda não há campanhas nem criativos em processo",
  [NO_TASKS_DESCRIPTION]:
    "As tarefas aparecerão aqui automaticamente quando você iniciar uma nova publicação de campanha ou gerar criativos",
  [RESET_CHAT_ALERT_TITLE]: "Tem certeza?",
  [RESET_CHAT_ALERT_DESCRIPTION]: "Todas as mensagens do chat serão excluídas.",
  [DISCARD_OPTIMIZATION_ALERT_TITLE]: "Tem certeza?",
  [DISCARD_OPTIMIZATION_ALERT_DESCRIPTION]:
    "Esta otimização será descartada e você não poderá recuperá-la.",
  [DISCARD_GENERATING_CREATIVE_ALERT_DESCRIPTION]:
    "O criativo gerado será descartado e você não poderá recuperá-lo.",
  [DISCARD_GENERATING_VIDEO_ALERT_DESCRIPTION]:
    "O vídeo gerado será descartado e você não poderá recuperá-lo.",
  [DISCARD_IMAGE_ANIMATION_ALERT_DESCRIPTION]:
    "A animação gerada será descartada e você não poderá recuperá-la.",
  [DISCARD_GENERATING_CUSTOM_REPORT_ALERT_DESCRIPTION]:
    "O relatório gerado será descartado e você não poderá recuperá-lo.",
  [DISCARD_ANALYZING_IMAGE_LAYERS_ALERT_DESCRIPTION]:
    "A análise de camadas será descartada e você não poderá recuperá-la.",
  [DISCARD_ANALYZING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION]:
    "Esta análise de modelo será descartada da sua lista de atividade.",
  [DISCARD_PRODUCING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION]:
    "Esta produção será descartada da sua lista de atividade.",
  [BUTTON_DISCARD_ALL]: "Descartar Todas",
  [DISCARD_ALL_ACTIVITIES_TITLE]: "Descartar Todas as Atividades?",
  [DISCARD_ALL_ACTIVITIES_DESCRIPTION]:
    "As atividades concluídas serão descartadas e o acesso às informações neste local será perdido. As atividades que continuam em andamento serão mantidas.",

  // Keys para el modal de sets guardados
  [SAVED_LOCATION_SETS_TITLE]: "Conjuntos de localizações salvos",
  [SAVED_LOCATION_SETS_CLOSE_BUTTON]: "Fechar",

  [FIELD_OPEN_MAP_RADIUS_SELECT_TITLE]: "Selecionar localizações",
  [FIELD_OPEN_MAP_RADIUS_SELECT_DESCRIPTION]:
    "Selecione localizações para a sua campanha.",

  // Keys para los botones principales
  [LOAD_LOCATION_SET_BUTTON]: "Selecionar localizações",
  [SAVE_LOCATION_SET_BUTTON]: "Salvar localizações",
  [SAVE_LOCATION_SET_SUCCESS]: "Conjunto de localizações salvo",
  [SAVE_LOCATION_SET_ERROR]: "Erro ao salvar conjunto de localizações",
  [LOAD_LOCATION_SETS_ERROR]: "Erro ao carregar conjuntos de localizações",
  [SAVE_LOCATION_SET_DUPLICATE_ERROR]:
    "Já existe um conjunto com as mesmas localizações",

  // CUSTOMER ACQUISITION CONFIGURATION
  [CUSTOMER_ACQUISITION_TITLE]: "Aquisição de clientes",
  [CUSTOMER_ACQUISITION_SWITCH_LABEL]:
    "Ajuste a sua oferta para ajudar você a conquistar novos clientes",
  [CUSTOMER_ACQUISITION_ACCOUNT_LEVEL]: "Usar configuração de nível da conta",
  [CUSTOMER_ACQUISITION_CAMPAIGN_LEVEL]:
    "Usar configuração específica da campanha",
  [CUSTOMER_ACQUISITION_NEW_CUSTOMER_VALUE]: "Cliente novo",
  [CUSTOMER_ACQUISITION_NEW_CUSTOMER_HIGH_VALUE]: "Cliente novo de alto valor",

  // METRICS NOT FOUND MESSAGE
  [METRICS_NOT_FOUND_MESSAGE]: "Métricas não encontradas",
  [SEARCH_METRICS_PLACEHOLDER]: "Buscar métricas...",
  [CONFIGURE_METRICS]: "Configurar métricas",
  [GENERAL_METRIC]: "Geral",

  /*GENERAL METRICS*/
  [REACH]: "Alcance",
  [FREQUENCY]: "Frequência",
  [CPM_METRICS]: "CPM",
  [CPC_METRICS]: "CPC",
  [ESTIMATED_AUDIENCE_SIZE]: "Tamanho estimado da audiência",
  [REACH_AT_TARGET_FREQUENCY]: "Alcance na frequência-alvo",
  [AUDIENCE_SIZE]: "Tamanho da audiência",
  [POTENTIAL_REACH]: "Alcance potencial",
  [ESTIMATED_DAILY_RESULTS]: "Resultados diários estimados",

  /*SPECIFICS METRICS GOOGLE*/
  [ALL_CONVERSIONS]: "Todas as conversões",
  [ALL_CONVERSIONS_FROM_INTERACTIONS_RATE]:
    "Taxa de todas as conversões por interações",
  [ALL_CONVERSIONS_VALUE]: "Valor de todas as conversões",
  [APP_EVENT_ADD_TO_CART]: "Eventos de adicionar ao carrinho no app",
  [APP_INSTALL]: "Instalações de app",
  [AVERAGE_CART_SIZE]: "Tamanho médio do carrinho",
  [AVERAGE_COST]: "Custo médio",
  [AVERAGE_CPC]: "Custo médio por clique",
  [AVERAGE_ORDER_VALUE_MICROS]: "Valor médio do pedido",
  [CHECKOUT]: "Finalizações de compra",
  [COMMENTS_METRICS]: "Comentários",
  [CONVERSION_RATE]: "Taxa de conversão",
  [CONVERSIONS_FROM_INTERACTIONS_RATE]: "Taxa de conversões por interações",
  [CONVERSIONS_VALUE]: "Valor de conversões",
  [COST_OF_GOODS_SOLD_MICROS]: "Custo dos produtos vendidos",
  [COST_PER_ALL_CONVERSIONS]: "Custo por todas as conversões",
  [COST_PER_APP_EVENT_ADD_TO_CART]: "Custo por adicionar ao carrinho no app",
  [COST_PER_APP_INSTALL]: "Custo por instalação de app",
  [COST_PER_CHECKOUT]: "Custo por finalização de compra",
  [COST_PER_CONVERSION]: "Custo por conversão",
  [COST_PER_PURCHASE]: "Custo por compra",
  [COST_PER_VIEW_CONTENT]: "Custo por visualização de conteúdo",
  [CROSS_DEVICE_CONVERSIONS]: "Conversões entre dispositivos",
  [CROSS_DEVICE_CONVERSIONS_VALUE_MICROS]:
    "Valor de conversões entre dispositivos",
  [CROSS_SELL_COST_OF_GOODS_SOLD_MICROS]:
    "Custo dos produtos vendidos em venda cruzada",
  [CROSS_SELL_GROSS_PROFIT_MICROS]: "Lucro bruto de venda cruzada",
  [CROSS_SELL_REVENUE_MICROS]: "Receita de venda cruzada",
  [CROSS_SELL_UNITS_SOLD]: "Unidades vendidas em venda cruzada",
  [ENGAGEMENT_RATE]: "Taxa de engajamento",
  [FOLLOWS]: "Seguidores",
  [GROSS_PROFIT_MARGIN]: "Margem de lucro bruto",
  [GROSS_PROFIT_MICROS]: "Lucro bruto",
  [INTERACTION_RATE]: "Taxa de interação",
  [INTERACTIONS_METRICS]: "Interações",
  [LEAD_COST_OF_GOODS_SOLD_MICROS]: "Custo dos produtos vendidos por lead",
  [LEAD_GROSS_PROFIT_MICROS]: "Lucro bruto por lead",
  [LEAD_REVENUE_MICROS]: "Receita por lead",
  [LEAD_UNITS_SOLD]: "Unidades vendidas por lead",
  [LIKES_METRICS]: "Curtidas",
  [ORDERS_METRICS]: "Pedidos",
  [PROFILE_VISITS]: "Visitas ao perfil",
  [PURCHASE]: "Compras",
  [REVENUE_MICROS]: "Receita",
  [SHARES_METRICS]: "Compartilhamentos",
  [VALUE_PER_ALL_CONVERSIONS]: "Valor por todas as conversões",
  [VALUE_PER_CONVERSION]: "Valor por conversão",
  [VIDEO_VIEWS_P100]: "Visualizações completas de vídeo",
  [VIEW_CONTENT]: "Visualizações de conteúdo",
  [VIEW_THROUGH_CONVERSIONS]: "Conversões por visualização",

  /*SPECIFICS METRICS META*/
  [ACTION_VALUES]: "Valores de ação",
  [ACTIONS_METRICS]: "Ações",
  [COST_PER_ADD_TO_CART_META]: "Custo por adicionar ao carrinho",
  [ADD_TO_CART_META]: "Adicionar ao carrinho",
  [COST_PER_WEB_IN_STORE_PURCHASE_META]: "Custo por compra web na loja",
  [WEB_IN_STORE_PURCHASE_META]: "Compra web na loja",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META]:
    "Custo por conversão externa Fb Pixel de pesquisa",
  [OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META]:
    "Conversão externa Fb Pixel de pesquisa",
  [COST_PER_LINK_CLICK_META]: "Custo por clique no link",
  [LINK_CLICK_META]: "Clique no link",
  [COST_PER_PAGE_ENGAGEMENT_META]: "Custo por engajamento da página",
  [PAGE_ENGAGEMENT_META]: "Engajamento da página",
  [COST_PER_PURCHASE_META]: "Custo por compra",
  [PURCHASE_META]: "Compra",
  [COST_PER_LANDING_PAGE_VIEW_META]:
    "Custo por visualização da página de destino",
  [LANDING_PAGE_VIEW_META]: "Visualização da página de destino",
  [COST_PER_POST_ENGAGEMENT_META]: "Custo por engajamento da publicação",
  [POST_ENGAGEMENT_META]: "Engajamento da publicação",
  [COST_PER_ONSITE_WEB_VIEW_CONTENT_META]:
    "Custo por visualização de conteúdo web no site",
  [ONSITE_WEB_VIEW_CONTENT_META]: "Visualização de conteúdo web no site",
  [COST_PER_ONSITE_WEB_ADD_TO_CART_META]:
    "Custo por adicionar ao carrinho web no site",
  [ONSITE_WEB_ADD_TO_CART_META]: "Adicionar ao carrinho web no site",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META]:
    "Custo por conversão externa Fb Pixel de adicionar informações de pagamento",
  [OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META]:
    "Conversão externa Fb Pixel de adicionar informações de pagamento",
  [COST_PER_COMMENT_META]: "Custo por comentário",
  [COMMENT_META]: "Comentário",
  [COST_PER_ONSITE_WEB_APP_PURCHASE_META]:
    "Custo por compra de app web no site",
  [ONSITE_WEB_APP_PURCHASE_META]: "Compra de app web no site",
  [COST_PER_OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META]:
    "Custo por visualização de conteúdo externa de adicionar Leads Meta",
  [OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META]:
    "Visualização de conteúdo externa de adicionar Leads Meta",
  [COST_PER_VIEW_CONTENT_META]: "Custo por ver conteúdo",
  [VIEW_CONTENT_META]: "Ver conteúdo",
  [COST_PER_WEB_APP_IN_STORE_PURCHASE_META]:
    "Custo por compra de app web na loja",
  [WEB_APP_IN_STORE_PURCHASE_META]: "Compra de app web na loja",
  [COST_PER_ONSITE_WEB_APP_ADD_TO_CART_META]:
    "Custo por adicionar ao carrinho de app web no site",
  [ONSITE_WEB_APP_ADD_TO_CART_META]: "Adicionar ao carrinho de app web no site",
  [COST_PER_OFFSITE_SEARCH_ADD_META_LEADS_META]:
    "Custo por pesquisa externa de adicionar Leads Meta",
  [OFFSITE_SEARCH_ADD_META_LEADS_META]:
    "Pesquisa externa de adicionar Leads Meta",
  [COST_PER_POST_META]: "Custo por publicação",
  [POST_META]: "Publicação",
  [COST_PER_ONSITE_CONVERSION_POST_SAVE_META]:
    "Custo por conversão no site ao salvar publicação",
  [ONSITE_CONVERSION_POST_SAVE_META]: "Conversão no site ao salvar publicação",
  [COST_PER_ONSITE_WEB_INITIATE_CHECKOUT_META]:
    "Custo por início de checkout web no site",
  [ONSITE_WEB_INITIATE_CHECKOUT_META]: "Início de checkout web no site",
  [COST_PER_ONSITE_CONVERSION_POST_NET_SAVE_META]:
    "Custo por conversão no site ao salvar publicação líquida",
  [ONSITE_CONVERSION_POST_NET_SAVE_META]:
    "Conversão no site ao salvar publicação líquida",
  [COST_PER_ONSITE_WEB_APP_VIEW_CONTENT_META]:
    "Custo por visualização de conteúdo de app web no site",
  [ONSITE_WEB_APP_VIEW_CONTENT_META]:
    "Visualização de conteúdo de app web no site",
  [COST_PER_POST_INTERACTION_GROSS_META]:
    "Custo por interação bruta da publicação",
  [POST_INTERACTION_GROSS_META]: "Interação bruta da publicação",
  [COST_PER_ONSITE_WEB_PURCHASE_META]: "Custo por compra web no site",
  [ONSITE_WEB_PURCHASE_META]: "Compra web no site",
  [COST_PER_ADD_PAYMENT_INFO_META]:
    "Custo por adicionar informações de pagamento",
  [ADD_PAYMENT_INFO_META]: "Adicionar informações de pagamento",
  [COST_PER_SEARCH_META]: "Custo por pesquisa",
  [SEARCH_META]: "Pesquisa",
  [COST_PER_VIDEO_VIEW_META]: "Custo por visualização de vídeo",
  [VIDEO_VIEW_META]: "Visualização de vídeo",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META]:
    "Custo por conversão externa Fb Pixel de ver conteúdo",
  [OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META]:
    "Conversão externa Fb Pixel de ver conteúdo",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META]:
    "Custo por conversão externa Fb Pixel de adicionar ao carrinho",
  [OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META]:
    "Conversão externa Fb Pixel de adicionar ao carrinho",
  [COST_PER_POST_REACTION_META]: "Custo por reação da publicação",
  [POST_REACTION_META]: "Reação da publicação",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META]:
    "Custo por conversão externa Fb Pixel de início de checkout",
  [OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META]:
    "Conversão externa Fb Pixel de início de checkout",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META]:
    "Custo por conversão externa Fb Pixel de compra",
  [OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META]:
    "Conversão externa Fb Pixel de compra",
  [COST_PER_INITIATE_CHECKOUT_META]: "Custo por início de checkout",
  [INITIATE_CHECKOUT_META]: "Início de checkout",
  [COST_PER_LIKE_META]: "Custo por curtida",
  [LIKE_META]: "Curtida",
  [AD_CLICK_ACTIONS]: "Cliques em anúncios",
  [AD_IMPRESSION_ACTIONS]: "Impressões de anúncios",
  [AUCTION_BID]: "Lance no leilão",
  [AUCTION_COMPETITIVENESS]: "Competitividade no leilão",
  [AUCTION_MAX_COMPETITOR_BID]: "Lance máximo do concorrente",
  [CANVAS_AVG_VIEW_PERCENT]: "Porcentagem média de visualização do Canvas",
  [CANVAS_AVG_VIEW_TIME]: "Tempo médio de visualização do Canvas",
  [CATALOG_SEGMENT_ACTIONS]: "Ações do segmento de catálogo",
  [CATALOG_SEGMENT_VALUE]: "Valor do segmento de catálogo",
  [CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS]:
    "ROAS de compras mobile no segmento de catálogo",
  [CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS]:
    "ROAS de compras omnicanal no segmento de catálogo",
  [CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS]:
    "ROAS de compras no site no segmento de catálogo",
  [CONVERSION_VALUES]: "Valores de conversão",
  [CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE]:
    "Compras mobile de produtos convertidos",
  [CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE]:
    "Valor de compras mobile de produtos convertidos",
  [CONVERTED_PRODUCT_OFFLINE_PURCHASE]:
    "Compras offline de produtos convertidos",
  [CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE]:
    "Valor de compras offline de produtos convertidos",
  [CONVERTED_PRODUCT_OMNI_PURCHASE]:
    "Compras omnicanal de produtos convertidos",
  [CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES]:
    "Valores de compras omnicanal de produtos convertidos",
  [CONVERTED_PRODUCT_QUANTITY]: "Quantidade de produtos convertidos",
  [CONVERTED_PRODUCT_VALUE]: "Valor de produtos convertidos",
  [CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE]:
    "Compras no site de produtos convertidos",
  [CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE]:
    "Valor de compras no site de produtos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE]:
    "Compras mobile de produtos promovidos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE]:
    "Valor de compras mobile de produtos promovidos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE]:
    "Compras offline de produtos promovidos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE]:
    "Valor de compras offline de produtos promovidos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE]:
    "Compras omnicanal de produtos promovidos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES]:
    "Valores de compras omnicanal de produtos promovidos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_QUANTITY]:
    "Quantidade de produtos promovidos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_VALUE]:
    "Valor de produtos promovidos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE]:
    "Compras no site de produtos promovidos convertidos",
  [CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE]:
    "Valor de compras no site de produtos promovidos convertidos",
  [COST_PER_15SEC_VIDEO_VIEW]: "Custo por visualização de vídeo de 15 segundos",
  [COST_PER_15_SEC_VIDEO_VIEW]:
    "Custo por visualização de vídeo de 15 segundos",
  [COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW]:
    "Custo por visualização contínua de vídeo de 2 segundos",
  [COST_PER_ACTION_TYPE]: "Custo por tipo de ação",
  [COST_PER_AD_CLICK]: "Custo por clique no anúncio",
  [COST_PER_DDA_COUNT_BY_CONVS]: "Custo por contagem DDA por conversões",
  [COST_PER_ESTIMATED_AD_RECALLERS]:
    "Custo por lembretes estimados de anúncios",
  [COST_PER_INLINE_LINK_CLICK]: "Custo por clique em link inline",
  [COST_PER_INLINE_POST_ENGAGEMENT]:
    "Custo por engajamento em publicação inline",
  [COST_PER_OBJECTIVE_RESULT]: "Custo por resultado do objetivo",
  [COST_PER_ONE_THOUSAND_AD_IMPRESSION]: "Custo por mil impressões de anúncios",
  [COST_PER_OUTBOUND_CLICK]: "Custo por clique de saída",
  [COST_PER_RESULT]: "Custo por resultado",
  [COST_PER_THRUPLAY]: "Custo por reprodução completa",
  [COST_PER_UNIQUE_ACTION_TYPE]: "Custo por tipo de ação única",
  [COST_PER_UNIQUE_CLICK]: "Custo por clique único",
  [COST_PER_UNIQUE_CONVERSION]: "Custo por conversão única",
  [COST_PER_UNIQUE_INLINE_LINK_CLICK]: "Custo por clique único em link inline",
  [COST_PER_UNIQUE_OUTBOUND_CLICK]: "Custo por clique de saída único",
  [CPP]: "Custo por pessoa",
  [DDA_COUNT_BY_CONVS]: "Contagem DDA por conversões",
  [DDA_RESULTS]: "Resultados DDA",
  [ESTIMATED_AD_RECALLERS]: "Lembretes estimados de anúncios",
  [INSTAGRAM_PROFILE_FOLLOW]: "Seguidores do Instagram",
  [FULL_VIEW_IMPRESSIONS]: "Impressões de visualização completa",
  [FULL_VIEW_REACH]: "Alcance de visualização completa",
  [INLINE_LINK_CLICK_CTR]: "CTR de cliques em links inline",
  [INLINE_LINK_CLICKS]: "Cliques em links inline",
  [INLINE_POST_ENGAGEMENT]: "Engajamento em publicações inline",
  [INSTANT_EXPERIENCE_CLICKS_TO_OPEN]:
    "Cliques para abrir a experiência instantânea",
  [INSTANT_EXPERIENCE_CLICKS_TO_START]:
    "Cliques para iniciar a experiência instantânea",
  [INSTANT_EXPERIENCE_OUTBOUND_CLICKS]:
    "Cliques de saída na experiência instantânea",
  [INTERACTIVE_COMPONENT_TAP]: "Toques no componente interativo",
  [LANDING_PAGE_VIEW_PER_LINK_CLICK]:
    "Visualizações da página de destino por clique no link",
  [MARKETING_MESSAGES_DELIVERY_RATE]:
    "Taxa de entrega de mensagens de marketing",
  [OBJECTIVE_RESULT_RATE]: "Taxa de resultado do objetivo",
  [OBJECTIVE_RESULTS]: "Resultados do objetivo",
  [OUTBOUND_CLICKS]: "Cliques de saída",
  [OUTBOUND_CLICKS_CTR]: "CTR de cliques de saída",
  [PURCHASE_PER_LANDING_PAGE_VIEW]:
    "Compras por visualização da página de destino",
  [QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE]:
    "Taxa de resposta qualificada à pergunta de qualificação",
  [RESULT_RATE]: "Taxa de resultados",
  [RESULTS_METRICS]: "Resultados",
  [ROAS_METRICS]: "ROAS",
  [SHOPS_ASSISTED_PURCHASES]: "Compras assistidas em lojas",
  [SOCIAL_SPEND]: "Gasto social",
  [TOTAL_CARD_VIEW]: "Visualizações totais de cartões",
  [VIDEO_30SEC_WATCHED_ACTIONS]:
    "Ações de visualização de vídeo de 30 segundos",
  [VIDEO_30_SEC_WATCHED_ACTIONS]:
    "Ações de visualização de vídeo de 30 segundos",
  [VIDEO_AVG_TIME_WATCHED_ACTIONS]:
    "Ações de tempo médio de visualização de vídeo",
  [VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS]:
    "Ações de visualização contínua de vídeo de 2 segundos",
  [VIDEO_P100_WATCHED_ACTIONS]: "Ações de visualização de vídeo a 100%",
  [VIDEO_P25_WATCHED_ACTIONS]: "Ações de visualização de vídeo a 25%",
  [VIDEO_P50_WATCHED_ACTIONS]: "Ações de visualização de vídeo a 50%",
  [VIDEO_P75_WATCHED_ACTIONS]: "Ações de visualização de vídeo a 75%",
  [VIDEO_P95_WATCHED_ACTIONS]: "Ações de visualização de vídeo a 95%",
  [VIDEO_PLAY_ACTIONS]: "Ações de reprodução de vídeo",
  [VIDEO_PLAY_CURVE_ACTIONS]: "Ações da curva de reprodução de vídeo",
  [VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS]:
    "Ações de retenção de reprodução de vídeo de 0 a 15s",
  [VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS]:
    "Ações de retenção de reprodução de vídeo de 20 a 60s",
  [VIDEO_PLAY_RETENTION_GRAPH_ACTIONS]:
    "Ações do gráfico de retenção de reprodução de vídeo",
  [VIDEO_TIME_WATCHED_ACTIONS]: "Ações de tempo de visualização de vídeo",
  [WEBSITE_CTR]: "CTR do site",
  [WEBSITE_PURCHASE_ROAS]: "ROAS de compras no site",
  [VIDEO_HOOK_RATE]: "Taxa de gancho do vídeo",
  [VIDEO_RETENTION_RATE]: "Taxa de retenção do vídeo",

  /*SPECIFICS METRICS TIKTOK*/
  [BILLED_COST]: "Custo faturado",
  [GROSS_IMPRESSIONS]: "Impressões brutas",
  [CONVERSION_RATE_TIKTOK]: "Taxa de conversão",
  [RESULT_RATE_TIKTOK]: "Taxa de resultados",
  [VIDEO_VIEWS_P100_TIKTOK]: "Reproduções a 100%",
  [AVERAGE_VIDEO_PLAY]: "Reprodução média de vídeo",
  [ENGAGEMENT_RATE_TIKTOK]: "Taxa de engajamento",
  [FOLLOWS_TIKTOK]: "Seguidores",
  [LIKES_TIKTOK]: "Curtidas",
  [COMMENTS_TIKTOK]: "Comentários",
  [SHARES_TIKTOK]: "Compartilhamentos",
  [PROFILE_VISITS_TIKTOK]: "Visitas ao perfil",
  [COMMENTS_LINKEDIN]: "Comentários",
  [COMPANY_PAGE_CLICKS_LINKEDIN]: "Cliques na página da empresa",
  [EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN]: "Conversões em sites externos",
  [FOLLOWS_LINKEDIN]: "Seguimentos",
  [FULL_SCREEN_PLAYS_LINKEDIN]: "Reproduções em tela cheia",
  [LANDING_PAGE_CLICKS_LINKEDIN]: "Cliques na página de destino",
  [LIKES_LINKEDIN]: "Recomendações",
  [REACTIONS_LINKEDIN]: "Reações",
  [RETURN_ON_AD_SPEND_LINKEDIN]: "Retorno do investimento publicitário",
  [SHARES_LINKEDIN]: "Vezes que foi compartilhado",
  [TOTAL_ENGAGEMENTS_LINKEDIN]: "Engajamentos totais",
  [VIDEO_COMPLETIONS_LINKEDIN]: "Visualizações completas do vídeo",
  [VIDEO_STARTS_LINKEDIN]: "Reproduções de vídeo iniciadas",
  [VIDEO_VIEWS_LINKEDIN]: "Visualizações de vídeo",
  [ONE_CLICK_LEADS_LINKEDIN]: "Leads",
  [ONE_CLICK_LEAD_FORM_OPENS_LINKEDIN]: "Aberturas do formulário",
  [LEAD_FORM_COMPLETION_RATE_LINKEDIN]: "Taxa de conclusão do formulário",
  [VALID_WORK_EMAIL_LEADS_LINKEDIN]: "Leads com e-mail de trabalho",
  [DOWNLOAD_CLICKS_LINKEDIN]: "Cliques de download",
  [DOCUMENT_FIRST_QUARTILE_COMPLETIONS_LINKEDIN]: "Documento a 25%",
  [DOCUMENT_MIDPOINT_COMPLETIONS_LINKEDIN]: "Documento a 50%",
  [DOCUMENT_THIRD_QUARTILE_COMPLETIONS_LINKEDIN]: "Documento a 75%",
  [DOCUMENT_COMPLETIONS_LINKEDIN]: "Documento a 100%",
  [LIVE_VIEWS]: "Visualizações ao vivo",
  [APP_INSTALL_TIKTOK]: "Instalações de app",
  [COST_PER_APP_INSTALL_TIKTOK]: "Custo por instalação de app",
  [REGISTRATION]: "Cadastros",
  [COST_PER_REGISTRATION]: "Custo por cadastro",
  [PURCHASE_TIKTOK]: "Compras",
  [COST_PER_PURCHASE_TIKTOK]: "Custo por compra",
  [PURCHASE_RATE]: "Taxa de compra",
  [TOTAL_PURCHASE_VALUE]: "Valor total de compras",
  [APP_EVENT_ADD_TO_CART_TIKTOK]: "Eventos de adicionar ao carrinho",
  [COST_PER_APP_EVENT_ADD_TO_CART_TIKTOK]:
    "Custo por evento de adicionar ao carrinho",
  [CHECKOUT_TIKTOK]: "Finalizações de compra",
  [COST_PER_CHECKOUT_TIKTOK]: "Custo por finalização de compra",
  [VIEW_CONTENT_TIKTOK]: "Visualização de conteúdo",
  [COST_PER_VIEW_CONTENT_TIKTOK]: "Custo por visualização de conteúdo",
  [NEXT_DAY_OPEN]: "Aberturas no dia seguinte",
  [DAY7_RETENTION]: "Retenção em 7 dias",
  [CASH_SPEND]: "Gasto em dinheiro",
  [VOUCHER_SPEND]: "Gasto em cupons",
  [COST_PER_1000_REACHED]: "Custo por 1.000 alcançados",
  [CONVERSION_RATE_V2]: "Taxa de conversão V2",
  [REAL_TIME_CONVERSION]: "Conversões em tempo real",
  [REAL_TIME_COST_PER_CONVERSION]: "Custo por conversão em tempo real",
  [REAL_TIME_CONVERSION_RATE]: "Taxa de conversão em tempo real",
  [REAL_TIME_CONVERSION_RATE_V2]: "Taxa de conversão em tempo real V2",
  [REAL_TIME_RESULT]: "Resultados em tempo real",
  [REAL_TIME_COST_PER_RESULT]: "Custo por resultado em tempo real",
  [REAL_TIME_RESULT_RATE]: "Taxa de resultados em tempo real",
  [SECONDARY_GOAL_RESULT]: "Resultados do objetivo secundário",
  [COST_PER_SECONDARY_GOAL_RESULT]:
    "Custo por resultado do objetivo secundário",
  [SECONDARY_GOAL_RESULT_RATE]: "Taxa de resultados do objetivo secundário",
  [VIDEO_PLAY_ACTIONS_TIKTOK]: "Ações de reprodução de vídeo",
  [VIDEO_WATCHED_2S]: "Visualizações de 2 segundos",
  [VIDEO_WATCHED_6S]: "Visualizações de 6 segundos",
  [VIDEO_VIEWS_P25]: "Reproduções a 25%",
  [VIDEO_VIEWS_P50]: "Reproduções a 50%",
  [VIDEO_VIEWS_P75]: "Reproduções a 75%",
  [AVERAGE_VIDEO_PLAY_PER_USER]: "Reprodução média por usuário",
  [PAID_ENGAGED_VIEW]: "Visualizações engajadas pagas",
  [PAID_ENGAGEMENT_ENGAGED_VIEW]: "Visualizações engajadas de interação paga",
  [ENGAGED_VIEW_15S]: "Visualizações engajadas de 15s",
  [PAID_ENGAGED_VIEW_15S]: "Visualizações engajadas pagas de 15s",
  [PAID_ENGAGEMENT_ENGAGED_VIEW_15S]:
    "Visualizações engajadas de interação paga de 15s",
  [CLICKS_ON_MUSIC_DISC]: "Cliques no disco de música",
  [DUET_CLICKS]: "Cliques em dueto",
  [STITCH_CLICKS]: "Cliques em Stitch",
  [SOUND_USAGE_CLICKS]: "Cliques de uso de som",
  [MUSIC_UPLOAD_TITLE]: "Música de fundo",
  [MUSIC_UPLOAD_BUTTON]: "Enviar música",
  [MUSIC_REMOVE_BUTTON]: "Excluir música",
  [MUSIC_UPLOAD_DESCRIPTION]:
    "Envie um arquivo de música em formato MP3 para o seu anúncio",
  [ANCHOR_CLICKS]: "Cliques na âncora",
  [ANCHOR_CLICK_RATE]: "Taxa de cliques na âncora",
  [CLICKS_ON_HASHTAG_CHALLENGE]: "Cliques em desafios de hashtag",
  [PROFILE_VISITS_RATE]: "Taxa de visitas ao perfil",
  [TT_PLAYLIST_VISIT]: "Visitas à playlist",
  [TT_PLAYLIST_VISIT_RATE]: "Taxa de visitas à playlist",
  [LIVE_UNIQUE_VIEWS]: "Visualizações únicas ao vivo",
  [LIVE_EFFECTIVE_VIEWS]: "Visualizações efetivas ao vivo",
  [LIVE_PRODUCT_CLICKS]: "Cliques em produtos ao vivo",
  [INTERACTIVE_ADD_ON_IMPRESSIONS]: "Impressões de complementos interativos",
  [INTERACTIVE_ADD_ON_DESTINATION_CLICKS]:
    "Cliques de destino em complementos interativos",
  [INTERACTIVE_ADD_ON_ACTIVITY_CLICKS]:
    "Cliques de atividade em complementos interativos",
  [INTERACTIVE_ADD_ON_OPTION_A_CLICKS]:
    "Cliques na opção A de complementos interativos",
  [INTERACTIVE_ADD_ON_OPTION_B_CLICKS]:
    "Cliques na opção B de complementos interativos",
  [COUNTDOWN_STICKER_RECALL_CLICKS]:
    "Cliques no adesivo de contagem regressiva",
  [IX_PAGE_DURATION_AVG]: "Duração média da página IX",
  [IX_PAGE_VIEWRATE_AVG]: "Taxa média de visualização da página IX",
  [IX_VIDEO_VIEWS]: "Visualizações de vídeo IX",
  [IX_VIDEO_VIEWS_P25]: "Visualizações de vídeo IX a 25%",
  [IX_VIDEO_VIEWS_P50]: "Visualizações de vídeo IX a 50%",
  [IX_VIDEO_VIEWS_P75]: "Visualizações de vídeo IX a 75%",
  [IX_VIDEO_VIEWS_P100]: "Visualizações de vídeo IX a 100%",
  [IX_AVERAGE_VIDEO_PLAY]: "Reprodução média de vídeo IX",
  [REAL_TIME_APP_INSTALL]: "Instalações de app em tempo real",
  [REAL_TIME_APP_INSTALL_COST]: "Custo de instalação de app em tempo real",
  [REGISTRATION_RATE]: "Taxa de cadastro",
  [TOTAL_REGISTRATION]: "Cadastros totais",
  [COST_PER_TOTAL_REGISTRATION]: "Custo por cadastro total",
  [TOTAL_PURCHASE]: "Compras totais",
  [COST_PER_TOTAL_PURCHASE]: "Custo por compra total",
  [VALUE_PER_TOTAL_PURCHASE]: "Valor por compra total",
  [TOTAL_ACTIVE_PAY_ROAS]: "ROAS de pagamento ativo total",
  [TOTAL_PURCHASE_ROAS_DAY0]: "ROAS de compra total dia 0",
  [TOTAL_PURCHASE_ROAS_DAY2]: "ROAS de compra total dia 2",
  [TOTAL_PURCHASE_ROAS_DAY6]: "ROAS de compra total dia 6",
  [TOTAL_PURCHASE_VALUE_DAY0]: "Valor total de compras dia 0",
  [TOTAL_PURCHASE_VALUE_DAY2]: "Valor total de compras dia 2",
  [TOTAL_PURCHASE_VALUE_DAY6]: "Valor total de compras dia 6",
  [APP_EVENT_ADD_TO_CART_RATE]: "Taxa de adicionar ao carrinho",
  [TOTAL_APP_EVENT_ADD_TO_CART]: "Eventos totais de adicionar ao carrinho",
  [COST_PER_TOTAL_APP_EVENT_ADD_TO_CART]:
    "Custo por adicionar ao carrinho total",
  [VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART]:
    "Valor por adicionar ao carrinho total",
  [TOTAL_APP_EVENT_ADD_TO_CART_VALUE]: "Valor total de adicionar ao carrinho",
  [CHECKOUT_RATE]: "Taxa de finalização de compra",
  [TOTAL_CHECKOUT]: "Finalizações de compra totais",
  [COST_PER_TOTAL_CHECKOUT]: "Custo por finalização de compra total",
  [VALUE_PER_CHECKOUT]: "Valor por finalização de compra",
  [TOTAL_CHECKOUT_VALUE]: "Valor total de finalizações de compra",
  [VIEW_CONTENT_RATE]: "Taxa de visualização de conteúdo",
  [TOTAL_VIEW_CONTENT]: "Visualizações de conteúdo totais",
  [COST_PER_TOTAL_VIEW_CONTENT]: "Custo por visualização de conteúdo total",
  [VALUE_PER_TOTAL_VIEW_CONTENT]: "Valor por visualização de conteúdo total",
  [TOTAL_VIEW_CONTENT_VALUE]: "Valor total de visualizações de conteúdo",
  [COST_PER_NEXT_DAY_OPEN]: "Custo por abertura no dia seguinte",
  [NEXT_DAY_OPEN_RATE]: "Taxa de abertura no dia seguinte",
  [TOTAL_NEXT_DAY_OPEN]: "Aberturas totais no dia seguinte",
  [COST_PER_TOTAL_NEXT_DAY_OPEN]: "Custo por abertura total no dia seguinte",
  [COST_PER_DAY7_RETENTION]: "Custo por retenção em 7 dias",
  [DAY7_RETENTION_RATE]: "Taxa de retenção em 7 dias",
  [TOTAL_DAY7_RETENTION]: "Retenção total em 7 dias",
  [COST_PER_TOTAL_DAY7_RETENTION]: "Custo por retenção total em 7 dias",
  [VALUE_PER_TOTAL_DAY7_RETENTION]: "Valor por retenção total em 7 dias",
  [TOTAL_DAY7_RETENTION_VALUE]: "Valor total de retenção em 7 dias",
  [ADD_PAYMENT_INFO]: "Adicionar informações de pagamento",
  [COST_PER_ADD_PAYMENT_INFO]: "Custo por adicionar informações de pagamento",
  [ADD_PAYMENT_INFO_RATE]: "Taxa de adicionar informações de pagamento",
  [TOTAL_ADD_PAYMENT_INFO]: "Total de adicionar informações de pagamento",
  [COST_TOTAL_ADD_PAYMENT_INFO]:
    "Custo total de adicionar informações de pagamento",
  [ADD_TO_WISHLIST]: "Adicionar à lista de desejos",
  [COST_PER_ADD_TO_WISHLIST]: "Custo por adicionar à lista de desejos",
  [ADD_TO_WISHLIST_RATE]: "Taxa de adicionar à lista de desejos",
  [TOTAL_ADD_TO_WISHLIST]: "Total de adições à lista de desejos",
  [COST_PER_TOTAL_ADD_TO_WISHLIST]:
    "Custo por total de adições à lista de desejos",
  [VALUE_PER_TOTAL_ADD_TO_WISHLIST]:
    "Valor por total de adições à lista de desejos",
  [TOTAL_ADD_TO_WISHLIST_VALUE]: "Valor total de adições à lista de desejos",
  [LAUNCH_APP]: "Abrir app",
  [COST_PER_LAUNCH_APP]: "Custo por abrir app",
  [LAUNCH_APP_RATE]: "Taxa de abertura de app",
  [TOTAL_LAUNCH_APP]: "Aberturas de app totais",
  [COST_PER_TOTAL_LAUNCH_APP]: "Custo por abertura total de app",
  [COMPLETE_TUTORIAL]: "Concluir tutorial",
  [COST_PER_COMPLETE_TUTORIAL]: "Custo por concluir tutorial",
  [COMPLETE_TUTORIAL_RATE]: "Taxa de concluir tutorial",
  [TOTAL_COMPLETE_TUTORIAL]: "Tutoriais concluídos totais",
  [COST_PER_TOTAL_COMPLETE_TUTORIAL]: "Custo por tutorial concluído total",
  [VALUE_PER_TOTAL_COMPLETE_TUTORIAL]: "Valor por tutorial concluído total",
  [TOTAL_COMPLETE_TUTORIAL_VALUE]: "Valor total de tutoriais concluídos",
  [CREATE_GROUP]: "Criar grupo",
  [COST_PER_CREATE_GROUP]: "Custo por criar grupo",
  [CREATE_GROUP_RATE]: "Taxa de criação de grupo",
  [TOTAL_CREATE_GROUP]: "Grupos criados totais",
  [COST_PER_TOTAL_CREATE_GROUP]: "Custo por criação total de grupo",
  [VALUE_PER_TOTAL_CREATE_GROUP]: "Valor por criação total de grupo",
  [TOTAL_CREATE_GROUP_VALUE]: "Valor total de grupos criados",
  [JOIN_GROUP]: "Entrar em grupo",
  [COST_PER_JOIN_GROUP]: "Custo por entrar em grupo",
  [JOIN_GROUP_RATE]: "Taxa de entrada em grupo",
  [TOTAL_JOIN_GROUP]: "Entradas em grupo totais",
  [COST_PER_TOTAL_JOIN_GROUP]: "Custo por entrada total em grupo",
  [VALUE_PER_TOTAL_JOIN_GROUP]: "Valor por entrada total em grupo",
  [TOTAL_JOIN_GROUP_VALUE]: "Valor total de entradas em grupo",
  [CREATE_GAMEROLE]: "Criar papel de jogo",
  [COST_PER_CREATE_GAMEROLE]: "Custo por criar papel de jogo",
  [CREATE_GAMEROLE_RATE]: "Taxa de criação de papel de jogo",
  [TOTAL_CREATE_GAMEROLE]: "Papéis de jogo criados totais",
  [COST_PER_TOTAL_CREATE_GAMEROLE]: "Custo por criação total de papel de jogo",
  [VALUE_PER_TOTAL_CREATE_GAMEROLE]: "Valor por criação total de papel de jogo",
  [TOTAL_CREATE_GAMEROLE_VALUE]: "Valor total de papéis de jogo criados",
  [SPEND_CREDITS]: "Gastar créditos",
  [COST_PER_SPEND_CREDITS]: "Custo por gastar créditos",
  [SPEND_CREDITS_RATE]: "Taxa de gasto de créditos",
  [TOTAL_SPEND_CREDITS]: "Créditos gastos totais",
  [COST_PER_TOTAL_SPEND_CREDITS]: "Custo por gasto total de créditos",
  [VALUE_PER_TOTAL_SPEND_CREDITS]: "Valor por gasto total de créditos",
  [TOTAL_SPEND_CREDITS_VALUE]: "Valor total de créditos gastos",
  [ACHIEVE_LEVEL]: "Alcançar nível",
  [COST_PER_ACHIEVE_LEVEL]: "Custo por alcançar nível",
  [ACHIEVE_LEVEL_RATE]: "Taxa de alcançar nível",
  [TOTAL_ACHIEVE_LEVEL]: "Níveis alcançados totais",
  [COST_PER_TOTAL_ACHIEVE_LEVEL]: "Custo por nível alcançado total",
  [VALUE_PER_TOTAL_ACHIEVE_LEVEL]: "Valor por nível alcançado total",
  [TOTAL_ACHIEVE_LEVEL_VALUE]: "Valor total de níveis alcançados",
  [UNLOCK_ACHIEVEMENT]: "Desbloquear conquista",
  [COST_PER_UNLOCK_ACHIEVEMENT]: "Custo por desbloquear conquista",
  [UNLOCK_ACHIEVEMENT_RATE]: "Taxa de desbloqueio de conquista",
  [TOTAL_UNLOCK_ACHIEVEMENT]: "Conquistas desbloqueadas totais",
  [COST_PER_TOTAL_UNLOCK_ACHIEVEMENT]: "Custo por conquista desbloqueada total",
  [VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT]:
    "Valor por conquista desbloqueada total",
  [TOTAL_UNLOCK_ACHIEVEMENT_VALUE]: "Valor total de conquistas desbloqueadas",
  [SALES_LEAD]: "Lead de vendas",
  [COST_PER_SALES_LEAD]: "Custo por lead de vendas",
  [SALES_LEAD_RATE]: "Taxa de leads de vendas",
  [TOTAL_SALES_LEAD]: "Leads de vendas totais",
  [COST_PER_TOTAL_SALES_LEAD]: "Custo por lead de vendas total",
  [VALUE_PER_TOTAL_SALES_LEAD]: "Valor por lead de vendas total",
  [TOTAL_SALES_LEAD_VALUE]: "Valor total de leads de vendas",
  [IN_APP_AD_CLICK]: "Clique em anúncio no aplicativo",
  [COST_PER_IN_APP_AD_CLICK]: "Custo por clique em anúncio no aplicativo",
  [IN_APP_AD_CLICK_RATE]: "Taxa de cliques em anúncios no aplicativo",
  [TOTAL_IN_APP_AD_CLICK]: "Total de cliques em anúncios no aplicativo",
  [COST_PER_TOTAL_IN_APP_AD_CLICK]:
    "Custo por clique total em anúncios no aplicativo",
  [VALUE_PER_TOTAL_IN_APP_AD_CLICK]:
    "Valor por clique total em anúncios no aplicativo",
  [TOTAL_IN_APP_AD_CLICK_VALUE]:
    "Valor total de cliques em anúncios no aplicativo",
  [IN_APP_AD_IMPR]: "Impressões de anúncios no aplicativo",
  [COST_PER_IN_APP_AD_IMPR]: "Custo por impressão de anúncio no aplicativo",
  [IN_APP_AD_IMPR_RATE]: "Taxa de impressões de anúncios no aplicativo",
  [TOTAL_IN_APP_AD_IMPR]: "Total de impressões de anúncios no aplicativo",
  [COST_PER_TOTAL_IN_APP_AD_IMPR]:
    "Custo por impressão total de anúncios no aplicativo",
  [VALUE_PER_TOTAL_IN_APP_AD_IMPR]:
    "Valor por impressão total de anúncios no aplicativo",
  [TOTAL_IN_APP_AD_IMPR_VALUE]:
    "Valor total de impressões de anúncios no aplicativo",
  [LOAN_APPLY]: "Solicitação de empréstimo",
  [COST_PER_LOAN_APPLY]: "Custo por solicitação de empréstimo",
  [LOAN_APPLY_RATE]: "Taxa de solicitações de empréstimo",
  [TOTAL_LOAN_APPLY]: "Total de solicitações de empréstimo",
  [COST_PER_TOTAL_LOAN_APPLY]: "Custo por total de solicitações de empréstimo",
  [LOAN_CREDIT]: "Crédito de empréstimo",
  [COST_PER_LOAN_CREDIT]: "Custo por crédito de empréstimo",
  [LOAN_CREDIT_RATE]: "Taxa de crédito de empréstimo",
  [TOTAL_LOAN_CREDIT]: "Total de créditos de empréstimo",
  [COST_PER_TOTAL_LOAN_CREDIT]: "Custo por total de créditos de empréstimo",
  [LOAN_DISBURSEMENT]: "Desembolso de empréstimo",
  [COST_PER_LOAN_DISBURSEMENT]: "Custo por desembolso de empréstimo",
  [LOAN_DISBURSEMENT_RATE]: "Taxa de desembolso de empréstimo",
  [TOTAL_LOAN_DISBURSEMENT]: "Total de desembolsos de empréstimos",
  [COST_PER_TOTAL_LOAN_DISBURSEMENT]:
    "Custo por total de desembolsos de empréstimos",
  [LOGIN]: "Entrar",
  [COST_PER_LOGIN]: "Custo por login",
  [LOGIN_RATE]: "Taxa de login",
  [TOTAL_LOGIN]: "Total de logins",
  [COST_PER_TOTAL_LOGIN]: "Custo por total de logins",
  [RATINGS]: "Avaliações",
  [GALLERY_VIEW_SCORES]: "Ver pontuações",
  [GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_TITLE]: "Sair do fluxo atual?",
  [GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_DESCRIPTION]:
    "Você sairá da tela atual e abrirá a criação da campanha com o conteúdo selecionado. É possível que alterações não salvas sejam perdidas.",
  [GALLERY_SELECTED_COUNT_SINGULAR]: "Selecionado",
  [GALLERY_SELECTED_COUNT_PLURAL]: "Selecionados",
  [GALLERY_FOLDERS_ALL]: "Todos",
  [GALLERY_FOLDERS_CREATE_TITLE]: "Criar pasta",
  [GALLERY_FOLDERS_NAME]: "Nome da pasta",
  [GALLERY_FOLDERS_DUPLICATE]: "Já existe uma pasta com este nome",
  [GALLERY_FOLDERS_CREATE_SUCCESS]: "Pasta criada",
  [GALLERY_FOLDERS_MOVE_SUCCESS]: "Conteúdo movido para a pasta selecionada",
  [GALLERY_FOLDERS_CREATE_ERROR]: "Não foi possível criar a pasta",
  [GALLERY_FOLDERS_MOVE_ERROR]: "Não foi possível mover o conteúdo",
  [GALLERY_FOLDERS_BAR_ARIA_LABEL]: "Navegação de pastas da galeria",
  [GALLERY_FOLDERS_NEW_INLINE]: "Nova pasta",
  [GALLERY_UPLOAD_FOLDER_EMPTY]:
    "A pasta não tem arquivos válidos. Formatos permitidos: {{value}}.",
  [GALLERY_FOLDERS_UNASSIGN_SUCCESS]: "Conteúdo removido da pasta",
  [GALLERY_FOLDERS_UNASSIGN_ERROR]:
    "Não foi possível remover o conteúdo da pasta",
  [GALLERY_FOLDERS_CREATE_IN]: "Criar pasta em",
  [GALLERY_FOLDERS_MOVE]: "Mover para a pasta",
  [GALLERY_FOLDERS_MOVE_TITLE]: "Mover para a pasta",
  [GALLERY_FOLDERS_MOVE_DESCRIPTION]: "Movendo de: {{folder}}",
  [GALLERY_FOLDERS_DESTINATION]: "Pasta de destino",
  [GALLERY_FOLDERS_SELECT]: "Selecionar pasta",
  [GALLERY_FOLDERS_DESTINATION_PATH]: "Será salvo em: {{path}}",
  [GALLERY_FOLDERS_RENAME_TITLE]: "Renomear pasta",
  [GALLERY_FOLDERS_RENAME_SUCCESS]: "Pasta renomeada",
  [GALLERY_FOLDERS_RENAME_ERROR]: "Não foi possível renomear a pasta",
  [GALLERY_FOLDERS_RENAME_ARIA_LABEL]: "Renomear pasta {{name}}",
  [GALLERY_FOLDERS_DELETE_ARIA_LABEL]: "Excluir Pasta {{name}}",
  [GALLERY_FOLDERS_DELETE_TITLE]: "Excluir Pasta?",
  [GALLERY_FOLDERS_DELETE_TEXT]:
    'A pasta "{{name}}" será excluída. Os itens que ela contém não serão excluídos, apenas ficarão fora da pasta.',
  [GALLERY_FOLDERS_DELETE_SUCCESS]: "Pasta Excluída",
  [GALLERY_FOLDERS_DELETE_ERROR]: "Não foi possível excluir a pasta",
  [GALLERY_FOLDERS_REMOVE_FROM_FOLDER]: "Tirar da Pasta",
  [GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TITLE]: "Tirar da Pasta?",
  [GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TEXT]:
    "Este item deixará de pertencer a esta pasta, mas não será excluído.",
  [GALLERY_FILTER_APPROVAL_STATUS]: "Status de Aprovação",
  [CAMPAIGNS_FOLDER_EMPTY]: "Não há campanhas nesta pasta",
  [CAMPAIGNS_MOVE_SELECTED]: "Mover selecionadas",
  [CAMPAIGNS_FOLDERS_MOVE]: "Mover campanhas para a pasta",
  [CAMPAIGNS_FOLDERS_MOVE_TITLE]: "Mover campanhas para a pasta",
  [CAMPAIGNS_FOLDERS_MOVE_DESCRIPTION]: "Movendo campanhas de: {{folder}}",
  [CAMPAIGNS_FOLDERS_MOVE_SUCCESS]:
    "Campanhas movidas para a pasta selecionada",
  [CAMPAIGNS_FOLDERS_MOVE_ERROR]: "Não foi possível mover as campanhas",
  [CAMPAIGNS_FOLDERS_UNASSIGN_SUCCESS]: "Campanhas removidas da pasta",
  [CAMPAIGNS_FOLDERS_UNASSIGN_ERROR]:
    "Não foi possível remover as campanhas da pasta",
  [CAMPAIGNS_SELECT_ROW]: "Selecionar campanha",
  [COST_PER_RATINGS]: "Custo por avaliação",
  [RATINGS_RATE]: "Taxa de avaliações",
  [TOTAL_RATINGS]: "Total de avaliações",
  [COST_PER_TOTAL_RATINGS]: "Custo por total de avaliações",
  [VALUE_PER_TOTAL_RATINGS]: "Valor por total de avaliações",
  [TOTAL_RATINGS_VALUE]: "Valor total de avaliações",
  [SEARCH_TIKTOK]: "Buscar",
  [COST_PER_SEARCH]: "Custo por busca",
  [SEARCH_RATE]: "Taxa de buscas",
  [TOTAL_SEARCH]: "Total de buscas",
  [COST_PER_TOTAL_SEARCH]: "Custo por total de buscas",
  [START_TRIAL]: "Iniciar teste",
  [COST_PER_START_TRIAL]: "Custo por início de teste",
  [START_TRIAL_RATE]: "Taxa de início de teste",
  [TOTAL_START_TRIAL]: "Total de inícios de teste",
  [COST_PER_TOTAL_START_TRIAL]: "Custo por total de inícios de teste",
  [SUBSCRIBE]: "Assinar",
  [COST_PER_SUBSCRIBE]: "Custo por assinatura",
  [SUBSCRIBE_RATE]: "Taxa de assinaturas",
  [TOTAL_SUBSCRIBE]: "Total de assinaturas",
  [COST_PER_TOTAL_SUBSCRIBE]: "Custo por total de assinaturas",
  [VALUE_PER_TOTAL_SUBSCRIBE]: "Valor por total de assinaturas",
  [TOTAL_SUBSCRIBE_VALUE]: "Valor total de assinaturas",
  [UNIQUE_CUSTOM_APP_EVENTS]: "Eventos personalizados únicos do aplicativo",
  [COST_PER_UNIQUE_CUSTOM_APP_EVENT]:
    "Custo por evento personalizado único do aplicativo",
  [CUSTOM_APP_EVENT_RATE]: "Taxa de eventos personalizados do aplicativo",
  [CUSTOM_APP_EVENTS]: "Eventos personalizados do aplicativo",
  [COST_PER_CUSTOM_APP_EVENT]: "Custo por evento personalizado do aplicativo",
  [VALUE_PER_CUSTOM_APP_EVENT]: "Valor por evento personalizado do aplicativo",
  [CUSTOM_APP_EVENTS_VALUE]: "Valor dos eventos personalizados do aplicativo",
  [UNIQUE_AD_IMPRESSION_EVENTS]: "Eventos únicos de impressão de anúncio",
  [COST_PER_UNIQUE_AD_IMPRESSION_EVENT]:
    "Custo por evento único de impressão de anúncio",
  [CUSTOMIZED_AD_IMPRESSION_EVENT_RATE]:
    "Taxa personalizada de eventos de impressão de anúncio",
  [ADS_IMPRESSION_EVENTS]: "Eventos de impressão de anúncios",
  [COST_PRE_AD_IMPRESSION_EVENT]: "Custo por evento de impressão de anúncio",
  [VALUE_PER_AD_IMPRESSION_EVENT]: "Valor por evento de impressão de anúncio",
  [TOTAL_AD_IMPRESSION_EVENTS_VALUE]:
    "Valor total de eventos de impressão de anúncio",
  [TOTAL_AD_IMPRESSION_ROAS]: "ROAS total de impressão de anúncio",
  [AD_IMPRESSION_AD_REVENUE_ROAS_DAY0]:
    "ROAS de receita de anúncios por impressão — Dia 0",
  [AD_IMPRESSION_AD_REVENUE_ROAS_DAY2]:
    "ROAS de receita de anúncios por impressão — Dia 2",
  [AD_IMPRESSION_AD_REVENUE_ROAS_DAY6]:
    "ROAS de receita de anúncios por impressão — Dia 6",
  [AD_IMPRESSION_AD_REVENUE_DAY0]: "Receita de anúncios por impressão — Dia 0",
  [AD_IMPRESSION_AD_REVENUE_DAY2]: "Receita de anúncios por impressão — Dia 2",
  [AD_IMPRESSION_AD_REVENUE_DAY6]: "Receita de anúncios por impressão — Dia 6",
  [COMPLETE_PAYMENT_ROAS]: "ROAS de pagamento concluído",
  [COMPLETE_PAYMENT]: "Pagamento concluído",
  [COST_PER_COMPLETE_PAYMENT]: "Custo por pagamento concluído",
  [COMPLETE_PAYMENT_RATE]: "Taxa de pagamentos concluídos",
  [VALUE_PER_COMPLETE_PAYMENT]: "Valor por pagamento concluído",
  [TOTAL_COMPLETE_PAYMENT_RATE]: "Taxa total de pagamentos concluídos",
  [TOTAL_LANDING_PAGE_VIEW]: "Total de visualizações da página de destino",
  [COST_PER_LANDING_PAGE_VIEW]: "Custo por visualização da página de destino",
  [LANDING_PAGE_VIEW_RATE]: "Taxa de visualizações da página de destino",
  [TOTAL_PAGEVIEW]: "Total de visualizações de página",
  [COST_PER_PAGEVIEW]: "Custo por visualização de página",
  [PAGEVIEW_RATE]: "Taxa de visualizações de página",
  [AVG_VALUE_PER_PAGEVIEW]: "Valor médio por visualização de página",
  [TOTAL_VALUE_PER_PAGEVIEW]: "Valor total por visualização de página",
  [PAGE_BROWSE_VIEW]: "Visualização de navegação da página",
  [COST_PER_PAGE_BROWSE_VIEW]: "Custo por visualização de navegação da página",
  [PAGE_BROWSE_VIEW_RATE]: "Taxa de visualizações de navegação da página",
  [TOTAL_PAGE_BROWSE_VIEW_VALUE]:
    "Valor total de visualizações de navegação da página",
  [VALUE_PER_PAGE_BROWSE_VIEW]: "Valor por visualização de navegação da página",
  [BUTTON_CLICK]: "Clique no botão",
  [COST_PER_BUTTON_CLICK]: "Custo por clique no botão",
  [BUTTON_CLICK_RATE]: "Taxa de cliques no botão",
  [VALUE_PER_BUTTON_CLICK]: "Valor por clique no botão",
  [TOTAL_BUTTON_CLICK_VALUE]: "Valor total de cliques no botão",
  [ONLINE_CONSULT]: "Consulta online",
  [COST_PER_ONLINE_CONSULT]: "Custo por consulta online",
  [ONLINE_CONSULT_RATE]: "Taxa de consultas online",
  [VALUE_PER_ONLINE_CONSULT]: "Valor por consulta online",
  [TOTAL_ONLINE_CONSULT_VALUE]: "Valor total de consultas online",
  [USER_REGISTRATION]: "Cadastro de usuário",
  [COST_PER_USER_REGISTRATION]: "Custo por cadastro de usuário",
  [USER_REGISTRATION_RATE]: "Taxa de cadastros de usuários",
  [VALUE_PER_USER_REGISTRATION]: "Valor por cadastro de usuário",
  [TOTAL_USER_REGISTRATION_VALUE]: "Valor total de cadastros de usuários",
  [PAGE_CONTENT_VIEW_EVENTS]: "Eventos de visualização de conteúdo da página",
  [COST_PER_PAGE_CONTENT_VIEW_EVENT]:
    "Custo por evento de visualização de conteúdo da página",
  [PAGE_CONTENT_VIEW_EVENT_RATE]:
    "Taxa de eventos de visualização de conteúdo da página",
  [VALUE_PER_PAGE_CONTENT_VIEW_EVENT]:
    "Valor por visualização de conteúdo da página",
  [TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE]:
    "Valor total de visualizações de conteúdo da página",
  [PRODUCT_DETAILS_PAGE_BROWSE]: "Navegação na página de detalhes do produto",
  [COST_PER_PRODUCT_DETAILS_PAGE_BROWSE]:
    "Custo por navegação na página de detalhes do produto",
  [PRODUCT_DETAILS_PAGE_BROWSE_RATE]:
    "Taxa de navegação na página de detalhes do produto",
  [VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE]:
    "Valor por navegação na página de detalhes do produto",
  [TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE]:
    "Valor total de navegação na página de detalhes do produto",
  [WEB_EVENT_ADD_TO_CART]: "Evento web de adicionar ao carrinho",
  [COST_PER_WEB_EVENT_ADD_TO_CART]:
    "Custo por evento web de adicionar ao carrinho",
  [WEB_EVENT_ADD_TO_CART_RATE]: "Taxa de eventos web de adicionar ao carrinho",
  [VALUE_PER_WEB_EVENT_ADD_TO_CART]:
    "Valor por evento web de adicionar ao carrinho",
  [TOTAL_WEB_EVENT_ADD_TO_CART_VALUE]:
    "Valor total de eventos web de adicionar ao carrinho",
  [ON_WEB_ORDER]: "Pedido no site",
  [COST_PER_ON_WEB_ORDER]: "Custo por pedido no site",
  [ON_WEB_ORDER_RATE]: "Taxa de pedidos no site",
  [VALUE_PER_ON_WEB_ORDER]: "Valor por pedido no site",
  [TOTAL_ON_WEB_ORDER_VALUE]: "Valor total de pedidos no site",
  [INITIATE_CHECKOUT]: "Iniciar checkout",
  [COST_PER_INITIATE_CHECKOUT]: "Custo por início de checkout",
  [INITIATE_CHECKOUT_RATE]: "Taxa de início de checkout",
  [VALUE_PER_INITIATE_CHECKOUT]: "Valor por início de checkout",
  [TOTAL_INITIATE_CHECKOUT_VALUE]: "Valor total de inícios de checkout",
  [ADD_BILLING]: "Adicionar dados de faturamento",
  [COST_PER_ADD_BILLING]: "Custo por adicionar dados de faturamento",
  [ADD_BILLING_RATE]: "Taxa de adição de dados de faturamento",
  [VALUE_PER_ADD_BILLING]: "Valor por adição de dados de faturamento",
  [TOTAL_ADD_BILLING_VALUE]: "Valor total de adições de dados de faturamento",
  [PAGE_EVENT_SEARCH]: "Evento de busca na página",
  [COST_PER_PAGE_EVENT_SEARCH]: "Custo por evento de busca na página",
  [PAGE_EVENT_SEARCH_RATE]: "Taxa de eventos de busca na página",
  [VALUE_PER_PAGE_EVENT_SEARCH]: "Valor por evento de busca na página",
  [TOTAL_PAGE_EVENT_SEARCH_VALUE]: "Valor total de eventos de busca na página",
  [FORM_TIKTOK]: "Formulário",
  [COST_PER_FORM]: "Custo por formulário",
  [FORM_RATE]: "Taxa de formulários",
  [VALUE_PER_FORM]: "Valor por formulário",
  [TOTAL_FORM_VALUE]: "Valor total de formulários",
  [DOWNLOAD_START]: "Início do download",
  [COST_PER_DOWNLOAD_START]: "Custo por início do download",
  [DOWNLOAD_START_RATE]: "Taxa de início do download",
  [VALUE_PER_DOWNLOAD_START]: "Valor por início do download",
  [TOTAL_DOWNLOAD_START_VALUE]: "Valor total de inícios de download",
  [ON_WEB_ADD_TO_WISHLIST]: "Adicionar à lista de desejos no site",
  [COST_PER_ON_WEB_ADD_TO_WISHLIST]:
    "Custo por adição à lista de desejos no site",
  [ON_WEB_ADD_TO_WISHLIST_PER_CLICK]:
    "Adições à lista de desejos no site por clique",
  [VALUE_PER_ON_WEB_ADD_TO_WISHLIST]:
    "Valor por adição à lista de desejos no site",
  [TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE]:
    "Valor total de adições à lista de desejos no site",
  [ON_WEB_SUBSCRIBE]: "Assinatura no site",
  [COST_PER_ON_WEB_SUBSCRIBE]: "Custo por assinatura no site",
  [ON_WEB_SUBSCRIBE_PER_CLICK]: "Assinaturas no site por clique",
  [VALUE_PER_ON_WEB_SUBSCRIBE]: "Valor por assinatura no site",
  [TOTAL_ON_WEB_SUBSCRIBE_VALUE]: "Valor total de assinaturas no site",
  [WEBSITE_TOTAL_FIND_LOCATION]: "Total de localizações encontradas no site",
  [WEBSITE_COST_PER_FIND_LOCATION]: "Custo por localização encontrada no site",
  [WEBSITE_FIND_LOCATION_RATE]: "Taxa de localizações encontradas no site",
  [WEBSITE_VALUE_PER_FIND_LOCATION]: "Valor por localização encontrada no site",
  [WEBSITE_TOTAL_FIND_LOCATION_VALUE]:
    "Valor total de localizações encontradas no site",
  [WEBSITE_TOTAL_SCHEDULE]: "Total de agendamentos no site",
  [WEBSITE_COST_PER_SCHEDULE]: "Custo por agendamento no site",
  [WEBSITE_SCHEDULE_RATE]: "Taxa de agendamentos no site",
  [WEBSITE_VALUE_PER_SCHEDULE]: "Valor por agendamento no site",
  [WEBSITE_TOTAL_SCHEDULE_VALUE]: "Valor total de agendamentos no site",
  [WEBSITE_TOTAL_CUSTOMIZE_PRODUCT]:
    "Total de personalizações de produto no site",
  [WEBSITE_COST_PER_CUSTOMIZE_PRODUCT]:
    "Custo por personalização de produto no site",
  [WEBSITE_CUSTOMIZE_PRODUCT_RATE]: "Taxa de personalização de produto no site",
  [WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT]:
    "Valor por personalização de produto no site",
  [WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE]:
    "Valor total de personalizações de produto no site",
  [CUSTOM_PAGE_EVENTS]: "Eventos personalizados da página",
  [COST_PER_CUSTOM_PAGE_EVENT]: "Custo por evento personalizado da página",
  [CUSTOM_PAGE_EVENT_RATE]: "Taxa de eventos personalizados da página",
  [VALUE_PER_CUSTOM_PAGE_EVENT]: "Valor por evento personalizado da página",
  [CUSTOM_PAGE_EVENTS_VALUE]: "Valor dos eventos personalizados da página",
  [ONSITE_PURCHASES_ROAS]: "ROAS de compras no site",
  [ONSITE_TOTAL_PURCHASE]: "Total de compras no site",
  [ONSITE_COST_PER_PURCHASE]: "Custo por compra no site",
  [ONSITE_PURCHASE_RATE]: "Taxa de compras no site",
  [ONSITE_VALUE_PER_PURCHASE]: "Valor por compra no site",
  [ONSITE_TOTAL_PURCHASE_VALUE]: "Valor total de compras no site",
  [ONSITE_TOTAL_CHECKOUT_INITIATION]: "Total de inícios de checkout no site",
  [ONSITE_COST_PER_CHECKOUT_INITIATION]: "Custo por início de checkout no site",
  [ONSITE_CHECKOUT_INITIATION_RATE]: "Taxa de início de checkout no site",
  [ONSITE_VALUE_PER_CHECKOUT_INITIATION]:
    "Valor por início de checkout no site",
  [ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE]:
    "Valor total de inícios de checkout no site",
  [ONSITE_TOTAL_ADD_TO_CART]: "Total de adições ao carrinho no site",
  [ONSITE_COST_PER_ADD_TO_CART]: "Custo por adição ao carrinho no site",

  [ONSITE_ADD_TO_CART_RATE]: "Taxa de adicionar ao carrinho no site",
  [ONSITE_VALUE_PER_ADD_TO_CART]: "Valor por adicionar ao carrinho no site",
  [ONSITE_TOTAL_ADD_TO_CART_VALUE]:
    "Valor total de adições ao carrinho no site",
  [ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW]:
    "Visualizações totais de detalhes do produto no site",
  [ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW]:
    "Custo por visualização de detalhes do produto no site",
  [ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE]:
    "Taxa de visualizações de detalhes do produto no site",
  [ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW]:
    "Valor por visualização de detalhes do produto no site",
  [ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE]:
    "Valor total de visualizações de detalhes do produto no site",
  [ONSITE_ADD_TO_WISHLIST]: "Adicionar à lista de desejos no site",
  [COST_PER_ONSITE_ADD_TO_WISHLIST]:
    "Custo por adicionar à lista de desejos no site",
  [ONSITE_ADD_TO_WISHLIST_RATE]: "Taxa de adicionar à lista de desejos no site",
  [VALUE_PER_ONSITE_ADD_TO_WISHLIST]:
    "Valor por adicionar à lista de desejos no site",
  [TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE]:
    "Valor total de adições à lista de desejos no site",
  [ONSITE_ADD_BILLING]: "Adicionar dados de faturamento no site",
  [COST_PER_ONSITE_ADD_BILLING]:
    "Custo por adicionar dados de faturamento no site",
  [ONSITE_ADD_BILLING_RATE]: "Taxa de adicionar dados de faturamento no site",
  [VALUE_PER_ONSITE_ADD_BILLING]:
    "Valor por adicionar dados de faturamento no site",
  [TOTAL_ONSITE_ADD_BILLING_VALUE]:
    "Valor total de adicionar dados de faturamento no site",
  [ONSITE_FORM]: "Formulário no site",
  [COST_PER_ONSITE_FORM]: "Custo por formulário no site",
  [ONSITE_FORM_RATE]: "Taxa de formulários no site",
  [VALUE_PER_ONSITE_FORM]: "Valor por formulário no site",
  [TOTAL_ONSITE_FORM_VALUE]: "Valor total de formulários no site",
  [ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION]:
    "Envios de formulário filtrados totais no site",
  [ONSITE_DOWNLOAD_START]: "Início de download no site",
  [COST_PER_ONSITE_DOWNLOAD_START]: "Custo por início de download no site",
  [ONSITE_DOWNLOAD_START_RATE]: "Taxa de inícios de download no site",
  [ONSITE_DESTINATION_VISITS]: "Visitas ao destino no site",
  [COST_PER_ONSITE_DESTINATION_VISIT]: "Custo por visita ao destino no site",
  [ONSITE_DESTINATION_VISIT_RATE]: "Taxa de visitas ao destino no site",
  [IX_PAGE_VIEW_COUNT]: "Contagem de visualizações de página IX",
  [COST_PER_IX_PAGE_VIEW_COUNT]:
    "Custo por contagem de visualizações de página IX",
  [IX_PAGE_VIEW_COUNT_RATE]: "Taxa de contagem de visualizações de página IX",
  [IX_BUTTON_CLICK_COUNT]: "Contagem de cliques no botão IX",
  [COST_PER_IX_BUTTON_CLICK_COUNT]: "Custo por contagem de cliques no botão IX",
  [IX_BUTTON_CLICK_COUNT_RATE]: "Taxa de contagem de cliques no botão IX",
  [IX_PRODUCT_CLICK_COUNT]: "Contagem de cliques no produto IX",
  [COST_PER_IX_PRODUCT_CLICK_COUNT]:
    "Custo por contagem de cliques no produto IX",
  [IX_PRODUCT_CLICK_COUNT_RATE]: "Taxa de contagem de cliques no produto IX",
  [OFFLINE_TOTAL_CRM_EVENTS]: "Eventos de CRM totais offline",
  [OFFLINE_COST_PER_CRM_EVENT]: "Custo por evento de CRM offline",
  [OFFLINE_CRM_EVENT_RATE]: "Taxa de eventos de CRM offline",
  [OFFLINE_VALUE_PER_CRM_EVENT]: "Valor por evento de CRM offline",
  [OFFLINE_CRM_EVENT_VALUE]: "Valor de eventos de CRM offline",
  [OFFLINE_SHOPPING_EVENTS]: "Eventos de compra offline",
  [COST_PER_OFFLINE_SHOPPING_EVENT]: "Custo por evento de compra offline",
  [OFFLINE_SHOPPING_EVENT_RATE]: "Taxa de eventos de compra offline",
  [VALUE_PER_OFFLINE_SHOPPING_EVENT]: "Valor por evento de compra offline",
  [OFFLINE_SHOPPING_EVENTS_VALUE]: "Valor de eventos de compra offline",
  [OFFLINE_SHOPPING_EVENTS_ROAS]: "ROAS de eventos de compra offline",
  [OFFLINE_CONTACT_EVENTS]: "Eventos de contato offline",
  [COST_PER_OFFLINE_CONTACT_EVENT]: "Custo por evento de contato offline",
  [OFFLINE_CONTACT_EVENT_RATE]: "Taxa de eventos de contato offline",
  [VALUE_PER_OFFLINE_CONTACT_EVENT]: "Valor por evento de contato offline",
  [OFFLINE_CONTACT_EVENTS_VALUE]: "Valor de eventos de contato offline",
  [OFFLINE_SUBSCRIBE_EVENTS]: "Eventos de assinatura offline",
  [COST_PER_OFFLINE_SUBSCRIBE_EVENT]: "Custo por evento de assinatura offline",
  [OFFLINE_SUBSCRIBE_EVENT_RATE]: "Taxa de eventos de assinatura offline",
  [VALUE_PER_OFFLINE_SUBSCRIBE_EVENT]: "Valor por evento de assinatura offline",
  [OFFLINE_SUBSCRIBE_EVENTS_VALUE]: "Valor de eventos de assinatura offline",
  [OFFLINE_FORM_EVENTS]: "Eventos de formulário offline",
  [COST_PER_OFFLINE_FORM_EVENT]: "Custo por evento de formulário offline",
  [OFFLINE_FORM_EVENT_RATE]: "Taxa de eventos de formulário offline",
  [VALUE_PER_OFFLINE_FORM_EVENT]: "Valor por evento de formulário offline",
  [OFFLINE_FORM_EVENTS_VALUE]: "Valor de eventos de formulário offline",
  [OFFLINE_ADD_PAYMENT_INFO_EVENTS]:
    "Eventos de adicionar dados de pagamento offline",
  [COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT]:
    "Custo por evento de adicionar dados de pagamento offline",
  [OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE]:
    "Taxa de eventos de adicionar dados de pagamento offline",
  [VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT]:
    "Valor por evento de adicionar dados de pagamento offline",
  [OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE]:
    "Valor de eventos de adicionar dados de pagamento offline",
  [OFFLINE_ADD_TO_CART_EVENTS]: "Eventos de adicionar ao carrinho offline",
  [COST_PER_OFFLINE_ADD_TO_CART_EVENT]:
    "Custo por evento de adicionar ao carrinho offline",
  [OFFLINE_ADD_TO_CART_EVENT_RATE]:
    "Taxa de eventos de adicionar ao carrinho offline",
  [VALUE_PER_OFFLINE_ADD_TO_CART_EVENT]:
    "Valor por evento de adicionar ao carrinho offline",
  [OFFLINE_ADD_TO_CART_EVENTS_VALUE]:
    "Valor de eventos de adicionar ao carrinho offline",
  [OFFLINE_ADD_TO_WISHLIST_EVENTS]:
    "Eventos de adicionar à lista de desejos offline",
  [COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT]:
    "Custo por evento de adicionar à lista de desejos offline",
  [OFFLINE_ADD_TO_WISHLIST_EVENT_RATE]:
    "Taxa de eventos de adicionar à lista de desejos offline",
  [VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT]:
    "Valor por evento de adicionar à lista de desejos offline",
  [OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE]:
    "Valor de eventos de adicionar à lista de desejos offline",
  [OFFLINE_CLICK_BUTTON_EVENTS]: "Eventos de clique no botão offline",
  [COST_PER_OFFLINE_CLICK_BUTTON_EVENT]:
    "Custo por evento de clique no botão offline",
  [OFFLINE_CLICK_BUTTON_EVENT_RATE]:
    "Taxa de eventos de clique no botão offline",
  [VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT]:
    "Valor por evento de clique no botão offline",
  [OFFLINE_CLICK_BUTTON_EVENTS_VALUE]:
    "Valor de eventos de clique no botão offline",
  [OFFLINE_COMPLETE_REGISTRATION_EVENTS]:
    "Eventos de cadastro completo offline",
  [COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT]:
    "Custo por evento de cadastro completo offline",
  [OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE]:
    "Taxa de eventos de cadastro completo offline",
  [VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT]:
    "Valor por evento de cadastro completo offline",
  [OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE]:
    "Valor de eventos de cadastro completo offline",
  [OFFLINE_DOWNLOAD_EVENTS]: "Eventos de download offline",
  [COST_PER_OFFLINE_DOWNLOAD_EVENT]: "Custo por evento de download offline",
  [OFFLINE_DOWNLOAD_EVENT_RATE]: "Taxa de eventos de download offline",
  [VALUE_PER_OFFLINE_DOWNLOAD_EVENT]: "Valor por evento de download offline",
  [OFFLINE_DOWNLOAD_EVENTS_VALUE]: "Valor de eventos de download offline",
  [OFFLINE_INITIATE_CHECKOUT_EVENTS]: "Eventos de início de pagamento offline",
  [COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT]:
    "Custo por evento de início de pagamento offline",
  [OFFLINE_INITIATE_CHECKOUT_EVENT_RATE]:
    "Taxa de eventos de início de pagamento offline",
  [VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT]:
    "Valor por evento de início de pagamento offline",
  [OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE]:
    "Valor de eventos de início de pagamento offline",
  [OFFLINE_PLACE_ORDER_EVENTS]: "Eventos de realizar pedido offline",
  [COST_PER_OFFLINE_PLACE_ORDER_EVENT]:
    "Custo por evento de realizar pedido offline",
  [OFFLINE_PLACE_ORDER_EVENT_RATE]:
    "Taxa de eventos de realizar pedido offline",
  [VALUE_PER_OFFLINE_PLACE_ORDER_EVENT]:
    "Valor por evento de realizar pedido offline",
  [OFFLINE_PLACE_ORDER_EVENTS_VALUE]:
    "Valor de eventos de realizar pedido offline",
  [OFFLINE_SEARCH_EVENTS]: "Eventos de busca offline",
  [COST_PER_OFFLINE_SEARCH_EVENT]: "Custo por evento de busca offline",
  [OFFLINE_SEARCH_EVENT_RATE]: "Taxa de eventos de busca offline",
  [VALUE_PER_OFFLINE_SEARCH_EVENT]: "Valor por evento de busca offline",
  [OFFLINE_SEARCH_EVENTS_VALUE]: "Valor de eventos de busca offline",
  [OFFLINE_VIEW_CONTENT_EVENTS]: "Eventos de ver conteúdo offline",
  [COST_PER_OFFLINE_VIEW_CONTENT_EVENT]:
    "Custo por evento de ver conteúdo offline",
  [OFFLINE_VIEW_CONTENT_EVENT_RATE]: "Taxa de eventos de ver conteúdo offline",
  [VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT]:
    "Valor por evento de ver conteúdo offline",
  [OFFLINE_VIEW_CONTENT_EVENTS_VALUE]:
    "Valor de eventos de ver conteúdo offline",
  [OFFLINE_PREFERRED_LEADS]: "Leads preferidos offline",
  [OFFLINE_COST_PER_PREFERRED_LEAD]: "Custo por lead preferido offline",
  [OFFLINE_PREFERRED_LEAD_RATE]: "Taxa de leads preferidos offline",
  [OFFLINE_TOTAL_FIND_LOCATION]: "Localizações encontradas totais offline",
  [OFFLINE_COST_PER_FIND_LOCATION]: "Custo por localização encontrada offline",
  [OFFLINE_FIND_LOCATION_RATE]: "Taxa de localizações encontradas offline",
  [OFFLINE_VALUE_PER_FIND_LOCATION]: "Valor por localização encontrada offline",
  [OFFLINE_TOTAL_FIND_LOCATION_VALUE]:
    "Valor total de localizações encontradas offline",
  [OFFLINE_TOTAL_SCHEDULE]: "Agendamentos totais offline",
  [OFFLINE_COST_PER_SCHEDULE]: "Custo por agendamento offline",
  [OFFLINE_SCHEDULE_RATE]: "Taxa de agendamentos offline",
  [OFFLINE_VALUE_PER_SCHEDULE]: "Valor por agendamento offline",
  [OFFLINE_TOTAL_SCHEDULE_VALUE]: "Valor total de agendamentos offline",
  [OFFLINE_TOTAL_CUSTOMIZE_PRODUCT]: "Produtos personalizados totais offline",
  [OFFLINE_COST_PER_CUSTOMIZE_PRODUCT]:
    "Custo por produto personalizado offline",
  [OFFLINE_CUSTOMIZE_PRODUCT_RATE]:
    "Taxa de personalização de produtos offline",
  [OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT]:
    "Valor por produto personalizado offline",
  [OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE]:
    "Valor total de produtos personalizados offline",
  [OFFLINE_TOTAL_CUSTOM_EVENTS]: "Eventos personalizados totais offline",
  [OFFLINE_COST_PER_CUSTOM_EVENT]: "Custo por evento personalizado offline",
  [OFFLINE_CUSTOM_EVENT_RATE]: "Taxa de eventos personalizados offline",
  [OFFLINE_VALUE_PER_CUSTOM_EVENT]: "Valor por evento personalizado offline",
  [OFFLINE_TOTAL_CUSTOM_EVENT_VALUE]:
    "Valor total de eventos personalizados offline",
  [MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE]:
    "Conversas totais por mensagem direta do TikTok",
  [MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE]:
    "Custo por conversa por mensagem direta do TikTok",
  [MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE]:
    "Taxa de conversa por mensagem direta do TikTok",
  [MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP]:
    "Conversas totais por app de mensagem instantânea",
  [MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP]:
    "Custo por conversa por app de mensagem instantânea",
  [MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP]:
    "Taxa de conversa por app de mensagem instantânea",
  [ONSITE_SHOPPING_ROAS]: "ROAS de compras no site",
  [ONSITE_SHOPPING]: "Compra no site",
  [COST_PER_ONSITE_SHOPPING]: "Custo por compra no site",
  [ONSITE_SHOPPING_RATE]: "Taxa de compras no site",
  [VALUE_PER_ONSITE_SHOPPING]: "Valor por compra no site",
  [TOTAL_ONSITE_SHOPPING_VALUE]: "Valor total de compras no site",
  [SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION]:
    "Compras totais por envio de pedido na loja",
  [SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION]:
    "Receita bruta por envio de pedido na loja",
  [SHOP_TOTAL_ITEMS_PURCHASED]: "Itens totais comprados na loja",
  [OFFLINE_TOTAL_CUSTOMIZE_PRODUCT]:
    "Total de personalizações de produto offline",
  [OFFLINE_COST_PER_CUSTOMIZE_PRODUCT]:
    "Custo por Personalização de Produto Offline",
  [OFFLINE_CUSTOMIZE_PRODUCT_RATE]:
    "Taxa de Personalizações de Produto Offline",
  [OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT]:
    "Valor por Personalização de Produto Offline",
  [ONSITE_INITIATE_CHECKOUT_COUNT]: "Contagem de inícios de pagamento no site",
  [COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT]:
    "Custo por contagem de inícios de pagamento no site",
  [ONSITE_INITIATE_CHECKOUT_COUNT_RATE]:
    "Taxa de contagem de inícios de pagamento no site",
  [VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT]:
    "Valor por contagem de inícios de pagamento no site",
  [TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE]:
    "Valor total da contagem de inícios de pagamento no site",
  [ONSITE_ON_WEB_DETAIL]: "Detalhes na web no site",
  [COST_PER_ONSITE_ON_WEB_DETAIL]: "Custo por detalhe na web no site",
  [ONSITE_ON_WEB_DETAIL_RATE]: "Taxa de detalhes na web no site",
  [VALUE_PER_ONSITE_ON_WEB_DETAIL]: "Valor por detalhe na web no site",
  [TOTAL_ONSITE_ON_WEB_DETAIL_VALUE]: "Valor total de detalhes na web no site",
  [ONSITE_ON_WEB_CART]: "Carrinho na web no site",
  [COST_PER_ONSITE_ON_WEB_CART]: "Custo por carrinho na web no site",
  [ONSITE_ON_WEB_CART_RATE]: "Taxa de carrinhos na web no site",
  [VALUE_PER_ONSITE_ON_WEB_CART]: "Valor por carrinho na web no site",
  [TOTAL_ONSITE_ON_WEB_CART_VALUE]: "Valor total de carrinhos na web no site",
  [VTA_CONVERSION]: "Conversão VTA",
  [COST_PER_VTA_CONVERSION]: "Custo por conversão VTA",
  [CTA_CONVERSION]: "Conversão CTA",
  [COST_PER_CTA_CONVERSION]: "Custo por conversão CTA",
  [ENGAGED_VIEW_THROUGH_CONVERSIONS]: "Conversões por visualização engajada",
  [COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION]:
    "Custo por conversão por visualização engajada",
  [VTA_APP_INSTALL]: "Instalação de app VTA",
  [COST_PER_VTA_APP_INSTALL]: "Custo por instalação de app VTA",
  [CTA_APP_INSTALL]: "Instalação de app CTA",
  [COST_PER_CTA_APP_INSTALL]: "Custo por instalação de app CTA",
  [EVTA_APP_INSTALL]: "Instalação de app EVTA",
  [COST_PER_EVTA_APP_INSTALL]: "Custo por instalação de app EVTA",
  [VTA_REGISTRATION]: "Cadastro VTA",
  [COST_PER_VTA_REGISTRATION]: "Custo por cadastro VTA",
  [CTA_REGISTRATION]: "Cadastro CTA",
  [COST_PER_CTA_REGISTRATION]: "Custo por cadastro CTA",
  [EVTA_REGISTRATION]: "Cadastro EVTA",
  [COST_PER_EVTA_REGISTRATION]: "Custo por cadastro EVTA",
  [VTA_PURCHASE]: "Compra VTA",
  [COST_PER_VTA_PURCHASE]: "Custo por compra VTA",
  [CTA_PURCHASE]: "Compra CTA",
  [COST_PER_CTA_PURCHASE]: "Custo por compra CTA",
  [EVTA_PURCHASE]: "Compra EVTA",
  [COST_PER_EVTA_PURCHASE]: "Custo por compra EVTA",
  [VTA_COMPLETE_PAYMENT]: "Pagamento concluído VTA",
  [COST_PER_VTA_PAYMENTS_COMPLETED]: "Custo por pagamentos concluídos VTA",
  [EVTA_PAYMENTS_COMPLETED]: "Pagamentos concluídos EVTA",
  [COST_PER_EVTA_PAYMENTS_COMPLETED]: "Custo por pagamentos concluídos EVTA",
  [VTA_COMPLETE_PAYMENT_VALUE]: "Valor do pagamento concluído VTA",
  [VTA_COMPLETE_PAYMENT_ROAS]: "ROAS do pagamento concluído VTA",

  [SKAN_RESULT]: "Resultado SKAN",
  [SKAN_COST_PER_RESULT]: "Custo por resultado SKAN",
  [SKAN_RESULT_RATE]: "Taxa de resultados SKAN",
  [SKAN_CONVERSION]: "Conversão SKAN",
  [SKAN_COST_PER_CONVERSION]: "Custo por conversão SKAN",
  [SKAN_CONVERSION_RATE]: "Taxa de conversão SKAN",
  [SKAN_CONVERSION_RATE_V2]: "Taxa de conversão SKAN V2",
  [SKAN_CLICK_TIME_CONVERSION]: "Conversão no momento do clique SKAN",
  [SKAN_CLICK_TIME_COST_PER_CONVERSION]:
    "Custo por conversão no momento do clique SKAN",
  [SKAN_CLICK_TIME_CONVERSION_RATE]:
    "Taxa de conversão no momento do clique SKAN",
  [SKAN_CLICK_TIME_CONVERSION_RATE_V2]:
    "Taxa de conversão no momento do clique SKAN V2",
  [SKAN_APP_INSTALL]: "Instalação de app SKAN",
  [SKAN_COST_PER_APP_INSTALL]: "Custo por instalação de app SKAN",
  [SKAN_APP_INSTALL_WITHHELD]: "Instalação de app SKAN retida",
  [SKAN_REGISTRATION]: "Cadastro SKAN",
  [SKAN_COST_PER_REGISTRATION]: "Custo por cadastro SKAN",
  [SKAN_REGISTRATION_RATE]: "Taxa de cadastros SKAN",
  [SKAN_TOTAL_REGISTRATION]: "Cadastros totais SKAN",
  [SKAN_COST_PER_TOTAL_REGISTRATION]: "Custo por cadastro total SKAN",
  [SKAN_PURCHASE]: "Compra SKAN",
  [SKAN_COST_PER_PURCHASE]: "Custo por compra SKAN",
  [SKAN_PURCHASE_RATE]: "Taxa de compras SKAN",
  [SKAN_TOTAL_PURCHASE]: "Compras totais SKAN",
  [SKAN_COST_PER_TOTAL_PURCHASE]: "Custo por compra total SKAN",
  [SKAN_TOTAL_PURCHASE_VALUE]: "Valor total de compras SKAN",
  [SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS]:
    "ROAS de pagamento ativo repetido total SKAN",
  [SKAN_ADD_TO_CART]: "Adicionar ao carrinho SKAN",
  [SKAN_COST_PER_ADD_TO_CART]: "Custo por adicionar ao carrinho SKAN",
  [SKAN_ADD_TO_CART_RATE]: "Taxa de adicionar ao carrinho SKAN",
  [SKAN_TOTAL_ADD_TO_CART]: "Adições totais ao carrinho SKAN",
  [SKAN_COST_PER_TOTAL_ADD_TO_CART]: "Custo por adição total ao carrinho SKAN",
  [SKAN_TOTAL_ADD_TO_CART_VALUE]: "Valor total de adições ao carrinho SKAN",
  [SKAN_CHECKOUT]: "Finalizar compra SKAN",
  [SKAN_COST_PER_CHECKOUT]: "Custo por finalizar compra SKAN",
  [SKAN_CHECKOUT_RATE]: "Taxa de finalização de compra SKAN",
  [SKAN_TOTAL_CHECKOUT]: "Finalizações de compra totais SKAN",
  [SKAN_COST_PER_TOTAL_CHECKOUT]: "Custo por finalização total de compra SKAN",
  [SKAN_TOTAL_CHECKOUT_VALUE]: "Valor total de finalizações de compra SKAN",
  [SKAN_VIEW_CONTENT]: "Ver conteúdo SKAN",
  [SKAN_COST_PER_VIEW_CONTENT]: "Custo por ver conteúdo SKAN",
  [SKAN_VIEW_CONTENT_RATE]: "Taxa de visualização de conteúdo SKAN",
  [SKAN_TOTAL_VIEW_CONTENT]: "Visualizações totais de conteúdo SKAN",
  [SKAN_COST_PER_TOTAL_VIEW_CONTENT]:
    "Custo por visualização total de conteúdo SKAN",
  [SKAN_TOTAL_VIEW_CONTENT_VALUE]:
    "Valor total de visualizações de conteúdo SKAN",
  [SKAN_ADD_PAYMENT_INFO]: "Adicionar informações de pagamento SKAN",
  [SKAN_COST_PER_ADD_PAYMENT_INFO]:
    "Custo por adicionar informações de pagamento SKAN",
  [SKAN_ADD_PAYMENT_INFO_RATE]:
    "Taxa de adicionar informações de pagamento SKAN",
  [SKAN_TOTAL_ADD_PAYMENT_INFO]:
    "Total de adicionar informações de pagamento SKAN",
  [SKAN_COST_TOTAL_ADD_PAYMENT_INFO]:
    "Custo total de adicionar informações de pagamento SKAN",
  [SKAN_ADD_TO_WISHLIST]: "Adicionar à lista de desejos SKAN",
  [SKAN_COST_PER_ADD_TO_WISHLIST]:
    "Custo por adicionar à lista de desejos SKAN",
  [SKAN_ADD_TO_WISHLIST_RATE]: "Taxa de adicionar à lista de desejos SKAN",
  [SKAN_TOTAL_ADD_TO_WISHLIST]: "Total de adições à lista de desejos SKAN",
  [SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST]:
    "Custo por total de adições à lista de desejos SKAN",
  [SKAN_TOTAL_ADD_TO_WISHLIST_VALUE]:
    "Valor total de adições à lista de desejos SKAN",
  [SKAN_LAUNCH_APP]: "Abrir app SKAN",
  [SKAN_COST_PER_LAUNCH_APP]: "Custo por abrir app SKAN",
  [SKAN_LAUNCH_APP_RATE]: "Taxa de abertura de app SKAN",
  [SKAN_TOTAL_LAUNCH_APP]: "Aberturas de app totais SKAN",
  [SKAN_COST_PER_TOTAL_LAUNCH_APP]: "Custo por abertura total de app SKAN",
  [SKAN_COMPLETE_TUTORIAL]: "Concluir tutorial SKAN",
  [SKAN_COST_PER_COMPLETE_TUTORIAL]: "Custo por concluir tutorial SKAN",
  [SKAN_COMPLETE_TUTORIAL_RATE]: "Taxa de concluir tutorial SKAN",
  [SKAN_TOTAL_COMPLETE_TUTORIAL]: "Tutoriais concluídos totais SKAN",
  [SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL]:
    "Custo por tutorial concluído total SKAN",
  [SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE]:
    "Valor total de tutoriais concluídos SKAN",
  [SKAN_CREATE_GROUP]: "Criar grupo SKAN",
  [SKAN_COST_PER_CREATE_GROUP]: "Custo por criação de grupo SKAN",
  [SKAN_CREATE_GROUP_RATE]: "Taxa de criação de grupo SKAN",
  [SKAN_TOTAL_CREATE_GROUP]: "Total de criação de grupo SKAN",
  [SKAN_COST_PER_TOTAL_CREATE_GROUP]: "Custo por criação total de grupo SKAN",
  [SKAN_TOTAL_CREATE_GROUP_VALUE]: "Valor total de criação de grupo SKAN",
  [SKAN_JOIN_GROUP]: "Entrar em grupo SKAN",
  [SKAN_COST_PER_JOIN_GROUP]: "Custo por entrar em grupo SKAN",
  [SKAN_JOIN_GROUP_RATE]: "Taxa de entrada em grupo SKAN",
  [SKAN_TOTAL_JOIN_GROUP]: "Entradas em grupo totais SKAN",
  [SKAN_COST_PER_TOTAL_JOIN_GROUP]: "Custo por entrada total em grupo SKAN",
  [SKAN_TOTAL_JOIN_GROUP_VALUE]: "Valor total de entradas em grupo SKAN",
  [SKAN_CREATE_GAMEROLE]: "Criar papel de jogo SKAN",
  [SKAN_COST_PER_CREATE_GAMEROLE]: "Custo por criar papel de jogo SKAN",
  [SKAN_CREATE_GAMEROLE_RATE]: "Taxa de criação de papel de jogo SKAN",
  [SKAN_TOTAL_CREATE_GAMEROLE]: "Papéis de jogo criados totais SKAN",
  [SKAN_COST_PER_TOTAL_CREATE_GAMEROLE]:
    "Custo por criação total de papel de jogo SKAN",
  [SKAN_TOTAL_CREATE_GAMEROLE_VALUE]:
    "Valor total de papéis de jogo criados SKAN",
  [SKAN_SPEND_CREDITS]: "Gastar créditos SKAN",
  [SKAN_COST_PER_SPEND_CREDITS]: "Custo por gastar créditos SKAN",
  [SKAN_SPEND_CREDITS_RATE]: "Taxa de gasto de créditos SKAN",
  [SKAN_TOTAL_SPEND_CREDITS]: "Créditos gastos totais SKAN",
  [SKAN_COST_PER_TOTAL_SPEND_CREDITS]: "Custo por gasto total de créditos SKAN",
  [SKAN_TOTAL_SPEND_CREDITS_VALUE]: "Valor total de créditos gastos SKAN",
  [SKAN_ACHIEVE_LEVEL]: "Alcançar nível SKAN",
  [SKAN_COST_PER_ACHIEVE_LEVEL]: "Custo por alcançar nível SKAN",
  [SKAN_ACHIEVE_LEVEL_RATE]: "Taxa de alcançar nível SKAN",
  [SKAN_TOTAL_ACHIEVE_LEVEL]: "Níveis alcançados totais SKAN",
  [SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL]: "Custo por nível alcançado total SKAN",
  [SKAN_TOTAL_ACHIEVE_LEVEL_VALUE]: "Valor total de níveis alcançados SKAN",
  [SKAN_UNLOCK_ACHIEVEMENT]: "Desbloquear conquista SKAN",
  [SKAN_COST_PER_UNLOCK_ACHIEVEMENT]: "Custo por desbloquear conquista SKAN",
  [SKAN_UNLOCK_ACHIEVEMENT_RATE]: "Taxa de desbloqueio de conquista SKAN",
  [SKAN_TOTAL_UNLOCK_ACHIEVEMENT]: "Conquistas desbloqueadas totais SKAN",
  [SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT]:
    "Custo por conquista desbloqueada total SKAN",
  [SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE]:
    "Valor total de conquistas desbloqueadas SKAN",
  [SKAN_SALES_LEAD]: "Lead de vendas SKAN",
  [SKAN_COST_PER_SALES_LEAD]: "Custo por lead de vendas SKAN",
  [SKAN_SALES_LEAD_RATE]: "Taxa de leads de vendas SKAN",
  [SKAN_TOTAL_SALES_LEAD]: "Leads de vendas totais SKAN",
  [SKAN_COST_PER_TOTAL_SALES_LEAD]: "Custo por lead de vendas total SKAN",
  [SKAN_TOTAL_SALES_LEAD_VALUE]: "Valor total de leads de vendas SKAN",
  [SKAN_IN_APP_AD_CLICK]: "Clique em anúncio no app SKAN",
  [SKAN_COST_PER_IN_APP_AD_CLICK]: "Custo por clique em anúncio no app SKAN",
  [SKAN_IN_APP_AD_CLICK_RATE]: "Taxa de cliques em anúncios no app SKAN",
  [SKAN_TOTAL_IN_APP_AD_CLICK]: "Cliques totais em anúncios no app SKAN",
  [SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK]:
    "Custo por clique total em anúncios no app SKAN",
  [SKAN_TOTAL_IN_APP_AD_CLICK_VALUE]:
    "Valor total de cliques em anúncios no app SKAN",
  [SKAN_IN_APP_AD_IMPR]: "Impressão de anúncio no app SKAN",
  [SKAN_COST_PER_IN_APP_AD_IMPR]: "Custo por impressão de anúncio no app SKAN",
  [SKAN_IN_APP_AD_IMPR_RATE]: "Taxa de impressões de anúncios no app SKAN",
  [SKAN_TOTAL_IN_APP_AD_IMPR]: "Impressões totais de anúncios no app SKAN",
  [SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR]:
    "Custo por impressão total de anúncios no app SKAN",
  [SKAN_TOTAL_IN_APP_AD_IMPR_VALUE]:
    "Valor total de impressões de anúncios no app SKAN",
  [SKAN_LOAN_APPLY]: "Solicitar empréstimo SKAN",
  [SKAN_COST_PER_LOAN_APPLY]: "Custo por solicitar empréstimo SKAN",
  [SKAN_LOAN_APPLY_RATE]: "Taxa de solicitações de empréstimo SKAN",
  [SKAN_TOTAL_LOAN_APPLY]: "Solicitações de empréstimo totais SKAN",
  [SKAN_COST_PER_TOTAL_LOAN_APPLY]:
    "Custo por solicitação total de empréstimo SKAN",
  [SKAN_LOAN_CREDIT]: "Crédito de empréstimo SKAN",
  [SKAN_COST_PER_LOAN_CREDIT]: "Custo por crédito de empréstimo SKAN",
  [SKAN_LOAN_CREDIT_RATE]: "Taxa de créditos de empréstimo SKAN",
  [SKAN_TOTAL_LOAN_CREDIT]: "Créditos de empréstimo totais SKAN",
  [SKAN_COST_PER_TOTAL_LOAN_CREDIT]:
    "Custo por crédito total de empréstimo SKAN",
  [SKAN_LOAN_DISBURSEMENT]: "Desembolso de empréstimo SKAN",
  [SKAN_COST_PER_LOAN_DISBURSEMENT]: "Custo por desembolso de empréstimo SKAN",
  [SKAN_LOAN_DISBURSEMENT_RATE]: "Taxa de desembolsos de empréstimo SKAN",
  [SKAN_TOTAL_LOAN_DISBURSEMENT]: "Desembolsos de empréstimo totais SKAN",
  [SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT]:
    "Custo por desembolso total de empréstimo SKAN",
  [SKAN_LOGIN]: "Iniciar sessão SKAN",
  [SKAN_COST_PER_LOGIN]: "Custo por iniciar sessão SKAN",
  [SKAN_LOGIN_RATE]: "Taxa de inícios de sessão SKAN",
  [SKAN_TOTAL_LOGIN]: "Inícios de sessão totais SKAN",
  [SKAN_COST_PER_TOTAL_LOGIN]: "Custo por início de sessão total SKAN",
  [SKAN_RATINGS]: "Avaliações SKAN",
  [SKAN_COST_PER_RATINGS]: "Custo por avaliação SKAN",
  [SKAN_RATINGS_RATE]: "Taxa de avaliações SKAN",
  [SKAN_TOTAL_RATINGS]: "Avaliações totais SKAN",
  [SKAN_COST_PER_TOTAL_RATINGS]: "Custo por avaliação total SKAN",
  [SKAN_TOTAL_RATINGS_VALUE]: "Valor total de avaliações SKAN",
  [SKAN_SEARCH]: "Busca SKAN",
  [SKAN_COST_PER_SEARCH]: "Custo por busca SKAN",
  [SKAN_SEARCH_RATE]: "Taxa de buscas SKAN",
  [SKAN_TOTAL_SEARCH]: "Buscas totais SKAN",
  [SKAN_COST_PER_TOTAL_SEARCH]: "Custo por busca total SKAN",
  [SKAN_START_TRIAL]: "Iniciar teste SKAN",
  [SKAN_COST_PER_START_TRIAL]: "Custo por início de teste SKAN",
  [SKAN_START_TRIAL_RATE]: "Taxa de inícios de teste SKAN",
  [SKAN_TOTAL_START_TRIAL]: "Inícios de teste totais SKAN",
  [SKAN_COST_PER_TOTAL_START_TRIAL]: "Custo por início total de teste SKAN",
  [SKAN_SUBSCRIBE]: "Assinatura SKAN",
  [SKAN_COST_PER_SUBSCRIBE]: "Custo por assinatura SKAN",
  [SKAN_SUBSCRIBE_RATE]: "Taxa de assinaturas SKAN",
  [SKAN_TOTAL_SUBSCRIBE]: "Assinaturas totais SKAN",
  [SKAN_COST_PER_TOTAL_SUBSCRIBE]: "Custo por assinatura total SKAN",
  [SKAN_TOTAL_SUBSCRIBE_VALUE]: "Valor total de assinaturas SKAN",
  [SKAN_VTA_CONVERSION]: "Conversão VTA SKAN",
  [SKAN_COST_PER_VTA_CONVERSION]: "Custo por conversão VTA SKAN",
  [SKAN_VTA_APP_INSTALL]: "Instalação de app VTA SKAN",
  [SKAN_COST_PER_VTA_APP_INSTALL]: "Custo por instalação de app VTA SKAN",
  [SKAN_VTA_REGISTRATION]: "Cadastro VTA SKAN",
  [SKAN_COST_PER_VTA_REGISTRATION]: "Custo por cadastro VTA SKAN",
  [SKAN_VTA_PURCHASE]: "Compra VTA SKAN",
  [SKAN_COST_PER_VTA_PURCHASE]: "Custo por compra VTA SKAN",
  [SKAN_CTA_CONVERSION]: "Conversão CTA SKAN",
  [SKAN_COST_PER_CTA_CONVERSION]: "Custo por conversão CTA SKAN",
  [SKAN_CTA_APP_INSTALL]: "Instalação de app CTA SKAN",
  [SKAN_COST_PER_CTA_APP_INSTALL]: "Custo por instalação de app CTA SKAN",
  [SKAN_CTA_REGISTRATION]: "Cadastro CTA SKAN",
  [SKAN_COST_PER_CTA_REGISTRATION]: "Custo por cadastro CTA SKAN",
  [SKAN_CTA_PURCHASE]: "Compra CTA SKAN",
  [SKAN_COST_PER_CTA_PURCHASE]: "Custo por compra CTA SKAN",

  // OVERVIEW REPORT
  [OVERVIEW_REPORT_GENERATING_SUMMARY]: "Gerando resumo...",
  [OVERVIEW_REPORT_SUMMARY_NOT_GENERATED]: "Não foi possível gerar o resumo",

  // GENERATE PDF
  [REPORT_DATE_GENERATED]:
    "Data de geração: {{date,monthTextShort}} {{date,dayShort}}, {{date,year}}",
  [REPORT_GENERATED_BY_BUZZLY_AI]: "Relatório gerado por {{NAME_BUSINESS}}",
  [AI_GENERATED_SECTION_CHIP]: "Gerado por {{NAME_BUSINESS}}",
  [AI_GENERATED_SECTION_CHIP_ARIA]:
    "Conteúdo gerado pela IA da {{NAME_BUSINESS}}. Ao editar, a etiqueta desaparece.",
  [DOWNLOADING_PDF]: "Baixando PDF...",
  [PDF_DOWNLOADED_SUCCESSFULLY]: "PDF baixado com sucesso",
  [OPTIMIZATION]: "Otimização",

  [CHAT_QUESTION_1]: "O ROAS melhorou em relação à semana passada?",
  [CHAT_QUESTION_2]: "Como o CPA médio se compara com o período anterior?",
  [CHAT_QUESTION_3]:
    "O orçamento está bem distribuído entre plataformas ou grupos?",
  [CHAT_QUESTION_4]: "Quais públicos rendem melhor nas campanhas atuais?",
  [CHAT_QUESTION_5]: "Há grupos de anúncios para pausar ou escalar?",
  [CHAT_QUESTION_6]:
    "Que mudanças estratégicas você sugere para melhorar o desempenho?",
  [CHAT_QUESTION_7]: "Como o CPA mudou recentemente?",
  [CHAT_QUESTION_8]: "Qual é o próximo passo na otimização de campanhas?",
  [CHAT_QUESTION_9]: "Há alertas ou tendências negativas que devemos revisar?",

  //RESERVATION STATUS
  [RESERVATION_STATUS_1]: "A previsão foi realizada com sucesso.",
  [RESERVATION_STATUS_2]: "A previsão ainda está sendo gerada.",
  [RESERVATION_STATUS_3]:
    "Não é possível alcançar o público. O alcance é amplo demais ou o orçamento é alto demais.",
  [RESERVATION_STATUS_4]:
    "Os ajustes da previsão não são válidos (por exemplo, a duração).",
  [RESERVATION_STATUS_5]: "Valor de targeting_spec inválido.",
  [RESERVATION_STATUS_6]:
    "O orçamento ou o lance para o alcance especificado são baixos demais.",
  [RESERVATION_STATUS_7]: "A duração do conjunto de anúncios é curta demais.",
  [RESERVATION_STATUS_8]: "A duração do conjunto de anúncios é longa demais.",
  [RESERVATION_STATUS_9]:
    "Falta tempo demais para a data de término do conjunto de anúncios.",
  [RESERVATION_STATUS_10]: "O limite de frequência não foi especificado.",
  [RESERVATION_STATUS_11]:
    "A posição de anúncios especificada não é suportada (por exemplo, combinar a publicação de anúncios na coluna direita e no feed).",
  [RESERVATION_STATUS_12]:
    "Há um problema com as datas (de início ou término) do conjunto de anúncios: a hora de início já passou, os horários especificados não incluem a meia-noite ou as datas não cobrem um dia inteiro. A data de término já passou, está a mais de 90 dias da data inicial ou não termina depois das 6:00.",
  [RESERVATION_STATUS_13]: "O país-alvo ainda não é suportado.",
  [RESERVATION_STATUS_14]:
    "As datas do conjunto de anúncios incluem dias indisponíveis.",
  [RESERVATION_STATUS_15]:
    "Não há inventário suficiente, então não é possível fazer reservas. Consulte 'Reservar previsões' para mais informações.",
  [RESERVATION_STATUS_16]:
    "Não foi possível obter o alcance mínimo necessário para a conta. Consulte 'Obter restrições da conta'.",
  [RESERVATION_STATUS_17]:
    "O alcance real disponível para esta previsão é menor que o alcance mínimo do país-alvo (normalmente 200.000 pessoas na maioria dos países).",
  [RESERVATION_STATUS_18]:
    "A programação de faixas do dia informada não é válida.",
  [RESERVATION_STATUS_19]: "Não é possível alcançar o CPM objetivo.",
  [RESERVATION_STATUS_20]:
    "O limite de frequência é baixo demais para a entrega combinada.",
  [RESERVATION_STATUS_21]:
    "O inventário de anúncios mudou o suficiente para que a previsão fique imprecisa.",
  [RESERVATION_STATUS_23]:
    "O intervalo do limite de frequência não é suportado no país-alvo.",
  [RESERVATION_STATUS_24]:
    "O conjunto de anúncios do estudo de lift da exclusão do grupo de contas ou campanhas não é coerente com a previsão de reserva.",
  [RESERVATION_STATUS_25]:
    "O limite de frequência não pode superar o número de dias em que a sua campanha está no ar.",
  [RESERVATION_STATUS_26]:
    "O público selecionado está vazio e não pode ser usado.",
  [RESERVATION_STATUS_27]:
    "Não é permitido modificar a sua campanha enquanto ela está no ar.",
  [RESERVATION_STATUS_28]:
    "Não é possível modificar a campanha no ar criada com um pedido de inserção.",
  [RESERVATION_STATUS_29]:
    "Não é possível modificar a campanha no ar por restrições de tempo.",
  [RESERVATION_STATUS_30]:
    "Para editar um conjunto de anúncios de reserva que está no ar, escolha um orçamento maior que o gasto atual.",
  [RESERVATION_STATUS_31]:
    "O estudo de lift do grupo de contas ou campanhas começa depois que a campanha já iniciou.",
  [RESERVATION_STATUS_32]:
    "O estudo de lift do grupo de contas ou campanhas termina antes de a campanha acabar.",
  [RESERVATION_STATUS_35]:
    "Não é possível definir a hora de início da campanha de reserva no passado.",
  [RESERVATION_STATUS_36]:
    "Confira se a duração do conjunto de anúncios de reserva é maior que um dia e se a hora de início ou término da campanha é válida.",
  [RESERVATION_STATUS_37]:
    "O Audience Network não aceita o objetivo com o tipo de compra por reserva.",
  [RESERVATION_STATUS_39]:
    "A combinação de posicionamentos selecionada não pode ser usada na compra por reserva.",
  [RESERVATION_STATUS_40]:
    "Algumas versões de sistemas operacionais para celular não podem ser segmentadas com o tipo de compra por reserva.",
  [RESERVATION_STATUS_41]:
    "Os amigos das conexões não podem ser segmentados com o tipo de compra por reserva.",
  [RESERVATION_STATUS_42]:
    "As campanhas de reserva não podem ser publicadas quando o Audience Network é o único posicionamento selecionado. Selecione o Audience Network junto com o feed do Facebook ou o feed do Instagram como posicionamentos adicionais.",
  [RESERVATION_STATUS_44]: "A reserva não aceita Facebook Stories.",
  [RESERVATION_STATUS_45]:
    "Para usar Facebook Stories como posicionamento, selecione também os feeds do Facebook ou o Instagram Stories.",
  [RESERVATION_STATUS_50]:
    "A combinação de posicionamentos selecionada não pode ser usada na compra por reserva. No caso da compra por pedido de inserção de reserva, confira se o objetivo é 'Reproduções de vídeo'. Caso contrário, para usar a função in-stream do Facebook, selecione o posicionamento dos feeds do Facebook.",
  [RESERVATION_STATUS_53]:
    "O posicionamento de vídeo in-stream só está disponível para públicos dos Estados Unidos, Reino Unido, Austrália, Nova Zelândia, Irlanda, Tailândia, México, Peru, França, Alemanha, Argentina, Colômbia, Espanha, Chile, Equador, República Dominicana, Guatemala, Bolívia, Honduras, El Salvador, Noruega, Suécia, Países Baixos, Bélgica, Polônia, Portugal, Dinamarca, Índia, Malásia, Filipinas, Indonésia e Vietnã. Para continuar, edite o público para incluir só pessoas desses países.",
  [RESERVATION_STATUS_60]:
    "Para usar o Facebook Marketplace, selecione o posicionamento dos feeds do Facebook.",
  [RESERVATION_STATUS_66]:
    "O posicionamento da coluna direita do Facebook não pode ser combinado com outros posicionamentos.",
  [RESERVATION_STATUS_69]:
    "Se você quer que o anúncio apareça na seção Explorar do Instagram, também precisa selecionar o feed do Instagram como posicionamento.",
  [RESERVATION_STATUS_100]:
    "Erro do sistema, não é culpa do usuário. Tente novamente.",

  // MODAL WELCOME
  [MODAL_WELCOME_TITLE]: "Bem-vindo ao {{NAME_BUSINESS}}!",
  [MODAL_WELCOME_SUBTITLE]: "A sua assinatura foi ativada com sucesso",
  [MODAL_WELCOME_PLAN_NAME]: "Plano {{planName}}",
  [MODAL_WELCOME_BUTTON]: "Configure a sua marca",

  // MODAL REDIRECT BRAND SETUP
  [MODAL_REDIRECT_BRAND_SETUP_TITLE]: "Bem-vindo ao {{NAME_BUSINESS}}",
  [MODAL_REDIRECT_BRAND_SETUP_SUBTITLE]:
    "Para começar a usar o {{NAME_BUSINESS}}, você precisa configurar a sua marca",
  [MODAL_REDIRECT_BRAND_SETUP_BUTTON]: "Configurar a sua marca",

  // MODAL SUCCESS BRAND SETUP
  [MODAL_SUCCESS_BRAND_SETUP_TITLE]: "A sua marca está pronta!",
  [MODAL_SUCCESS_BRAND_SETUP_SUBTITLE]: "Escolha o seu próximo passo",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_TITLE]: "Lançar campanhas",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_DESCRIPTION]:
    "Crie campanhas publicitárias com IA, incluindo textos, criativos e segmentação para melhores resultados.",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_TITLE]: "Gerar anúncios",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_DESCRIPTION]:
    "Gere vídeos e imagens com IA, prontos para publicar e adaptados à sua marca.",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_POST_TITLE]: "Publicar nas redes",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_CALENDAR_DESCRIPTION]:
    "Publique os seus posts orgânicos em várias plataformas na hora ou deixe-os agendados para mais tarde.",
  [MODAL_SUCCESS_BRAND_SETUP_BUTTON_START]: "Começar",
  [MODAL_SUCCESS_BRAND_SETUP_BUTTON_LATER]: "Vou fazer isso depois",

  // ONBOARDING CHECKLIST
  [ONBOARDING_CHECKLIST_HEADER_TITLE]: "Primeiros passos",
  [ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_TITLE]: "Configure a sua marca",
  [ONBOARDING_CHECKLIST_ITEM_CREATIVES_TITLE]:
    "Crie os seus primeiros criativos",
  [ONBOARDING_CHECKLIST_ITEM_PUBLISH_TITLE]: "Publique nas suas redes sociais",
  [ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_TITLE]: "Crie a sua primeira campanha",
  [ONBOARDING_CHECKLIST_FOOTER_COMPLETED]:
    "Excelente trabalho, agora você já pode começar a criar",
  [ONBOARDING_CHECKLIST_SUBTITLE]:
    "Conclua estes passos para desbloquear todo o potencial.",
  [ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_DESCRIPTION]:
    "Adicione o nome, o logo e as cores da sua marca para personalizar a sua experiência.",
  [ONBOARDING_CHECKLIST_ITEM_CREATIVES_DESCRIPTION]:
    "Crie criativos e copys prontos para publicar.",
  [ONBOARDING_CHECKLIST_ITEM_PUBLISH_DESCRIPTION]:
    "Conecte as suas redes sociais e publique o seu conteúdo.",
  [ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_DESCRIPTION]:
    "Lance e administre a sua primeira campanha publicitária.",
  [ONBOARDING_CHECKLIST_PROGRESS_COMPLETED]:
    "{{completed}}/{{total}} concluídos",
  [ONBOARDING_CHECKLIST_SKIP_GUIDE]: "Pular guia",

  // CONNECTION PROGRESS MODAL
  [CONNECTING_TO_PLATFORM]: "Como conectar a minha conta de {{platform}}",
  [CONNECTING_TO_PLATFORM_DESCRIPTION]:
    "Confira se você tem permissão de administrador na sua conta de {{platform}} antes de continuar",

  // MODAL CANCEL SUBSCRIPTION
  [MODAL_CANCEL_SUBSCRIPTION_TITLE]: "Cancelar assinatura",
  [MODAL_CANCEL_SUBSCRIPTION_SUBTITLE]:
    "A sua assinatura continua ativa até o fim do período de faturamento atual. Até lá, você mantém acesso a todas as funções e aos créditos do seu plano.",
  [MODAL_CANCEL_SUBSCRIPTION_SUBTITLE_WARNING]:
    "⚠️ Ao terminar o período, as suas campanhas e todo o conteúdo da sua galeria serão <bold>excluídos</bold> de forma <bold>permanente</bold>.",
  [MODAL_CANCEL_SUBSCRIPTION_CONFIRM_BUTTON]: "Cancelar plano",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_TITLE]:
    "Motivo do cancelamento (mínimo de {{minChars}} caracteres):",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_PLACEHOLDER]:
    "Explique brevemente o motivo do cancelamento da sua assinatura...",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT]:
    "✓ Atinge o mínimo obrigatório",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT_MIN_CHARS]:
    "{{charCount}}/{{minChars}} caracteres mínimos",
  [MODAL_CANCEL_SUBSCRIPTION_WARNING_MESSAGE]:
    "Todas as campanhas serão excluídas de forma permanente no {{NAME_BUSINESS}} e nas plataformas de anúncios conectadas. O conteúdo da galeria também será apagado. Esta ação é irreversível e você não poderá recuperá-las. Deseja continuar?",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_LIMITED_OFFER]:
    "Oferta por tempo limitado",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_TITLE]:
    "⚠️ Isto vai excluir todo o seu trabalho",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_INTRO]:
    "15 dias úteis depois do fim do período, o seguinte será excluído de forma <boldDanger>permanente</boldDanger> e <boldDanger>irreversível</boldDanger>:",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_CAMPAIGNS]:
    "As suas campanhas gerenciadas no {{NAME_BUSINESS}}, que ficarão pausadas",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_GALLERY]:
    "Todo o conteúdo da sua galeria: imagens, vídeos, carrosséis, animações, modelos etc.",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_DATA]:
    "Os seus dados, configurações de marca, públicos e relatórios",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_API_CONNECTIONS]:
    "As conexões de API com Meta, Google, TikTok e LinkedIn",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_INTRO]:
    "Antes de <boldDanger>cancelar</boldDanger>, recomendamos:",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DOWNLOAD_GALLERY]:
    "Baixar o conteúdo da sua galeria; depois de baixado, ele é seu de forma permanente",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_EXPORT_REPORTS]:
    "Exportar os relatórios que você quiser guardar",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DUPLICATE_CAMPAIGNS]:
    "Duplicar na plataforma de anúncios as campanhas que você quiser manter ativas",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_NO_RECOVERY]:
    "Esta ação não pode ser desfeita. O {{NAME_BUSINESS}} não guarda uma cópia de segurança.",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_CONFIRM_PROMPT]:
    "Para confirmar, digite <boldDanger>EXCLUIR</boldDanger> abaixo",
  [MODAL_CANCEL_SUBSCRIPTION_CONFIRM_WORD]: "EXCLUIR",
  [BUTTON_KEEP_MY_ACCOUNT]: "Manter a minha conta",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_INTRO]:
    "Mantenha o seu conteúdo e as suas campanhas ativas com esta oferta por tempo limitado.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_FROM_DATE]:
    "A partir de {{date,short}}, você pagará {{price}} USD / mês e receberá {{credits}} créditos.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_NO_DATE]:
    "Você pagará {{price}} USD / mês e receberá {{credits}} créditos.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_IMMEDIATE_CREDITS]:
    "Além disso, você receberá na hora 50 créditos grátis.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_TAKE_OFFER_BUTTON]:
    "Aceitar oferta",
  [MODAL_CANCEL_SUBSCRIPTION_RETENTION_OFFER_REDEEMED_SUCCESS]:
    "Oferta resgatada",
  [BUTTON_CANCEL_PLAN_AND_DELETE_CAMPAIGNS]: "Cancelar plano e excluir tudo",

  // CANCELLATION REASONS
  [CANCELLATION_REASON_SELECT_LABEL]: "Conte-nos por que você está cancelando",
  [CANCELLATION_REASON_TOO_EXPENSIVE]: "Está caro demais",
  [CANCELLATION_REASON_NOT_FREQUENT_USE]: "Não uso com frequência suficiente",
  [CANCELLATION_REASON_BETTER_ALTERNATIVE]: "Encontrei uma alternativa melhor",
  [CANCELLATION_REASON_TECHNICAL_ISSUES]: "Problemas técnicos ou de desempenho",
  [CANCELLATION_REASON_NOT_MEET_NEEDS]: "Não atende às minhas necessidades",
  [CANCELLATION_REASON_DIFFICULT_TO_USE]: "Dificuldade para usar a plataforma",
  [CANCELLATION_REASON_SITUATION_CHANGED]:
    "Minha situação pessoal/profissional mudou",
  [CANCELLATION_REASON_TEMPORARY_NEED]: "Só precisava temporariamente",
  [CANCELLATION_REASON_SECURITY_CONCERNS]:
    "Preocupações com segurança ou privacidade",
  [CANCELLATION_REASON_OTHER]: "Outro motivo",

  // FILTERS GALLERY
  [FILTERS_GALLERY_IMAGE]: "Imagens",
  [FILTERS_GALLERY_VIDEO]: "Vídeos",
  [FILTERS_GALLERY_CAROUSEL]: "Carrosséis",
  [GALLERY_CREATE_CAROUSEL]: "Criar carrossel",
  [FILTERS_GALLERY_FEED]: "Feed do Instagram",
  [FILTERS_GALLERY_HORIZONTAL]: "Horizontal",
  [FILTERS_GALLERY_VERTICAL]: "Vertical",
  [FILTERS_GALLERY_SQUARE]: "Quadrado",
  [FILTERS_GALLERY_TODAY]: "Hoje",
  [FILTERS_GALLERY_WEEK]: "Esta semana",
  [FILTERS_GALLERY_MONTH]: "Este mês",
  [FILTERS_GALLERY_YEAR]: "Este ano",
  [FILTERS_GALLERY_RESET_FILTERS]: "Redefinir filtros",
  [FILTERS_GALLERY_RESULTS_COUNTER]: "{{count}} de {{total}} elementos",

  // GALLERY CONTENT SOURCES
  [GALLERY_SOURCE_MY_CONTENT]: "Meu conteúdo",
  [GALLERY_SOURCE_GOOGLE]: "Importar do Google",
  [GALLERY_SOURCE_AD_ACCOUNT]: "Importar da conta de anúncios",
  [GALLERY_SOURCE_AD_ACCOUNT_EMPTY]:
    "Selecione uma plataforma e uma conta de anúncios para ver os criativos",
  [GALLERY_SOURCE_GOOGLE_DRIVE]: "Importar do Google Drive",
  [GALLERY_SOURCE_SOCIAL_POSTS]: "Importar das redes sociais",
  [GALLERY_SOCIAL_POSTS_DESCRIPTION]:
    "Selecione o post que você quer usar. Alguns posts podem não aparecer se foram publicados recentemente",
  [GALLERY_VIDEO_THUMBNAIL_FALLBACK_TOOLTIP]:
    "Este post é um vídeo. Não foi possível carregar a prévia em vídeo, por isso a miniatura é exibida. Se você usá-lo, o anúncio será publicado mesmo assim como vídeo.",
  [GALLERY_SOURCE_CANVA]: "Importar do Canva",
  [GALLERY_SELECT_SOURCE]: "Conteúdo",
  [GALLERY_ASSETS_TITLE]: "Recursos",
  [GALLERY_ASSETS_RENAME_TITLE]: "Renomear asset",
  [GALLERY_ASSETS_RENAME_SUCCESS]: "Asset renomeado",
  [GALLERY_ASSETS_RENAME_ERROR]: "Não foi possível renomear o asset",
  [GALLERY_ASSETS_RENAME_ARIA_LABEL]: "Renomear asset {{name}}",
  [GALLERY_ASSETS_NAME_LABEL]: "Nome do arquivo",
  [GALLERY_UPLOADING_ASSETS]: "Enviando assets",
  [GALLERY_GOOGLE_NOT_CONNECTED]:
    "Conecte a sua conta do Google para acessar os recursos do Google",
  [GALLERY_META_NOT_CONNECTED]:
    "Conecte a sua conta da Meta para acessar os posts sociais",
  [GALLERY_CONTENT_TYPE]: "Tipo de conteúdo",
  [GALLERY_DIMENSIONS]: "Dimensões",
  [GALLERY_DATE_RANGE]: "Intervalo de datas",
  [GALLERY_TITLE_DIMENSIONS]: "{{width}} × {{height}}",

  // CAROUSEL IMAGES MANAGER
  [CAROUSEL_IMAGES_MANAGER_TITLE]: "Imagens ({{count}}/35)",
  [CAROUSEL_IMAGES_MANAGER_DELETE_ALL]: "Excluir todas",
  [CAROUSEL_IMAGES_MANAGER_ADD_IMAGE]: "Adicionar imagem",
  [CAROUSEL_IMAGES_MANAGER_NO_IMAGES]: "Não há imagens adicionadas",
  [CAROUSEL_IMAGES_MANAGER_DIMENSIONS_HELP]:
    "Dimensões obrigatórias: 1200x628, 640x640 ou 720x1280 pixels",

  // MODAL SHARE INSTAGRAM
  [MODAL_SHARE_TITLE]: "Compartilhar conteúdo",
  [MODAL_SHARE_SELECT_PLATFORMS_TITLE]:
    "Selecione as plataformas em que você quer publicar",
  [ALERT_SHARE_INSTAGRAM_ERROR]: "Erro ao publicar este conteúdo",
  [ALERT_SHARE_SUCCESS]: "Conteúdo publicado com sucesso",
  [ALERT_SHARE_SCHEDULED_SUCCESS]: "A publicação foi agendada com sucesso",
  [BUTTON_SHARE_MEDIA]: "Publicar",
  [BUTTON_SHARE_LOADING]: "Publicando...",
  [BUTTON_SCHEDULE_MEDIA]: "Agendar publicação",
  [BUTTON_SCHEDULING_MEDIA]: "Agendando...",
  [BUTTON_PUBLISH_NOW]: "Publicar agora",
  [SCHEDULE_DATE_MIN_FUTURE_ERROR]:
    "A data deve ser pelo menos 5 minutos no futuro",
  [SUGGESTED_PUBLISH_SCHEDULE_LOADING]: "Sugerindo horário",
  [DESCRIPTION_INSTAGRAM_LABEL]: "Descrição",
  [DESCRIPTION_INSTAGRAM_GENERATING]: "Gerando descrição",
  [TYPE_CONTENT_INSTAGRAM_LABEL]: "Tipo de conteúdo",
  [INSTAGRAM_COLLABORATORS_LABEL]: "Colaboradores",
  [INSTAGRAM_COLLABORATORS_PLACEHOLDER]: "Adicionar colaboradores (máx. 3)",
  [INSTAGRAM_COLLABORATORS_HELPER]:
    "Digite nomes de usuário do Instagram sem @",
  [IMAGE_NO_CONTENT_TO_SHOW]: "Não há conteúdo para exibir",
  [NO_SUPPORTED_FILE]: "Tipo de arquivo não suportado",

  // MODAL CANVA IMAGE CONFIG
  [MODAL_CANVA_IMAGE_CONFIG_CONTENT_TYPE_LABEL]: "Tipo de conteúdo",

  // MAP TRADUCCIONES
  [MAP_TRADUCCIONES_STATUS]: "Situação",
  [MAP_TRADUCCIONES_PLATFORM]: "Plataforma",
  [MAP_TRADUCCIONES_TITLES]: "Títulos",
  [MAP_TRADUCCIONES_CTA]: "Chamada para ação",
  [MAP_TRADUCCIONES_CTAS]: "Chamadas para ação",
  [MAP_TRADUCCIONES_CTA_ID]: "ID da chamada para ação",
  [MAP_TRADUCCIONES_CALL_TO_ACTION]: "CTA",
  [MAP_TRADUCCIONES_CALL_TO_ACTIONS]: "CTAs",
  [MAP_TRADUCCIONES_CALL_TO_ACTION_ID]: "ID do CTA",
  [CAMPAIGN_SYNCING_STATUS]: "Sincronizando",
  [MAP_TRADUCCIONES_MEDIA_URLS]: "URLs de mídia",
  [MAP_TRADUCCIONES_MEDIA_DATA]: "dados de mídia",
  [MAP_TRADUCCIONES_MUSIC_URL]: "URL da música",
  [MAP_TRADUCCIONES_IS_CAROUSEL]: "é carrossel",
  [MAP_TRADUCCIONES_OBJECTIVE]: "objetivo",
  [MAP_TRADUCCIONES_INTEGRATION_ID]: "ID de integração",
  [MAP_TRADUCCIONES_AD_ACCOUNT_ID]: "ID da conta de anúncios",
  [MAP_TRADUCCIONES_PAGE_ID]: "ID da página",
  [MAP_TRADUCCIONES_INSTAGRAM_ID]: "ID do Instagram",
  [MAP_TRADUCCIONES_USE_CAMPAIGN_BUDGET]: "usar orçamento da campanha",
  [MAP_TRADUCCIONES_TYPE_BUDGET]: "tipo de orçamento",
  [MAP_TRADUCCIONES_BUDGET]: "orçamento",
  [MAP_TRADUCCIONES_IS_CATALOG_CAMPAIGN]: "é campanha de catálogo",
  [MAP_TRADUCCIONES_WHATSAPP_BUSINESS_NUMBER]: "número do WhatsApp Business",
  [MAP_TRADUCCIONES_MESSAGE_TEMPLATE]: "modelo de mensagem",
  [MAP_TRADUCCIONES_INSTANT_FORM]: "Formulário Instantâneo",
  [MAP_TRADUCCIONES_TRACKING_ID]: "ID de tracking",
  [MAP_TRADUCCIONES_TRACKING_CUSTOM_EVENT_ID]:
    "ID do evento de tracking personalizado",
  [MAP_TRADUCCIONES_CATALOG_ID]: "ID do catálogo",
  [MAP_TRADUCCIONES_IS_IOS14_CAMPAIGN]: "é campanha de iOS 14",
  [MAP_TRADUCCIONES_APP_ID]: "ID do app",
  [MAP_TRADUCCIONES_BUYING_TYPE]: "tipo de compra",
  [MAP_TRADUCCIONES_DESCRIPTIONS]: "descrições",
  [MAP_TRADUCCIONES_ADS]: "anúncios",
  [MAP_TRADUCCIONES_KEYWORDS]: "palavras-chave",
  [MAP_TRADUCCIONES_KEYWORDS_NEGATIVE]: "palavras-chave negativas",
  [MAP_TRADUCCIONES_START_DATE]: "data de início",
  [MAP_TRADUCCIONES_END_DATE]: "data de término",
  [MAP_TRADUCCIONES_AGE_RANGE]: "faixa etária",
  [MAP_TRADUCCIONES_GENDERS]: "gêneros",
  [MAP_TRADUCCIONES_LOCATIONS]: "localizações",
  [MAP_TRADUCCIONES_INTERESTS]: "interesses",
  [MAP_TRADUCCIONES_BEHAVIORS]: "comportamentos",
  [MAP_TRADUCCIONES_CUSTOM_AUDIENCES]: "públicos personalizados",
  [MAP_TRADUCCIONES_EXCLUDED_CUSTOM_AUDIENCES]:
    "públicos personalizados excluídos",
  [MAP_TRADUCCIONES_BID_GOAL]: "objetivo de lance",
  [MAP_TRADUCCIONES_OPTIMIZATION_GOAL]: "Otimizar para",
  [MAP_TRADUCCIONES_IDENTITY_TIKTOK_ID]: "ID de identidade do TikTok",
  [MAP_TRADUCCIONES_TYPE]: "tipo",
  [MAP_TRADUCCIONES_ID]: "ID",
  [MAP_TRADUCCIONES_DESTINATION_URL]: "URL de destino",
  [MAP_TRADUCCIONES_BUSINESS_NAME]: "nome do negócio",
  [MAP_TRADUCCIONES_LOGO_URLS]: "URLs dos logos",
  [MAP_TRADUCCIONES_IMAGE_URLS]: "URLs das imagens",
  [MAP_TRADUCCIONES_VIDEO_URLS]: "URLs dos vídeos",
  [MAP_TRADUCCIONES_LONG_HEADLINES]: "manchetes longas",
  [MAP_TRADUCCIONES_SEARCH_THEMES]: "temas de busca",

  // MAP STATUS
  [MAP_STATUS_ACTIVE]: "Ativo",
  [MAP_STATUS_DEACTIVATED]: "Desativado",

  [BUTTON_OPTIMIZE_CAMPAIGN]: "Otimizações",
  [BUTTON_OPTIMIZE_CAMPAIGN_MESSAGE]:
    "Que recomendações você me dá para melhorar a minha campanha?",

  [ADD_CHANGES]: "Será adicionado:",
  [UPDATE_CHANGES]: "Será atualizado:",
  [REMOVE_CHANGES]: "Será removido:",

  [OVERVIEW_HOME_STATISTICS]: "Resumo",
  [KPI_TARGET_CPA_ABOVE_PLATFORM]:
    "<bold>{{platform}}</bold> tem um CPA de {{cpa}} {{currency}} nos últimos 14 dias, acima do objetivo de {{targetCpa}} {{currency}}.",
  [KPI_TARGET_CPA_ALERTS_TITLE]: "Advertência",
  [OVERVIEW_HOME_STATISTICS_VIEW_MORE]: "Ver mais",
  [STATISTICS_ONLY_BUZZLY_CAMPAIGNS]:
    "Só são contabilizadas as campanhas criadas em {{NAME_BUSINESS}}. As campanhas criadas fora da plataforma não serão consideradas.",
  [VIEW_SPEND_BREAKDOWN]: "Ver por plataforma",
  [LIST_TABLE_CAMPAIGNS_TITLE]: "Suas campanhas",
  [DASHBOARD_METRICS_DELAY_WARNING]:
    "Pode haver um atraso de até 3 horas entre as métricas que você vê nos gerenciadores de anúncios de cada plataforma e as que aparecem em {{NAME_BUSINESS}}.",
  [DASHBOARD_METRICS_DELAY_DISMISS]: "Não mostrar de novo",
  [TRIAL_CONTENT_CTA_MESSAGE]:
    "Gostou deste conteúdo? Use-o em qualquer uma destas opções:",
  [TRIAL_CONTENT_CTA_BUTTON_SHARE_INSTAGRAM]: "Compartilhar no Instagram",
  [TRIAL_CONTENT_CTA_BUTTON_SHARE_TIKTOK]: "Compartilhar no TikTok",
  [TRIAL_CONTENT_CTA_BUTTON_MORE_OPTIONS]: "Mais opções",

  // MODAL CREATE WITH AI
  [MODAL_CREATE_WITH_IA_TITLE]: "Gerar criativos",
  [MODAL_CREATE_WITH_IA_SUBTITLE]: "Configuração",
  [MODAL_CREATE_WITH_IA_GENERATED_CREATIVES]: "Criativos gerados",
  [MODAL_CREATE_WITH_IA_UPLOAD_IMAGE]: "Enviar imagem",
  [MODAL_CREATE_WITH_IA_ADD_URL]: "Adicionar URL",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_EMPTY]:
    "Não há recursos adicionais. Configure-os no Brand Setup.",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_SUBTITLE]:
    "Selecione os recursos adicionais que você quer usar como referência para gerar os seus criativos.",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_TOGGLE_ARIA]:
    "Incluir recurso {{number}} na geração",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_PREVIEW_ARIA]:
    "Prévia da imagem do recurso {{number}}",
  [MODAL_CREATE_WITH_IA_EXTRACT_URL]: "Importar da URL",
  [MODAL_CREATE_WITH_IA_IMPORT_PHOTOS_URL_HINT]:
    "Você também pode importar imagens ao adicionar uma URL acima.",
  [MODAL_CREATE_WITH_IA_DESCRIPTION]: "Descrição",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_BASIC]: "Configuração básica",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE]: "Imagens de referência",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_PRODUCTS]:
    "Fotos do produto",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_SERVICES]:
    "Imagens do serviço",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS]:
    "Envie imagens do seu produto para que a IA as use como referências visuais.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES]:
    "Envie imagens que representem o seu serviço para que a IA as use como referências visuais.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_URL]:
    "Opcional. A IA usa este link para os detalhes do produto, como o nome, o preço e as ofertas. Funciona com ou sem fotos.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_UPLOAD]:
    "Opcional. Adicione fotos enviando-as, da galeria ou da URL do produto. Funcionam com ou sem link.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_URL]:
    "Opcional. A IA usa este link para os detalhes do serviço, como o nome, o preço e as ofertas. Funciona com ou sem imagens.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_UPLOAD]:
    "Opcional. Adicione imagens enviando-as, da galeria ou da URL do serviço. Funcionam com ou sem link.",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_TITLE]: "Anúncio de referência",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_STYLE_GUIDE_CHIP]: "Estilo",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_LOCAL]: "Enviar",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_SEARCH]: "Concorrentes",
  [MODAL_CREATE_WITH_IA_REFERENCE_IMAGE_ASSETS_CHIP]: "Recursos",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_DESCRIPTION]:
    "Envie um anúncio de referência para copiar o layout. As cores da marca são aplicadas sobre essa estrutura.",
  [MODAL_CREATE_WITH_IA_PHYSICAL_NO_REFERENCE_IMAGES_DESCRIPTION]:
    "Deseja gerar o conteúdo sem enviar imagens de referência do produto?",
  [MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_TITLE]:
    "Logo obrigatório para vídeos",
  [MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_DESCRIPTION]:
    "Envie o logo da sua marca para gerar o vídeo.",
  [MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_OPTIONAL_DESCRIPTION]:
    "Opcional: envie o logo para incluí-lo na peça publicitária final. Sem logo, o fechamento usará headline e CTA.",
  [MODAL_CREATE_WITH_IA_MAX_IMAGES_MESSAGE]:
    "Limite de {{maxImages}} imagens de referência",
  [CONFIGURATION_PANEL_TITLE_IMAGE_PHYSICAL_PRODUCT]: "Fotos do produto",
  [CONFIGURATION_PANEL_SUBTITLE_IMAGE_PHYSICAL_PRODUCT]:
    "Envie uma ou mais fotos do seu produto que cumpram os requisitos para um melhor resultado.",
  [CONFIGURATION_PANEL_ADD_MULTIPLE_PERSPECTIVES_TIP]:
    "Adicione imagens do mesmo produto, na mesma cor e modelo, de ângulos e perspectivas diferentes para melhores resultados.",
  [CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_TITLE]: "URL do serviço",
  [CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_DESCRIPTION]:
    "Adicione imagens e conteúdo facilmente com a URL do seu serviço.",
  [CONFIGURATION_PANEL_WEBSITE_URL_TITLE]: "URL do produto",
  [CONFIGURATION_PANEL_WEBSITE_URL_DESCRIPTION]:
    "Adicione imagens e conteúdo facilmente com a URL do seu produto.",
  [CONFIGURATION_PANEL_CLARIFICATION_INPUT_IMAGES]:
    "Confira se as imagens cumprem os requisitos para um melhor resultado.",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_TITLE]:
    "Requisitos da imagem para melhores resultados",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_INTRO]:
    "Para que o resultado tenha mais qualidade e fidelidade, confira se a sua imagem de referência cumpre estes requisitos:",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_WARNING_DISTORTION]:
    "Produtos com textos pequenos e/ou fundos desfocados podem ter distorções imperceptíveis.",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_HIGH_QUALITY]:
    "Qualidade alta: use imagens nítidas e claras, sem desfoque nem pixelização",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_PROMINENT]:
    "Produto em destaque: o produto deve ser o elemento principal (ocupar pelo menos 60-70% do espaço)",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SIZE]:
    "Tamanho adequado: o produto deve parecer grande e claro, não pequeno ou difícil de distinguir",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SAME_COLOR_AND_MODEL]:
    "Uma só variante: todas as fotos devem ser do mesmo produto, cor e modelo; mude só o ângulo ou o enquadramento, não a cor nem a versão.",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_COMPLETE]:
    "Produto completo: o produto deve estar totalmente visível, sem partes cortadas ou fora do enquadramento",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_LIGHTING]:
    "Bem iluminado: boa iluminação que permita ver todos os detalhes do produto",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_NO_PEOPLE]:
    "Sem pessoas: para que o foco seja representar bem o produto e não as pessoas",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_TITLE]: "Evite:",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_LIST]:
    "Produtos muito pequenos, cortados, desfocados ou em que o produto não seja o protagonista",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_EXAMPLES_TITLE]: "Exemplos:",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_PEOPLE]:
    "Evite usar imagens que contenham pessoas.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_INSTRUCTIONS]: "Instruções",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_THEME]: "Tema",
  [MODAL_CREATE_WITH_IA_PROMPT_OPTIONAL]:
    "Este campo é opcional e você pode usá-lo para adicionar instruções de geração. Se não forem informadas, usaremos a sua configuração de marca.",
  [MODAL_CREATE_WITH_IA_PROMPT_THEME_OPTIONAL]:
    "Descreva o tema do seu vídeo. Por exemplo: quero promover o desconto de até 20% para este verão.",
  [MODAL_CREATE_WITH_IA_EMPTY_STATE_TITLE]: "Pronto para criar",
  [MODAL_CREATE_WITH_IA_EMPTY_STATE_SUBTITLE]:
    "Configure as suas preferências no painel lateral",

  // MODAL IMAGE EDIT
  [MODAL_IMAGE_EDIT_EMPTY_STATE_TITLE]: "Edite a sua imagem",
  [MODAL_IMAGE_EDIT_EMPTY_STATE_DESCRIPTION]:
    "Descreva as alterações que você quer fazer na sua imagem. Você pode pedir melhorias, mudanças de estilo, ajustes de cor e mais.",
  [MODAL_IMAGE_EDIT_TITLE]: "Edite a sua imagem",
  [MODAL_IMAGE_EDIT_SUBTITLE]: "Edite as suas imagens com IA",
  [MODAL_IMAGE_EDIT_PROCESSING_MESSAGE]: "Pensando",
  [MODAL_IMAGE_EDIT_ERROR_CONVERT_BASE64]:
    "Não foi possível converter a imagem para base64",
  [MODAL_IMAGE_EDIT_ERROR_EDITING]: "Erro ao editar a imagem",
  [MODAL_IMAGE_EDIT_ERROR_PROCESSING]: "Não foi possível processar a imagem",
  [MODAL_IMAGE_EDIT_INPUT_PLACEHOLDER]:
    "Descreva as alterações que você quer...",
  [MODAL_IMAGE_EDIT_EDITING_LABEL]: "Editando",
  [MODAL_IMAGE_EDIT_LOADING_LABEL]: "Carregando",
  [MODAL_IMAGE_EDIT_IMAGE_NOT_FOUND]: "Imagem não encontrada",
  [MODAL_IMAGE_EDIT_START_CREATING]: "Comece a criar a sua primeira imagem",
  [MODAL_IMAGE_EDIT_IMAGE_ALT]: "Imagem a editar",
  [MODAL_IMAGE_EDIT_VERSION_FORMAT]: "V{{version}} - IMAGEM",
  [MODAL_IMAGE_EDIT_ORIGINAL_IMAGE_LABEL]: "Imagem original",
  [MODAL_IMAGE_EDIT_EDITED_IMAGE_LABEL]: "Imagem editada v{{version}}",
  [MODAL_IMAGE_EDIT_SAVE_ALERT_TITLE]: "Como você quer salvar esta imagem?",
  [MODAL_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION]:
    "Você pode substituir a imagem original ou criar uma nova versão com as suas alterações.",
  [MODAL_IMAGE_EDIT_REPLACE_BUTTON]: "Substituir",

  // MODAL VIDEO EDITOR
  [MODAL_VIDEO_EDITOR_TITLE]: "Editor de vídeo",
  [MODAL_VIDEO_EDITOR_EDIT_VIDEO]: "Editar vídeo",
  [MODAL_VIDEO_EDITOR_ADD_VIDEO]: "Adicionar vídeo",
  [MODAL_VIDEO_EDITOR_ADD_IMAGE]: "Adicionar imagem",
  [MODAL_VIDEO_EDITOR_ADD_AUDIO]: "Adicionar áudio",
  [MODAL_VIDEO_EDITOR_ADD_SUBTITLES]: "Adicionar legendas",
  [MODAL_VIDEO_EDITOR_EXPORTING]: "Exportando vídeo...",
  [MODAL_VIDEO_EDITOR_SAVE_ERROR]: "Não foi possível salvar o vídeo editado",
  [MODAL_VIDEO_EDITOR_SPLIT_HINT]:
    "Clique duas vezes em uma faixa para dividir no playhead",
  [MODAL_VIDEO_EDITOR_ARIA_LABEL]: "Editor de vídeo",
  [MODAL_VIDEO_EDITOR_TRACK_VIDEO]: "Arrastar ou enviar conteúdo",
  [MODAL_VIDEO_EDITOR_TRACK_IMAGE]: "Adicionar elementos",
  [MODAL_VIDEO_EDITOR_TRACK_AUDIO]: "Adicionar áudio",
  [MODAL_VIDEO_EDITOR_CLIP_DURATION]: "{{count}} s",
  [MODAL_VIDEO_EDITOR_SPLIT_CLIP]: "Dividir",
  [MODAL_VIDEO_EDITOR_CLIP_ACTIONS]: "Ações do clipe",
  [MODAL_VIDEO_EDITOR_BRAND]: "Vídeo",
  [MODAL_VIDEO_EDITOR_EMPTY_STAGE_TITLE]: "O seu vídeo aparecerá aqui",
  [MODAL_VIDEO_EDITOR_EMPTY_STAGE_HINT]: "Importe um arquivo para começar",
  [MODAL_VIDEO_EDITOR_DROP_HINT]: "ou arraste e solte o conteúdo",
  [MODAL_VIDEO_EDITOR_PLAY]: "Reproduzir",
  [MODAL_VIDEO_EDITOR_PAUSE]: "Pausar",
  [MODAL_VIDEO_EDITOR_DEFAULT_PROJECT_NAME]: "O seu projeto de vídeo",
  [MODAL_VIDEO_EDITOR_TIMELINE_ARIA]: "Linha do tempo do editor de vídeo",
  [MODAL_VIDEO_EDITOR_TIMELINE_RESIZE]: "Redimensionar linha do tempo",
  [MODAL_VIDEO_EDITOR_INSERT_START]: "Início",
  [MODAL_VIDEO_EDITOR_INSERT_END]: "Fim",
  [MODAL_VIDEO_EDITOR_ANALYZING_SUBTITLES]: "Analisando legendas…",
  [MODAL_VIDEO_EDITOR_TRACK_SUBTITLE]: "Legendas",
  [MODAL_VIDEO_EDITOR_CAPTIONS_ARIA]: "Legendas",
  [MODAL_VIDEO_EDITOR_CAPTIONS_DISABLE]: "Desativar",
  [MODAL_VIDEO_EDITOR_CAPTIONS_ENABLE]: "Ativar",
  [MODAL_VIDEO_EDITOR_SAVE_ALERT_TITLE]: "Como você quer salvar este vídeo?",
  [MODAL_VIDEO_EDITOR_SAVE_ALERT_DESCRIPTION]:
    "Você pode substituir o vídeo original ou criar uma nova versão com as suas alterações.",
  [MODAL_VIDEO_EDITOR_ANALYZE_SUBTITLES_ERROR]:
    "Não foi possível analisar as legendas",
  [MODAL_VIDEO_EDITOR_PROPERTIES_TITLE]: "Propriedades da camada",
  [MODAL_VIDEO_EDITOR_PROPERTIES_EMPTY]:
    "Selecione uma camada na linha do tempo",
  [MODAL_VIDEO_EDITOR_PROPERTIES_NAME]: "Nome",
  [MODAL_VIDEO_EDITOR_PROPERTIES_VOLUME]: "Volume",
  [MODAL_VIDEO_EDITOR_PROPERTIES_MIXED]: "Misto",
  [MODAL_VIDEO_EDITOR_PROPERTIES_SELECTED_COUNT]: "{{count}} camadas",
  [MODAL_VIDEO_EDITOR_PROPERTIES_POSITION]: "Posição",
  [MODAL_VIDEO_EDITOR_PROPERTIES_SIZE]: "Tamanho",
  [MODAL_VIDEO_EDITOR_PROPERTIES_X]: "X",
  [MODAL_VIDEO_EDITOR_PROPERTIES_Y]: "Y",
  [MODAL_VIDEO_EDITOR_PROPERTIES_WIDTH]: "Largura",
  [MODAL_VIDEO_EDITOR_PROPERTIES_HEIGHT]: "Altura",
  [MODAL_IMAGE_EDIT_SAVE_AS_NEW_BUTTON]: "Salvar como nova",
  [MODAL_IMAGE_EDIT_WORK_MODE_LABEL]: "Escolha como trabalhar",
  [MODAL_IMAGE_EDIT_GENERATIVE_TITLE]: "Edição com IA",
  [MODAL_IMAGE_EDIT_GENERATIVE_DESCRIPTION]: "Transforma a imagem completa",
  [MODAL_IMAGE_EDIT_LAYERS_TITLE]: "Edição manual",
  [MODAL_IMAGE_EDIT_LAYERS_DESCRIPTION]: "Mova cada elemento separadamente",
  [MODAL_IMAGE_EDIT_LAYERS_BADGE_NEW]: "NOVO",
  [MODAL_IMAGE_EDIT_LAYERS_EMPTY_TITLE]: "Edição manual",
  [MODAL_IMAGE_EDIT_LAYERS_EMPTY_DESCRIPTION]:
    "Analise a imagem para separar cada elemento e editá-lo de forma independente.",
  [MODAL_IMAGE_EDIT_LAYERS_ERROR_TITLE]: "Não foi possível analisar",
  [MODAL_IMAGE_EDIT_LAYERS_ERROR_DESCRIPTION]:
    "Não foi possível separar as camadas desta imagem. Tente novamente.",
  [MODAL_IMAGE_EDIT_LAYERS_ADD]: "Adicionar",
  [MODAL_IMAGE_EDIT_LAYERS_LIST_TITLE]: "Elementos do design",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_IMAGE]: "Imagem",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_OBJECT]: "Objeto",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_TEXT]: "Texto",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_LOGO]: "Logo",
  [MODAL_IMAGE_EDIT_LAYERS_BACKGROUND]: "Fundo",
  [MODAL_IMAGE_EDIT_LAYERS_FALLBACK_NAME]: "Camada {{index}}",
  [MODAL_IMAGE_EDIT_LAYERS_ANALYZING]: "Analisando camadas",
  [MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_TITLE]: "Aviso",
  [MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_DESCRIPTION]:
    "Se você fizer uma edição com IA, a separação por elementos desta imagem será perdida porque uma nova será gerada.",
  [MODAL_IMAGE_EDIT_CLOSE_TITLE]: "Fechar o editor?",
  [MODAL_IMAGE_EDIT_CLOSE_DESCRIPTION]:
    "Se você fechar agora, as alterações não salvas serão perdidas.",
  [ANALYZE_LAYERS_EDIT_TEXT_TITLE]: "Detecção de camadas de texto",
  [ANALYZE_LAYERS_EDIT_TEXT_DESCRIPTION]:
    "Editar texto pode gerar camadas inconsistentes ou fazer com que decorações se percam. Você pode adicionar manualmente os elementos que faltarem, se precisar.",
  [ANALYZE_LAYERS_EXTRACT_TEXT_ENABLE_BUTTON]: "Ativar",
  [ANALYZE_LAYERS_EXTRACT_TEXT_DISABLE_BUTTON]: "Desativar",

  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_IMAGE]: "Imagem",
  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO]: "Vídeo",
  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO_BETA]: "Vídeo (Beta)",
  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_CAROUSEL]: "Carrossel",
  [MODAL_CREATE_WITH_IA_IMAGE_TYPE_REALISTA]: "Realista",
  [MODAL_CREATE_WITH_IA_IMAGE_TYPE_PRODUCTO]: "Produto",
  [MODAL_CREATE_WITH_IA_LANGUAGE_ES]: "Espanhol",
  [MODAL_CREATE_WITH_IA_LANGUAGE_EN]: "English",
  [MODAL_CREATE_WITH_IA_LANGUAGE_FR]: "Français",
  [MODAL_CREATE_WITH_IA_LANGUAGE_DE]: "Deutsch",
  [MODAL_CREATE_WITH_IA_LANGUAGE_IT]: "Italiano",
  [MODAL_CREATE_WITH_IA_DIMENSION_SQUARE]: "Quadrada (1200x1200)",
  [MODAL_CREATE_WITH_IA_DIMENSION_HORIZONTAL]: "Horizontal (1920x1080)",
  [MODAL_CREATE_WITH_IA_DIMENSION_VERTICAL]: "Vertical (1080x1920)",
  [MODAL_CREATE_WITH_IA_LABEL_MEDIA_TYPE]: "Formato",
  [MODAL_CREATE_WITH_IA_LABEL_IMAGE_TYPE]: "Tipo",
  [MODAL_CREATE_WITH_IA_LABEL_VIDEO_TYPE]: "Tipo de vídeo",
  [MODAL_CREATE_WITH_IA_LABEL_LANGUAGE]: "Idioma",
  [MODAL_CREATE_WITH_IA_LABEL_WITH_SUBTITLES]: "Com legendas",
  [MODAL_CREATE_WITH_IA_LABEL_AI_WATERMARK]: "Marca d'água de IA",
  [MODAL_CREATE_WITH_IA_AI_WATERMARK_DESCRIPTION]:
    "Algumas plataformas exigem, por regulamentação, uma marca d'água em vídeos gerados com IA para identificá-los.",
  [MODAL_SUBTITLE_OPTIONS_TITLE]: "Personalize as suas legendas",
  [MODAL_SUBTITLE_OPTIONS_PERSONALIZE]: "Personalizar legendas",
  [MODAL_SUBTITLE_OPTIONS_FONT_FAMILY]: "Fonte",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE]: "Estilo da tipografia",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_NORMAL]: "Normal",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD]: "Negrito",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_ITALIC]: "Itálico",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD_ITALIC]: "Negrito e itálico",
  [MODAL_SUBTITLE_OPTIONS_SUBTITLE_COLOR]: "Cor do texto",
  [MODAL_SUBTITLE_OPTIONS_DO_HIGHLIGHT]: "Destacar palavras",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_COLOR]: "Cor do destaque",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE]: "Efeito do destaque",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_KARAOKE]: "Karaoke",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_WORD]: "Por palavra",
  [MODAL_SUBTITLE_OPTIONS_PRESET]: "Preset",
  [MODAL_SUBTITLE_OPTIONS_PRESET_KARAOKE]: "Karaoke",
  [MODAL_SUBTITLE_OPTIONS_PRESET_HIGHLIGHT]: "Highlight",
  [MODAL_SUBTITLE_OPTIONS_PRESET_BOXED]: "Caixas",
  [MODAL_SUBTITLE_OPTIONS_BOX_COLOR]: "Cor da caixa",
  [MODAL_SUBTITLE_OPTIONS_HAS_BACKGROUND]: "Fundo atrás do texto",
  [MODAL_SUBTITLE_OPTIONS_BACKGROUND_COLOR]: "Cor do fundo",
  [MODAL_SUBTITLE_OPTIONS_PREVIEW_LABEL]:
    "Assim ficaria a legenda do meu vídeo",
  [MODAL_CREATE_WITH_IA_LABEL_ACCENT]: "Sotaque",
  [MODAL_CREATE_WITH_IA_LABEL_LOCATION]: "Localização",
  [MODAL_CREATE_WITH_IA_LABEL_DIMENSIONS]: "Dimensões",
  [MODAL_CREATE_WITH_IA_LABEL_PLATFORM]: "Otimizar para",
  [MODAL_CREATE_WITH_IA_PLATFORM_DEFAULT]: "Neutro",
  [MODAL_CREATE_WITH_IA_LABEL_CAROUSEL]: "Carrossel",
  [MODAL_CREATE_WITH_IA_LABEL_NUMBER_OF_IMAGES]: "Número de imagens",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_NUMBER_OF_IMAGES]: "Ex.: 3",
  [MODAL_CREATE_WITH_IA_PLATFORM_META]: "Meta",
  [MODAL_CREATE_WITH_IA_PLATFORM_TIKTOK]: "TikTok",
  [MODAL_CREATE_WITH_IA_PLATFORM_GOOGLE]: "Google",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION]:
    "Gere imagens de modelos femininas usando as minhas sandálias em uma praia tropical...",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION_VIDEO]:
    "Gere um vídeo mostrando o meu produto em ação, destacando características e benefícios principais...",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_IMAGE_URL]: "URL da imagem...",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_WEBSITE_URL]: "URL do site...",
  [MODAL_CREATE_WITH_IA_WARNING_REFERENCE_IMAGE]:
    "Para gerar imagens, você deve enviar imagens do seu produto",
  [MODAL_CREATE_WITH_IA_URLS_ADDED]: "URLs adicionadas {{count}}",
  [MODAL_CREATE_WITH_IA_IMAGES_COUNT]: "Imagens do produto {{count}}",
  [MODAL_CREATE_WITH_IA_SERVICE_IMAGES_COUNT]: "Imagens do serviço {{count}}",
  [MODAL_CREATE_WITH_IA_GENERATING]: "Gerando...",
  [MODAL_CREATE_WITH_IA_GENERATE_WITH_AI]: "Gerar",
  [MODAL_CREATE_WITH_IA_IMAGES_CREATED]: "{{count}} criativos criados",
  [MODAL_CREATE_WITH_IA_GENERATING_IMAGES]: "Gerando criativos...",
  [MODAL_CREATE_WITH_IA_YOU_CAN_LEAVE_THE_PAGE]: "Você pode sair da página",
  [`${MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS}_one`]:
    "{{count}} geração em andamento",
  [MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS]:
    "{{count}} gerações em andamento",
  [MODAL_CREATE_WITH_IA_GENERATION_FAILED]:
    "Não foi possível gerar este conteúdo",
  [MODAL_CREATE_WITH_IA_MAX_CONCURRENT_GENERATIONS]:
    "Você tem {{count}} gerações em andamento. Aguarde uma terminar para gerar outra.",
  [MODAL_CREATE_WITH_IA_ERROR_LOADING_IMAGE]: "Erro ao carregar a imagem",
  [MODAL_CREATE_WITH_IA_GENERATED_IMAGE_ALT]: "Imagem gerada {{index}}",
  [MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY]: "Salvar conteúdo ({{count}})",
  [MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY_NO_COUNT]: "Salvar conteúdo",
  [MODAL_CREATE_WITH_IA_SAVING_TO_GALLERY]: "Salvando...",
  [MODAL_CREATE_WITH_IA_SAVED_SUCCESSFULLY]: "Conteúdo salvo",
  [MODAL_CREATE_WITH_IA_DOWNLOAD_ALL]: "Baixar todas",
  [MODAL_CREATE_WITH_IA_MORE_VARIATIONS]: "Mais variações",
  [MODAL_CREATE_WITH_IA_ARIA_LABEL]: "Modal de criação com IA",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_ADVANCED]: "Configuração avançada",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL]: "Formato",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL_VIDEO]: "Formato de vídeo",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_HELPER]:
    "Use um destes formatos populares.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NONE]: "Sem formato",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_WHATSAPP]: "Mensagem de WhatsApp",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_IG_STORY]: "Story do IG",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_APOLOGY]: "Pedido de Desculpas",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_NEWS]: "Notícia",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_TEXT_POST]: "Post de Texto",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_COMMENT_THREAD]: "Fio de Comentários",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_REVIEW_CAPTURE]:
    "Captura de Avaliação",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_SEARCH_AUTOCOMPLETE]:
    "Busca e Autocompletar",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_CHECKLIST]: "Checklist",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_EMAIL_CAPTURE]: "Captura de E-mail",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_TEXT_POST]:
    "Uma opinião em formato de publicação: avatar, nome e texto. A voz de uma pessoa, não a de um logo.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_COMMENT_THREAD]:
    "Uma pergunta e várias respostas empilhadas, como em um fórum. A prova social de alguém que não conhece você.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_REVIEW_CAPTURE]:
    "Estrelas, nome e texto. A prova social mais forte e também a mais vigiada pelos reguladores.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_SEARCH_AUTOCOMPLETE]:
    "Uma barra de busca com a pergunta que o seu cliente já faz. A sua marca é a resposta.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_CHECKLIST]:
    "Uma lista com caixas marcadas e uma sem marcar: o seu produto é o que falta.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_EMAIL_CAPTURE]:
    "Uma caixa de entrada com um assunto que prende. É lida em meio segundo.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_LOAD_ERROR]:
    "Não foi possível carregar os formatos.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION]: "Explicação",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO]:
    "Para este formato recomendamos as dimensões {{aspectRatio}}. Altere-as clicando",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO_ACTION]: "aqui",
  [MODAL_CREATE_WITH_IA_GALLERY_BUTTON]: "Abrir galeria",
  [MODAL_CREATE_WITH_IA_IMPORT_META_AD_LIBRARY]: "Ver concorrentes",
  [COMPETITOR_SCOPE_MENU_ITEM]: "Concorrentes",
  [COMPETITOR_SCOPE_MODAL_TITLE]: "Anúncios de concorrentes",
  [ALERT_COMPETITOR_SCOPE_TITLE]: "Configure a sua marca",
  [ALERT_COMPETITOR_SCOPE_DESCRIPTION]:
    "Complete a configuração da sua marca para ver os anúncios dos seus concorrentes.",
  [ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_TITLE]:
    "Adicione os seus concorrentes",
  [ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_DESCRIPTION]:
    "Adicione pelo menos um concorrente na configuração da sua marca para ver os anúncios dele.",
  [BUTTON_CONFIGURE_BRAND]: "Configurar marca",
  [BUTTON_CONFIGURE_COMPETITORS]: "Configurar concorrentes",
  [MODAL_COMPETITORS_CONFIRM_REFERENCE_TITLE]:
    "Usar este anúncio como referência?",
  [MODAL_COMPETITORS_CONFIRM_REFERENCE_DESCRIPTION]:
    "Este anúncio de concorrente será usado como referência de estilo para o seu criativo.",
  [MODAL_COMPETITORS_PREPARING_REFERENCE]:
    "Preparando para usar como referência...",
  [MODAL_COMPETITORS_SHOW_FAVORITES_ONLY]: "Ver só favoritos",
  [MODAL_COMPETITORS_SHOW_ALL_ADS]: "Ver todos os anúncios",
  [MODAL_COMPETITORS_FAVORITES_EMPTY]: "Você não tem anúncios favoritos.",
  [MODAL_COMPETITORS_SAVED_TO_FAVORITES]: "Salvo em Favoritos",
  [MODAL_COMPETITORS_SAVED_TO_FOLDER]: "Salvo em {{folder}}",
  [MODAL_COMPETITORS_REMOVED_FROM_FOLDER]: "Removido de {{folder}}",
  [MODAL_COMPETITORS_SELECT_FOLDER_TITLE]: "Selecionar pasta",
  [MODAL_COMPETITORS_CHANGE_LOCATION]: "Alterar",
  [MODAL_COMPETITORS_REMOVED_FROM_FAVORITES]: "Removido dos favoritos",
  [MODAL_COMPETITORS_ADD_OPTION]: "Adicionar concorrente",
  [MODAL_COMPETITORS_EDIT_BUTTON]: "Editar concorrentes",
  [MODAL_COMPETITORS_EDIT_TITLE]: "Gerenciar concorrentes",
  [MODAL_COMPETITORS_EDIT_SUBTITLE]:
    "Adicione ou remova marcas que você queira acompanhar",
  [MODAL_COMPETITORS_EDIT_COUNT_ARIA]:
    "{{current}} de {{max}} concorrentes adicionados",
  [MODAL_COMPETITORS_STRONG_SIGNAL]: "Sinal forte",
  [MODAL_COMPETITORS_AD_LIBRARY_CTA_LABEL]: "CTA: {{label}}",
  [MODAL_CREATE_WITH_IA_META_AD_LIBRARY_LOADING]:
    "Carregando referências de concorrentes...",
  [MODAL_GALLERY_META_AD_LIBRARY_EMPTY_CONTENT]:
    "Não há referências disponíveis.",
  [MODAL_META_AD_LIBRARY_COMPETITOR_FILTER_LABEL]: "Concorrente",
  [MODAL_META_AD_LIBRARY_COMPETITOR_ALL]: "Todos os concorrentes",
  [MODAL_META_AD_LIBRARY_PLATFORM_ALL]: "Todas as plataformas",
  [MODAL_META_AD_LIBRARY_DURATION_HOURS]: "{{count}} horas ativas",
  [MODAL_META_AD_LIBRARY_DURATION_DAYS]: "{{count}} dias ativos",
  [MODAL_META_AD_LIBRARY_VIEW_ONLY_TOOLTIP]: "Somente visualização",
  [MODAL_META_AD_LIBRARY_LOADING_RESOLVING_COMPETITORS]:
    "Buscando os seus concorrentes...",
  [MODAL_META_AD_LIBRARY_LOADING_FETCHING_ADS]:
    "Analisando os anúncios deles...",
  [MODAL_META_AD_LIBRARY_LOADING_PREPARING_GALLERY]:
    "Escolhendo os vencedores...",
  [MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TITLE]: "Aviso",
  [MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TEXT]:
    "Se você sair agora, o conteúdo não será salvo.",
  [MODAL_CREATE_WITH_IA_LABEL_VIDEO_DURATION_SECONDS]: "Duração do vídeo",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_12_SECONDS]: "12 segundos",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_15_SECONDS]: "15 segundos",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_20_SECONDS]: "20 segundos",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_25_SECONDS]: "25 segundos",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_30_SECONDS]: "30 segundos",

  // VIDEO TYPES
  [VIDEO_TYPE_UNBOXING]: "Unboxing",
  [VIDEO_TYPE_PRODUCT_SHOWCASE]: "Product showcase",
  [VIDEO_TYPE_UGC]: "UGC",
  [VIDEO_TYPE_LIFESTYLE]: "Lifestyle",
  [VIDEO_TYPE_TESTIMONIALS_REVIEWS]: "Depoimentos / avaliações",
  [VIDEO_TYPE_TESTIMONIAL]: "Depoimento",
  [VIDEO_TYPE_EMOTIONAL_STORYTELLING]: "Storytelling emocional",
  [VIDEO_TYPE_CASE_STUDY]: "Case study",
  [VIDEO_TYPE_CORPORATE]: "Corporativo",
  [VIDEO_TYPE_SURREAL]: "Surrealista",
  [VIDEO_TYPE_MEGA_CREATIVE]: "Mega criativo",
  [VIDEO_TYPE_OTHER]: "Personalizado",

  // ALERTS CAMPAIGNS
  [ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET_LABEL]:
    "É possível que a sua campanha não esteja gerando impressões porque não tem um objetivo de marketing configurado. Para verificar, vá ao Gerenciador de anúncios de {{platform}}, busque a sua campanha, clique no ícone de configuração e confira se há um objetivo de marketing definido.",
  [ALERT_PIXEL_NOT_FIRED_LABEL]:
    "O pixel configurado nesta campanha não registrou eventos nos últimos 7 dias.",
  [ALERT_CAMPAIGN_STARTED_LABEL]:
    "A sua campanha está ativa há mais de 2 dias sem gerar impressões. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_CAMPAIGN_CPA_HIGH_LABEL]:
    "{{platform}} tem um CPA de {{cpa}} {{currency}} nos últimos 14 dias, acima do objetivo de {{targetCpa}} {{currency}}.",
  [ALERT_AD_ACCOUNT_STATUS_LABEL]:
    "A conta de anúncios tem um aviso. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_DISABLED_LABEL]:
    "Conta de anúncios desativada. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_UNSETTLED_LABEL]:
    "Conta de anúncios com saldo pendente sem pagamento. É possível que os anúncios não estejam sendo exibidos.",
  [ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY_LABEL]:
    "Conta de anúncios sem saldo disponível. É possível que os anúncios não estejam sendo exibidos.",
  [ALERT_AD_ACCOUNT_NO_BALANCE_LABEL]:
    "Sua conta de anúncios não tem mais saldo. As campanhas podem não estar sendo exibidas. Verifique no Gerenciador de Anúncios de {{platform}}.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW_LABEL]:
    "Conta de anúncios em revisão por atividade suspeita. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT_LABEL]:
    "A conta de anúncios está processando um pagamento pendente. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD_LABEL]:
    "Conta de anúncios em período de carência por um pagamento pendente. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE_LABEL]:
    "Conta de anúncios em processo de encerramento. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_CLOSED_LABEL]:
    "Conta de anúncios encerrada definitivamente. Disponível apenas para consulta.",
  [ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED_LABEL]:
    "Conta de anúncios com status encerrado desconhecido. Consulte o Gerenciador de anúncios de {{platform}} para mais informações.",
  [ALERT_AD_ACCOUNT_STATUS_LIMITED_LABEL]:
    "Conta de anúncios restrita ou sancionada. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_LABEL]:
    "A revisão da conta de anúncios foi recusada. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL_LABEL]:
    "A revisão final da conta de anúncios foi recusada e não pode ser reenviada. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED_LABEL]:
    "A revisão das alterações da conta de anúncios foi recusada. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW_LABEL]:
    "Conta de anúncios pendente de revisão. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION_LABEL]:
    "Conta de anúncios pendente de verificação. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW_LABEL]:
    "As alterações da conta de anúncios estão pendentes de revisão. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW_LABEL]:
    "Conta de anúncios aguardando uma revisão interna. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH_LABEL]:
    "Conta de anúncios pendente de verificação pública das qualificações. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION_LABEL]:
    "Conta de anúncios sem qualificações verificadas. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING_LABEL]:
    "O contrato da conta de anúncios ainda não está vigente. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_DRAFT_LABEL]:
    "Conta de anúncios em rascunho e ainda não pode exibir anúncios. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD_LABEL]:
    "Conta de anúncios em retenção de faturamento por um problema no método de pagamento ou em um pagamento. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD_LABEL]:
    "A conta de anúncios atingiu o orçamento total. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD_LABEL]:
    "A conta de anúncios atingiu a data de término. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_RESTRICTED_LABEL]:
    "Conta de anúncios restrita por políticas. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD_LABEL]:
    "Conta de anúncios em retenção interna da plataforma. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_STOPPED_LABEL]:
    "Conta de anúncios interrompida e sem entregar anúncios. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_SUSPENDED_LABEL]:
    "Conta de anúncios suspensa. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_CANCELED_LABEL]:
    "Conta de anúncios cancelada. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING_LABEL]:
    "O faturamento da conta de anúncios está pendente de aprovação. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED_LABEL]:
    "O faturamento da conta de anúncios foi cancelado. É possível que os anúncios não estejam sendo exibidos. Consulte o Gerenciador de anúncios de {{platform}} para mais detalhes.",
  [ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS_LABEL]:
    "Nenhum produto do seu Merchant Center tem um status elegível para esta campanha. Revise o status dos seus produtos, pois isso pode prejudicar a entrega da sua campanha.",
  [ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES_LABEL]:
    "Alguns produtos do seu Merchant Center não têm um status elegível para esta campanha. Revise o status dos seus produtos, pois isso pode prejudicar a entrega da sua campanha.",
  [ALERT_AD_CPA_LOW_LABEL]:
    "O CPA deste anúncio supera em pelo menos 30% o CPA médio do seu conjunto de anúncios.",
  [ALERT_AD_CPA_MEDIUM_LABEL]:
    "O CPA deste anúncio supera em pelo menos 50% o CPA médio do seu conjunto de anúncios.",
  [ALERT_AD_CPA_HIGH_LABEL]:
    "O CPA deste anúncio é pelo menos o dobro do CPA médio do seu conjunto de anúncios.",
  [ALERT_ASSET_GROUP_CPA_LOW_LABEL]:
    "O CPA deste Asset Group supera em pelo menos 30% o CPA médio da campanha.",
  [ALERT_ASSET_GROUP_CPA_MEDIUM_LABEL]:
    "O CPA deste Asset Group supera em pelo menos 50% o CPA médio da campanha.",
  [ALERT_ASSET_GROUP_CPA_HIGH_LABEL]:
    "O CPA deste Asset Group duplica ou supera o CPA médio da campanha.",
  [ALERT_AD_GROUP_CPA_LOW_LABEL]:
    "O CPA deste grupo de anúncios supera em pelo menos 30% o CPA médio da campanha.",
  [ALERT_AD_GROUP_CPA_MEDIUM_LABEL]:
    "O CPA deste grupo de anúncios supera em pelo menos 50% o CPA médio da campanha.",
  [ALERT_AD_GROUP_CPA_HIGH_LABEL]:
    "O CPA deste grupo de anúncios duplica ou supera o CPA médio da campanha.",
  [ALERT_AD_CPA_LOW_TABLE_LABEL]:
    "Um anúncio supera em pelo menos 30% o CPA médio do seu conjunto de anúncios.",
  [ALERT_AD_CPA_MEDIUM_TABLE_LABEL]:
    "Um anúncio supera em pelo menos 50% o CPA médio do seu conjunto de anúncios.",
  [ALERT_AD_CPA_HIGH_TABLE_LABEL]:
    "Um anúncio duplica o CPA médio do seu conjunto de anúncios.",
  [ALERT_ASSET_GROUP_CPA_LOW_TABLE_LABEL]:
    "Um Asset Group supera em pelo menos 30% o CPA médio da campanha.",
  [ALERT_ASSET_GROUP_CPA_MEDIUM_TABLE_LABEL]:
    "Um Asset Group supera em pelo menos 50% o CPA médio da campanha.",
  [ALERT_ASSET_GROUP_CPA_HIGH_TABLE_LABEL]:
    "Um Asset Group duplica ou supera o CPA médio da campanha.",
  [ALERT_AD_GROUP_CPA_LOW_TABLE_LABEL]:
    "Um grupo de anúncios supera em pelo menos 30% o CPA médio da campanha.",
  [ALERT_AD_GROUP_CPA_MEDIUM_TABLE_LABEL]:
    "Um grupo de anúncios supera em pelo menos 50% o CPA médio da campanha.",
  [ALERT_AD_GROUP_CPA_HIGH_TABLE_LABEL]:
    "Um grupo de anúncios duplica ou supera o CPA médio da campanha.",
  [ALERT_CREATIVE_FATIGUE_MEDIUM_LABEL]:
    "Este anúncio tem fadiga criativa média. Vale a pena começar a renovar o criativo.",
  [ALERT_CREATIVE_FATIGUE_HIGH_LABEL]:
    "Este anúncio tem fadiga criativa alta. Renove o criativo para recuperar o desempenho.",
  [ALERT_CREATIVE_FATIGUE_MEDIUM_TABLE_LABEL]:
    "Um anúncio tem fadiga criativa média.",
  [ALERT_CREATIVE_FATIGUE_HIGH_TABLE_LABEL]:
    "Um anúncio tem fadiga criativa alta.",

  // CARDS IN CHAT BOT
  [CARD_GENERATE_COPY]: "Geração de copy",
  [CARD_GENERATE_COPY_DESCRIPTION]: "Criar textos persuasivos para anúncios",
  [CARD_GENERATE_COPY_QUESTION]:
    "Me dê sugestões para melhorar os textos dos anúncios da minha campanha",
  [CARD_GET_CAMPAIGN_LEARNINGS]: "Obter aprendizados da campanha",
  [CARD_GET_CAMPAIGN_LEARNINGS_DESCRIPTION]:
    "Saber o que funciona e o que não funciona na sua campanha",
  [CARD_GET_CAMPAIGN_LEARNINGS_QUESTION]:
    "Quais aprendizados você pode me dar sobre a minha campanha?",
  [CARD_OPTIMIZE_GENERAL]: "Recomendações gerais",
  [CARD_OPTIMIZE_GENERAL_DESCRIPTION]:
    "Sugestões para melhorar o desempenho geral",
  [CARD_OPTIMIZE_GENERAL_QUESTION]:
    "Que recomendações você me dá para melhorar a minha campanha?",
  [CARD_MANAGE_BUDGET]: "Gestão de orçamento",
  [CARD_MANAGE_BUDGET_DESCRIPTION]: "Otimizar a distribuição do orçamento",
  [CARD_MANAGE_BUDGET_QUESTION]:
    "Me dê sugestões para otimizar o orçamento da minha campanha",
  // Owner dashboard chat cards
  [CARD_OWNER_CLIENT_HEALTH]: "Saúde do cliente",
  [CARD_OWNER_CLIENT_HEALTH_DESCRIPTION]:
    "Entender pontuações de saúde e contas em risco",
  [CARD_OWNER_CLIENT_HEALTH_QUESTION]:
    "Quais clientes têm pontuação de saúde baixa e o que posso fazer?",
  [CARD_OWNER_INSIGHTS]: "Insights",
  [CARD_OWNER_INSIGHTS_DESCRIPTION]:
    "Revise insights e tendências da plataforma",
  [CARD_OWNER_INSIGHTS_QUESTION]: "Quais insights devo revisar hoje?",
  [CARD_OWNER_ACCOUNTS]: "Contas",
  [CARD_OWNER_ACCOUNTS_DESCRIPTION]: "Gerencie contas de clientes e acessos",
  [CARD_OWNER_ACCOUNTS_QUESTION]: "Como gerencio as contas de clientes?",
  [CARD_OWNER_BILLING]: "Faturamento",
  [CARD_OWNER_BILLING_DESCRIPTION]: "Revise faturamento, planos e pagamentos",
  [CARD_OWNER_BILLING_QUESTION]: "Me dê um resumo de faturamento e planos",
  [CARD_OWNER_SUPPORT]: "Suporte",
  [CARD_OWNER_SUPPORT_DESCRIPTION]:
    "Obtenha ajuda com problemas de clientes e escalonamentos",
  [CARD_OWNER_SUPPORT_QUESTION]:
    "Quais problemas de suporte precisam de atenção?",
  [CARD_OWNER_CLIENTS_ACCOUNTS]: "Clientes e contas",
  [CARD_OWNER_CLIENTS_ACCOUNTS_DESCRIPTION]:
    "Resumo de clientes, inícios de sessão e atividade",
  [CARD_OWNER_CLIENTS_ACCOUNTS_QUESTION]:
    "Resuma os meus clientes e a atividade recente deles",
  [CARD_OWNER_BRANDS]: "Marcas",
  [CARD_OWNER_BRANDS_DESCRIPTION]: "Gerenciar marcas e configurações",
  [CARD_OWNER_BRANDS_QUESTION]: "Como adiciono ou gerencio marcas no painel?",
  [CARD_OWNER_PLANS_MRR]: "Planos e MRR",
  [CARD_OWNER_PLANS_MRR_DESCRIPTION]: "Receita, planos e uso",
  [CARD_OWNER_PLANS_MRR_QUESTION]: "Me dê um resumo do MRR e do uso dos planos",
  // Date range presets
  [DATE_RANGE_PRESET_TODAY]: "Hoje",
  [DATE_RANGE_PRESET_YESTERDAY]: "Ontem",
  [DATE_RANGE_PRESET_LAST_7]: "Últimos 7 dias",
  [DATE_RANGE_PRESET_LAST_14]: "Últimos 14 dias",
  [DATE_RANGE_PRESET_LAST_30]: "Últimos 30 dias",
  [DATE_RANGE_PRESET_THIS_WEEK]: "Esta semana",
  [DATE_RANGE_PRESET_LAST_WEEK]: "Semana passada",
  [DATE_RANGE_PRESET_THIS_MONTH]: "Este mês",
  [DATE_RANGE_PRESET_LAST_MONTH]: "Mês passado",
  [DATE_RANGE_PRESET_THIS_YEAR]: "Este ano",
  [DATE_RANGE_PRESET_LAST_YEAR]: "Ano passado",

  [NPS_FORM_TITLE]:
    "Qual a probabilidade de você recomendar {{NAME_BUSINESS}} a um amigo ou colega?",
  [NPS_LABEL_NOT_LIKELY_AT_ALL]: "Pouco provável",
  [NPS_LABEL_EXTREMELY_LIKELY]: "Muito provável",
  [NPS_SAVING_RATING]: "Salvando a sua avaliação...",
  [NPS_THANK_YOU_TITLE]: "Obrigado pela sua avaliação!",
  [NPS_THANK_YOU_DESCRIPTION]:
    "A sua opinião é muito importante para nós e nos ajuda a melhorar {{NAME_BUSINESS}}.",

  //MODAL OVERLAP CONFLICTS
  [MODAL_OVERLAP_CONFLICTS_TITLE]: "Algumas localizações se sobrepõem",
  [MODAL_OVERLAP_CONFLICTS_DESCRIPTION]:
    "Foram detectados conflitos. Se você continuar, vamos remover as localizações sobrepostas.",
  [PAGE_NUMBER]: "Página {{number}}",

  //TABLE ADMIN DASHBOARD
  [TABLE_ADMIN_DASHBOARD_CLIENT]: "Cliente",
  [TABLE_ADMIN_DASHBOARD_RENEW_DATE]: "Data de renovação",
  [TABLE_ADMIN_DASHBOARD_RENEW_DATE_VALUE]: "{{date, dd/MM/yyyy}}",
  [TABLE_ADMIN_DASHBOARD_DISCOVERY_SOURCE]: "Origem do contato",
  [TABLE_ADMIN_DASHBOARD_HEALTH_SCORE]: "Health Score",
  [TABLE_ADMIN_DASHBOARD_CAMPAIGNS]: "Campanhas",
  [TABLE_ADMIN_DASHBOARD_KPI]: "KPI",
  [TABLE_ADMIN_DASHBOARD_SPEND]: "Gasto (7d)",
  [TABLE_ADMIN_DASHBOARD_CPA]: "CPA (7d)",
  [TABLE_ADMIN_DASHBOARD_TARGET_CPA]: "CPA objetivo",
  [TABLE_ADMIN_DASHBOARD_ROAS]: "ROAS (7d)",
  [TABLE_ADMIN_DASHBOARD_RESULTS]: "Resultados (7d)",
  [TABLE_ADMIN_DASHBOARD_LAST_LOGIN]: "Último login",
  [TABLE_ADMIN_DASHBOARD_LOGINS]: "Logins (30d)",
  [TABLE_ADMIN_DASHBOARD_USERS]: "Usuários",
  [TABLE_ADMIN_DASHBOARD_AUTOMATION]: "Otimizações (30d)",
  [TABLE_ADMIN_DASHBOARD_MRR]: "MRR",
  [TABLE_ADMIN_DASHBOARD_PLAN]: "Plano",
  [TABLE_ADMIN_DASHBOARD_CREATIVES]: "Criativos",
  [TABLE_ADMIN_DASHBOARD_NPS]: "NPS",
  [TABLE_ADMIN_DASHBOARD_AI_CREATIVES_LAST_30_DAYS]:
    "Criativos de IA salvos (30d)",
  [TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE]: "{{campaignsActive}} ativas",
  [TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE_SINGLE]: "{{campaignsActive}} ativa",
  [TABLE_ADMIN_DASHBOARD_INVOICE_OVERDUE]: "Fatura vencida",
  [TABLE_ADMIN_DASHBOARD_LOADING_MORE]: "Carregando mais clientes...",
  [TABLE_ADMIN_DASHBOARD_SHOWING_CLIENTS]:
    "Mostrando {{count}} de {{total}} clientes",
  [TABLE_ADMIN_CREATIVES_UTILIZED]: "{{creativesUsed}} salvos",
  [TABLE_ADMIN_CREATIVE_UTILIZED]: "{{creativesUsed}} salvo",
  [TABLE_ADMIN_LAST_LOGIN_DAYS]: "Há {{days}}d",
  [TABLE_ADMIN_CANCELLATION_REASON_SUBTITLE]: "Motivo do cancelamento",
  [TABLE_ADMIN_CANCELLATION_REASON_BUTTON]: "Ver motivo",
  [TABLE_ADMIN_CANCELLED_BADGE]: "Cancelou",
  [TABLE_ADMIN_ADD_ADVERTISER_BUTTON]: "Criar marca",
  [TABLE_ADMIN_ADD_CREDITS_BUTTON]: "Adicionar créditos",
  [TABLE_ADMIN_ACTIONS_BUTTON]: "Ações",
  [TABLE_ADMIN_ACTIVATE_PLAN_BUTTON]: "Ativar plano",
  [TABLE_ADMIN_DEACTIVATE_PLAN_BUTTON]: "Desativar plano",
  [TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_TITLE]: "Ativar o plano?",
  [TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_MESSAGE]:
    "Esta ação ativará o plano para esta agência.",
  [TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_TITLE]: "Desativar o plano?",
  [TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_MESSAGE]:
    "Esta ação desativará o plano para esta agência.",
  [TABLE_ADMIN_MARK_DEMO_BUTTON]: "Marcar como conta demo",
  [TABLE_ADMIN_CONFIRM_MARK_DEMO_TITLE]: "Marcar como conta demo?",
  [TABLE_ADMIN_CONFIRM_MARK_DEMO_MESSAGE]:
    "Todas as marcas desta agência serão marcadas como demo. Elas deixarão de aparecer nesta lista.",
  [TABLE_ADMIN_CREDITS_USAGE]: "Créditos: {{used,number}} / {{total,number}}",
  [TABLE_ADMIN_PENDING_PAYMENT_BADGE]: "Pagamento pendente",
  [TABLE_ADMIN_PRIORITY_BADGE]: "Prioridade",
  [TABLE_ADMIN_SEND_EMAIL_BUTTON]: "Enviar e-mail",
  [TABLE_ADMIN_LOGIN_AS_CLIENT_BUTTON]: "Entrar como cliente",
  [OWNER_LOGIN_AS_USER_OPTION]: "{{name}} ({{email}})",
  [OWNER_LOGIN_AS_USER_OPTION_EMAIL]: "{{email}}",
  [OWNER_LOGIN_AS_CONNECTING]: "Entrando como cliente...",
  [OWNER_LOGIN_AS_ERROR_TITLE]: "Não foi possível iniciar sessão",
  [OWNER_LOGIN_AS_ERROR_EXPIRED]:
    "Este link expirou ou já foi usado. Peça a um admin para gerar outro.",
  [OWNER_LOGIN_AS_ERROR_INVALID]: "Este link de início de sessão não é válido.",
  [OWNER_LOGIN_AS_ERROR_MISSING_PARAMS]:
    "Faltam dados obrigatórios neste link.",
  [OWNER_LOGIN_AS_ERROR_GENERIC]:
    "Não foi possível iniciar sessão com este link. Tente novamente.",
  [OWNER_LOGIN_AS_ERROR_USER_NOT_FOUND]:
    "Não foi encontrado um usuário com esse e-mail.",
  [OWNER_LOGIN_AS_ERROR_INVALID_EMAIL]: "O e-mail não é válido.",
  [OWNER_LOGIN_AS_ERROR_FORBIDDEN]:
    "Você não tem permissão para iniciar sessão como este usuário.",
  [OWNER_LOGIN_AS_ERROR_UNAUTHORIZED]:
    "Você não está autorizado a criar um link de acesso ao cliente.",
  [SUPPORT_SESSION_BANNER_TITLE]: "Sessão de suporte ativa",
  [SUPPORT_SESSION_BANNER_DESCRIPTION]:
    "A equipe de suporte está usando esta conta. A sessão será encerrada automaticamente às {{time}}.",
  [SUPPORT_SESSION_ENDED_TITLE]: "A sessão de suporte terminou",
  [SUPPORT_SESSION_ENDED_DESCRIPTION]:
    "As sessões de suporte duram uma hora. Se precisar de mais tempo, entre novamente pelo painel de administração.",
  [TABLE_ADMIN_SEND_EMAIL_MODAL_TITLE]: "Enviar e-mail",
  [TABLE_ADMIN_SEND_EMAIL_SUBJECT_LABEL]: "Assunto",
  [TABLE_ADMIN_SEND_EMAIL_BODY_LABEL]: "Mensagem",
  [TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_LABEL]: "Destinatários",
  [TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_PLACEHOLDER]: "Selecione os destinatários",
  [TABLE_ADMIN_SEND_EMAIL_SELECT_ALL]: "Selecionar todos",
  [TABLE_ADMIN_SEND_EMAIL_SEND_BUTTON]: "Enviar",
  [TABLE_ADMIN_SEND_EMAIL_SUCCESS]: "E-mail enviado com sucesso",
  [TABLE_ADMIN_MODIFY_KPI_CPA_BUTTON]: "Modificar KPI / CPA",
  [TABLE_ADMIN_ENABLE_FEATURES_BUTTON]: "Ativar funcionalidades",
  [TABLE_ADMIN_FEATURE_TYPOGRAPHIC_FIDELITY]: "Fidelidade tipográfica",
  [TABLE_ADMIN_FEATURE_MINIMUM_TERM_CONTRACT]:
    "Cláusula de prazo mínimo (3 meses)",
  [TABLE_ADMIN_AI_IMAGE_MODEL_BUTTON]: "Modelo de IA para imagens",
  [TABLE_ADMIN_AI_IMAGE_PROVIDER_GOOGLE]: "Google",
  [TABLE_ADMIN_AI_IMAGE_PROVIDER_OPENAI]: "OpenAI",
  [TABLE_ADMIN_AI_IMAGE_PROVIDER_SEEDREAM]: "Seedream",
  [MODAL_MODIFY_KPI_CPA_TITLE]: "KPI e CPA objetivo — {{name}}",
  [MODAL_MODIFY_KPI_CPA_PRIMARY_LABEL]: "KPI principal",
  [MODAL_MODIFY_KPI_CPA_TARGET_LABEL]: "CPA objetivo",
  [MODAL_MODIFY_KPI_CPA_CURRENCY_LABEL]: "Moeda",
  [MODAL_MODIFY_KPI_CPA_SAVE_SUCCESS]: "Configuração de KPI e CPA salva",
  [MODAL_MODIFY_KPI_CPA_VOLUMEN_LABEL]:
    "Quantos resultados (do KPI) você quer por mês?",
  [MODAL_CAMPAIGN_KPI_CPA_TITLE]: "Metas da Campanha",
  [MODAL_CAMPAIGN_KPI_CPA_INHERIT_HINT]:
    "Configure uma meta por plataforma (KPI, resultados semanais, CPA e moeda). Se você deixar uma plataforma vazia, a meta da conta será usada.",
  [MODAL_CAMPAIGN_KPI_CPA_WEEKLY_VOLUME_LABEL]:
    "Quantos resultados (do KPI) você quer por semana?",
  [ADMIN_KPI_PRIMARY_LEADS]: "Leads",
  [ADMIN_KPI_PRIMARY_SALES]: "Vendas",
  [ADMIN_KPI_PRIMARY_MESSAGES]: "Mensagens",
  [ADMIN_KPI_PRIMARY_INTERACTIONS]: "Interações",
  [ADMIN_KPI_PRIMARY_TRAFFIC]: "Tráfego",
  [ADMIN_KPI_PRIMARY_CONVERSIONS]: "Conversões",
  [ADMIN_KPI_PRIMARY_DOWNLOADS]: "Instalações",
  [ADMIN_KPI_PRIMARY_APP_INSTALLS]: "Instalações de app",
  [ADMIN_KPI_PRIMARY_VIDEO_VIEWS]: "Reproduções de vídeo",
  [ADMIN_KPI_PRIMARY_AWARENESS]: "Reconhecimento",
  [ADMIN_KPI_PRIMARY_REACH]: "Alcance",
  [ADMIN_KPI_PRIMARY_ENGAGEMENT]: "Engajamento",
  [ADMIN_KPI_PRIMARY_STORE_VISITS]: "Visitas à loja",
  [ADMIN_KPI_PRIMARY_WEBSITE_CONVERSIONS]: "Conversões no site",
  [ADMIN_KPI_PRIMARY_CATALOG_SALES]: "Vendas de catálogo",
  [ADMIN_KPI_PRIMARY_SIGNUPS]: "Cadastros",
  [ADMIN_DASHBOARD_TITLE]: "Painel de saúde dos clientes",
  [OWNER_DASHBOARD_NAV_FORM]: "Formulários",
  [OWNER_DASHBOARD_NAV_REPORTED_CONTENT]: "Conteúdo denunciado",
  [OWNER_DASHBOARD_NAV_PROMOTIONAL_CODES]: "Códigos",
  [OWNER_DASHBOARD_NAV_GLOBAL_NOTIFICATIONS]: "Notificações",
  [OWNER_DASHBOARD_NAV_AD_SPEND]: "Investimento em anúncios",
  [OWNER_AD_SPEND_TITLE]: "Investimento em anúncios",
  [OWNER_AD_SPEND_DESCRIPTION]:
    "Gasto total das campanhas lançadas pela plataforma, em USD.",
  [OWNER_AD_SPEND_PRESET_HISTORIC]: "Histórico",
  [OWNER_AD_SPEND_PRESET_LAST_7]: "Últimos 7 dias",
  [OWNER_AD_SPEND_PRESET_LAST_30]: "Últimos 30 dias",
  [OWNER_AD_SPEND_PRESET_LAST_90]: "Últimos 90 dias",
  [OWNER_AD_SPEND_PRESET_THIS_MONTH]: "Este mês",
  [OWNER_AD_SPEND_PRESET_LAST_MONTH]: "Mês anterior",
  [OWNER_AD_SPEND_PRESET_CUSTOM]: "Personalizado",
  [OWNER_AD_SPEND_CUSTOM_PENDING]:
    "Selecione um intervalo de datas e salve-o para atualizar o relatório.",
  [OWNER_AD_SPEND_ACCURACY_WARNING]:
    "A filtragem por datas anteriores a 15 de outubro de 2026 pode ser imprecisa.",
  [OWNER_AD_SPEND_ACCURACY_WARNING_ESTIMATED]:
    "Inclui {{value}} estimados a partir de estatísticas acumuladas.",
  [OWNER_AD_SPEND_KPI_TOTAL]: "Investimento total",
  [OWNER_AD_SPEND_KPI_ADVERTISERS]: "Anunciantes com investimento",
  [OWNER_AD_SPEND_KPI_COUNTRIES]: "Países",
  [OWNER_AD_SPEND_VS_PREVIOUS_PERIOD]: "Período anterior: {{value}}",
  [OWNER_AD_SPEND_CHART_TITLE]: "Evolução do investimento por plataforma",
  [OWNER_AD_SPEND_CHART_DAILY]: "Diário",
  [OWNER_AD_SPEND_CHART_MONTHLY]: "Mensal",
  [OWNER_AD_SPEND_PLATFORMS_TITLE]: "Participação por plataforma",
  [OWNER_AD_SPEND_TOP_ADVERTISERS_TITLE]: "Contas que mais investem",
  [OWNER_AD_SPEND_TOP_COUNTRIES_TITLE]: "Países que mais investem",
  [OWNER_AD_SPEND_TOP_ADVERTISERS_ARIA]: "Contas que mais investem",
  [OWNER_AD_SPEND_TOP_COUNTRIES_ARIA]: "Países que mais investem",
  [OWNER_AD_SPEND_COLUMN_ADVERTISER]: "Anunciante",
  [OWNER_AD_SPEND_COLUMN_COUNTRY]: "País",
  [OWNER_AD_SPEND_COLUMN_SPEND]: "Investimento",
  [OWNER_AD_SPEND_COLUMN_SHARE]: "% do total",
  [OWNER_AD_SPEND_COLUMN_PLATFORMS]: "Plataformas",
  [OWNER_AD_SPEND_UNASSIGNED_COUNTRY]: "Sem país atribuído",
  [OWNER_AD_SPEND_TREND_NEW]: "Novo",
  [OWNER_AD_SPEND_ESTIMATED_BADGE]: "Estimado",
  [OWNER_AD_SPEND_EMPTY_TITLE]: "Ainda não há investimento registrado",
  [OWNER_AD_SPEND_EMPTY_DESCRIPTION]:
    "Os dados aparecerão após a primeira coleta diária.",
  [OWNER_AD_SPEND_MOCK_BADGE]: "Dados simulados",
  [OWNER_DASHBOARD_NAV_CREATE_USER]: "Criar usuário",
  [OWNER_DASHBOARD_NAV_OPTIONS]: "Opções",
  [OWNER_GLOBAL_NOTIFICATIONS_TITLE]: "Notificações globais",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_TITLE]: "Título",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_BODY]: "Corpo",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_CTA]: "CTA",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK]: "Link",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK_HELPER]:
    "Use um caminho interno como /ads-campaign ou uma URL https completa. Este link é o mesmo para todos os idiomas.",
  [OWNER_GLOBAL_NOTIFICATIONS_CTA_LINK_PAIR_ERROR]:
    "O CTA em todos os idiomas e o link devem ser preenchidos juntos.",
  [OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_BUTTON]: "Publicar e enviar e-mail",
  [OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_SUCCESS]: "Notificação publicada.",
  [MODAL_CREATE_OWNER_USER_ARIA_LABEL]: "Modal de criar usuário owner",
  [MODAL_CREATE_OWNER_USER_TITLE]: "Criar usuário",
  [MODAL_CREATE_OWNER_USER_DESCRIPTION]:
    "Crie um usuário owner com acesso ao painel de administração.",
  [MODAL_CREATE_OWNER_USER_SUCCESS]: "Usuário criado com sucesso",
  [REGISTER_PROMOTIONAL_CODE_LABEL]: "Código promocional (opcional)",
  [REGISTER_PROMOTIONAL_CODE_PLACEHOLDER]: "Digite o seu código",
  [REGISTER_DISCOVERY_SOURCE_LABEL]: "Como você nos conheceu?",
  [OWNER_PROMOTIONAL_CODES_CREATE_TITLE]: "Criar código promocional",
  [OWNER_PROMOTIONAL_CODES_CREATE_BUTTON]: "Criar código",
  [OWNER_PROMOTIONAL_CODES_MODAL_SUBTITLE]:
    "Defina o código, o limite de resgates e se vale para giveaways do AppSumo.",
  [OWNER_PROMOTIONAL_CODES_GENERATE_CODE_TOOLTIP]: "Gerar código aleatório",
  [OWNER_PROMOTIONAL_CODES_FIELD_CODE]: "Código",
  [OWNER_PROMOTIONAL_CODES_FIELD_MAX_REDEMPTIONS]: "Resgates máximos",
  [OWNER_PROMOTIONAL_CODES_FIELD_APP_SUMO]: "Giveaway AppSumo",
  [OWNER_PROMOTIONAL_CODES_FIELD_TIER]: "Nível AppSumo",
  [OWNER_PROMOTIONAL_CODES_TIER_OPTION_1]: "Nível 1",
  [OWNER_PROMOTIONAL_CODES_TIER_OPTION_2]: "Nível 2",
  [OWNER_PROMOTIONAL_CODES_TIER_OPTION_3]: "Nível 3",
  [OWNER_PROMOTIONAL_CODES_COLUMN_CODE]: "Código",
  [OWNER_PROMOTIONAL_CODES_COLUMN_CREATED]: "Criado",
  [OWNER_PROMOTIONAL_CODES_COLUMN_REGISTERED]: "Cadastros",
  [OWNER_PROMOTIONAL_CODES_COLUMN_MAX_REDEMPTIONS]: "Resgates máximos",
  [OWNER_PROMOTIONAL_CODES_COLUMN_TYPE]: "Tipo",
  [OWNER_PROMOTIONAL_CODES_TYPE_VALUE_APP_SUMO]: "AppSumo",
  [OWNER_PROMOTIONAL_CODES_TYPE_APP_SUMO_TIER_SUFFIX]: " - Tier {{tier}}",
  [OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STANDARD]: "Padrão",
  [OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STRIPE_DISCOUNT]: "Desconto Stripe",
  [OWNER_PROMOTIONAL_CODES_FIELD_STRIPE_CODE]: "Código Stripe",
  [OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT]: "Valor do desconto",
  [OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT_TYPE]: "Tipo de desconto",
  [OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_FIXED]: "Fixo (USD)",
  [OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_PERCENTAGE]: "Porcentagem",
  [OWNER_PROMOTIONAL_CODES_ERROR_INVALID_STRIPE_DISCOUNT]:
    "Preencha um código Stripe, um valor e um tipo de desconto válidos",
  [PRICING_PROMO_DISCOUNT_APPLIED]: "Preço com desconto aplicado",
  [OWNER_PROMOTIONAL_CODES_COLUMN_STATUS]: "Situação",
  [OWNER_PROMOTIONAL_CODES_STATUS_ACTIVE]: "Ativo",
  [OWNER_PROMOTIONAL_CODES_STATUS_INACTIVE]: "Inativo",
  [OWNER_PROMOTIONAL_CODES_CREATE_SUCCESS]: "Código promocional criado",
  [OWNER_PROMOTIONAL_CODES_ERROR_DUPLICATE]:
    "Já existe um código com este valor",
  [OWNER_PROMOTIONAL_CODES_ERROR_INVALID]: "Digite um código válido",
  [PROMOTIONAL_CODE_NOT_FOUND]: "Este código promocional não existe.",
  [PROMOTIONAL_CODE_INACTIVE]: "Este código promocional já não está ativo.",
  [PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED]:
    "Este código promocional atingiu o limite de resgates.",
  [ADMIN_DASHBOARD_SUBTITLE]:
    "Acompanhe a participação dos clientes e detecte riscos de cancelamento",
  [ADMIN_DASHBOARD_SEARCH_PLACEHOLDER]: "Buscar por nome...",
  [ADMIN_DASHBOARD_FILTER_STATUS_PLACEHOLDER]: "Filtrar por status",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_TITLE]: "Resumo de saúde dos clientes",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_HEALTHY]: "Saudável",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_WATCHLIST]: "Watchlist",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_AT_RISK]: "Risco de churn",
  [CREATE_BRAND_BUTTON]: "Criar marca",
  [ADMIN_DASHBOARD_CREATE_BRAND_BUTTON]: "Adicionar cliente",
  [ANNOTATIONS_SIDEBAR_AGENCY_HEADER]: "Agência: {{name}}",
  [ANNOTATIONS_SIDEBAR_ADVERTISER_HEADER]: "Marca: {{name}}",
  [ANNOTATIONS_SIDEBAR_EMPTY_TITLE]: "Ainda não há anotações",
  [ANNOTATIONS_SIDEBAR_EMPTY_SUBTITLE]:
    "Deixe notas internas para a sua equipe sobre este cliente. Anexe imagens, PDFs ou vídeos quando precisar.",
  [ANNOTATIONS_SIDEBAR_INPUT_PLACEHOLDER]: "Escreva uma anotação para {{name}}",
  [ANNOTATIONS_SIDEBAR_YOU_LABEL]: "Você",
  [ANNOTATIONS_SIDEBAR_LOADING]: "Carregando anotações...",
  [ANNOTATIONS_SIDEBAR_CLOSE]: "Fechar anotações",
  [ANNOTATIONS_UNREAD_BADGE_ARIA]: "Novas anotações",
  [ANNOTATIONS_UNREAD_COUNT]: "{{count}} novas",
  [ANNOTATIONS_MENTION_ALL]: "Todos",
  [ANNOTATIONS_MENTION_MENU_ARIA]: "Mencionar usuário",
  [ANNOTATIONS_MESSAGE_EDIT]: "Editar",
  [ANNOTATIONS_MESSAGE_DELETE]: "Excluir",
  [ANNOTATIONS_MESSAGE_DELETE_CONFIRM]:
    "Tem certeza de que deseja excluir esta anotação?",
  [ANNOTATIONS_MESSAGE_EDITING]: "Editando mensagem...",
  [ANNOTATIONS_MESSAGE_CANCEL_EDIT]: "Cancelar edição",
  [ANNOTATIONS_MESSAGE_MENU_ARIA]: "Opções da mensagem",
  [ADMIN_DASHBOARD_CREATE_BRAND_MODAL_TITLE]: "Criar marca",
  [ADMIN_DASHBOARD_CREATE_BRAND_MODAL_SUBTITLE]:
    "Configure a conta básica da marca",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_ACTIVE_LABEL]: "Plano ativo",
  [ADMIN_DASHBOARD_USER_CREATED_SUCCESS]: "Usuário criado com sucesso",
  [ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_LABEL]: "É uma conta de teste?",
  [ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_YES]: "Sim, é de teste",
  [ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_NO]: "Não é de teste",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_TYPE_LABEL]: "Tipo de plano",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_RECURRENT_LABEL]: "Recorrência do plano",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_LABEL]: "Plano",
  [ADMIN_DASHBOARD_CREATE_BRAND_HAS_ADDON_SPEND_FEE_LABEL]: "Tem add-on",
  [ADMIN_DASHBOARD_CREATE_BRAND_FEATURES_LABEL]: "Funcionalidades",
  [ADMIN_DASHBOARD_CREATE_BRAND_AD_SPEND_FEE_PERCENTAGE_LABEL]:
    "Comissão sobre o spend (%)",
  [ADMIN_DASHBOARD_CREATE_BRAND_STRIPE_SUBSCRIPTION_ID_LABEL]:
    "ID de assinatura Stripe (opcional)",
  [ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_TITLE]: "Criar marca",
  [ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_BRAND_NAME_LABEL]: "Nome da marca",
  [ADMIN_DASHBOARD_ADVERTISER_CREATED_SUCCESS]: "Marca criada com sucesso",
  [DELETE_BRAND_CONFIRMATION_TITLE]: "Excluir marca",
  [DELETE_BRAND_CONFIRMATION_DESCRIPTION]:
    "Tem certeza de que deseja excluir «{{brandName}}»? Esta ação é definitiva e não pode ser desfeita. Os dados desta marca serão excluídos da agência.",
  [DELETE_BRAND_SUCCESS]: "Marca excluída com sucesso",
  [DELETE_BRAND_ERROR]: "Não foi possível excluir esta marca. Tente novamente.",
  [DELETE_BRAND_MAIN_CANNOT_DELETE]:
    "Não é possível excluir esta marca porque ela é a principal.",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_TITLE]: "Adicionar créditos",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_LABEL]: "Créditos a adicionar",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_PLACEHOLDER]: "Digite os créditos",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MIN_ERROR]:
    "Os créditos devem ser maiores ou iguais a {{min}}",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MAX_ERROR]:
    "Os créditos devem ser menores ou iguais a {{max}}",
  [ADMIN_DASHBOARD_CREDITS_ADDED_SUCCESS]: "Créditos adicionados com sucesso",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_MODAL_TITLE]:
    "Alocação recorrente por marca",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CREDITS_LABEL]: "Limite de créditos",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_VIDEOS_LABEL]: "Limite de vídeos",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CONSUMED_LABEL]:
    "Consumido neste ciclo: {{value}}",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_HINT]:
    "Máximo do plano da agência: {{max}}",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_REMOVE_HINT]:
    "Deixe o campo vazio para remover o limite desta marca.",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_TOTAL_ASSIGNED_LABEL]:
    "Total atribuído",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_LABEL]:
    "Disponível no plano",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_SUCCESS]:
    "Alocação de consumo atualizada",
  [NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE]:
    "Esta marca atingiu o limite de consumo atribuído",
  [NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE_DESCRIPTION]:
    "Fale com o seu administrador para ampliar os limites desta marca",
  [BRAND_USAGE_LIMIT_ALERT_EDIT_LIMITS_BUTTON]: "Editar limites",
  [BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN]:
    "A soma das alocações por marca ultrapassa os benefícios do plano da agência.",
  [BRAND_USAGE_ALLOCATION_BELOW_CONSUMED]:
    "O limite não pode ser menor que o consumo atual da marca neste ciclo.",
  [HEALTH_SCORE_LABEL]: "Health Score",

  // GENERATING CREATIVE ALERTS
  [GENERATING_CREATIVE_TITLE]: "Gerando criativos",
  [GENERATING_CREATIVE_SUCCESS]: "Criativos Gerados com Sucesso",
  [GENERATING_CREATIVE_ERROR]: "Erro ao Gerar Criativos",
  [ALERT_GENERIC_ERROR_TITLE]: "Ocorreu um Erro",
  [GENERATING_CUSTOM_REPORT_MESSAGE]: "Gerando Relatório",
  [GENERATING_CUSTOM_REPORT_SUCCESS]: "Relatório Gerado com Sucesso",
  [GENERATING_CUSTOM_REPORT_ERROR]: "Erro ao Gerar o Relatório",
  [ANALYZING_IMAGE_LAYERS_MESSAGE]: "Analisando Camadas",
  [ANALYZING_IMAGE_LAYERS_SUCCESS]: "Imagem Analisada com Sucesso",
  [ANALYZING_IMAGE_LAYERS_ERROR]: "Erro ao Analisar as Camadas",
  [ANALYZING_CREATIVE_TEMPLATE_MESSAGE]: "Analisando Criativo",
  [ANALYZING_CREATIVE_TEMPLATE_SUCCESS]: "Criativo Analisado com Sucesso",
  [ANALYZING_CREATIVE_TEMPLATE_ERROR]: "Erro ao Analisar o Criativo",
  [PRODUCING_CREATIVE_TEMPLATE_MESSAGE]: "Produzindo Criativos de Modelo",
  [PRODUCING_CREATIVE_TEMPLATE_PREVIEW_MESSAGE]:
    "Produzindo a Preview do Modelo",
  [PRODUCING_CREATIVE_TEMPLATE_PREVIEW_SUCCESS]:
    "Preview do Modelo Produzida com Sucesso",
  [PRODUCING_CREATIVE_TEMPLATE_PREVIEW_ERROR]:
    "Erro ao Produzir a Preview do Modelo",
  [PRODUCING_CREATIVE_TEMPLATE_SUCCESS]:
    "Criativos de Modelo Produzidos com Sucesso",
  [PRODUCING_CREATIVE_TEMPLATE_PARTIAL]:
    "Foram produzidos {{succeeded}} de {{requested}} criativos",
  [PRODUCING_CREATIVE_TEMPLATE_PARTIAL_SINGULAR]:
    "Foi produzido 1 de {{requested}} criativos",
  [PRODUCING_CREATIVE_TEMPLATE_ERROR]: "Erro ao Produzir Criativos de Modelo",
  [EDITING_IMAGE_TITLE]: "Editando imagem",
  [EDITING_IMAGE_SUCCESS]: "Imagem Editada com Sucesso",
  [EDITING_IMAGE_ERROR]: "Erro ao Editar a Imagem",
  [RESIZING_IMAGE_TITLE]: "Redimensionando imagem",
  [RESIZING_IMAGE_SUCCESS]: "Imagem Redimensionada com Sucesso",
  [RESIZING_IMAGE_ERROR]: "Erro ao Redimensionar a Imagem",

  [AGENT_LABEL]: "Agente",
  [GO_TO_DASHBOARD]: "Ir ao dashboard",
  [IMAGES_MODERATION_BLOCKED]: "Imagens bloqueadas pela moderação",

  // Accents
  [ACCENT_ES_ARGENTINO]: "Argentino",
  [ACCENT_ES_COLOMBIANO]: "Colombiano",
  [ACCENT_ES_CHILENO]: "Chileno",
  [ACCENT_ES_MEXICANO]: "Mexicano",
  [ACCENT_ES_ESPANOL_ESPANA]: "Espanhol da Espanha",
  [ACCENT_ES_PERUANO]: "Peruano",
  [ACCENT_ES_VENEZOLANO]: "Venezuelano",
  [ACCENT_ES_CARIBENO]: "Caribenho",
  [ACCENT_ES_NEUTRAL]: "Neutro",

  [ACCENT_EN_AMERICAN]: "Americano",
  [ACCENT_EN_BRITISH]: "Britânico",
  [ACCENT_EN_AUSTRALIAN]: "Australiano",
  [ACCENT_EN_NEUTRAL]: "Neutro",
  [PARTNERSHIP]: "Parceiros",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE]: "Imagem",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO]: "Vídeo",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL]: "Carrossel",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT]: "Documento",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP]: "Configuração do anúncio",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD]: "Criar anúncio",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST]: "Usar publicação",
  [ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING]:
    "Não é possível usar esta publicação de vídeo porque não há URL de download disponível.",
  [AD_FORMAT_PLACEHOLDER]: "Formato de anúncio",
  [SELECT_AD_FORMAT_TO_CONTINUE]:
    "Selecione um formato de anúncio para continuar",

  // Campaign Learnings
  [CAMPAIGN_LEARNINGS_TITLE]: "Aprendizados da campanha",
  [CAMPAIGN_LEARNINGS_SUBTITLE]: "Análise completa",
  [CAMPAIGN_LEARNINGS_KEY_LEARNINGS]: "Aprendizados-chave",
  [CAMPAIGN_LEARNINGS_WHAT_WORKED]: "O que funcionou",
  [CAMPAIGN_LEARNINGS_WHAT_DIDNT_WORK]: "O que não funcionou",
  [PLATFORM_META]: "Meta",
  [PLATFORM_GOOGLE]: "Google",

  // BRAND SETUP CONFIRM MODAL
  [MODAL_BRAND_SETUP_CONFIRM_TITLE]:
    "Deseja guardar esta configuração de marca?",
  [MODAL_BRAND_SETUP_CONFIRM_DESCRIPTION]:
    "Esta configuração será usada como base para a geração de campanhas e de peças publicitárias (imagens e vídeos). Verifique se as informações estão corretas antes de continuar; mesmo assim, você poderá atualizá-las mais tarde.",
  [MODAL_BRAND_SETUP_CONFIRM_BUTTON]: "Continuar",
  [MODAL_BRAND_SETUP_REVIEW_BUTTON]: "Revisar",

  // Facebook Modal Upload
  [MODAL_UPLOAD_FACEBOOK_TYPE_LABEL]: "Tipo de conteúdo do Facebook",
  [TYPE_CONTENT_FACEBOOK_LABEL]: "Tipo de conteúdo",
  [MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL]: "Publicação",
  [MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL]: "História",
  [MODAL_UPLOAD_FACEBOOK_TYPE_REEL_LABEL]: "Reel",

  // CAROUSEL IMAGES
  [INSTAGRAM_FEED_ASPECT_RATIO_WARNING]:
    "O tamanho da sua imagem não coincide com o formato recomendado para publicações do Instagram (ideal: 4:5). Quer ajustá-la?",
  [CAROUSEL_MIN_IMAGES_WARNING]:
    "Você deve selecionar pelo menos 2 imagens para um carrossel",
  [CAROUSEL_MAX_IMAGES_WARNING]: "Você pode selecionar até {{max}} imagens",
  [CAROUSEL_DRAG_TO_REORDER]:
    "Arraste as imagens para alterar a ordem. A primeira será a imagem principal.",
  [CAROUSEL_ADD_MORE_IMAGES]: "Adicionar mais imagens",
  [CAROUSEL_IMAGES_SELECTED]: "{{count}} imagens selecionadas",
  [CAROUSEL_MAIN_IMAGE]: "Principal",

  // TIKTOK
  [TYPE_CONTENT_TIKTOK_LABEL]: "Tipo de conteúdo",
  [MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL]: "Post",
  [MODAL_UPLOAD_TIKTOK_TYPE_VIDEO_LABEL]: "Vídeo",

  // Unified Carousel translation
  [CONTENT_TYPE_CAROUSEL]: "Carrossel",

  // Content type change confirmation
  [CONFIRM_REGENERATE_TEXTS_AFTER_CREATIVE_CHANGE_TITLE]:
    "Deseja regenerar todos os textos com base no novo criativo?",
  [BUTTON_KEEP_TEXTS]: "Manter textos",
  [REGENERATING_AD_TEXTS_OVERLAY_MESSAGE]: "Regenerando textos…",

  [CONFIRM_CHANGE_CONTENT_TYPE_TITLE]:
    "Tem certeza de que deseja alterar o tipo de conteúdo?",
  [CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_CAROUSEL]:
    "Todas as plataformas passarão a Carrossel.",
  [CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_POST]:
    "Todas as plataformas passarão a Post.",

  // PLANS CREDITS
  [ADS_SUBSCRIPTION_BENEFIT_CREDITS]: "{{value,number}} créditos",
  [ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_YEAR]: "{{value,number}} créditos/ano",
  [APPSUMO_SUBSCRIPTION_TIER_1]: "Tier 1",
  [APPSUMO_SUBSCRIPTION_TIER_2]: "Tier 2",
  [APPSUMO_SUBSCRIPTION_TIER_3]: "Tier 3",
  [VALUE_SUBSCRIPTION_ONE_TIME]:
    "{{value,number}} {{currency}} (pagamento único)",
  [BUTTON_APPSUMO_VIEW_PLANS]: "Ver planos no AppSumo",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE]: "Imagem",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO]: "Vídeo",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL]: "Carrossel",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT]: "Documento",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP]: "Configuração do anúncio",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD]: "Criar anúncio",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST]: "Usar publicação",
  [ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING]:
    "Não é possível usar esta publicação de vídeo porque não há URL de download disponível.",
  [AD_FORMAT_PLACEHOLDER]: "Formato de anúncio",
  [SELECT_AD_FORMAT_TO_CONTINUE]:
    "Selecione um formato de anúncio para continuar",

  // CREDIT REWARD MODAL
  [LINKEDIN_ARTICLE_DEFAULT_TEXT]:
    'Desde que integramos {{NAME_BUSINESS}}, a nossa forma de fazer marketing mudou por completo: deixamos de "apenas escrever posts" para desenhar ecossistemas de conteúdo com uma estratégia clara, coerente e focada em resultados.\n\nO que antes era um processo lento hoje é um fluxo 100% otimizado com IA: transformamos ideias em campanhas inteligentes e criamos conteúdo multimídia gerado por inteligência artificial. Além disso, a ferramenta eleva o tom e lapida a mensagem para que cada palavra conte, com mais consistência, zero estresse criativo e uma comunicação que realmente converte.',
  [CREDIT_REWARD_MODAL_TITLE]: "Ganhe créditos grátis",
  [CREDIT_REWARD_MODAL_SUBTITLE]:
    "Faça uma publicação no LinkedIn e ganhe créditos grátis",
  [CREDIT_REWARD_MODAL_ARIA_LABEL]: "Ganhe créditos grátis",
  [CREDIT_REWARD_MODAL_BUTTON_TEXT]: "Ganhe <u><em>créditos grátis</em></u>",
  [CREDIT_REWARD_MODAL_REWARD]: "Recompensa",
  [CREDIT_REWARD_MODAL_REWARD_DESCRIPTION]:
    "Depois de compartilhar a publicação",
  [CREDIT_REWARD_MODAL_ARTICLE_CONTENT_LABEL]: "Conteúdo do artigo",
  [CREDIT_REWARD_MODAL_ARTICLE_CONTENT_PLACEHOLDER]:
    "Escreva o conteúdo do artigo que você deseja publicar...",
  [CREDIT_REWARD_MODAL_VERIFICATION_NOTICE]:
    "A publicação será verificada antes de conceder os créditos",
  [CREDIT_REWARD_MODAL_BUTTON_CANCEL]: "Cancelar",
  [CREDIT_REWARD_MODAL_BUTTON_PUBLISH]: "Publicar e obter créditos",
  [CREDIT_REWARD_MODAL_BUTTON_PUBLISHING]: "Publicando...",
  [CREDIT_REWARD_MODAL_BUTTON_RETRY]: "Tentar novamente",
  [CREDIT_REWARD_MODAL_LOADING_TITLE]: "Verificando publicação",
  [CREDIT_REWARD_MODAL_LOADING_DESCRIPTION]:
    "Isso pode levar alguns segundos...",
  [CREDIT_REWARD_MODAL_SUCCESS_TITLE]: "Publicação realizada",
  [CREDIT_REWARD_MODAL_SUCCESS_TEXT]:
    "+{{credits}} créditos foram adicionados à sua conta. Obrigado por participar!",
  [CREDIT_REWARD_MODAL_ERROR_TITLE]: "Erro ao publicar",
  [CREDIT_REWARD_MODAL_ERROR_TEXT]:
    "Não foi possível creditar os créditos. Verifique a sua publicação e tente novamente.",

  // BRAND SETUP SECTIONS
  [SECTION_COMPETITORS_TITLE]: "Concorrentes",
  [SECTION_COMPETITORS_SUBTITLE_SINGULAR]: "Marca identificada",
  [SECTION_COMPETITORS_SUBTITLE_PLURAL]: "Marcas identificadas",
  [SECTION_SOCIAL_TITLE]: "Redes sociais",
  [SECTION_SOCIAL_SUBTITLE_SINGULAR]: "Perfil identificado",
  [SECTION_SOCIAL_SUBTITLE_PLURAL]: "Perfis identificados",
  [SECTION_VOICE_TITLE]: "Voz da marca",
  [SECTION_VOICE_SUBTITLE]: "Tom e personalidade",
  [SECTION_VOICE_TONE_DESCRIPTION]: "Descrição do tom",
  [SECTION_VOICE_ATTRIBUTES_LABEL]: "Atributos de voz (máx. 6)",
  [SECTION_OFFER_TITLE]: "Oferta",
  [SECTION_OFFER_SUBTITLE]: "Tipo de negócio",
  [SECTION_OFFER_TYPE_LABEL]: "Tipo",
  [SECTION_OFFER_VISUAL_STYLE_LABEL]: "Estilo visual",
  [SECTION_OFFER_BUSINESS_VALUE_PROPOSITION_LABEL]:
    "Proposta de valor do negócio",
  [SECTION_OFFER_DEFAULT_VALUE]: "Serviços",
  [SECTION_COUNTRY_TITLE]: "País",
  [SECTION_COUNTRY_SUBTITLE]: "Localização do negócio",
  [SECTION_COUNTRY_LABEL]: "País",
  [SECTION_COUNTRY_DEFAULT_VALUE]: "Selecione um país",
  [SECTION_TYPOGRAPHY_TITLE]: "Tipografia",
  [SECTION_TYPOGRAPHY_SUBTITLE]: "Sistema de fontes",
  [SECTION_TYPOGRAPHY_FONT_FAMILY_LABEL]: "Fonte",
  [SECTION_TYPOGRAPHY_TITLE_FONT_LABEL]: "Fonte principal",
  [SECTION_TYPOGRAPHY_SUBTITLE_FONT_LABEL]: "Fonte secundária",
  [SECTION_TYPOGRAPHY_BODY_FONT_LABEL]: "Fonte secundária",
  [SECTION_TYPOGRAPHY_ADD_TYPOGRAPHY]: "Adicionar tipografia",
  [SECTION_TYPOGRAPHY_FONT_SIZES_LABEL]: "Tamanhos de fonte",
  [SECTION_TYPOGRAPHY_HEADING_LABEL]: "Título",
  [SECTION_TYPOGRAPHY_SUBHEADING_LABEL]: "Subtítulo",
  [SECTION_TYPOGRAPHY_BODY_LABEL]: "Corpo",
  [SECTION_TYPOGRAPHY_PX_UNIT]: "px",
  [SECTION_TYPOGRAPHY_GENERATING_PREVIEW]: "Gerando prévia",
  [SECTION_TYPOGRAPHY_ADD_FONT]: 'Adicionar "{{value}}"',
  [SECTION_LOGO_TITLE]: "Logo",
  [SECTION_LOGO_SUBTITLE]: "Ativo principal",
  [SECTION_COLORS_TITLE]: "Identidade visual",
  [SECTION_COLORS_SUBTITLE]: "Cores e estilo visual",
  [SECTION_COLORS_ADD_COLOR]: "Adicionar cor",
  [SECTION_TARGET_AUDIENCE_TITLE]: "Público-alvo",
  [SECTION_TARGET_AUDIENCE_SUBTITLE]: "Perfil do cliente ideal",
  [SECTION_TARGET_AUDIENCE_ICP_LABEL]: "Perfil do cliente ideal",
  [SECTION_PRODUCT_IMAGES_TITLE]: "Produtos",
  [SECTION_PRODUCT_IMAGES_SUBTITLE]:
    "Adicione imagens dos seus produtos ou serviços",
  [BUTTON_UPLOAD_PRODUCT_IMAGES]: "Enviar imagens",
  [BUTTON_DELETE_PRODUCT_IMAGE]: "Excluir",
  [SECTION_ADDITIONAL_ASSETS_TITLE]: "Recursos adicionais",
  [SECTION_ADDITIONAL_ASSETS_SUBTITLE]:
    "Adicione imagens de referência com indicações específicas para gerar criativos mais personalizados.",
  [SECTION_ADDITIONAL_ASSETS_PROMPT_LABEL]: "Instrução de uso",
  [SECTION_ADDITIONAL_ASSETS_PROMPT_PLACEHOLDER]:
    "Ex.: colocar no canto inferior direito como selo de qualidade",
  [SECTION_ADDITIONAL_ASSETS_PROMPT_REQUIRED]:
    "A instrução de uso é obrigatória para cada imagem",
  [BUTTON_UPLOAD_ADDITIONAL_ASSET]: "Adicionar imagem",
  [SECTION_ADDITIONAL_ASSETS_MAX_ERROR]: "Máximo de 10 imagens adicionais",
  [SECTION_ADDITIONAL_ASSETS_ASSET_LABEL]: "Recurso {{number}}",
  [SECTION_ADDITIONAL_ASSETS_MAX_TOOLTIP]:
    "Você atingiu o máximo de 10 recursos adicionais",
  [SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM]:
    "Esta imagem e a sua instrução de uso serão excluídas",
  [SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM_TITLE]: "Excluir recurso?",
  [SECTION_ADDITIONAL_ASSETS_INCOMPLETE_PAIR]:
    "Cada recurso deve incluir imagem e instrução de uso",
  [SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_LABEL]: "É condicional",
  [SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_HELP]:
    "Ative se este recurso só deve ser usado quando se aplicar ao contexto da peça. Se for sempre obrigatório, deixe desativado.",
  [SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_LABEL]: "Informação variável",
  [SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_HELP]:
    "Ative se este recurso deve ser personalizado com a informação específica de cada peça. Se o conteúdo não muda, deixe desativado.",
  [SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_LABEL]: "Grupo de variantes",
  [SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_HELP]:
    "Atribua o mesmo nome de grupo aos recursos que são alternativas entre si. Ao gerar várias peças, será usada uma variante diferente em cada uma e apenas uma por peça. Deixe em branco se o recurso não tiver alternativas ou se não precisar ser diferente em cada peça.",
  [SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_PLACEHOLDER]: "ex.: ingresso",
  [MODAL_ADDITIONAL_ASSET_TITLE]: "Recurso adicional",
  [BUTTON_CHANGE_ADDITIONAL_ASSET_IMAGE]: "Trocar imagem",
  [SECTION_BUYER_PERSONA_TITLE]: "Buyer persona",
  [SECTION_BUYER_PERSONA_SUBTITLE]: "Perfil do comprador",
  [SECTION_BUYER_PERSONA_LABEL]: "Buyer persona",
  [SECTION_BUYER_PERSONA_PLACEHOLDER_NAME]: "Nome",
  [SECTION_BUYER_PERSONA_PLACEHOLDER_DESCRIPTION]: "Descrição",

  // BRAND SETUP SECTIONS
  [BRAND_SETUP_SECTION_BRAND_NAME]: "Minha marca",
  [BRAND_SETUP_SECTION_BRAND_DESCRIPTION]:
    "Esta é a descrição da minha marca. Aqui você pode adicionar informações sobre o seu negócio, os seus valores e a sua missão",
  [BRAND_SETUP_SECTION_BRAND_NAME_PLACEHOLDER]:
    "Escreva aqui o nome da sua marca",
  [BRAND_SETUP_SECTION_BRAND_DESCRIPTION_PLACEHOLDER]:
    "Escreva aqui do que se trata a sua marca",

  // MODAL EDIT URL PARAMETERS
  [MODAL_EDIT_URL_PARAMETERS_TITLE]: "Editar parâmetros de URL",
  [MODAL_EDIT_URL_PARAMETERS_DESCRIPTION]:
    "Os parâmetros de URL podem ajudar você a coletar dados de desempenho da sua campanha.",
  [MODAL_EDIT_URL_PARAMETERS_UTM_SECTION_LABEL]: "Parâmetros UTM",
  [MODAL_EDIT_URL_PARAMETERS_CUSTOM_SECTION_LABEL]: "Parâmetros personalizados",
  [MODAL_EDIT_URL_PARAMETERS_PREVIEW_LABEL]: "Prévia",
  [MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_NAME]: "Nome do parâmetro",
  [MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_VALUE]: "Valor do parâmetro",
  [MODAL_EDIT_URL_PARAMETERS_CONFIGURED]:
    "{{count}} parâmetros UTM configurados",
  [MODAL_EDIT_URL_PARAMETERS_BUTTON_APPLY]: "Aplicar",
  [MODAL_EDIT_URL_PARAMETERS_BUTTON_CONFIGURE]: "Editar parâmetros de URL",
  [MODAL_EDIT_URL_PARAMETERS_CUSTOM_KEY_RESERVED]:
    "Esta chave é reservada. Use a seção de parâmetros UTM para modificá-la.",
  [MODAL_EDIT_URL_PARAMETERS_BUILD_LABEL]: "Montar UTMs",
  [URL_EXAMPLE_PLACEHOLDER]: "https://www.seusite.com",

  // MODAL FEEDBACK
  [MODAL_FEEDBACK_TITLE]: "Compartilhe a sua opinião",
  [MODAL_FEEDBACK_DESCRIPTION]:
    "Ajude-nos a melhorar compartilhando o que você pensa sobre este conteúdo.",
  [MODAL_FEEDBACK_PLACEHOLDER]: "Conte o que você pensa...",
  [MODAL_FEEDBACK_LIKE_LABEL]: "Você gostou deste conteúdo",
  [MODAL_FEEDBACK_DISLIKE_LABEL]: "Você não gostou deste conteúdo",
  [MODAL_REPORT_CONTENT_TITLE]: "Denunciar conteúdo",
  [MODAL_REPORT_CONTENT_DESCRIPTION]:
    "Conte qual problema este conteúdo apresenta para que possamos revisá-lo (somente se houver erros como deformações, falhas visuais ou resultados incorretos).",
  [MODAL_REPORT_CONTENT_PLACEHOLDER]:
    "Escreva o motivo ou o contexto da denúncia...",
  [MODAL_REPORT_CONTENT_SUCCESS]: "Denúncia enviada com sucesso.",
  [BUTTON_REPORT_CONTENT]: "Denunciar",

  // ALERTS ANIMATION IMAGE
  [ANIMATING_IMAGE_TITLE]: "Animando imagem",
  [ANIMATING_IMAGE_SUCCESS]: "Imagem Animada com Sucesso",
  [ANIMATING_IMAGE_ERROR]: "Erro ao Animar a Imagem",
  // COUNTRIES
  [COUNTRY_ANDORRA]: "Andorra",
  [COUNTRY_UNITED_ARAB_EMIRATES]: "Emirados Árabes Unidos",
  [COUNTRY_AFGHANISTAN]: "Afeganistão",
  [COUNTRY_ANTIGUA_AND_BARBUDA]: "Antígua e Barbuda",
  [COUNTRY_ANGUILLA]: "Anguila",
  [COUNTRY_ALBANIA]: "Albânia",
  [COUNTRY_ARMENIA]: "Armênia",
  [COUNTRY_ANGOLA]: "Angola",
  [COUNTRY_ANTARCTICA]: "Antártida",
  [COUNTRY_ARGENTINA]: "Argentina",
  [COUNTRY_AMERICAN_SAMOA]: "Samoa Americana",
  [COUNTRY_AUSTRIA]: "Áustria",
  [COUNTRY_AUSTRALIA]: "Austrália",
  [COUNTRY_ARUBA]: "Aruba",
  [COUNTRY_ALLAND_ISLANDS]: "Ilhas Åland",
  [COUNTRY_AZERBAIJAN]: "Azerbaijão",
  [COUNTRY_BOSNIA_AND_HERZEGOVINA]: "Bósnia e Herzegovina",
  [COUNTRY_BARBADOS]: "Barbados",
  [COUNTRY_BANGLADESH]: "Bangladesh",
  [COUNTRY_BELGIUM]: "Bélgica",
  [COUNTRY_BURKINA_FASO]: "Burkina Faso",
  [COUNTRY_BULGARIA]: "Bulgária",
  [COUNTRY_BAHRAIN]: "Bahrein",
  [COUNTRY_BURUNDI]: "Burundi",
  [COUNTRY_BENIN]: "Benim",
  [COUNTRY_SAINT_BARTHELEMY]: "São Bartolomeu",
  [COUNTRY_BERMUDA]: "Bermudas",
  [COUNTRY_BRUNEI_DARUSSALAM]: "Brunei",
  [COUNTRY_BOLIVIA]: "Bolívia",
  [COUNTRY_BRAZIL]: "Brasil",
  [COUNTRY_BAHAMAS]: "Bahamas",
  [COUNTRY_BHUTAN]: "Butão",
  [COUNTRY_BOUVET_ISLAND]: "Ilha Bouvet",
  [COUNTRY_BOTSWANA]: "Botsuana",
  [COUNTRY_BELARUS]: "Bielorrússia",
  [COUNTRY_BELIZE]: "Belize",
  [COUNTRY_CANADA]: "Canadá",
  [COUNTRY_COCOS_KEELING_ISLANDS]: "Ilhas Cocos",
  [COUNTRY_CONGO_DEMOCRATIC_REPUBLIC_OF_THE]: "Congo, República Democrática do",
  [COUNTRY_CENTRAL_AFRICAN_REPUBLIC]: "República Centro-Africana",
  [COUNTRY_CONGO_REPUBLIC_OF_THE]: "Congo, República do",
  [COUNTRY_SWITZERLAND]: "Suíça",
  [COUNTRY_COTE_D_IVOIRE]: "Costa do Marfim",
  [COUNTRY_COOK_ISLANDS]: "Ilhas Cook",
  [COUNTRY_CHILE]: "Chile",
  [COUNTRY_CAMEROON]: "Camarões",
  [COUNTRY_CHINA]: "China",
  [COUNTRY_COLOMBIA]: "Colômbia",
  [COUNTRY_COSTA_RICA]: "Costa Rica",
  [COUNTRY_CUBA]: "Cuba",
  [COUNTRY_CAPE_VERDE]: "Cabo Verde",
  [COUNTRY_CURACAO]: "Curaçao",
  [COUNTRY_CHRISTMAS_ISLAND]: "Ilha Christmas",
  [COUNTRY_CYPRUS]: "Chipre",
  [COUNTRY_CZECH_REPUBLIC]: "República Tcheca",
  [COUNTRY_GERMANY]: "Alemanha",
  [COUNTRY_DJIBOUTI]: "Djibuti",
  [COUNTRY_DENMARK]: "Dinamarca",
  [COUNTRY_DOMINICA]: "Dominica",
  [COUNTRY_DOMINICAN_REPUBLIC]: "República Dominicana",
  [COUNTRY_ALGERIA]: "Argélia",
  [COUNTRY_ECUADOR]: "Equador",
  [COUNTRY_ESTONIA]: "Estônia",
  [COUNTRY_EGYPT]: "Egito",
  [COUNTRY_WESTERN_SAHARA]: "Saara Ocidental",
  [COUNTRY_ERITREA]: "Eritreia",
  [COUNTRY_SPAIN]: "Espanha",
  [COUNTRY_ETHIOPIA]: "Etiópia",
  [COUNTRY_FINLAND]: "Finlândia",
  [COUNTRY_FIJI]: "Fiji",
  [COUNTRY_FALKLAND_ISLANDS_MALVINAS]: "Ilhas Malvinas",
  [COUNTRY_MICRONESIA_FEDERATED_STATES_OF]: "Micronésia",
  [COUNTRY_FAROE_ISLANDS]: "Ilhas Faroé",
  [COUNTRY_FRANCE]: "França",
  [COUNTRY_GABON]: "Gabão",
  [COUNTRY_UNITED_KINGDOM]: "Reino Unido",
  [COUNTRY_GRENADA]: "Granada",
  [COUNTRY_GEORGIA]: "Geórgia",
  [COUNTRY_FRENCH_GUIANA]: "Guiana Francesa",
  [COUNTRY_GUERNSEY]: "Guernsey",
  [COUNTRY_GHANA]: "Gana",
  [COUNTRY_GIBRALTAR]: "Gibraltar",
  [COUNTRY_GREENLAND]: "Groenlândia",
  [COUNTRY_GAMBIA]: "Gâmbia",
  [COUNTRY_GUINEA]: "Guiné",
  [COUNTRY_GUADELOUPE]: "Guadalupe",
  [COUNTRY_EQUATORIAL_GUINEA]: "Guiné Equatorial",
  [COUNTRY_GREECE]: "Grécia",
  [COUNTRY_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS]:
    "Ilhas Geórgia do Sul e Sandwich do Sul",
  [COUNTRY_GUATEMALA]: "Guatemala",
  [COUNTRY_GUAM]: "Guam",
  [COUNTRY_GUINEA_BISSAU]: "Guiné-Bissau",
  [COUNTRY_GUYANA]: "Guiana",
  [COUNTRY_HONG_KONG]: "Hong Kong",
  [COUNTRY_HEARD_ISLAND_AND_MCDONALD_ISLANDS]: "Ilhas Heard e McDonald",
  [COUNTRY_HONDURAS]: "Honduras",
  [COUNTRY_CROATIA]: "Croácia",
  [COUNTRY_HAITI]: "Haiti",
  [COUNTRY_HUNGARY]: "Hungria",
  [COUNTRY_INDONESIA]: "Indonésia",
  [COUNTRY_IRELAND]: "Irlanda",
  [COUNTRY_ISRAEL]: "Israel",
  [COUNTRY_ISLE_OF_MAN]: "Ilha de Man",
  [COUNTRY_INDIA]: "Índia",
  [COUNTRY_BRITISH_INDIAN_OCEAN_TERRITORY]:
    "Território Britânico do Oceano Índico",
  [COUNTRY_IRAQ]: "Iraque",
  [COUNTRY_IRAN_ISLAMIC_REPUBLIC_OF]: "Irã",
  [COUNTRY_ICELAND]: "Islândia",
  [COUNTRY_ITALY]: "Itália",
  [COUNTRY_JERSEY]: "Jersey",
  [COUNTRY_JAMAICA]: "Jamaica",
  [COUNTRY_JORDAN]: "Jordânia",
  [COUNTRY_JAPAN]: "Japão",
  [COUNTRY_KENYA]: "Quênia",
  [COUNTRY_KYRGYZSTAN]: "Quirguistão",
  [COUNTRY_CAMBODIA]: "Camboja",
  [COUNTRY_KIRIBATI]: "Kiribati",
  [COUNTRY_COMOROS]: "Comores",
  [COUNTRY_SAINT_KITTS_AND_NEVIS]: "São Cristóvão e Névis",
  [COUNTRY_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF]: "Coreia do Norte",
  [COUNTRY_KOREA_REPUBLIC_OF]: "Coreia do Sul",
  [COUNTRY_KUWAIT]: "Kuwait",
  [COUNTRY_CAYMAN_ISLANDS]: "Ilhas Cayman",
  [COUNTRY_KAZAKHSTAN]: "Cazaquistão",
  [COUNTRY_LAO_PEOPLES_DEMOCRATIC_REPUBLIC]: "Laos",
  [COUNTRY_LEBANON]: "Líbano",
  [COUNTRY_SAINT_LUCIA]: "Santa Lúcia",
  [COUNTRY_LIECHTENSTEIN]: "Liechtenstein",
  [COUNTRY_SRI_LANKA]: "Sri Lanka",
  [COUNTRY_LIBERIA]: "Libéria",
  [COUNTRY_LESOTHO]: "Lesoto",
  [COUNTRY_LITHUANIA]: "Lituânia",
  [COUNTRY_LUXEMBOURG]: "Luxemburgo",
  [COUNTRY_LATVIA]: "Letônia",
  [COUNTRY_LIBYA]: "Líbia",
  [COUNTRY_MOROCCO]: "Marrocos",
  [COUNTRY_MONACO]: "Mônaco",
  [COUNTRY_MOLDOVA_REPUBLIC_OF]: "Moldávia",
  [COUNTRY_MONTENEGRO]: "Montenegro",
  [COUNTRY_SAINT_MARTIN_FRENCH_PART]: "São Martinho",
  [COUNTRY_MADAGASCAR]: "Madagascar",
  [COUNTRY_MARSHALL_ISLANDS]: "Ilhas Marshall",
  [COUNTRY_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF]: "Macedônia do Norte",
  [COUNTRY_MALI]: "Mali",
  [COUNTRY_MYANMAR]: "Mianmar",
  [COUNTRY_MONGOLIA]: "Mongólia",
  [COUNTRY_MACAO]: "Macau",
  [COUNTRY_NORTHERN_MARIANA_ISLANDS]: "Ilhas Marianas do Norte",
  [COUNTRY_MARTINIQUE]: "Martinica",
  [COUNTRY_MAURITANIA]: "Mauritânia",
  [COUNTRY_MONTSERRAT]: "Montserrat",
  [COUNTRY_MALTA]: "Malta",
  [COUNTRY_MAURITIUS]: "Maurício",
  [COUNTRY_MALDIVES]: "Maldivas",
  [COUNTRY_MALAWI]: "Malaui",
  [COUNTRY_MEXICO]: "México",
  [COUNTRY_MALAYSIA]: "Malásia",
  [COUNTRY_MOZAMBIQUE]: "Moçambique",
  [COUNTRY_NAMIBIA]: "Namíbia",
  [COUNTRY_NEW_CALEDONIA]: "Nova Caledônia",
  [COUNTRY_NIGER]: "Níger",
  [COUNTRY_NORFOLK_ISLAND]: "Ilha Norfolk",
  [COUNTRY_NIGERIA]: "Nigéria",
  [COUNTRY_NICARAGUA]: "Nicarágua",
  [COUNTRY_NETHERLANDS]: "Países Baixos",
  [COUNTRY_NORWAY]: "Noruega",
  [COUNTRY_NEPAL]: "Nepal",
  [COUNTRY_NAURU]: "Nauru",
  [COUNTRY_NIUE]: "Niue",
  [COUNTRY_NEW_ZEALAND]: "Nova Zelândia",
  [COUNTRY_OMAN]: "Omã",
  [COUNTRY_PANAMA]: "Panamá",
  [COUNTRY_PERU]: "Peru",
  [COUNTRY_FRENCH_POLYNESIA]: "Polinésia Francesa",
  [COUNTRY_PAPUA_NEW_GUINEA]: "Papua-Nova Guiné",
  [COUNTRY_PHILIPPINES]: "Filipinas",
  [COUNTRY_PAKISTAN]: "Paquistão",
  [COUNTRY_POLAND]: "Polônia",
  [COUNTRY_SAINT_PIERRE_AND_MIQUELON]: "São Pedro e Miquelão",
  [COUNTRY_PITCAIRN]: "Ilhas Pitcairn",
  [COUNTRY_PUERTO_RICO]: "Porto Rico",
  [COUNTRY_PALESTINE_STATE_OF]: "Palestina",
  [COUNTRY_PORTUGAL]: "Portugal",
  [COUNTRY_PALAU]: "Palau",
  [COUNTRY_PARAGUAY]: "Paraguai",
  [COUNTRY_QATAR]: "Catar",
  [COUNTRY_REUNION]: "Reunião",
  [COUNTRY_ROMANIA]: "Romênia",
  [COUNTRY_SERBIA]: "Sérvia",
  [COUNTRY_RUSSIAN_FEDERATION]: "Rússia",
  [COUNTRY_RWANDA]: "Ruanda",
  [COUNTRY_SAUDI_ARABIA]: "Arábia Saudita",
  [COUNTRY_SOLOMON_ISLANDS]: "Ilhas Salomão",
  [COUNTRY_SEYCHELLES]: "Seicheles",
  [COUNTRY_SUDAN]: "Sudão",
  [COUNTRY_SWEDEN]: "Suécia",
  [COUNTRY_SINGAPORE]: "Singapura",
  [COUNTRY_SAINT_HELENA]: "Santa Helena",
  [COUNTRY_SLOVENIA]: "Eslovênia",
  [COUNTRY_SVALBARD_AND_JAN_MAYEN]: "Svalbard e Jan Mayen",
  [COUNTRY_SLOVAKIA]: "Eslováquia",
  [COUNTRY_SIERRA_LEONE]: "Serra Leoa",
  [COUNTRY_SAN_MARINO]: "San Marino",
  [COUNTRY_SENEGAL]: "Senegal",
  [COUNTRY_SOMALIA]: "Somália",
  [COUNTRY_SURINAME]: "Suriname",
  [COUNTRY_SOUTH_SUDAN]: "Sudão do Sul",
  [COUNTRY_SAO_TOME_AND_PRINCIPE]: "São Tomé e Príncipe",
  [COUNTRY_EL_SALVADOR]: "El Salvador",
  [COUNTRY_SINT_MAARTEN_DUTCH_PART]: "Sint Maarten",
  [COUNTRY_SYRIAN_ARAB_REPUBLIC]: "Síria",
  [COUNTRY_SWAZILAND]: "Essuatíni",
  [COUNTRY_TURKS_AND_CAICOS_ISLANDS]: "Ilhas Turcas e Caicos",
  [COUNTRY_CHAD]: "Chade",
  [COUNTRY_FRENCH_SOUTHERN_TERRITORIES]: "Territórios Franceses do Sul",
  [COUNTRY_TOGO]: "Togo",
  [COUNTRY_THAILAND]: "Tailândia",
  [COUNTRY_TAJIKISTAN]: "Tajiquistão",
  [COUNTRY_TOKELAU]: "Tokelau",
  [COUNTRY_TIMOR_LESTE]: "Timor-Leste",
  [COUNTRY_TURKMENISTAN]: "Turcomenistão",
  [COUNTRY_TUNISIA]: "Tunísia",
  [COUNTRY_TONGA]: "Tonga",
  [COUNTRY_TURKEY]: "Turquia",
  [COUNTRY_TRINIDAD_AND_TOBAGO]: "Trinidad e Tobago",
  [COUNTRY_TUVALU]: "Tuvalu",
  [COUNTRY_TAIWAN]: "Taiwan",
  [COUNTRY_UNITED_REPUBLIC_OF_TANZANIA]: "Tanzânia",
  [COUNTRY_UKRAINE]: "Ucrânia",
  [COUNTRY_UGANDA]: "Uganda",
  [COUNTRY_UNITED_STATES]: "Estados Unidos",
  [COUNTRY_URUGUAY]: "Uruguai",
  [COUNTRY_UZBEKISTAN]: "Uzbequistão",
  [COUNTRY_HOLY_SEE_VATICAN_CITY_STATE]: "Santa Sé (Cidade do Vaticano)",
  [COUNTRY_SAINT_VINCENT_AND_THE_GRENADINES]: "São Vicente e Granadinas",
  [COUNTRY_VENEZUELA]: "Venezuela",
  [COUNTRY_BRITISH_VIRGIN_ISLANDS]: "Ilhas Virgens Britânicas",
  [COUNTRY_US_VIRGIN_ISLANDS]: "Ilhas Virgens Americanas",
  [COUNTRY_VIETNAM]: "Vietnã",
  [COUNTRY_VANUATU]: "Vanuatu",
  [COUNTRY_WALLIS_AND_FUTUNA]: "Wallis e Futuna",
  [COUNTRY_SAMOA]: "Samoa",
  [COUNTRY_KOSOVO]: "Kosovo",
  [COUNTRY_YEMEN]: "Iêmen",
  [COUNTRY_MAYOTTE]: "Mayotte",
  [COUNTRY_SOUTH_AFRICA]: "África do Sul",
  [COUNTRY_ZAMBIA]: "Zâmbia",
  [COUNTRY_ZIMBABWE]: "Zimbábue",

  // MODAL CREDITS USAGE DETAILED
  [MODAL_CREDITS_USAGE_DETAILED_TITLE]: "Uso detalhado de créditos",
  [MODAL_CREDITS_USAGE_DETAILED_ARIA_LABEL]: "Uso detalhado de créditos",
  [MODAL_CREDITS_USAGE_DETAILED_LINK]: "Ver uso detalhado",
  [MODAL_CREDITS_USAGE_DETAILED_PERIOD]: "Período: {{from}} — {{to}}",
  [MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_ADVERTISER_TITLE]: "Uso por marca",
  [MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_USER_TITLE]: "Uso por usuário",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_ADVERTISER]: "Marca",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_USER]: "Usuário",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT]: "Créditos gastos",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_VIDEOS_SPENT]: "Vídeos",
  [MODAL_CREDITS_USAGE_DETAILED_LOADING]: "Carregando uso de créditos...",
  [MODAL_CREDITS_USAGE_DETAILED_EMPTY]: "Nenhum gasto registrado neste período",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_TOTAL_CREDITS]:
    "Total de créditos: {{value}}",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CREDITS_BY_GROUP_TITLE]:
    "Total de créditos por grupo",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_CREDITS]:
    "{{agencyName}}: {{value}} créditos",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_ACCORDION_TITLE]:
    "Uso detalhado de {{agencyName}}",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_EMPTY_GROUPS]:
    "Nenhum grupo atribuído",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CALCULATING]:
    "Calculando o uso das marcas...",

  // PRE-ACTIVACIÓN
  [PRE_ACTIVATION_BADGE]: "PRÉ-ATIVAÇÃO",
  [PRE_ACTIVATION_SECTION_CONTACT]: "01 · Dados de contato",
  [PRE_ACTIVATION_SECTION_01_BUSINESS]: "02 · Seu negócio",
  [PRE_ACTIVATION_SECTION_02_CURRENT_ADS]: "03 · Publicidade atual",
  [PRE_ACTIVATION_SECTION_03_OBJECTIVES]: "04 · Objetivos",
  [PRE_ACTIVATION_SECTION_04_MEETING_ACCESS]: "05 · Acessos para a reunião",
  [PRE_ACTIVATION_HERO_TITLE]: "Conte-nos sobre<br/>o seu <em>negócio</em>",
  [PRE_ACTIVATION_HERO_DESCRIPTION]:
    "Para aproveitar ao máximo a nossa reunião de ativação, preencha este formulário antes da chamada. São 10 minutos e nos permite chegar preparados com uma estratégia personalizada para você.",
  [PRE_ACTIVATION_HERO_DESCRIPTION_AGENCY]:
    "Para aproveitar ao máximo a sua ativação, preencha este formulário antes da primeira sessão. São cerca de 5 minutos e nos permite chegar com a sua marca já configurada na plataforma.",
  [PRE_ACTIVATION_FIELD_BUSINESS_NAME]: "Nome da sua empresa ou marca",
  [PRE_ACTIVATION_FIELD_AGENCY_NAME]: "Nome da sua agência",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME]: "Ex.: Agência Digital Norte",
  [PRE_ACTIVATION_FIELD_FULL_NAME]: "Seu nome completo",
  [PRE_ACTIVATION_FIELD_EMAIL]: "E-mail",
  [PRE_ACTIVATION_FIELD_WHATSAPP]: "WhatsApp (com código do país)",
  [PRE_ACTIVATION_FIELD_WHAT_YOU_SELL]:
    "O que você vende? Descreva em 2–3 frases",
  [PRE_ACTIVATION_HINT_WHAT_YOU_SELL]:
    "Inclua o que o diferencia da concorrência.",
  [PRE_ACTIVATION_FIELD_AVERAGE_PRICE]: "Preço médio do seu produto ou serviço",
  [PRE_ACTIVATION_HINT_AVERAGE_PRICE]:
    "Por unidade, kit ou assinatura mensal. Indique a moeda.",
  [PRE_ACTIVATION_FIELD_IDEAL_CUSTOMER]: "Quem é o seu cliente ideal?",
  [PRE_ACTIVATION_HINT_IDEAL_CUSTOMER]:
    "Idade, gênero, interesses, localização, nível socioeconômico.",
  [PRE_ACTIVATION_FIELD_WHERE_CUSTOMER_BUYS]: "Onde o seu cliente compra?",
  [PRE_ACTIVATION_FIELD_WEBSITE_URL]: "URL do seu site ou loja",
  [PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME]: "Ex.: Natura Kids Colombia",
  [PRE_ACTIVATION_PLACEHOLDER_FULL_NAME]: "Nome e sobrenome",
  [PRE_ACTIVATION_PLACEHOLDER_EMAIL]: "email@empresa.com",
  [PRE_ACTIVATION_PLACEHOLDER_WHATSAPP]: "+57 300 123 4567",
  [PRE_ACTIVATION_PLACEHOLDER_WHAT_YOU_SELL]:
    "Ex.: vendemos calçados ergonômicos infantis que respeitam o formato natural do pé. Diferente das marcas nacionais, temos o mesmo nível de qualidade das marcas internacionais, mas fabricado localmente…",
  [PRE_ACTIVATION_PLACEHOLDER_AVERAGE_PRICE]:
    "Ex.: $48.000 COP por par / USD 25 por unidade",
  [PRE_ACTIVATION_PLACEHOLDER_IDEAL_CUSTOMER]:
    "Ex.: mães entre 25–45 anos, NSE médio-alto, atentas à saúde infantil, localizadas na Colômbia e no México…",
  [PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL]: "https://sualoja.com",
  [PRE_ACTIVATION_SALES_CHANNEL_TIENDA_WEB]: "Loja online / e-commerce",
  [PRE_ACTIVATION_SALES_CHANNEL_TIENDA_FISICA]: "Loja física",
  [PRE_ACTIVATION_SALES_CHANNEL_WHATSAPP]: "WhatsApp / DM direto",
  [PRE_ACTIVATION_SALES_CHANNEL_MARKETPLACE]:
    "Marketplace (Mercado Livre, Amazon etc.)",
  [PRE_ACTIVATION_SALES_CHANNEL_APP]: "Aplicativo",
  [PRE_ACTIVATION_FIELD_HAS_ADS]: "Você já investe em publicidade paga?",
  [PRE_ACTIVATION_HAS_ADS_SI]: "Sim, tenho campanhas ativas",
  [PRE_ACTIVATION_HAS_ADS_ANTES]: "Sim, mas não tenho campanhas ativas agora",
  [PRE_ACTIVATION_HAS_ADS_NO]:
    "Não, esta é a minha primeira vez com publicidade paga",
  [PRE_ACTIVATION_FIELD_AD_PLATFORMS]:
    "Em quais plataformas você tem ou teve campanhas?",
  [PRE_ACTIVATION_ADS_PLATFORM_META]: "Meta Ads (Facebook / Instagram)",
  [PRE_ACTIVATION_ADS_PLATFORM_GOOGLE]: "Google Ads",
  [PRE_ACTIVATION_ADS_PLATFORM_TIKTOK]: "TikTok Ads",
  [PRE_ACTIVATION_ADS_PLATFORM_OTHER]: "Outro (LinkedIn, X, Pinterest etc.)",
  [PRE_ACTIVATION_PLACEHOLDER_ADS_PLATFORM_OTHER]: "Especifique a plataforma",
  [PRE_ACTIVATION_FIELD_MONTHLY_AD_SPEND]:
    "Quanto você investe por mês em publicidade?",
  [PRE_ACTIVATION_HINT_MONTHLY_AD_SPEND]:
    "Total de todas as plataformas. Indique a moeda.",
  [PRE_ACTIVATION_FIELD_CURRENT_METRICS]: "Métricas atuais (se você tiver)",
  [PRE_ACTIVATION_HINT_CURRENT_METRICS]:
    "ROAS, CPA, CTR, conversões por plataforma. Não se preocupe se não tiver esses dados à mão.",
  [PRE_ACTIVATION_FIELD_TARGET_CPA]: "Qual é o seu CPA objetivo?",
  [PRE_ACTIVATION_HINT_TARGET_CPA]:
    "Quanto você está disposto a pagar por cada venda ou lead?",
  [PRE_ACTIVATION_FIELD_BEST_CAMPAIGN_MESSAGES]:
    "Quais campanhas ou mensagens funcionaram melhor para você?",
  [PRE_ACTIVATION_HINT_BEST_CAMPAIGN_MESSAGES]:
    "Formatos (vídeo, imagem, carrossel), audiências, ângulos criativos etc. Se você não tiver histórico, deixe em branco.",
  [PRE_ACTIVATION_PLACEHOLDER_MONTHLY_AD_SPEND]:
    "Ex.: USD 700 / mês · $3.000.000 COP / mês · Não tenho investimento atual",
  [PRE_ACTIVATION_PLACEHOLDER_CURRENT_METRICS]:
    "Ex.: Meta Ads: ROAS 4,5, CPA $15.000 COP · Google Ads SEARCH: ROAS 5,15, 23 conversões · Ainda não tenho dados",
  [PRE_ACTIVATION_PLACEHOLDER_TARGET_CPA]:
    "Ex.: $6.000 COP por compra / USD 15 por lead",
  [PRE_ACTIVATION_PLACEHOLDER_BEST_CAMPAIGN_MESSAGES]:
    "Ex.: as imagens estáticas no Instagram com 20% de desconto funcionam melhor do que os vídeos. As audiências de mães de 28–40 anos convertem muito melhor…",
  [PRE_ACTIVATION_FIELD_MONTHLY_SALES]:
    "Quais são as suas vendas atuais por mês?",
  [PRE_ACTIVATION_FIELD_SALES_GOAL_60_90]:
    "Qual é o seu objetivo de vendas em 60–90 dias?",
  [PRE_ACTIVATION_FIELD_BUZZLY_FOCUS]:
    "Qual é o seu foco principal com a Adle?",
  [PRE_ACTIVATION_BUZZLY_FOCUS_PERFORMANCE]:
    "Performance — quero mais vendas e resultados mensuráveis",
  [PRE_ACTIVATION_BUZZLY_FOCUS_CONTENIDO]:
    "Conteúdo — quero gerar criativos e anúncios de qualidade com IA",
  [PRE_ACTIVATION_BUZZLY_FOCUS_AMBOS]:
    "Ambos — performance e produção de conteúdo",
  [PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LEVEL]:
    "Você tem material criativo disponível?",
  [PRE_ACTIVATION_HINT_CREATIVE_MATERIAL_LEVEL]:
    "Fotos do produto, vídeos, logo em alta qualidade, branding etc.",
  [PRE_ACTIVATION_CREATIVE_MATERIAL_SI_MUCHO]:
    "Sim, tenho bastante material pronto",
  [PRE_ACTIVATION_CREATIVE_MATERIAL_SI_POCO]: "Tenho algum, mas pouco",
  [PRE_ACTIVATION_CREATIVE_MATERIAL_NO_IA]:
    "Não, prefiro gerar tudo com IA na Adle",
  [PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LOCATION]:
    "Onde está o seu material criativo?",
  [PRE_ACTIVATION_FIELD_ADDITIONAL_MEETING_NOTES]:
    "Algo mais que devamos saber antes da reunião?",
  [PRE_ACTIVATION_PLACEHOLDER_MONTHLY_SALES]:
    "Ex.: 150 pares / mês · $8M COP / mês · 50 leads / mês",
  [PRE_ACTIVATION_PLACEHOLDER_SALES_GOAL_60_90]:
    "Ex.: 300 pares / mês · $20M COP / mês · 150 leads / mês",
  [PRE_ACTIVATION_PLACEHOLDER_CREATIVE_MATERIAL_LOCATION]:
    "Ex.: Google Drive (compartilho o link) · Dropbox · No meu celular · Está nas redes sociais",
  [PRE_ACTIVATION_PLACEHOLDER_ADDITIONAL_MEETING_NOTES]:
    "Sazonalidade, lançamentos próximos, restrições de orçamento, algo que não funcionou antes, o que nos ajudar a nos preparar melhor…",
  [PRE_ACTIVATION_MEETING_INTRO]:
    "Para a reunião de ativação, precisamos que você tenha disponíveis os acessos às suas plataformas de anúncios. Sem esses acessos, não podemos configurar as campanhas durante a reunião.",
  [PRE_ACTIVATION_FIELD_MEETING_ACCESS]:
    "Quais destes acessos você terá disponíveis para a reunião?",
  [PRE_ACTIVATION_MEETING_ACCESS_META_BM]:
    "Meta Business Manager (administrador)",
  [PRE_ACTIVATION_MEETING_ACCESS_GOOGLE_ADS]: "Google Ads (administrador)",
  [PRE_ACTIVATION_MEETING_ACCESS_TIKTOK_ADS]: "TikTok Ads Manager",
  [PRE_ACTIVATION_MEETING_ACCESS_GA4]: "Google Analytics 4 / GA4",
  [PRE_ACTIVATION_MEETING_ACCESS_PIXEL]: "Meta Pixel instalado no site",
  [PRE_ACTIVATION_MEETING_ACCESS_GTM]: "Google Tag Manager",
  [PRE_ACTIVATION_FIELD_ACCESS_NOT_READY]:
    "Há algum acesso que você ainda não tem pronto?",
  [PRE_ACTIVATION_HINT_ACCESS_NOT_READY]:
    "Conte para que possamos ajudar a resolver antes da reunião.",
  [PRE_ACTIVATION_PLACEHOLDER_ACCESS_NOT_READY]:
    "Ex.: o Google Ads é gerenciado pela nossa agência anterior e estou coordenando para que me deem acesso. Não sei se o Meta Pixel está instalado…",
  [PRE_ACTIVATION_ARIA_REQUIRED]: "obrigatório",
  [PRE_ACTIVATION_SUBMIT_BUTTON]: "Enviar formulário →",
  [PRE_ACTIVATION_SUBMIT_SUCCESS_TITLE]: "Formulário enviado",
  [PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE]:
    "Suas informações foram registradas corretamente. Entraremos em contato em breve para agendar a reunião de ativação.",
  [PRE_ACTIVATION_CONFIDENTIALITY_NOTE]:
    "Suas informações são 100% confidenciais e só serão usadas pela equipe Adle para preparar a sua ativação.",
  [PRE_ACTIVATION_FIELD_ORGANIZATION_TYPE]: "Você é agência ou marca?",
  [PRE_ACTIVATION_HINT_ORGANIZATION_TYPE]:
    "Selecione o perfil que melhor descreve a sua operação para mostrar as perguntas certas.",
  [PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY_LABEL]: "Agência",
  [PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND_LABEL]: "Marca",
  [PRE_ACTIVATION_FIELD_JOB_TITLE]: "Cargo / função",
  [PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE]:
    "Ex.: CEO, Media Buyer, Diretor de marketing",
  [PRE_ACTIVATION_SECTION_AGENCY_01_BASICS]:
    "02 · Informações básicas da agência",
  [PRE_ACTIVATION_SECTION_AGENCY_02_LIVE_EXERCISE]:
    "03 · A marca para o exercício ao vivo",
  [PRE_ACTIVATION_SECTION_AGENCY_03_OPERATIONS]: "04 · Operação atual",
  [PRE_ACTIVATION_SECTION_AGENCY_04_MEETING_ACCESS]:
    "05 · Acessos para a chamada",
  [PRE_ACTIVATION_FIELD_AGENCY_PLATFORM_USERS_COUNT]:
    "Quantas pessoas da equipe vão usar a Adle?",
  [PRE_ACTIVATION_HINT_AGENCY_PLATFORM_USERS_COUNT]:
    "Para preparar os assentos e a configuração de usuários.",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_PLATFORM_USERS_COUNT]:
    "Ex.: 3 media buyers + 1 diretor criativo",
  [PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS]:
    "Quais plataformas vocês vão operar na Adle?",
  [PRE_ACTIVATION_FIELD_AGENCY_MODULES]: "Quais módulos você vai utilizar?",
  [PRE_ACTIVATION_HINT_AGENCY_MODULES]:
    "Selecione todos os que se aplicam. Com isso montamos o conteúdo das duas sessões.",
  [PRE_ACTIVATION_AGENCY_MODULE_CREATIVE]: "Design e geração de criativos",
  [PRE_ACTIVATION_AGENCY_MODULE_PAID_MEDIA]:
    "Implementação e otimização de campanhas e mídia paga",
  [PRE_ACTIVATION_AGENCY_MODULE_ORGANIC_SOCIAL]: "Publicações em redes sociais",
  [PRE_ACTIVATION_AGENCY_MODULE_COMPETITOR_ADS]:
    "Análise de anúncios da concorrência",
  [PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME]:
    "Qual marca do seu portfólio você quer usar nas sessões?",
  [PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME]:
    "Deve ser uma marca real, ativa e com ativos disponíveis.",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME]:
    "Ex.: Marca X — varejo de beleza",
  [PRE_ACTIVATION_FIELD_AGENCY_BRAND_ASSETS_READY]:
    "Vocês têm os ativos dessa marca prontos para compartilhar — logos, paletas, fotos de produto?",
  [PRE_ACTIVATION_HINT_AGENCY_BRAND_ASSETS_READY]:
    "Assim podemos avançar mais rápido durante a sessão ao vivo.",
  [PRE_ACTIVATION_FIELD_AGENCY_CREATIVE_BOTTLENECK]:
    "Qual parte do processo criativo consome mais tempo de vocês hoje?",
  [PRE_ACTIVATION_HINT_AGENCY_CREATIVE_BOTTLENECK]:
    "Briefings, produção, adaptações, aprovações etc.",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_CREATIVE_BOTTLENECK]:
    "Ex.: adaptar criativos a vários formatos e marcas consome a maior parte do tempo da equipe.",
  [PRE_ACTIVATION_FIELD_AGENCY_USES_AD_AUTOMATION]:
    "Vocês usam alguma ferramenta de automação de mídia atualmente?",
  [PRE_ACTIVATION_HINT_AGENCY_USES_AD_AUTOMATION]:
    "Regras, scripts, ferramentas de edição em massa etc.",
  [PRE_ACTIVATION_OPTION_YES]: "Sim",
  [PRE_ACTIVATION_OPTION_NO]: "Não",
  [PRE_ACTIVATION_BEFORE_START_LABEL]: "Antes de começar",
  [PRE_ACTIVATION_BEFORE_START_TITLE]:
    "Como aproveitar ao máximo a sua ativação",
  [PRE_ACTIVATION_BEFORE_START_INTRO]:
    "São duas sessões e a segunda se apoia na primeira. Elas não se repetem: o que não der tempo de cobrir não é retomado. Cinco coisas fazem a diferença.",
  [PRE_ACTIVATION_BEFORE_START_TIP_1_TITLE]: "Que participe quem vai operar",
  [PRE_ACTIVATION_BEFORE_START_TIP_1_DESCRIPTION]:
    "O treinamento não é delegável. Se uma pessoa participa e depois explica para o restante, acabam convivendo duas formas de trabalhar. Garanta que quem vai operar a plataforma reserve a agenda das duas sessões.",
  [PRE_ACTIVATION_BEFORE_START_TIP_2_TITLE]:
    "Que a diretoria esteja na primeira sessão",
  [PRE_ACTIVATION_BEFORE_START_TIP_2_DESCRIPTION]:
    "Este é o ponto mais importante desta lista. Quando o dono ou o diretor da agência entra na primeira sessão, a equipe entende que a Adle é a plataforma com a qual vão operar, e não um teste paralelo que pode ser abandonado no primeiro atrito. Sem esse sinal, as pessoas voltam à forma habitual de trabalhar em poucos dias e a ativação fica no ar.\n\nSe também puder acompanhar a segunda sessão, melhor ainda: é a que mostra o resultado real e de onde saem as decisões de escalar.",
  [PRE_ACTIVATION_BEFORE_START_TIP_3_TITLE]:
    "Deixe a medição pronta antes da sessão 2",
  [PRE_ACTIVATION_BEFORE_START_TIP_3_DESCRIPTION]:
    "Nela lançamos uma campanha real. Se o pixel não estiver instalado ou os eventos de conversão não estiverem configurados, não há lançamento e a sessão é reagendada. Encaminhe isso a quem cuida da parte técnica dessa marca.",
  [PRE_ACTIVATION_BEFORE_START_TIP_4_TITLE]:
    "Tenha os acessos e os ativos à mão",
  [PRE_ACTIVATION_BEFORE_START_TIP_4_DESCRIPTION]:
    "Você conecta as suas contas na primeira sessão, então quem participar precisa ser administrador nesse dia. Tenha também à mão os ativos da marca, como logos, paleta, tipografias e fotos de produto, para comparar ao vivo o que a IA gera a partir do seu site e corrigir na hora, se for preciso.",
  [PRE_ACTIVATION_BEFORE_START_TIP_5_TITLE]: "Escolha bem a marca do exercício",
  [PRE_ACTIVATION_BEFORE_START_TIP_5_DESCRIPTION]:
    "Tudo é feito sobre uma só. Escolha uma ativa, com ativos disponíveis e com a medição funcionando. As demais você replica depois.",
  [PRE_ACTIVATION_BEFORE_START_CALLOUT]:
    "Se o formulário chegar incompleto ou os acessos não estiverem prontos, a sessão é reagendada sem custo, mas o ciclo do seu plano continua contando a partir da data do primeiro pagamento.",
  [PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN]: "LinkedIn Ads",
  [PRE_ACTIVATION_FIELD_AGENCY_PHONE]: "Telefone",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_PHONE]: "+57 300 000 0000",
  [PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE]: "Cargo",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE]: "Ex.: Diretor de mídia",
  [PRE_ACTIVATION_FIELD_AGENCY_BACKUP_CONTACT]: "Responsável suplente",
  [PRE_ACTIVATION_HINT_AGENCY_BACKUP_CONTACT]:
    "Uma segunda pessoa com poder de decisão, para quem possamos escrever se o responsável principal não estiver disponível",
  [PRE_ACTIVATION_FIELD_AGENCY_LEADERSHIP_CONTACT]:
    "Quem da diretoria vai acompanhar a ativação?",
  [PRE_ACTIVATION_HINT_AGENCY_LEADERSHIP_CONTACT]:
    "A participação na primeira sessão é indispensável. É o sinal de que a equipe pode priorizar a ativação",
  [PRE_ACTIVATION_SECTION_CONTACT_DESCRIPTION_AGENCY]:
    "Informações da pessoa responsável pela ativação e dos contatos de apoio.",
  [PRE_ACTIVATION_SECTION_AGENCY_02_TITLE]: "02 · Módulos",
  [PRE_ACTIVATION_SECTION_AGENCY_02_SUBTITLE]:
    "Alimenta a Sessão 1 · Configuração",
  [PRE_ACTIVATION_SECTION_AGENCY_03_TITLE]: "03 · Sua equipe",
  [PRE_ACTIVATION_SECTION_AGENCY_03_SUBTITLE]:
    "Alimenta a Sessão 1 · Treinamento",
  [PRE_ACTIVATION_SECTION_AGENCY_04_TITLE]: "04 · A marca do exercício",
  [PRE_ACTIVATION_SECTION_AGENCY_04_SUBTITLE]:
    "Alimenta a Sessão 1 · Configuração base",
  [PRE_ACTIVATION_SECTION_AGENCY_04_DESCRIPTION]:
    "Toda a ativação acontece sobre uma única marca. As demais você configura depois, repetindo o mesmo fluxo.",
  [PRE_ACTIVATION_SECTION_AGENCY_05_TITLE]: "05 · Agende a sua primeira sessão",
  [PRE_ACTIVATION_SECTION_AGENCY_05_SUBTITLE]:
    "Sessão 1 · Onboarding e configuração",
  [PRE_ACTIVATION_SECTION_AGENCY_05_DESCRIPTION]:
    "Agende aqui a sua sessão de onboarding. A segunda coordenamos com você no fim da primeira, quando já soubermos como está a sua configuração.",
  [PRE_ACTIVATION_SECTION_AGENCY_06_TITLE]: "06 · Confirmações",
  [PRE_ACTIVATION_SECTION_AGENCY_06_HEADING]: "Antes de enviar",
  [PRE_ACTIVATION_FIELD_AGENCY_USER_FULL_NAME]: "Nome e sobrenome",
  [PRE_ACTIVATION_FIELD_AGENCY_USER_EMAIL]: "E-mail",
  [PRE_ACTIVATION_FIELD_AGENCY_TEAM_FAMILIARITY]:
    "O quanto a equipe está familiarizada com a gestão de mídia?",
  [PRE_ACTIVATION_HINT_AGENCY_TEAM_FAMILIARITY]:
    "Nos permite ajustar o ritmo e a profundidade da primeira sessão.",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_ADVANCED]:
    "Avançado — estruturam e otimizam campanhas todos os dias",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INTERMEDIATE]:
    "Intermediário — lançam campanhas, mas não otimizam de forma sistemática",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INITIAL]:
    "Inicial — a equipe está aprendendo mídia paga",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_MIXED]:
    "Misto — há perfis dos dois níveis",
  [PRE_ACTIVATION_AGENCY_TEAM_CALLOUT]:
    "O treinamento não é delegável: quem opera a plataforma é quem se capacita e deve participar das duas sessões.",
  [PRE_ACTIVATION_FIELD_AGENCY_BRAND_WEBSITE]: "URL do site dessa marca",
  [PRE_ACTIVATION_HINT_AGENCY_BRAND_WEBSITE]:
    "Daqui a nossa IA extrai a identidade visual, o idioma e o contexto do negócio para deixar a marca pré-configurada antes da primeira sessão",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_BRAND_WEBSITE]: "https://www.marca.com",
  [PRE_ACTIVATION_AGENCY_SCHEDULE_BUTTON]:
    "Agendar a minha sessão de onboarding →",
  [PRE_ACTIVATION_AGENCY_SCHEDULE_LOCKED_HINT]:
    "Para agendar a sessão, você deve completar as informações das seções anteriores.",
  [PRE_ACTIVATION_ONBOARDING_MODAL_ARIA_LABEL]:
    "Modal para agendar a sessão de onboarding",
  [PRE_ACTIVATION_ONBOARDING_MODAL_TITLE]: "Agendar sessão de onboarding",
  [PRE_ACTIVATION_ONBOARDING_MODAL_DESCRIPTION]:
    "Escolha data e hora para a sua sessão de onboarding.",
  [PRE_ACTIVATION_SCHEDULED_SESSION_TITLE]: "Sessão agendada",
  [PRE_ACTIVATION_SCHEDULED_SESSION_DATE]: "Data",
  [PRE_ACTIVATION_SCHEDULED_SESSION_TIME]: "Hora",
  [PRE_ACTIVATION_SCHEDULED_SESSION_MISSING]:
    "Esta solicitação não tem uma sessão de onboarding agendada.",
  [PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_SINGLE_BRAND]:
    "Entendo que a ativação cobre uma única marca e que as demais eu configuro repetindo o mesmo fluxo.",
  [PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_ACCOUNT_ADMIN]:
    "Entendo que a minha equipe conecta as próprias contas de anúncios durante a sessão 1 e mantém a administração delas.",
  [PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_RESCHEDULE]:
    "Entendo que, se as informações ou os acessos não estiverem prontos, a sessão é reagendada sem custo, mas o ciclo do meu plano continua contando a partir da data do primeiro pagamento.",
  [PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE_AGENCY]:
    "Suas informações foram registradas corretamente.",
  [OWNER_FORM_SUBMISSION_COLUMN_ORGANIZATION_TYPE]: "Perfil",

  // TIKTOK ADGROUP PLACEMENTS
  [TIKTOK_ADGROUP_PLACEMENTS_TITLE]: "Posicionamentos",
  [TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_LABEL]: "TikTok",
  [TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_DESCRIPTION]:
    "Exibe seus anúncios no TikTok",
  [TIKTOK_ADGROUP_PLACEMENTS_PANGLE_LABEL]: "Pangle",
  [TIKTOK_ADGROUP_PLACEMENTS_PANGLE_DESCRIPTION]:
    "O Pangle, a rede de publicidade do TikTok for Business, permite que os anunciantes alcancem usuários em aplicativos e sites que não pertencem ao TikTok.",

  // APPSUMO CALLBACK
  [APPSUMO_CALLBACK_CONNECTING]: "Conectando com o AppSumo…",
  [APPSUMO_CALLBACK_ERROR_TITLE]: "Erro de conexão",
  [APPSUMO_CALLBACK_ERROR_DESCRIPTION]:
    "Ocorreu um erro ao conectar sua conta do AppSumo. Tente novamente pelo AppSumo ou entre em contato com o suporte.",
  [APPSUMO_CALLBACK_ERROR_CODE_EXPIRED]:
    "Este link expirou ou já foi usado. Reinicie o processo pelo AppSumo.",
  [APPSUMO_CALLBACK_ERROR_OAUTH_DENIED]:
    "O acesso foi negado. Tente novamente pelo AppSumo.",
  [APPSUMO_CALLBACK_BUTTON_RETURN_TO_APPSUMO]: "Voltar ao AppSumo",
  [APPSUMO_CALLBACK_ERROR_ANOMALOUS]:
    "Ocorreu um erro inesperado com a sua conta. Entre em contato com o suporte.",

  // MODAL PERFORMANCE MARKETING SPECIALIST
  [BUTTON_HIRE_PERFORMANCE_SPECIALIST]: "Contratar especialista",
  [MODAL_PERFORMANCE_SPECIALIST_ARIA_LABEL]:
    "Modal de especialista em performance marketing",
  [MODAL_PERFORMANCE_SPECIALIST_TITLE]: "Especialista em performance marketing",
  [MODAL_PERFORMANCE_SPECIALIST_SUBTITLE]:
    "Serviço 100% gerenciado por nós: definimos os objetivos junto com você, nós executamos, otimizamos e reportamos.",
  [MODAL_PERFORMANCE_SPECIALIST_WHAT_YOU_GET_TITLE]: "O que faremos por você",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_1]: "Estratégia e definição de KPIs",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_2]:
    "Otimização contínua no Meta, Google e TikTok",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_3]:
    "Revisão de tracking, medição e atribuição",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_4]:
    "Insights semanais e relatório mensal",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_TITLE]: "Preço e condições",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_MAIN]:
    "USD 499/mês + {{percentage}}% do gasto publicitário mensal",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_1]:
    "O investimento em anúncios não está incluído e é pago diretamente às plataformas.",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_2]:
    "Cláusula de permanência de 3 meses.",
  [MODAL_PERFORMANCE_SPECIALIST_CTA]: "Contratar especialista",

  // MODAL AD HOC SUPPORT
  [MODAL_AD_HOC_SUPPORT_ARIA_LABEL]: "Modal de sessão de suporte",
  [MODAL_AD_HOC_SUPPORT_TITLE]: "Sessão de suporte",
  [MODAL_AD_HOC_SUPPORT_DESCRIPTION]:
    "Agende uma sessão de suporte com a nossa equipe para potencializar os seus resultados.",
  [BILLING_SPECIALIST_PURCHASE_SUCCESS_TITLE]: "Pagamento concluído",
  [BILLING_SPECIALIST_PURCHASE_SUCCESS_DESCRIPTION]:
    "Você contratou um especialista. O próximo passo é agendar uma reunião com a nossa equipe",
  [BILLING_SPECIALIST_SCHEDULE_MEETING_BUTTON]: "Agendar reunião",

  // APPSUMO REGISTER
  [APPSUMO_REGISTER_TITLE]: "Crie sua conta",
  [APPSUMO_REGISTER_SUBTITLE]:
    "Conclua o seu cadastro para ativar a sua licença do AppSumo.",
  [APPSUMO_REGISTER_BUTTON_SUBMIT]: "Criar conta",
  [APPSUMO_REGISTER_SESSION_EXPIRED]:
    "Sua sessão expirou. Reinicie o processo pelo AppSumo.",
  [APP_SUMO_REACTIVATION_NOT_ELIGIBLE]:
    "Esta conta não pode ser reativada pelo AppSumo. Tente entrar ou entre em contato com o suporte.",
  [APPSUMO_REACTIVATION_OTP_TITLE]: "Reative sua conta",
  [APPSUMO_REACTIVATION_OTP_EMAIL_SENT]:
    "Enviamos um código de reativação para {{emailMasked}}.",

  // ENTERPRISE INTAKE
  [ENTERPRISE_INTAKE_BADGE]: "Enterprise Intake",
  [ENTERPRISE_INTAKE_BADGE_AGENCY]: "PROPOSTA ENTERPRISE · AGÊNCIAS",
  [ENTERPRISE_INTAKE_BADGE_BRAND]: "PROPOSTA ENTERPRISE · MARCAS",
  [ENTERPRISE_INTAKE_HERO_TITLE]: "Formulário Enterprise Intake",
  [ENTERPRISE_INTAKE_HERO_DESCRIPTION]:
    "Com essas respostas preparamos uma proposta sob medida para a sua operação. Tempo estimado: 5 minutos.",
  [ENTERPRISE_INTAKE_SECTION_01_CONTACT]: "Contato",
  [ENTERPRISE_INTAKE_SECTION_02_MODULE_SELECTOR]: "Alcance",
  [ENTERPRISE_INTAKE_SECTION_03_USERS]: "Usuários",
  [ENTERPRISE_INTAKE_SECTION_04_SUPPORT_CONTRACT]: "Plano",
  [ENTERPRISE_INTAKE_SECTION_05_ADDITIONAL_NOTES]: "Notas adicionais",
  [ENTERPRISE_INTAKE_ARIA_REQUIRED]: "obrigatório",
  [ENTERPRISE_INTAKE_SUBMIT_BUTTON]: "Enviar formulário →",
  [ENTERPRISE_INTAKE_SUBMIT_SUCCESS_TITLE]: "Formulário enviado",
  [ENTERPRISE_INTAKE_SUBMIT_SUCCESS_MESSAGE]:
    "Suas informações foram registradas corretamente. Prepararemos a sua proposta Enterprise em 24–48 horas e entraremos em contato.",
  [ENTERPRISE_INTAKE_CONFIDENTIALITY_NOTE]:
    "Suas informações são 100% confidenciais e só serão usadas pela equipe Adle para preparar a sua proposta Enterprise.",
  [ENTERPRISE_INTAKE_OTHER_OPTION]: "Outro",
  [ENTERPRISE_INTAKE_OTHER_PLACEHOLDER]: "Especifique aqui…",

  [ENTERPRISE_INTAKE_FIELD_FULL_NAME]: "Nome completo",
  [ENTERPRISE_INTAKE_FIELD_CORPORATE_EMAIL]: "E-mail corporativo",
  [ENTERPRISE_INTAKE_FIELD_COMPANY_NAME]: "Empresa",
  [ENTERPRISE_INTAKE_FIELD_JOB_TITLE]: "Cargo",
  [ENTERPRISE_INTAKE_FIELD_COMPANY_WEBSITE]: "Site da empresa",
  [ENTERPRISE_INTAKE_PLACEHOLDER_FULL_NAME]: "Ex.: Maria Garcia",
  [ENTERPRISE_INTAKE_PLACEHOLDER_CORPORATE_EMAIL]: "Ex.: maria@empresa.com",
  [ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME]: "Ex.: Agência Digital S.A.",
  [ENTERPRISE_INTAKE_PLACEHOLDER_JOB_TITLE]: "Ex.: Head de Marketing",
  [ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_WEBSITE]:
    "Ex.: https://www.empresa.com",

  [ENTERPRISE_INTAKE_FIELD_PURCHASE_DECISION_MAKER]:
    "Quem toma a decisão final de compra?",
  [ENTERPRISE_INTAKE_PURCHASE_DECISION_SELF]: "Eu sou quem decide",
  [ENTERPRISE_INTAKE_PURCHASE_DECISION_COLLECT_INFO]:
    "Eu reúno as informações, outra pessoa/área decide",
  [ENTERPRISE_INTAKE_PURCHASE_DECISION_SHARED]:
    "Decisão compartilhada entre várias áreas",
  [ENTERPRISE_INTAKE_FIELD_CURRENT_TOOL_OR_ADLE_STATUS]:
    "Atualmente vocês usam outra ferramenta ou já são clientes da Adle?",
  [ENTERPRISE_INTAKE_CURRENT_TOOL_ADLE_CLIENT]:
    "Somos clientes atuais da Adle (renovação / expansão)",
  [ENTERPRISE_INTAKE_CURRENT_TOOL_EVALUATING_SWITCH]:
    "Usamos outra ferramenta e estamos avaliando mudar",
  [ENTERPRISE_INTAKE_CURRENT_TOOL_NO_SIMILAR]:
    "Não usamos nenhuma ferramenta semelhante hoje",
  [ENTERPRISE_INTAKE_FIELD_OPERATING_COUNTRIES_COUNT]:
    "Em quantos países / mercados vocês operam?",
  [ENTERPRISE_INTAKE_PLACEHOLDER_OPERATING_COUNTRIES_COUNT]: "Ex.: 3",
  [ENTERPRISE_INTAKE_FIELD_CREATIVES_VARY_BY_MARKET]:
    "Se vocês operam em vários mercados, os criativos variam por país/idioma?",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_YES_PER_MARKET]:
    "Sim, cada mercado precisa das próprias versões",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_PARTIALLY]:
    "Parcialmente — alguns assets são adaptados por mercado",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_NO_SAME_MATERIAL]:
    "Não, o mesmo material é usado em todos",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_NOT_APPLICABLE]: "Não se aplica",

  [ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES]:
    "Você pode marcar vários. Conforme o que marcar, aparecem as seções de assets criativos e de campanhas.",
  [ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES]:
    "Quais módulos da Adle vocês vão utilizar?",
  [ENTERPRISE_INTAKE_MODULE_CREATIVE_ASSETS]:
    "Módulo 1 · Geração de assets criativos: imagens, adaptações, animações e vídeos",
  [ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_LAUNCH]:
    "Módulo 2 · Implementação de campanhas: criar e lançar campanhas pela Adle",
  [ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_IMPORT]:
    "Módulo 3 · Monitoramento e otimizações: aplicar otimizações às campanhas",
  [ENTERPRISE_INTAKE_MODULE_ORGANIC_SOCIAL]:
    "Módulo 6 · Social media: programar publicações nas redes sociais",
  [ENTERPRISE_INTAKE_FIELD_PRIMARY_GOAL]:
    "Objetivo principal que vocês buscam resolver com a Adle",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_CREATIVE_SPEED]:
    "Aumentar a velocidade e o volume de criativos",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_PERFORMANCE]:
    "Melhorar o desempenho / ROI das campanhas",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_SCALE_MULTIPLATFORM]:
    "Escalar campanhas multiplataforma",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_REDUCE_COSTS]:
    "Reduzir custos de produção de assets",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_CENTRALIZE_OPERATIONS]:
    "Centralizar a operação de várias marcas/anunciantes",
  [ENTERPRISE_INTAKE_VOLUME_STABLE_YEAR_ROUND]: "Estável o ano todo",
  [ENTERPRISE_INTAKE_VOLUME_PEAK_DEMAND]: "Tem picos de alta demanda",

  [ENTERPRISE_INTAKE_SECTION_MODULE_1_CREATIVE_ASSETS]: "Assets criativos",
  [ENTERPRISE_INTAKE_MODULE1_INTRO]:
    "Aparece e é obrigatória somente se você marcou o Módulo 1. Cada formato e cada frame de carrossel conta como uma peça.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_BRANDS_OR_VISUAL_IDENTITIES_COUNT]:
    "Quantas marcas ou identidades visuais vocês vão gerenciar no módulo criativo?",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_INDEPENDENT_BRAND_CONFIGS_COUNT]:
    "Quantas configurações de marca INDEPENDENTES vocês precisam?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_INDEPENDENT_BRAND_CONFIGS]:
    "Cada marca ou submarca com o próprio brandbook / identidade visual distinta exige uma configuração independente para que a IA gere assets alinhados. Ex.: uma marca com 3 submarcas visualmente distintas = 3 configurações.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_NEW_IMAGES_COUNT]:
    "Quantas peças estáticas vocês precisam por mês?",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_FORMATS_PER_PIECE_AVG]:
    "Em média, para quantos formatos / posicionamentos vocês adaptam cada peça?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_FORMATS_PER_PIECE]:
    "Ex.: se uma imagem é publicada no feed, nos stories e em um banner, são 3 formatos. Ao operar em várias plataformas, esse número costuma ficar entre 3 e 5. Cada adaptação de formato conta como uma ação independente.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_ADDITIONAL_EDITS_COUNT]:
    "Quantas adaptações / edições ADICIONAIS vocês fazem por mês? (opcional)",
  [ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_ADDITIONAL_EDITS]:
    "Edições ou versões que não são adaptação de formato — mudanças de texto, retoques etc.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_VIDEOS_COUNT]:
    "Quantos vídeos por mês?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_VIDEOS]:
    "Até 30 segundos, com roteiro, áudio e legendas.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_IMAGE_ANIMATIONS_COUNT]:
    "Quantas animações por mês?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_IMAGE_ANIMATIONS]:
    "Movimento sobre uma peça estática já aprovada.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_VERSIONS_PER_PIECE_BEFORE_APPROVAL]:
    "Quantas versões ou ajustes vocês fazem por peça antes de aprová-la?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_VERSIONS_PER_PIECE]:
    "Cada iteração conta como uma ação.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_CREATIVE_VOLUME_VARIATION]:
    "O volume criativo varia entre os meses?",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_PEAK_MONTH_PIECES_COUNT]:
    "Se houver picos: quantas peças em um mês ALTO?",

  [ENTERPRISE_INTAKE_SECTION_MODULE_2_PAID_MEDIA_LAUNCH]: "Campanhas",
  [ENTERPRISE_INTAKE_MODULE2_INTRO]:
    "Aparece e é obrigatória somente se você marcou o Módulo 2 ou o Módulo 3.",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_AD_ACCOUNTS_OR_ADVERTISERS_COUNT]:
    "Quantas contas de anúncios / anunciantes vocês vão conectar?",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT]:
    "Quantas campanhas vocês vão implementar por mês, no total?",
  [ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_CAMPAIGNS]:
    "Cada campanha é contada POR PLATAFORMA. Uma campanha no Meta, Google e TikTok conta como 3. Indique o total de ativações por canal.",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_OPTIMIZATIONS_COUNT]:
    "Quantas otimizações em um mês médio?",
  [ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_OPTIMIZATIONS]:
    "Ajustes de desempenho em campanhas ativas. Considere que cada campanha ativa costuma exigir vários ajustes por mês para manter o desempenho; não subestime esse volume se vocês gerenciam muitas campanhas.",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_CAMPAIGN_VOLUME_VARIATION]:
    "O volume de campanhas varia entre os meses?",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_PEAK_MONTH_CAMPAIGNS_COUNT]:
    "Se houver picos: quantas campanhas em um mês ALTO?",

  [ENTERPRISE_INTAKE_SECTION_MODULE_3_PAID_MEDIA_IMPORT]:
    "Módulo 3 — Importação de campanhas de mídia paga",
  [ENTERPRISE_INTAKE_MODULE3_INTRO]:
    "Responda somente se você marcou este módulo. Se não se aplica, pule para a próxima seção.",
  [ENTERPRISE_INTAKE_MODULE3_FIELD_CAMPAIGNS_TO_IMPORT]:
    "Quantas campanhas vocês importariam? (uma única vez, no início)",
  [ENTERPRISE_INTAKE_MODULE3_FIELD_IMPORT_PLATFORMS]:
    "De quais plataformas vocês importariam? (marque todas)",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_META]: "Meta",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_GOOGLE]: "Google",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_TIKTOK]: "TikTok",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_LINKEDIN]: "LinkedIn",

  [ENTERPRISE_INTAKE_SECTION_MODULE_4_ORGANIC_SOCIAL]:
    "Módulo 4 — Redes sociais / Publicações orgânicas",
  [ENTERPRISE_INTAKE_MODULE4_INTRO]:
    "Responda somente se você marcou este módulo. Se não se aplica, pule para a próxima seção.",
  [ENTERPRISE_INTAKE_MODULE4_FIELD_MONTHLY_ORGANIC_POSTS]:
    "Quantas publicações orgânicas vocês agendam em um mês médio?",
  [ENTERPRISE_INTAKE_MODULE4_FIELD_SCHEDULING_NETWORKS]:
    "Em quais redes vocês agendariam? (marque todas)",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_INSTAGRAM]: "Instagram",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_FACEBOOK]: "Facebook",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_TIKTOK]: "TikTok",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_LINKEDIN]: "LinkedIn",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_X_TWITTER]: "X / Twitter",
  [ENTERPRISE_INTAKE_MODULE4_FIELD_POST_CREATION_SOURCE]:
    "As publicações são criadas na Adle ou já vêm prontas?",
  [ENTERPRISE_INTAKE_MODULE4_POST_CREATED_IN_ADLE]:
    "São criadas na Adle (criativo + copy)",
  [ENTERPRISE_INTAKE_MODULE4_POST_READY_TO_SCHEDULE]:
    "Já vêm prontas, a Adle só agenda",
  [ENTERPRISE_INTAKE_MODULE4_POST_MIXED]: "Misto",

  [ENTERPRISE_INTAKE_FIELD_ACTIVE_ADVERTISERS_MONTH1]:
    "Quantos anunciantes estarão ATIVOS na Adle durante o primeiro mês?",
  [ENTERPRISE_INTAKE_HINT_ACTIVE_ADVERTISERS_MONTH1]:
    "Os que realmente vão operar desde o início",
  [ENTERPRISE_INTAKE_FIELD_TOTAL_ADVERTISERS_60_90]:
    "Nos próximos 60–90 dias, qual será o TOTAL de anunciantes que vocês esperam gerenciar?",
  [ENTERPRISE_INTAKE_HINT_TOTAL_ADVERTISERS_60_90]:
    "Inclui os do mês 1 + os que entrarem depois",
  [ENTERPRISE_INTAKE_FIELD_ADMIN_ACCESS_PHASE1]:
    "Vocês têm acesso de administrador às contas de anúncios que vão conectar?",
  [ENTERPRISE_INTAKE_ADMIN_ACCESS_ALL]: "Sim, a todas",
  [ENTERPRISE_INTAKE_ADMIN_ACCESS_MOST]: "À maioria",
  [ENTERPRISE_INTAKE_ADMIN_ACCESS_SOME]: "A algumas / ainda não",

  [ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT]:
    "Quantos usuários precisam de acesso?",
  [ENTERPRISE_INTAKE_FIELD_PLATFORM_CAPACITY_MANAGEMENT]:
    "Como será gerenciado o uso da capacidade da plataforma?",
  [ENTERPRISE_INTAKE_PLATFORM_CAPACITY_CENTRALIZED_POOL]:
    "Pool centralizado (todos compartilham o total)",
  [ENTERPRISE_INTAKE_PLATFORM_CAPACITY_ASSIGNED_QUOTAS]:
    "Cotas atribuídas por conta / marca",
  [ENTERPRISE_INTAKE_CREDITS_MIXED]: "Misto",

  [ENTERPRISE_INTAKE_CREDITS_EQUIVALENCES_TITLE]:
    "Equivalências de créditos (modelo atual da Adle)",
  [ENTERPRISE_INTAKE_CREDITS_RENEWAL_NOTE]:
    "Os créditos são renovados mensalmente e não são acumuláveis.",
  [ENTERPRISE_INTAKE_CREDITS_UNCERTAIN_NOTE]:
    "Se você não tiver 100% de certeza dos volumes, escolha a faixa mais próxima. Na chamada de validação ajustamos a estimativa.",
  [ENTERPRISE_INTAKE_VOLUME_ZERO]: "0 — não vou usar",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_ESTIMATED_CREDITS]:
    "Estimativa total de créditos a consumir por mês",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_ESTIMATED_CREDITS]:
    "Se você não tiver 100% de certeza dos volumes, escolha a faixa mais próxima ou deixe em branco e nós calculamos",

  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_IMAGES]:
    "Imagens com IA estimadas por mês",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_IMAGES]:
    "Número aproximado de imagens com IA geradas por mês",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_VIDEOS]:
    "Vídeos com IA estimados por mês",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_VIDEOS]:
    "Número aproximado de vídeos com IA gerados por mês",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_CAMPAIGNS]:
    "Campanhas com IA estimadas por mês",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_CAMPAIGNS]:
    "Número aproximado de campanhas com IA criadas por mês",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_OPTIMIZATIONS]:
    "Otimizações com IA estimadas por mês",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_OPTIMIZATIONS]:
    "Número aproximado de otimizações com IA executadas por mês",
  [ENTERPRISE_INTAKE_FIELD_USES_ORGANIC_SCHEDULING]:
    "Vocês usarão agendamento de publicações orgânicas?",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_ORGANIC_POSTS]:
    "Publicações orgânicas estimadas por mês",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_ORGANIC_POSTS]:
    "Número aproximado de publicações orgânicas agendadas por mês",
  [ENTERPRISE_INTAKE_FIELD_PHASE1_PAID_CHANNELS]:
    "Em quais canais vocês ativam campanhas? (marque todos)",
  [ENTERPRISE_INTAKE_HINT_PHASE1_PAID_CHANNELS]:
    "Selecione todos os que se aplicam",
  [ENTERPRISE_INTAKE_CHANNEL_META]: "Meta (Facebook / Instagram)",
  [ENTERPRISE_INTAKE_CHANNEL_GOOGLE]: "Google (Ads / Display)",
  [ENTERPRISE_INTAKE_CHANNEL_TIKTOK]: "TikTok",
  [ENTERPRISE_INTAKE_CHANNEL_LINKEDIN]: "LinkedIn",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AD_SPEND_RANGE]:
    "Faixa de investimento publicitário mensal (Ad Spend) que a Adle vai gerenciar",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AD_SPEND_RANGE]:
    "Não inclui o custo da plataforma",
  [ENTERPRISE_INTAKE_AD_SPEND_LESS_THAN_10K]: "Menos de $10 mil USD",
  [ENTERPRISE_INTAKE_AD_SPEND_MORE_THAN_500K]: "Mais de $500 mil USD",

  [ENTERPRISE_INTAKE_FIELD_PLATFORM_MANAGEMENT]:
    "Quem vai gerenciar a plataforma?",
  [ENTERPRISE_INTAKE_HINT_PLATFORM_MANAGEMENT]:
    "Indica se é necessário um kick-off de treinamento pago",
  [ENTERPRISE_INTAKE_PLATFORM_MGMT_OWN_TEAM]:
    "Nossa própria equipe (requer treinamento / kick-off)",
  [ENTERPRISE_INTAKE_PLATFORM_MGMT_THIRD_PARTY]:
    "Um terceiro / agência gerencia para nós",
  [ENTERPRISE_INTAKE_PLATFORM_MGMT_ADLE_OPERATES]:
    "A Adle opera a plataforma para nós",
  [ENTERPRISE_INTAKE_FIELD_WHITE_LABEL]: "Vocês precisam de white label?",
  [ENTERPRISE_INTAKE_HINT_WHITE_LABEL]:
    "A plataforma com a marca de vocês. Só com contrato de 12 meses e é cotada à parte.",
  [ENTERPRISE_INTAKE_WHITE_LABEL_ESSENTIAL]: "Sim, é indispensável",
  [ENTERPRISE_INTAKE_WHITE_LABEL_INTERESTED]:
    "Temos interesse, mas não é indispensável",
  [ENTERPRISE_INTAKE_WHITE_LABEL_NOT_NEEDED]: "Não precisamos",
  [ENTERPRISE_INTAKE_WHITE_LABEL_UNSURE]: "Não tenho certeza / vamos conversar",
  [ENTERPRISE_INTAKE_FIELD_URGENCY_DEADLINE]:
    "Vocês têm uma data limite ou um evento que marque urgência?",
  [ENTERPRISE_INTAKE_PLACEHOLDER_URGENCY_DEADLINE]:
    "Ex.: vencimento do contrato atual, lançamento de campanha, apresentação a um cliente",
  [ENTERPRISE_INTAKE_FIELD_ESTIMATED_TOOL_BUDGET]:
    "Vocês têm um orçamento estimado previsto para esta ferramenta?",
  [ENTERPRISE_INTAKE_HINT_ESTIMATED_TOOL_BUDGET]:
    "Nos ajuda a adequar a proposta à realidade de vocês. É uma referência, não um compromisso.",
  [ENTERPRISE_INTAKE_BUDGET_LT_1000]: "Menos de $1.000 USD/mês",
  [ENTERPRISE_INTAKE_BUDGET_1000_2500]: "$1.000 – $2.500 USD/mês",
  [ENTERPRISE_INTAKE_BUDGET_2500_5000]: "$2.500 – $5.000 USD/mês",
  [ENTERPRISE_INTAKE_BUDGET_5000_10000]: "$5.000 – $10.000 USD/mês",
  [ENTERPRISE_INTAKE_BUDGET_GT_10000]: "Mais de $10.000 USD/mês",
  [ENTERPRISE_INTAKE_BUDGET_NOT_DEFINED]:
    "Ainda não temos um orçamento definido",
  [ENTERPRISE_INTAKE_BUDGET_PREFER_NOT_ANSWER]: "Prefiro não responder",

  [ENTERPRISE_INTAKE_FIELD_SUPPORT_LEVEL]:
    "Nível de suporte e operação necessário",
  [ENTERPRISE_INTAKE_SUPPORT_TECH_ONLY]:
    "Somente tecnologia (autogestão + suporte técnico padrão)",
  [ENTERPRISE_INTAKE_SUPPORT_PARTIAL]:
    "Acompanhamento parcial (CSM + adoção / estratégia)",
  [ENTERPRISE_INTAKE_SUPPORT_FULL_OPERATION]:
    "Operação completa (a Adle executa)",
  [ENTERPRISE_INTAKE_FIELD_CSM_CADENCE]:
    "Frequência de contato com o Customer Success Manager (CSM)",
  [ENTERPRISE_INTAKE_CSM_WEEKLY]: "Semanal",
  [ENTERPRISE_INTAKE_CSM_BIWEEKLY]: "Quinzenal",
  [ENTERPRISE_INTAKE_CSM_MONTHLY]: "Mensal",
  [ENTERPRISE_INTAKE_CSM_AS_NEEDED]: "Somente quando necessário",
  [ENTERPRISE_INTAKE_FIELD_CONTRACT_FORMAT]:
    "Por quanto tempo seria o contrato?",
  [ENTERPRISE_INTAKE_CONTRACT_MONTHLY]: "Mensal (máxima flexibilidade)",
  [ENTERPRISE_INTAKE_CONTRACT_QUARTERLY]: "Trimestral",
  [ENTERPRISE_INTAKE_CONTRACT_ANNUAL]: "Anual (melhor tarifa)",
  [ENTERPRISE_INTAKE_FIELD_IMPLEMENTATION_TIMELINE]:
    "Horizonte de implementação desejado",
  [ENTERPRISE_INTAKE_HINT_IMPLEMENTATION_TIMELINE]:
    "Da assinatura até o Go-Live",
  [ENTERPRISE_INTAKE_TIMELINE_0_3_DAYS]: "0–3 dias",
  [ENTERPRISE_INTAKE_TIMELINE_4_7_DAYS]: "4–7 dias",
  [ENTERPRISE_INTAKE_TIMELINE_8_15_DAYS]: "8–15 dias",
  [ENTERPRISE_INTAKE_TIMELINE_16_30_DAYS]: "16–30 dias",
  [ENTERPRISE_INTAKE_TIMELINE_30_PLUS_DAYS]: "Mais de 30 dias",
  [ENTERPRISE_INTAKE_FIELD_SECURITY_REQUIREMENTS]:
    "Requisitos de segurança / TI",
  [ENTERPRISE_INTAKE_SECURITY_SSO]: "SSO (Single Sign-On) obrigatório",
  [ENTERPRISE_INTAKE_SECURITY_AUDIT_LOGS]: "Logs de auditoria e controle de IP",
  [ENTERPRISE_INTAKE_SECURITY_NOT_APPLICABLE]:
    "Não se aplica — somente acesso por e-mail e senha",

  [ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES]:
    "Há mais alguma coisa que precisamos saber?",
  [ENTERPRISE_INTAKE_HINT_ADDITIONAL_NOTES]:
    "Ex.: é para uma licitação com prazo, integrações ou restrições de TI.",
  [ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES]:
    "Ex.: é para uma licitação com prazo, integrações ou restrições de TI.",
  [ENTERPRISE_INTAKE_FOOTNOTE_ADDITIONAL_NOTES]:
    "Com base nas suas respostas, agendaremos uma chamada de validação para ajustar a estimativa antes da proposta final.",

  [ENTERPRISE_INTAKE_MODULE_REPORTS]:
    "Módulo 4 · Relatórios: visualizar, analisar e baixar",
  [ENTERPRISE_INTAKE_MODULE_COMPETITORS]:
    "Módulo 5 · Concorrentes: analisar anúncios da concorrência e usá-los como referência para gerar conteúdo",
  [ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT]:
    "Quantas marcas vocês vão configurar na Adle?",
  [ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT_AGENCY]:
    "Quantas marcas ou anunciantes vocês vão configurar na Adle?",
  [ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_AGENCY]:
    "Cada marca tem a própria configuração para gerar conteúdo: brandbook, tom de voz, identidade visual, tipografias, cores, buyer persona e audiência. Se uma submarca tem um estilo diferente, conte à parte. Contas de anúncios, páginas do Facebook, perfis do Instagram e plataformas (Meta, Google, TikTok, LinkedIn) da mesma marca não contam à parte. Se vocês vão usar só o módulo de campanhas, conte cada anunciante.",
  [ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_BRAND]:
    "Cada marca tem a própria configuração para gerar conteúdo: brandbook, tom de voz, identidade visual, tipografias, cores, buyer persona e audiência. Se uma submarca tem um estilo diferente, conte à parte. Contas de anúncios, páginas do Facebook, perfis do Instagram e plataformas (Meta, Google, TikTok, LinkedIn) da mesma marca não contam à parte. Se vocês vão usar só o módulo de campanhas, conte cada marca que anuncia.",
  [ENTERPRISE_INTAKE_PLACEHOLDER_SCOPE_BRANDS_COUNT]: "Número",
  [ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME_BRAND]: "Ex.: Marca S.A.",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_STATIC_PIECES]:
    "Ex.: 100 peças em 3 formatos são 300 peças.",
  [ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER]:
    "Vocês querem folga? Para quais gerações?",
  [ENTERPRISE_INTAKE_HINT_CREATIVES_BUFFER]:
    "Margem extra sobre o volume do mês para ajustes e novas versões: cada ajuste consome o mesmo que gerar a peça de novo. Os planos Enterprise costumam usar 15%. Ex.: 100 estáticas com 15% = 115 no plano.",
  [ENTERPRISE_INTAKE_BUFFER_STATICS]: "Estáticas",
  [ENTERPRISE_INTAKE_BUFFER_ANIMATIONS]: "Animações",
  [ENTERPRISE_INTAKE_BUFFER_VIDEOS]: "Vídeos",
  [ENTERPRISE_INTAKE_BUFFER_NONE]: "Não precisamos de folga",
  [ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER_PERCENT]: "De quanto?",
  [ENTERPRISE_INTAKE_BUFFER_PERCENT_10]: "10%",
  [ENTERPRISE_INTAKE_BUFFER_PERCENT_15]: "15% · recomendado",
  [ENTERPRISE_INTAKE_BUFFER_PERCENT_20]: "20%",
  [ENTERPRISE_INTAKE_PLACEHOLDER_BUFFER_PERCENT_OTHER]: "Ex.: 25",
  [ENTERPRISE_INTAKE_HINT_CAMPAIGNS_SECTION]:
    "Aparece e é obrigatória somente se você marcou o Módulo 2 ou o Módulo 3.",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_AGENCY]:
    "Somando todas as plataformas e anunciantes.",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_BRAND]:
    "Somando todas as plataformas e marcas.",
  [ENTERPRISE_INTAKE_FIELD_OPTIMIZATION_FREQUENCY]:
    "Com que frequência vocês otimizam cada campanha?",
  [ENTERPRISE_INTAKE_HINT_OPTIMIZATION_FREQUENCY]:
    "Cada otimização sugerida pela IA que é aplicada consome créditos; as que não são aplicadas e os ajustes manuais não consomem.",
  [ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_LOW]:
    "Baixa: 1 vez por semana (4 por mês por campanha)",
  [ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_MEDIUM]:
    "Média: 2 vezes por semana (8 por mês por campanha) · recomendado",
  [ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_HIGH]:
    "Alta: 3 ou mais por semana (12 por mês por campanha)",
  [ENTERPRISE_INTAKE_HINT_PLATFORM_USERS_COUNT]:
    "Quem só aprova peças não precisa de usuário.",
  [ENTERPRISE_INTAKE_HINT_CONTRACT_TERM]:
    "Mínimo de 6 meses. Com 12 meses a tarifa mensal é menor.",
  [ENTERPRISE_INTAKE_CONTRACT_TERM_6]: "6 meses",
  [ENTERPRISE_INTAKE_CONTRACT_TERM_12]: "12 meses · melhor tarifa",
  [ENTERPRISE_INTAKE_FIELD_MEDIA_MANAGEMENT_ADDON]:
    "Vocês querem que a equipe da Adle gerencie a estratégia e a mídia?",
  [ENTERPRISE_INTAKE_HINT_MEDIA_MANAGEMENT_ADDON]:
    "O add-on de gestão equivale a 15% do investimento mensal em mídia.",
  [ENTERPRISE_INTAKE_MEDIA_ADDON_YES]: "Sim, com o add-on de gestão",
  [ENTERPRISE_INTAKE_MEDIA_ADDON_NO]: "Não, nossa equipe opera a plataforma",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_MEDIA_SPEND]:
    "Quanto vocês investem por mês em mídia, somando todas as plataformas?",
  [ENTERPRISE_INTAKE_PLACEHOLDER_MONTHLY_MEDIA_SPEND]: "USD por mês",
  [ENTERPRISE_INTAKE_WHITE_LABEL_YES]: "Sim",
  [ENTERPRISE_INTAKE_WHITE_LABEL_NO]: "Não",
  [ENTERPRISE_INTAKE_SECTION_PLAN]: "Plano",

  [OWNER_FORM_SUBMISSION_TYPE_PRE_ACTIVATION]: "Pré-ativação",
  [OWNER_FORM_SUBMISSION_TYPE_ENTERPRISE]: "Enterprise",

  [OPTION_EMAIL]: "E-mail",
  [OPTION_META]: "Meta (Instagram ou Facebook)",
  [OPTION_GOOGLE]: "Google",
  [OPTION_LINKEDIN]: "LinkedIn",
  [OPTION_LLM]: "LLM (ChatGPT, Grok, Claude, Gemini etc.)",
  [OPTION_OTHER]: "Outro",

  [GLOBAL_REPORT_TITLE]: "Relatórios",
  [GLOBAL_REPORT_DESCRIPTION]:
    "Conheça o desempenho das suas campanhas no período selecionado.",
  [GLOBAL_REPORT_MENU_GROUP]: "Relatórios / Métricas",
  [GLOBAL_REPORT_MENU_ITEM]: "Relatórios",
  [GLOBAL_REPORT_PAGE_TITLE]: "Relatório global da marca — {{brandName}}",
  [GLOBAL_REPORT_PERIOD_LAST_7_DAYS]: "Últimos 7 dias",
  [GLOBAL_REPORT_PERIOD_LAST_14_DAYS]: "Últimos 14 dias",
  [GLOBAL_REPORT_PERIOD_LAST_30_DAYS]: "Últimos 30 dias",
  [GLOBAL_REPORT_AI_ANALYSIS]: "Agente",
  [GLOBAL_REPORT_OBJECTIVES_BUTTON]: "Objetivos",
  [GLOBAL_REPORT_TOTAL_INVESTMENT]: "Investimento total",
  [GLOBAL_REPORT_AVERAGE_ROAS]: "ROAS médio",
  [GLOBAL_REPORT_ACTIVE_CAMPAIGNS]: "Campanhas ativas",
  [GLOBAL_REPORT_REMAINING_BUDGET]: "Orçamento restante",
  [GLOBAL_REPORT_BUDGET_EXPIRES_IN]: "Expira em {{days}} dias",
  [GLOBAL_REPORT_PAUSED_CAMPAIGNS]: "{{count}} pausadas",
  [GLOBAL_REPORT_VS_PREVIOUS_WEEK]: "vs semana anterior",
  [GLOBAL_REPORT_AGENT_INSIGHTS]: "Insights",
  [GLOBAL_REPORT_NEW_INSIGHTS]: "{{count}} novos",
  [GLOBAL_REPORT_NO_INSIGHTS]:
    "Não há insights disponíveis para este período. Tente outro intervalo de datas ou quando houver mais atividade nas suas campanhas.",
  [GLOBAL_REPORT_INSIGHTS_ERROR]:
    "Não foi possível gerar os insights. Tente novamente mais tarde.",
  [GLOBAL_REPORT_SUMMARY_TITLE]: "Resumo do período",
  [GLOBAL_REPORT_SUMMARY_OVERVIEW_TEXT]:
    "Como foi o desempenho geral do portfólio entre {{startDateTime}} e {{endDateTime}}? Inclua quantas campanhas rodaram ou foram criadas no período, as métricas agregadas (investimento, ROAS, impressões, cliques) e um parágrafo conciso com os principais achados.",
  [GLOBAL_REPORT_INSIGHTS_QUESTION]:
    "Gere insights de portfólio para as próximas campanhas: o que devo repetir ou fazer de novo (o que funcionou), o que devo evitar ou deixar de fazer (o que falhou) e alertas. Baseie-os em métricas semanais, copy dos anúncios (ângulos, hooks, dores, CTAs, títulos) e registros de alterações. Seja específico e acionável — nada genérico.",
  [GLOBAL_REPORT_GENERATING_SUMMARY]: "Gerando resumo...",
  [GLOBAL_REPORT_SUMMARY_NOT_GENERATED]:
    "Não foi possível gerar o resumo para este período.",
  [GLOBAL_REPORT_ASK_QUESTION]: "Pergunte ao agente sobre este relatório...",
  [GLOBAL_REPORT_ASK_QUESTION_OPEN]: "Pergunte-me sobre as suas campanhas",
  [GLOBAL_REPORT_VIEW_HISTORICAL_INSIGHTS]: "Ver todos os insights históricos",
  [GLOBAL_REPORT_AGENT_ACTIONS]: "Resumo das ações do agente",
  [GLOBAL_REPORT_ACTIONS_PERFORMED]: "Ações realizadas",
  [GLOBAL_REPORT_ACTION_TYPE_GENERATE_CAMPAIGN]: "{{count}} campanhas criadas",
  [GLOBAL_REPORT_ACTION_TYPE_CREATIVES]: "{{count}} imagens geradas",
  [GLOBAL_REPORT_ACTION_TYPE_VIDEOS]: "{{count}} vídeos produzidos",
  [GLOBAL_REPORT_ACTION_TYPE_MESSAGES]: "{{count}} otimizações aplicadas",
  [GLOBAL_REPORT_ACTION_TYPE_OPTIMIZATIONS_APPLIED]:
    "{{count}} otimizações aplicadas",
  [GLOBAL_REPORT_ACTION_TYPE_GENERIC]: "{{count}} ações realizadas",
  [GLOBAL_REPORT_ACTION_CREATIVES_SUBTITLE]: "Criativos gerados com IA",
  [GLOBAL_REPORT_ACTION_VIDEOS_SUBTITLE]: "Vídeos gerados com IA",
  [GLOBAL_REPORT_ACTION_MESSAGES_SUBTITLE]: "Otimizações e mensagens do agente",
  [GLOBAL_REPORT_ACTION_GENERIC_SUBTITLE]: "Atividade registrada",
  [GLOBAL_REPORT_NO_ACTIONS_IN_PERIOD]:
    "Não há ações registradas neste período.",
  [GLOBAL_REPORT_NO_CAMPAIGNS_IN_PERIOD]:
    "Não foram encontradas campanhas para este intervalo de datas.",
  [GLOBAL_REPORT_NO_ACTIVITY_IN_PERIOD]:
    "Não há atividade de campanhas neste período.",
  [GLOBAL_REPORT_SELECT_DATES_PROMPT]:
    "Selecione um intervalo de datas para gerar o seu relatório.",
  [GLOBAL_REPORT_MEASURABLE_KPI_LABEL]: "KPI mensurável",
  [GLOBAL_REPORT_MEASURABLE_KPI_ALL]: "Todos os resultados",
  [GLOBAL_REPORT_NO_CAMPAIGNS_FOR_KPI]:
    "Nenhuma campanha ou plataforma neste período mede o KPI selecionado.",
  [GLOBAL_REPORT_DOWNLOAD_NOT_READY]:
    "O relatório ainda está sendo preparado. Aguarde um momento antes de baixá-lo.",
  [GLOBAL_REPORT_PDF_OPTION]: "Relatório PDF",
  [GLOBAL_REPORT_CUSTOM_OPTION]: "Relatório personalizado",
  [GLOBAL_REPORT_SERVER_PDF_BUTTON]: "Baixar PDF (servidor)",
  [GLOBAL_REPORT_SERVER_PDF_FOOTER]:
    "Adle · Relatório de leads · {{dateRange}}",
  [GLOBAL_REPORT_SERVER_PDF_FILE_NAME]: "Relatorio_{{dateRange}}.pdf",
  [MODAL_CUSTOM_REPORT_CTA]: "Personalizar relatório",
  [MODAL_CUSTOM_REPORT_TITLE]: "Gerar relatório personalizado",
  [MODAL_CUSTOM_REPORT_DESCRIPTION]:
    "Escolha um modelo, o período e o formato para gerar uma apresentação com os achados das suas campanhas.",
  [MODAL_CUSTOM_REPORT_TEMPLATE]: "Modelo",
  [MODAL_CUSTOM_REPORT_TEMPLATE_GENERAL]: "Geral",
  [MODAL_CUSTOM_REPORT_TEMPLATE_SALES]: "Vendas",
  [MODAL_CUSTOM_REPORT_TEMPLATE_LEADS]: "Leads",
  [MODAL_CUSTOM_REPORT_TEMPLATE_CUSTOM]: "Personalizado",
  [MODAL_CUSTOM_REPORT_PROMPT]: "Prompt",
  [MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER]:
    "Indique em que você quer focar o relatório. Ex.: quero que o relatório foque na análise do desempenho dos criativos e em quais ângulos de comunicação funcionaram melhor.",
  [MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER_CSV]:
    "Descreva as linhas e métricas do CSV. Ex.: campanhas e anúncios, detalhamento semanal, investimento, impressões, ROAS e cliques de saída únicos.",
  [MODAL_CUSTOM_REPORT_USE_PREVIOUS_PROMPT]: "Usar um prompt anterior",
  [MODAL_CUSTOM_REPORT_DATES]: "Datas",
  [MODAL_CUSTOM_REPORT_FORMAT]: "Formato do relatório",
  [MODAL_CUSTOM_REPORT_LANGUAGE]: "Idioma",
  [MODAL_CUSTOM_REPORT_FORMAT_PDF]: "PDF",
  [MODAL_CUSTOM_REPORT_FORMAT_PPTX]: "Apresentação PowerPoint (editável)",
  [MODAL_CUSTOM_REPORT_FORMAT_CSV]: "CSV (Excel)",
  [MODAL_CUSTOM_REPORT_PDF_UNAVAILABLE]:
    "A geração em PDF ainda não está disponível.",
  [MODAL_CUSTOM_REPORT_COLLECTING]: "Coletando informações",
  [MODAL_CUSTOM_REPORT_ANALYZING]: "Analisando informações",
  [MODAL_CUSTOM_REPORT_RENDERING]: "Preparando a apresentação",
  [MODAL_CUSTOM_REPORT_ERROR]:
    "Não foi possível gerar o relatório. Tente novamente.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_TITLE]: "Prompts anteriores",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DESCRIPTION]:
    "Escolha um prompt salvo ou exclua-o da lista.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_EMPTY]:
    "Ainda não há prompts personalizados salvos.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_TITLE]: "Excluir este prompt?",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_DESCRIPTION]:
    "Ele será apagado dos seus prompts salvos. Esta ação não pode ser desfeita.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE]: "Excluir prompt",
  [GLOBAL_REPORT_HEAVY_LOAD_FETCHING_CAMPAIGNS]:
    "Recuperando as informações das suas campanhas",
  [GLOBAL_REPORT_HEAVY_LOAD_FETCHING_STATS]:
    "Obtendo as estatísticas de desempenho",
  [GLOBAL_REPORT_HEAVY_LOAD_ANALYZING]: "Analisando as informações coletadas",
  [GLOBAL_REPORT_HEAVY_LOAD_GENERATING_INSIGHTS]: "Gerando insights acionáveis",
  [GLOBAL_REPORT_ACTIVE_CAMPAIGNS_TABLE]: "Campanhas ativas",
  [GLOBAL_REPORT_CAMPAIGNS_TABLE]: "Campanhas",
  [GLOBAL_REPORT_COLUMN_CAMPAIGN]: "Campanha",
  [GLOBAL_REPORT_COLUMN_INVESTMENT]: "Investimento",
  [GLOBAL_REPORT_COLUMN_ROAS]: "ROAS",
  [GLOBAL_REPORT_COLUMN_IMPRESSIONS]: "Impressões",
  [GLOBAL_REPORT_COLUMN_CTR]: "CTR",
  [GLOBAL_REPORT_COLUMN_STATUS]: "Situação",
  [GLOBAL_REPORT_STATUS_ALERT]: "Alerta",
  [GLOBAL_REPORT_STATUS_OPTIMAL]: "Ótima",
  [GLOBAL_REPORT_STATUS_BRAND]: "Marca",
  [GLOBAL_REPORT_INSIGHT_ROAS_DROP_TITLE]: "Queda de ROAS em Verão Running",
  [GLOBAL_REPORT_INSIGHT_ROAS_DROP_DESCRIPTION]:
    "O ROAS caiu de 4,2x para 2,9x em 3 dias. Possível saturação de audiência no segmento de 25–34.",
  [GLOBAL_REPORT_INSIGHT_CPC_PEAK_TITLE]: "Pico de CPC às terças-feiras",
  [GLOBAL_REPORT_INSIGHT_CPC_PEAK_DESCRIPTION]:
    "O CPC sobe 34% nas terças de manhã. Considere ajustar os lances por horário.",
  [GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_TITLE]:
    "Vídeo de 30s supera a imagem estática",
  [GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_DESCRIPTION]:
    "O CTR do vídeo é 2,1x maior no Meta. Oportunidade de escalar o orçamento neste formato.",
  [GLOBAL_REPORT_ACTION_DATE_TODAY]: "Hoje",
  [GLOBAL_REPORT_ACTION_DATE_YESTERDAY]: "Ontem",
  [GLOBAL_REPORT_ACTION_DATE_MAR_26]: "26 mar",
  [GLOBAL_REPORT_ACTION_DATE_MAR_25]: "25 mar",
  [GLOBAL_REPORT_ACTION_CAMPAIGNS_CREATED]: "2 campanhas criadas",
  [GLOBAL_REPORT_ACTION_IMAGES_GENERATED]: "5 imagens geradas",
  [GLOBAL_REPORT_ACTION_VIDEOS_PRODUCED]: "3 vídeos produzidos",
  [GLOBAL_REPORT_ACTION_OPTIMIZATION_APPLIED]: "1 otimização aplicada",
  [GLOBAL_REPORT_DEFAULT_BRAND_NAME]: "Marca",
  [GLOBAL_REPORT_STATS_TIME_TITLE]: "Evolução",
  [GLOBAL_REPORT_STATS_TIME_SUBTITLE]: "Evolução diária de gasto e resultados",
  [GLOBAL_REPORT_STATS_DAILY_RESULTS_TITLE]: "Evolução diária de resultados",
  [GLOBAL_REPORT_STATS_WEEKLY_RESULTS_TITLE]: "Evolução semanal de resultados",
  [GLOBAL_REPORT_STATS_MONTHLY_RESULTS_TITLE]: "Evolução mensal de resultados",
  [GLOBAL_REPORT_STATS_DAILY_RESULTS_SUBTITLE]: "Resultados por dia no período",
  [GLOBAL_REPORT_STATS_WEEKLY_TIME_SUBTITLE]:
    "Evolução semanal de gasto e resultados",
  [GLOBAL_REPORT_STATS_MONTHLY_TIME_SUBTITLE]:
    "Evolução mensal de gasto e resultados",
  [GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_TITLE]: "Impressões e CTR",
  [GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_SUBTITLE]:
    "Evolução diária de impressões e CTR",
  [GLOBAL_REPORT_STATS_WEEKLY_IMPRESSIONS_CTR_SUBTITLE]:
    "Evolução semanal de impressões e CTR",
  [GLOBAL_REPORT_STATS_MONTHLY_IMPRESSIONS_CTR_SUBTITLE]:
    "Evolução mensal de impressões e CTR",
  [GLOBAL_REPORT_STATS_PLATFORM_TITLE]: "Plataformas",
  [GLOBAL_REPORT_STATS_PLATFORM_SUBTITLE]: "Resultados por plataforma",
  [GLOBAL_REPORT_STATS_PLATFORM_CPA_TITLE]: "CPA por plataforma",
  [GLOBAL_REPORT_STATS_PLATFORM_SPEND_TITLE]: "Gasto por plataforma",
  [GLOBAL_REPORT_STATS_CREATIVES_TITLE]: "Anúncios",
  [GLOBAL_REPORT_STATS_CREATIVES_SUBTITLE]:
    "Comparação de anúncios por eficiência (CPA) e por volume de resultados",
  [GLOBAL_REPORT_STATS_CREATIVES_LOWEST_CPA_TITLE]: "Menor CPA",
  [GLOBAL_REPORT_STATS_CREATIVES_HIGHEST_VOLUME_TITLE]:
    "Maior volume de resultados",
  [GLOBAL_REPORT_STATS_RADAR_TITLE]: "Perfil multidimensional de campanhas",
  [GLOBAL_REPORT_STATS_RADAR_SUBTITLE]:
    "Comparação normalizada de métricas-chave por campanha",
  [GLOBAL_REPORT_STATS_BELOW_AVERAGE]: "Abaixo da média (escalar)",
  [GLOBAL_REPORT_STATS_ABOVE_AVERAGE]: "Acima da média (revisar/pausar)",
  [GLOBAL_REPORT_STATS_NO_DATA]:
    "Não há dados suficientes para exibir este gráfico.",
  [GLOBAL_REPORT_STATS_SPEND_AXIS]: "Gasto",
  [GLOBAL_REPORT_STATS_IMPRESSIONS_AXIS]: "Impressões",
  [GLOBAL_REPORT_STATS_SPEND_DISTRIBUTION]: "Distribuição de gasto",
  [GLOBAL_REPORT_GOALS_TITLE]: "Metas",
  [GLOBAL_REPORT_GOALS_SUBTITLE]:
    "Progresso do volume mensal de resultados e projeção diária para 7 dias",
  [GLOBAL_REPORT_GOALS_STACKED_TITLE]: "Resultados vs meta mensal",
  [GLOBAL_REPORT_GOALS_STACKED_SUBTITLE]:
    "Soma dos resultados nos últimos 30 dias em relação ao volume mensal configurado",
  [GLOBAL_REPORT_GOALS_PROJECTION_TITLE]: "Projeção de resultados",
  [GLOBAL_REPORT_GOALS_PROJECTION_SUBTITLE]: "Projeção de resultados por dia",
  [GLOBAL_REPORT_GOALS_ACHIEVED]: "Alcançado",
  [GLOBAL_REPORT_GOALS_REMAINING]: "Restante",
  [GLOBAL_REPORT_GOALS_EXCEEDED]: "Meta superada em {{count}}",
  [GLOBAL_REPORT_GOALS_PROJECTION_ACTUAL]: "Resultados diários (real)",
  [GLOBAL_REPORT_GOALS_PROJECTION_FORECAST]: "Resultados diários (projeção)",
  [GLOBAL_REPORT_GOALS_TARGET_LINE]: "Meta mensal",
  [GLOBAL_REPORT_GOALS_CONFIGURE_PROMPT]:
    "Configure seu KPI para ver metas e projeção.",
  [GLOBAL_REPORT_GOALS_CONFIGURE_BUTTON]: "Configurar KPI",
  [GLOBAL_REPORT_GOALS_KPI_MISMATCH_PROMPT]:
    "Selecione {{kpi}} como KPI mensurável para ver metas e projeção.",
  [CAMPAIGN_APPROVAL_PAGE_TITLE]: "Aprovação de campanha",
  [CAMPAIGN_APPROVAL_PAGE_DESCRIPTION]:
    "Revise os textos e criativos desta campanha e deixe sua aprovação final.",
  [CAMPAIGN_APPROVAL_INVALID_TITLE]: "Este link não é válido",
  [CAMPAIGN_APPROVAL_INVALID_DESCRIPTION]:
    "O link de aprovação não é válido ou não está mais disponível. Peça ao seu administrador um novo link.",
  [CAMPAIGN_APPROVAL_EXPIRED_TITLE]: "Este link expirou",
  [CAMPAIGN_APPROVAL_EXPIRED_DESCRIPTION]:
    "O link de aprovação expirou. Peça à sua agência que compartilhe um novo.",
  [CAMPAIGN_APPROVAL_CONTENT_EMPTY]:
    "Não há conteúdo disponível para revisar nesta campanha.",
  [CAMPAIGN_APPROVAL_LOADING_FETCHING_CAMPAIGN_DATA]:
    "Carregando dados da campanha",
  [CAMPAIGN_APPROVAL_LOADING_PREPARING_REVIEW]: "Preparando a revisão",
  [CAMPAIGN_APPROVAL_GENERAL_COMMENT_TITLE]: "Comentário geral",
  [CAMPAIGN_APPROVAL_GENERAL_COMMENT_DESCRIPTION]:
    "Compartilhe um feedback geral sobre a campanha antes de aprová-la ou rejeitá-la.",
  [CAMPAIGN_APPROVAL_COMMENT_PLACEHOLDER]: "Escreva aqui seu comentário geral",
  [CAMPAIGN_APPROVAL_COMMENT_BUTTON]: "Enviar comentário",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_TITLE]: "Comentário específico",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_DESCRIPTION]:
    "Descreva o que alterar neste texto ou criativo.",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_PLACEHOLDER]:
    "Escreva aqui seu comentário específico",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_BUTTON]: "Adicionar comentário",
  [CAMPAIGN_APPROVAL_DECISION_TITLE]: "Decisão final",
  [CAMPAIGN_APPROVAL_DECISION_DESCRIPTION]:
    "Você deve deixar um resumo antes de aprovar ou rejeitar esta versão da campanha.",
  [CAMPAIGN_APPROVAL_DECISION_PLACEHOLDER]:
    "Escreva um resumo final da sua decisão",
  [CAMPAIGN_APPROVAL_APPROVE_BUTTON]: "Aprovar",
  [CAMPAIGN_APPROVAL_REJECT_BUTTON]: "Rejeitar",
  [CAMPAIGN_APPROVAL_TEXTS_TITLE]: "Textos",
  [CAMPAIGN_APPROVAL_DESTINATION_TITLE]: "Destino",
  [CAMPAIGN_APPROVAL_LEAD_FORM_PREVIEW_UNAVAILABLE]:
    "Não foi possível carregar a prévia deste formulário.",
  [CAMPAIGN_APPROVAL_CREATIVES_TITLE]: "Criativos",
  [CAMPAIGN_APPROVAL_CREATIVE_TITLE]: "Criativo",
  [CAMPAIGN_APPROVAL_SLIDE_LABEL]: "Slide",
  [CAMPAIGN_APPROVAL_FIELD_TITLE_LABEL]: "Título",
  [CAMPAIGN_APPROVAL_FIELD_HEADLINE_LABEL]: "Manchete",
  [CAMPAIGN_APPROVAL_FIELD_LONG_HEADLINE_LABEL]: "Manchete longa",
  [CAMPAIGN_APPROVAL_FIELD_DESCRIPTION_LABEL]: "Descrição",
  [CAMPAIGN_APPROVAL_FIELD_CREATIVE_LABEL]: "Criativo",
  [CAMPAIGN_APPROVAL_LOCKED_STATUS_APPROVED]:
    "Esta versão já foi aprovada. Não é mais possível enviar comentários.",
  [CAMPAIGN_APPROVAL_LOCKED_STATUS_REJECTED]:
    "Esta versão já foi rejeitada. Não é mais possível enviar comentários.",
  [CAMPAIGN_APPROVAL_LOCKED_STATUS_DECIDED]:
    "Esta versão já tem uma decisão final. Os comentários estão fechados.",
  [CAMPAIGN_APPROVAL_TARGET_ENTITY_AD]: "Anúncio",
  [CAMPAIGN_APPROVAL_TARGET_ENTITY_ASSETS_GROUP]: "Grupo de recursos",
  [CAMPAIGN_APPROVAL_CONTROLS_TITLE]: "Revisão",
  [CAMPAIGN_APPROVAL_CONTROLS_DESCRIPTION]:
    "Ative um link público para que seu cliente revise textos e criativos antes de publicar.",
  [CAMPAIGN_APPROVAL_INACTIVE_DESCRIPTION]:
    "Ative esta opção se precisar que seu cliente aprove os textos e criativos da campanha. Ao ativá-la, será gerado um link para compartilhar com o seu cliente, para que revise e deixe comentários. Você não poderá publicar a campanha até que seu cliente a aprove. Esta ação não pode ser desfeita.",
  [CAMPAIGN_APPROVAL_STATE_INACTIVE]: "Inativo",
  [CAMPAIGN_APPROVAL_STATE_ACTIVE]: "Ativo",
  [CAMPAIGN_APPROVAL_SHARED_LINK_LABEL]: "Link:",
  [CAMPAIGN_APPROVAL_CONFIRM_ENABLE_TITLE]: "Enviar para revisão",
  [CAMPAIGN_APPROVAL_CONFIRM_ENABLE_DESCRIPTION]:
    "Será gerado um link que você poderá compartilhar com o seu cliente para que revise a campanha.",
  [CAMPAIGN_APPROVAL_ENABLE_BUTTON]: "Enviar para revisão",
  [CAMPAIGN_APPROVAL_COPY_LINK_BUTTON]: "Copiar",
  [CAMPAIGN_APPROVAL_COPY_LINK_COPIED]: "Copiado",
  [CAMPAIGN_APPROVAL_REJECTED_DESCRIPTION]:
    "Seu cliente solicitou alterações na campanha. Revise os comentários, faça as modificações necessárias, salve as alterações e envie o link novamente.",
  [CAMPAIGN_APPROVAL_APPROVED_DESCRIPTION]:
    "Seu cliente aprovou a campanha. Agora você pode publicá-la.",
  [CAMPAIGN_APPROVAL_PENDING_DESCRIPTION]:
    "Aguardando a aprovação ou a solicitação de alterações do seu cliente.",
  [CAMPAIGN_APPROVAL_VIEW_COMMENTS_BUTTON]: "Ver comentários",
  [CAMPAIGN_APPROVAL_VIEW_REVIEW_BUTTON]: "Ver revisão",
  [CAMPAIGN_APPROVAL_STATUS_PENDING]: "Pendente",
  [CAMPAIGN_APPROVAL_STATUS_APPROVED]: "Aprovado",
  [CAMPAIGN_APPROVAL_STATUS_REJECTED]: "Alterações solicitadas",
  [GALLERY_CONTENT_APPROVAL_STATUS_REJECTED]: "Alterações",
  [CAMPAIGN_APPROVAL_PANEL_TITLE]: "Alterações solicitadas",
  [CAMPAIGN_APPROVAL_PANEL_DESCRIPTION]:
    "Acompanhe os comentários ativos da versão atual e vá até o campo correspondente.",
  [CAMPAIGN_APPROVAL_PANEL_EMPTY]:
    "Ainda não há comentários ativos para esta versão.",
  [CAMPAIGN_APPROVAL_PANEL_STALE_TOGGLE]: "Mostrar comentários anteriores",
  [CAMPAIGN_APPROVAL_PANEL_CURRENT_DRAFT]: "Versão atual",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_PENDING]: "Revisão em andamento",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_APPROVED]: "Campanha aprovada",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_REJECTED]: "Alterações solicitadas",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_PENDING]:
    "Ainda não há comentários. Acompanhe o status de cada revisor.",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_APPROVED]:
    "Campanha aprovada. Não há comentários pendentes nesta versão.",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_REJECTED]:
    "Não há comentários ativos para esta versão.",
  [CAMPAIGN_APPROVAL_STALE_LABEL]: "Anterior",
  [CAMPAIGN_APPROVAL_AD_PREVIEW_TITLE]: "Prévia do anúncio",
  [CAMPAIGN_APPROVAL_AD_PREVIEW_ERROR]:
    "Não foi possível carregar a prévia do anúncio.",
  [CAMPAIGN_APPROVAL_PUBLISH_BLOCKED_BANNER]:
    "A publicação está bloqueada até que o cliente aprove esta campanha.",
  [CAMPAIGN_APPROVAL_SEND_FOR_REVIEW]: "Enviar para revisão",
  [CONTENT_APPROVAL_PAGE_TITLE]: "Aprovação de conteúdo",
  [CONTENT_APPROVAL_REPLACE_BUTTON]: "Substituir",
  [CONTENT_APPROVAL_EDIT_BUTTON]: "Editar",
  [CONTENT_APPROVAL_SAVE_REVISION_BUTTON]: "Salvar alterações",
  [CONTENT_APPROVAL_SAVE_REVISION_SUCCESS_DESCRIPTION]:
    "As alterações foram salvas. Copie e envie o link novamente para o seu cliente.",
  [CONTENT_APPROVAL_APPROVE_CONTENT_BUTTON]: "Aprovar conteúdo",
  [CONTENT_APPROVAL_SIDEBAR_TITLE]: "Comentários",
  [CONTENT_APPROVAL_ALL_GOOD_QUESTION]: "O conteúdo está pronto?",
  [CONTENT_APPROVAL_CONFIRM_ENABLE_TITLE]: "Enviar para revisão",
  [CONTENT_APPROVAL_CONFIRM_ENABLE_DESCRIPTION]:
    "Será gerado um link que você poderá compartilhar com o seu cliente para que revise o conteúdo.",
  [CONTENT_APPROVAL_ENABLE_SUCCESS_DESCRIPTION]:
    "Copie e envie ao cliente o seguinte link para que revise o conteúdo:",
  [CAMPAIGN_APPROVAL_ENABLE_SUCCESS_DESCRIPTION]:
    "Copie e envie ao cliente o seguinte link para que revise a campanha:",
  [APPROVAL_ENABLE_SUCCESS_OR_SEPARATOR]: "ou",
  [APPROVAL_REVIEW_EMAIL_LABEL]: "Enviar o link por e-mail",
  [APPROVAL_EMAIL_SEND_BUTTON]: "Enviar",
  [APPROVAL_EMAIL_SEND_SENT]: "Enviado",
  [APPROVAL_EMAIL_INVALID]: "E-mail inválido",
  [APPROVAL_REVIEWER_NOT_FOUND]:
    "Não há nenhum revisor com esse e-mail nesta aprovação.",
  [APPROVAL_ADD_REVIEWER]: "Adicionar revisor",
  [APPROVAL_REVIEWER_LABEL]: "Revisor {{number}}",
  [APPROVAL_REVIEWER_MAX_REACHED]: "Máximo de 10 revisores",
  [APPROVAL_REVIEWER_EMAIL_DUPLICATED]:
    "Este e-mail já está atribuído a um revisor",
  [APPROVAL_REVIEWER_ADDED_SUCCESS]: "Revisor adicionado",
  [APPROVAL_REVIEWER_STATUS_PENDING]: "Pendente",
  [APPROVAL_REVIEWER_STATUS_APPROVED]: "Aprovado",
  [APPROVAL_REVIEWER_STATUS_REJECTED]: "Rejeitado",
  [APPROVAL_CURRENT_REVIEWER_LABEL]: "Revisando como {{email}}",
  [APPROVAL_REVIEWING_AS_PREFIX]: "Revisando como",
  [APPROVAL_REVIEWERS_SECTION_LABEL]: "Revisores",
  [APPROVAL_COMMENT_AUTHOR_LABEL]: "{{email}}",
  [CONTENT_APPROVAL_SENT_DATE]: "Enviado em {{date}}",
  [CONTENT_APPROVAL_CLIENT_COMMENTS_TITLE]: "Comentários do cliente",
  [CONTENT_APPROVAL_CLIENT_COMMENTS_EMPTY]:
    "Seu cliente ainda não deixou comentários.",
  [CONTENT_APPROVAL_REVIEWER_COMMENTS_EMPTY]:
    "Você ainda não adicionou comentários.",
  [CONTENT_APPROVAL_COMMENT_PLACEHOLDER]: "Escreva seu comentário aqui...",
  [CONTENT_APPROVAL_REVIEW_LINK_LABEL]: "Link de revisão",
  [CONTENT_APPROVAL_STATUS_SECTION_LABEL]: "Situação",
  [CONTENT_APPROVAL_MAIN_CREATIVE_LABEL]: "Criativo principal",
  [CONTENT_APPROVAL_CREATIVE_CARD_TITLE]: "Criativo {{number}}",
  [CONTENT_APPROVAL_CREATIVE_TYPE_LABEL]: "Tipo: {{type}}",
  [CONTENT_APPROVAL_COMMENT_CREATIVE_NUMBER]: "Criativo {{number}}",
  [CONTENT_APPROVAL_CONFIRM_APPROVE_TITLE]: "Aprovar conteúdo?",
  [CONTENT_APPROVAL_CONFIRM_APPROVE_DESCRIPTION]:
    "A agência receberá uma notificação de que o conteúdo foi aprovado.",
  [CONTENT_APPROVAL_APPROVE_BUTTON]: "Aprovar",
  [CONTENT_APPROVAL_DECISION_APPROVED_SUCCESS]:
    "A notificação de aprovação foi enviada à agência.",
  [CONTENT_APPROVAL_CONTENT_APPROVED_TITLE]: "Conteúdo aprovado",
  [CONTENT_APPROVAL_COMMENT_SENT_SUCCESS]: "Seu comentário foi enviado",
  [CONTENT_APPROVAL_REVIEW_NEXT_CONTENT_BUTTON]: "Próximo conteúdo",
  [CONTENT_APPROVAL_ANOTHER_COMMENT_BUTTON]: "Outro comentário",
  [CONTENT_APPROVAL_ALL_CONTENTS_REVIEWED]: "Você revisou todos os conteúdos",
  [CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION]:
    "Ainda restam {{count}} conteúdos para revisar.",
  [CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION_SINGLE]:
    "Ainda resta {{count}} conteúdo para revisar.",
  [CONTENT_APPROVAL_LOCKED_STATUS_APPROVED]:
    "Este conteúdo já foi aprovado. Não é mais possível enviar comentários.",
  [CONTENT_APPROVAL_INVALID_TITLE]: "Este link não é válido",
  [CONTENT_APPROVAL_INVALID_DESCRIPTION]:
    "O link de aprovação de conteúdo não é válido ou não está mais disponível. Peça ao seu administrador um novo link.",
  [CONTENT_APPROVAL_EXPIRED_TITLE]: "Este link expirou",
  [CONTENT_APPROVAL_EXPIRED_DESCRIPTION]:
    "O link de aprovação de conteúdo expirou. Peça à sua agência que compartilhe um novo.",
  [CONTENT_APPROVAL_LOADING_VALIDATING_LINK]: "Validando o link de revisão",
  [CONTENT_APPROVAL_LOADING_FETCHING_CREATIVES]: "Carregando criativos",
  [CONTENT_APPROVAL_LOADING_PREPARING_REVIEW]: "Preparando a revisão",
  [CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_TITLE]:
    "A campanha ainda não está aprovada",
  [CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_DESCRIPTION]:
    "Esta campanha foi enviada para revisão do cliente e ainda não foi aprovada. Deseja publicá-la mesmo assim?",
  [CAMPAIGN_APPROVAL_READY_TO_DECIDE]: "Pronto para decidir?",
  [CAMPAIGN_APPROVAL_COMMENTS_LEFT]: "Você deixou {{count}} comentários",
  [CAMPAIGN_APPROVAL_AD_SET_LABEL]: "CONJUNTO DE ANÚNCIOS",
  [CAMPAIGN_APPROVAL_ADS_COUNT]: "{{count}} anúncios",
  [CAMPAIGN_APPROVAL_ADS_COUNT_SINGLE]: "{{count}} anúncio",
  [CAMPAIGN_APPROVAL_SIDEBAR_CAMPAIGNS]: "Selecione uma plataforma",
  [CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS]: "{{count}} conjuntos de anúncios",
  [CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS_SINGLE]: "{{count}} conjunto de anúncios",
  [CAMPAIGN_APPROVAL_SIDEBAR_ADS]: "{{count}} anúncios",
  [CAMPAIGN_APPROVAL_SIDEBAR_ADS_SINGLE]: "{{count}} anúncio",
  [CAMPAIGN_APPROVAL_SIDEBAR_TEXTS]: "{{count}} textos",
  [CAMPAIGN_APPROVAL_SIDEBAR_TEXTS_SINGLE]: "{{count}} texto",
  [CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES]: "{{count}} criativos",
  [CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES_SINGLE]: "{{count}} criativo",
  [CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT]: "{{count}} textos",
  [CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT_SINGLE]: "{{count}} texto",
  [CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT]: "{{count}} criativos",
  [CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT_SINGLE]: "{{count}} criativo",
  [CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT]: "{{count}} comentários",
  [CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT_SINGLE]: "{{count}} comentário",
  [CAMPAIGN_APPROVAL_REJECT_REQUIRES_COMMENT]:
    "Para rejeitar, você precisa deixar pelo menos um comentário em um elemento ou escrever um aqui.",
  [CAMPAIGN_APPROVAL_COMMENT_SEND_HINT]: "Ctrl/⌘ + Enter para enviar",
  [CAMPAIGN_APPROVAL_APPROVE_CAMPAIGN_BUTTON]: "Aprovar campanha",
  [CAMPAIGN_APPROVAL_CONFIRM_APPROVE_TITLE]: "Aprovar campanha?",
  [CAMPAIGN_APPROVAL_CONFIRM_APPROVE_DESCRIPTION]:
    "A agência receberá uma notificação de que a campanha foi aprovada e poderá publicá-la",
  [CAMPAIGN_APPROVAL_CONFIRM_REJECT_TITLE]: "Rejeitar campanha?",
  [CAMPAIGN_APPROVAL_CONFIRM_REJECT_DESCRIPTION]:
    "Tem certeza de que deseja rejeitar esta campanha? A agência receberá uma notificação.",
  [CAMPAIGN_APPROVAL_DECISION_APPROVED_SUCCESS]:
    "A notificação de aprovação foi enviada à agência.",
  [CAMPAIGN_APPROVAL_DECISION_REJECTED_SUCCESS]:
    "A notificação de rejeição foi enviada à agência.",

  [TEMPLATES_MENU_ITEM]: "Modelos",
  [TEMPLATES_TITLE]: "Modelos",
  [TEMPLATE]: "Modelo",
  [TEMPLATES_SEARCH_PLACEHOLDER]: "Buscar modelos",
  [TEMPLATES_SEARCH_NO_RESULTS]: "Nenhum modelo corresponde a esse nome.",
  [TEMPLATES_SORT_NEWEST_FIRST]: "Mais recentes primeiro",
  [TEMPLATES_SORT_OLDEST_FIRST]: "Mais antigos primeiro",
  [TEMPLATES_SORT_NAME_ASC]: "Nome (A–Z)",
  [TEMPLATES_SORT_NAME_DESC]: "Nome (Z–A)",
  [TEMPLATES_DESCRIPTION]:
    "Crie um modelo, defina camadas, grupos e propriedades, ou envie um criativo para que possamos analisá-lo para você.",
  [TEMPLATES_BUTTON_UPLOAD]: "Enviar criativo",
  [TEMPLATES_UPLOAD_FROM_GALLERY]: "Da galeria",
  [TEMPLATES_UPLOAD_FROM_DEVICE]: "Do dispositivo",
  [TEMPLATES_BUTTON_CREATE]: "Criar",
  [TEMPLATES_LAYOUT_KIND_IMAGE]: "Imagem",
  [TEMPLATES_LAYOUT_KIND_CAROUSEL]: "Carrossel",
  [TEMPLATES_CREATE_KIND_TITLE]: "Tipo de modelo",
  [TEMPLATES_CREATE_KIND_DESCRIPTION]:
    "Escolha uma imagem única ou um carrossel com vários slides.",
  [TEMPLATES_CREATE_KIND_SINGLE]: "Imagem única",
  [TEMPLATES_CREATE_KIND_CAROUSEL]: "Carrossel",
  [TEMPLATES_CREATE_KIND_SLIDE_COUNT]: "Número de slides",
  [TEMPLATES_SLIDE_LABEL]: "Slide {{index}}",
  [TEMPLATES_ADD_SLIDE]: "Adicionar",
  [TEMPLATES_DUPLICATE_SLIDE]: "Duplicar slide",
  [TEMPLATES_DELETE_SLIDE]: "Excluir slide",
  [TEMPLATES_SLIDES_ROW]: "Slides",
  [TEMPLATES_CAROUSEL_TYPE]: "Tipo de carrossel",
  [TEMPLATES_CONTINUOUS_SETUP_TITLE]: "Configurar carrossel contínuo",
  [TEMPLATES_CONTINUOUS_SETUP_SLIDES]: "Número de slides",
  [TEMPLATES_CONTINUOUS_SETUP_FORMAT]: "Formato de cada slide",
  [TEMPLATES_LAYOUT_KIND_CONTINUOUS]: "Contínuo",
  [TEMPLATES_LAYOUT_KIND_INDIVIDUAL]: "Individual",
  [TEMPLATES_LAYOUT_KIND_INDIVIDUAL_TOOLTIP]:
    "Modo individual: cada slide do carrossel é desenhado separadamente.",
  [TEMPLATES_LAYOUT_KIND_CONTINUOUS_TOOLTIP]:
    "Modo contínuo: um único design que se estende por todos os slides.",
  [TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_HINT]:
    "Clique para voltar ao modo individual (cada slide é desenhado separadamente).",
  [TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_HINT]:
    "Clique para mudar para o modo contínuo (um único design pelos slides).",
  [TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_BLOCKED]:
    "Para voltar ao modo individual (cada slide separado) não deve haver nenhuma camada no modelo.",
  [TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_BLOCKED]:
    "Para mudar para o modo contínuo (um único design pelos slides) não deve haver nenhuma camada no modelo.",
  [TEMPLATES_CONFIRM_DELETE_STRIP_SLIDE_DESCRIPTION]:
    "O slide {{index}} e o seu conteúdo serão eliminados. As camadas que o atravessam serão cortadas.",
  [TEMPLATES_STRIP_FORMAT_TOO_LARGE]:
    "Este formato excede o tamanho máximo da faixa contínua",
  [TEMPLATES_FORMATS_ROW]: "Formatos",
  [TEMPLATES_CAROUSEL_CHIP]: "Carrossel",
  [TEMPLATES_CONTINUOUS_CAROUSEL_CHIP]: "Carrossel contínuo",
  [TEMPLATES_EMPTY]: "Ainda não há modelos.",
  [TEMPLATES_FOLDER_EMPTY]: "Esta pasta está vazia.",
  [TEMPLATES_EMPTY_CANVAS_HINT]:
    "Comece a criar seu criativo por camadas ou envie uma imagem e faremos isso por você.",
  [TEMPLATES_EMPTY_ADD_LAYER]: "Adicionar camada",
  [TEMPLATES_BACKGROUND_LAYER]: "fundo",
  [TEMPLATES_OPEN]: "Abrir",
  [TEMPLATES_DUPLICATE]: "Duplicar",
  [TEMPLATES_DELETE]: "Excluir",
  [TEMPLATES_SAVE]: "Salvar",
  [TEMPLATES_USAGE_GUIDE]: "Guia de uso",
  [TEMPLATES_GUIDE_PDF_URL]:
    "https://clapp-prod.s3.us-east-1.amazonaws.com/docs/templates-guide/PT.pdf",
  [TEMPLATES_GUIDE_VIDEO_URL]:
    "https://clapp-dev.s3.us-east-1.amazonaws.com/socialMedia/-Oqn1dn3aXEtzakQBesw/364413e2-24a2-44fd-bac7-280e8973c66d.mp4",
  [TEMPLATES_BACK]: "Voltar para modelos",
  [TEMPLATES_NAME]: "Nome",
  [TEMPLATES_UNTITLED]: "Sem título",
  [TEMPLATES_ZONES]: "Camadas",
  [TEMPLATES_LAYERS]: "Camadas",
  [TEMPLATES_PROPERTIES]: "Propriedades",
  [TEMPLATES_NO_SELECTION]: "Selecione uma camada para editá-la.",
  [TEMPLATES_ADD_LAYER]: "Elemento",
  [TEMPLATES_ZONE_NAME]: "Nome da camada",
  [TEMPLATES_LAYER_NAME]: "Nome da camada",
  [TEMPLATES_ZONE_TYPE]: "Tipo de camada",
  [TEMPLATES_ZONE_SOURCE]: "Comportamento",
  [TEMPLATES_TYPE_TEXT]: "Texto",
  [TEMPLATES_TYPE_IMAGE]: "Imagem",
  [TEMPLATES_TYPE_SHAPE]: "Forma",
  [TEMPLATES_TYPE_GROUP]: "Grupo",
  [TEMPLATES_SOURCE_ASSET]: "Fixo",
  [TEMPLATES_SOURCE_DATA]: "Variável",
  [TEMPLATES_SOURCE_GENERATED]: "Gerado",
  [TEMPLATES_SOURCE_FIXED]: "Fixo",
  [TEMPLATES_SOURCE_COMPUTED]: "Calculado",
  [TEMPLATES_SOURCE_ASSET_HINT]:
    "Sempre usa o mesmo texto ou imagem para todas as imagens geradas.",
  [TEMPLATES_SOURCE_DATA_HINT]:
    "Você pode atribuir um valor específico para cada imagem gerada.",
  [TEMPLATES_SOURCE_GENERATED_HINT]:
    "A IA cria um texto ou uma imagem diferente em cada imagem gerada, de acordo com as instruções.",
  [TEMPLATES_SOURCE_COMPUTED_HINT]:
    "É calculado com uma expressão a partir de outras variáveis.",
  [TEMPLATES_FIXED_VALUE]: "Valor",
  [TEMPLATES_FIXED_VALUE_PLACEHOLDER]: "Texto",
  [TEMPLATES_LAYER_TEXT]: "Texto",
  [TEMPLATES_STYLE]: "Estilo",
  [TEMPLATES_ORIGIN_TEXT]: "Referência",
  [TEMPLATES_EXPRESSION]: "Expressão",
  [TEMPLATES_VARIABLE]: "Variável",
  [TEMPLATES_PROMPT]: "Instruções",
  [TEMPLATES_GENERATE_PROMPT]: "Gerar Instruções",
  [TEMPLATES_GENERATE_PROMPT_ERROR]: "Não foi possível gerar as instruções.",
  [TEMPLATES_GENERATE_PROMPT_NO_EXAMPLE]:
    "Adicione um Texto ou Imagem de Exemplo para Gerar Instruções.",
  [TEMPLATES_SAVE_PROMPT]: "Salvar Instruções",
  [TEMPLATES_SAVE_PROMPT_TITLE]: "Salvar Instruções",
  [TEMPLATES_SAVE_PROMPT_ERROR]: "Não foi possível salvar as instruções.",
  [TEMPLATES_SAVE_PROMPT_SUCCESS]: "Instrução Salva",
  [TEMPLATES_IMPORT_PROMPT]: "Importar Instruções",
  [TEMPLATES_IMPORT_PROMPT_TITLE]: "Instruções Salvas",
  [TEMPLATES_IMPORT_SELECTED]: "Importar",
  [TEMPLATES_IMPORT_PROMPT_EMPTY]: "Não há instruções salvas.",
  [TEMPLATES_IMPORT_PROMPT_ERROR]: "Não foi possível carregar as instruções.",
  [TEMPLATES_DELETE_PROMPT]: "Excluir Instruções",
  [TEMPLATES_DELETE_PROMPT_ERROR]: "Não foi possível excluir as instruções.",
  [TEMPLATES_TRY_LAYER]: "Testar",
  [TEMPLATES_TRY_LAYER_ERROR]:
    "Não foi possível gerar a visualização da camada.",
  [TEMPLATES_IS_BACKGROUND]: "Fundo",
  [TEMPLATES_NEGATIVE_PROMPT]: "Evitar",
  [TEMPLATES_ASSET_REF]: "Recurso",
  [TEMPLATES_SELECT_ASSET]: "Selecionar recurso",
  [TEMPLATES_CHANGE_ASSET]: "Alterar recurso",
  [TEMPLATES_FIT]: "Ajustar",
  [TEMPLATES_SHAPE_FILL]: "Preenchimento",
  [TEMPLATES_SHAPE_RADIUS]: "Raio",
  [TEMPLATES_FONT_SIZE]: "Tamanho",
  [TEMPLATES_FONT_COLOR]: "Cor",
  [TEMPLATES_STROKE_WIDTH]: "Espessura do contorno",
  [TEMPLATES_STROKE_METRIC]: "Largura",
  [TEMPLATES_SHADOW]: "Sombra",
  [TEMPLATES_SHADOW_ANGLE]: "Direção (°)",
  [TEMPLATES_SHADOW_DISTANCE]: "Distância",
  [TEMPLATES_SHADOW_BLUR]: "Desfoque",
  [TEMPLATES_PRESETS]: "Predefinições",
  [TEMPLATES_SHADOW_PRESET_SOFT]: "Suave",
  [TEMPLATES_SHADOW_PRESET_LIFT]: "Elevada",
  [TEMPLATES_SHADOW_PRESET_HARD]: "Dura",
  [TEMPLATES_SHADOW_PRESET_GLOW]: "Brilho",
  [TEMPLATES_STROKE_COLOR]: "Cor do contorno",
  [TEMPLATES_BACKGROUND_PADDING]: "Fundo",
  [TEMPLATES_BACKGROUND_SEPARATION]: "Distância da letra",
  [TEMPLATES_BACKGROUND_RADIUS]: "Arredondamento",
  [TEMPLATES_BACKGROUND_COLOR]: "Cor do fundo",
  [TEMPLATES_PAINT_SETTINGS]: "Configurações",
  [TEMPLATES_HIGHLIGHTS_TITLE]: "Estilos específicos",
  [TEMPLATES_HIGHLIGHTS_HINT]:
    "Selecione um trecho do texto e altere sua cor, contorno ou fundo para destacá-lo. Você pode combinar os três. Sem seleção, as alterações serão aplicadas a toda a camada.",
  [TEMPLATES_HIGHLIGHTS_ADD]: "Adicionar destaque",
  [TEMPLATES_HIGHLIGHTS_REMOVE]: "Excluir destaque",
  [TEMPLATES_HIGHLIGHTS_KIND_FILL]: "Letra",
  [TEMPLATES_HIGHLIGHTS_KIND_STROKE]: "Contorno",
  [TEMPLATES_HIGHLIGHTS_KIND_BACKGROUND]: "Fundo",
  [TEMPLATES_HIGHLIGHTS_PHRASE]: "Frase de referência",
  [TEMPLATES_HIGHLIGHTS_PHRASE_INVALID]:
    "A frase deve aparecer no texto de referência.",
  [TEMPLATES_HIGHLIGHTS_CAPTURE]: "Selecionar no canvas",
  [TEMPLATES_HIGHLIGHTS_CAPTURING]: "Selecione o texto…",
  [TEMPLATES_INLINE_REPLACEMENTS_TITLE]: "Substituir texto por imagens",
  [TEMPLATES_INLINE_REPLACEMENTS_HINT]:
    "Substitua uma palavra exata dentro de um texto por uma imagem.",
  [TEMPLATES_INLINE_REPLACEMENTS_ADD]: "Adicionar substituição",
  [TEMPLATES_INLINE_REPLACEMENTS_REMOVE]: "Remover substituição",
  [TEMPLATES_INLINE_REPLACEMENTS_PHRASE]: "Palavra",
  [TEMPLATES_LINE_SPACING]: "Espaçamento entre linhas",
  [TEMPLATES_LETTER_SPACING]: "Espaçamento entre letras",
  [TEMPLATES_FONT_FAMILY]: "Tipografia",
  [TEMPLATES_FONT_FACE]: "Estilo da fonte",
  [TEMPLATES_TEXT_STYLE]: "Estilo do texto",
  [TEMPLATES_TEXT_STYLE_NORMAL]: "Normal",
  [TEMPLATES_TEXT_STYLE_ITALIC]: "Itálico",
  [TEMPLATES_TEXT_STYLE_UNDERLINE]: "Sublinhado",
  [TEMPLATES_TEXT_STYLE_ITALIC_UNDERLINE]: "Itálico e sublinhado",
  [TEMPLATES_ADD_FONT]: "+ Adicionar fonte",
  [TEMPLATES_ADD_FONT_TITLE]: "Adicionar fonte",
  [TEMPLATES_ADD_FONT_NAME]: "Nome da fonte",
  [TEMPLATES_ADD_FONT_NAME_HINT]: "Nome da família. Ex.: Inter",
  [TEMPLATES_ADD_FONT_MATCH_HINT]:
    "Será adicionada como {{style}} de {{family}}.",
  [TEMPLATES_ADD_FONT_PARSE_FAILED]:
    "Não foi possível ler os metadados. Digite o nome da família.",
  [TEMPLATES_ADD_FONT_PARTIAL_ERROR]: "Não foi possível enviar algumas fontes.",
  [TEMPLATES_ADD_FONT_VARIABLE]: "Fonte variável",
  [TEMPLATES_ADD_FONT_SUMMARY]: "Resumo",
  [TEMPLATES_ADD_FONT_SUMMARY_FAMILY]: "Família",
  [TEMPLATES_ADD_FONT_SUMMARY_STYLE]: "Estilo",
  [TEMPLATES_ADD_FONT_SUMMARY_KIND]: "Tipo",
  [TEMPLATES_ADD_FONT_SUMMARY_STATIC]: "Fonte estática",
  [TEMPLATES_ADD_FONT_SUMMARY_STYLES]: "Estilos disponíveis",
  [TEMPLATES_ADD_FONT_SUMMARY_HINT]:
    "Selecione um ou vários arquivos .ttf, .otf, .woff ou .woff2. Os estilos da mesma família serão agrupados em um único resumo.",
  [TEMPLATES_ADD_FONT_CHANGE_FILE]: "Alterar arquivos",
  [TEMPLATES_ADD_FONT_FILE]: "Arquivo",
  [TEMPLATES_ADD_FONT_SELECT_FILE]: "Selecionar arquivos",
  [TEMPLATES_ADD_FONT_ERROR]: "Não foi possível enviar a fonte.",
  [TEMPLATES_ADD_FONT_INVALID_FILE]:
    "Use arquivos .ttf, .otf, .woff ou .woff2.",
  [TEMPLATES_ADD_FONT_INVALID_NAME]: "O nome não pode conter . # $ [ ] /",
  [TEMPLATES_ALIGN]: "Alinhamento",
  [TEMPLATES_ALIGN_LEFT]: "Esquerda",
  [TEMPLATES_ALIGN_CENTER]: "Centro",
  [TEMPLATES_ALIGN_RIGHT]: "Direita",
  [TEMPLATES_ALIGN_TOP]: "Superior",
  [TEMPLATES_ALIGN_MIDDLE]: "Meio",
  [TEMPLATES_ALIGN_BOTTOM]: "Inferior",
  [TEMPLATES_ALIGN_LAYERS]: "Alinhar",
  [TEMPLATES_LOCK_LAYER]: "Bloquear",
  [TEMPLATES_UNLOCK_LAYER]: "Desbloquear",
  [TEMPLATES_HIDE_LAYER]: "Ocultar",
  [TEMPLATES_SHOW_LAYER]: "Mostrar",
  [TEMPLATES_ALIGNMENT_GUIDES]: "Guias de alinhamento",
  [TEMPLATES_GUIDE_OPACITY]: "Opacidade da guia",
  [TEMPLATES_ORIENTATION]: "Orientação",
  [TEMPLATES_ORIENTATION_HORIZONTAL]: "Horizontal",
  [TEMPLATES_ORIENTATION_VERTICAL]: "Vertical ↓",
  [TEMPLATES_ORIENTATION_VERTICAL_UP]: "Vertical ↑",
  [TEMPLATES_OVERFLOW]: "Se não couber",
  [TEMPLATES_MAX_LINES]: "Máx. de linhas",
  [TEMPLATES_MIN_LINES]: "Mín. de linhas",
  [TEMPLATES_MIN_FONT]: "Mínimo",
  [TEMPLATES_POSITION]: "Posição",
  [TEMPLATES_SIZE]: "Tamanho",
  [TEMPLATES_POS_X]: "X",
  [TEMPLATES_POS_Y]: "Y",
  [TEMPLATES_POS_W]: "W",
  [TEMPLATES_POS_H]: "H",
  [TEMPLATES_FRAME_W]: "Largura do quadro",
  [TEMPLATES_FRAME_H]: "Altura do quadro",
  [TEMPLATES_CLIP]: "Recortar conteúdo",
  [TEMPLATES_HIDE]: "Ocultar",
  [TEMPLATES_SHOW]: "Mostrar",
  [TEMPLATES_MIN_SIZE]: "Tamanho mínimo",
  [TEMPLATES_PADDING]: "Área segura",
  [TEMPLATES_DRAW]: "Desenhar camada",
  [TEMPLATES_DRAWING]: "Desenho",
  [TEMPLATES_DRAW_HINT]:
    "Arraste sobre o canvas. Com um grupo ou subcamada selecionado, a nova camada será criada dentro do grupo.",
  [TEMPLATES_OVERFLOW_SHRINK]: "Reduzir",
  [TEMPLATES_OVERFLOW_REJECT]: "Bloquear",
  [TEMPLATES_BACKDROP_NOTE]:
    "Marque a área; o arquivo real do logotipo ou selo será enviado depois. Esta imagem serve apenas como fundo do editor.",
  [TEMPLATES_NODE_COUNT]: "{{count}} camadas",
  [TEMPLATES_NODE_COUNT_SINGLE]: "{{count}} camada",
  [TEMPLATES_ARTBOARD]: "{{width}}×{{height}}",
  [TEMPLATES_ADD_FORMAT]: "Adicionar",
  [TEMPLATES_CUSTOM_FORMAT]: "Personalizado",
  [TEMPLATES_CUSTOM_FORMAT_TITLE]: "Tamanho personalizado",
  [TEMPLATES_CUSTOM_WIDTH]: "Largura",
  [TEMPLATES_CUSTOM_HEIGHT]: "Altura",
  [TEMPLATES_CUSTOM_SIZE_INVALID]:
    "Digite uma largura e uma altura entre 1 e 8192.",
  [TEMPLATES_EDIT_PREVIOUS]: "Editar anterior",
  [TEMPLATES_NEW_FORMAT_HINT]:
    "Envie uma imagem para separá-la em camadas ou copie as camadas do tamanho anterior.",
  [TEMPLATES_REMOVE_FORMAT]: "Remover tamanho",
  [TEMPLATES_THIS_FORMAT]: "este tamanho",
  [TEMPLATES_UPLOAD_REFERENCE]: "Enviar guia",
  [TEMPLATES_CHANGE_REFERENCE]: "Alterar guia",
  [TEMPLATES_SHOW_GUIDE]: "Mostrar guia",
  [TEMPLATES_HIDE_GUIDE]: "Ocultar guia",
  [TEMPLATES_GUIDE_HINT]:
    "A guia mostra o criativo original como uma sobreposição translúcida para que você possa ver onde cada camada deve ficar.",
  [TEMPLATES_EDITOR_PREVIEW_VARIABLES_TITLE]: "Variáveis de visualização",
  [TEMPLATES_EDITOR_PREVIEW_VARIABLES_DESCRIPTION]:
    "Preencha as variáveis e imagens necessárias para este modelo.",
  [TEMPLATES_EDITOR_PREVIEW_ERROR]: "Não foi possível gerar a visualização.",
  [TEMPLATES_EDITOR_PREVIEW_TITLE]: "Visualização",
  [TEMPLATES_EDITOR_PREVIEW_USED_VALUES]: "Valores utilizados",
  [TEMPLATES_EDITOR_PREVIEW_SAVED_TO_GALLERY]: "Conteúdo Salvo Na Galeria",
  [TEMPLATES_ZOOM_IN]: "Aumentar zoom",
  [TEMPLATES_ZOOM_OUT]: "Diminuir zoom",
  [TEMPLATES_ZOOM_FIT]: "Ajustar à tela",
  [TEMPLATES_TEXT_COLLISION_ONE]: "1 texto pode cobrir outra camada",
  [TEMPLATES_TEXT_COLLISION_OTHER]:
    "{{count}} textos podem cobrir outras camadas",
  [TEMPLATES_TEXT_COLLISION_UNNAMED_TEXT]: "Texto",
  [TEMPLATES_TEXT_COLLISION_UNNAMED_IMAGE]: "Imagem",
  [CANVAS_TOOLS_BAR_LABEL]: "Ferramentas",
  [CANVAS_TOOL_ERASER]: "Apagar objeto",
  [CANVAS_TOOL_ERASER_HINT]: "Pinte sobre o elemento que deseja apagar",
  [CANVAS_TOOL_ERASER_BRUSH_SIZE]: "Tamanho do pincel",
  [CANVAS_TOOL_ERASER_APPLY]: "Apagar",
  [TEMPLATES_UNAUTHORIZED]: "Você não tem permissão para editar modelos.",
  [TEMPLATES_ANALYZING_LOCK]: "Separando seu criativo em camadas…",
  [TEMPLATES_SAVE_SUCCESS]: "Modelo salvo.",
  [TEMPLATES_DELETE_ERROR]: "Não foi possível excluir o modelo.",
  [TEMPLATES_UPLOAD_ERROR]: "Não foi possível enviar a imagem.",
  [TEMPLATES_ANALYZE_ERROR]: "Não foi possível analisar o criativo.",
  [TEMPLATES_ANALYZE_IMAGE_TOO_SMALL]:
    "A imagem é pequena demais para ser separada em camadas. Ela precisa ter resolução mínima de 1080 x 1080 (HD).",
  [IMAGE_TOO_SMALL_FOR_LAYERIZE]:
    "A imagem é pequena demais para separar em camadas. Ela precisa ter resolução mínima de 1080 x 1080 (HD).",
  [TEMPLATES_ANALYZE_RETRY]: "Tentar novamente",
  [TEMPLATES_CREATE_ERROR]: "Não foi possível criar o modelo.",
  [TEMPLATES_SAVE_ERROR]: "Não foi possível salvar o modelo.",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE]:
    "As variáveis não coincidem entre os tamanhos",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE_CAROUSEL]:
    "As variáveis não coincidem entre os tamanhos do mesmo slide",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION]:
    "Todos os tamanhos devem ter as mesmas variáveis. As seguintes variáveis estão ausentes nestes tamanhos:",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION_CAROUSEL]:
    "Dentro de cada slide, todos os tamanhos devem ter as mesmas variáveis. As seguintes variáveis estão ausentes nestes tamanhos:",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_ARIA_LABEL]:
    "Variáveis ausentes por tamanho",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_FORMAT]: "Tamanho",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_TYPE]: "Tipo de camada",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_VARIABLE]: "Variável",
  [TEMPLATES_SAVE_TRANSPARENCY_GAP_TITLE]: "Aviso",
  [TEMPLATES_SAVE_TRANSPARENCY_GAP_DESCRIPTION]:
    "Esses tamanhos possuem áreas transparentes descobertas. Você pode preenchê-las agora ou continuar: se continuar, essas áreas serão preenchidas com branco.",
  [TEMPLATES_CONFIRM_DELETE_TITLE]: "Excluir modelo?",
  [TEMPLATES_CONFIRM_DELETE_DESCRIPTION]: "Esta ação não pode ser desfeita.",
  [TEMPLATES_CONFIRM_REMOVE_FORMAT_TITLE]: "Remover tamanho?",
  [TEMPLATES_CONFIRM_REMOVE_FORMAT_DESCRIPTION]:
    "O tamanho {{format}} e todas as suas camadas serão removidos. Esta ação não pode ser desfeita.",
  [TEMPLATES_CONFIRM_ADD_FORMAT]: "Adicionar formato",
  [TEMPLATES_CONFIRM_ADD_FORMAT_DESCRIPTION]:
    "Lembre-se de concluir toda a configuração do formato inicial para facilitar o trabalho nos novos formatos.",
  [TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND]: "Redimensionar Fundo",
  [TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND_DESCRIPTION]:
    "Quer redimensionar a imagem de fundo com IA para que ela se ajuste ao novo formato?",
  [TEMPLATES_AI_RESIZE_BACKGROUND_CONFIRM]: "Redimensionar",
  [TEMPLATES_AI_RESIZE_BACKGROUND_LOCK]: "Redimensionando o fundo com IA",
  [TEMPLATES_KEEP_EDITING]: "Continuar editando",
  [TEMPLATES_CLOSE_UNSAVED_DESCRIPTION]:
    "Tem certeza de que deseja sair? Todas as alterações não salvas serão perdidas.",
  [TEMPLATES_PRODUCE_DRAFT_TITLE]: "Modelo incompleto",
  [TEMPLATES_PRODUCE_DRAFT_DESCRIPTION]:
    "Conclua o modelo com um nome e pelo menos uma camada antes de produzir.",
  [TEMPLATES_PRODUCE_DRAFT_COMPLETE]: "Concluir",
  [TEMPLATES_SAVE_PRODUCE_TITLE]: "Modelo salvo",
  [TEMPLATES_SAVE_BLOCKED_PRODUCING]:
    "Há criativos sendo produzidos com este modelo. Salvar agora poderia causar erros na produção. Você poderá salvar as alterações assim que terminar.",
  [TEMPLATES_SAVE_PRODUCE_DESCRIPTION]: "Agora você pode produzir criativos.",
  [TEMPLATES_SAVE_PRODUCE_CONFIRM]: "Produzir",
  [TEMPLATES_SAVE_PRODUCE_CANCEL]: "Voltar",
  [TEMPLATES_NEW_ZONE]: "camada",
  [TEMPLATES_NEW_LAYER]: "Camada",
  [TEMPLATES_PRODUCE_MENU_ITEM]: "Produzir",
  [TEMPLATES_PRODUCE_TITLE]: "Produzir",
  [TEMPLATES_PRODUCE_DESCRIPTION]:
    "Escolha um modelo, um idioma e preencha as variáveis de cada linha.",
  [TEMPLATES_PRODUCE_CONFIG_KICKER]: "Configuração",
  [TEMPLATES_PRODUCE_SELECTED_TEMPLATE_LABEL]: "Modelo selecionado",
  [TEMPLATES_PRODUCE_VARIABLES_EYEBROW]: "Variáveis de produção",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGE_UNIT]: "imagem",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGES_UNIT]: "imagens",
  [TEMPLATES_PRODUCE_SUMMARY_VARIATION_LABEL]: "{{count}} variação",
  [TEMPLATES_PRODUCE_SUMMARY_VARIATIONS_LABEL]: "{{count}} variações",
  [TEMPLATES_PRODUCE_SUMMARY_COST]: "{{count}} {{unit}}",
  [TEMPLATES_PRODUCE_SUMMARY_COST_LABEL]: "Custo",
  [TEMPLATES_PRODUCE_SUMMARY_RATE]: "{{count}} {{unit}} por imagem",
  [TEMPLATES_PRODUCE_SUMMARY_FORMAT]: "Formato {{size}}",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT]: "{{count}} imagens",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT_SINGLE]: "{{count}} imagem",
  [TEMPLATES_PRODUCE_SUMMARY_SIZE_COUNT]: "{{count}} tamanho",
  [TEMPLATES_PRODUCE_SUMMARY_SIZES_COUNT]: "{{count}} tamanhos",
  [TEMPLATES_PRODUCE_SUMMARY_SLIDE_COUNT]: "{{count}} slide",
  [TEMPLATES_PRODUCE_SUMMARY_SLIDES_COUNT]: "{{count}} slides",
  [TEMPLATES_PRODUCE_ROW_COUNT]: "{{count}} linhas",
  [TEMPLATES_PRODUCE_ROW_COUNT_SINGLE]: "{{count}} linha",
  [TEMPLATES_PRODUCE_TEMPLATE]: "Modelo",
  [TEMPLATES_PRODUCE_CHANGE]: "Alterar",
  [TEMPLATES_PRODUCE_DIMENSIONS]: "Tamanhos",
  [TEMPLATES_PRODUCE_LANGUAGE]: "Idioma",
  [TEMPLATES_PRODUCE_VARIATIONS]: "Número de variações",
  [TEMPLATES_PRODUCE_VARIATIONS_PER_ROW]: "Variações por linha",
  [TEMPLATES_PRODUCE_ROWS]: "Linhas",
  [TEMPLATES_PRODUCE_ROWS_HINT]:
    "Digite aqui. Não é necessário nenhum arquivo.",
  [TEMPLATES_PRODUCE_ADD_ROW]: "Adicionar linha",
  [TEMPLATES_PRODUCE_LOAD_LAST_CONFIG]: "Carregar últimos dados usados",
  [TEMPLATES_PRODUCE_UPLOAD_CSV]: "Enviar CSV",
  [TEMPLATES_PRODUCE_DOWNLOAD_FORMAT]: "Baixar CSV",
  [TEMPLATES_PRODUCE_CSV_EXAMPLE_FILENAME]: "{{name}}-variaveis-exemplo.csv",
  [TEMPLATES_PRODUCE_CSV_EXAMPLE_TEXT]: "Exemplo {{label}}",
  [TEMPLATES_PRODUCE_GENERATE]: "Gerar {{count}} imagens",
  [TEMPLATES_PRODUCE_GENERATE_SINGLE]: "Gerar {{count}} imagem",
  [TEMPLATES_PRODUCE_PREVIEW]: "Gerar visualização",
  [TEMPLATES_PRODUCE_PREVIEW_TOOLTIP]: "Gera uma imagem de teste deste modelo.",
  [TEMPLATES_PRODUCE_PREVIEW_THIS_SLIDE]: "Deste slide",
  [TEMPLATES_PRODUCE_PREVIEW_WHOLE_CAROUSEL]: "De todo o carrossel",
  [TEMPLATES_PRODUCE_SUMMARY]: "Resumo",
  [TEMPLATES_PRODUCE_EMPTY_TEMPLATES]:
    "Ainda não há modelos com camadas para produzir.",
  [TEMPLATES_PRODUCE_EMPTY_VARIABLES]:
    "Este modelo não possui variáveis para preencher.",
  [TEMPLATES_PRODUCE_SELECT_TEMPLATE]: "Selecionar um modelo",
  [TEMPLATES_PRODUCE_CSV_TITLE]: "Como deseja carregar o CSV?",
  [TEMPLATES_PRODUCE_CSV_DESCRIPTION]:
    "Você pode substituir todas as linhas atuais ou adicionar as linhas do arquivo ao final.",
  [TEMPLATES_PRODUCE_CSV_REPLACE]: "Substituir",
  [TEMPLATES_PRODUCE_CSV_APPEND]: "Adicionar",
  [TEMPLATES_PRODUCE_CSV_ERROR]: "Não foi possível ler o arquivo CSV.",
  [TEMPLATES_PRODUCE_CSV_EMPTY]:
    "O CSV não possui linhas válidas para as variáveis deste modelo.",
  [TEMPLATES_PRODUCE_CHANGE_TEMPLATE_TITLE]: "Alterar modelo?",
  [TEMPLATES_PRODUCE_CHANGE_TEMPLATE_DESCRIPTION]:
    "As linhas atuais serão apagadas porque as variáveis podem ser diferentes.",
  [TEMPLATES_PRODUCE_VALIDATION_ERROR]:
    "Preencha todas as variáveis. As células com dados ausentes estão marcadas em vermelho.",
  [TEMPLATES_PRODUCE_VALIDATION_HIGHLIGHT]:
    "Cada frase destacada deve corresponder exatamente ao texto dessa linha. As células que não correspondem estão marcadas em vermelho.",
  [TEMPLATES_PRODUCE_VALIDATION_NO_ROWS]:
    "Adicione pelo menos uma linha antes de gerar.",
  [TEMPLATES_PRODUCE_VALIDATION_VARIATIONS]:
    "Digite um número inteiro de pelo menos 1.",
  [TEMPLATES_PRODUCE_VALIDATION_NO_FORMATS]:
    "Selecione pelo menos um tamanho para gerar.",
  [TEMPLATES_PRODUCE_VALIDATION_TOO_MANY_ROWS]:
    "Você pode gerar no máximo {{max}} linhas por produção. Você solicitou {{count}}. Reduza o número de variações ou linhas.",
  [TEMPLATES_PRODUCE_GENERATE_SUCCESS]:
    "A produção começou. Você pode sair desta página; os resultados aparecerão abaixo da tabela e no painel de atividades.",
  [TEMPLATES_PRODUCE_DELETE_ROW]: "Excluir linha",
  [TEMPLATES_PRODUCE_COPY_TO_COLUMN]: "Copiar este valor para toda a coluna",
  [TEMPLATES_PRODUCE_SELECT_IMAGE]: "Selecionar imagem",
  [TEMPLATES_PRODUCE_REPLACE_IMAGE]: "Substituir imagem",
  [TEMPLATES_PRODUCE_IMAGE_CHECKING]: "Verificando se a imagem pode ser usada",
  [TEMPLATES_PRODUCE_IMAGE_UNUSABLE]:
    "Esta imagem não pode ser baixada devido a um bloqueio. Envie-a manualmente.",
  [TEMPLATES_PRODUCE_IMAGES_PROCESSING]:
    "As imagens recebidas estão sendo processadas.",
  [TEMPLATES_PRODUCE_IMAGES_UNUSABLE]:
    "Algumas imagens não podem ser baixadas para uso. Verifique a tabela e envie-as manualmente.",
  [TEMPLATES_PRODUCE_DELETE_IMAGE]: "Excluir imagem",
  [TEMPLATES_PRODUCE_RESULTS]: "Resultados",
  [TEMPLATES_PRODUCE_RUN_TITLE]: "{{date}}",
  [TEMPLATES_PRODUCE_RUN_LEGACY]: "Gerações anteriores",
  [TEMPLATES_PRODUCE_DELETE_SELECTED]: "Excluir ({{count}})",
  [TEMPLATES_PRODUCE_DELETE_CONFIRM_TITLE]:
    "Excluir {{count}} item(ns) gerado(s)?",
  [TEMPLATES_PRODUCE_DELETE_CONFIRM_TEXT]: "Esta ação não pode ser desfeita.",
  [TEMPLATES_PRODUCE_DELETE_ERROR]:
    "Não foi possível excluir os itens selecionados.",
  [TEMPLATES_PRODUCE_DOWNLOAD_CONFIG]: "Baixar configuração",
  [TEMPLATES_PRODUCE_CONFIG_FILENAME]: "{{name}}-variaveis.csv",
  [TEMPLATES_PRODUCE_GENERATING]: "Gerando…",
  [TEMPLATES_PRODUCE_ACTIVE_RUN]:
    "Já existe uma produção em andamento para este conjunto. Aguarde até que ela termine.",
  [TEMPLATES_PRODUCE_EDIT_TITLE]: "Editar peça",
  [TEMPLATES_PRODUCE_EDIT_NO_INSTANCE]:
    "Esta peça não possui camadas editáveis. Gere-a novamente para habilitar a edição.",
  [TEMPLATES_PRODUCE_ADD_TEXT]: "Texto",
  [TEMPLATES_PRODUCE_ADD_IMAGE]: "Imagem",
  [TEMPLATES_PRODUCE_ADD_SHAPE]: "Forma",
  [TEMPLATES_PRODUCE_ADD_GROUP]: "Grupo",
  [TEMPLATES_GROUP_LAYERS]: "Grupo",
  [TEMPLATES_PRODUCE_SAVE_ERROR]: "Não foi possível salvar a peça.",
  [TEMPLATES_PRODUCE_PARTIAL_SUMMARY]:
    "{{succeeded}} de {{requested}} gerados. {{failed}} falharam.",
  [TEMPLATES_PRODUCE_PARTIAL_TITLE]:
    "Quase pronto: {{succeeded}} de {{requested}} criativos gerados",
  [TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_SINGULAR]:
    "1 criativo não pôde ser gerado. Você pode tentar novamente sem repetir os demais.",
  [TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_PLURAL]:
    "{{failed}} criativos não puderam ser gerados. Você pode tentar novamente sem repetir os demais.",
  [TEMPLATES_PRODUCE_RETRY_FAILED]: "Tentar novamente os que falharam",
  [TEMPLATES_PRODUCE_RETRY_FAILED_SINGULAR]: "Tentar novamente o que falhou",
  [TEMPLATES_PRODUCE_RETRY_FAILED_PLURAL]: "Tentar novamente os que falharam",
  [TEMPLATES_PRODUCE_FAILURE_GENERIC]: "Não foi possível gerar esta imagem.",
  [TEMPLATES_PRODUCE_FAILURE_BUSY]: "O serviço está ocupado. Tente novamente.",
  [TEMPLATES_PRODUCE_FAILURE_IMAGE]: "Não foi possível gerar esta imagem.",
  [TEMPLATES_PRODUCE_FAILURE_DATA]:
    "Esta linha não possui os dados obrigatórios.",

  [AI_COMPETITORS_PAGE_TITLE]: "Análise de concorrentes",
  [AI_COMPETITORS_URL_STEP_NUMBER]: "Etapa 01 / 04",
  [AI_COMPETITORS_URL_TITLE]: "Analise",
  [AI_COMPETITORS_URL_MUTED]: "seus concorrentes.",
  [AI_COMPETITORS_URL_DESCRIPTION]:
    "Cole o site da sua empresa. Em segundos, mostramos quem está anunciando no seu mercado e quais anúncios estão usando.",
  [AI_COMPETITORS_URL_PLACEHOLDER]: "Cole o site da sua empresa",
  [AI_COMPETITORS_URL_CTA]: "Ver anúncios dos meus concorrentes",
  [AI_COMPETITORS_URL_INVALID]:
    "O que você digitou não parece ser uma URL válida. Verifique se está correta e tente novamente.",
  [AI_COMPETITORS_URL_BLOCKED]:
    "Não conseguimos obter informações do seu site. Algumas páginas usam mecanismos que bloqueiam o acesso automatizado (anti-crawlers).",
  [AI_COMPETITORS_URL_NO_COMPETITORS]:
    "Não encontramos concorrentes para essa marca. Tente outra URL ou um domínio mais específico.",
  [AI_COMPETITORS_ANALYZING_STEP_NUMBER]: "Etapa 02 / 04",
  [AI_COMPETITORS_ANALYZING_TITLE]: "Estamos analisando",
  [AI_COMPETITORS_ANALYZING_MUTED]: "seu mercado.",
  [AI_COMPETITORS_ANALYZING_DESCRIPTION]:
    "Identificamos sua marca, categoria e país para sugerir concorrentes reais.",
  [AI_COMPETITORS_PROGRESS_FALLBACK]: "Analisando seu site",
  [AI_COMPETITORS_PROGRESS_REVIEWING_PAGE]: "Analisando sua página",
  [AI_COMPETITORS_PROGRESS_FINDING_COMPETITORS]: "Buscando seus concorrentes",
  [AI_COMPETITORS_PROGRESS_CONSOLIDATING_COMPETITORS]:
    "Consolidando seus concorrentes",
  [AI_COMPETITORS_PROGRESS_RESOLVING_ADS]: "Localizando seus concorrentes",
  [AI_COMPETITORS_PROGRESS_SEARCHING_ADS]: "Buscando anúncios ativos",
  [AI_COMPETITORS_PROGRESS_CONSOLIDATING_ADS]: "Consolidando os anúncios",
  [AI_COMPETITORS_COMPETITORS_STEP_NUMBER]: "Etapa 03 / 04",
  [AI_COMPETITORS_COMPETITORS_TITLE]: "Estes são",
  [AI_COMPETITORS_COMPETITORS_MUTED]: "seus concorrentes.",
  [AI_COMPETITORS_COMPETITORS_DESCRIPTION]:
    "Remova os que não se aplicam, edite o nome ou cole o domínio dos concorrentes que você deseja analisar.",
  [AI_COMPETITORS_COMPETITORS_EMPTY]:
    "Não encontramos concorrentes automaticamente. Cole o domínio de quem você deseja analisar.",
  [AI_COMPETITORS_COMPETITORS_ADD_PLACEHOLDER]:
    "Cole um domínio, ex.: concorrente.com",
  [AI_COMPETITORS_COMPETITORS_ADD]: "Adicionar",
  [AI_COMPETITORS_COMPETITORS_ADD_INVALID]:
    "Verifique o domínio. Ele deve ter um formato como marca.com",
  [AI_COMPETITORS_COMPETITORS_NAME_LABEL]: "Nome",
  [AI_COMPETITORS_COMPETITORS_REMOVE]: "Excluir",
  [AI_COMPETITORS_COMPETITORS_CTA]: "Buscar seus anúncios",
  [AI_COMPETITORS_COMPETITORS_NEED_ONE]:
    "Adicione pelo menos um concorrente para buscar anúncios.",
  [AI_COMPETITORS_COMPETITORS_ADD_MAX]:
    "Você pode adicionar até {{max}} concorrentes.",
  [AI_COMPETITORS_SEARCHING_STEP_NUMBER]: "Etapa 04 / 04",
  [AI_COMPETITORS_SEARCHING_TITLE]: "Buscando",
  [AI_COMPETITORS_SEARCHING_MUTED]: "anúncios ativos.",
  [AI_COMPETITORS_SEARCHING_ERROR]:
    "Não conseguimos concluir a busca. Tente novamente.",
  [AI_COMPETITORS_SEARCHING_RETRY]: "Tentar novamente",
  [AI_COMPETITORS_RESULTS_STEP_NUMBER]: "Anúncios encontrados",
  [AI_COMPETITORS_RESULTS_TITLE]: "Isto é o que",
  [AI_COMPETITORS_RESULTS_MUTED]: "seus concorrentes estão anunciando.",
  [AI_COMPETITORS_RESULTS_SUMMARY]:
    "Encontramos {{adsCount}} anúncios ativos de {{competitorCount}} concorrentes.",
  [AI_COMPETITORS_RESULTS_NO_ADS]: "Nenhum anúncio ativo",
  [AI_COMPETITORS_RESULTS_NO_ADS_ALERT_TITLE]:
    "Seus concorrentes quase não estão anunciando. Esta é a sua oportunidade.",
  [AI_COMPETITORS_RESULTS_NO_ADS_ALERT_BODY]:
    "A Adle pode analisar seus concorrentes 24/7 e replicar os anúncios que realmente funcionam.",
  [AI_COMPETITORS_RESULTS_NO_ADS_CTA]: "Agendar uma demonstração",
  [AI_COMPETITORS_RESULTS_VIEW_MORE]: "Ver mais",
  [AI_COMPETITORS_RESULTS_GENERATE]: "Gerar minha versão",
  [AI_COMPETITORS_RESULTS_LOCKED_COUNT]: "+{{count}} anúncios",
  [AI_COMPETITORS_RESULTS_DOWNLOAD]: "Baixar",
  [AI_COMPETITORS_RESULTS_FORMAT_IMAGE]: "Imagem",
  [AI_COMPETITORS_RESULTS_FORMAT_VIDEO]: "Vídeo",
  [AI_COMPETITORS_RESULTS_FORMAT_CAROUSEL]: "Carrossel",
  [AI_COMPETITORS_AGENDA_CONFIRM_TITLE]: "Descubra a Adle",
  [AI_COMPETITORS_AGENDA_CONFIRM_TEXT]:
    "Mostramos todos os anúncios dos seus concorrentes e ensinamos como replicá-los em segundos.",
  [AI_COMPETITORS_AGENDA_CONFIRM_CTA]: "Agendar uma demonstração",
  [AI_COMPETITORS_AGENDA_BACK]: "Voltar",
  [AI_COMPETITORS_AGENDA_STEP_NUMBER]: "Próximo passo",
  [AI_COMPETITORS_AGENDA_TITLE]: "Vamos mostrar",
  [AI_COMPETITORS_AGENDA_MUTED]: "como replicá-los.",
  [AI_COMPETITORS_AGENDA_CONTEXT]:
    "Encontramos {{adsCount}} anúncios ativos de {{competitorNames}}. Na chamada, mostraremos como replicar os que apresentam melhor desempenho com {{productName}}.",
  [AI_COMPETITORS_AGENDA_CONTEXT_ZERO]:
    "Seus concorrentes quase não estão anunciando: esta é a sua oportunidade. {{productName}} pode analisá-los 24/7 e replicar os anúncios que funcionam.",
  [AI_COMPETITORS_AGENDA_CONTEXT_FALLBACK]:
    "Na chamada, mostraremos como replicar os anúncios que apresentam melhor desempenho com {{productName}}.",
  [AI_COMPETITORS_THANKS_STEP_NUMBER]: "Agendamento confirmado",
  [AI_COMPETITORS_THANKS_TITLE]: "Nos vemos",
  [AI_COMPETITORS_THANKS_MUTED]: "na chamada.",
  [AI_COMPETITORS_THANKS_DESCRIPTION]:
    "Enviamos a confirmação por e-mail. Na sessão, analisaremos os anúncios dos seus concorrentes e mostraremos como replicar os que apresentam melhor desempenho.",
  [NEW_FEATURE_CALLOUT_BADGE]: "NOVA FUNCIONALIDADE",
  [NEW_FEATURE_CALLOUT_CLOSE_ARIA]: "Fechar",
  [NEW_FEATURE_CALLOUT_DEFAULT_CTA]: "Descobrir",
  [NEW_FEATURE_CALLOUT_INSIGHTS_TITLE]: "Insights",
  [NEW_FEATURE_CALLOUT_INSIGHTS_DESCRIPTION]:
    "Descubra os aprendizados que a IA identificou nos resultados das suas campanhas e aplique-os à configuração da sua marca.",
  [NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_TITLE]: "Modelos",
  [NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_DESCRIPTION]:
    "Gere conteúdo a partir de modelos: defina as camadas ou envie um criativo para que possamos analisá-lo para você.",
  [NEW_FEATURE_CALLOUT_AUTOMATIONS_TITLE]: "Automações",
  [NEW_FEATURE_CALLOUT_AUTOMATIONS_DESCRIPTION]:
    "Publique automaticamente conteúdos da sua biblioteca: escolha a pasta, as plataformas e a frequência. Nós cuidamos do resto.",

  // AUTOMATIONS
  [AUTOMATIONS_MENU_TITLE]: "Automações",
  [AUTOMATIONS_PAGE_TITLE]: "Publicação Automática",
  [AUTOMATIONS_PAGE_DESCRIPTION]:
    "Permita que {{NAME_BUSINESS}} publique automaticamente conteúdos da sua biblioteca nas suas redes sociais conectadas.",
  [BUTTON_NEW_AUTOMATION]: "Nova",
  [AUTOMATIONS_HERO_TITLE]: "Economize tempo. Continue publicando.",
  [AUTOMATIONS_HERO_DESCRIPTION]:
    "Selecione uma pasta, escolha suas plataformas e {{NAME_BUSINESS}} cuidará do resto — desde o agendamento até a publicação.",
  [AUTOMATIONS_STATUS_ACTIVE]: "Ativa",
  [AUTOMATIONS_STATUS_PAUSED]: "Pausada",
  [AUTOMATIONS_LABEL_FOLDER]: "Pasta",
  [AUTOMATIONS_LABEL_PLATFORMS]: "Plataformas",
  [AUTOMATIONS_LABEL_FREQUENCY]: "Frequência",
  [AUTOMATIONS_LABEL_NEXT_POST]: "Próxima publicação",
  [AUTOMATIONS_MOCK_BRAND_CONTENT]: "Conteúdo da marca",
  [AUTOMATIONS_MOCK_PRODUCT_LAUNCH]: "Lançamento de produto",
  [AUTOMATIONS_MOCK_THOUGHT_LEADERSHIP]: "Liderança de pensamento",
  [AUTOMATIONS_MOCK_FOLDER_SOCIAL_SEPTEMBER]: "Redes sociais de setembro",
  [AUTOMATIONS_MOCK_FOLDER_ALL_CONTENT]: "Todo o conteúdo",
  [AUTOMATIONS_MOCK_FOLDER_LINKEDIN]: "Conteúdo do LinkedIn",
  [AUTOMATIONS_MOCK_FREQ_ONE_PER_DAY]: "1 publicação por dia",
  [AUTOMATIONS_MOCK_FREQ_FIVE_PER_WEEK]: "5 publicações por semana",
  [AUTOMATIONS_MOCK_FREQ_THREE_PER_WEEK]: "3 publicações por semana",
  [AUTOMATIONS_FREQ_ONE_PER_DAY]: "1 publicação por dia",
  [AUTOMATIONS_FREQ_THREE_PER_WEEK]: "3 publicações por semana",
  [AUTOMATIONS_FREQ_FOUR_PER_WEEK]: "4 publicações por semana",
  [AUTOMATIONS_FREQ_FIVE_PER_WEEK]: "5 publicações por semana",
  [AUTOMATIONS_FREQ_SIX_PER_WEEK]: "6 publicações por semana",
  [AUTOMATIONS_MOCK_NEXT_TODAY]: "Hoje · 19:00",
  [AUTOMATIONS_MOCK_NEXT_EMPTY]: "—",
  [AUTOMATIONS_MOCK_NEXT_TOMORROW]: "Amanhã · 09:00",
  [MODAL_CREATE_AUTOMATION_TITLE]: "Criar automação",
  [AUTOMATIONS_STEP_SOURCE]: "Fonte",
  [AUTOMATIONS_STEP_PLATFORMS]: "Plataformas",
  [AUTOMATIONS_STEP_SCHEDULE]: "Agendamento",
  [AUTOMATIONS_STEP_CONTENT_AI]: "Conteúdo e IA",
  [AUTOMATIONS_STEP_REVIEW]: "Revisão",
  [AUTOMATIONS_STEP_SOURCE_TITLE]: "Selecionar fonte de conteúdo",
  [AUTOMATIONS_STEP_SOURCE_HELP]:
    "Escolha quais conteúdos {{NAME_BUSINESS}} deve usar para a publicação automática.",
  [AUTOMATIONS_SOURCE_ALL_TITLE]: "Todo o conteúdo (raiz)",
  [AUTOMATIONS_SOURCE_ALL_DESCRIPTION]:
    "Usa todo o conteúdo da sua biblioteca.",
  [AUTOMATIONS_SOURCE_FOLDER_TITLE]: "Pasta específica",
  [AUTOMATIONS_SOURCE_FOLDER_DESCRIPTION]:
    "Usa o conteúdo de uma pasta selecionada.",
  [AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS]: "Incluir subpastas",
  [AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS_HELP]:
    "Também usa conteúdos de pastas aninhadas.",
  [AUTOMATIONS_STEP_LANGUAGE_TITLE]: "Idioma",
  [AUTOMATIONS_STEP_LANGUAGE_HELP]:
    "As descrições das publicações serão geradas neste idioma.",
  [AUTOMATIONS_VALIDATION_LANGUAGE]:
    "Selecione o idioma das descrições para continuar.",
  [AUTOMATIONS_REVIEW_LANGUAGE]: "Idioma",
  [AUTOMATIONS_CONNECT_ACCOUNTS]: "Conectar contas",
  [AUTOMATIONS_STEP_PLATFORMS_TITLE]: "Selecionar plataformas",
  [AUTOMATIONS_STEP_PLATFORMS_HELP]:
    "Escolha as contas sociais nas quais {{NAME_BUSINESS}} poderá publicar conteúdo.",
  [AUTOMATIONS_PLATFORM_CONNECTED]: "Conectada",
  [AUTOMATIONS_STEP_SCHEDULE_TITLE]: "Definir programação de publicação",
  [AUTOMATIONS_STEP_SCHEDULE_HELP]:
    "Informe a {{NAME_BUSINESS}} com que frequência e quando publicar.",
  [AUTOMATIONS_SCHEDULE_FREQUENCY]: "Frequência",
  [AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW]: "Janela de publicação",
  [AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW_HELP]:
    "{{NAME_BUSINESS}} sugerirá os melhores horários para publicar dentro desta janela de tempo.",
  [AUTOMATIONS_SCHEDULE_TIMEZONE]: "Fuso horário",
  [AUTOMATIONS_SCHEDULE_VALIDITY]: "Duração",
  [AUTOMATIONS_SCHEDULE_VALIDITY_HELP]:
    "Defina quando esta automação começa e termina.",
  [AUTOMATIONS_SCHEDULE_START]: "Início",
  [AUTOMATIONS_SCHEDULE_START_NOW]: "Iniciar agora",
  [AUTOMATIONS_SCHEDULE_START_NOW_HELP]:
    "A automação começará imediatamente após ser criada.",
  [AUTOMATIONS_SCHEDULE_START_SCHEDULED]: "Agendar início",
  [AUTOMATIONS_SCHEDULE_END]: "Fim",
  [AUTOMATIONS_SCHEDULE_END_ALWAYS_ON]: "Sempre ativa",
  [AUTOMATIONS_SCHEDULE_END_ALWAYS_ON_HELP]:
    "A automação continuará até que você a pause.",
  [AUTOMATIONS_SCHEDULE_END_SCHEDULED]: "Encerrar em uma data",
  [AUTOMATIONS_STEP_CONTENT_AI_TITLE]: "Conteúdo e IA",
  [AUTOMATIONS_STEP_CONTENT_AI_HELP]:
    "Escolha como {{NAME_BUSINESS}} deve preparar cada publicação antes de publicá-la.",
  [AUTOMATIONS_CONTENT_ORIGINAL_TITLE]: "Usar conteúdo original",
  [AUTOMATIONS_CONTENT_ORIGINAL_DESCRIPTION]:
    "Publica os conteúdos selecionados exatamente como estão.",
  [AUTOMATIONS_CONTENT_AI_TITLE]: "Otimizar com a IA do {{NAME_BUSINESS}}",
  [AUTOMATIONS_CONTENT_AI_DESCRIPTION]:
    "Gera descrições e adapta o conteúdo para cada plataforma.",
  [AUTOMATIONS_AI_NOTE_TITLE]: "A assistência de IA está pronta",
  [AUTOMATIONS_AI_NOTE_DESCRIPTION]:
    "{{NAME_BUSINESS}} manterá a voz da sua marca consistente.",
  [AUTOMATIONS_STEP_REVIEW_TITLE]: "Revisar automação",
  [AUTOMATIONS_STEP_REVIEW_HELP]:
    "Revise sua configuração antes de criar esta automação.",
  [AUTOMATIONS_REVIEW_SOURCE]: "Fonte",
  [AUTOMATIONS_REVIEW_PLATFORMS]: "Plataformas",
  [AUTOMATIONS_REVIEW_SCHEDULE]: "Agendamento",
  [AUTOMATIONS_REVIEW_VALIDITY]: "Duração",
  [AUTOMATIONS_REVIEW_VALIDITY_VALUE]: "{{start}} · {{end}}",
  [AUTOMATIONS_REVIEW_VALIDITY_START_NOW]: "Começa agora",
  [AUTOMATIONS_REVIEW_VALIDITY_START_AT]: "Começa em {{datetime}}",
  [AUTOMATIONS_REVIEW_VALIDITY_ALWAYS_ON]: "Sempre ativa",
  [AUTOMATIONS_REVIEW_VALIDITY_END_AT]: "Termina em {{datetime}}",
  [AUTOMATIONS_REVIEW_NAME]: "Nome",
  [AUTOMATIONS_REVIEW_CONTENT_AI]: "Conteúdo gerado por IA",
  [AUTOMATIONS_DEFAULT_NAME]: "Automação {{date}}",
  [AUTOMATIONS_BUTTON_BACK]: "Voltar",
  [AUTOMATIONS_BUTTON_CREATE]: "Criar",
  [AUTOMATIONS_BUTTON_SAVE]: "Salvar alterações",
  [AUTOMATIONS_REVIEW_SCHEDULE_VALUE]:
    "{{frequency}} · {{startTime}} – {{endTime}}",
  [AUTOMATIONS_STATUS_WAITING]: "Aguardando conteúdo",
  [AUTOMATIONS_STATUS_SCHEDULING]: "Agendando",
  [AUTOMATIONS_STATUS_ATTENTION]: "Requer atenção",
  [AUTOMATIONS_STATUS_OFF]: "Desativada",
  [AUTOMATIONS_STATUS_ENDED]: "Encerrada",
  [AUTOMATIONS_MENU_EDIT]: "Editar",
  [AUTOMATIONS_MENU_VIEW_CALENDAR]: "Ver calendário",
  [AUTOMATIONS_MENU_TURN_OFF]: "Desativar",
  [AUTOMATIONS_TURN_OFF_TITLE]: "Desativar a publicação automática?",
  [AUTOMATIONS_TURN_OFF_DESCRIPTION]:
    "As publicações já agendadas não serão removidas automaticamente. Isso impedirá o {{NAME_BUSINESS}} de criar novas publicações automáticas.",
  [AUTOMATIONS_TURN_OFF_CONFIRM]: "Desativar",
  [AUTOMATIONS_WAITING_BANNER]:
    "Automação pausada — não há conteúdo compatível para publicar.",
  [AUTOMATIONS_ATTENTION_BANNER]:
    "Uma ou mais contas de redes sociais precisam de atenção. As outras plataformas continuarão publicando.",
  [AUTOMATIONS_VALIDATION_FOLDER]: "Selecione uma pasta para continuar.",
  [AUTOMATIONS_VALIDATION_ACCOUNTS]:
    "Selecione pelo menos uma conta conectada.",
  [AUTOMATIONS_VALIDATION_WINDOW]:
    "O início da janela de publicação deve ser anterior ao final.",
  [AUTOMATIONS_VALIDATION_START_REQUIRED]:
    "Selecione uma data e hora de início.",
  [AUTOMATIONS_VALIDATION_START_FUTURE]:
    "A data de início deve ser agora ou no futuro.",
  [AUTOMATIONS_VALIDATION_END_REQUIRED]:
    "Selecione uma data e hora de término.",
  [AUTOMATIONS_VALIDATION_END_FUTURE]:
    "A data de término deve estar no futuro.",
  [AUTOMATIONS_VALIDATION_END_AFTER_START]:
    "A data de término deve ser posterior ao início.",
  [AUTOMATIONS_HERO_QUEUED]: "Na fila",
  [AUTOMATIONS_HERO_PUBLISHED]: "Publicações nesta semana",
  [AUTOMATIONS_HERO_FAILED]: "Falhou",
  [AUTOMATIONS_HERO_NEXT]: "Próxima publicação",
  [AUTOMATIONS_NEXT_NONE]: "—",
  [AUTOMATIONS_REMAINING_CONTENT]: "{{count}} restantes",
  [CALENDAR_SOURCE_AUTOMATED]: "Automática",
  [CALENDAR_ACTIVE_AUTOMATIONS]: "Automações ativas ({{count}})",
  [CALENDAR_AUTOMATION_ENDS]: "Termina em {{date}}",
  [CALENDAR_AUTOMATION_FOLDER]: "{{folder}}",
  [CALENDAR_SOURCE_MANUAL]: "Manual",
  [EVENT_DETAILS_AUTOMATION]: "Automação",
  [EVENT_DETAILS_ACCOUNT]: "Conta",
  [MODAL_EDIT_AUTOMATION_TITLE]: "Editar automação",
  [AUTOMATIONS_NO_PERMISSION]:
    "Você pode visualizar as automações, mas não pode modificá-las.",
  [OPTIMISTIC_SWITCH_FAILURE_BODY]:
    "Não foi possível {{action}} {{name}} devido ao seguinte erro:",
  [OPTIMISTIC_SWITCH_FAILURE_EMAIL_SUBJECT]:
    "Ocorreu um problema ao atualizar o último estado que você tentou alterar.",
  [OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN]: "ativar a campanha",
  [OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN]: "desativar a campanha",
  [OPTIMISTIC_SWITCH_ACTIVATE_ASSETS_GROUP]: "ativar o grupo de recursos",
  [OPTIMISTIC_SWITCH_DEACTIVATE_ASSETS_GROUP]: "desativar o grupo de recursos",
  [OPTIMISTIC_SWITCH_ACTIVATE_AD_GROUP]: "ativar o grupo de anúncios",
  [OPTIMISTIC_SWITCH_DEACTIVATE_AD_GROUP]: "desativar o grupo de anúncios",
  [OPTIMISTIC_SWITCH_ACTIVATE_AD]: "ativar o anúncio",
  [OPTIMISTIC_SWITCH_DEACTIVATE_AD]: "desativar o anúncio",
  [OPTIMISTIC_SWITCH_ACTIVATE_AUTOMATION]: "retomar a automação",
  [OPTIMISTIC_SWITCH_DEACTIVATE_AUTOMATION]: "pausar a automação",
  [OPTIMISTIC_SWITCH_ACTIVATE_PROMO_CODE]: "ativar o código",
  [OPTIMISTIC_SWITCH_DEACTIVATE_PROMO_CODE]: "desativar o código",
  [CREATE_CAMPAIGN_WIZARD_ARIA]: "Criar campanha",
  [CREATE_CAMPAIGN_SETUP_TITLE]: "Criar campanha",
  [CREATE_CAMPAIGN_SETUP_DESCRIPTION]:
    "Escolha o idioma, as localizações e uma plataforma. O tema é opcional.",
  [CREATE_CAMPAIGN_WIZARD_STEP_INSTRUCTIONS_HELP]:
    "Adicione contexto ou arquivos opcionais para que a campanha esteja alinhada ao seu objetivo.",
  [CREATE_CAMPAIGN_WIZARD_STEP_LANGUAGE_HELP]:
    "Escolha o idioma dos anúncios, textos e recomendações.",
  [CREATE_CAMPAIGN_WIZARD_STEP_LOCATIONS_HELP]:
    "Selecione as localizações onde esta campanha deve ser veiculada.",
  [CREATE_CAMPAIGN_WIZARD_STEP_PLATFORM_HELP]:
    "Escolha uma plataforma para continuar. Você poderá voltar e alterá-la depois.",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_TITLE]: "Exclusões de {{adAccountName}}",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_DESCRIPTION]:
    "Aplique diferentes tipos de exclusões no nível da conta. Elas serão aplicadas em comum a todas as campanhas atuais e futuras da conta.",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNELS]: "Canais excluídos",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEOS]: "Vídeos excluídos",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CONTENT_CATEGORIES]: "Categorias excluídas",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EXCLUDED_APPS]: "Apps excluídos",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_CATEGORIES]: "Categorias excluídas",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOADING]: "Carregando configuração",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY_ROW]: "Ainda não há dados",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SETTINGS]: "Exclusões da conta",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORDS]: "Palavras-chave negativas",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_YOUTUBE]: "YouTube",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APPS]: "Apps",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD]: "Palavra-chave",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_INVALID_CHARS]:
    "A palavra-chave tem caracteres não permitidos (., -, /, e outros símbolos)",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_MATCH_SYNTAX]:
    'A correspondência deve fechar corretamente: [palavra] ou "palavra". Não use aspas simples',
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_TYPE]: "Correspondência",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_BROAD]: "Ampla",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_PHRASE]: "De frase",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_EXACT]: "Exata",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL]: "Canal do YouTube",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL_INVALID]:
    "Use um link de canal do YouTube (youtube.com/channel/..., /@usuario, /c/... ou /user/...)",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEO]: "Vídeo do YouTube",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CATEGORIES]: "Categorias",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_ID]: "ID do app",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_NAME]: "Nome",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SEARCH_CATEGORIES]: "Buscar categoria",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY]: "Ainda não há exclusões",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVED]: "Exclusões salvas",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVE_ERROR]:
    "Não foi possível salvar as exclusões",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOAD_ERROR]:
    "Não foi possível carregar a configuração da conta",
  [GOOGLE_ADS_CONTENT_LABEL_BELOW_THE_FOLD]: "Conteúdo fora da primeira tela",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_CONTENT_FOR_FAMILIES]:
    "Conteúdo para famílias e Feito para crianças",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_FIGHTING]: "Jogos de luta",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_MATURE]:
    "Jogos para adultos",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SENSITIVE]:
    "Saúde sensível",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SOURCE_UNDETERMINED]:
    "Saúde de fonte não determinada",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_RECENT]: "Notícias recentes",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SENSITIVE]:
    "Notícias sensíveis",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SOURCE_NOT_FEATURED]:
    "Notícias de fontes não destacadas",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_POLITICS]: "Política",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_RELIGION]: "Religião",
  [GOOGLE_ADS_CONTENT_LABEL_EMBEDDED_VIDEO]: "Vídeo incorporado",
  [GOOGLE_ADS_CONTENT_LABEL_JUVENILE]: "Conteúdo grotesco ou bizarro",
  [GOOGLE_ADS_CONTENT_LABEL_LIVE_STREAMING_VIDEO]: "Vídeo ao vivo",
  [GOOGLE_ADS_CONTENT_LABEL_PARKED_DOMAIN]: "Domínio sem site",
  [GOOGLE_ADS_CONTENT_LABEL_PROFANITY]: "Linguagem obscena",
  [GOOGLE_ADS_CONTENT_LABEL_SEXUALLY_SUGGESTIVE]:
    "Conteúdo sexualmente sugestivo",
  [GOOGLE_ADS_CONTENT_LABEL_SOCIAL_ISSUES]: "Temas sociais sensíveis",
  [GOOGLE_ADS_CONTENT_LABEL_TRAGEDY]: "Morte e tragédia",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO]: "Vídeo",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_NOT_YET_RATED]: "Vídeo sem classificação",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_G]:
    "Classificação G (livre para todos os públicos)",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_MA]:
    "Classificação MA (somente adultos)",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_PG]:
    "Classificação PG (recomenda-se supervisão dos pais)",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_T]:
    "Classificação T (adolescentes)",
  [FEATURE_ADDON_PAYWALL_TITLE]: "Melhore este recurso",
  [FEATURE_ADDON_PAYWALL_DESCRIPTION]:
    "Você atingiu o limite gratuito deste recurso do AppSumo. Escolha um plano mensal para continuar.",
  [FEATURE_ADDON_PAYWALL_CURRENT_LIMIT]: "Limite atual: {{limit}}",
  [FEATURE_ADDON_PAYWALL_TIER_CTA]: "Assinar",
  [FEATURE_ADDON_PAYWALL_CLOSE]: "Fechar",
  [FEATURE_ADDON_PAYWALL_FREE]: "Grátis",
  [FEATURE_ADDON_PAYWALL_INCLUDED]: "Sua conta já inclui {{benefits}}",
  [FEATURE_ADDON_INCLUDED_AUTOMATIONS]:
    "{{capacity}} para publicar em {{platforms}} até {{count}} vezes por semana",
  [FEATURE_ADDON_INCLUDED_TEMPLATES]:
    "{{capacity}} e gerar até {{produceLimit}} peças de cada vez",
  [FEATURE_ADDON_INCLUDED_COMPETITORS]:
    "ver {{visibility}} anúncios em {{platforms}}, salvar 1 favorito e gerar 1 versão",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_POOL_ONE]: "1 favorito ou versão por mês",
  [FEATURE_ADDON_PAYWALL_CURRENT]: "Atual",
  [FEATURE_ADDON_PAYWALL_PER_MONTH]: "USD/mês",
  [FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS]:
    "Até {{limit}} automações na sua conta",
  [FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS_ONE]: "1 automação",
  [FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES]:
    "Até {{limit}} modelos na sua conta",
  [FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES_ONE]: "1 modelo",
  [FEATURE_ADDON_BENEFIT_ACTIONS]:
    "Salvar ou gerar até {{limit}} anúncios por mês",
  [FEATURE_ADDON_BENEFIT_ACTIONS_ONE]: "Salvar ou gerar uma variação",
  [FEATURE_ADDON_BENEFIT_VISIBILITY]:
    "Ver {{limit}} anúncios dos seus concorrentes",
  [FEATURE_ADDON_BENEFIT_VISIBILITY_ALL]:
    "Ver todos os anúncios dos seus concorrentes",
  [FEATURE_ADDON_PAYWALL_TIER_NAME]: "Tier {{index}}",
  [FEATURE_ADDON_HERO_AUTOMATIONS]:
    "Automatize a publicação de conteúdo nas suas redes sociais.",
  [FEATURE_ADDON_HERO_TEMPLATES]:
    "Gere conteúdo a partir de modelos definidos por você.",
  [FEATURE_ADDON_HERO_COMPETITORS]:
    "Revise e gere variações dos anúncios que funcionam para a sua concorrência.",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_PUBLISH]:
    "Publique no Facebook, Instagram, Youtube, TikTok e LinkedIn",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_SCHEDULE]:
    "Sugerir o melhor dia e horário para cada tipo de publicação",
  [FEATURE_ADDON_BENEFIT_TEMPLATES_LAYERS]:
    "Defina camadas, grupos e propriedades",
  [FEATURE_ADDON_BENEFIT_TEMPLATES_ANALYZE]: "Separar um criativo em camadas",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_SAVE]:
    "Salve anúncios e gere a sua versão",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_INSPIRE]:
    "Revise anúncios da sua concorrência no Meta, Google e LinkedIn",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_PLATFORMS]: "Publique em {{platforms}}",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_FREQUENCY]:
    "Até {{count}} publicações multiplataforma por semana por automação",
  [FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_TERM]:
    "Publicação multiplataforma",
  [FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_BODY]:
    "Uma mesma publicação em várias plataformas ao mesmo tempo conta como apenas 1 publicação.",
  [FEATURE_ADDON_BENEFIT_TEMPLATES_PRODUCE]:
    "Gere até {{limit}} peças de cada vez",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_PLATFORMS]: "Anúncios em {{platforms}}",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES]:
    "Salve até {{limit}} favoritos por mês",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES_ONE]: "Salve 1 favorito",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE]: "Gere a sua versão",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE_ONE]: "Gere 1 versão",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_POOL]:
    "Até {{limit}} favoritos ou versões por mês",
  [FEATURE_ADDON_NAME_AUTOMATIONS]: "Automações",
  [FEATURE_ADDON_NAME_TEMPLATES]: "Modelos",
  [FEATURE_ADDON_NAME_COMPETITORS]: "Concorrentes",
  [FEATURE_ADDON_UNPAID_TITLE]: "Falha no pagamento de {{feature}} {{tier}}",
  [FEATURE_ADDON_UNPAID_PERIOD]:
    "Pagamento de {{feature}} {{tier}}, período de {{startDate, short}} a {{endDate, short}}",
  [FEATURE_ADDON_UNPAID_AMOUNT]: "Pagamento pendente de {{value}} {{currency}}",
  [FEATURE_ADDON_BILLING_TITLE]: "Add-ons",
  [FEATURE_ADDON_BILLING_RENEWS]: "Renova em {{date, short}}",
  [FEATURE_ADDON_BILLING_CANCELS]: "Cancela em {{date, short}}",
  [FEATURE_ADDON_BILLING_UPGRADE]: "Fazer upgrade do plano",
  [FEATURE_ADDON_BILLING_CANCEL_TITLE]: "Cancelar este add-on?",
  [FEATURE_ADDON_BILLING_CANCEL_MODAL_TITLE]: "⚠️ Isto cancelará o add-on",
  [FEATURE_ADDON_BILLING_CANCEL_MODAL_CONFIRM]: "Cancelar add-on",
  [FEATURE_ADDON_BILLING_CANCEL_MODAL_KEEP]: "Manter add-on",
  [FEATURE_ADDON_BILLING_CANCEL_DESCRIPTION]:
    "Você continua com este add-on até {{date, day}} de {{date, monthText}} de {{date, year}}. Depois passa para o plano gratuito e perde o acesso aos benefícios do seu plano pago.",
  [FEATURE_ADDON_BILLING_CANCELLED_TITLE]: "Cancelamento agendado",
  [FEATURE_ADDON_BILLING_REACTIVATED_TITLE]: "Add-on reativado",
  [FEATURE_ADDON_BILLING_MENU]: "Opções do add-on",
  [EXTRA_SEATS_MANAGE]: "Gerenciar",
  [EXTRA_SEATS_MODAL_TITLE]: "Usuários Adicionais da Equipe",
  [EXTRA_SEATS_MODAL_SUBTITLE]:
    "Seu plano inclui {{planUsers}} usuários. Os extras custam {{price}}/mês cada.",
  [EXTRA_SEATS_MODAL_SUBTITLE_NO_PRICE]:
    "Seu plano inclui {{planUsers}} usuários.",
  [EXTRA_SEATS_QUANTITY_LABEL]: "Usuários extras",
  [EXTRA_SEATS_DELTA_USERS_ONE]: "{{count}} usuário × {{price}}",
  [EXTRA_SEATS_DELTA_USERS]: "{{count}} usuários × {{price}}",
  [EXTRA_SEATS_AMOUNT_PER_MONTH]: "{{amount}}/mês",
  [EXTRA_SEATS_DUE_TODAY_LABEL]: "Hoje você paga",
  [EXTRA_SEATS_PRORATION_TODAY]:
    "Proporcional hoje ({{start, d MMM}} → {{end, d MMM}})",
  [EXTRA_SEATS_NEXT_TOTAL_FROM]: "A partir de {{date, d MMM}}",
  [EXTRA_SEATS_NEXT_TOTAL_MONTHLY]: "Por mês",
  [EXTRA_SEATS_MONTHLY_TOTAL]: "Total mensal",
  [EXTRA_SEATS_KEEP_UNTIL_CYCLE_ONE]:
    "Você mantém seu usuário extra até o fim do ciclo.",
  [EXTRA_SEATS_KEEP_UNTIL_CYCLE]:
    "Você mantém seus {{count}} usuários até o fim do ciclo.",
  [EXTRA_SEATS_PRORATION_NOTE]:
    "Você paga só pelos dias que restam neste ciclo. Próxima cobrança: {{date, d MMM}} · {{amount}}",
  [EXTRA_SEATS_NO_CHARGE_NOTE]: "Sem cobrança hoje.",
  [EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK_ONE]:
    "Você tem {{used}} membros ativos. Remova um em {{section}} antes de reduzir.",
  [EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK]:
    "Você tem {{used}} membros ativos. Remova {{count}} em {{section}} antes de reduzir.",
  [EXTRA_SEATS_REDUCE_BLOCKED_ONE]:
    "Remova um em {{section}} antes de reduzir.",
  [EXTRA_SEATS_REDUCE_BLOCKED]:
    "Remova {{count}} em {{section}} antes de reduzir.",
  [EXTRA_SEATS_CONFIRM]: "Confirmar",
  [EXTRA_SEATS_ADDED]:
    "Usuário extra adicionado. Agora você pode criar o usuário.",
  [EXTRA_SEATS_CHECKOUT_CANCELLED]:
    "Pagamento cancelado. Nenhum usuário extra foi adicionado.",
  [EXTRA_SEATS_CHECKOUT_INCOMPLETE]:
    "O pagamento não foi concluído. Nenhum usuário extra foi adicionado.",
  [EXTRA_SEATS_BILLING_ROW_TITLE]: "Usuários Adicionais da Equipe",
  [EXTRA_SEATS_QUANTITY_BADGE]: "{{n}} Usuários adicionais",
  [EXTRA_SEATS_REDUCE_NOTICE]:
    "Seus usuários extras serão reduzidos para {{n}} em {{date, short}}. Sem reembolso do período atual.",
  [EXTRA_SEATS_CANCEL_NOTICE]:
    "Os usuários extras serão cancelados em {{date, short}}.",
  [EXTRA_SEATS_CHANGE_SAVED]: "Usuários extras atualizados.",
  [EXTRA_SEATS_FORBIDDEN]:
    "Você não tem permissão para alterar os usuários extras.",
  [EXTRA_SEATS_DECREASE]: "Menos usuários extras",
  [EXTRA_SEATS_INCREASE]: "Mais usuários extras",
  [EXTRA_SEATS_RETRY]:
    "Não foi possível atualizar os usuários extras. Tente novamente.",
  [EXTRA_SEATS_REACTIVATE_NOT_ELIGIBLE]:
    "Os usuários extras não podem ser reativados no seu plano atual.",
  [EXTRA_SEATS_CHECKOUT_FORBIDDEN]:
    "Este pagamento não corresponde a usuários extras.",
  [EXTRA_SEATS_MISSING_AGENCY]:
    "Não encontramos a agência desta conta, então os usuários extras não estão disponíveis.",
  [SEAT_LIMIT_REACHED]: "Você atingiu o limite de usuários do seu plano.",
  [SEATS_QUANTITY_CHANGED]:
    "Seus usuários extras mudaram. Revise e tente novamente.",
  [SEATS_OPERATION_IN_PROGRESS]:
    "Há outra alteração em andamento. Tente novamente em um minuto.",
  [SEATS_UNPAID]:
    "Seus usuários extras têm uma fatura pendente. Atualize seu método de pagamento para adicionar mais.",
  [SEATS_QUANTITY_OUT_OF_RANGE]:
    "Você pode escolher entre {{min}} e {{max}} usuários extras.",
  [SEATS_NOT_ELIGIBLE]:
    "Usuários extras não estão disponíveis para esta conta.",
  [SEATS_PRICE_NOT_CONFIGURED]:
    "Os usuários extras não estão disponíveis no momento.",
  [SEATS_SUBSCRIPTION_NOT_FOUND]:
    "Não encontramos a assinatura de usuários extras.",
  [BUTTON_BULK_CREATE_CAMPAIGNS]: "Geração em Massa",
  [BULK_CAMPAIGNS_DESCRIPTION]:
    "Envie o brief das suas campanhas e a Adle se encarregará de detectar todas as campanhas e a estrutura que você quer gerar.",
  [BULK_CAMPAIGNS_SUMMARY]:
    "Encontramos um total de {{campaigns}} campanhas a gerar, com até {{maxAdGroups}} grupos de anúncios dentro de cada uma.",
  [BULK_CAMPAIGNS_LIST_TITLE]: "Campanhas que serão geradas",
  [BULK_CAMPAIGNS_GENERATE]: "Gerar campanhas",
  [BULK_CAMPAIGNS_GENERATING]: "Gerando campanhas...",
  [BULK_CAMPAIGNS_ALERT_ANALYZING]: "Analisando o Documento de Campanhas...",
  [BULK_CAMPAIGNS_ALERT_ANALYSIS_SUCCESS]:
    "Documento Analisado. Revise as Campanhas a Gerar",
  [BULK_CAMPAIGNS_ALERT_ANALYSIS_ERROR]:
    "Não Foi Possível Analisar o Documento",
  [BULK_CAMPAIGNS_ALERT_GENERATING]: "Gerando {{count}} Campanhas...",
  [BULK_CAMPAIGNS_ALERT_GENERATION_SUCCESS]: "{{count}} Campanhas Geradas",
  [BULK_CAMPAIGNS_ALERT_GENERATION_ERROR]:
    "Não Foi Possível Gerar as Campanhas",
  [BULK_CAMPAIGNS_GENERATE_ERROR]:
    "Não foi possível gerar as campanhas. Tente novamente.",
  [BULK_CAMPAIGNS_PLATFORM_NOT_SUPPORTED]:
    "A plataforma {{platform}} não está disponível para a geração em massa.",
  [BULK_CAMPAIGNS_PLATFORM_NOT_DETECTED]:
    "Não foi possível detectar a plataforma deste documento.",
  [BULK_CAMPAIGNS_TYPE_NOT_SUPPORTED]:
    "Este tipo de campanha não está disponível para a geração em massa.",
  [BULK_CAMPAIGNS_TITLE]: "Gere Campanhas em Massa",
  [BULK_CAMPAIGNS_DROP_TITLE]: "Solte seu arquivo aqui ou clique para procurar",
  [BULK_CAMPAIGNS_DROP_FORMATS]:
    "Excel (.xlsx), CSV, TSV, PDF, Markdown ou TXT. Até 7 MB",
  [BULK_CAMPAIGNS_ANALYZING]: "Analisando {{fileName}}",
  [BULK_CAMPAIGNS_FILE_NOT_SUPPORTED]:
    "Este tipo de arquivo não é compatível. Use Excel (.xlsx), CSV, TSV, PDF, Markdown ou TXT.",
  [BULK_CAMPAIGNS_FILE_TOO_LARGE]:
    "O arquivo é muito grande. O tamanho máximo é 7 MB.",
  [BULK_CAMPAIGNS_EXTRACT_ERROR]:
    "Não conseguimos ler a estrutura deste arquivo. Tente novamente ou use outro arquivo.",
  [BULK_CAMPAIGNS_CONTENTS_LOAD_ERROR]:
    "Não foi possível carregar os conteúdos. Tente novamente.",
  [BULK_CAMPAIGNS_NO_CAMPAIGNS_FOUND]:
    "Não encontramos nenhuma estrutura de campanha neste arquivo.",
  [BULK_CAMPAIGNS_CHOOSE_ANOTHER_FILE]: "Escolher outro arquivo",
  [CAMPAIGN_AGENT_WELCOME_TITLE]:
    "Posso aplicar alterações na sua campanha por você",
  [CAMPAIGN_AGENT_WELCOME_SUBTITLE]:
    "Peça uma melhoria, revise o que eu proponho e aplique com um clique. Nada é publicado até você decidir.",
  [CAMPAIGN_AGENT_STEP_ASK]: "Peça",
  [CAMPAIGN_AGENT_STEP_REVIEW]: "Revise",
  [CAMPAIGN_AGENT_STEP_APPLY]: "Aplique",
  [CAMPAIGN_AGENT_WELCOME_HINT]:
    "Você também pode escrever a alteração que deseja, por exemplo: “Altere a idade do público para 25 a 45 anos”.",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER]: "Peça uma alteração para sua campanha",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_1]:
    "Aumente em 20% o orçamento da campanha",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_2]:
    "Reescreva os textos incluindo a promoção de 20% de desconto",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_3]:
    "Escreva títulos mais curtos e diretos para os meus anúncios",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_4]:
    "Mude o público para pessoas de 25 a 40 anos",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_5]:
    "Mude o CTA de todos os anúncios para “Comprar agora”",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_6]:
    "Adicione interesses de fitness e vida saudável ao público",
  [CAMPAIGN_AGENT_CARD_LEARNINGS_TITLE]:
    "Analise resultados e proponha ajustes",
  [CAMPAIGN_AGENT_CARD_LEARNINGS_DESCRIPTION]:
    "Identifico o que funciona e preparo alterações",
  [CAMPAIGN_AGENT_CARD_LEARNINGS_QUESTION]:
    "Analise os resultados da minha campanha e prepare alterações concretas que você possa aplicar.",
  [CAMPAIGN_AGENT_CARD_IMPROVE_TITLE]: "Melhore minha campanha",
  [CAMPAIGN_AGENT_CARD_IMPROVE_DESCRIPTION]:
    "Reviso segmentação, textos e configuração",
  [CAMPAIGN_AGENT_CARD_IMPROVE_QUESTION]:
    "Revise minha campanha e prepare as alterações que mais podem melhorar os resultados.",
  [CAMPAIGN_AGENT_CARD_BUDGET_TITLE]: "Ajuste meu orçamento",
  [CAMPAIGN_AGENT_CARD_BUDGET_DESCRIPTION]:
    "Sugiro como distribuir melhor seu investimento",
  [CAMPAIGN_AGENT_CARD_BUDGET_QUESTION]:
    "Revise o orçamento da minha campanha e prepare as alterações para otimizá-lo.",
  [CAMPAIGN_AGENT_CARD_COPY_TITLE]: "Reescreva meus anúncios",
  [CAMPAIGN_AGENT_CARD_COPY_DESCRIPTION]:
    "Escrevo textos novos prontos para aplicar",
  [CAMPAIGN_AGENT_CARD_COPY_QUESTION]:
    "Escreva textos novos para os anúncios da minha campanha e deixe-os prontos para aplicar.",
  [CAMPAIGN_AGENT_IMPROVEMENTS_READY_ONE]: "1 melhoria pronta para aplicar",
  [CAMPAIGN_AGENT_IMPROVEMENTS_READY_MANY]:
    "{{count}} melhorias prontas para aplicar",
  [CAMPAIGN_AGENT_IMPROVEMENTS_READY_DESCRIPTION]:
    "Revise cada uma e aplique na sua campanha com um clique. Nada é publicado até você decidir.",
  [CAMPAIGN_AGENT_CHANGES_COUNT_ONE]: "1 alteração",
  [CAMPAIGN_AGENT_CHANGES_COUNT_MANY]: "{{count}} alterações",
  [CAMPAIGN_AGENT_CREATIVE_BADGE]: "Criativo",
  [CAMPAIGN_AGENT_SUMMARY_TITLE]: "O que vou alterar",
  [CAMPAIGN_AGENT_SUMMARY_NEW_VALUE]: "Novo valor: {{value}}",
  [CAMPAIGN_AGENT_SUMMARY_NEW_VALUES]: "{{count}} novos valores",
  [CAMPAIGN_AGENT_SUMMARY_ADD_ONE]: "Adiciona: {{value}}",
  [CAMPAIGN_AGENT_SUMMARY_ADD_MANY]: "Adiciona {{count}} itens",
  [CAMPAIGN_AGENT_SUMMARY_REMOVE_ONE]: "Remove: {{value}}",
  [CAMPAIGN_AGENT_SUMMARY_REMOVE_ITEM]: "Remove 1 item",
  [CAMPAIGN_AGENT_SUMMARY_REMOVE_MANY]: "Remove {{count}} itens",
  [CAMPAIGN_AGENT_SUMMARY_CREATE]: "Cria: {{name}}",
  [CAMPAIGN_AGENT_SUMMARY_CREATE_UNNAMED]: "Cria um novo",
  [CAMPAIGN_AGENT_SUMMARY_CREATIVE]:
    "Levo você ao anúncio para trocar a imagem ou o vídeo",
  [CAMPAIGN_AGENT_SUMMARY_MORE_ONE]: "+1 alteração a mais",
  [CAMPAIGN_AGENT_SUMMARY_MORE_MANY]: "+{{count}} alterações a mais",
  [CAMPAIGN_AGENT_SUMMARY_FOOTNOTE]:
    "Você verá o detalhe completo antes de aplicar.",
  [CAMPAIGN_AGENT_SUMMARY_CREATIVE_FOOTNOTE]:
    "Ao clicar, aplico as alterações e levo você ao anúncio para escolher o novo criativo.",
  [CAMPAIGN_AGENT_SUMMARY_MANUAL]:
    "Não posso aplicar esta alteração por você. Eu mostro como fazer.",
  [BUTTON_CAMPAIGN_AGENT_REVIEW_AND_APPLY]: "Revisar e aplicar",
  [BUTTON_CAMPAIGN_AGENT_APPLY_AND_OPEN_AD]: "Aplicar e ir ao anúncio",
  [BUTTON_CAMPAIGN_AGENT_VIEW_RECOMMENDATION]: "Ver recomendação",
  [BUTTON_CAMPAIGN_AGENT_VIEW_CHANGES]: "Ver Alterações",
  [CAMPAIGN_AGENT_APPLIED_BADGE]: "Aplicado",
  [CAMPAIGN_AGENT_APPLIED_CAPTION]:
    "Aplicado no editor. Publique as alterações para ativá-lo.",
  [CAMPAIGN_AGENT_DONE_CAPTION]: "Marcado como feito.",
  [CAMPAIGN_AGENT_DISCARDED_BADGE]: "Descartado",
  [CAMPAIGN_AGENT_DISCARDED_CAPTION]:
    "Você descartou esta melhoria. Nenhuma alteração foi aplicada.",
  [CAMPAIGN_AGENT_RESULT_APPLIED_TITLE]: "Alterações aplicadas na sua campanha",
  [CAMPAIGN_AGENT_RESULT_APPLIED_DESCRIPTION]:
    "Apliquei “{{title}}” no editor. Para que apareça nos seus anúncios, publique as alterações.",
  [CAMPAIGN_AGENT_RESULT_PARTIAL_TITLE]: "Apliquei parte das alterações",
  [CAMPAIGN_AGENT_RESULT_PARTIAL_DESCRIPTION]:
    "Apliquei {{applied}} de {{total}} alterações de “{{title}}”. Revise as demais no editor ou peça uma alternativa. Lembre-se de publicar as alterações.",
  [CAMPAIGN_AGENT_RESULT_FAILED_TITLE]: "Não consegui aplicar as alterações",
  [CAMPAIGN_AGENT_RESULT_FAILED_DESCRIPTION]:
    "Algo impediu aplicar “{{title}}” na sua campanha. Nenhuma alteração foi feita. Posso sugerir uma alternativa.",
  [CAMPAIGN_AGENT_RESULT_CREATIVE_TITLE]: "Levei você ao anúncio",
  [CAMPAIGN_AGENT_RESULT_CREATIVE_DESCRIPTION]:
    "Escolha ou gere o novo criativo para “{{title}}” na pré-visualização do anúncio. Depois publique as alterações.",
  [BUTTON_CAMPAIGN_AGENT_GO_TO_PUBLISH]: "Ir para publicar",
  [BUTTON_CAMPAIGN_AGENT_NEXT_IMPROVEMENT]: "Ver próxima melhoria",
  [BUTTON_CAMPAIGN_AGENT_ASK_ALTERNATIVE]: "Pedir uma alternativa",
  [CAMPAIGN_AGENT_ASK_ALTERNATIVE_MESSAGE]:
    "Não foi possível aplicar “{{title}}” na minha campanha. Sugira uma alternativa que você consiga aplicar.",
  [CAMPAIGN_AGENT_FOLLOW_UP_MORE_TITLE]: "O que mais posso melhorar?",
  [CAMPAIGN_AGENT_FOLLOW_UP_MORE_MESSAGE]:
    "Que outra alteração você recomenda aplicar nesta campanha?",
  [CAMPAIGN_AGENT_FOLLOW_UP_BUDGET_TITLE]: "Ajustar orçamento",
  [CAMPAIGN_AGENT_FOLLOW_UP_COPY_TITLE]: "Melhorar textos",
  [CAMPAIGN_AGENT_BUTTON_TOOLTIP]:
    "Peça ao agente alterações para sua campanha",
  [CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_ONE]:
    "Você tem 1 melhoria pronta para aplicar",
  [CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_MANY]:
    "Você tem {{count}} melhorias prontas para aplicar",
  [PAYWALL_INSUFFICIENT_CREDITS_TITLE]: "Seus créditos acabaram!",
  [PAYWALL_INSUFFICIENT_CREDITS_SUBTITLE]:
    "Você não pode executar mais ações no momento.",
  [PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_TITLE]: "Melhore seu plano",
  [PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_DESCRIPTION]:
    "Acesse mais créditos e mais recursos melhorando seu plano.",
  [PAYWALL_INSUFFICIENT_CREDITS_BUY_TITLE]: "Ou compre créditos",
  [PAYWALL_INSUFFICIENT_CREDITS_BUY_DESCRIPTION]:
    "Se você só precisa de um impulso, escolha um pacote de créditos.",
  [PAYWALL_INSUFFICIENT_CREDITS_ARIA_LABEL]:
    "Créditos esgotados: melhore seu plano ou compre créditos",
  [BULK_CAMPAIGNS_CONTENTS_COUNTER]: "{{count}}/{{limit}}",
  [BULK_PLATFORM_GOOGLE]: "Google",
  [BULK_PLATFORM_META]: "Meta",
  [BULK_PLATFORM_TIKTOK]: "TikTok",
  [BULK_PLATFORM_LINKEDIN]: "LinkedIn",
  [BULK_FIELD_INSTAGRAM]: "Instagram",
  [BULK_CAMPAIGNS_EMPTY_FILE]:
    "O arquivo está vazio. Escolha um arquivo com conteúdo.",
  [BULK_CAMPAIGNS_TOO_MANY_CONTENTS]:
    "Você pode selecionar até {{limit}} conteúdos.",
  [BULK_CAMPAIGNS_ANALYZE]: "Analisar",
  [BULK_CAMPAIGNS_CANCEL_ANALYSIS]: "Cancelar análise",
  [BULK_CAMPAIGNS_STALE]:
    "Você mudou o arquivo ou os conteúdos. A análise anterior não vale mais. Analise de novo.",
  [BULK_CAMPAIGNS_SELECT_CONTENTS]: "Selecionar conteúdos",
  [BULK_CAMPAIGNS_CONTENTS_HINT]:
    "Se a plataforma precisa de criativos e você não escolhe nenhum, os anúncios são criados vazios.",
  [BULK_CAMPAIGNS_REMOVE_CONTENT]: "Remover conteúdo",
  [BULK_CAMPAIGNS_FILE_READY]: "{{fileName}} ({{size}})",
  [BULK_CAMPAIGNS_REPLACE_FILE]: "Solte outro arquivo para substituí-lo.",
  [BULK_CAMPAIGNS_RESULT_CREATED]: "Campanhas criadas: {{count}}",
  [BULK_CAMPAIGNS_RESULT_FAILED]: "Campanhas que não foram criadas: {{count}}",
  [BULK_CAMPAIGNS_RESULT_CLEARED]: "Referências limpas: {{count}}",
  [BULK_CAMPAIGNS_RESULT_CLEARED_DETAIL]:
    "Removemos {{field}} da campanha {{campaign}}.",
  [BULK_CAMPAIGNS_RESULT_TITLE]: "Resultado",
  [BULK_CAMPAIGNS_VIEW_CAMPAIGNS]: "Ver campanhas",
  [`${BULK_CAMPAIGNS_SUMMARY_COUNT}_one`]:
    "Encontramos {{count}} campanha para gerar.",
  [BULK_CAMPAIGNS_SUMMARY_COUNT]: "Encontramos {{count}} campanhas para gerar.",
  [BULK_CAMPAIGNS_ACCOUNTS_UNAVAILABLE]:
    "Não há contas de anúncios disponíveis para criar estas campanhas. Nenhum rascunho foi criado e nenhum crédito foi usado.",
  [BULK_FIELD_PRIMARY_TEXT]: "Texto principal",
  [BULK_FIELD_HEADLINE]: "Título",
  [BULK_FIELD_LONG_HEADLINE]: "Título longo",
  [BULK_FIELD_SEARCH_THEME]: "Tema de pesquisa",
  [BULK_FIELD_CALL_TO_ACTION]: "Chamada para ação",
  [BULK_FIELD_TITLES]: "Títulos",
  [BULK_FIELD_HEADLINES]: "Títulos",
  [BULK_FIELD_LONG_HEADLINES]: "Títulos longos",
  [BULK_FIELD_DESCRIPTIONS]: "Descrições",
  [BULK_FIELD_KEYWORDS]: "Palavras-chave",
  [BULK_FIELD_KEYWORDS_NEGATIVE]: "Palavras-chave negativas",
  [BULK_FIELD_DESTINATION_URL]: "URL de destino",
  [BULK_FIELD_DAILY_BUDGET]: "Orçamento diário",
  [BULK_FIELD_LANGUAGE]: "Idioma",
  [BULK_FIELD_OBJECTIVE]: "Objetivo",
  [BULK_FIELD_SEARCH_THEMES]: "Temas de pesquisa",
  [BULK_FIELD_CALLOUTS]: "Frases de destaque",
  [BULK_FIELD_AUDIENCE]: "Público",
  [BULK_FIELD_PAGE]: "Página",
  [BULK_FIELD_IDENTITY]: "Identidade",
  [BULK_FIELD_APP]: "Aplicativo",
  [BULK_FIELD_APP_STORE]: "Loja de aplicativos",
  [BULK_FIELD_AD_FORMAT]: "Formato do anúncio",
  [BULK_FIELD_ACCOUNT]: "Conta de anúncios",
  [BULK_FIELD_MERCHANT]: "Merchant Center",
  [BULK_FIELD_LOCATIONS]: "Localizações",
  [TIKTOK_INDUSTRY_22102000000]: "Roupas e acessórios / Bolsas",
  [TIKTOK_INDUSTRY_22101000000]:
    "Roupas e acessórios / Acessórios de vestuário",
  [TIKTOK_INDUSTRY_22107000000]: "Roupas e acessórios / Joias de alto padrão",
  [TIKTOK_INDUSTRY_22108000000]: "Roupas e acessórios / Roupas masculinas",
  [TIKTOK_INDUSTRY_22109000000]: "Roupas e acessórios / Calçados masculinos",
  [TIKTOK_INDUSTRY_22106000000]: "Roupas e acessórios / Joias",
  [TIKTOK_INDUSTRY_22999000000]: "Roupas e acessórios / Outros",
  [TIKTOK_INDUSTRY_22112000000]:
    "Roupas e acessórios / Roupas tradicionais e cerimoniais",
  [TIKTOK_INDUSTRY_22105000000]: "Roupas e acessórios / Relógios",
  [TIKTOK_INDUSTRY_22113000000]: "Roupas e acessórios / Dispositivos vestíveis",
  [TIKTOK_INDUSTRY_22110000000]: "Roupas e acessórios / Roupas femininas",
  [TIKTOK_INDUSTRY_22111000000]: "Roupas e acessórios / Calçados femininos",
  [TIKTOK_INDUSTRY_16105000000]: "Eletrodomésticos / Dispositivos digitais",
  [TIKTOK_INDUSTRY_16104000000]: "Eletrodomésticos / Eletrodomésticos",
  [TIKTOK_INDUSTRY_16101000000]: "Eletrodomésticos / Cozinha e banheiro",
  [TIKTOK_INDUSTRY_16102000000]: "Eletrodomésticos / Linha branca",
  [TIKTOK_INDUSTRY_16999000000]: "Eletrodomésticos / Outros",
  [TIKTOK_INDUSTRY_16100000000]: "Eletrodomésticos / Cuidados pessoais",
  [TIKTOK_INDUSTRY_20101000000]: "Apps / Reprodutores de áudio e vídeo",
  [TIKTOK_INDUSTRY_20110000000]: "Apps / Negócios e produtividade",
  [TIKTOK_INDUSTRY_20104000000]: "Apps / Educação",
  [TIKTOK_INDUSTRY_20106000000]: "Apps / Serviços financeiros",
  [TIKTOK_INDUSTRY_20109000000]: "Apps / Saúde e fitness",
  [TIKTOK_INDUSTRY_20107000000]: "Apps / Vida e lazer",
  [TIKTOK_INDUSTRY_20102000000]: "Apps / Notícias e leitura",
  [TIKTOK_INDUSTRY_20105000000]: "Apps / Compras online",
  [TIKTOK_INDUSTRY_20999000000]: "Apps / Outros apps",
  [TIKTOK_INDUSTRY_20111000000]: "Apps / Parentalidade",
  [TIKTOK_INDUSTRY_20103000000]: "Apps / Fotografia",
  [TIKTOK_INDUSTRY_20100000000]: "Apps / Redes sociais",
  [TIKTOK_INDUSTRY_20108000000]: "Apps / Viagens",
  [TIKTOK_INDUSTRY_20112000000]: "Apps / Utilitários",
  [TIKTOK_INDUSTRY_12104000000]:
    "Bebês, crianças e maternidade / Roupa de cama para bebê",
  [TIKTOK_INDUSTRY_12108000000]:
    "Bebês, crianças e maternidade / Artigos de alimentação",
  [TIKTOK_INDUSTRY_12100000000]:
    "Bebês, crianças e maternidade / Comida para bebê",
  [TIKTOK_INDUSTRY_12102000000]:
    "Bebês, crianças e maternidade / Fórmula infantil",
  [TIKTOK_INDUSTRY_12110000000]:
    "Bebês, crianças e maternidade / Higiene do bebê",
  [TIKTOK_INDUSTRY_12105000000]:
    "Bebês, crianças e maternidade / Calçados de bebê",
  [TIKTOK_INDUSTRY_12107000000]: "Bebês, crianças e maternidade / Cadeirinhas",
  [TIKTOK_INDUSTRY_12109000000]:
    "Bebês, crianças e maternidade / Roupas infantis",
  [TIKTOK_INDUSTRY_12103000000]:
    "Bebês, crianças e maternidade / Fraldas e lenços",
  [TIKTOK_INDUSTRY_12999000000]: "Bebês, crianças e maternidade / Outros",
  [TIKTOK_INDUSTRY_12101000000]:
    "Bebês, crianças e maternidade / Carrinhos e berços",
  [TIKTOK_INDUSTRY_12106000000]: "Bebês, crianças e maternidade / Brinquedos",
  [TIKTOK_INDUSTRY_14105000000]:
    "Beleza e cuidados pessoais / Medicina estética",
  [TIKTOK_INDUSTRY_14104000000]: "Beleza e cuidados pessoais / Cosméticos",
  [TIKTOK_INDUSTRY_14107000000]:
    "Beleza e cuidados pessoais / Cuidados femininos",
  [TIKTOK_INDUSTRY_14106000000]:
    "Beleza e cuidados pessoais / Fragrâncias e perfumes",
  [TIKTOK_INDUSTRY_14101000000]:
    "Beleza e cuidados pessoais / Cuidados com o cabelo",
  [TIKTOK_INDUSTRY_14100000000]: "Beleza e cuidados pessoais / Higiene bucal",
  [TIKTOK_INDUSTRY_14999000000]: "Beleza e cuidados pessoais / Outros",
  [TIKTOK_INDUSTRY_14103000000]:
    "Beleza e cuidados pessoais / Cuidados com a pele",
  [TIKTOK_INDUSTRY_14102000000]:
    "Beleza e cuidados pessoais / Perucas e penteados",
  [TIKTOK_INDUSTRY_24108000000]:
    "Serviços empresariais / Agricultura, silvicultura, pecuária e pesca",
  [TIKTOK_INDUSTRY_24118000000]: "Serviços empresariais / Leilões",
  [TIKTOK_INDUSTRY_24105000000]: "Serviços empresariais / Materiais químicos",
  [TIKTOK_INDUSTRY_24103000000]:
    "Serviços empresariais / Engenharia de construção",
  [TIKTOK_INDUSTRY_24104000000]:
    "Serviços empresariais / Eletrônica e elétrica",
  [TIKTOK_INDUSTRY_24109000000]:
    "Serviços empresariais / Eficiência energética e meio ambiente",
  [TIKTOK_INDUSTRY_24114000000]: "Serviços empresariais / Exposições",
  [TIKTOK_INDUSTRY_24107000000]: "Serviços empresariais / Franquias",
  [TIKTOK_INDUSTRY_24120000000]:
    "Serviços empresariais / Empreendedorismo individual",
  [TIKTOK_INDUSTRY_24119000000]:
    "Serviços empresariais / Planejamento e gestão de investimentos",
  [TIKTOK_INDUSTRY_24116000000]: "Serviços empresariais / Serviços de TI",
  [TIKTOK_INDUSTRY_24117000000]: "Serviços empresariais / Serviços jurídicos",
  [TIKTOK_INDUSTRY_24111000000]: "Serviços empresariais / Logística",
  [TIKTOK_INDUSTRY_24106000000]:
    "Serviços empresariais / Máquinas e equipamentos",
  [TIKTOK_INDUSTRY_24112000000]:
    "Serviços empresariais / Marketing e publicidade",
  [TIKTOK_INDUSTRY_24101000000]:
    "Serviços empresariais / Equipamentos e suprimentos de escritório",
  [TIKTOK_INDUSTRY_24999000000]: "Serviços empresariais / Outros",
  [TIKTOK_INDUSTRY_24113000000]:
    "Serviços empresariais / Consultoria profissional",
  [TIKTOK_INDUSTRY_24100000000]: "Serviços empresariais / Imóveis e aluguel",
  [TIKTOK_INDUSTRY_24102000000]:
    "Serviços empresariais / Recrutamento e busca de emprego",
  [TIKTOK_INDUSTRY_24110000000]: "Serviços empresariais / Segurança",
  [TIKTOK_INDUSTRY_24115000000]:
    "Serviços empresariais / Terceirização de serviços",
  [TIKTOK_INDUSTRY_30100000000]:
    "Comércio eletrônico (não app) / Grandes varejistas",
  [TIKTOK_INDUSTRY_30102000000]:
    "Comércio eletrônico (não app) / Grandes plataformas",
  [TIKTOK_INDUSTRY_30101000000]:
    "Comércio eletrônico (não app) / Plataformas pequenas e médias",
  [TIKTOK_INDUSTRY_10100000000]: "Educação / Primeira infância e pré-escola",
  [TIKTOK_INDUSTRY_10102000000]: "Educação / Ensino superior",
  [TIKTOK_INDUSTRY_10105000000]: "Educação / Idiomas",
  [TIKTOK_INDUSTRY_10106000000]: "Educação / Formação não acadêmica (hobbies)",
  [TIKTOK_INDUSTRY_10999000000]: "Educação / Outra educação",
  [TIKTOK_INDUSTRY_10103000000]: "Educação / Educação no exterior",
  [TIKTOK_INDUSTRY_10101000000]: "Educação / Ensino fundamental, médio e K-12",
  [TIKTOK_INDUSTRY_10104000000]: "Educação / Formação profissional",
  [TIKTOK_INDUSTRY_13100000000]: "Serviços financeiros / Bancos comerciais",
  [TIKTOK_INDUSTRY_13108000000]: "Serviços financeiros / Birôs de crédito",
  [TIKTOK_INDUSTRY_13117000000]: "Serviços financeiros / Cartões de crédito",
  [TIKTOK_INDUSTRY_13115000000]:
    "Serviços financeiros / Financiamento coletivo",
  [TIKTOK_INDUSTRY_13116000000]: "Serviços financeiros / Criptomoedas",
  [TIKTOK_INDUSTRY_13112000000]: "Serviços financeiros / Câmbio",
  [TIKTOK_INDUSTRY_13107000000]: "Serviços financeiros / Fundos",
  [TIKTOK_INDUSTRY_13104000000]: "Serviços financeiros / Garantias",
  [TIKTOK_INDUSTRY_13102000000]: "Serviços financeiros / Seguros",
  [TIKTOK_INDUSTRY_13110000000]:
    "Serviços financeiros / Consultoria de investimentos",
  [TIKTOK_INDUSTRY_13111000000]: "Serviços financeiros / Empréstimos",
  [TIKTOK_INDUSTRY_13109000000]: "Serviços financeiros / Microfinanças",
  [TIKTOK_INDUSTRY_13999000000]: "Serviços financeiros / Outros",
  [TIKTOK_INDUSTRY_13105000000]: "Serviços financeiros / Casas de penhor",
  [TIKTOK_INDUSTRY_13113000000]: "Serviços financeiros / Metais preciosos",
  [TIKTOK_INDUSTRY_13101000000]: "Serviços financeiros / Valores mobiliários",
  [TIKTOK_INDUSTRY_13114000000]:
    "Serviços financeiros / Pagamentos de terceiros",
  [TIKTOK_INDUSTRY_1310300000]: "Serviços financeiros / Fundos fiduciários",
  [TIKTOK_INDUSTRY_27103000000]: "Alimentos e bebidas / Bebidas alcoólicas",
  [TIKTOK_INDUSTRY_27104000000]: "Alimentos e bebidas / Culinária e receitas",
  [TIKTOK_INDUSTRY_27100000000]: "Alimentos e bebidas / Gastronomia",
  [TIKTOK_INDUSTRY_27101000000]:
    "Alimentos e bebidas / Alimentos e produtos frescos",
  [TIKTOK_INDUSTRY_27102000000]: "Alimentos e bebidas / Bebidas não alcoólicas",
  [TIKTOK_INDUSTRY_27999000000]: "Alimentos e bebidas / Outros",
  [TIKTOK_INDUSTRY_25301000000]: "Jogos / Ação",
  [TIKTOK_INDUSTRY_25302000000]: "Jogos / Cassino",
  [TIKTOK_INDUSTRY_25300000000]: "Jogos / Hipercasual",
  [TIKTOK_INDUSTRY_25313000000]: "Jogos / Infantis",
  [TIKTOK_INDUSTRY_25303000000]: "Jogos / Match",
  [TIKTOK_INDUSTRY_25999000000]: "Jogos / Outros",
  [TIKTOK_INDUSTRY_25311000000]: "Jogos / Festa",
  [TIKTOK_INDUSTRY_25304000000]: "Jogos / Quebra-cabeça",
  [TIKTOK_INDUSTRY_25305000000]: "Jogos / Corrida",
  [TIKTOK_INDUSTRY_25306000000]: "Jogos / RPG",
  [TIKTOK_INDUSTRY_25307000000]: "Jogos / Tiro",
  [TIKTOK_INDUSTRY_25308000000]: "Jogos / Simulação",
  [TIKTOK_INDUSTRY_25309000000]: "Jogos / Esportes",
  [TIKTOK_INDUSTRY_25310000000]: "Jogos / Estratégia",
  [TIKTOK_INDUSTRY_25312000000]: "Jogos / Tabuleiro",
  [TIKTOK_INDUSTRY_29102000000]: "Saúde / Suplementos",
  [TIKTOK_INDUSTRY_29101000000]: "Saúde / Informação médica",
  [TIKTOK_INDUSTRY_29100000000]: "Saúde / Serviços médicos",
  [TIKTOK_INDUSTRY_29103000000]: "Saúde / Medicamentos",
  [TIKTOK_INDUSTRY_29999000000]: "Saúde / Outra saúde",
  [TIKTOK_INDUSTRY_21102000000]:
    "Melhorias para a casa / Materiais de construção e iluminação",
  [TIKTOK_INDUSTRY_21101000000]: "Melhorias para a casa / Móveis",
  [TIKTOK_INDUSTRY_21103000000]: "Melhorias para a casa / Ferragens e elétrica",
  [TIKTOK_INDUSTRY_21104000000]: "Melhorias para a casa / Decoração",
  [TIKTOK_INDUSTRY_21100000000]: "Melhorias para a casa / Design de interiores",
  [TIKTOK_INDUSTRY_21999000000]: "Melhorias para a casa / Outros",
  [TIKTOK_INDUSTRY_21105000000]:
    "Melhorias para a casa / Filtros de linha e tomadas",
  [TIKTOK_INDUSTRY_18106000000]: "Produtos para o lar / Aparelhos de limpeza",
  [TIKTOK_INDUSTRY_18110000000]: "Produtos para o lar / Artigos de limpeza",
  [TIKTOK_INDUSTRY_18104000000]: "Produtos para o lar / Acessórios de café",
  [TIKTOK_INDUSTRY_18101000000]:
    "Produtos para o lar / Essenciais do dia a dia",
  [TIKTOK_INDUSTRY_18102000000]: "Produtos para o lar / Copos e taças",
  [TIKTOK_INDUSTRY_18105000000]: "Produtos para o lar / Acessórios de cozinha",
  [TIKTOK_INDUSTRY_18108000000]: "Produtos para o lar / Lavanderia",
  [TIKTOK_INDUSTRY_18109000000]: "Produtos para o lar / Cuidados com couro",
  [TIKTOK_INDUSTRY_18999000000]: "Produtos para o lar / Outros",
  [TIKTOK_INDUSTRY_18112000000]: "Produtos para o lar / Controle de pragas",
  [TIKTOK_INDUSTRY_18100000000]: "Produtos para o lar / Armazenamento",
  [TIKTOK_INDUSTRY_18103000000]: "Produtos para o lar / Jogos de chá",
  [TIKTOK_INDUSTRY_18107000000]: "Produtos para o lar / Lenços e toalhitas",
  [TIKTOK_INDUSTRY_18111000000]: "Produtos para o lar / Brinquedos",
  [TIKTOK_INDUSTRY_26114000000]:
    "Serviços do dia a dia / Beleza e cuidados pessoais",
  [TIKTOK_INDUSTRY_26112000000]:
    "Serviços do dia a dia / Serviços ao consumidor",
  [TIKTOK_INDUSTRY_26102000000]:
    "Serviços do dia a dia / Namoro e relacionamentos",
  [TIKTOK_INDUSTRY_26113000000]: "Serviços do dia a dia / Exercício e fitness",
  [TIKTOK_INDUSTRY_26108000000]: "Serviços do dia a dia / Jardinagem",
  [TIKTOK_INDUSTRY_26104000000]: "Serviços do dia a dia / Presentes e flores",
  [TIKTOK_INDUSTRY_26105000000]: "Serviços do dia a dia / Limpeza doméstica",
  [TIKTOK_INDUSTRY_26111000000]: "Serviços do dia a dia / Serviços de internet",
  [TIKTOK_INDUSTRY_26999000000]: "Serviços do dia a dia / Outros",
  [TIKTOK_INDUSTRY_26101000000]: "Serviços do dia a dia / Fotografia",
  [TIKTOK_INDUSTRY_26106000000]: "Serviços do dia a dia / Compras",
  [TIKTOK_INDUSTRY_26107000000]: "Serviços do dia a dia / Venda de usados",
  [TIKTOK_INDUSTRY_26109000000]: "Serviços do dia a dia / Pagamento de contas",
  [TIKTOK_INDUSTRY_26103000000]:
    "Serviços do dia a dia / Celebrações de casamento",
  [TIKTOK_INDUSTRY_26100000000]:
    "Serviços do dia a dia / Fotografia de casamento",
  [TIKTOK_INDUSTRY_23113000000]: "Notícias e entretenimento / Anime",
  [TIKTOK_INDUSTRY_23114000000]: "Notícias e entretenimento / Astrologia",
  [TIKTOK_INDUSTRY_23122000000]:
    "Notícias e entretenimento / Beleza e cuidados pessoais",
  [TIKTOK_INDUSTRY_23102000000]:
    "Notícias e entretenimento / Negócios e economia",
  [TIKTOK_INDUSTRY_23126000000]:
    "Notícias e entretenimento / Informação automotiva",
  [TIKTOK_INDUSTRY_23108000000]:
    "Notícias e entretenimento / Celebridades e fofocas",
  [TIKTOK_INDUSTRY_23105000000]:
    "Notícias e entretenimento / Caridade e bem-estar público",
  [TIKTOK_INDUSTRY_23111000000]:
    "Notícias e entretenimento / Colecionáveis e antiguidades",
  [TIKTOK_INDUSTRY_23116000000]: "Notícias e entretenimento / Cultura e arte",
  [TIKTOK_INDUSTRY_23104000000]:
    "Notícias e entretenimento / Cultura e história",
  [TIKTOK_INDUSTRY_23128000000]:
    "Notícias e entretenimento / Informação de comércio eletrônico",
  [TIKTOK_INDUSTRY_23107000000]: "Notícias e entretenimento / Meio ambiente",
  [TIKTOK_INDUSTRY_23124000000]:
    "Notícias e entretenimento / Comida e culinária",
  [TIKTOK_INDUSTRY_23125000000]:
    "Notícias e entretenimento / Jogos e software utilitário",
  [TIKTOK_INDUSTRY_23127000000]: "Notícias e entretenimento / Informação geral",
  [TIKTOK_INDUSTRY_23115000000]: "Notícias e entretenimento / Humor",
  [TIKTOK_INDUSTRY_23106000000]: "Notícias e entretenimento / Direito",
  [TIKTOK_INDUSTRY_23109000000]: "Notícias e entretenimento / Estilo de vida",
  [TIKTOK_INDUSTRY_23110000000]: "Notícias e entretenimento / Eventos ao vivo",
  [TIKTOK_INDUSTRY_23100000000]: "Notícias e entretenimento / Militar",
  [TIKTOK_INDUSTRY_23119000000]: "Notícias e entretenimento / Filmes",
  [TIKTOK_INDUSTRY_23999000000]: "Notícias e entretenimento / Outros",
  [TIKTOK_INDUSTRY_23129000000]:
    "Notícias e entretenimento / Informação sobre pets",
  [TIKTOK_INDUSTRY_23101000000]: "Notícias e entretenimento / Política",
  [TIKTOK_INDUSTRY_23118000000]: "Notícias e entretenimento / Leitura",
  [TIKTOK_INDUSTRY_23130000000]:
    "Notícias e entretenimento / Informação imobiliária",
  [TIKTOK_INDUSTRY_23131000000]: "Notícias e entretenimento / Relacionamentos",
  [TIKTOK_INDUSTRY_23103000000]:
    "Notícias e entretenimento / Ciência e tecnologia",
  [TIKTOK_INDUSTRY_23134000000]:
    "Notícias e entretenimento / Promoção de contas em redes",
  [TIKTOK_INDUSTRY_23123000000]:
    "Notícias e entretenimento / Esportes e fitness",
  [TIKTOK_INDUSTRY_23132000000]:
    "Notícias e entretenimento / Sites de streaming",
  [TIKTOK_INDUSTRY_23133000000]:
    "Notícias e entretenimento / Informação turística",
  [TIKTOK_INDUSTRY_23112000000]:
    "Notícias e entretenimento / Séries e dramas de TV",
  [TIKTOK_INDUSTRY_23117000000]:
    "Notícias e entretenimento / Programas de variedades",
  [TIKTOK_INDUSTRY_19999000000]: "Pets / Outros",
  [TIKTOK_INDUSTRY_19103000000]: "Pets / Estética",
  [TIKTOK_INDUSTRY_19101000000]: "Pets / Saúde",
  [TIKTOK_INDUSTRY_19102000000]: "Pets / Produtos para o lar",
  [TIKTOK_INDUSTRY_19105000000]: "Pets / Brinquedos",
  [TIKTOK_INDUSTRY_19106000000]: "Pets / Acessórios de viagem",
  [TIKTOK_INDUSTRY_19104000000]: "Pets / Petiscos",
  [TIKTOK_INDUSTRY_19100000000]: "Pets / Ração",
  [TIKTOK_INDUSTRY_28100000000]: "Esportes e ar livre / Equipamento outdoor",
  [TIKTOK_INDUSTRY_28101000000]:
    "Esportes e ar livre / Esportes e equipamentos",
  [TIKTOK_INDUSTRY_15100000000]: "Tecnologia e eletrônicos / Celulares",
  [TIKTOK_INDUSTRY_15105000000]:
    "Tecnologia e eletrônicos / Acessórios de computador",
  [TIKTOK_INDUSTRY_15103000000]:
    "Tecnologia e eletrônicos / Conserto de computadores",
  [TIKTOK_INDUSTRY_15101000000]: "Tecnologia e eletrônicos / Computadores",
  [TIKTOK_INDUSTRY_15102000000]:
    "Tecnologia e eletrônicos / Componentes de computador",
  [TIKTOK_INDUSTRY_15104000000]:
    "Tecnologia e eletrônicos / Dispositivos de jogos",
  [TIKTOK_INDUSTRY_15106000000]: "Tecnologia e eletrônicos / Produtos de rede",
  [TIKTOK_INDUSTRY_15107000000]:
    "Tecnologia e eletrônicos / Equipamentos de escritório",
  [TIKTOK_INDUSTRY_15999000000]: "Tecnologia e eletrônicos / Outros",
  [TIKTOK_INDUSTRY_17103000000]: "Viagens / Hotéis e hospedagem",
  [TIKTOK_INDUSTRY_17999000000]: "Viagens / Outros",
  [TIKTOK_INDUSTRY_17105000000]: "Viagens / Passeios e atrações",
  [TIKTOK_INDUSTRY_17106000000]: "Viagens / Agências e serviços de viagem",
  [TIKTOK_INDUSTRY_11111000000]:
    "Veículos e transporte / Acessórios para veículos de 2 e 3 rodas",
  [TIKTOK_INDUSTRY_11110000000]: "Veículos e transporte / Aviões",
  [TIKTOK_INDUSTRY_11101000000]:
    "Veículos e transporte / Acessórios automotivos",
  [TIKTOK_INDUSTRY_11103000000]: "Veículos e transporte / Peças automotivas",
  [TIKTOK_INDUSTRY_11102000000]: "Veículos e transporte / Serviços automotivos",
  [TIKTOK_INDUSTRY_11100000000]: "Veículos e transporte / Automóveis",
  [TIKTOK_INDUSTRY_11107000000]: "Veículos e transporte / Bicicletas",
  [TIKTOK_INDUSTRY_11112000000]: "Veículos e transporte / Concessionárias",
  [TIKTOK_INDUSTRY_11104000000]: "Veículos e transporte / Aluguel de carros",
  [TIKTOK_INDUSTRY_11108000000]: "Veículos e transporte / Patinetes elétricos",
  [TIKTOK_INDUSTRY_11106000000]: "Veículos e transporte / Motos",
  [TIKTOK_INDUSTRY_11999000000]: "Veículos e transporte / Outros",
  [TIKTOK_INDUSTRY_11105000000]: "Veículos e transporte / Carros usados",
  [TIKTOK_INDUSTRY_11109000000]: "Veículos e transporte / Veículos aquáticos",
  [META_ATTRIBUTION_WINDOW_TITLE]: "Janela de atribuição",
  [META_ATTRIBUTION_WINDOW_DESCRIPTION]:
    "Quantos dias depois de um clique ou de ver o anúncio a Meta atribui uma conversão a este conjunto de anúncios.",
  [META_ATTRIBUTION_WINDOW_7D_CLICK_1D_VIEW]:
    "Clique de 7 dias + visualização de 1 dia",
  [META_ATTRIBUTION_WINDOW_7D_CLICK]: "Clique de 7 dias",
  [META_ATTRIBUTION_WINDOW_1D_CLICK_1D_VIEW]:
    "Clique de 1 dia + visualização de 1 dia",
  [META_ATTRIBUTION_WINDOW_1D_CLICK]: "Clique de 1 dia",
  [META_ATTRIBUTION_WINDOW_DEFAULT_OPTION]: "{{window}} (padrão)",
  [META_ATTRIBUTION_ENGAGED_VIEW_LABEL]:
    "Incluir visualização engajada de 1 dia (pessoas que interagiram com o anúncio ou assistiram pelo menos 5 segundos do vídeo)",
  [WHITE_LABEL_TITLE]: "White-label",
  [WHITE_LABEL_BUY]: "Comprar",
  [WHITE_LABEL_PRICE_PER_MONTH]: "{{price}}/mês",
  [WHITE_LABEL_DIALOG_BODY]:
    "Sua própria marca na plataforma: logo, cores, domínio e e-mails sem a marca Adle.",
  [WHITE_LABEL_NO_SETUP_FEE]: "Sem taxa de instalação. Cancele quando quiser.",
  [WHITE_LABEL_AFTER_PAYMENT]:
    "Após o pagamento você completa sua marca e nossa equipe a configura.",
  [WHITE_LABEL_APP_SUMO_CONFIRM]:
    "Esta compra é feita para toda a agência e cobrada mensalmente, separada da sua licença AppSumo. Continuar?",
  [WHITE_LABEL_ONLY_OWNER]: "Somente o dono da conta pode comprar.",
  [WHITE_LABEL_STATUS_PENDING_BRANDING]: "Complete sua marca",
  [WHITE_LABEL_STATUS_CONFIGURING]: "Em configuração",
  [WHITE_LABEL_STATUS_ACTIVE]: "Ativo",
  [WHITE_LABEL_STATUS_REVERT_PENDING]: "Cancelado",
  [WHITE_LABEL_ALREADY_ACTIVE]: "Já ativo",
  [WHITE_LABEL_COMPLETE_BRAND]: "Completar marca",
  [WHITE_LABEL_EDIT_BRAND]: "Editar marca",
  [WHITE_LABEL_FORM_TITLE]: "Configure sua marca",
  [WHITE_LABEL_FORM_INTRO]:
    "Personalize a identidade visual do seu espaço e como os usuários vão vê-lo.",
  [WHITE_LABEL_FORM_SECTION_GENERAL]: "01 · Informações gerais",
  [WHITE_LABEL_FORM_SECTION_VISUAL]: "02 · Identidade visual",
  [WHITE_LABEL_FORM_SECTION_VISUAL_HELP]:
    "Envie os recursos gráficos que a sua marca vai usar.",
  [WHITE_LABEL_FORM_SECTION_COLORS]: "03 · Paleta de cores",
  [WHITE_LABEL_FORM_SECTION_COLORS_HELP]:
    "Defina as cores que vão representar a sua marca.",
  [WHITE_LABEL_FORM_SECTION_DOMAIN]: "04 · Domínio e comentários",
  [WHITE_LABEL_FORM_BADGE_REQUIRED]: "Obrigatório",
  [WHITE_LABEL_FORM_BADGE_OPTIONAL]: "Opcional",
  [WHITE_LABEL_FORM_DROP_TITLE]: "Arraste o logo aqui",
  [WHITE_LABEL_FORM_DROP_HINT]: "Ou selecione um arquivo · PNG, JPG ou SVG",
  [WHITE_LABEL_FORM_INVALID_FILE]: "Arquivo inválido.",
  [WHITE_LABEL_FORM_DOMAIN_BLOCKED]: "Você não pode usar o domínio adle.ai.",
  [WHITE_LABEL_FORM_DOMAIN_INVALID]: "Domínio inválido.",
  [WHITE_LABEL_FORM_COLOR_INVALID]:
    "Use uma cor hexadecimal, por exemplo #1A2B3C.",
  [WHITE_LABEL_FORM_NAME_INVALID]: "O nome deve ter entre 2 e 60 caracteres.",
  [WHITE_LABEL_FORM_NOTES_INVALID]:
    "Os comentários não podem passar de 500 caracteres.",
  [WHITE_LABEL_FORM_LOGO_NAV_HELP]: "Para a barra esquerda.",
  [WHITE_LABEL_FORM_LOGO_LOGIN_HELP]: "Para a tela de login.",
  [WHITE_LABEL_FORM_FAVICON_CAPTION]: "Ícone do navegador",
  [WHITE_LABEL_FORM_FAVICON_HELP]: "Imagem que aparece na aba.",
  [WHITE_LABEL_FORM_NAME_PLACEHOLDER]: "Ex. Minha Agência Digital",
  [WHITE_LABEL_FORM_DOMAIN_PLACEHOLDER]: "app.suaagencia.com",
  [WHITE_LABEL_FORM_NOTES_PLACEHOLDER]:
    "Alguma instrução adicional sobre a sua marca?",
  [WHITE_LABEL_FORM_COLOR_PRIMARY]: "Principal",
  [WHITE_LABEL_FORM_COLOR_SECONDARY]: "Secundária",
  [WHITE_LABEL_FORM_COLOR_BUTTONS]: "Botões",
  [WHITE_LABEL_FORM_NAME_BUSINESS]: "Nome da sua empresa",
  [WHITE_LABEL_FORM_LOGO]: "Logo principal",
  [WHITE_LABEL_FORM_LOGO_NAVBAR]: "Logo de navegação",
  [WHITE_LABEL_FORM_LOGO_LOGIN]: "Logo de acesso",
  [WHITE_LABEL_FORM_FAVICON]: "Favicon",
  [WHITE_LABEL_FORM_PRIMARY_COLOR]: "Cor principal",
  [WHITE_LABEL_FORM_SECONDARY_COLOR]: "Cor secundária",
  [WHITE_LABEL_FORM_PRIMARY_BUTTON_COLOR]: "Cor dos botões (opcional)",
  [WHITE_LABEL_FORM_DESIRED_DOMAIN]: "Domínio desejado",
  [WHITE_LABEL_FORM_DOMAIN_HELP]:
    "Enviaremos por e-mail como apontar seu domínio.",
  [WHITE_LABEL_FORM_NOTES]: "Comentários para a equipe (Opcional)",
  [WHITE_LABEL_FORM_SUBMIT]: "Enviar marca",
  [WHITE_LABEL_FORM_SUBMITTED]:
    "Recebemos sua marca. Nossa equipe vai configurá-la e avisaremos você.",
  [WHITE_LABEL_CONFIRMING_PAYMENT]: "Confirmando seu pagamento…",
  [WHITE_LABEL_CHECKOUT_CANCELLED]:
    "Pagamento cancelado. Nenhuma cobrança foi feita.",
  [WHITE_LABEL_NOT_ELIGIBLE]:
    "Seu plano não permite comprar white-label. Fale conosco para um orçamento.",
  [WHITE_LABEL_ERROR_ALREADY_ACTIVE]:
    "O white-label já está ativo na sua conta.",
  [WHITE_LABEL_NOT_PURCHASED]: "Você precisa comprar o white-label primeiro.",
  [WHITE_LABEL_INVALID_BRANDING]: "Verifique o campo destacado.",
  [WHITE_LABEL_INVALID_TRANSITION]:
    "Esta mudança de status do white-label não é permitida.",
  [AGENCY_ACCOUNT_LINKING_PICKER_TITLE]: "Suas contas de anúncios conectadas",
  [AGENCY_ACCOUNT_LINKING_PICKER_SHEET_TITLE]:
    "Obtenha melhores resultados e uma análise mais profunda",
  [AGENCY_ACCOUNT_LINKING_PICKER_SHEET_DESCRIPTION]:
    "Permita que a Adle acesse suas contas de anúncios para analisar e otimizar suas campanhas. Os proprietários das contas de anúncios que você deseja conectar receberão um e-mail ou notificação informando que uma conexão foi estabelecida com {{NAME_BUSINESS}}.",
  [AGENCY_ACCOUNT_LINKING_CONSENT]:
    "Deixe a Adle acessar estas contas para analisar e otimizar suas campanhas",
  [AGENCY_ACCOUNT_LINKING_CONSENT_TOOLTIP]:
    "A Adle usa isso para revisar o desempenho e sugerir melhorias nas suas campanhas.",
  [AGENCY_ACCOUNT_LINKING_CONSENT_INFO]: "Mais informações",
  [AGENCY_ACCOUNT_LINKING_CARD_TITLE]:
    "Tenha resultados melhores e uma análise mais profunda.",
  [AGENCY_ACCOUNT_LINKING_CARD_BODY]:
    "Deixe a Adle acessar suas contas de anúncios para analisar e otimizar suas campanhas.",
  [AGENCY_ACCOUNT_LINKING_ENABLE]: "Ativar",
  [AGENCY_ACCOUNT_LINKING_NOT_NOW]: "Agora não",
  [AGENCY_ACCOUNT_LINKING_SHEET_TITLE]:
    "Escolha Quais Contas de Clientes Incluir",
  [AGENCY_ACCOUNT_LINKING_SHEET_DESCRIPTION]:
    "Os donos das contas de anúncios que você deseja conectar receberão um e-mail ou uma notificação de que uma conexão foi estabelecida com {{NAME_BUSINESS}}.",
  [AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_TITLE]: "Confirmar conexão",
  [AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_BODY]:
    "Os donos das contas de anúncios receberão um e-mail ou uma notificação avisando da conexão com {{NAME_BUSINESS}}.",
  [AGENCY_ACCOUNT_LINKING_CONFIRM]: "Confirmar ({{count}})",
  [AGENCY_ACCOUNT_LINKING_TOAST_DONE_ONE]:
    "Pronto, a Adle já pode ajudar a otimizar sua conta",
  [AGENCY_ACCOUNT_LINKING_TOAST_DONE_OTHER]:
    "Pronto, a Adle já pode ajudar a otimizar suas {{count}} contas",
  [AGENCY_ACCOUNT_LINKING_TOAST_PARTIAL]:
    "Pronto. A Adle pode ajudar a otimizar {{linked}} de {{total}} contas.",
  [AGENCY_ACCOUNT_LINKING_TOAST_LATER]:
    "Não conseguimos concluir isso agora. Você pode tentar de novo em instantes.",
  [AGENCY_ACCOUNT_LINKING_PLATFORM_META]: "Meta",
  [AGENCY_ACCOUNT_LINKING_PLATFORM_GOOGLE]: "Google Ads",
  [AGENCY_ACCOUNT_LINKING_PLATFORM_TIKTOK]: "TikTok",
  [AGENCY_ACCOUNT_LINKING_SHEET_LINKING]:
    "Vinculando contas, isso pode levar alguns segundos…",
  [AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_TITLE]:
    "Algumas contas não foram vinculadas",
  [AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_BODY]:
    "Vinculamos {{linked}} de {{total}}. Revise cada conta e siga o passo indicado.",
  [AGENCY_ACCOUNT_LINKING_SHEET_FAILED_TITLE]:
    "Não conseguimos vincular estas contas",
  [AGENCY_ACCOUNT_LINKING_SHEET_FAILED_BODY]:
    "Nenhuma conta foi vinculada. Revise o motivo e o próximo passo.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_TITLE]: "Falta a aprovação do cliente",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_BODY]:
    "O cliente precisa aprovar a solicitação antes que a Adle possa usar estas contas.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_META]:
    "O cliente precisa aprovar a solicitação na Meta, em Configurações do negócio → Solicitações.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GOOGLE]:
    "O cliente precisa aprovar a solicitação no Google Ads, em Administrador → Acesso e segurança → Administradores.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_TIKTOK]:
    "O cliente precisa aprovar a solicitação no TikTok Ads Manager, em Notificações → Business Center.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GENERIC]:
    "O cliente precisa aprovar a solicitação na plataforma de anúncios.",
  [AGENCY_ACCOUNT_LINKING_SHEET_NOT_CONFIGURED]:
    "A Adle ainda está terminando de habilitar a vinculação nesta plataforma. Nossa equipe já foi avisada e vamos tentar de novo automaticamente; você não precisa fazer nada.",
  [AGENCY_ACCOUNT_LINKING_SHEET_RECONNECT]:
    "Conecte a plataforma de novo e confira se você tem permissões de administrador.",
  [AGENCY_ACCOUNT_LINKING_SHEET_RETRY_STEP]: "Você pode tentar de novo.",
  [AGENCY_ACCOUNT_LINKING_SHEET_REQUEST_AGAIN]:
    "O cliente recusou ou removeu o acesso, ou a solicitação expirou. Peça para ele aceitar e tente de novo.",
  [AGENCY_ACCOUNT_LINKING_SHEET_SUPPORT]:
    "Esta conta precisa de uma revisão. Fale com o suporte da Adle e ajudamos você a vinculá-la.",
  [AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS_TITLE]: "Vinculação em andamento",
  [AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS]:
    "Já existe uma vinculação em andamento. Espere um instante e tente de novo.",
  [AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING_TITLE]:
    "Vinculação ainda em processo",
  [AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING]:
    "A vinculação ainda está em andamento. Espere um instante e tente de novo se ela não terminar.",
  [AGENCY_ACCOUNT_LINKING_COLUMN_STATUS]: "Status",
  [AGENCY_ACCOUNT_LINKING_COLUMN_DETAILS]: "Detalhes",
  [AGENCY_ACCOUNT_LINKING_STATUS_UNLINKED]: "Não vinculada",
  [AGENCY_ACCOUNT_LINKING_STATUS_PENDING]: "Pendente",
  [AGENCY_ACCOUNT_LINKING_STATUS_FAILED]: "Falhou",
  [AGENCY_ACCOUNT_LINKING_STATUS_LINKED]: "Vinculada",
  [AGENCY_ACCOUNT_LINKING_DETAIL_NOT_ADMIN]:
    "O usuário conectado não é administrador desta conta.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_RECONNECT]:
    "Reconecte a conta com permissões de administrador.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_UNREADABLE]:
    "Não foi possível ler esta conexão.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_NOT_CONFIGURED]:
    "A Adle ainda não pode vincular esta plataforma.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_NOT_IN_BUSINESS]:
    "Esta conta não está em um Business Manager ou Business Center.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_LIMIT]:
    "Esta conta atingiu o limite de administradores.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_MANAGED_ELSEWHERE]:
    "Esta conta já é administrada em outra hierarquia.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_INCOMPATIBLE]:
    "Estas contas não podem ser vinculadas entre si.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_REJECTED]:
    "A vinculação foi recusada na plataforma.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_EXPIRED]: "A vinculação pendente expirou.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_REVOKED]: "A vinculação não está mais ativa.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_UNSUPPORTED]:
    "Esta plataforma ainda não pode ser vinculada.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_GENERIC]:
    "Não foi possível concluir a vinculação.",
  [ADLE_CARD_WAITLIST_EYEBROW]: "Em breve",
  [ADLE_CARD_WAITLIST_TITLE]:
    "Adle Card: Um Cartão para Todas as Suas Campanhas",
  [ADLE_CARD_WAITLIST_SUBTITLE]:
    "Pague Meta, Google e TikTok com um único saldo e pare de perder dias de campanha por pagamentos recusados.",
  [ADLE_CARD_WAITLIST_FEATURE_VIRTUAL_CARDS]:
    "Um cartão virtual por marca, criado em um clique",
  [ADLE_CARD_WAITLIST_FEATURE_SINGLE_BALANCE]:
    "Um único saldo pré-pago para Meta, Google e TikTok",
  [ADLE_CARD_WAITLIST_FEATURE_CASHBACK]:
    "1,5% de cashback em todo o seu investimento publicitário",
  [ADLE_CARD_WAITLIST_FEATURE_NO_FEES]:
    "Sem mensalidade e sem limites de gasto",
  [ADLE_CARD_WAITLIST_FEATURE_NO_DECLINES]:
    "Chega de pagamentos recusados que pausam suas campanhas",
  [ADLE_CARD_WAITLIST_FEATURE_TOP_UPS]:
    "Recargas por ACH ou transferência bancária (mínimo USD 1.000)",
  [ADLE_CARD_WAITLIST_EMAIL_LABEL]: "Email",
  [ADLE_CARD_WAITLIST_COUNTRY_LABEL]: "País da sua empresa",
  [ADLE_CARD_WAITLIST_COUNTRY_PLACEHOLDER]: "Selecione seu país",
  [ADLE_CARD_WAITLIST_CTA]: "Entrar na lista de espera",
  [ADLE_CARD_WAITLIST_NOT_NOW]: "Agora não",
  [ADLE_CARD_WAITLIST_DISCLAIMER]:
    "Sem compromisso. Avisaremos quando o Adle Card estiver disponível no seu país.",
  [ADLE_CARD_WAITLIST_SUCCESS_TITLE]: "Você Está na Lista!",
  [ADLE_CARD_WAITLIST_SUCCESS_DESCRIPTION]:
    "Vamos escrever para {{email}} assim que abrirmos os primeiros acessos.",
  [ADLE_CARD_WAITLIST_SUBMIT_ERROR]:
    "Não conseguimos salvar seu cadastro. Tente novamente.",
  [ADLE_CARD_WAITLIST_BANNER]:
    "Novidade: Adle Card, um saldo para Meta, Google e TikTok com 1,5% de cashback.",
  [ADLE_CARD_WAITLIST_BANNER_LINK]: "Entrar na lista",
  [ADLE_CARD_WAITLIST_CARD_ARIA]: "Ilustração do Adle Card",
  [ADLE_CARD_WAITLIST_CARD_VIRTUAL]: "Virtual",
  [ADLE_CARD_WAITLIST_CARD_BRAND_FALLBACK]: "Sua marca",
  [OWNER_DASHBOARD_NAV_ADLE_CARD_WAITLIST]: "Lista de espera Adle Card",
  [`${ADLE_CARD_WAITLIST_ADMIN_TOTAL}_zero`]: "{{count}} cadastros",
  [`${ADLE_CARD_WAITLIST_ADMIN_TOTAL}_one`]: "{{count}} cadastro",
  [ADLE_CARD_WAITLIST_ADMIN_TOTAL]: "{{count}} cadastros",
  [ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_ALL_TIME]: "Gasto total (USD)",
  [ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_3M]: "Gasto nos últimos 3 meses (USD)",
  [ADLE_CARD_WAITLIST_ADMIN_SPEND_UNAVAILABLE]:
    "Não foi possível carregar o gasto publicitário.",
};

export default translation;
